(function() {
  'use strict';

  angular
    .module('food-settings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.foodsettings', {
        url: '/food-settings',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/food-settings/food-settings.html',
            controller: 'FoodSettingsController as vm'
          }
        },
        resolve: {
          fmItems: function(apiResolver) {
            return apiResolver.resolve('fmItems.getAll@get');
          },
          foodType: function(apiResolver) {
            return apiResolver.resolve('foodType@get');
          },
          foodUnit: function(apiResolver) {
            return apiResolver.resolve('foodUnit@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          fmCategory: function(apiResolver) {
            return apiResolver.resolve('fmCategory.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: '{{ "RESTRAUNTANT.MENU-ITEMS" | translate }}'
        }
      });

    // Api
    //msApiProvider.register('foodType', ['app/data/settings/tax/tax.json']);

  }
})();

(function() {
  'use strict';

  angular
    .module('food-settings')
    .controller('CustomerDialogsController', CustomerDialogsController)
    .directive('eopdEnter', function() {
      return function(scope, element, attrs) {
        element.on("keydown keypress", function(event) {
          if (event.which === 13) {
            scope.$apply(function() {
              scope.$eval(attrs.eopdEnter, { 'event': event });
            });

            event.preventDefault();
          }
        });
      };
    })
    .directive('nextOnEnter', function () {
    return {
        restrict: 'A',
        link: function ($scope, selem, attrs) {
            selem.on('keydown', function (e) {
                var code = e.keyCode || e.which;
                if (code === 40) {
                    e.preventDefault();
                    var pageElems = document.querySelectorAll('input, select, textarea'),
                        elem = e.srcElement || e.target,
                        focusNext = false,
                        len = pageElems.length;
                    for (var i = 0; i < len; i++) {
                        var pe = pageElems[i];
                        if (focusNext) {
                            if (pe.style.display !== 'none') {
                                angular.element(pe).focus();
                                break;
                            }
                        } else if (pe === elem) {
                            focusNext = true;
                        }
                    }
                }
            });
        }
    }
})

  /** @ngInject */ //customer_mobile, customer_id, customer_name, customer_email, customer_address, customer_locality

  function CustomerDialogsController($scope, locality, $timeout, $q, $translate, $rootScope, point, $mdToast, $mdDialog, api, customer_data, customer_details, customer_Added, dietType) {
    // $scope.customer = { 'customer_id': customer_id, 'customer_mobile': customer_mobile, 'customer_name': customer_name, 'customer_email': customer_email, 'customer_address': customer_address, 'customer_locality': customer_locality }
    var vm = this;
    vm.title = 'Add';
    $scope.ngSubmits = 'submit';
    if (customer_data.searchText != '' && customer_data.customer_mobile == undefined) {
      $scope.customer = { 'customer_mobile': angular.copy(customer_data) }
    } else if (customer_data.customer_id) {
      $scope.customer = { 'customer_id': customer_data.customer_id, 'customer_city': customer_data.customer_city, 'customer_mobile': customer_data.searchText ? customer_data.searchText : customer_data.customer_mobile, 'customer_name': customer_data.customer_name, 'customer_email': customer_data.customer_email, 'localityID': customer_data.localityID, 'customer_address': customer_data.customer_address, 'localityName': customer_data.customer_locality, 'pointsEarned': customer_data.pointsEarned, 'whatsapp': customer_data.whatsapp }
      vm.title = 'Edit';
      $scope.ngSubmits = 'update';
    } else {
      $scope.customer = angular.copy(customer_data.customer_mobile);
    }

    var localityy = locality.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.locality = localityy;
    vm.settings = dietType.settings;
    //autofocus for customer
    $timeout(function() {
      $('#customerMobileNo').focus();
    }, 100);
   /* $timeout(function() {
      $('input').keydown(function(event) {
        console.log(event.which)
        // check for hyphen
        if (event.which === 40) {
          event.preventDefault();
          $(this).next('.keydown').focus();
        }
      });
    }, 100); */

    // ******************************
    // Internal methods
    // ******************************
    vm.food = loadAll();
    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;

    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.localityName.indexOf(lowercaseQuery) === 0);
      };

    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

      var foodList = vm.locality
      return foodList.map(function(food) {
        return {
          localityName: food.localityName.toLowerCase(),
          display: food.localityName,
          localityID: food.localityID
        };
      });
    }

    // restrict the customer name max or min exceeds 
    $scope.user = {
      name: {
        required: true,
        minlength: 3,
        maxlength: 60
      }
    }

    // restrict the customer mobile max or min exceeds 
    $scope.number = {
      name: {
        required: true,
        minlength: 10,
        maxlength: 12
      }
    };


    $scope.update_customer = function(customer) {
      if ($scope.CustomerInfo.$invalid) {
        alert('Please fill valid data for all required fields')

      } else {
        var currentcustomerpoint = [];
        var edit_customer = [customer].map(function(data) {
          var locality_name = [];
          return { 'customer_mobile': data.customer_mobile, 'branch_id': $rootScope.user[0].branch_id, 'customer_id': data.customer_id, 'customer_name': data.customer_name, 'localityID': data.localityName.localityID ? data.localityName.localityID : customer_data.localityID, 'customer_locality': data.localityName.localityName ? data.localityName.localityName : customer_data.customer_locality, 'customer_address': data.customer_address, 'customer_city': data.customer_city, 'pointsEarned': data.pointsEarned, 'customer_email': data.customer_email, 'whatsapp': data.whatsapp }
        })

        api.update_customer.getID.update({ customer_id: customer.customer_id }, edit_customer[0],
          function(response) {
            if (!response.data) {
              for (var i = 0; i < customer_details.length; i++) {
                if (customer_details[i].customer_id === customer.customer_id) {
                  currentcustomerpoint.push(customer_details[i].pointsEarned)
                  customer_details[i] = angular.copy((edit_customer[0]));
                  break;
                }
              };
              var editedcustomer = [$scope.customer].map(function(data) {

                return { 'customer_mobile': data.customer_mobile, 'customer_city': data.customer_city, 'customer_id': data.customer_id, 'customer_name': data.customer_name, 'branch_id': $rootScope.user[0].branch_id, 'localityID': data.localityName.localityID ? data.localityName.localityID : customer_data.localityID, 'customer_locality': data.localityName.localityName ? data.localityName.localityName : customer_data.customer_locality, 'customer_address': data.customer_address, 'customer_email': data.customer_email, 'pointsEarned': currentcustomerpoint[0] ? currentcustomerpoint[0] : data.pointsEarned, 'whatsapp': data.whatsapp }
              })
              $rootScope.$broadcast("salesId", editedcustomer[0]);
              $mdToast.show({
                template: '<md-toast class="success"><span flex>Customer updated successfully</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });

              $mdDialog.hide();
            } else {
              $mdToast.show({
                template: '<md-toast class="error"><span flex>Mobile number already exists try another one!</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });
            }
          });
      }
    }

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.submit_customer = function(customer) {
      if ($scope.CustomerInfo.$invalid) {
        alert('Please fill valid data for all required fields')

      } else {
        var new_customer = [$scope.customer].map(function(data) {
          if (point[0].EnableFirstTime == 1) {
            return { 'customer_mobile': data.customer_mobile, 'customer_city': data.customer_city, 'customer_name': data.customer_name, 'localityID': data.localityName.localityID, 'customer_locality': data.localityName.localityName, 'customer_address': data.customer_address, 'customer_email': data.customer_email, 'pointsEarned': point[0].FirstTimePoint, 'branch_id': $rootScope.user[0].branch_id, 'whatsapp': data.whatsapp}
          } else {
            return { 'customer_mobile': data.customer_mobile, 'customer_city': data.customer_city, 'customer_name': data.customer_name, 'localityID': data.localityName.localityID, 'customer_locality': data.localityName.localityName, 'customer_address': data.customer_address, 'customer_email': data.customer_email, 'branch_id': $rootScope.user[0].branch_id, 'whatsapp': data.whatsapp }
          }
        })
        $scope.customer_details = customer_details
        api.save_customer.getAll.save(new_customer, // Success
          function(response) {
            if (response.insertId) {
              var mergeData = angular.merge(new_customer[0], { customer_id: response.insertId }, { 'data': customer_Added })
              customer_details.unshift(mergeData);
              $scope.customers = angular.copy(new_customer[0])
              $rootScope.$broadcast("salesId", $scope.customers);
              $mdToast.show({
                template: '<md-toast class="success"><span flex>Customer Added successfully</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });
              $mdDialog.hide();
            } else {
              $mdToast.show({
                template: '<md-toast class="error"><span flex>Mobile number already exists try another one!</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });
            }
          })

      }
    }
  }

  // Methods

  //////////

})();

(function() {
  'use strict';

  angular
    .module('app.inventory.stockSaleMaterial', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.stockSaleMaterial', {
        url: '/stock-sale-material',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/inventory/sale-material/stock-sale-material/stock-sale-material.html',
            controller: 'StockSaleMaterialController as vm'
          }
        },
        resolve: {
          smcategorydata: function(apiResolver) {
            return apiResolver.resolve('smcategorydata.getAll@get');
          },

          siItems: function(apiResolver) {
            return apiResolver.resolve('siItems.getAll@get');
          },
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          }
        },

        ncyBreadcrumb: {
          label: "{{'Inventory.STOCK-OF-SALE-MATERIAL' | translate}}"
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.stockSaleMaterial')
    .controller('StockSaleMaterialController', StockSaleMaterialController)
    .directive('exportToCsv7', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            //var today=new Date()
            var today = new Date(scope.myDate).toString(); //get like wed apr with time
            today = new Date(today).toUTCString();
            today = today.split(' ').slice(0, 4).join(' ');
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: (today) + '- Stock Sale Material' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });

  /** @ngInject */
  function StockSaleMaterialController($scope, smcategorydata, $rootScope, siItems, branch_data, $timeout, $mdDialog, $mdToast, api) {
    var vm = this;
    $scope.mdtableselected = []; // dummy assign
    vm.branchFilterData = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });
    $scope.myDate = new Date(); // assign today data to md picker
    //get full data of sale materials of category from database
    vm.salecategorys = smcategorydata;
    //filter sale materials data for branch wise
    var siItemss = siItems.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    vm.sistock = siItemss; //assign filtered data to table
    //select box data for caegory filter in raw items
    var All_sale_category_items = [{ siCatergoryID: "All", smCatergoryName: "All Catergory" }]
    //filter sale material category data for branch wise
    var siCategorys = smcategorydata.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    //map function for our convenient
    var smdata = siCategorys.map(function(sm) {
      return { 'siCatergoryID': sm.siCatergoryID, 'smCatergoryName': sm.siCatergoryName }
    })

    vm.smCategory = All_sale_category_items.concat(smdata); //concat two array
    $scope.categ = '';
    //function for dropdown filter in raw items
    $scope.getSale_items = function(stu) {

      //$scope.sale_load = true
      var smID = stu;
      if (stu == "All") {
        $scope.categ = ''

      } else {
        $scope.categ = stu;
      }
      getDesserts();

    };

    $scope.getDesserts = getDesserts; //method for function call
    $scope.saleitems_query = {
      filter: '',
      limit: '10',
      page: 1,
      branch_id: $rootScope.user[0].branch_id,
      category: ''
    };

    function getDesserts() {
      $scope.saleitems_query = {
        filter: '',
        limit: '10',
        page: $scope.saleitems_query.page,
        branch_id: $rootScope.user[0].branch_id,
        category: $scope.categ,
      };

      $scope.reload = function() {
        $scope.promise = api.siItemLimit.getAll.get($scope.saleitems_query, paidexpense_success).$promise;
      };
      $scope.reload();
    }

    getDesserts(); //function call for access inside of the function

    function paidexpense_success(desserts) {
      $scope.paidexpense_count = desserts[0].paidexpense_count;
      vm.sistock = desserts[0].results;
    }
    //balance expense filter
    $scope.$watch('saleitems_query.filter', function(newValue, oldValue) {
      console.log(newValue);
      console.log(oldValue);

      if (!oldValue) {
        var bookmark = $scope.saleitems_query.page ? $scope.saleitems_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.saleitems_query.page = 1
      }
      if (!newValue) {
        $scope.saleitems_query.page = bookmark ? bookmark : 1
      };
      $scope.getDesserts = getDesserts; //method for function
      $scope.reload();
    });

    //clear text function while search
    $scope.clearTexts = function() {
      $scope.saleitems_query.filter = '';
    }

    // GET CATEGORY NAME
    //---------------- 
    $scope.getCategoryName = function(siInfo) {
      if (!vm.salecategorys) {
        return;
      }
      for (var i = 0; i < vm.salecategorys.length; i++) {
        if (vm.salecategorys[i].siCatergoryID == siInfo.siCatergoryID) {
          return vm.salecategorys[i].siCatergoryName
        }
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.smSalesOrder', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.smSalesOrder', {
        url: '/sm-Sales-order',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/inventory/sale-material/sales-order/sm-sales-order.html',
            controller: 'SmSalesOrderController as vm'
          }
        },
        resolve: {
          getsales: function(apiResolver) {
            return apiResolver.resolve('getsales.getAll@get');
          },
          salematerial_bill_data: function(apiResolver) {
            return apiResolver.resolve('salematerial_bill_data.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          getvendors: function(apiResolver) {
            return apiResolver.resolve('getvendors.getAll@get');
          }
        },
        ncyBreadcrumb: {

          label: "{{'Inventory.SALE-MATERIAL' | translate}} {{'Inventory.PURCHASE-ORDER' | translate}}"
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.smSalesOrder')
    .controller('SmSalesOrderController', SmSalesOrderController)
    .directive('exportToCsv2', function() { //export as excel directive for inventory purchase sales materials
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Purchase Sale Material' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });



  /** @ngInject */
  function SmSalesOrderController($scope, staffRole, salematerial_bill_data, getvendors, getsales, api, $cookies, $rootScope, $stateParams, $state, $timeout, $mdDialog, $mdToast) {
    //console.log(salematerial_bill_data);
    var vm = this;
    var originatorEv;
    $scope.mdtableselected = []; // dummy assign
    //get loggedin staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    //get staff data with id for like hi staff
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    vm.staffs = staffRole;
    $scope.staffs = "admin"
    //filters staff for branch wise
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': '', 'name': 'All staff' }]
    $scope.purchae_salematerial_staff = staffRole.filter(function(staff) {
      return salematerial_bill_data.some(function(smpurchaseorders) {
        return (staff.staffID == smpurchaseorders.staffID && staff.status == 'active' && staff.branch_id == smpurchaseorders.branch_id)
      })
    })
    vm.staffRole = staff_all.concat($scope.purchae_salematerial_staff); //concat of two array

    var vendor_all = [{ 'vendor_name': 'All vendors', 'vendorID': '' }]
    var getvendorss = getvendors.filter(function(vendor) {
      if (vendor.branch_id == $rootScope.user[0].branch_id) {
        return vendor
      }
    })
    //map vendor data for our convenient for dropdown
    var vend = getvendorss.map(function(allvendor) {
      return { 'vendor_name': allvendor.company_name, 'vendorID': allvendor.vendorID }
    })
    //to find who was last edit
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    // merge all and branch wise vendor
    vm.vendor = vendor_all.concat(vend); //concat of two array
    $scope.myDate = new Date(); //assign today date to $scope variable
    //restrict condition for max date
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    //clear search text function while search
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }

    //success function of purchase order from the server
    function purchase_order_success(desserts) {
      //collect counts from server
      $scope.total_paid = desserts[0].total_paid
      $scope.total_purchase = desserts[0].total_purchase
      $scope.total_cash = desserts[0].total_cash
      $scope.total_card = desserts[0].total_card
      $scope.total_cheque = desserts[0].total_cheque
      $scope.total_online = desserts[0].total_online
      $scope.balance = desserts[0].balance
      $scope.paid_count = desserts[0].paid_count;
      $scope.balance_count = desserts[0].balance_count

      vm.purchase_serviceID = desserts[0].results.map(function(item) {
        if (!item.DeliveryDate || item.DeliveryDate == 'null' || item.DeliveryDate == 'undefined') {
          var time = ''
          var deli_time = ''
        } else {
          var date_delivery = new Date(item.DeliveryDate).toString(); //get like wed apr with time
          var a = date_delivery.split(' ') //split date like array
          var order_time = new Date(item.created_on).toString(); //get like wed apr with time
          var b = order_time.split(' ') //split date like array
          var ordertiming = (order_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
          var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM

          var deli_time = new Date(item.DeliveryDate).toString(); //get like wed apr with time
          var bs = deli_time.split(' ') //split date like array
          var delitiming = (deli_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hourss = (delitiming[0] % 12) || 12; // convert to 12-hour style
          var deltime = hourss + ":" + delitiming[1] + " " + (delitiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
          var orderdate = (b[0] + " " + b[1] + " " + b[3]);
          var deliverydate = (a[0] + " " + a[1] + " " + a[3]);
          var currentTime = new Date();
          var endTime = new Date(item.DeliveryDate);

          var ms = (endTime - currentTime); // ms of difference
          var days = Math.round(ms / 86400000);
          var finalCountdown = (days + "d left");
          var remainingtime = ms < 0 ? "EXPIRED" : finalCountdown
        }
        //filter only items depending on purchaseorder_id for count length of items
        var food_items = []; // empty array for get np of items for count
        getsales.forEach(function(a) { //count&watch each items
          if (a.staffID == $rootScope.user[0].staffID && a.inventory_salesOrder_id == item.inventory_salesOrder_id)
            food_items.push(a.smname);
        });
        return { 'rmname': food_items.length, 'payment_status': item.payment_status, 'tax_cgst': item.tax_cgst === null ? 0 : item.tax_cgst, 'tax_sgst': item.tax_sgst === null ? 0 : item.tax_sgst, 'discount': item.discount, 'staffID': item.staffID, 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'due_date': item.payment_status == 'fully paid' ? new Date(item.paid_date) : item.due_date, 'received_amount': item.received_amount, 'purchaseStatus': item.purchaseStatus, 'deltime': deltime, 'created_on': new Date(item.created_on), 'remainingtime': remainingtime, 'status': item.status, 'showordertime': time, 'purchase_order_id': item.inventory_salesOrder_id, 'vendor_name': item.vendor_name, 'total_amount': item.total_amount, 'DeliveryDate': new Date(item.DeliveryDate) }

      })
      // Assign the mapped value to md-table
      vm.getpurchase = vm.purchase_serviceID //assign mapped data to table
      $scope.purchaseorder_count = vm.purchase_serviceID.length // apply total_count pagination
    }

    /*----------------
    Filter dropdown and data get from server
    -------------------*/
    $scope.changeDate = changeDate;
    //function for change date for show data depending on date
    function changeDate(status_type, amount_type, myDate, vendor, staff) {
      $scope.retrieve = "rmInfo"

      $scope.load = true // Show preloader
      getDessertsss(status_type, amount_type, myDate, vendor, staff) // callback funtion

      $timeout(function() {
        $scope.load = false // hide preloader
      }, 500);

    }
    $scope.getDessertsss = getDessertsss()
    //service for purchase list
    function getDessertsss(status_type, amount_type, myDate, vendor, staff) {
      
      if (amount_type == undefined && status_type == undefined && myDate == undefined && vendor == undefined) {
        // if All selected in dropdown filter and init page load
        var amount_type = 'All'
        var status_type = ''
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
        var vendor = ''
      } else {
        // if All not selected in dropdown filter
        var amount_type =  amount_type == undefined ? 'All' : amount_type;
        var vendor = vendor == undefined ? '' : vendor;
        var status_type = status_type == undefined ? '' : status_type;
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear()
      }
     
      if ($cookies.get('admin') != 'admin') {
        // If staff assign this value
        $scope.purchaseorder_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          status_type: status_type,
          month: month,
          year: year,
          vendor: vendor,
          order_bill_type: 'purchase'
        };
      }
      if ($cookies.get('admin') == 'admin') {
        // If admin assign this value
        //var staffID = staff == undefined ? 'admin' : staff;
        var staffID = 'admin';
        $scope.purchaseorder_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          status_type: status_type,
          month: month,
          year: year,
          vendor: vendor,
          order_bill_type: 'purchase'
        };
      }
      $scope.reload = function() {
        $scope.promise = api.getsales_service.getAll.get($scope.purchaseorder_query, purchase_order_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000);*/
      };
      $scope.reload()
    };
    getDessertsss();


    vm.amount_type = [{
      "name": 'All amount type',
      "value": 'All'
    }, {
      "name": 'Paid amount',
      "value": 'fully paid'
    }, {
      "name": 'Balance amount',
      "value": 'balance'
    }];
    vm.status_type = [{
      "name": 'All status type',
      "value": ''
    }, {
      "name": 'Ordered',
      "value": 'ordered'
    }, {
      "name": 'Delivered',
      "value": 'delivered'
    }];


    //search text query filter for pagination while search

    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss = getDessertsss;
      $scope.reload();
    });

    //supported for angularjs material 1.10 for only showing month in date filter
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];

    // GET purchase order created name for admin
    //---------------- 
    $scope.purchaseorder_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };

    // Delete the purchase order
    $scope.removeRow = function(item, ev, index) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this item?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.delete_salematerial_data.getID.delete({ inventory_salesOrder_id: item.purchase_order_id },
          function(response) {
            //success callback
            deleteItem(item);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

      /**
       * Delete index of the  Item
       */
      function deleteItem(item) {
        vm.getpurchase.splice(vm.getpurchase.indexOf(item), 1);

        $mdToast.show({
          template: '<md-toast><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });


      }

    }


    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
      // unknown code for search pagination
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss = getDessertsss;
      // for trigger the service to get data
      $scope.reload();
    });

    //redirect from list to edit with id
    $scope.purchaseid = function(purchase_order_id) {
      var id = purchase_order_id;
      $scope.params = $stateParams;
      $state.go('app.addSales', { id: purchase_order_id })
    }

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.addSales', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.addSales', {
        url: '/add-sales-order/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/inventory/sale-material/add-sales_order/addSales.html',
            controller: 'addSalesController as vm'
          }
        },
        resolve: {
          getvendors: function(apiResolver) {

            return apiResolver.resolve('getvendors.getAll@get');
          },
          siItems: function(apiResolver) {
            return apiResolver.resolve('siItems.getAll@get');
          },
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },

          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          expense_amountType: function(apiResolver) {
            return apiResolver.resolve('expense_amountType@get');
          }


        },
        ncyBreadcrumb: {

          parent: function($scope, $stateParams) {


            if ($scope.state.params.id) {

              console.log($scope.state.params.id)
              // Constant defined in CollectionsLibraryMyController
              return 'app.smSalesOrder';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController
              return null;
            }
          },

          label: "{{get_BreadcrumbLabel()}}"
          //label: 'New Expense'
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.addSales')
    .controller('addSalesController', addSalesController)
    .directive('validNumber', function() {
      return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModelCtrl) {
          if (!ngModelCtrl) {
            return;
          }

          ngModelCtrl.$parsers.push(function(val) {
            var clean = val.replace(/^[^1-9]*|[^0-9]/g, '');
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.on('keypress', function(event) {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    });


  /** @ngInject */
  function addSalesController($scope, $state, $cookies, branch_data, siCategory, Upload, dietType, expense_amountType, $mdDialog, $rootScope, siItems, $mdToast, $q, $timeout, $stateParams, api, getvendors) {

    var vm = this;
        // filter branch data 
    vm.branchFilterData = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });
    //get loggedin staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    $scope.currentDate = new Date() //assign today date
    vm.purchaseTax_status = dietType.purchase; //include or exclude for dropdownS
    vm.barcode = dietType.barcode;
    //tab wise active div html
    $scope.expensebill = true;
    $scope.expensebills = function() {
      $scope.expensebill = true;
      $scope.payments = false;
    }
    $scope.payment = function() {
      $scope.payments = true;
      $scope.expensebill = false;
    }
    //condition for when staff change for purchase status the text will be changed in front end
    $scope.changestatus = function() {
      if (vm.purchase.status == 'delivered') {
        vm.purchase.DeliveryDate = new Date();
        
      } else {
        vm.purchase.DeliveryDate = ''

      }
    }
    //get amount type from data json like card cash cheque
    vm.expense_amountType = expense_amountType.expensebill.Amount_PayType;
    $scope.cash = "cash"
    $scope.myDate = new Date();
    //retrict date only 30 days move on backward from md pciker FOR Due DATE
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate()
    );


    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 3,
      $scope.myDate.getDate()
    );


    //retrict date only 30 days move on backward from md pciker FOR Delivery DATE
    $scope.minDatess = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 0,
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDatess = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 0,
      $scope.myDate.getDate()
    );


    //retrict date only 30 days move on backward from md pciker FOR PAID DATE
    $scope.minDates = new Date(
      $scope.myDate.getFullYear() - 1,
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDates = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    //function for get new row while purchase another item
    $scope.keyPressed = function(keyEvent) {
      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        vm.exitems.push({
          'item_name': '',
          'item_amount': 0
        });
        $scope.indx = vm.exitems.length - 1;
        $scope.$watch(vm.exitems, function() {
          $timeout(function() {
            angular.element('.autodd').focus();
          }, 10);

        })

      }
    };
    //when enter key barcode pressed
    $scope.barcodekeyPressed = function($event, inputValue) {
      /*if (event.keyCode == 13 || event.which == 13) {
        $timeout(function() {
          $('.md-autocomplete-suggestions li:first-child').click();
          $('.qty').focus();
        }, 300);
      } */
      if ($event.keyCode == 13 || $event.which == 13) { 
        var validList = $event.target.classList;
        var valid = [];
        for (var i = 0; i < validList.length; i++) {
          if (validList[i] == 'ng-valid-md-require-match' || validList[i] == 'ng-valid') {
            valid.push(validList[i]); 
          }
        };
        var setint = setInterval(function(){ 
          var itemLength = $('.md-autocomplete-suggestions-container:not(.ng-hide) li').length;
          var autocompleteopen = $('.md-autocomplete-suggestions-container:not(.ng-hide)').length;
          if(itemLength == 1) {
            $('.md-autocomplete-suggestions-container:not(.ng-hide) li:first-child').click();
            //$('ul#'+ulId+' li:first-child').trigger("click");
            $('.qty').select();
            clearInterval(setint);
          } else if(itemLength > 0 && autocompleteopen) {
            clearInterval(setint);
          } 
          if(valid.length > 0 && autocompleteopen==0) {
            $('.qty').select();
            clearInterval(setint);
          }   
        }, vm.barcode.scanner_interval_delay);
        setTimeout(function() { 
          clearInterval(setint);
        }, vm.barcode.scanner_timeout_intervalFunction); //10 seconds
      }
    };
    //filter sale material category data for branch wise
    var siCategorys = siCategory.filter(function(smCatergory) {
      if (smCatergory.branch_id == $rootScope.user[0].branch_id) {
        return smCatergory
      }
    })
    vm.salecategorys = siCategorys; //pass category while add new sale material items

    //popup for add new sale material data
    vm.showAddTableDialogs = function(ev, siInfo) {
      $mdDialog.show({
        controller: 'addSaleDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/sale-item/item/dialog/si-additem.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          siItems: vm.rmitems,
          siCategory: vm.salecategorys,
          siInfo: siInfo,
          dietType: dietType,
          branch_data : branch_data

        }
      });
    };
    // Add Table dialog
    //popup for add new vendor data
    vm.showAddTableDialog = function(ev, vItem) {
      $mdDialog.show({
        controller: 'addVendorDialogController',
        templateUrl: 'app/main/admin/vendor/vendor.addcategory.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          vendor: vItem,
          vendors_all: vm.food

        },
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false
      })
    };
    //number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };

    // Add placeholder for autocomplete
    $timeout(function() {
      $(".foodItem-auto input").attr("placeholder", "Enter the purchase item");
    }, 500);

    //filter branch data for branch wise
    var branchfilter = branch_data.filter(function(branch) {
      if (branch.branch_id == $rootScope.user[0].branch_id)
        return branch
    })
    $scope.branch_name = branchfilter[0].branch_name; //apply branch name
    //jspdf syntax for get div as pdf format
    var doc = new jsPDF();
    var specialElementHandlers = {
      '#editor': function(element, renderer) {
        return true;
      }
    };
    //export pdf function
    $scope.SaveExportPdf = function(purchase_order_id) {
      $scope.purchase_order_id = purchase_order_id;
      $scope.ReportTime = new Date()
      $timeout(function() {
        doc.fromHTML($('#purchasesalematerial').html(), 15, 15, {
          'width': 170,
          'elementHandlers': specialElementHandlers
        });
        doc.save("" + moment(new Date()).format('MMM DD,YYYY') + "-Purchase Sale Material-" + $scope.branch_name + ".pdf");
        if ($scope.params.id) {
          // redirect state to purchase order list
          $state.go('app.smSalesOrder', { id: '' })
        } else {
          // redirect state to add purchase order
          $state.go("app.addSales", {}, { reload: "app.addSales" })
        }

      }, 1000)

    };

    // Set active tab for initial time
    $scope.prTabName = "tabBillInfo";
    vm.sistocks = siItems //autocomplete data
    vm.vendors = getvendors; //all vendor data
    //when tap change in payment status clear old inputs of payment status
    $scope.clear_advancePaid = function() {
      vm.expayment.note = ''
      vm.expayment.received_amount = ''
      vm.expayment.cheque_no = ''
      vm.expayment.transcation_no = ''
    }

    //when tap change in payment status clear old inputs of payment status
    $scope.clear_payment = function() {
      if (vm.expayment.payment_status == 'fully paid') {
        vm.expayment.received_amount = ''
      }
      if (vm.expayment.cheque_no) {
        vm.expayment.transcation_no = ''
      }
      if (vm.expayment.transcation_no) {
        vm.expayment.cheque_no = ''
      }

    }
    // Methods
    $scope.params = $stateParams; //accessing url parameter
    /*
       -------------------------------------------------

       Add scenario init sale material data

       -------------------------------------------------
       */
    //add purpuse
    if (!$scope.params.id) {
      vm.exitems = [{}]
      vm.purchase = {}
      vm.expayment = {}
      vm.file = ''
      vm.expayment.paid_date = new Date();
      vm.purchase.selectOrdered = 'delivered';
    }
    /*
    -------------------------------------------------

    Edit scenario init sale material data

    -------------------------------------------------
    */
    else { //edit purpose
      var purchase_order_id = $scope.params.id;
      // Getting data inventory sales order table
      api.inventory_salesdata.getaData.get({ purchase_order_id: purchase_order_id },
        function(response) {
          vm.purchase = response[0];
          if (vm.purchase.status == 'delivered') {
            $scope.disable_state = true;
          } else {
            $scope.disable_state = false;
          }
          $scope.url = response[0].billname;
          $scope.image_name_copy = angular.copy($scope.url) //make copy delete the receipt
          vm.purchase.Description = vm.purchase.Description == 'undefined' ? '' : vm.purchase.Description
          vm.purchase.due_date = response[0].due_date == '' ? '' : new Date(response[0].due_date);
          vm.purchase.DeliveryDate = new Date(response[0].DeliveryDate);
        })
      // Getting data inventory sales items table
      api.inventory_salesItems.getID.get({ purchase_order_id: purchase_order_id },
        function(response) {
          vm.exitems = response;
        })
      // Getting data purchase expense payment table
      api.expense_payment_sales.getID.get({ expense_bill_id: purchase_order_id },
        function(response) {
          vm.expayment = response[0];
          calculateTotals() //call watch function
          vm.expayment.paid_date = new Date(response[0].paid_date);
          vm.expayment.payment_type = response[0].payment_type
          vm.expayment.transcation_no = vm.expayment.transcation_no == null ? '' : response[0].transcation_no
          vm.expayment.cheque_no = vm.expayment.cheque_no == null ? '' : response[0].cheque_no

        })

    }

    //store payment types in array
    vm.payment = [{
      "name": 'Unpaid',
      "value": 'unpaid'
    }, {
      "name": 'Fully Paid',
      "value": 'fully paid'
    }, {
      "name": 'Advance Paid',
      "value": 'advance paid'
    }];

    //store order types in array
    vm.orderstatus = [{
      "status": 'ordered',
      "value": 'Ordered'
    }, {
      "status": 'delivered',
      "value": 'Delivered'
    }];

    vm.myDate = new Date(); //assign today date

    // Add Row
    //----------------
    $scope.addRow = function() {
      vm.exitems.push({
        'item_name': '',
        'item_amount': '0'
      });
    };

    //cancel function
    $scope.cancel = function(ev) {
      if ($scope.newsales.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go("app.addSales", {}, { reload: "app.addSales" })
        }, function() {
          // Canceled
        });
      } else {
        $state.go("app.addSales", {}, { reload: "app.addSales" })
      }
    }
    //cancel function while staff  in edit status
    $scope.canceledit = function(ev) {
      if ($scope.newsales.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go('app.smSalesOrder', { id: '' })
        }, function() {
          // Canceled
        });
      } else {
        $state.go('app.smSalesOrder', { id: '' })
      }
    }
    // Remove Row
    $scope.removeRow = function(expenseitem, ev, index) {
      if (!expenseitem.inventory_salesItems_id) {
        vm.exitems.splice(index, 1);
      } else {
        var confirm = $mdDialog.confirm()
          .title('Delete')
          .htmlContent('Are you sure you want to delete this item?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {

          var item_quantity = { 'item_quantity': expenseitem.quantity * expenseitem.containQty }

          //this service is for when staff edit exist row items in list to update the quanity
          api.deleteAndupdate_salematerial_quantity.getID.update({ siItemID: expenseitem.smItemID, inventory_salesItems_id: expenseitem.inventory_salesItems_id }, item_quantity,
            function(response) {
              api.delete_salematerial_items.getID.delete({ inventory_salesItems_id: expenseitem.inventory_salesItems_id },
                function(response) {
                  //success callback
                  deleteItem(expenseitem);
                },
                function(response) {
                  // error callback
                }
              );

            },
            function() {
              // Canceled
            });
        });
      };
      /**
       * Delete index of the Item
       */
      function deleteItem(fmitem) {
        vm.exitems.splice(vm.exitems.indexOf(expenseitem), 1);

        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      }

    }

    //load all data for autocomplete
    vm.food = loadAll(); //load all vendors in autocomplete
    vm.rmitems = loadrm(); //load all sale material items in auto complete
    vm.foodItemName = null;
    vm.rmname = null;

    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;
    vm.querySearchrm = querySearchrm;
    vm.selectedItemChange = selectedItemChange;

    //focus tax data
    $scope.focustax = function() {
      $timeout(function() {
        angular.element('#tax-focus').focus();
      }, 100);
    }
    $scope.focustaxSgst = function() {
      $timeout(function() {
        angular.element('#taxSgst-focus').focus();
      }, 100);
    }
    //focus discount data
    $scope.focusdiscount = function() {
      $timeout(function() {
        angular.element('#discount-focus').focus();
      }, 100);
    }

    //watch variable function
    var calculateTotals = function() {
      /*-----------------------------------
       EDIT purpose calculation manipulation started
      -------------------------------------*/
      if ($scope.params.id) { //it happens while in edit status
        if (vm.expayment.tax_status) {
          vm.exitems.tax_status = vm.expayment.tax_status
        }
        var discount = vm.expayment.discount;
        if (discount) {
          vm.exitems.discount = discount
        }
        //auto open status for tax
        if (vm.expayment.tax_type) {
          vm.exitems.tax_type = vm.expayment.tax_type
        }

        if (vm.expayment.tax_cgst) {
          $scope.OpenTax = true;
          $scope.hideclose = true;
        };
        if (vm.expayment.tax_sgst) {
          $scope.OpenTax = true;
          $scope.hideclose = true;
        };
        //auto open status for discount
        if (vm.expayment.discount) {
          $scope.OpenPermission = true;
          $scope.hideclose = true;

        };
        // if exclude condition
        if (vm.expayment.tax_status == 'exclude') {
          if (vm.expayment.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = vm.expayment.tax_cgst
            vm.exitems.tax_sgstValue = vm.expayment.tax_sgst
            vm.exitems.tax_cgst = vm.expayment.tax_cgst
            vm.exitems.tax_sgst = vm.expayment.tax_sgst
            vm.exitems.taxamount = parseInt(vm.exitems.tax_cgst) + parseInt(vm.exitems.tax_sgst)
          } else if (vm.expayment.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.expayment.subtotal / 100) * vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.expayment.subtotal / 100) * vm.expayment.tax_sgstPercent
            vm.exitems.tax_cgst = vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgst = vm.expayment.tax_sgstPercent
            vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
          }
        }
        // if include condition
        if (vm.expayment.tax_status == 'include') {
          if (vm.expayment.tax_type == 'amount') {
            vm.exitems.tax_cgst = vm.expayment.tax_cgst
            vm.exitems.tax_sgst = vm.expayment.tax_sgst
          } else if (response[0].tax_type == 'percent') {
            vm.exitems.tax_cgst = vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgst = vm.expayment.tax_sgstPercent
          }
          vm.exitems.taxamount = 0
        }
      };
      /*-----------------------------------
             EDIT purpose ended
        -------------------------------------*/
      /*-----------------------------------
       Add purpose calculation manipulation started
      -------------------------------------*/
      var subtotals = 0;
      angular.forEach(vm.exitems, function(smitem) {
        smitem.item_subtotal = smitem.quantity * smitem.smrate;
        smitem.quantity = (smitem.quantity != null) ? smitem.quantity : '';
        smitem.smrate = (smitem.smrate != null) ? smitem.smrate : '';
        subtotals += smitem.quantity * smitem.smrate;
      })
      vm.exitems.subtotal = subtotals;

      $scope.dataChange = function() {
        cals();
      };
      cals();

      function cals() {
        var tax_cgstPercent = (vm.exitems.tax_cgst != null) ? vm.exitems.tax_cgst : 0;
        var tax_sgstPercent = (vm.exitems.tax_sgst != null) ? vm.exitems.tax_sgst : 0;
        vm.exitems.discount = (vm.exitems.discount != null) ? vm.exitems.discount : '';
        // if exclude condition
        if (vm.exitems.tax_status == 'exclude') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = (tax_cgstPercent == '') ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = (tax_sgstPercent == '') ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
        } // if include condition
        else if (vm.exitems.tax_status == 'include') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = tax_cgstPercent == '' ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = tax_sgstPercent == '' ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = (vm.exitems.subtotal / 100) * 0;
        }

        vm.roundtotal = vm.exitems.subtotal + vm.exitems.taxamount - vm.exitems.discount;
        vm.exitems.total_amount = Math.round(vm.roundtotal);
      }

      //remove row condition :- Disable first index while removing rows,
      if (vm.exitems.length > 1) {
        $scope.formitem = false;
      } else {
        $scope.formitem = true;
      }
    };

    $scope.$watch('vm.exitems', calculateTotals, true); //watch function ng-repeat array name
    // Clear the discount :- Calculation
    $scope.clearDis = function() {
      if (!vm.exitems.discount) {
        vm.exitems.discount = 0;
      };
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) + parseInt(vm.exitems.discount)
      vm.exitems.discount = '';
    }
    // Clear the Tax :- Calculation
    $scope.clrTax = function() {
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) - parseInt(vm.exitems.taxamount)
      vm.exitems.tax_cgst = '';
      vm.exitems.tax_sgst = '';
      vm.exitems.taxamount = 0;
    }

    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.vendor_name.indexOf(lowercaseQuery) === 0);
      };
    }

    function querySearchrm(query) {
      var results = query ? vm.rmitems.filter(createFilterForRm(query)) : vm.rmitems;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 10, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterForRm(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(food) {
        if (vm.branchFilterData[0].barcode_enable == 1) {
          return (food.smname.indexOf(query) >= 0);
        } else {
          return (food.smname.indexOf(lowercaseQuery) >= 0);
        };
      };


    }


    function selectedItemChange(index, fmitem) {
      return fmitem.smrate = fmitem.smname.smrate, fmitem.quantity = fmitem.smname.quantity, fmitem.containQty = fmitem.smname.containQty
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      //filter vendors for branch wise
      var vendor_data = vm.vendors.filter(function(vendor) {
        if (vendor.branch_id == $rootScope.user[0].branch_id) {
          return vendor
        }
      })
      var foodList = vendor_data //assign filterd vendors in autocomplete
      return foodList.map(function(food) {
        return {
          vendor_name: food.company_name.toLowerCase(),
          display: food.company_name,
          vendorID: food.vendorID
        };
      });
    }



    //load all sale materials items in autocomplete
    function loadrm() {
      //filter sale material items for branch wise
      var sistockss = vm.sistocks.filter(function(smitems) {
        if (smitems.branch_id == $rootScope.user[0].branch_id) {
          return smitems
        }
      })
      var salestocks = sistockss //assign filtered smitems for autocomplete
      return salestocks.map(function(food) {
        if (vm.branchFilterData[0].barcode_enable != 1) {
          return {
            smname: food.siname.toLowerCase(),
            display: food.siname,
            quantity: 1,
            smrate: food.PurchasePrice,
            containQty: food.containQty,
            smCatergoryID: food.siCatergoryID,
            smItemID: food.siItemID,
          };
        } else {
          return {
            smname: food.barcode,
            display: food.siname,
            quantity: 1,
            smrate: food.PurchasePrice,
            containQty: food.containQty,
            smCatergoryID: food.siCatergoryID,
            smItemID: food.siItemID,
          };
        }
      });
    }


    //function for Breadcrumb Label with id
    $rootScope.get_BreadcrumbLabel = function() {
      if ($scope.params.id) {
        return $scope.params.id
      } else if (!$scope.params.id) {
        return "Purchase Order"
      }
    }

    $scope.removeupload = function() {
      vm.file = ''
    }
    $scope.removeFile = function(ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this?')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        var file = {
          'file': angular.copy($scope.image_name_copy),
          'expense_bill_id': $scope.params.id
        };
        var expense_bill_id = $scope.params.id;
        api.salesbill_folder.getaData.save(file,
          function(response) {
            $scope.url = ''
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Receipt deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          });

      })
    };

    //updateBill function for only update data in db 

    $scope.update_purchase = function(exportPdfClicked) {
      $scope.newsales.$setSubmitted();

      if ($scope.newsales.$valid) {
        updateservice(exportPdfClicked);
        if (!exportPdfClicked) {
          $state.go('app.smSalesOrder', { id: '' })
        }
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Order updated successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //saveBill function for only save data in db
    $scope.add_purchase = function(exportPdfClicked) {

      $scope.newsales.$setSubmitted();

      if ($scope.newsales.$valid) {
        saveservice(exportPdfClicked)
        if (!exportPdfClicked) {
          // redirect when click on save button
          $state.go("app.addSales", {}, { reload: "app.addSales" })
        }
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Order added successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    function updateservice(exportPdfClicked) {

      if (vm.file) {
        Upload.upload({
          url: 'http://localhost:1100/update_salesbill', //webAPI exposed to upload the file
          data: { file: vm.file, inventory_salesOrder_id: $scope.params.id } //pass file as data, should be user ng-model
        }).then(function(resp) { //upload function returns a promise
        })
      }
      var purchase_orer = vm.purchase;
      var purchase_item = vm.exitems[0].smname;

      var itemdatas = vm.exitems.map(function(item) {
        // Compare data and update stock in stock table if delivered status
        if (siItems.siname = item.searchText && purchase_orer.status == "delivered") {
          var item_quantity = { 'item_quantity': item.quantity * item.containQty, 'editeditems': item, 'smItemID': item.smItemID }
          //filter only new item
          var editadditem = [item].filter(function(addednewitem) {
            if (addednewitem.smname.smItemID) {
              return addednewitem
            }
          })
          //filter only database item
          var editdbitem = [item].filter(function(getExistingitem) {
            if (getExistingitem.inventory_salesItems_id) {
              return getExistingitem
            }
          })

          //this service is for when staff edit exist row items in list to update the quanity
          api.update_salematerial_quantity.getID.update({ siItemID: item.smItemID }, item_quantity,
            function(response) {

            });

          if (editadditem.length) {
            var item_quantitys = { 'item_quantity': item.quantity * item.containQty }
            //this service is for when staff added new row items in list to update the quanity
            api.updateInventory_salequantity.getID.update({ siItemID: item.smname.smItemID }, item_quantitys,
              function(response) {});
          }
        }
        return { 'smItemID': item.smname.smItemID, 'smCatergoryID': item.smname.smCatergoryID, 'containQty': item.containQty, 'smname': item.smname.smname, 'quantity': item.quantity, 'expiry_date': item.expiry_date, 'smrate': item.smrate, 'item_subtotal': item.item_subtotal }
      });
      /*
      -------------------------------------------
      update data in inventory sales order table 
      -------------------------------------------
      */
      var purchase_orders = [{
        'vendor_name': purchase_orer.vendor_name.vendor_name == undefined ? purchase_orer.vendor_name : purchase_orer.vendor_name.vendor_name,
        'vendor_id': purchase_orer.vendor_name.vendorID ? purchase_orer.vendor_name.vendorID : purchase_orer.vendor_id,
        'Description': purchase_orer.Description,
        'status': purchase_orer.status,
        'due_date': purchase_orer.due_date == null ? '' : purchase_orer.due_date,
        'DeliveryDate': purchase_orer.DeliveryDate,
        'branch_id': $rootScope.user[0].branch_id,
        'modifiedID': $rootScope.user[0].staffID,
        'order_bill_type': 'purchase_orer.order_bill_type',
        'post_status':'update'
      }];
      api.update_inventorySale_order.getID.update({ purchase_order_id: $scope.params.id }, purchase_orders,
        function(response) {});
      var payment = vm.expayment;
      /*-------------------------------------------
        update data in expense payment table 
        -------------------------------------------*/
      var expensepayment = [{
        'note': payment.note,
        'received_amount': payment.received_amount,
        'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
        'payment_type': payment.payment_type,
        'transcation_no': payment.transcation_no == "null" ? '' : payment.transcation_no,
        'cheque_no': payment.cheque_no == "null" ? '' : payment.cheque_no,
        'status': 'sales',
        'tax_cgst': vm.exitems.tax_cgstValue,
        'tax_sgst': vm.exitems.tax_sgstValue,
        'tax_status': vm.exitems.tax_status,
        'tax_type': vm.exitems.tax_type,
        'tax_cgstPercent': vm.exitems.tax_cgst,
        'tax_sgstPercent': vm.exitems.tax_sgst,
        'discount': vm.exitems.discount,
        'subtotal': vm.exitems.subtotal,
        'paid_date': payment.paid_date,
        'total_amount': vm.exitems.total_amount

      }];

      api.update_expensepayment_sales.getID.update({ expense_bill_id: $scope.params.id }, expensepayment,
        function(response) {});
      /*-------------------------------------------
         update data in inventory sales item
         -------------------------------------------*/
      //update sales_Payment
      api.update_inventorySale_items.getID.update({ purchase_order_id: $scope.params.id }, {'barcode_enable': vm.branchFilterData[0].barcode_enable, 'itemData' : vm.exitems},
        function(response) {
          if (exportPdfClicked) {
            $scope.SaveExportPdf($scope.params.id);
          }
        });

    }

    function saveservice(exportPdfClicked) {
      var purchase_orer = vm.purchase;
      var purchase_item = vm.exitems[0].rmname;

      var itemdatas = vm.exitems.map(function(item) {
        // if barcode enabled barcode no change to item 
        if(vm.branchFilterData[0].barcode_enable == 1) {
          item.smname.smname = item.smname.display;
        };
        console.log(item.smname.smname);
        //check full raw material items and staff purchased items if delivered status
        if (siItems.siname = item.searchText && purchase_orer.status == "delivered") {
          var item_quantity = { 'item_quantity': item.quantity * item.containQty }
          // update quantity in stock table
          api.updateInventory_salequantity.getID.update({ siItemID: item.smname.smItemID }, item_quantity,
            function(response) {});
        }
        return { 'smItemID': item.smname.smItemID, 'smCatergoryID': item.smname.smCatergoryID, 'containQty': item.containQty, 'smname': item.smname.smname, 'quantity': item.quantity, 'expiry_date': item.expiry_date, 'smrate': item.smrate, 'item_subtotal': item.item_subtotal }
      });
      
      /*
      -------------------------------
      Add receipt and get inserted id
      -------------------------------
     var file = vm.file ? vm.file : [{ 'file': null }]
      Upload.upload({
        url: 'http://localhost:1100/uploadsales', //webAPI exposed to upload the file

        data: { file: file } //pass file as data, should be user ng-model

      }).then(function(resp) { //upload function returns a promise */
        console.log(purchase_orer.due_date);

        var inventory_sales_order = [{
          'vendor_name': purchase_orer.vendor_name.vendor_name,
          'vendor_id': purchase_orer.vendor_name.vendorID,
          'Description': purchase_orer.Description,
          'status': purchase_orer.status,
          'DeliveryDate': purchase_orer.DeliveryDate,
          'due_date': purchase_orer.due_date == null || purchase_orer.due_date == undefined ? '' : purchase_orer.due_date,
          'staffID': $rootScope.user[0].staffID,
          'modifiedID': $rootScope.user[0].staffID,
          'branch_id': $rootScope.user[0].branch_id,
          'billname': '',
          'order_bill_type': 'purchase',
          'post_status':'new'
        }];
        /*
         -------------------------------------------
         Add data in inventory sales order table using inserted id
         -------------------------------------------
         */
        api.inventory_sales_order.getAll.save(inventory_sales_order,
          function(response) {
            console.log(response);
            var inventory_salesOrder_id = response.insertId;
            var salesorderitem = { 'itemdata': itemdatas, 'inventory_salesOrder_id': inventory_salesOrder_id };
            /*-------------------------------------------
                 Add data in inventory sales item table
              -------------------------------------------*/
            api.inventory_sale_items.getAll.save(salesorderitem,
              function(response) {
                /*-------------------------------------------
                    Add data in expense payment table
                 -------------------------------------------*/
                var payment = vm.expayment;
                var expensepayment = [{
                  'note': payment.note,
                  'received_amount': payment.received_amount,
                  'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
                  'payment_type': payment.payment_status == 'unpaid' ? '' : payment.payment_type,
                  'transcation_no': payment.transcation_no,
                  'cheque_no': payment.cheque_no,
                  'status': 'sales',
                  'tax_cgst': vm.exitems.tax_cgstValue,
                  'tax_sgst': vm.exitems.tax_sgstValue,
                  'tax_status': vm.exitems.tax_status,
                  'tax_type': vm.exitems.tax_type,
                  'tax_cgstPercent': vm.exitems.tax_cgst,
                  'tax_sgstPercent': vm.exitems.tax_sgst,
                  'discount': vm.exitems.discount,
                  'subtotal': vm.exitems.subtotal,
                  'total_amount': vm.exitems.total_amount,
                  'paid_date': payment.paid_date,
                  'inventory_salesOrder_id': inventory_salesOrder_id

                }];

                api.expensepayment.getAll.save(expensepayment,
                  function(response) {
                    if (exportPdfClicked) {
                      // send purchase order id for export pdf
                      $scope.SaveExportPdf(inventory_salesOrder_id);
                    }
                  });
              });
          })
      //});
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.stockRawMaterial', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.stockRawMaterial', {
        url: '/stock-raw-material',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/inventory/raw-material/stock-raw-material/stock-raw-material.html',
            controller: 'StockRawMaterialController as vm'
          }
        },
        resolve: {
          rmstock: function(apiResolver) {
            return apiResolver.resolve('rmstock.getAll@get');
          },
          rmcategorydata: function(apiResolver) {
            return apiResolver.resolve('rmcategorydata.getAll@get');
          },

          rmItems: function(apiResolver) {
            return apiResolver.resolve('rmItems.getAll@get');
          },

          rmcategory: function(apiResolver) {
            return apiResolver.resolve('rmCategory.getAll@get');

          }
        },

        ncyBreadcrumb: {
          label: "{{'Inventory.STOCK-OF-RAW-MATERIAL' | translate}}"
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.stockRawMaterial')
    .controller('StockRawMaterialController', StockRawMaterialController)
    .directive('exportToCsv8', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            //var today=new Date()
            var today = new Date(scope.myDate).toString(); //get like wed apr with time
            today = new Date(today).toUTCString();
            today = today.split(' ').slice(0, 4).join(' ');
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: (today) + '- Stock Raw Material' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });

  /** @ngInject */
  function StockRawMaterialController($scope, $rootScope, $timeout, rmItems, rmcategory, $mdDialog, $mdToast, rmstock, rmcategorydata) {
    var vm = this;
    //get full raw material category data
    vm.rmcategorydata = rmcategorydata;
    $scope.myDate = new Date(); // assign today data to md picker
    //filter raw material items for branch wise
    var rmItemss = rmItems.filter(function(rmitems) {
      if (rmitems.branch_id == $rootScope.user[0].branch_id) {
        return rmitems
      }
    })

    vm.rmstock = rmItemss; //assign rm items to table
    vm.rawcategorys = rmcategory;
    //select box data for caegory filter in raw items
    var All_raw_category_items = [{ rmCatergoryID: "All", rmCatergoryName: "All Catergory" }]
    //filter raw material items for branch wise
    var rmcategorydatas = rmcategorydata.filter(function(rmcategorys) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return rmcategorys.branch_id == branch_id
      })
    })
    //map rmcategory data for our convenient
    var rmdata = rmcategorydatas.map(function(rm) {
      return { 'rmCatergoryID': rm.rmCatergoryID, 'rmCatergoryName': rm.rmCatergoryName }
    })

    vm.rmCategory = All_raw_category_items.concat(rmdata); //concat of two array
    //clear search text function while search
    $scope.clearText = function() {
      vm.search = '';
    }
    //filter raw material items as category wise
    $scope.getRaw_items = function(stu) {
      $scope.raw_load = true
      var rmID = stu;
      if (stu == "All") {
        vm.rmstock = rmItemss;
        $timeout(function() {
          $scope.raw_load = false
        }, 500);

        return;
      }

      vm.rmstock = [];
      for (var i = 0; i < rmItemss.length; i++) {
        if (rmItemss[i].rmCatergoryID == rmID) {
          vm.rmstock.push(rmItemss[i]);
          continue;
          return;

        }
      }
      $timeout(function() {
        $scope.raw_load = false
      }, 500);

    };

    // GET CATEGORY NAME
    //---------------- 
    $scope.getCategoryName = function(rmInfo) {
      if (!vm.rawcategorys) {
        return;
      }
      for (var i = 0; i < vm.rawcategorys.length; i++) {
        if (vm.rawcategorys[i].rmCatergoryID == rmInfo.rmCatergoryID) {
          return vm.rawcategorys[i].rmCatergoryName
        }
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.rmPurchasedOrder', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.rmPurchasedOrder', {
        url: '/rm-purchased-order',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/inventory/raw-material/purchased-order/rm-purchased-order.html',
            controller: 'RmPurchasedOrderController as vm'
          }
        },
          resolve: {
          getpurchase: function(apiResolver) {
            return apiResolver.resolve('getpurchase.getAll@get');
          },
           staffRole: function (apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
        },
         rawmaterial_bill_data: function(apiResolver) {
            return apiResolver.resolve('rawmaterial_bill_data.getAll@get');
          },
          getvendors: function(apiResolver) {
          return apiResolver.resolve('getvendors.getAll@get');
         }
        },
        ncyBreadcrumb: {
          label: "{{'Inventory.RAW-MATERIAL' | translate}} {{'Inventory.PURCHASE-ORDER' | translate}}"
        }
      });

    // Translation
 
   
  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.rmPurchasedOrder')
    .controller('RmPurchasedOrderController', RmPurchasedOrderController)
    .directive('exportToCsv1', function() { //export as excel for raw material purchase order
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Purchase Rawmaterial' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function RmPurchasedOrderController($scope, staffRole, rawmaterial_bill_data, api, getvendors, $cookies, $rootScope, $stateParams, $state, $timeout, $mdDialog, $mdToast, getpurchase) {
    //console.log(getpurchase);
    var vm = this;
    var originatorEv;
    $scope.mdtableselected = []; // dummy assign
    //get loggedin staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    //get staff data with id for like hi staff
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    vm.staffs = staffRole;
    //filter vendor data for branch wise
    var vendor_all = [{ 'vendor_name': 'All vendors', 'vendorID': '' }]
    var getvendorss = getvendors.filter(function(vendor) {
      if (vendor.branch_id == $rootScope.user[0].branch_id) {
        return vendor
      }
    })

    var vend = getvendorss.map(function(a) {
      return { 'vendor_name': a.company_name, 'vendorID': a.vendorID }
    })
    // merge all and branch wise vendor
    vm.vendor = vendor_all.concat(vend); //concat of two array

    $scope.myDate = new Date();
    $scope.staffs = "admin"
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': '', 'name': 'All staff' }]
    //filter purchase raw material staffs and branch wise
    $scope.purchae_rawmaterial_staff = staffRole.filter(function(staff) {
      return rawmaterial_bill_data.some(function(rmpurchaseorders) {
        return (staff.staffID == rmpurchaseorders.staffID && staff.status == 'active' && staff.branch_id == rmpurchaseorders.branch_id)
      })
    })
    // Merge all staff and branch wise staff for admin
    vm.staffRole = staff_all.concat($scope.purchae_rawmaterial_staff); //concat two array
    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    $scope.monthyear = new Date();
    //clear search text function
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }
    //find the staff name who was the last edit for particular bill
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };

    //Getting purchase order from server in function
    function purchase_order_success(desserts) {

      $scope.total_paid = desserts[0].total_paid;
      $scope.total_purchase = desserts[0].total_purchase;
      $scope.total_cash = desserts[0].total_cash;
      $scope.total_card = desserts[0].total_card;
      $scope.total_cheque = desserts[0].total_cheque;
      $scope.total_online = desserts[0].total_online;
      $scope.balance = desserts[0].balance;
      $scope.paid_count = desserts[0].paid_count;
      $scope.balance_count = desserts[0].balance_count;

      //collect all data for our purpose
      vm.purchase_serviceID = desserts[0].results.map(function(item) {        
        if (!item.DeliveryDate || item.DeliveryDate=='null' || item.DeliveryDate=='undefined') {
          var time = ''
          var deli_time = ''
        } else {
          var date_delivery = new Date(item.DeliveryDate).toString(); //get like wed apr with time
          var a = date_delivery.split(' ') //split date like array
          var order_time = new Date(item.created_on).toString(); //get like wed apr with time
          var b = order_time.split(' ') //split date like array
          var ordertiming = (order_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
          var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
          var orderdate = (b[0] + " " + b[1] + " " + b[3]);

          var deli_time = new Date(item.DeliveryDate).toString(); //get like wed apr with time
          var bs = deli_time.split(' ') //split date like array
          var delitiming = (deli_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hourss = (delitiming[0] % 12) || 12; // convert to 12-hour style
          var deltime = hourss + ":" + delitiming[1] + " " + (delitiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM

          var deliverydate = (a[0] + " " + a[1] + " " + a[3]);
          var currentTime = new Date();
          var endTime = new Date(item.DeliveryDate);
        }

        //filter only items depending on purchaseorder_id for count of items
        var food_items = []; // empty array for get np of items for count
        getpurchase.forEach(function(fullPurchaseItemData) { //count&watch each items
          if (fullPurchaseItemData.staffID == $rootScope.user[0].staffID && fullPurchaseItemData.purchase_order_id == item.purchase_order_id)
            food_items.push(fullPurchaseItemData.rmname);
        });
        return {
          'rmname': food_items.length,
          'purchaseStatus': item.purchaseStatus,
          'modifiedID': item.modifiedID,
          'last_modified': new Date(item.last_modified),
          'payment_status': item.payment_status,
          'tax_cgst': item.tax_cgst === null ? 0 : item.tax_cgst,
          'tax_sgst': item.tax_sgst === null ? 0 : item.tax_sgst,
          'discount': item.discount,
          //'deli_time': deltime,
          'staffID': item.staffID,
          'created_on': new Date(item.created_on),
          'showordertime': time,
          'due_date': item.payment_status == 'fully paid' ? new Date(item.paid_date) : item.due_date,
          'purchase_order_id': item.purchase_order_id,
          'vendor_name': item.vendor_name,
          'total_amount': item.total_amount,
          'received_amount': item.received_amount,
          'DeliveryDate': new Date(item.DeliveryDate)
        }

      })
      // Assign the mapped value to md-table
      vm.getpurchase = vm.purchase_serviceID;
      $scope.purchaseorder_count = vm.purchase_serviceID.length; // apply total_count pagination
    }

    /*----------------
    Filter dropdown and data get from server
    -------------------*/
    $scope.changeDate = changeDate;
    //function for change date for show data depending on date
    function changeDate(status_type, amount_type, myDate, vendor, staff) {

      $scope.load = true; // Show preloader
      getPurchaseOrder(status_type, amount_type, myDate, vendor, staff) // callback funtion

      $timeout(function() {
        $scope.load = false; // hide preloader
      }, 500);

    }
    $scope.getPurchaseOrder = getPurchaseOrder()
    //service for purchase list
    function getPurchaseOrder(status_type, amount_type, myDate, vendor, staff) {
      if (amount_type == undefined || status_type == undefined || myDate == undefined || vendor == undefined) {
        // if All selected in dropdown filter and init page load
        var amount_type = 'All'
        var status_type = ''
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
        var vendor = ''
      } else {
        // if All not selected in dropdown filter
        var vendor = vendor;
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear()
      }


      if ($cookies.get('admin') != 'admin') {
        // If staff assign this value
        $scope.purchaseorder_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          status_type: status_type,
          month: month,
          year: year,
          vendor: vendor
        };
      }
      if ($cookies.get('admin') == 'admin') {
        // If admin assign this value
        var staffID = staff == undefined ? 'admin' : staff
        $scope.purchaseorder_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          status_type: status_type,
          month: month,
          year: year,
          vendor: vendor
        };
      }


      $scope.reload = function() {
        $scope.promise = api.getpurchase_service.getAll.get($scope.purchaseorder_query, purchase_order_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000);*/
      };
      $scope.reload()
    };
    getPurchaseOrder();
    // GET purchase order created name for admin
    //---------------- 
    $scope.purchaseorder_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };

    vm.amount_type = [{
      "name": 'All amount type',
      "value": 'All'
    }, {
      "name": 'Paid amount',
      "value": 'fully paid'
    }, {
      "name": 'Balance amount',
      "value": 'balance'
    }];
    vm.status_type = [{
      "name": 'All status',
      "value": ''
    }, {
      "name": 'Ordered',
      "value": 'ordered'
    }, {
      "name": 'Delivered',
      "value": 'delivered'
    }];


    // Delete the purchase order
    $scope.deletePurchaseOrder = function(item, ev, index) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this item?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.delete_rawmaterial_data.getID.delete({ purchase_order_id: item.purchase_order_id },
          function(response) {
            //success callback
            deleteItem(item);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

      /**
       * Delete Item
       */
      function deleteItem(item) {
        vm.getpurchase.splice(vm.getpurchase.indexOf(item), 1);

        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });


      }

    }

    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
      // unknown code for search pagination
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      // while search
      $scope.getPurchaseOrder = getPurchaseOrder;
      // for trigger the service to get data
      $scope.reload();
    });
    //date filter only showing months
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];

    //pass id to new purchase order for edit purpose
    $scope.purchaseid = function(purchase_order_id) {
      var id = purchase_order_id;
      $scope.params = $stateParams;
      $state.go('app.addPurchase', { id: purchase_order_id })
    }


    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

  }
})();

(function() {
  'use strict';

  angular
   .module('app.inventory.deliverToKitchen', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.deliverToKitchen', {
        url: '/deliver-to-kitchen',
        views: {
           'content@app': {
            templateUrl: 'app/main/cashier/inventory/raw-material/deliver-to-kitchen/deliver-to-kitchen.html',
            controller: 'deliverToKitchenController as vm'
          }
        },
         resolve: {
            rmstocks: function(apiResolver) {
            return apiResolver.resolve('rmstocks.getAll@get');
          },           
           staffRole: function (apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
        }
        },
        ncyBreadcrumb: {
          label: 'Deliver to Kitchen'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.deliverToKitchen')
    .controller('deliverToKitchenController', deliverToKitchenController);

  /** @ngInject */
  function deliverToKitchenController($scope, $timeout, staffRole, $rootScope, $cookies, $interval, api, msNavigationService, $state, $mdDialog, $mdToast, rmstocks) {
    var vm = this;
    vm.staffs = staffRole;
    $scope.mdtableselected = []; // dummy assign
    // Last updated staff and details
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    //assign all raw material items for auto complete
    vm.rmstocks = rmstocks;
    //get staff data from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');
    //get staff data with id for show like hi staff
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      });

    $scope.purchaseorder_query = {
      filter: '',
      limit: '10',
      order: 'nameToLower',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };
    //search text clear function
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }
    //convert date from string to date
    $scope.formatDate = function(date) {
      return new Date(date)
    }

    //success function of delivery kitchen data from the server
    function delivery_kitchen_success(desserts) {
      //collect counts from server
      $scope.deliveryLength = desserts[0].results
      $scope.purchaseorder_count = desserts[0].purchaseorder_count // apply total_count for doordelivery section
      vm.getpurchase = desserts[0].results
    }

    //service for get all delivery kitchen data
    $scope.getDessertsss = function() {
      $scope.reload = function() {
        $scope.promise = api.getkitchendata_service.getAll.get($scope.purchaseorder_query, delivery_kitchen_success).$promise;
       /* $timeout(function() {
          $scope.reload();
        }, 500000); */
      };
      $scope.reload();
    };


    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
// Unknown code for pagination
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss();
    });



    // GET created by for amdin to know who created
    //---------------- 
    //filter only raw material permission staffs
    $scope.deliverykitchen_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };

    // Add Table dialog
    //popup for add or edit delivery item for kitchen
    vm.showAddTableDialog = function(ev, delToKitchen) {
      $mdDialog.show({
        controller: DialogController,
        templateUrl: 'app/main/cashier/inventory/raw-material/deliver-to-kitchen/deliver-to-kitchen-additem.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false,
        locals: {
          delToKitchen: delToKitchen,
          rmstocks: vm.rmstocks,

        }
      })

      function DialogController($scope, $interval, $cookies, $state, $mdDialog, $mdToast, rmstocks, $q, $timeout, api, delToKitchen) {
        var vm = this;
        $rootScope.user = $cookies.getObject('user');
        $timeout(function() {
          $scope.rmstock = rmstocks;
        }, 1000);

       // add row for delivery kitchen items
        $scope.addRow = function() {
          $scope.exitems.push({});
        }
        var DeliveryKitchenData = [];
        DeliveryKitchenData.push(delToKitchen);
        $scope.exitems = DeliveryKitchenData; //edit purpose to deploy items into inputs

        if (!delToKitchen) { //add purpose
          $scope.exitems = [{}];
          $scope.title = 'Add';
          $scope.newRMItem = true;
        };

        //when staff pressed enter key add another item means here new row will be pushed
        $scope.keyPressed = function(keyEvent) {
          if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
            $scope.exitems.push({});
            $scope.indx = $scope.exitems.length - 1;
            $scope.$watch($scope.exitems, function() {
              $timeout(function() {
                angular.element('.autodd').focus();
              }, 10);

            })
          }
        };
        //delete index of row in front end
        $scope.removeRow = function(fmitem, ev, index) {
          $scope.exitems.splice(index, 1);
        }

        // ******************************
        // Internal methods
        // ******************************
        $scope.food = loadAll(); //load all raw material items in auto complete
        $scope.rmname = null;
        $scope.searchText = null;
        $scope.querySearch = querySearch;

        /**
         * Search for food... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
          var results = query ? $scope.food.filter(createFilterFor(query)) : $scope.food;
          var deferred = $q.defer();
          $timeout(function() {
            deferred.resolve(results);
          }, Math.random() * 1000, false);
          return deferred.promise;
        }
        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);
          return function filterFn(food) {
            return (food.rmname.indexOf(lowercaseQuery) === 0);
          };

        }

        function loadAll() {
          //filter raw material items for branch wise
          var rmstockss = rmstocks.filter(function(rmitems) {
            if (rmitems.branch_id == $rootScope.user[0].branch_id) {
              return rmitems
            }
          })
          $scope.rmstock = rmstockss; //assign filterd rmitems for autocomplete
          var foodList = $scope.rmstock //assign filterd rmitems for autocomplete
          return foodList.map(function(food) {
            return {
              rmname: food.rmname.toLowerCase(),
              display: food.rmname,
              rmItemID: food.rmItemID,
              unit: food.unit,
              stock_quantity: food.quantity,
            };
          });
        }

        // Edit function
        //----------------
        $scope.editItem = function(fmitem) {
          $scope.addfoodForm.$setSubmitted();
          // form validation
          if ($scope.addfoodForm.$valid) {
            var kitchendata = $scope.exitems;
            var rmitemdatas = kitchendata.map(function(item) {
              var item_quantity = { 'item_quantity': item.quantity, rmItemID: item.rmItemID, 'editeditems': [item] }
              //this service is for when staff edit exist row items in list to update the quanity
              api.updatedeliveryeditquantity.getID.update({ rmItemID: item.rmItemID }, item_quantity,
                function(response) {

                });

              return { 'rmname': item.rmname, 'rmItemID': item.rmItemID, 'unit': item.unit, 'quantity': item.quantity, 'reason': item.reason == null ? '' : item.reason, 'modifiedID': $rootScope.user[0].staffID }
            });
            var deliveryto_kitchen_id = $scope.exitems[0].deliveryto_kitchen_id;

            api.editkitchendata.getID.update({ deliveryto_kitchen_id: deliveryto_kitchen_id }, rmitemdatas,
              function(response) {

                $mdDialog.hide(); // close popup 
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Updated successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });

              },
              // Error
              function(response) {}
            );
          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }

        };


        //save function for add kitchen data
        $scope.submit = function(fmitem) {
          $scope.addfoodForm.$setSubmitted();
          // form validation checking
          if ($scope.addfoodForm.$valid) {
            $scope.total = rmstocks;
            var kitchendata = $scope.exitems
            var rmitemdatas = kitchendata.map(function(item) {
              var item_quantity = { 'item_quantity': item.quantity }
              // Stock table service
              api.updatedeliveryquantity.getID.update({ rmItemID: item.rmname.rmItemID }, item_quantity,
                function(response) {

                });
              return { 'rmname': item.searchText, 'rmItemID': item.rmname.rmItemID, 'unit': item.rmname.unit, 'quantity': item.quantity, 'reason': item.reason, 'staffID': $rootScope.user[0].staffID, 'modifiedID': $rootScope.user[0].staffID, 'branch_id': $rootScope.user[0].branch_id }
            });
            // Deliver to kitchen table store data
            api.rmitemdatas.getAll.save(rmitemdatas,
              function(response) {
                $state.go("app.deliverToKitchen", {}, { reload: "app.deliverToKitchen" })
                $mdDialog.hide();
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Added successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              });
          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        }

        $scope.closeDialog = function() {
          $mdDialog.hide();
        }

      }

      // Delete alert
      vm.showAlert = function(ev) {
        var confirm = $mdDialog.confirm({
          title: 'Delete Item',
          textContent: 'Are you sure you want to delete this Item?',
          ariaLabel: 'delete food item',
          targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: true,
          ok: 'Remove',
          cancel: 'Cancel'
        });

        $mdDialog.show(confirm).then(function() {

        }, function() {
          // Canceled
        });

      }

    }
    // Delete alert
    vm.deleteContactConfirm = function(vItem, ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Item?')
        .ariaLabel('delete Item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        var item_quantity = { 'item_quantity': vItem.quantity }
        //this service is for when staff edit exist row items in list to update the quanity
        api.deleteAndupdate_delivery_quantity.getID.update({ rmItemID: vItem.rmItemID, deliveryto_kitchen_id: vItem.deliveryto_kitchen_id }, item_quantity,
          function(response) {
            api.editkitchendata.getID.delete({ deliveryto_kitchen_id: vItem.deliveryto_kitchen_id },
              function(response) {
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Deleted successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
                //success callback
                deleteItem(vItem);
              },
              function(response) {
                // error callback
              }
            );
          },
          function() {
            // Canceled
          });
      });

      // delete un needed items in delivery kichen data
      function deleteItem(vItem) {
        vm.getpurchase.splice(vm.getpurchase.indexOf(vItem), 1);
      }

    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.addPurchase', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.addPurchase', {
        url: '/add-purchase-order/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/inventory/raw-material/add-purchase_order/addPurchase.html',
            controller: 'addPurchaseController as vm'
          }
        },
        resolve: {
          getvendors: function(apiResolver) {

            return apiResolver.resolve('getvendors.getAll@get');
          },
          rmstocks: function(apiResolver) {
            return apiResolver.resolve('rmstocks.getAll@get');
          },
          rmItems: function(apiResolver) {
            return apiResolver.resolve('rmItems.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          rmCategory: function(apiResolver) {
            return apiResolver.resolve('rmCategory.getAll@get');
          },
          foodUnit: function(apiResolver) {
            return apiResolver.resolve('foodUnit@get');
          },
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          expense_amountType: function(apiResolver) {
            return apiResolver.resolve('expense_amountType@get');
          }

        },
        ncyBreadcrumb: {

          parent: function($scope, $stateParams) {


            if ($scope.state.params.id) {

              console.log($scope.state.params.id)
              // Constant defined in CollectionsLibraryMyController
              return 'app.rmPurchasedOrder';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController
              return null;
            }
          },

          label: "{{get_BreadcrumbLabel()}}"
          //label: 'New Expense'
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.inventory.addPurchase')
    .controller('addPurchaseController', addPurchaseController)
    .directive('validNumber', function() {
      return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModelCtrl) {
          if (!ngModelCtrl) {
            return;
          }

          ngModelCtrl.$parsers.push(function(val) {
            var clean = val.replace(/^[^1-9]*|[^0-9]/g, '');
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.on('keypress', function(event) {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    })
    .directive('dateInput', function() {
      // String data will format to date format for input
      return {
        restrict: 'A',
        scope: {
          ngModel: '='
        },
        link: function(scope) {
          if (scope.ngModel) scope.ngModel = new Date(scope.ngModel);
        }
      }
    });


  /** @ngInject */
  function addPurchaseController($scope, $cookies, branch_data, rmItems, rmCategory, foodUnit, dietType, Upload, expense_amountType, $mdDialog, $state, $rootScope, $mdToast, $q, $timeout, $stateParams, api, getvendors, rmstocks) {
    var vm = this;
    //get logged in staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    $scope.currentDate = new Date() //assign today date by default
    vm.purchaseTax_status = dietType.purchase; // Receive include and exclude array from general json

    // Set active tab for initial time
    $scope.prTabName = "tabBillInfo";
    vm.rmstocks = rmstocks; // In autocomplete data
    //filter vendor data for branch wise
    var getvendorss = getvendors.filter(function(vendor) {
      if (vendor.branch_id == $rootScope.user[0].branch_id) {
        return vendor
      }
    })
    vm.vendors = getvendorss; //assign filterd vendors
    //store amount pay type like cash or card
    vm.expense_amountType = expense_amountType.expensebill.Amount_PayType; // getting pay mode data from local json
    $scope.cash = "cash";

    //initial activation of tab
    $scope.expensebill = true; // active tab
    //tab when change
    $scope.expensebills = function() {
      $scope.expensebill = true;
      $scope.payments = false
    }
    $scope.payment = function() {
      $scope.payments = true
      $scope.expensebill = false;
    }
    //filter raw material catagory for branch wise for while add new raw material item this categories will sent via popup dynamically
    var rmCategorys = rmCategory.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    // vm.rawMenusInfo = rmItems;
    vm.rawcategorys = rmCategorys; //assign raw material categories for send via popup and  add new raw material item when staff click plus button

    //filter branch data for branch wise
    var branchfilter = branch_data.filter(function(branch) {
      if (branch.branch_id == $rootScope.user[0].branch_id)
        return branch
    })
    $scope.branch_name = branchfilter[0].branch_name; //assign branch name


    //get as pdf syntax function using jspdf library
    var doc = new jsPDF();
    var specialElementHandlers = {
      '#editor': function(element, renderer) {
        return true;
      }
    };
    //export pdf function
    $scope.SaveExportPdf = function(purchase_order_id) {

      $scope.purchase_order_id = purchase_order_id;
      $scope.ReportTime = new Date()
      $timeout(function() {
        doc.fromHTML($('#purchaserawmaterial').html(), 15, 15, {
          'width': 170,
          'elementHandlers': specialElementHandlers
        });
        doc.save("" + moment(new Date()).format('MMM DD,YYYY') + "-Purchase Raw Material-" + $scope.branch_name + ".pdf");
        if ($scope.params.id) {
          // redirect state to purchase order list
          $state.go('app.rmPurchasedOrder', { id: '' })
        } else {
          // redirect state to add purchase order
          $state.go("app.addPurchase", {}, { reload: "app.addPurchase" })
        }

      }, 1000)
    };

    //add new raw material item popup  
    vm.showAddTableDialog = function(ev, rmInfo) {
      $mdDialog.show({
        controller: 'addRawDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/raw-material/item/dialog/rm-additem.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          rmItems: vm.rmitems,
          rmCategory: vm.rawcategorys,
          rmInfo: rmInfo,
          foodUnit: foodUnit

        }
      });
    };
    // Add Table dialog
    //add new vendor popup
    vm.showAddTableDialogs = function(ev, vItem) {
      $mdDialog.show({
        controller: 'addVendorDialogController',
        templateUrl: 'app/main/admin/vendor/vendor.addcategory.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          vendor: vItem,
          vendors_all: vm.food

        },
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false
      })
    };

    //while changed purchase status the text will be changed
    $scope.changestatus = function() {
      if (vm.purchase.status == 'delivered') {
        vm.purchase.DeliveryDate = new Date();
        
      } else {
        vm.purchase.DeliveryDate = ''

      }
    }

    $scope.myDate = new Date(); //assign today date
    //retrict date only 30 days move on backward from md pciker FOR Due DATE
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 3,
      $scope.myDate.getDate()
    );


    //retrict date only 30 days move on backward from md pciker FOR Delivery DATE
    $scope.minDatess = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 0,
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDatess = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 0,
      $scope.myDate.getDate()
    );


    //retrict date only 30 days move on backward from md pciker FOR PAID DATE
    $scope.minDates = new Date(
      $scope.myDate.getFullYear() - 1,
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDates = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
          //when change payment status clear old payment status of sub inputs
      $scope.clear_advancePaid = function() {
        vm.expayment.note = ''
        vm.expayment.received_amount = ''
        vm.expayment.cheque_no = ''
        vm.expayment.transcation_no = ''
      }
      //vm.purchase.DeliveryDate = new Date()
      $scope.clear_payment = function() {

        if (vm.expayment.payment_status == 'fully paid') {
          vm.expayment.received_amount = ''
        }
        if (vm.expayment.cheque_no) {
          vm.expayment.transcation_no = ''
        }
        if (vm.expayment.transcation_no) {
          vm.expayment.cheque_no = ''
        }

      }

    // Methods
    $scope.params = $stateParams; //url parameter
    /*
    -------------------------------------------------

    Add scenario init raw material data

    -------------------------------------------------
    */
    //add purpose
    if (!$scope.params.id) {
      // Init empty data
      vm.exitems = [{}];
      vm.purchase = {};
      vm.expayment = {};
      vm.expayment.paid_date = new Date();
      vm.purchase.selectOrdered = 'delivered';
      
    }
    /*
    -------------------------------------------------

    Edit scenario init raw material data

    -------------------------------------------------
    */
    else { //edit purpose
      vm.expayment = {}
      var purchase_order_id = $scope.params.id;
      // Getting data purchase order table
      api.purchasedata.getaData.get({ purchase_order_id: purchase_order_id },
        function(response) {
          vm.purchase = response[0];
          if (vm.purchase.status == 'delivered') {
            $scope.disable_state = true;
          } else {
            $scope.disable_state = false;
          }
          $scope.url = response[0].billname; //apply image name
          $scope.image_name_copy = angular.copy($scope.url) //make copy delete the receipt
          vm.purchase.Description = vm.purchase.Description == 'undefined' ? '' : vm.purchase.Description
          vm.purchase.due_date = response[0].due_date == '' ? '' : new Date(response[0].due_date);
          vm.purchase.DeliveryDate = new Date(response[0].DeliveryDate);
        })
      // Getting data purchase item table
      api.purchaseitem.getID.get({ purchase_order_id: purchase_order_id },
        function(response) {
          vm.exitems = response
        })
      // Getting data purchase expense payment table
      api.expense_payment_purchase.getID.get({ expense_bill_id: purchase_order_id },
        function(response) {
          vm.expayment = response[0];
          calculateTotals(); //call watch function
          vm.expayment.transcation_no = vm.expayment.transcation_no == null ? '' : response[0].transcation_no
          vm.expayment.cheque_no = vm.expayment.cheque_no == null ? '' : response[0].cheque_no
          vm.expayment.paid_date = new Date(response[0].paid_date)
        })

    }


    //while purchase enter button will triggered and added new empty row
    $scope.keyPressed = function(keyEvent) {
      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        vm.exitems.push({
          'item_name': '',
          'item_amount': 0
        });
        $scope.indx = vm.exitems.length - 1;
        $scope.$watch(vm.exitems, function() {
          $timeout(function() {
            angular.element('.autodd').focus();
          }, 10);

        })

      }
    };
    //cancel function
    $scope.cancel = function(ev) {
      if ($scope.newpurchase.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go("app.addPurchase", {}, { reload: "app.addPurchase" })
        }, function() {
          // Canceled
        });
      } else {
        $state.go("app.addPurchase", {}, { reload: "app.addPurchase" })
      }
    }
    //while update items this button triggered
    $scope.canceledit = function(ev) {
      if ($scope.newpurchase.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go('app.rmPurchasedOrder', { id: '' })
        }, function() {
          // Canceled
        });
      } else {
        $state.go('app.rmPurchasedOrder', { id: '' })
      }
    }


    // only number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };


    vm.payment = [{
      "name": 'Unpaid',
      "value": 'unpaid'
    }, {
      "name": 'Fully Paid',
      "value": 'fully paid'
    }, {
      "name": 'Advance Paid',
      "value": 'advance paid'
    }, ];
    vm.orderstatus = [{
      "status": 'ordered',
      "value": 'Ordered'
    }, {
      "status": 'delivered',
      "value": 'Delivered'
    }];

    vm.myDate = new Date(); //assign today date

    // Add Row
    //----------------
    $scope.addRow = function() {
      vm.exitems.push({
        'item_name': '',
        'item_amount': '0'
      });
    };

    // Remove Row
    $scope.removeRow = function(expenseitem, ev, index) {
      if (!expenseitem.purchase_items_id) {
        vm.exitems.splice(index, 1);
      } else {
        var confirm = $mdDialog.confirm()
          .title('Delete')
          .htmlContent('Are you sure you want to delete this item?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          var item_quantity = { 'item_quantity': expenseitem.quantity * expenseitem.containQty }

          //this service is for when staff edit exist row items in list to update the quanity
          api.deleteAndupdate_rawmaterial_quantity.getID.update({ rmItemID: expenseitem.rmItemID, purchase_items_id: expenseitem.purchase_items_id }, item_quantity,
            function(response) {
              api.delete_purchase_items.getID.delete({ purchase_items_id: expenseitem.purchase_items_id },
                function(response) {
                  //success callback
                  deleteItem(expenseitem);
                },
                function(response) {
                  // error callback
                }
              );

            },
            function() {
              // Canceled
            });
        });

      };
      /**
       * Delete index of the Item
       */
      function deleteItem(fmitem) {
        vm.exitems.splice(vm.exitems.indexOf(expenseitem), 1);

        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    vm.food = loadAll(); //load all vendors in autocomplete
    vm.rmitems = loadrm(); //load all raw items in autocomplete
    vm.foodItemName = null;
    vm.rmname = null;

    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;
    vm.querySearchrm = querySearchrm;
    vm.selectedItemChange = selectedItemChange;



    $scope.focustax = function() {
      $timeout(function() {
        angular.element('#tax-focus').focus();
      }, 100);
    }
    $scope.focustaxSgst = function() {
      $timeout(function() {
        angular.element('#taxSgst-focus').focus();
      }, 100);
    }
    $scope.focusdiscount = function() {
      $timeout(function() {
        angular.element('#discount-focus').focus();
      }, 100);
    }
    var calculateTotals = function() {
      /*-----------------------------------
       EDIT purpose calculation manipulation started
      -------------------------------------*/
      if ($scope.params.id) {
        if (vm.expayment.tax_status) {
          vm.exitems.tax_status = vm.expayment.tax_status
        }
        var discount = vm.expayment.discount;
        if (discount) {
          vm.exitems.discount = discount
        }
        //auto open when tax  is exist
        if (vm.expayment.tax_type) {
          vm.exitems.tax_type = vm.expayment.tax_type
        }
        //auto open tax cgst  is exist
        if (vm.expayment.tax_cgst) {
          $scope.OpenTax = true;
          $scope.hideclose = true;
        };
        //auto open tax sgst  is exist
        if (vm.expayment.tax_sgst) {
          $scope.OpenTax = true;
          $scope.hideclose = true;
        };
        //auto open when discount  is exist
        if (vm.expayment.discount) {
          $scope.OpenPermission = true;
          $scope.hideclose = true;

        };
        // Tax Manipulation
        // if exclude condition
        if (vm.expayment.tax_status == 'exclude') {
          if (vm.expayment.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = vm.expayment.tax_cgst
            vm.exitems.tax_sgstValue = vm.expayment.tax_sgst
            vm.exitems.tax_cgst = vm.expayment.tax_cgst
            vm.exitems.tax_sgst = vm.expayment.tax_sgst
            vm.exitems.taxamount = parseInt(vm.exitems.tax_cgst) + parseInt(vm.exitems.tax_sgst)
          } else if (vm.expayment.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.expayment.subtotal / 100) * vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.expayment.subtotal / 100) * vm.expayment.tax_sgstPercent
            vm.exitems.tax_cgst = vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgst = vm.expayment.tax_sgstPercent
            vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
          }
        }
        // if include condition
        if (vm.expayment.tax_status == 'include') {
          if (vm.expayment.tax_type == 'amount') {
            vm.exitems.tax_cgst = vm.expayment.tax_cgst
            vm.exitems.tax_sgst = vm.expayment.tax_sgst
          } else if (response[0].tax_type == 'percent') {
            vm.exitems.tax_cgst = vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgst = vm.expayment.tax_sgstPercent
          }
          vm.exitems.taxamount = 0
        }
      };
      /*-----------------------------------
           EDIT purpose ended
      -------------------------------------*/
      /*-----------------------------------
       Add purpose calculation manipulation started
      -------------------------------------*/
      var subtotals = 0;
      angular.forEach(vm.exitems, function(rmitem) {
        rmitem.item_subtotal = rmitem.quantity * rmitem.rmrate;
        rmitem.quantity = (rmitem.quantity != null) ? rmitem.quantity : '';
        rmitem.rmrate = (rmitem.rmrate != null) ? rmitem.rmrate : '';
        subtotals += rmitem.quantity * rmitem.rmrate;
      })
      vm.exitems.subtotal = subtotals;
      // Data change in tax dropdown
      $scope.dataChange = function() {
        cals();
      };
      cals();

      function cals() {
        var tax_cgstPercent = (vm.exitems.tax_cgst != null) ? vm.exitems.tax_cgst : 0;
        var tax_sgstPercent = (vm.exitems.tax_sgst != null) ? vm.exitems.tax_sgst : 0;
        vm.exitems.discount = (vm.exitems.discount != null) ? vm.exitems.discount : '';
        // Tax Calculation
        // if exclude condition
        if (vm.exitems.tax_status == 'exclude') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = (tax_cgstPercent == '') ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = (tax_sgstPercent == '') ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
        }
        // if include condition
        else if (vm.exitems.tax_status == 'include') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = tax_cgstPercent == '' ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = tax_sgstPercent == '' ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = (vm.exitems.subtotal / 100) * 0;
        }

        vm.roundtotal = vm.exitems.subtotal + vm.exitems.taxamount - vm.exitems.discount;
        vm.exitems.total_amount = Math.round(vm.roundtotal);
      }
      //remove row condition :- Disable first index while removing rows,
      if (vm.exitems.length > 1) {
        $scope.formitem = false;
      } else {
        $scope.formitem = true;

      }

    };

    $scope.$watch('vm.exitems', calculateTotals, true); //watch function of ng-repeat array name

    // Clear the discount :- Calculation
    $scope.clearDis = function() {
      if (!vm.exitems.discount) {
        vm.exitems.discount = 0;
      };
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) + parseInt(vm.exitems.discount)
      vm.exitems.discount = '';
    }
    // Clear the Tax :- Calculation
    $scope.clrTax = function() {
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) - parseInt(vm.exitems.taxamount)
      vm.exitems.tax_cgst = '';
      vm.exitems.tax_sgst = '';
      vm.exitems.taxamount = 0;

    }

    /**
     * Search for Vendor... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.vendor_name.indexOf(lowercaseQuery) === 0);
      };

    }

    function querySearchrm(query) {
      var results = query ? vm.rmitems.filter(createFilterForRm(query)) : vm.rmitems;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterForRm(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.rmname.indexOf(lowercaseQuery) >= 0);
      };

    }


    function selectedItemChange(index, fmitem) {
      return fmitem.rmrate = fmitem.rmname.rmrate, fmitem.quantity = fmitem.rmname.quantity, fmitem.containQty = fmitem.rmname.containQty, fmitem.unit = fmitem.rmname.unit
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      //filter vendors for branch wise
      var vendor_data = vm.vendors.filter(function(vendor) {
        if (vendor.branch_id == $rootScope.user[0].branch_id) {
          return vendor
        }
      })
      var foodList = vendor_data //assign filtered vendors in autocomplete
      return foodList.map(function(food) {
        return {
          vendor_name: food.company_name.toLowerCase(),
          display: food.company_name,
          vendorID: food.vendorID
        };
      });
    }
    //load all raw material items in autocomplete
    function loadrm() {
      //filter rmitems for branch wise
      var rmstockss = vm.rmstocks.filter(function(rmitems) {
        if (rmitems.branch_id == $rootScope.user[0].branch_id) {
          return rmitems
        }
      })
      var rawstocks = rmstockss //assign rmitems for branch wise for autocomplete
      return rawstocks.map(function(food) {
        return {
          rmname: food.rmname.toLowerCase(),
          display: food.rmname,
          quantity: 1,
          rmrate: food.rmrate,
          containQty: food.containQty,
          unit: food.unit,
          rmCatergoryID: food.rmCatergoryID,
          rmItemID: food.rmItemID,
        };
      });
    }



    //function for Breadcrumb Label with id
    $rootScope.get_BreadcrumbLabel = function() {
      if ($scope.params.id) {
        return $scope.params.id
      } else if (!$scope.params.id) {
        return "Purchased Order"
      }
    }

    //updateBill function for only update data in db 

    $scope.update_purchase = function(index) {
      $scope.newpurchase.$setSubmitted();
      // form validation condition
      if ($scope.newpurchase.$valid) {
        // Update service
        updateservice(index);
        if (!index) {
          $state.go('app.rmPurchasedOrder', { id: '' })
        }
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Order updated successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    // Add placeholder for autocomplete
    $timeout(function() {
      $(".foodItem-auto input").attr("placeholder", "Enter the purchase item");
    }, 500);

    //saveBill function for only save data in db
    $scope.add_purchase = function(exportPdfClicked) {

      $scope.newpurchase.$setSubmitted();
      // form validation condition
      if ($scope.newpurchase.$valid) {
        saveservice(exportPdfClicked);
        // clearform();
        if (!exportPdfClicked) {
          // redirect when click on save button
          $state.go("app.addPurchase", {}, { reload: "app.addPurchase" })
        }

        $mdToast.show({
          template: '<md-toast class="success"><span flex>Order added successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    // clear receipt file in client side 
    $scope.removeupload = function() {
      vm.file = ''
    }
    // clear receipt file in server side in edit
    $scope.removeFile = function(ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this?')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        var file = {
          'file': angular.copy($scope.image_name_copy),
          'expense_bill_id': $scope.params.id
        };
        var expense_bill_id = $scope.params.id;
        api.purchasebill_folder.getaData.save(file,
          function(response) {
            $scope.url = ''
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Receipt deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          });

      })
    };


    function updateservice(exportPdfClicked) {
      // If added newly any receipt image it will happen
      if (vm.file) {
        Upload.upload({
          url: 'http://localhost:1100/update_purchasebill', //webAPI exposed to upload the file
          data: { file: vm.file, purchase_order_id: $scope.params.id } //pass file as data, should be user ng-model
        }).then(function(resp) { //upload function returns a promise
        })
      };
      var purchase_orer = vm.purchase;
      var purchase_item = vm.exitems[0].rmname;

      var itemdatas = vm.exitems.map(function(item) {
        // Compare data and update stock in stock table if delivered status
        if (rmstocks.rmname = item.searchText && purchase_orer.status == "delivered") {
          var item_quantity = { 'item_quantity': item.quantity * item.containQty, 'editeditems': item }
          // Check and Data stored for added newly item
          var editadditem = [item].filter(function(addednewitem) {
            if (addednewitem.rmname.rmItemID) {
              return addednewitem
            }
          })
          // Check and Data stored for existing item
          var editdbitem = [item].filter(function(getExistingitem) {
            if (getExistingitem.purchase_items_id) {
              return getExistingitem
            }
          })

          //this service is for when staff edit exist row items in list to update the quanity
          api.update_rawmaterial_quantity.getID.update({ rmItemID: item.rmItemID }, item_quantity,
            function(response) {

            });
          // Added new item this service will work
          if (editadditem.length) {
            var item_quantitys = { 'item_quantity': item.quantity * item.containQty }
            //this service is for when staff added new row items in list to update the quanity
            api.updatequantity.getID.update({ rmItemID: item.rmname.rmItemID }, item_quantitys,
              function(response) {

              });
          }
        }
        return { 'rmItemID': item.rmname.rmItemID, 'rmCatergoryID': item.rmname.rmCatergoryID, 'rmname': item.rmname.rmname, 'expiry_date': item.expiry_date, 'quantity': item.quantity, 'containQty': item.containQty, 'rmrate': item.rmrate, 'item_subtotal': item.item_subtotal }
      });

      /*
      -------------------------------------------
      update data in purchase order table 
      -------------------------------------------
      */
      // Date stored
      var purchase_orders = [{
        'vendor_name': purchase_orer.vendor_name.vendor_name == undefined ? purchase_orer.vendor_name : purchase_orer.vendor_name.vendor_name,
        'vendor_id': purchase_orer.vendor_name.vendorID ? purchase_orer.vendor_name.vendorID : purchase_orer.vendor_id,
        'Description': purchase_orer.Description,
        'status': purchase_orer.status,
        'due_date': purchase_orer.due_date == null ? '' : purchase_orer.due_date,
        'DeliveryDate': purchase_orer.DeliveryDate,
        'modifiedID': $rootScope.user[0].staffID
      }];


      api.update_purchase_orders.getID.update({ purchase_order_id: $scope.params.id }, purchase_orders,
        function(response) {

        });
      /*-------------------------------------------
        update data in expense table 
        -------------------------------------------*/
      var payment = vm.expayment;
      var expensepayment = [{
        'note': payment.note,
        'received_amount': payment.received_amount,
        'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
        'payment_type': payment.payment_type,
        'transcation_no': payment.transcation_no,
        'cheque_no': payment.cheque_no,
        'status': 'purchase',
        'tax_cgst': vm.exitems.tax_cgstValue,
        'tax_sgst': vm.exitems.tax_sgstValue,
        'tax_status': vm.exitems.tax_status,
        'tax_type': vm.exitems.tax_type,
        'tax_cgstPercent': vm.exitems.tax_cgst,
        'tax_sgstPercent': vm.exitems.tax_sgst,
        'discount': vm.exitems.discount,
        'subtotal': vm.exitems.subtotal,
        'paid_date': payment.paid_date,
        'total_amount': vm.exitems.total_amount

      }];
      api.update_expensepayment_purchase.getID.update({ expense_bill_id: $scope.params.id }, expensepayment,
        function(response) {

        });
           /*-------------------------------------------
           update data in purchase item
           -------------------------------------------*/
      api.update_purchase_items.getID.update({ purchase_order_id: $scope.params.id }, vm.exitems,
        function(response) {
          if (exportPdfClicked) {
            $scope.SaveExportPdf($scope.params.id);
          }
        });
    }
    /*
    -----------------------------------------
  
    Add Save Service function

    -----------------------------------------
    */
    //save function 
    function saveservice(exportPdfClicked) {
      var purchase_orer = vm.purchase;
      var purchase_item = vm.exitems[0].rmname;

      var itemdatas = vm.exitems.map(function(item) {
        //check full raw material items and staff purchased items if delivered status
        if (rmstocks.rmname = item.searchText && purchase_orer.status == "delivered") {
          var item_quantity = { 'item_quantity': item.quantity * item.containQty }
          // update quantity in stock table
          api.updatequantity.getID.update({ rmItemID: item.rmname.rmItemID }, item_quantity,
            function(response) {});
        }
        return { 'rmItemID': item.rmname.rmItemID, 'rmCatergoryID': item.rmname.rmCatergoryID, 'rmname': item.rmname.rmname, 'expiry_date': item.expiry_date, 'quantity': item.quantity, 'containQty': item.containQty, 'rmrate': item.rmrate, 'item_subtotal': item.item_subtotal }
      });

      var file = vm.file ? vm.file : [{ 'file': null }]
      /*
      -------------------------------
      Add receipt and get inserted id
      -------------------------------
      */
      Upload.upload({
        url: 'http://localhost:1100/uploadpurchase', //webAPI exposed to upload the file

        data: { file: file, purchase_order_id: 6 } //pass file as data, should be user ng-model

      }).then(function(resp) { //upload function returns a promise
        var purchase_order_id = resp.data.insertId;
        var purchase_orders = [{
          'vendor_name': purchase_orer.vendor_name.vendor_name,
          'vendor_id': purchase_orer.vendor_name.vendorID,
          'Description': purchase_orer.Description,
          'status': purchase_orer.status,
          'due_date': purchase_orer.due_date,
          'DeliveryDate': purchase_orer.DeliveryDate,
          'staffID': $rootScope.user[0].staffID,
          'modifiedID': $rootScope.user[0].staffID,
          'branch_id': $rootScope.user[0].branch_id,
          'purchase_order_id': purchase_order_id

        }];
        /*
        -------------------------------------------
        Add data in purchase order table using inserted id
        -------------------------------------------
        */
        api.purchase_orders.getAll.save(purchase_orders,
          function(response) {
            //var purchase_order_id = response.insertId
            var salesorderitem = { 'itemdata': itemdatas, 'purchase_order_id': purchase_order_id };
            /*-------------------------------------------
                Add data in purchase order item table
             -------------------------------------------*/
            api.purchase_items.getAll.save(salesorderitem,
              function(response) {
                /*-------------------------------------------
                    Add data in expense payment table
                 -------------------------------------------*/

                var payment = vm.expayment;
                var expensepayment = [{
                  'note': payment.note,
                  'received_amount': payment.received_amount,
                  'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
                  'payment_type': payment.payment_status == 'unpaid' ? '' : payment.payment_type,
                  'transcation_no': payment.transcation_no,
                  'cheque_no': payment.cheque_no,
                  'status': 'purchase',
                  'tax_cgst': vm.exitems.tax_cgstValue,
                  'tax_sgst': vm.exitems.tax_sgstValue,
                  'tax_status': vm.exitems.tax_status,
                  'tax_type': vm.exitems.tax_type,
                  'tax_cgstPercent': vm.exitems.tax_cgst,
                  'tax_sgstPercent': vm.exitems.tax_sgst,
                  'discount': vm.exitems.discount,
                  'subtotal': vm.exitems.subtotal,
                  'total_amount': vm.exitems.total_amount,
                  'paid_date': payment.paid_date,
                  'purchase_order_id': purchase_order_id

                }];

                api.expensepayment.getAll.save(expensepayment,
                  function(response) {
                    if (exportPdfClicked) {
                      // send purchase order id for export pdf
                      $scope.SaveExportPdf(purchase_order_id);
                    }

                  });
              });
          });
      })

    }

  }
})();

(function() {
  'use strict';
  angular
    .module('app.billing.newBill', ['jkAngularRatingStars', 'mdPickers'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $breadcrumbProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State

    $breadcrumbProvider.setOptions({

      //  templateLastUrl: 'app/main/cashier/billing/currentbills/currentbills.html'
      //   prefixStateName: 'app.currentBills',
      // templateLast: '<i ng-bind-html="app/main/cashier/billing/currentbills/currentbills.html"></i>',
      //  includeAbstract : true
    });
    $stateProvider

      .state('app.newBill', {
        url: '/bill/:editbill/:customer_id/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/newbill/newbill.html',
            controller: 'NewBillController as vm'
          }

        },


        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id && $scope.state.params.editbill == 'orderedbill') {
              return 'app.currentBills';
            } else if ($scope.state.params.id && $scope.state.params.editbill == 'finishedbill') { // Constant defined in CollectionsLibraryAvailableController 
              return 'app.paidBills';
            } else if ($scope.state.params.id && $scope.state.params.editbill == 'currentbill') { // Constant defined in CollectionsLibraryAvailableController 
              return 'app.currentBills';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },

          label: "{{getBreadcrumbLabel()}}"

          //label: "{{ 'BILLINGS.NEW-BILL' | translate }}"

        },
        
        resolve: {
          TableNo: function(apiResolver, $rootScope) {
            //if($rootScope.online = false) {
              return apiResolver.resolve('TableNo.getAll@get');
           // }            
          },
          taxs: function(apiResolver) {
            return apiResolver.resolve('taxs.getAll@get');
          },
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          userRole: function(apiResolver) {
            return apiResolver.resolve('userRole.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },

          ThirdParty: function(apiResolver) {
            return apiResolver.resolve('ThirdParty.getAll@get');
          },
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          fmitem_sale: function(apiResolver) {
            return apiResolver.resolve('fmitem_sale.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          fmCategory: function(apiResolver) {
            return apiResolver.resolve('fmCategory.getAll@get');
          },
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },
          corporate_settings_Data: function (msApi) {
            return msApi.resolve('corporate_settings@get');
          }

        }
      });
    // Api
    msApiProvider.register('corporate_settings', ['app/data/corporate_settings/corporate_settings.json']);
    //msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);
    
   

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.billing.newBill')
        .factory('SaleBillingService', SaleBillingService);

    /** @ngInject */
    function SaleBillingService(msApi, $q)
    {
        var service = {
            data      : [],
            addNote   : addNote,
            //updateNote: updateNote,
            //deleteNote: deleteNote,
            getData   : getData
        };

        /**
         * Add Note
         * @param note
         */
        function addNote(note) {
            console.log(note);
            service.data.push(note);
        }

        /**
         * Update Note
         * @param note
         
        function updateNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }*/

        /**
         * Delete Note
         * @param note
        
        function deleteNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data.splice(i, 1);
                }
            }
        } */

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.notes@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function() {
  'use strict';

  angular
    .module('si-item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.si-item', {
        url: '/sale-item',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/sale-item/item/si-item.html',
            controller: 'SiItemController as vm'
          }
        },
        resolve: {
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
           branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
        },
        ncyBreadcrumb: {
          label: "Sale Material Items"
        }
      })
      .state('app.barcode', {
        url: '/sale-item/:id/:barcode/:name',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/sale-item/item/barcode-settings/barcode-settings.html',
            controller: 'SiItemController as vm'
          }
        },
        resolve: {
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
           branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
        },

        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id) {
              return 'app.si-item';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"
          //  label: '{{ "BILLINGS.CUSTOMERS" | translate }}'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('si-item')
    .controller('addSaleDialogController', addSaleDialogController);

  /** @ngInject */

  function addSaleDialogController($scope, msNavigationService, dietType, $rootScope, siInfo, $mdDialog, $mdToast, siItems, siCategory, branch_data, api, $http) {
    var vm = this;

    // Text
    vm.title = 'Edit';


    // DATA
    //----------------

    vm.settings = dietType.settings || {}; //assign general settings for restrict view
    vm.print = dietType.print; //assign print settings for mrp
    vm.dietType = dietType.newbill.tax_status //assign tax status for include or exclude which is came from general json
    vm.siInfos = siItems; //assign sale material items for input which is for edi purpose

    vm.siInfo = angular.copy(siInfo); //angular copy function for while change in input it will automatically change in table
    vm.salecategorys = siCategory;
    vm.file = null; // optional image file
    vm.imagePreview = (vm.siInfo && vm.siInfo.image_url) ? vm.siInfo.image_url : null;

    // only number validation 
    $scope.onlynumberDot = onlynumberDot;

    function onlynumberDot(e) {
      if (e.which != 8 && e.which != 0 && e.which != 46 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };

    // only number validation 
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    // barcode setting checking
    vm.branchFilterData = branch_data;
    //check whether this page have url params id or not
    if (!vm.siInfo) {
      vm.siInfo = {
        'siCatergoryID': '',
        'siname': '',
        'stock_quantity': '',
        'sirate': '',
        'containQty': '',
        'PurchasePrice': '',
        'tax_status': dietType.newbill.tax_status[0].value
      }

      // Text
      vm.title = 'Add';
      vm.newRMItem = true;
      //vm.contact.tags = [];
    } else {
      vm.siInfo.tax_status = dietType.newbill.tax_status[0].value
    }
    // Close Dialog
    $scope.closeDialog = function() {
      $mdDialog.hide();
    };
    vm.add_barcode_duplicate = 0;
    vm.barcode_warning = 0;
    // Add New Category
    //----------------
    $scope.addRMItem = function() {
      var siInfo = [{
        'siname': vm.siInfo.siname,
        'sirate': vm.siInfo.sirate,
        'smrate': vm.siInfo.PurchasePrice,
        'smname': vm.siInfo.siname,
        'tax_status': dietType.settings.global_tax ? '' : vm.siInfo.tax_status,
        'tax_sgst': vm.siInfo.tax_sgst,
        'tax_cgst': vm.siInfo.tax_cgst,
        'quantity': 1,
        'display': vm.siInfo.siname,
        'offerprice': vm.siInfo.offerprice,
        'dealer_price': vm.siInfo.dealer_price,
        'stock_quantity': vm.siInfo.stock_quantity,
        'containQty': vm.siInfo.containQty,
        'PurchasePrice': vm.siInfo.PurchasePrice,
        'siCatergoryID': vm.siInfo.siCatergoryID,
        'branch_id': $rootScope.user[0].branch_id,
        'barcode': vm.siInfo.barcode,
        'add_barcode_duplicate':vm.add_barcode_duplicate,
        'image_url': vm.siInfo.image_url || ''
      },
    ]; 

      api.siItems.getAll.save(siInfo[0],
        // Success
        function(response) {
          // if barcode already added response code should 204
          if(!response.code) {
            vm.barcode_warning = 0;
            var mergeData = angular.merge(siInfo[0], { siItemID: response.insertId })
            vm.siInfos.unshift(mergeData);

                    // If image selected, upload it now
            if (vm.file) {
              console.log('api.baseAPIUrl', api.baseAPIUrl, 'typeof', typeof api.baseAPIUrl, 'api object', api);
              var formData = new FormData();
              formData.append('image', vm.file);
              $http.post(api.baseAPIUrl + 'siItem/' + response.insertId + '/image', formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
              }).then(function(uploadResp) {
                if (uploadResp.data && uploadResp.data.image_url) {
                  mergeData.image_url = uploadResp.data.image_url;
                }
              }).catch(function(err) {
                console.error('Image upload error', err);
                var message = 'Image upload failed';
                if (err && err.data && err.data.error) {
                  message = err.data.error;
                } else if (err && err.statusText) {
                  message = err.statusText;
                }
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>' + message + '</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              });
            }

            $mdDialog.hide();
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Items added successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            // close popup
          } else {
            vm.barcode_warning = 1;
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Barcode already added to "' + response.data[0].siname + '".</span></md-toast>',
              position: 'bottom right',
              hideDelay: 8000,
              action: "close"
            });
            vm.add_barcode_duplicate = 1;
          }
        },
        // Error
        function(response) {}
      );
    };

    // Edit New Category
    //----------------
    $scope.editRMItem = function (siInfo) {
      console.log(siInfo);
      var siInfo = vm.siInfo;
      api.siItems.getID.update({ siItemID: siInfo.siItemID }, siInfo,
        function (response) {
          
          // if barcode already added response code should 204
          if (!response.code) {
            for (var i = 0; i < vm.siInfos.length; i++) {
              if (vm.siInfos[i].siItemID === vm.siInfo.siItemID) {
                vm.siInfos[i] = angular.copy(vm.siInfo);
                break;
              }
            };

            // If image selected, upload it now
            if (vm.file) {
              var formData = new FormData();
              formData.append('image', vm.file);
              $http.post(api.baseAPIUrl + 'siItem/' + siInfo.siItemID + '/image', formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
              }).then(function(uploadResp) {
                if (uploadResp.data && uploadResp.data.image_url) {
                  vm.siInfo.image_url = uploadResp.data.image_url;
                  for (var i = 0; i < vm.siInfos.length; i++) {
                    if (vm.siInfos[i].siItemID === vm.siInfo.siItemID) {
                      vm.siInfos[i].image_url = vm.siInfo.image_url;
                      break;
                    }
                  }
                }
              }).catch(function(err) {
                console.error('Image upload error', err);
                var message = 'Image upload failed';
                if (err && err.data && err.data.error) {
                  message = err.data.error;
                } else if (err && err.statusText) {
                  message = err.statusText;
                }
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>' + message + '</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              });
            }

            $mdDialog.hide(); // close popup 
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Items updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Barcode already added to "' + response.data[0].siname + '".</span></md-toast>',
              position: 'bottom right',
              hideDelay: 8000,
              action: "close"
            });
          }
        },
        // Error
        function (response) { }
      );

    };

  }
})();

(function() {
  'use strict';

  angular
    .module('rm-item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.rm-item', {
        url: '/raw-material-item',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/raw-material/item/rm-item.html',
            controller: 'RmitemController as vm'
          }
        },
        resolve: {
          rmItems: function(apiResolver) {
            return apiResolver.resolve('rmItems.getAll@get');
          },
          foodUnit: function(apiResolver) {
            return apiResolver.resolve('foodUnit@get');
          },
          rmCategory: function(apiResolver) {
            return apiResolver.resolve('rmCategory.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: "{{'FOOD.RAW-MATERIAL-ITEM' | translate }}"
        }

      });



  }
})();

(function() {
  'use strict';

  angular
    .module('rm-item')
    .controller('addRawDialogController', addRawDialogController);

  /** @ngInject */

  function addRawDialogController($scope, msNavigationService, $rootScope, foodUnit, $mdDialog, $mdToast, rmInfo, api, rmItems, rmCategory) {
    var vm = this;

    // Text
    vm.title = 'Edit';
    // DATA
    //----------------
    vm.rmInfos = rmItems; //assign particular clicked edit data to front end for edit purpose
    vm.rmInfo = angular.copy(rmInfo);
    //vm.foodtypes = foodType;
    vm.rawcategorys = rmCategory; //assign raw material categories to dropdown
    vm.unit = foodUnit.unit; //assign unit data to dropdown which is came from local json

    // only number validation of autocomplete
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    //check whether the page has url params id or not
    if (!vm.rmInfo) {
      vm.rmInfo = {
        'rmCatergoryID': '',
        'rmname': '',
        'rmstockAlert': '',
        'rmrate': ''
      };
      // Text
      vm.title = 'Add';
      vm.newRMItem = true;
      //vm.contact.tags = [];
    }
    // Close Dialog
    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    // Add New Category
    //----------------
    $scope.addRMItem = function() {
      var rmInfo = [{
        'rmname': vm.rmInfo.rmname,
        'display': vm.rmInfo.rmname,
        'rmrate': vm.rmInfo.rmrate,
        'stock_quantity': vm.rmInfo.stock_quantity,
        'containQty': vm.rmInfo.containQty,
        'quantity': 1,
        'rmCatergoryID': vm.rmInfo.rmCatergoryID,
        'unit': vm.rmInfo.unit,
        'branch_id': $rootScope.user[0].branch_id
      }];


      api.rmItems.getAll.save(rmInfo[0],
        // Success
        function(response) {
          var mergeData = angular.merge(rmInfo[0], { rmItemID: response.insertId })
          vm.rmInfos.unshift(mergeData);
          $mdDialog.hide();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Items added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
          // close popup 
        },
        // Error
        function(response) {}
      );
    };

    // Edit New Category
    //----------------
    $scope.editRMItem = function(rmInfo) {
      var rmInfo = vm.rmInfo;
      api.rmItems.getID.update({ rmItemID: rmInfo.rmItemID }, rmInfo,
        function(response) {
          for (var i = 0; i < vm.rmInfos.length; i++) {
            if (vm.rmInfos[i].rmItemID === vm.rmInfo.rmItemID) {
              vm.rmInfos[i] = angular.copy(vm.rmInfo);
              break;
            }
          };

          $mdDialog.hide(); // close popup 
          $mdToast.show({
            template: '<md-toast class="success"<span flex>Items updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {}
      );

    };




    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc.paidOdc', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.paidOdc', {
        url: '/paidOdc',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/odc-bill/paid-odc-bill/paid-odc.html',
            controller: 'PaidOdcController as vm'
          }
        },
        resolve: {
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          sales_order_data: function(apiResolver) {
            return apiResolver.resolve('sales_order_data.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          odc_category: function(apiResolver) {
            return apiResolver.resolve('odc_category@get');
          }

        },
        ncyBreadcrumb: {
          label: "{{'ODC.FINISHED-EVENT' | translate }}"
        }
      });

    // Translation

  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc.paidOdc')
    .controller('PaidOdcController', PaidOdcController)
    .directive('exportToCsv5', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Finished Event' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });

  /** @ngInject */
  function PaidOdcController($scope, api, $mdDialog, $mdToast, sales_order_data, customer_details, odc_category, staffRole, $stateParams, $state, $rootScope, $cookies, $timeout, $mdPanel) {
    var vm = this;
    this._mdPanel = $mdPanel;
    $scope.mdtableselected = []; // dummy assign
    var originatorEv;
    //get staff information from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');
    //store permissions in array
    $scope.admin = []
    $scope.ODCC = []
    $scope.odceditt = []
    $scope.odcdeletee = []
    //get permission from cookies
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 4) {
        $scope.ODCC.push("ODC");
      } else if (permissionss[i] == 42) {
        $scope.odceditt.push("ODCedit");
      } else if (permissionss[i] == 43) {
        $scope.odcdeletee.push("ODCdelete");
      }
    }
    //get staff data with id
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    vm.customers = customer_details; //assign all customer data to variable
    $scope.staffs = "admin"
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': '', 'name': 'All Staff' }]
    //filter odc permission staffs
    $scope.pos_staff = staffRole.filter(function(staff) {
      return sales_order_data.some(function(fullsalesorderdata) {
        return (staff.staffID == fullsalesorderdata.staffID && staff.status == 'active' && fullsalesorderdata.sales_dietType == 'ODC' && staff.branch_id == fullsalesorderdata.branch_id)
      })
    })

    vm.staffRole = staff_all.concat($scope.pos_staff); //concat of all array and filtered odc staff array

    $scope.myDate = new Date(); //assign today date by default

    vm.amount_type = [{
      "name": 'All amount type',
      "value": 'All'
    }, {
      "name": 'Paid amount',
      "value": 'fully paid'
    }, {
      "name": 'Balance amount',
      "value": 'balance'
    }];
    //syntax for view only month from date filter which is only for angular material 1.10
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    $scope.monthyear = new Date();


    // Remove Row
    $scope.removeRow = function(fmitem, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this event?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.currentodc_service.getID.delete({ salesorder_id: fmitem.salesorder_id },
          function(response) {
            //success callback
            deleteItem(fmitem);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });


      /**
       * Delete Item
       */
      function deleteItem(fmitem) {
        vm.balancebill.splice(vm.balancebill.indexOf(fmitem), 1);
        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        $state.go("app.paidOdc", {}, { reload: "app.paidOdc" });

      }

    }
    //get all datas of finished odc events
    function paidodc_success(desserts) {
  
      $scope.total_paid = desserts[0].total_paid
      $scope.full_data = desserts[0].full_total
      $scope.tax_info_sgst = desserts[0].tax_info_sgst
      $scope.tax_info_cgst = desserts[0].tax_info_cgst
      $scope.total_purchase = desserts[0].total_purchase
      $scope.total_cash = desserts[0].total_cash
      $scope.total_card = desserts[0].total_card
      $scope.total_cheque = desserts[0].total_cheque
      $scope.total_online = desserts[0].total_online
      $scope.balance = desserts[0].balance
      $scope.paid_count = desserts[0].paid_count;
      $scope.balance_count = desserts[0].balance_count
      $scope.odcbillLength = desserts[0].results;
      $scope.paidexpense_count = desserts[0].paidexpense_count;
      vm.balancebill = desserts[0].results;
    }


    $scope.changeDate = changeDate; //method for calling function
    //function for change date for show data depending on date ex. date, amount
    function changeDate(amount_type, myDate, staff) {
      $scope.retrieve = "rmInfo"

      $scope.load = true //show preload
      getDessertsss(amount_type, myDate, staff) // callback funtion

      $timeout(function() {
        $scope.load = false//hide preload
      }, 500);

    }
    $scope.getDessertsss = getDessertsss(); //assign function for variable
    //service for finished odc event 
    function getDessertsss(amount_type, myDate, staff) {
      if (amount_type == undefined || myDate == undefined) {
        var amount_type = 'All'
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
      } else {
        var amount_type = amount_type;
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear()
      }
      if ($cookies.get('admin') != 'admin') {
        // If staff assign this value
        $scope.paidexpense_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          month: month,
          year: year
        };
      }
      if ($cookies.get('admin') == 'admin') {
           // If admin assign this value
        var staffID = staff == undefined ? 'admin' : staff
        $scope.paidexpense_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          month: month,
          year: year
        };
      }
      $scope.reload = function() {
        $scope.promise = api.paidodc_service.getAll.get($scope.paidexpense_query, paidodc_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000);*/
      };
      $scope.reload();
    };

    getDessertsss() //while page load function will access inside


   //query watch filter for manage pagination 
    $scope.$watch('paidexpense_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.paidexpense_query.page ? $scope.paidexpense_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.paidexpense_query.page = 1
      }

      if (!newValue) {
        $scope.paidexpense_query.page = bookmark ? bookmark : 1
      }

      $scope.getDessertsss = getDessertsss;
      $scope.reload();
    });

    // GET CATEGORY NAME
    //---------------- 
    vm.staffs = staffRole; //assign all staff data
    //to find a staff name who was created for particular bill
    $scope.balexpense_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //to find edited staff
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };

   //to find who is a customer info
    $scope.balexpense_customernames = function(customer) {
      for (var i = 0; i < vm.customers.length; i++) {
        if (vm.customers[i].customer_id == customer.customer_id) {
          return vm.customers[i].customer_name
        }
      }
    };
    vm.expensecategory = odc_category.odcbill.odc_categories; //get all odc categories from local json
    //get category name
    $scope.balexpense_getcategory = function(customer) {
      for (var i = 0; i < vm.expensecategory.length; i++) {
        if (vm.expensecategory[i].value == customer.odc_categoryID) {
          return vm.expensecategory[i].label
        }
      }
    };
    //redirect to anothr state for edit purpose
    $scope.balexpense = function(sales_id, customer) {
      $scope.params = $stateParams;
      $state.go('app.new-odc', { id: sales_id, customer_id: customer, editodc: 'finishedevent' })
    }
    //clear text function while search
    $scope.clearText = function() {
      $scope.paidexpense_query.filter = '';
    }


    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc.new-odc', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.new-odc', {
        url: '/odc-banquet/:editodc/:customer_id/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/odc-bill/new-odc-bill/new-odc-bill.html',
            controller: 'NewOdcController as vm'
          }
        },
        resolve: {
          expense_amountType: function(apiResolver) {
            return apiResolver.resolve('expense_amountType@get');
          },
          taxs: function(apiResolver) {
            return apiResolver.resolve('taxs.getAll@get');
          },
          siItems: function(apiResolver) {
            return apiResolver.resolve('siItems.getAll@get');
          },
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          banquethall: function(apiResolver) {
            return apiResolver.resolve('banquethall.getAll@get');
          },
          fmItems: function(apiResolver) {
            return apiResolver.resolve('fmItems.getAll@get');
          },
          fmitem_sale: function(apiResolver) {
            return apiResolver.resolve('fmitem_sale.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },
          odc_category: function(apiResolver) {
            return apiResolver.resolve('odc_category@get');
          }

        },
        ncyBreadcrumb: {
          //abstract: false,
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id && $scope.state.params.editodc == 'upcomingevent') {
              return 'app.currentOdc';
            } else if ($scope.state.params.id && $scope.state.params.editodc == 'finishedevent') { // Constant defined in CollectionsLibraryAvailableController 
              return 'app.paidOdc';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"

          //label: "{{ 'BILLINGS.NEW-BILL' | translate }}"

        }
      });
    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/cashier/billing/odc-bill');

  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc.new-odc')
    .controller('NewOdcController', NewOdcController)
    .directive('validNumber', function() {
      return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModelCtrl) {
          if (!ngModelCtrl) {
            return;
          }
          ngModelCtrl.$parsers.push(function(val) {
            var clean = val.replace(/^[^1-9]*|[^0-9]/g, '');
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.on('keypress', function(event) {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    });

  /** @ngInject */
  function NewOdcController($scope, $rootScope, locality, dietType, $state, banquethall, expense_amountType, point, odc_category, customer_details, fmitem_sale, taxs, $mdpTimePicker, $mdDialog, $mdToast, $http, $cookies, $q, $window, $timeout, Upload, $stateParams, api) {

    var vm = this;
    // only number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };

    vm.settings = dietType.settings;
    // Phone number validation
    $scope.phonenumber = phonenumber;

    function phonenumber(e) {
      if (e.target.value.length > 9) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };
    $scope.myDate = new Date(); //Assign today date

    //retrict date only 30 days move on backward from md pciker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() - 30
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() + 150
    );

    // Set active tab for initial time
    $scope.prTabName = "tabBillInfo";
    vm.expense_amountType = expense_amountType.expensebill.Amount_PayType; //payment type like cash or card
    vm.expensecategory = odc_category.odcbill.odc_categories; //odc category which is came from local json
    //filter banquet hall which is came from database
    var banquethalls = banquethall.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    vm.hall_no = banquethalls //assign filtered banquet halls
    vm.odcType = odc_category.odcbill.odc_catalog; //assign type like odc or banquet which is came from local json
    // Methods
       //clear old payment when tab change
      $scope.clear_advancePaid = function() {
        vm.expayment.note = ''
        vm.expayment.received_amount = ''
      }
      //clear old payment when tab change
      $scope.clear_payment = function() {
        if (vm.expayment.payment_status == 'fully paid') {
          vm.expayment.received_amount = ''
        }
        if (vm.expayment.cheque_no) {
          vm.expayment.transcation_no = ''
        }
        if (vm.expayment.transcation_no) {
          vm.expayment.cheque_no = ''
        }

      }
    $scope.params = $stateParams; //url parameter
    //add purpose
    /*
    -------------------------------------------------

    Add scenario init odc bill data

    -------------------------------------------------
    */
    if (!$scope.params.id) {
      vm.billing = {}
      vm.expense = {}
      vm.expayment = {}
      vm.expense.sales_dietType = "ODC";
      vm.expense.created_on = new Date();
      vm.expayment.paid_date = new Date();
      vm.billing.enterTime = new Date();
      vm.fmitems = [{}]
      $scope.customer = ''
    }
    /*
      -------------------------------------------------

      Edit scenario init odc bill data

      -------------------------------------------------
      */
    else { //edit purpose
      // Edit Bill
      //----------------
      vm.billing = {}
      vm.expense = {}
      $scope.salesId = $scope.params.id //store url parameter id
      //get salesorder_id 
      var customer_id = $scope.params.customer_id
      var salesorder_ids = $scope.params.id
      //service for get  odc salesorder items
      api.odcitems.getaData.get({ salesorder_id: salesorder_ids },
        function(response) {
          vm.fmitemss = [response[0]]; // Qty and price for combo
          vm.fmitems = response; // expense items, qty, price

        })
      //service for get  odc salesorder primary table datas
      api.salesorder_diet.getID.get({ salesorder_id: salesorder_ids },
        function(response) {
          $scope.response = response;
          vm.billing = {
            'tableno': response[0].tableitem,
            'dietType': response[0].sales_dietType,
            'staff': response[0].manageBy,
            'odc_type': response[0].odc_type,
            'deliveryTime': response[0].sales_deliveryStatus
          }
          if (response[0].sales_deliveryTime) {
            var DeLiveryTime = new Date(response[0].sales_deliveryTime);
            vm.billing.enterTime = DeLiveryTime
          }
          var data = new Date(response[0].odc_deliveryDate)
          vm.expense.created_on = data;
          vm.expense.category_id = response[0].odc_categoryID
          vm.expense.sales_dietType = response[0].sales_dietType;
          vm.expense.hall_no = response[0].hall_no;

        })
      //service for get  sales payments
      api.payment_diet.getID.get({ salesorder_id: salesorder_ids },
        function(response) {
          vm.expayment = response[0]
          vm.expayment.paid_date = new Date(response[0].paid_date)
          vm.expayment.payment_type = response[0].payment_mode
          vm.billing.discount_type = response[0].discount_type;
          //watch function while data came from database
          var calculateTotals = function() {
            var subtotal = 0;
            if (vm.billing.odc_type == 'combo') {
              var changedatavariable = vm.fmitemss
            } else if (vm.billing.odc_type == 'individual') {
              var changedatavariable = vm.fmitems
            }
            angular.forEach(changedatavariable, function(fmitem) {
              //calculate itemfulltotal  
              var item = (fmitem != null) ? fmitem.salesitem_rate : 0;
              var qty = (fmitem != null) ? fmitem.sales_quantity : 0;
              fmitem.subitemtotal = item * qty; // individuval subtotal
              subtotal += item * qty; // combo & individuval subtotal

            })
            vm.billing.subTotal = subtotal;
            vm.billing.tax = (subtotal / 100) * vm.taxs[0].taxRate;
            vm.billing.tax_sgst = (subtotal / 100) * vm.taxs[1].taxRate;
            vm.billing.additional_charge = response[0].additional_charge


            if (vm.billing.discount_type == 'amount') {
              var discount = (vm.billing.discount != null) ? vm.billing.discount : 0;
              var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : '';
              $scope.total = subtotal + vm.billing.tax + vm.billing.tax_sgst - discount + additional_charge;
              vm.billing.roundtotal = Math.round($scope.total);
            } else if (vm.billing.discount_type == 'percent') {
              var discount = (vm.billing.discount != null) ? vm.billing.discount : 0;
              var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : '';
              vm.billing.discount_percent = (discount / 100) * (subtotal + vm.billing.tax + vm.billing.tax_sgst + additional_charge);
              $scope.total = subtotal + vm.billing.tax + vm.billing.tax_sgst - vm.billing.discount_percent + additional_charge;
              vm.billing.roundtotal = Math.round($scope.total);
            }
          };
          $scope.$watch('vm.fmitemss', calculateTotals, true);

          vm.billing.discount = response[0].discount;
          vm.paymentstatus = response[0].payment_status;
          vm.expayment = response[0];
          vm.expayment.transcation_no = vm.expayment.transcation_no == null ? '' : response[0].transcation_no
          vm.expayment.cheque_no = vm.expayment.cheque_no == null ? '' : response[0].cheque_no
          vm.expayment.received_amount = response[0].payment_received;
          $scope.cash = response[0].payment_mode;
          //discount is present then tap will automatically open
          if (vm.billing.discount) {
            $scope.OpenPermission = true;
            $scope.hideclose = true;

          };
          if (vm.billing.additional_charge) {
            $scope.OpenCharge = true;

          }
        })

      //service for get customer information
      api.customer_infodiet.getID.get({ salesorder_id: customer_id },
        function(response) {
          $scope.customer_data = response[0];
        })
    };


    vm.myDate = new Date();
    //cancel function for add
    $scope.cancel = function(ev) {
      if ($scope.odcBill.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go("app.new-odc", {}, { reload: "app.new-odc" })

        }, function() {
          // Canceled
        });
      } else {
        $state.go("app.new-odc", {}, { reload: "app.new-odc" })
      }
    }
    //cancel function for edit
    $scope.canceledit = function(ev) {
      if ($scope.odcBill.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          if ($scope.params.id && $scope.params.editodc == 'upcomingevent') {
            $state.go('app.currentOdc', { id: '', customer_id: '', editodc: '' })
          } else if ($scope.params.id && $scope.params.editodc == 'finishedevent') { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.paidOdc', { id: '', customer_id: '', editodc: '' })
          }
        }, function() {
          // Canceled
        });
      } else {
        $state.go('app.new-odc', { id: '', customer_id: '', editodc: '' })
      }

    }
    //when pressed enter key new row will be pushed
    $scope.keyPressed = function(keyEvent) {
      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        vm.fmitems.push({});
        $scope.indx = vm.fmitems.length - 1;
        $scope.$watch(vm.fmitems, function() {
          $timeout(function() {
            angular.element('.autodd').focus();
          }, 10);

        })
      }
    };

    // Add placeholder for autocomplete
    $timeout(function() {
      $(".foodItem-auto input").attr("placeholder", "Enter the food item");
    }, 500);

    // Add Row
    //----------------
    vm.fmitemss = [{}]

    $scope.addRow = function() {
      vm.fmitems.push({
        'item_name': '',
        'item_amount': '0'
      });
      $scope.indx = vm.fmitems.length - 1;
      $scope.$watch(vm.fmitems, function() {
        $timeout(function() {
          angular.element('.autodd').focus();
        }, 10);

      })

    };

    //autofocus for customer
    $scope.focuscustomer = focuscustomer;

    function focuscustomer() {
      $timeout(function() {
        angular.element('#radio-focuscustomer').focus();
      }, 100);
    }



    //autofocus for diet type
    $scope.focus = focus;

    function focus() {
      $timeout(function() {
        angular.element('#radio-focus').focus();
      }, 100);
    }

    $timeout(function() {
      angular.element('#radio-focus').focus();
    }, 100);


    //remove row condition :- Disable first index while removing rows, 



    // Remove Row
    $scope.removeRow = function(fmitem, ev, index) {
      console.log(fmitem)
      if (!fmitem.odc_salesorderitem_id) {
        vm.fmitems.splice(index, 1);
      } else {
        var confirm = $mdDialog.confirm()
          .title('Delete')
          .htmlContent('Are you sure you want to delete this item?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          api.deleteodcsales_items.getID.delete({ salesitem_id: fmitem.odc_salesorderitem_id },
            function(response) {
              //success callback
              deleteItem(fmitem);
            },
            function(response) {
              // error callback
            }
          );

        }, function() {
          // Canceled
        });

      };
      /**
       * Delete Item
       */
      function deleteItem(fmitem) {
        vm.fmitems.splice(vm.fmitems.indexOf(fmitem), 1);

        $mdToast.show({
          template: '<md-toast><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      }

    }
    //filter data branch wise
    var tax_data = taxs.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })

    //check whether tax data contains or not
    if (tax_data.length) {
      if (tax_data.length == 1) {
        vm.taxs = [{ 'taxName': tax_data[0].taxName, 'taxRate': tax_data[0].taxRate }, { 'taxName': 'SGST', 'taxRate': 0 }]
      } else {
        vm.taxs = tax_data;
      }
    } else {
      vm.taxs = [{ 'taxName': 'CGST', 'taxRate': 0 }, { 'taxName': 'SGST', 'taxRate': 0 }]
    }

    // Total Calculation
    //----------------
    var calculateTotals = function() {
      var subtotal = 0;

      if (vm.billing.odc_type == 'combo' || vm.billing.odc_type == undefined) {
        var changedatavariable = vm.fmitemss
      } else if (vm.billing.odc_type == 'individual') {
        var changedatavariable = vm.fmitems
      }
      angular.forEach(changedatavariable, function(fmitem) {
        //calculate itemsubtotal
        fmitem.salesitem_rate = (fmitem.salesitem_rate) ? fmitem.salesitem_rate : '';
        fmitem.sales_quantity = (fmitem.sales_quantity) ? fmitem.sales_quantity : '';
        var item = (fmitem.salesitem_rate != null) ? fmitem.salesitem_rate : 0;
        var qty = (fmitem.sales_quantity != null) ? fmitem.sales_quantity : 0;
        fmitem.subitemtotal = item * qty; // for individual subtotal
        subtotal += item * qty; // for individual & combo subtotal
      })

      $scope.dataChange = function() {
        // discount percent/ amount dropdown change
        cals();
      };
      cals();

      function cals() {

        vm.billing.subTotal = subtotal;
        vm.billing.tax = (subtotal / 100) * vm.taxs[0].taxRate;
        vm.billing.tax_sgst = (subtotal / 100) * vm.taxs[1].taxRate;
        if (!vm.billing.discount) {
          vm.billing.discount = '';
        };
        if (!vm.billing.additional_charge) {
          vm.billing.additional_charge = '';
        };

        if (vm.billing.discount_type == 'amount' || vm.billing.discount_type == undefined) {
          var discount = (vm.billing.discount != null) ? vm.billing.discount : 0;
          var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : 0;
          $scope.total = subtotal + vm.billing.tax + vm.billing.tax_sgst - discount + additional_charge;
          vm.billing.roundtotal = Math.round($scope.total);
        } else if (vm.billing.discount_type == 'percent' || vm.billing.discount_type == undefined) {

          var discount = (vm.billing.discount != null) ? vm.billing.discount : 0;
          var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : 0;
          vm.billing.discount_percent = (discount / 100) * (subtotal + vm.billing.tax + vm.billing.tax_sgst + additional_charge);
          $scope.total = subtotal + vm.billing.tax + vm.billing.tax_sgst - vm.billing.discount_percent + additional_charge;
          vm.billing.roundtotal = Math.round($scope.total);
        }
      }

    };
    //show delete icon when index is 1 on the item list
    var removeIndex = function() {
      if (vm.fmitems.length > 1) {
        $scope.formitem = false;
      } else {
        $scope.formitem = true;

      }
    }
    //when odc type change the watch function variable here changed
    $scope.odctypeChange = function() {
      if (vm.billing.odc_type == 'combo' || vm.billing.odc_type == undefined) {
        $scope.$watch('vm.fmitems', removeIndex, true);
        $scope.$watch('vm.fmitemss', calculateTotals, true);
      } else if (vm.billing.odc_type == 'individual') {
        $scope.$watch('vm.fmitems', removeIndex, true);
        $scope.$watch('vm.fmitems', calculateTotals, true);
      }
    }
    $scope.odctypeChange(); //function call to access inside the function whenever page loads

    //clear discount when click int mark
    $scope.clearDis = function() {
      if (!vm.billing.discount) {
        vm.billing.discount = 0;
      };
      if (!vm.billing.discount_percent) {
        vm.billing.discount_percent = 0;
      };
      if (vm.billing.discount_type == 'amount') {
        vm.billing.roundtotal = parseInt(vm.billing.roundtotal) + parseInt(vm.billing.discount);
        vm.billing.discount = '';
        vm.billing.discount_percent = '';
      } else if (vm.billing.discount_type == 'percent') {
        vm.billing.roundtotal = parseInt(vm.billing.roundtotal) + parseInt(Math.round(vm.billing.discount_percent));
        vm.billing.discount_percent = '';
        vm.billing.discount = '';
      }
    }
    //clear additional charge when click int mark
    $scope.clearCharge = function() {
      if (!vm.billing.additional_charge) {
        vm.billing.additional_charge = 0;
      };
      vm.billing.roundtotal = parseInt(vm.billing.roundtotal) - parseInt(vm.billing.additional_charge);
      vm.billing.additional_charge = '';
    }
    //focus function for input
    $scope.focusaddCharge = function() {
      $timeout(function() {
        angular.element('#additional_charge-focus').focus();
      }, 100);
    }
    $scope.focusdiscount = function() {
      $timeout(function() {
        angular.element('#discount-focus').focus();
      }, 100);
    }

    // ******************************
    // Internal methods
    // ******************************
    vm.food = loadAll();
    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;

    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {

      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();

      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 10, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.sales_items.indexOf(lowercaseQuery) === 0);
      };

    }

    //while select the food items get data for selected index and assign it.
    function selectedItemChange(index, fmitem) {

      for (var i = -1; i < vm.fmitems.length; i++) {
        if (i) {
          return fmitem.salesitem_rate = fmitem.sales_items.salesitem_rate, fmitem.sales_quantity = fmitem.sales_items.sales_quantity, fmitem.stock_quantity = fmitem.sales_items.stock_quantity

        }
      }
    }

    // only number validation of autocomplete
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var fmitem_sales = fmitem_sale.filter(function(item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })
      var foodList = fmitem_sales
      return foodList.map(function(food) {
        return {
          sales_items: food.fmItemName.toLowerCase(),
          sales_quantity: 1,
          display: food.fmItemName,
          salesitem_rate: 0,
          fmItemID: food.fmItemID,
          fmCatergoryID: food.fmCatergoryID,
          type: food.type
        };

      });
    }

    // ******************************
    // Customer autocomplete
    // ******************************

    //customer autocomplete entry
    vm.customer_data = loadAlll();
    vm.searchText = null;
    vm.querySearchh = querySearchh;
    vm.selectedItemChangge = selectedItemChangge;

    function querySearchh(query) {
      $scope.mobile = query
      var results = query ? vm.customer_data.filter(createFilterForr(query)) : vm.customer_data;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 10, false);
      return deferred.promise;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterForr(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(customer) {
        return (customer.customer_mobile.indexOf(lowercaseQuery) === 0);

      };

    }

    //while select the food items get data for selected index and assign it.: "customer_Added"
    function selectedItemChangge(customer) {
      $scope.customer = customer
      if ($scope.customer_data) {
        $scope.customer_data = '' // clear data after updated
        $scope.customer = ''
        focuscustomer()
      }

      return customer.customer_name = customer.customer_mobile.customer_name, customer.localityID = customer.customer_mobile.localityID, customer.customer_id = customer.customer_mobile.customer_id, customer.customer_email = customer.customer_mobile.customer_email, customer.customer_address = customer.customer_mobile.customer_address, customer.customer_locality = customer.customer_mobile.customer_locality, customer.customer_city = customer.customer_mobile.customer_city
    }
    $scope.filterValue = function($event) {
      if (isNaN(String.fromCharCode($event.keyCode))) {
        $event.preventDefault();
      }
    };

    /**
     * Build `states` list of key/value pairs
     */
    function loadAlll() {
      //filter customer details as branch wise
      var customer_detailss = customer_details.filter(function(item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })
      var customer_list = customer_detailss
      return customer_list.map(function(customer) {
        return {
          customer_id: customer.customer_id,
          customer_mobile: customer.customer_mobile,
          customer_email: customer.customer_email,
          display: customer.customer_mobile,
          customer_address: customer.customer_address,
          customer_locality: customer.customer_locality,
          customer_city: customer.customer_city,
          customer_name: customer.customer_name,
          localityID: customer.localityID
        };

      });
    }


    //function for Breadcrumb Label with id

    $rootScope.getBreadcrumbLabel = function() {
      if ($scope.params.id) {
        return $scope.params.id
      } else if (!$scope.params.id) {
        return "New Event"

      }
    }

    var point_data = [{
      'amount': 0,
      'perpoint_amount': 0,
      'EnableFirstTime': 0,
      'FirstTimePoint': 0,
      'enablepoint': 0
    }]

    // Add customer dialog customer_mobile, id, name, email, address, city
    vm.showAddTableDialog = function(ev, customer) {
      $mdDialog.show({
        controller: 'CustomerDialogsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cashier/billing/newbill/customer/dialog/add_customer_dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          customer_data: customer,
          customer_details: vm.customer_data,
          customer_Added: "customer_Added",
          locality: locality,
          point: point_data
        },
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false
      })
    };

    //broadcast data came from CustomerDialogController
    $scope.$on("salesId", function(event, customer) {
      $scope.customer_data = customer
    })

    vm.paymentselect = 'unpaid';

    vm.payment = [{
      "name": 'Unpaid',
      "value": 'unpaid'
    }, {
      "name": 'Fully Paid',
      "value": 'fully paid'
    }, {
      "name": 'Advance Paid',
      "value": 'advance paid'
    }];

    vm.paymentmodelist = [{
      "name": 'Cash',
      "value": 'cash'
    }, {
      "name": 'Card',
      "value": 'card'
    }];

    function updateservice() {
      var customer_id = [];
      // If user change data store in customer
      if ($scope.customer) {
        vm.customer_data.map(function(fullCustomer) {
          if ($scope.customer.searchText == fullCustomer.customer_mobile) {
            customer_id.push(fullCustomer.customer_id)
          }
        });

      }
      // If user doesnt change data store in customerdata
      if ($scope.customer_data) {
        vm.customer_data.map(function(fullCustomer) {
          if ($scope.customer_data.customer_mobile == fullCustomer.customer_mobile) {
            customer_id.push(fullCustomer.customer_id)
          }
        });

      };
      // Create new customer in that page
      var customerID = vm.customer_data.length == 0 ? null : vm.customer_data[0].customer_id;
      // Existing customer in that page
      var customerIDS = vm.customer_data.length == 0 ? null : customer_id[0];
      var customer_id = customer_id[0] == undefined && (vm.customer_data.length == 0 || vm.customer_data[0].data == 'customer_Added') ? customerID : customerIDS;
      var customer_ids = customer_id == undefined ? '' : customer_id //check empty or not
      //collecting all bill datas
      var billing = vm.billing;
      var fmitem = vm.billing.fmitems;
      var newexpense = vm.expense;

      //get user data from cookies
      var staffID = $rootScope.user[0].staffID;
      var branch_id = $rootScope.user[0].branch_id;

      // apply only if the dietType is doordelivery or  takeaway   
      if (vm.billing.enterTime) {
        // to filter date and time while select and enter time by user
        var userEnteredTime = vm.billing.enterTime.toString(); // user enter time change as string format
        var indexcount = userEnteredTime.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
        var Date_time = userEnteredTime.substring(0, indexcount); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient

        // to filter and take date and time with 12 hours
        var deliverytiming = (Date_time.split(' ')[4]).split(':'); //only get time and split it as array  
        var hours = (deliverytiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + deliverytiming[1] + " " + (deliverytiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM and produce time
        var takedate = (Date_time.split(' ')) // split user entered time&date for take date purpose
        var deliverdate = takedate[0] + " " + takedate[1] + " " + takedate[2] + " " + takedate[3] //  get date
        var deliverytime = deliverdate + " " + time // final date + time
      }

      var payment = vm.expayment;
      if (payment == undefined || payment.payment_status == 'unpaid' || payment.payment_status == 'advance paid') {
        var status = 'ordered'
      } else if (payment.payment_status == 'fully paid') {
        var status = 'finished'
      }
      /*
       -------------------------------------------
       update data in  odc sales order bill table 
       -------------------------------------------
       */
      var data = [{
        'odc_categoryID': newexpense.category_id,
        'hall_no': newexpense.hall_no,
        'odc_deliveryDate': newexpense.created_on,
        'sales_deliveryTime': deliverytime,
        'sales_dietType': newexpense.sales_dietType,
        'status': status,
        'odc_type': vm.billing.odc_type,
        'customer_id': customer_ids,
        'modifiedID': staffID,
        'branch_id': branch_id
      }];

      if (payment.payment_type) {
        // Payment type card, cash
        var pay_via = payment.payment_type
      } else {
        // unknown code
        var pay_via = payment.payment_mode
      }

      var Roundtotal = billing.roundtotal == undefined ? 0 : billing.roundtotal
      // Getting data to insert for salespayment
      var editsalespayment = [{
        'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
        'payment_mode': payment.payment_status == 'unpaid' ? '' : pay_via,
        'payment_received': payment.received_amount == undefined ? '' : payment.received_amount,
        'payment_total': Roundtotal,
        'salesorder_id': $scope.params.id,
        'tax_rate': billing.tax,
        'transcation_no': payment.transcation_no,
        'cheque_no': payment.cheque_no,
        'paid_date': payment.paid_date,
        'tax_sgst': billing.tax_sgst,
        'additional_charge': billing.additional_charge,
        'discount': billing.discount,
        'discount_type': billing.discount_type,
        'unpaid_description': payment.note
      }];

      /*
       -------------------------------------------
       update data in  odc sales order bill table 
       -------------------------------------------
       */
      api.updateOdcorder.getID.update({ salesorder_id: $scope.params.id }, data,
        function(response) {

        });
      //update sales_Payment
      /*
      -------------------------------------------
      update data in  odc sales payment table 
      -------------------------------------------
      */
      api.editsalespayment.getID.update({ salesorder_id: $scope.params.id }, editsalespayment,
        function(response) {

        });

      /*
      -------------------------------------------
      update data in  odc sales items bill table 
      -------------------------------------------
      */
      api.odcitems.getID.update({ salesorder_id: $scope.params.id }, vm.fmitems,
        function(response) {

        });

    }


    function saveservice() {

      /*
       -------------------------------------------
      identify customer id 
       -------------------------------------------
       */
      var customer_id = [];
      //
      if ($scope.customer) {
        vm.customer_data.map(function(fullCustomerData) {
          if ($scope.customer.searchText == fullCustomerData.customer_mobile) {
            customer_id.push(fullCustomerData.customer_id)
          }
        })
        vm.user = $scope.customer;
      }
      var customerID = vm.customer_data.length == 0 ? null : vm.customer_data[0].customer_id
      var customerIDS = vm.customer_data.length == 0 ? null : customer_id[0]
      var customer_id = customer_id[0] == undefined && (vm.customer_data.length == 0 || vm.customer_data[0].data == 'customer_Added') ? customerID : customerIDS
      var customer_ids = customer_id == undefined ? '' : customer_id //check empty or not

      //collecting all bill datas
      var billing = vm.billing;
      var fmitem = vm.billing.fmitems;
      var newexpense = vm.expense;
      //get user data from cookies
      var staffID = $rootScope.user[0].staffID;
      var branch_id = $rootScope.user[0].branch_id;

      if (billing.odc_type == 'combo') {
        var itemdatas = vm.fmitems.map(function(item) {
          return { 'item': item.sales_items.sales_items, 'qty': vm.fmitemss[0].sales_quantity, 'item_subrate': 0, 'itemprice': vm.fmitemss[0].salesitem_rate, 'itemsubtotal': billing.subTotal, 'fmItemID': item.sales_items.fmItemID, 'fmCatergoryID': item.sales_items.fmCatergoryID }
        });

      }
      if (billing.odc_type == 'individual') {
        var itemdatas = vm.fmitems.map(function(item) {
          return { 'item': item.sales_items.sales_items, 'qty': item.sales_quantity, 'item_subrate': item.subitemtotal, 'itemprice': item.salesitem_rate, 'itemsubtotal': billing.subTotal, 'fmItemID': item.sales_items.fmItemID, 'fmCatergoryID': item.sales_items.fmCatergoryID }
        });
      }


      // apply only if the dietType is doordelivery or  takeaway   
      if (vm.billing.enterTime) {
        // to filter date and time while select and enter time by user
        var userEnteredTime = vm.billing.enterTime.toString(); // user enter time change as string format
        var indexcount = userEnteredTime.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
        var Date_time = userEnteredTime.substring(0, indexcount); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient

        // to filter and take date and time with 12 hours
        var deliverytiming = (Date_time.split(' ')[4]).split(':'); //only get time and split it as array  
        var hours = (deliverytiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + deliverytiming[1] + " " + (deliverytiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM and produce time
        var takedate = (Date_time.split(' ')) // split user entered time&date for take date purpose
        var deliverdate = takedate[0] + " " + takedate[1] + " " + takedate[2] + " " + takedate[3] //  get date
        var deliverytime = deliverdate + " " + time // final date + time
      }

      var payment = vm.expayment;
      if (payment == undefined || payment.payment_status == 'unpaid' || payment.payment_status == 'advance paid') {
        var status = 'ordered'
      } else if (payment.payment_status == 'fully paid') {
        var status = 'finished'
      }

      // Getting data to insert for sales_order payment.payment_status == undefined ? 'unpaid' : payment.payment_status
      var data = [{
        'odc_categoryID': newexpense.category_id,
        'hall_no': newexpense.hall_no,
        'odc_deliveryDate': newexpense.created_on,
        'sales_deliveryTime': deliverytime,
        'sales_dietType': newexpense.sales_dietType,
        'odc_type': vm.billing.odc_type,
        'status': status,
        'customer_id': customer_ids,
        'staffID': staffID,
        'modifiedID': staffID,
        'branch_id': branch_id
      }];
      /*
      -------------------------------------------
      save data in  odc sales order bill table 
      -------------------------------------------
      */
      api.salesorder.getAll.save(data,
        // Success
        function(response) {
          $scope.salesId = response.insertId
          // getting salesorder_id
          var salesorder_id = response.insertId;

          // Getting data to insert for salesorder_item
          var salesorderitem = { 'itemdata': itemdatas, 'salesorder_id': salesorder_id };
          /*
           -------------------------------------------
           save data in  odc salesorder items bill table 
           -------------------------------------------
           */
          api.odc_saleitems.getAll.save(salesorderitem,
            function(response) {})
          var Roundtotal = billing.roundtotal == undefined ? 0 : billing.roundtotal
          // Getting data to insert for salespayment
          var salespayment = [{
            'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
            'payment_mode': payment.payment_status == 'unpaid' ? '' : payment.payment_type,
            'payment_received': payment.received_amount == undefined ? '' : payment.received_amount,
            'payment_total': Roundtotal,
            'paid_date': payment.paid_date,
            'salesorder_id': salesorder_id,
            'tax_rate': billing.tax,
            'transcation_no': payment.transcation_no,
            'cheque_no': payment.cheque_no,
            'tax_sgst': billing.tax_sgst,
            'additional_charge': billing.additional_charge,
            'discount': billing.discount,
            'discount_type': billing.discount_type,
            'unpaid_description': payment.note
          }];
          /*
           -------------------------------------------
           save data in  odc sales payment bill table 
           -------------------------------------------
           */
          api.salespayment.getAll.save(salespayment,
            function(response) {

            });
        })
    }

    //updateBill function for only update data in db
    $scope.updateBill = function() {
      $scope.odcBill.$setSubmitted();
      if ($scope.odcBill.$valid) {
        updateservice();
        if ($scope.params.id && $scope.params.editodc == 'upcomingevent') {
          $state.go('app.currentOdc', { id: '', customer_id: '', editodc: '' })
        } else if ($scope.params.id && $scope.params.editodc == 'finishedevent') { // Constant defined in CollectionsLibraryAvailableController 
          $state.go('app.paidOdc', { id: '', customer_id: '', editodc: '' })
        } else if (!$scope.params.id) { // Constant defined in CollectionsLibraryAvailableController 
          $state.go("app.new-odc", {}, { reload: "app.new-odc" })
        }

        $mdToast.show({
          template: '<md-toast class="success"><span flex>Event updated successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //initial tab activation for odc info
    $scope.odcbill = true
    //when tab change 
    $scope.odcbills = function() {
      $scope.odcbill = true;
      $scope.customerinfo = false
      $scope.payments = false
    }
    $scope.payment = function() {
      $scope.payments = true
      $scope.odcbill = false;
      $scope.customerinfo = false
    }
    $scope.customerinfos = function() {
      $scope.customerinfo = true
      $scope.odcbill = false;
      $scope.payments = false
    }

    //saveBill function for only save data in db
    $scope.saveBill = function(odcBills) {
      $scope.odcBill.$setSubmitted();

      if ($scope.odcBill.$valid) {
        saveservice()
        $state.go("app.new-odc", {}, { reload: "app.new-odc" })
        // clearform();
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Event added successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc.currentOdc', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.currentOdc', {
        url: '/currentOdc',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/odc-bill/current-odc-bill/current-odc.html',
            controller: 'CurrentOdcController as vm'
          }
        },
        resolve: {
    
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          sales_order_data: function(apiResolver) {
            return apiResolver.resolve('sales_order_data.getAll@get');
          },
          odc_category: function(apiResolver) {
            return apiResolver.resolve('odc_category@get');
          }

        },
        ncyBreadcrumb: {
          label: "{{'ODC.UPCOMING-EVENT' | translate }}"
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc.currentOdc')
    .controller('CurrentOdcController', CurrentOdcController)
    .directive('exportToCsv4', function() { //export as excel for odc
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Upcoming Event' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function CurrentOdcController($scope, odc_category, sales_order_data, $mdToast, staffRole, $mdDialog, $state, customer_details, $cookies, $rootScope, api, $timeout, $mdPanel, $stateParams) {
    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;
    $scope.mdtableselected = []; // dummy assign
    //get staff data from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');
    //store permissions  in array
    $scope.admin = []
    $scope.ODCC = []
    $scope.odceditt = []
    $scope.odcdeletee = []
    //get permissions from cookies
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 4) {
        $scope.ODCC.push("ODC");
      } else if (permissionss[i] == 42) {
        $scope.odceditt.push("ODCedit");
      } else if (permissionss[i] == 43) {
        $scope.odcdeletee.push("ODCdelete");
      }
    }
    //get staff data with id
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      });

    $scope.staffs = "admin"
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': '', 'name': 'All Staff' }]
    //filter out only odc permission staffs
    $scope.pos_staff = staffRole.filter(function(staff) {
      return sales_order_data.some(function(fullsalesorderdata) {
        return (staff.staffID == fullsalesorderdata.staffID && staff.status == 'active' && fullsalesorderdata.sales_dietType == 'ODC' && staff.branch_id == fullsalesorderdata.branch_id)
      })
    });

    vm.staffRole = staff_all.concat($scope.pos_staff); //concat two array suchas all array and filtered staff

    $scope.myDate = new Date(); //assign today date by default
    vm.amount_type = [{
      "name": 'All amount type',
      "value": 'All'
    }, {
      "name": 'Paid amount',
      "value": 'fully paid'
    }, {
      "name": 'Balance amount',
      "value": 'balance'
    }];
    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    $scope.monthyear = new Date();
    $scope.today = new Date();
    $scope.date = new Date();
    vm.customers = customer_details;
    //success function for get upcoming odc datas
    function currentodc_success(desserts) {
      //collect counts from server
      $scope.total_paid = desserts[0].total_paid
      $scope.full_data = desserts[0].full_total
      $scope.tax_info_sgst = desserts[0].tax_info_sgst
      $scope.tax_info_cgst = desserts[0].tax_info_cgst
      $scope.total_purchase = desserts[0].total_purchase
      $scope.total_cash = desserts[0].total_cash
      $scope.total_card = desserts[0].total_card
      $scope.total_cheque = desserts[0].total_cheque
      $scope.total_online = desserts[0].total_online
      $scope.balance = desserts[0].balance
      $scope.paid_count = desserts[0].paid_count;
      $scope.balance_count = desserts[0].balance_count
      $scope.odcbillLength = desserts[0].results;
      $scope.paidexpense_count = desserts[0].paidexpense_count;
      vm.balancebill = desserts[0].results;
    }


    $scope.changeDate = changeDate;
    //function for change date for show data depending on date
    function changeDate(amount_type, myDate, staff) {
      $scope.retrieve = "rmInfo"

      $scope.load = true
      getDessertsss(amount_type, myDate, staff) // callback funtion

      $timeout(function() {
        $scope.load = false
      }, 500);

    }
    $scope.getDessertsss = getDessertsss(); //assign function to $scope variable
    //service for get upcoming odc datas
    function getDessertsss(amount_type, myDate, staff) {
      // Init load all data in dropdown
      if (amount_type == undefined || myDate == undefined) {
        var amount_type = 'All'
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
      }
      // If change the value in dropdown
      else {
        var amount_type = amount_type;
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear()
      };
      // For Staff
      if ($cookies.get('admin') != 'admin') {
        $scope.paidexpense_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          month: month,
          year: year
        };
      }
      // For Admin
      if ($cookies.get('admin') == 'admin') {
        var staffID = staff == undefined ? 'admin' : staff
        $scope.paidexpense_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          month: month,
          year: year
        };
      }
      $scope.reload = function() {
        $scope.promise = api.currentodc_service.getAll.get($scope.paidexpense_query, currentodc_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000);*/
      };
      $scope.reload();
    };

    getDessertsss();


    //when search here pagination will managed
    $scope.$watch('paidexpense_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.paidexpense_query.page ? $scope.paidexpense_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.paidexpense_query.page = 1
      }

      if (!newValue) {
        $scope.paidexpense_query.page = bookmark ? bookmark : 1
      }

      $scope.getDessertsss = getDessertsss;
      $scope.reload();
    });

    // GET CATEGORY NAME
    //---------------- 
    vm.staffs = staffRole;
    //find who created particular bill for admin view
    $scope.balexpense_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //to  find who was done by last edit
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    //filter out only odc customer info
    $scope.balexpense_customernames = function(customer) {
      for (var i = 0; i < vm.customers.length; i++) {
        if (vm.customers[i].customer_id == customer.customer_id) {
          return vm.customers[i].customer_name
        }
      }
    };
    vm.expensecategory = odc_category.odcbill.odc_categories; //store categories which is came from local json
    //page load function for get all categories for all upcoming bills
    $scope.balexpense_getcategory = function(customer) {
      for (var i = 0; i < vm.expensecategory.length; i++) {
        if (vm.expensecategory[i].value == customer.odc_categoryID) {
          return vm.expensecategory[i].label
        }
      }
    };
    //transfer state from upcoming to new for edit purpose
    $scope.balexpense = function(sales_id, customer) {
      $scope.params = $stateParams;
      $state.go('app.new-odc', { id: sales_id, customer_id: customer, editodc: 'upcomingevent' })
    }
    //search text clear
    $scope.clearText = function() {
      $scope.paidexpense_query.filter = '';
    }


    // Remove Row
    $scope.removeRow = function(fmitem, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this event?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.currentodc_service.getID.delete({ salesorder_id: fmitem.salesorder_id },
          function(response) {
            //success callback
            deleteItem(fmitem);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });


      /**
       * Delete Item
       */
      function deleteItem(fmitem) {
        vm.balancebill.splice(vm.balancebill.indexOf(fmitem), 1);
        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        $state.go("app.currentOdc", {}, { reload: "app.currentOdc" });

      }

    }
    //showing only months in dates dropdown which is supported only angualrjs material 1.10
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense.paidExpense', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.paidExpense', {
        url: '/paidExpense',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/expense/paid-expense/paid-expense.html',
            controller: 'PaidExpenseController as vm'
          }
        },
        resolve: {
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          expense_bill_data: function(apiResolver) {
            return apiResolver.resolve('expense_bill_data.getAll@get');
          },
          expense_amountType: function(apiResolver) {
            return apiResolver.resolve('expense_amountType@get');
          },
          newexpense: function(apiResolver) {
            return apiResolver.resolve('newexpense.getAll@get');
          },
          getvendors: function(apiResolver) {
            return apiResolver.resolve('getvendors.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          }
        },
        ncyBreadcrumb: {
          label: "{{'EXPENSE.PAID-EXPENSE' | translate}}"
        }
      });

    // Translation

  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense.paidExpense')
    .controller('PaidExpenseController', PaidExpenseController)
    .directive('exportToCsv3', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Paid Expense' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function PaidExpenseController($scope, api, staffRole, expense_bill_data, dietType, getvendors, $mdToast, $mdDialog, expense_amountType, newexpense, $stateParams, $state, $rootScope, $cookies, $timeout, $mdPanel) {
    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;
    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
    vm.expense_amountType = expense_amountType.expensebill.Amount_PayType; //expense category which is came local json
    var amountType_all = [{ 'label': 'All Paid Type', 'value': '' }]
    var amounts_type = vm.expense_amountType.map(function(paymode) {
      return { 'label': paymode.label, 'value': paymode.value }
    })
    vm.paymentmodelist = amountType_all.concat(amounts_type); //amount type like cash or card
    vm.settings = dietType.settings;
    //store permissions in array
    $scope.admin = []

    $scope.expensebillss = []
    $scope.expenseeditt = []
    $scope.expensedeletee = []
    $scope.mdtableselected = []; // dummy assign
    //get permissions from array
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 2) {
        $scope.expensebillss.push("expensebills");
      } else if (permissionss[i] == 22) {
        $scope.expenseeditt.push("expensebillsedit");
      } else if (permissionss[i] == 23) {
        $scope.expensedeletee.push("expensebillsdelete");
      }
    }

    $scope.OpenDayWise = true;
    $scope.OpenMonthWise = false;
    //when click day wise
    $scope.OpenDayWises = function() {
      $scope.OpenDayWise = true;
      $scope.OpenMonthWise = false;
    }
    //when click month wise
    $scope.OpenMonthWises = function() {
      $scope.OpenMonthWise = true;
      $scope.OpenDayWise = false;
    }
    $scope.myDates = new Date(); //assign today date initially
    $scope.myDate = new Date();

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    //formate database date string into date format
    $scope.formatDate = function(date) {
      return new Date(date)
    }
    this.isOpen = false; //unknown command
    $scope.staffs = "admin"
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': '', 'name': 'All Staff' }]
    //filter only expense staff for branch wise
    $scope.expense_staff = staffRole.filter(function(staff) {
      return expense_bill_data.some(function(fullexpensedata) {
        return (staff.staffID == fullexpensedata.staffID && staff.status == 'active' && staff.branch_id == fullexpensedata.branch_id)
      })
    })
    vm.staffRole = staff_all.concat($scope.expense_staff); //concat of all array and filtered array

    var category_all = [{ 'exCatergoryName': 'All Category', 'exCatergoryID': '' }]
    //filter expense category for branch wise
    var newexpenses = newexpense.filter(function(category) {
      if (category.branch_id == $rootScope.user[0].branch_id) {
        return category
      }
    })
    //map category for our convenient
    var catd = newexpenses.map(function(category) {
      return { 'exCatergoryName': category.exCatergoryName, 'exCatergoryID': category.exCatergoryID }
    })
    vm.category = category_all.concat(catd); //concat of category all array and filtered category
    //filter vendor data branch wise
    var vendor_all = [{ 'vendor_name': 'All Vendors', 'vendorID': '' }]
    var getvendorss = getvendors.filter(function(vendor) {
      if (vendor.branch_id == $rootScope.user[0].branch_id) {
        return vendor
      }
    })
    //map vendor data for our convenient
    var vend = getvendorss.map(function(vendor) {
      return { 'vendor_name': vendor.company_name, 'vendorID': vendor.vendorID }
    })
    vm.vendor = vendor_all.concat(vend); //concat all vendor array and filtered vendor array
    //get logged in staff details from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');
    //get staff data with id
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    vm.staffs = staffRole; //assign all staff data to dropdown
    // ACTIVE TAB
    //----------------
    //showing month only for date dropdown
    $scope.selectedDate = null;
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];
    //delete paid expense bill
    $scope.removeRow = function(expenseitem, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.delete_expense.getID.delete({ expense_bill_id: expenseitem.expense_bill_id },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $state.go("app.paidExpense", {}, { reload: "app.paidExpense" });
          },
          function(response) {
            // error callback
            console.log("error");
          }
        );
      }, function() {
        // Canceled
      });

    }



    /*==========================================================================
                               General_paid_expense
    ========================================================================== */


    //success function for get paid expense datas
    function paidexpense_success(desserts) {
      //collect counts from server
      $scope.paidexpense_count = desserts[0].paidexpense_count
      vm.paidbill = desserts[0].results
      $scope.total_expense = desserts[0].total_expense
      $scope.total_cash = desserts[0].total_cash
      $scope.total_card = desserts[0].total_card
      $scope.total_cheque = desserts[0].total_cheque
      $scope.total_online = desserts[0].total_online
    }
    $scope.maximum = new Date();

    $scope.changeDate = changeDate; //method for function call
    //function for change date for show data depending on date
    function changeDate(myDate, categoryid, PaidType, vendor, staff, datewise) {
      $scope.retrieve = "rmInfo"
      $scope.load = true
      getDesserts(myDate, categoryid, PaidType, vendor, staff, datewise) // callback funtion
      // Preloader hide 
      $timeout(function() {
        $scope.load = false
      }, 500);
    }
    $scope.getDesserts = getDesserts; //method for function call
    function getDesserts(myDate, categoryid, PaidType, vendor, staff, datewise) {
      // Init page load with all type
      if (datewise == undefined && categoryid == undefined && PaidType == undefined && vendor == undefined) {
        var categoryid = ''
        var Paid = ''
        var vendor = ''
        var dbstring = new Date();
       // console.log(dbstring)
        var dd = dbstring.getDate();
        var mm = dbstring.getMonth() + 1;
        var yyyy = dbstring.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        dbstring = yyyy + '-' + mm + '-' + dd;
      }
      // If have value in dropdown
      else {
        var categoryid = categoryid;
        var Paid = PaidType;
        var vendor = vendor == undefined ? '' : vendor;
        // Init day wise
        if (datewise) {
          var dbstring = datewise;
          var dd = dbstring.getDate();
          var mm = dbstring.getMonth() + 1;
          var yyyy = dbstring.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }
          if (mm < 10) {
            mm = '0' + mm;
          }
          dbstring = yyyy + '-' + mm + '-' + dd;
        }
      }
      // If change to month
      if (myDate) {
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear();
        var dbstring = '';
      }
      if ($cookies.get('admin') != 'admin') {
        //for view table for staff query
        //var staffID = staff == undefined ? 'admin' : staff
        $scope.balexpense_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          month: month ? month : '',
          year: year ? year : '',
          categoryid: categoryid,
          PaidType: Paid,
          vendor: vendor,
          date: dbstring ? dbstring : ''
        };
      }
      if ($cookies.get('admin') == 'admin') {
        //for view table for admin query
       // var staffID = staff == undefined ? 'admin' : staff;
        var staffID = 'admin';
        $scope.balexpense_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          month: month ? month : '',
          year: year ? year : '',
          categoryid: categoryid,
          PaidType: Paid,
          vendor: vendor,
          date: dbstring
        };
      }


      $scope.reload = function() {
        $scope.promise = api.paidexpense_service.getAll.get($scope.balexpense_query, paidexpense_success).$promise;
      };
      $scope.reload();
    };

    getDesserts() //function call for access inside of the function


    //balance expense filter
    $scope.$watch('balexpense_query.filter', function(newValue, oldValue) {

      if (!oldValue) {
        var bookmark = $scope.balexpense_query.page ? $scope.balexpense_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.balexpense_query.page = 1
      }

      if (!newValue) {
        $scope.balexpense_query.page = bookmark ? bookmark : 1
      }

      $scope.getDesserts = getDesserts; //method for function
      $scope.reload();
    });


    $scope.keyPressed = function(rmInfo) {
      $scope.retrieve = rmInfo
    }


    // GET CATEGORY NAME
    //---------------- 
    //get who created for particular  bill for view only admin
    $scope.paidexpense_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //to find who was done by last edit 
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    //state redirect for edit purpose
    $scope.paidexpense = function(expense_bill_id) {
      var id = expense_bill_id;
      $scope.params = $stateParams;
      $state.go('app.newExpense', { id: expense_bill_id, editexpense: 'paid-expense' })
    }
    //clear text function while search
    $scope.clearTexts = function() {
      $scope.balexpense_query.filter = '';
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense.newExpense', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.newExpense', {
        url: '/expense/:editexpense/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/expense/new-expense/new-expense.html',
            controller: 'NewExpenseController as vm'
          }
        },
        resolve: {
          newexpense: function(apiResolver) {
            return apiResolver.resolve('newexpense.getAll@get');
          },
          getvendors: function(apiResolver) {
            return apiResolver.resolve('getvendors.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          expense_amountType: function(apiResolver) {
            return apiResolver.resolve('expense_amountType@get');
          }

        },
        ncyBreadcrumb: {

          parent: function($scope, $stateParams) {
            if ($scope.state.params.id && $scope.state.params.editexpense == 'balance-expense') {
              return 'app.balanceExpense';
            } else if ($scope.state.params.id && $scope.state.params.editexpense == 'paid-expense') { // Constant defined in CollectionsLibraryAvailableController 
              return 'app.paidExpense';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },

          label: "{{get_BreadcrumbLabel()}}"
          //label: 'New Expense'
        }
      });


  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense.newExpense')
    .controller('NewExpenseController', NewExpenseController);


  /** @ngInject */
  function NewExpenseController($scope, $rootScope, $state, dietType, expense_amountType, $mdDialog, $mdToast, $http, $cookies, $q, $window, $timeout, Upload, $stateParams, newexpense, getvendors, api) {

    var vm = this;
    //get logged in staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    vm.purchaseTax_status = dietType.purchase; //taxtype like include or exclude which is came from gernal json
    vm.settings = dietType.settings;
    // Set active tab for initial time
    $scope.prTabName = "tabBillInfo"; //initial expense info tab activation
    vm.expense_amountType = expense_amountType.expensebill.Amount_PayType; //payment type like cash or card which is came from local json
    //filter all new expense categories data for branch wise
    var newexpenses = newexpense.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    vm.expensecategory = newexpenses; // apply filtered expense category data
    vm.vendors = getvendors; //assign all vendors for autocomplete
    $scope.params = $stateParams; //url parmeter
    //initial tab activation
    $scope.expensebill = true
    //function for when change tab from payement to info
    $scope.expensebills = function() {
      $scope.expensebill = true;
      $scope.payments = false
    }
    //function for when change tab from info to payment
    $scope.payment = function() {
      $scope.payments = true
      $scope.expensebill = false;
    }
    $scope.myDate = new Date(); //assign today date

    //retrict date only 30 days move on backward from md pciker FOR DUE DATE
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() - 30
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() + 120
    );

    // Add Table dialog
    //add new vendor dialog
    vm.showAddTableDialogs = function(ev, vItem) {
      $mdDialog.show({
        controller: 'addVendorDialogController',
        templateUrl: 'app/main/admin/vendor/vendor.addcategory.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          vendor: vItem,
          vendors_all: vm.food
        },
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false
      })
    };

    //retrict date only 30 days move on backward from md pciker FOR PAID DATE
    $scope.minDates = new Date(
      $scope.myDate.getFullYear() - 1,
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDates = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
      //clear payment status when change
      $scope.clear_advancePaid = function() {
        vm.expayment.note = ''
        vm.expayment.received_amount = ''
        vm.expayment.cheque_no = ''
        vm.expayment.transcation_no = ''
      }
  //clear payment status when change
      $scope.clear_payment = function() {
        if (vm.expayment.payment_status == 'fully paid') {
          vm.expayment.received_amount = ''
        }
        if (vm.expayment.cheque_no) {
          vm.expayment.transcation_no = ''
        }
        if (vm.expayment.transcation_no) {
          vm.expayment.cheque_no = ''
        }
      }
    /*
    -------------------------------------------------

    Add scenario init expense bill data

    -------------------------------------------------
    */
    //add purpose
    if (!$scope.params.id) {
      vm.exitems = [{}]
      vm.expayment = {}
      vm.file = ''
    
      vm.expayment.paid_date = new Date()
    
    }
    /*
      -------------------------------------------------

      Edit scenario init expense bill data

      -------------------------------------------------
      */
    else { //edit purpose
      vm.expayment = {}

      //get expense_bill_id 
      var expense_bill_ids = $scope.params.id;
      //service for get expense data
      api.balexpense.getaData.get({ expense_bill_id: expense_bill_ids },
        function(response) {
          $scope.response = response;
          $scope.url = response[0].billname; //assign bill name for load receipt
          $scope.image_name_copy = angular.copy($scope.url) //make copy delete the receipt
          vm.expense = response[0];
          vm.expense.created_on = response[0].created_on == '' ? null : new Date(response[0].created_on);
        })
      //service for get  expense items
      api.expense_item.getID.get({ expense_bill_id: expense_bill_ids },
        function(response) {
          vm.exitems = response;
        })
      //service for get  expense payments
      api.expense_payment.getID.get({ expense_bill_id: expense_bill_ids },
        function(response) {
          vm.expayment = response[0];
          if (response[0].tax_status) {
            vm.exitems.tax_status = response[0].tax_status
          }
          vm.exitems.tax_type = response[0].tax_type
          vm.exitems.discount = response[0].discount
          // if exclude condition
          if (response[0].tax_status == 'exclude') {
            if (response[0].tax_type == 'amount') {
              vm.exitems.tax_cgstValue = response[0].tax_cgst
              vm.exitems.tax_sgstValue = response[0].tax_sgst
              vm.exitems.tax_cgst = response[0].tax_cgst
              vm.exitems.tax_sgst = response[0].tax_sgst
              vm.exitems.taxamount = parseInt(vm.exitems.tax_cgst) + parseInt(vm.exitems.tax_sgst)
            } else if (response[0].tax_type == 'percent') {
              vm.exitems.tax_cgstValue = (response[0].subtotal / 100) * response[0].tax_cgstPercent
              vm.exitems.tax_sgstValue = (response[0].subtotal / 100) * response[0].tax_sgstPercent
              vm.exitems.tax_cgst = response[0].tax_cgstPercent
              vm.exitems.tax_sgst = response[0].tax_sgstPercent
              vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
            }
          }
          // if include condition
          if (response[0].tax_status == 'include') {
            if (response[0].tax_type == 'amount') {
              vm.exitems.tax_cgst = response[0].tax_cgst
              vm.exitems.tax_sgst = response[0].tax_sgst
            } else if (response[0].tax_type == 'percent') {
              vm.exitems.tax_cgst = response[0].tax_cgstPercent
              vm.exitems.tax_sgst = response[0].tax_sgstPercent
            }
            vm.exitems.taxamount = 0
          }
          vm.exitems.total_amount = response[0].total_amount
          if (vm.exitems.tax_cgst) {
            $scope.OpenTax = true;
            $scope.hideclose = true;
          };
          if (vm.exitems.tax_sgst) {
            $scope.OpenTax = true;
            $scope.hideclose = true;
          };
          if (vm.exitems.discount) {
            $scope.OpenPermission = true;
            $scope.hideclose = true;

          };
          var paid_date = new Date(response[0].paid_date);
          vm.expayment.paid_date = paid_date;
          vm.expayment.payment_type = response[0].payment_type
          vm.expayment.transcation_no = vm.expayment.transcation_no == null ? '' : response[0].transcation_no
          vm.expayment.cheque_no = vm.expayment.cheque_no == null ? '' : response[0].cheque_no
        });
    };

    vm.myDate = new Date();


    // Add Row
    //----------------
    $scope.addRow = function() {
      vm.exitems.push({
        'item_name': '',
        'item_amount': '0'
      });
    };
    $scope.cancel = function(ev) {
      if ($scope.newexpense.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go("app.newExpense", {}, { reload: "app.newExpense" })
        }, function() {
          // Canceled
        });
      } else {
        $state.go("app.newExpense", {}, { reload: "app.newExpense" })
      }
    }
    //while update cancel function here worked
    $scope.canceledit = function(ev) {
      if ($scope.newexpense.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          if ($scope.params.id && $scope.params.editexpense == 'balance-expense') {
            $state.go('app.balanceExpense', { id: '', editexpense: '' })
          } else if ($scope.params.id && $scope.params.editexpense == 'paid-expense') { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.paidExpense', { id: '', editexpense: '' })
          } else if (!$scope.params.id) { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.newExpense', { id: '' })
          }
        }, function() {
          // Canceled
        });
      } else {
        $state.go('app.newExpense', { id: '' })
      }
    }


    // Remove Row
    //----------------fmitem.splice(index, 1);
    $scope.removeRow = function(expenseitem, ev, index) {
      if (!expenseitem.expense_item_id) {
        vm.exitems.splice(index, 1);
      } else {
        var confirm = $mdDialog.confirm()
          .title('Delete')
          .htmlContent('Are you sure you want to delete this item?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          api.delete_expense_items.getID.delete({ expense_item_id: expenseitem.expense_item_id },
            function(response) {
              //success callback
              deleteItem(expenseitem);
            },
            function(response) {
              // error callback
            }
          );

        }, function() {
          // Canceled
        });

      };
      /**
       * Delete Item
       */
      function deleteItem(fmitem) {
        vm.exitems.splice(vm.exitems.indexOf(expenseitem), 1);

        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }


    //function for Breadcrumb Label with id
    $rootScope.get_BreadcrumbLabel = function() {
      if ($scope.params.id) {
        return $scope.params.id
      } else if (!$scope.params.id) {
        return "New Expense"
      }
    }


    vm.paymentselect = 'unpaid';

    vm.payment = [{
      "name": 'Unpaid',
      "value": 'unpaid'
    }, {
      "name": 'Fully Paid',
      "value": 'fully paid'
    }, {
      "name": 'Advance Paid',
      "value": 'advance paid'
    }];

    // recurring
    vm.howmanyselect = 'never';
    vm.howmanylist = [{
      "name": 'Never',
      "value": 'never'
    }, {
      "name": 'Remaining',
      "value": 'remaining'
    }];

    // Often recurring
    vm.oftenselect = 'day';
    vm.oftenlist = [{
      "name": 'Day',
      "value": 'day'
    }, {
      "name": 'Week',
      "value": 'week'
    }, {
      "name": 'Month',
      "value": 'month'
    }, {
      "name": 'Year',
      "value": 'year'
    }, {
      "name": 'Custom',
      "value": 'custom'
    }];

    // custom count

    // Discount type
    vm.discount = '%';
    vm.discountTypes = [{
        "currency": '%'
      },
      {
        "currency": '$'
      }
    ];
    //focus tax input
    $scope.focustax = function() {
      $timeout(function() {
        angular.element('#tax-focus').focus();
      }, 100);
    }
    //focus discount input
    $scope.focusdiscount = function() {
      $timeout(function() {
        angular.element('#discount-focus').focus();
      }, 100);
    }
    //calculate functions for expense entry
    var calculateTotals = function() {
      var subtotals = 0;
      angular.forEach(vm.exitems, function(expenseitem) {
        // running to getting amount or per item
        var amount = (expenseitem.item_amount != null) ? expenseitem.item_amount : 0;
        subtotals += parseInt(amount)
      })
      vm.exitems.subtotal = subtotals;
      $scope.dataChange = function() {
        // only tax changes happen it will run
        cals();
      };
      cals();

      function cals() {
        var tax_cgstPercent = (vm.exitems.tax_cgst != null) ? vm.exitems.tax_cgst : 0;
        var tax_sgstPercent = (vm.exitems.tax_sgst != null) ? vm.exitems.tax_sgst : 0;
        vm.exitems.taxamount = (vm.exitems.taxamount != null) ? vm.exitems.taxamount : 0
        vm.exitems.discount = (vm.exitems.discount != null) ? vm.exitems.discount : '';
        // if exclude condition
        if (vm.exitems.tax_status == 'exclude') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = (tax_cgstPercent == '') ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = (tax_sgstPercent == '') ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
        } // if include condition
        else if (vm.exitems.tax_status == 'include') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = tax_cgstPercent == '' ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = tax_sgstPercent == '' ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = (vm.exitems.subtotal / 100) * 0;
        }

        vm.roundtotal = vm.exitems.subtotal + vm.exitems.taxamount - vm.exitems.discount;
        vm.exitems.total_amount = Math.round(vm.roundtotal);
      }
      //remove row condition :- Disable first index while removing rows,
      if (vm.exitems.length > 1) {
        $scope.formitem = false;
      } else {
        $scope.formitem = true;

      }

    };

    $scope.$watch('vm.exitems', calculateTotals, true); //watch function for ng-repeat array name

    // Clear the discount :- Calculation
    $scope.clearDis = function() {
      if (!vm.exitems.discount) {
        vm.exitems.discount = 0;
      };
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) + parseInt(vm.exitems.discount)
      vm.exitems.discount = '';
    }
    // Clear the Tax :- Calculation
    $scope.clrTax = function() {
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) - parseInt(vm.exitems.taxamount)
      vm.exitems.tax_cgst = '';
      vm.exitems.tax_sgst = '';
      vm.exitems.taxamount = 0;
    }

    //when staff add new row then enter key will be worked
    $scope.keyPressed = function(keyEvent) {
      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        vm.exitems.push({
          'item_name': '',
          'item_amount': 0
        });
        $scope.indx = vm.exitems.length - 1;
        $scope.$watch(vm.exitems, function() {
          $timeout(function() {
            angular.element('.autodd').focus();
          }, 10);

        })

      }
    };

    // ******************************
    // Internal methods
    // ******************************
    vm.food = loadAll(); //load all vendors
    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;

    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.vendor_name.indexOf(lowercaseQuery) === 0);
      };

    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var vendor_data = vm.vendors.filter(function(item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })
      var foodList = vendor_data
      return foodList.map(function(food) {
        return {
          vendor_name: food.company_name.toLowerCase(),
          display: food.company_name,
          vendorID: food.vendorID
        };
      });
    }

    //delete receipt function for both remove folder and database
    $scope.removeFile = function(ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this?')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        var file = {
          'file': angular.copy($scope.image_name_copy),
          'expense_bill_id': $scope.params.id
        };
        var expense_bill_id = $scope.params.id;
        api.expense_folder.getaData.save(file,
          function(response) {
            $scope.url = ''
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Receipt deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          });

      })
    };

    //update function for expense bill
    function updateservice() {
      if (vm.file) {
        Upload.upload({
          url: 'http://localhost:1100/update_expenssebill', //webAPI exposed to upload the file
          data: { file: vm.file, expense_bill_id: $scope.params.id } //pass file as data, should be user ng-model
        }).then(function(resp) { //upload function returns a promise
        })
      }
      var newexpense = vm.expense;
      var expenseitem = vm.expenseitem;
      var payment = vm.expayment;

     //get expense category name
      var exCatergoryName = []
      for (var i = 0; i < vm.expensecategory.length; i++) {
        if (vm.expensecategory[i].exCatergoryID == newexpense.exCatergoryID) {
          exCatergoryName.push(vm.expensecategory[i].exCatergoryName)
        }
      }
      /*
       -------------------------------------------
       update data in expense bill table 
       -------------------------------------------
       */
      //update expense_bill data with specific id
      var newexpensedata = [{
        'vendor_name': newexpense.vendor_name.vendor_name ? newexpense.vendor_name.vendor_name : newexpense.vendor_name,
        'vendor_id': newexpense.vendor_name.vendorID ? newexpense.vendor_name.vendorID : newexpense.vendor_id,
        'exCatergoryID': newexpense.exCatergoryID,
        'category_name': exCatergoryName[0],
        'created_on': newexpense.created_on == null ? '' : newexpense.created_on,
        'last_modified': new Date(),
        'modifiedID': $rootScope.user[0].staffID
      }];
      var expensepayment = [{
        'note': payment.note,
        'received_amount': payment.received_amount,
        'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
        'payment_type': payment.payment_type,
        'transcation_no': payment.transcation_no,
        'cheque_no': payment.cheque_no,
        'status': 'general',
        'tax_cgst': vm.exitems.tax_cgstValue,
        'tax_sgst': vm.exitems.tax_sgstValue,
        'tax_status': vm.exitems.tax_status,
        'tax_type': vm.exitems.tax_type,
        'tax_cgstPercent': vm.exitems.tax_cgst,
        'tax_sgstPercent': vm.exitems.tax_sgst,
        'discount': vm.exitems.discount,
        'subtotal': vm.exitems.subtotal,
        'paid_date': payment.paid_date,
        'total_amount': vm.exitems.total_amount
      }];

      //update data with id for primary table
      api.update_expense_data.getID.update({ expense_bill_id: $scope.params.id }, newexpensedata,
        function(response) {

        });
      /*-------------------------------------------
      update data in expense items table 
      -------------------------------------------*/
      //add expense_items to database         
      api.update_newexpenseitem.getID.update({ expense_bill_id: $scope.params.id }, vm.exitems,
        function(response) {

        });

      /*-------------------------------------------
        update data in expense payment table 
        -------------------------------------------*/
      api.update_expensepayment.getID.update({ expense_bill_id: $scope.params.id }, expensepayment,
        function(response) {

        });

    }

    //remove and upload new receipt it happens in front end
    $scope.removeupload = function() {
      vm.file = ''
    }
    //save function
    function saveservice() {
      var file = vm.file ? vm.file : [{ 'file': null }]
      //upload image to folder and database
      /*
      -------------------------------
      Add receipt and get inserted id
      -------------------------------
      
      Upload.upload({
        url: 'http://localhost:1100/upload', //webAPI exposed to upload the file
        data: { file: file } //pass file as data, should be user ng-model

      }).then(function(resp) { //upload function returns a promise
        console.log(resp);
        var expense_bill_id = resp.data.insertId;*/
        var newexpense = vm.expense;
        //  var recurring = vm.recurring;
        var expenseitem = vm.expenseitem;


        var exCatergoryName = []
        for (var i = 0; i < vm.expensecategory.length; i++) {
          if (vm.expensecategory[i].exCatergoryID == newexpense.exCatergoryID) {
            exCatergoryName.push(vm.expensecategory[i].exCatergoryName)
          }
        }
        console.log(new Date());
        /*
         -------------------------------------------
         post data in expense bill table 
         -------------------------------------------
         */
        //update expense_bill data with specific id
        var newexpensedata = [{
          'vendor_name': newexpense.vendor_name ? newexpense.vendor_name.vendor_name : '',
          'vendor_id': newexpense.vendor_name ? newexpense.vendor_name.vendorID : '',
          'exCatergoryID': newexpense.exCatergoryID,
          'category_name': exCatergoryName[0],
          'created_on': newexpense.created_on == undefined ? '' : newexpense.created_on,
          'staffID': $rootScope.user[0].staffID,
          'modifiedID': $rootScope.user[0].staffID,
          'last_modified': new Date(),
          'branch_id': $rootScope.user[0].branch_id
        }];
        //post data in primary table
        /*api.updatexpense_data.getaData.save({ expense_bill_id: expense_bill_id }, newexpensedata,
          function(response) {}); */
          var expense_bill_id;
          api.allexpense.getAll.save(newexpensedata,
            function(response) {
              var expense_bill_id = response.insertId;
             // console.log(response[0].insertId);
              console.log(response);
              
              /*-------------------------------------------
         post data in expense items table 
         -------------------------------------------*/
        //add expense_items to database         
        var expenseitemdatas = vm.exitems.map(function(item) {
          return { 'item_name': item.item_name, 'item_amount': item.item_amount }
        });

        var expenseitems = { 'expenseitemdata': expenseitemdatas, 'expense_bill_id': expense_bill_id };
        api.newexpenseitem.getAll.save(expenseitems,
          function(response) {});
        /*-------------------------------------------
        post data in expense payment table 
        -------------------------------------------*/
        var payment = vm.expayment;
        var expensepayment = [{
          'note': payment.note,
          'received_amount': payment.received_amount,
          'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
          'payment_type': payment.payment_status == 'unpaid' ? '' : payment.payment_type,
          'transcation_no': payment.transcation_no,
          'cheque_no': payment.cheque_no,
          'tax_cgst': vm.exitems.tax_cgstValue,
          'tax_sgst': vm.exitems.tax_sgstValue,
          'tax_status': vm.exitems.tax_status,
          'tax_type': vm.exitems.tax_type,
          'tax_cgstPercent': vm.exitems.tax_cgst,
          'tax_sgstPercent': vm.exitems.tax_sgst,
          'discount': vm.exitems.discount,
          'status': 'general',
          'subtotal': vm.exitems.subtotal,
          'total_amount': vm.exitems.total_amount,
          'paid_date': payment.paid_date,
          'expense_bill_id': expense_bill_id
        }];

        api.expensepayment.getAll.save(expensepayment,
          function(response) {});
      //});
              
            });
        
    }


    //updateBill function for only update data in db 
    $scope.updateBill = function() {
      $scope.newexpense.$setSubmitted();
      if ($scope.newexpense.$valid) {
        updateservice();
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Expense updated successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        if ($scope.params.id && $scope.params.editexpense == 'balance-expense') {
          $timeout(function(){
          $state.go('app.balanceExpense', { id: '', editexpense: '' })
          },500)
          
        } else if ($scope.params.id && $scope.params.editexpense == 'paid-expense') { // Constant defined in CollectionsLibraryAvailableController 
          $state.go('app.paidExpense', { id: '', editexpense: '' })
        }
      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //saveBill function for only save data in db
    $scope.saveBill = function() {
      $scope.newexpense.$setSubmitted();
      if ($scope.newexpense.$valid) {
        saveservice()
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Expense added successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

        $state.go("app.newExpense", {}, { reload: "app.newExpense" })
      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense.balanceExpense', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.balanceExpense', {
        url: '/balanceExpense',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/expense/balance-expense/balance-expense.html',
            controller: 'BalanceExpenseController as vm'
          }
        },
        resolve: {
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          }
        },
        ncyBreadcrumb: {
          label: "{{'EXPENSE.BALANCE-EXPENSE' | translate}}"
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense.balanceExpense')
    .controller('BalanceExpenseController', BalanceExpenseController);

  /** @ngInject */
  function BalanceExpenseController($scope, staffRole, $state, dietType, $mdDialog, $cookies, $mdToast, $rootScope, api, $timeout, $mdPanel, $stateParams) {
    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;
    $scope.mdtableselected = []; // dummy assign
    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
    vm.settings = dietType.settings;
    //get cookies data
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    //get logged in staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    //store permissions in array
    $scope.admin = [];

    $scope.expensebillss = []
    $scope.expenseeditt = []
    $scope.expensedeletee = []

    //get permission from cookies
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 2) {
        $scope.expensebillss.push("expensebills");
      } else if (permissionss[i] == 22) {
        $scope.expenseeditt.push("expensebilledit");
      } else if (permissionss[i] == 23) {
        $scope.expensedeletee.push("expensebilldelete");
      }
    }
    //get staff with id
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    vm.staffs = staffRole; //assign all staffs to variable

    // ACTIVE TAB
    //----------------
    //delete current bill
    $scope.removeRow = function(expenseitem, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.delete_expense.getID.delete({ expense_bill_id: expenseitem.expense_bill_id },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $state.go("app.balanceExpense", {}, { reload: "app.balanceExpense" });
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    }

    /*==========================================================================
                             General_Balance_Expense
      ========================================================================== */

    //query for get balance expense bill from to controller to db
    $scope.balexpense_query = {
      filter: '',
      limit: '10',
      order: 'nameToLower',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };
    //get success of balance expense 
    function balanceexpense_success(desserts) {
      $scope.paidexpense_count = desserts[0].paidexpense_count
      vm.balancebill = desserts[0].results
      $scope.total_expense = desserts[0].total_expense;
      $scope.total_advance = desserts[0].total_advance;
    }
    //while search restrict for showing div such as no data found
    $scope.keyPressed = function(rmInfo) {
      $scope.retrieve = rmInfo
    }
    //function for fetch balance expense data from database
    $scope.getDesserts = function() {
      $scope.reload = function() {
        $scope.promise = api.balanceexpense_service.getAll.get($scope.balexpense_query, balanceexpense_success).$promise;
        //$timeout(function() {
        //$scope.reload();
        //}, 30000);
      };
      $scope.reload();
    };
    //balance expense query search filter for manage pagination
    $scope.$watch('balexpense_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.balexpense_query.page ? $scope.balexpense_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.balexpense_query.page = 1
      }
      if (!newValue) {
        $scope.balexpense_query.page = bookmark ? bookmark : 1
      }

      $scope.getDesserts();
    });

    // GET CATEGORY NAME
    //---------------- 
    //get staff name
    $scope.balexpense_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //get last edited staff name
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    //pass id to edit balance expense
    $scope.balexpense = function(expense_bill_id) {
      var id = expense_bill_id;
      $scope.params = $stateParams;
      $state.go('app.newExpense', { id: expense_bill_id, editexpense: 'balance-expense' })
    }
    //clear text function for while edit
    $scope.clearTextss = function() {
      $scope.balexpense_query.filter = '';
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.dealer.smDealerOrder', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.smDealerOrder', {
        url: '/sm-dealer-order',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/dealer/dealer-order/sm-dealer-order.html',
            controller: 'SmDealerOrderController as vm'
          }
        },
        resolve: {
          getsales: function(apiResolver) {
            return apiResolver.resolve('getsales.getAll@get');
          },
          salematerial_bill_data: function(apiResolver) {
            return apiResolver.resolve('salematerial_bill_data.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          getvendors: function(apiResolver) {
            return apiResolver.resolve('getvendors.getAll@get');
          }
        },
        ncyBreadcrumb: {

          label: "{{'Dealer Orders'}}"
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.dealer.smDealerOrder')
    .controller('SmDealerOrderController', SmDealerOrderController)
    .directive('exportToCsv2', function() { //export as excel directive for inventory purchase sales materials
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Purchase Sale Material' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });



  /** @ngInject */
  function SmDealerOrderController($scope, staffRole, salematerial_bill_data, getvendors, getsales, api, $cookies, $rootScope, $stateParams, $state, $timeout, $mdDialog, $mdToast) {
    console.log(salematerial_bill_data);
    var vm = this;
    var originatorEv;
    $scope.mdtableselected = []; // dummy assign
    //get loggedin staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    //get staff data with id for like hi staff
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    vm.staffs = staffRole;
    $scope.staffs = "admin"
    //filters staff for branch wise
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': '', 'name': 'All staff' }]
    $scope.purchae_salematerial_staff = staffRole.filter(function(staff) {
      return salematerial_bill_data.some(function(smpurchaseorders) {
        return (staff.staffID == smpurchaseorders.staffID && staff.status == 'active' && staff.branch_id == smpurchaseorders.branch_id)
      })
    })
    vm.staffRole = staff_all.concat($scope.purchae_salematerial_staff); //concat of two array

    var vendor_all = [{ 'vendor_name': 'All Dealers', 'vendorID': '' }]
    var getvendorss = getvendors.filter(function(vendor) {
      if ((vendor.branch_id == $rootScope.user[0].branch_id) && (vendor.vendor_type == 'dealer') ) {
        return vendor
      }
    })
    //map vendor data for our convenient for dropdown
    var vend = getvendorss.map(function(allvendor) {
      return { 'vendor_name': allvendor.company_name, 'vendorID': allvendor.vendorID }
    })
    //to find who was last edit
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    // merge all and branch wise vendor
    vm.vendor = vendor_all.concat(vend); //concat of two array
    $scope.myDate = new Date(); //assign today date to $scope variable
    //restrict condition for max date
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    //clear search text function while search
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }

    //success function of purchase order from the server
    function purchase_order_success(desserts) {
      //collect counts from server
      $scope.total_paid = desserts[0].total_paid
      $scope.total_purchase = desserts[0].total_purchase
      $scope.total_cash = desserts[0].total_cash
      $scope.total_card = desserts[0].total_card
      $scope.total_cheque = desserts[0].total_cheque
      $scope.total_online = desserts[0].total_online
      $scope.balance = desserts[0].balance
      $scope.paid_count = desserts[0].paid_count;
      $scope.balance_count = desserts[0].balance_count

      vm.purchase_serviceID = desserts[0].results.map(function(item) {
        if (!item.DeliveryDate || item.DeliveryDate == 'null' || item.DeliveryDate == 'undefined') {
          var time = ''
          var deli_time = ''
        } else {
          var date_delivery = new Date(item.DeliveryDate).toString(); //get like wed apr with time
          var a = date_delivery.split(' ') //split date like array
          var order_time = new Date(item.created_on).toString(); //get like wed apr with time
          var b = order_time.split(' ') //split date like array
          var ordertiming = (order_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
          var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM

          var deli_time = new Date(item.DeliveryDate).toString(); //get like wed apr with time
          var bs = deli_time.split(' ') //split date like array
          var delitiming = (deli_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hourss = (delitiming[0] % 12) || 12; // convert to 12-hour style
          var deltime = hourss + ":" + delitiming[1] + " " + (delitiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
          var orderdate = (b[0] + " " + b[1] + " " + b[3]);
          var deliverydate = (a[0] + " " + a[1] + " " + a[3]);
          var currentTime = new Date();
          var endTime = new Date(item.DeliveryDate);

          var ms = (endTime - currentTime); // ms of difference
          var days = Math.round(ms / 86400000);
          var finalCountdown = (days + "d left");
          var remainingtime = ms < 0 ? "EXPIRED" : finalCountdown
        }
        //filter only items depending on purchaseorder_id for count length of items
        var food_items = []; // empty array for get np of items for count
        getsales.forEach(function(a) { //count&watch each items
          if (a.staffID == $rootScope.user[0].staffID && a.inventory_salesOrder_id == item.inventory_salesOrder_id)
            food_items.push(a.smname);
        });
        return { 'rmname': food_items.length, 'payment_status': item.payment_status, 'tax_cgst': item.tax_cgst === null ? 0 : item.tax_cgst, 'tax_sgst': item.tax_sgst === null ? 0 : item.tax_sgst, 'discount': item.discount, 'staffID': item.staffID, 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'due_date': item.payment_status == 'fully paid' ? new Date(item.paid_date) : item.due_date, 'received_amount': item.received_amount, 'purchaseStatus': item.purchaseStatus, 'deltime': deltime, 'created_on': new Date(item.created_on), 'remainingtime': remainingtime, 'status': item.status, 'showordertime': time, 'purchase_order_id': item.inventory_salesOrder_id, 'vendor_name': item.vendor_name, 'total_amount': item.total_amount, 'DeliveryDate': new Date(item.DeliveryDate) }

      })
      // Assign the mapped value to md-table
      vm.getpurchase = vm.purchase_serviceID //assign mapped data to table
      $scope.purchaseorder_count = vm.purchase_serviceID.length // apply total_count pagination
    }

    /*----------------
    Filter dropdown and data get from server
    -------------------*/
    $scope.changeDate = changeDate;
    //function for change date for show data depending on date
    function changeDate(status_type, amount_type, myDate, vendor, staff) {
      $scope.retrieve = "rmInfo"

      $scope.load = true // Show preloader
      getDessertsss(status_type, amount_type, myDate, vendor, staff) // callback funtion

      $timeout(function() {
        $scope.load = false // hide preloader
      }, 500);

    }
    $scope.getDessertsss = getDessertsss()
    //service for purchase list
    function getDessertsss(status_type, amount_type, myDate, vendor, staff) {
      if (amount_type == undefined || status_type == undefined || myDate == undefined || vendor == undefined) {
        // if All selected in dropdown filter and init page load
        var amount_type = 'All'
        var status_type = ''
        var month = new Date().getMonth() + 1;
        var year = new Date().getFullYear();
        var vendor = ''
      } else {
        // if All not selected in dropdown filter
        var vendor = vendor;
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear()
      }
      if ($cookies.get('admin') != 'admin') {
        // If staff assign this value
        $scope.purchaseorder_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          status_type: status_type,
          month: month,
          year: year,
          vendor: vendor,
          order_bill_type: 'dealer'
        };
      }
      if ($cookies.get('admin') == 'admin') {
        // If admin assign this value
        var staffID = staff == undefined ? 'admin' : staff
        $scope.purchaseorder_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          amount_type: amount_type,
          status_type: status_type,
          month: month,
          year: year,
          vendor: vendor,
          order_bill_type: 'dealer'
        };
      }
      $scope.reload = function() {
        $scope.promise = api.getsales_service.getAll.get($scope.purchaseorder_query, purchase_order_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000);*/
      };
      $scope.reload()
    };
    getDessertsss();


    vm.amount_type = [{
      "name": 'All amount type',
      "value": 'All'
    }, {
      "name": 'Paid amount',
      "value": 'fully paid'
    }, {
      "name": 'Balance amount',
      "value": 'balance'
    }];
    vm.status_type = [{
      "name": 'All status type',
      "value": ''
    }, {
      "name": 'Ordered',
      "value": 'ordered'
    }, {
      "name": 'Delivered',
      "value": 'delivered'
    }];


    //search text query filter for pagination while search

    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss = getDessertsss;
      $scope.reload();
    });

    //supported for angularjs material 1.10 for only showing month in date filter
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];

    // GET purchase order created name for admin
    //---------------- 
    $scope.purchaseorder_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };

    // Delete the purchase order
    $scope.removeRow = function(item, ev, index) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this item?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.delete_salematerial_data.getID.delete({ inventory_salesOrder_id: item.purchase_order_id },
          function(response) {
            //success callback
            deleteItem(item);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

      /**
       * Delete index of the  Item
       */
      function deleteItem(item) {
        vm.getpurchase.splice(vm.getpurchase.indexOf(item), 1);

        $mdToast.show({
          template: '<md-toast><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });


      }

    }


    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
      // unknown code for search pagination
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss = getDessertsss;
      // for trigger the service to get data
      $scope.reload();
    });

    //redirect from list to edit with id
    $scope.purchaseid = function(purchase_order_id) {
      var id = purchase_order_id;
      $scope.params = $stateParams;
      $state.go('app.addDealer', { id: purchase_order_id })
    }

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.dealer.addDealer', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.addDealer', {
        url: '/add-dealer-order/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/dealer/add-dealer_order/addDealer.html',
            controller: 'addDealerController as vm'
          }
        },
        resolve: {
          getvendors: function(apiResolver) {

            return apiResolver.resolve('getvendors.getAll@get');
          },
          siItems: function(apiResolver) {
            return apiResolver.resolve('siItems.getAll@get');
          },
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },

          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          expense_amountType: function(apiResolver) {
            return apiResolver.resolve('expense_amountType@get');
          }


        },
        ncyBreadcrumb: {

          parent: function($scope, $stateParams) {


            if ($scope.state.params.id) {

              console.log($scope.state.params.id)
              // Constant defined in CollectionsLibraryMyController
              return 'app.smDealerOrder';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController
              return null;
            }
          },

          label: "{{get_BreadcrumbLabel()}}"
          //label: 'New Expense'
        }
      });

    // Translation


  }
})();

(function() {
  'use strict';

  angular
    .module('app.dealer.addDealer')
    .controller('addDealerController', addDealerController)
    .directive('validNumber', function() {
      return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModelCtrl) {
          if (!ngModelCtrl) {
            return;
          }

          ngModelCtrl.$parsers.push(function(val) {
            var clean = val.replace(/^[^1-9]*|[^0-9]/g, '');
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.on('keypress', function(event) {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    });


  /** @ngInject */
  function addDealerController($scope, $state, $cookies, branch_data, siCategory, Upload, dietType, expense_amountType, $mdDialog, $rootScope, siItems, $mdToast, $q, $timeout, $stateParams, api, getvendors) {

    var vm = this;
        // filter branch data 
    vm.branchFilterData = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });
    //get loggedin staff data from cookies
    $rootScope.user = $cookies.getObject('user');
    $scope.currentDate = new Date() //assign today date
    vm.purchaseTax_status = dietType.purchase; //include or exclude for dropdownS
    //tab wise active div html
    $scope.expensebill = true;
    $scope.expensebills = function() {
      $scope.expensebill = true;
      $scope.payments = false;
    }
    $scope.payment = function() {
      $scope.payments = true;
      $scope.expensebill = false;
    }
    //condition for when staff change for purchase status the text will be changed in front end
    $scope.changestatus = function() {
      if (vm.purchase.status == 'delivered') {
        vm.purchase.DeliveryDate = new Date();
        
      } else {
        vm.purchase.DeliveryDate = ''

      }
    }
    //get amount type from data json like card cash cheque
    vm.expense_amountType = expense_amountType.expensebill.Amount_PayType;
    $scope.cash = "cash"
    $scope.myDate = new Date();
    //retrict date only 30 days move on backward from md pciker FOR Due DATE
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate()
    );


    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 3,
      $scope.myDate.getDate()
    );


    //retrict date only 30 days move on backward from md pciker FOR Delivery DATE
    $scope.minDatess = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 0,
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDatess = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 0,
      $scope.myDate.getDate()
    );


    //retrict date only 30 days move on backward from md pciker FOR PAID DATE
    $scope.minDates = new Date(
      $scope.myDate.getFullYear() - 1,
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDates = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    //function for get new row while purchase another item
    $scope.keyPressed = function(keyEvent) {
      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        vm.exitems.push({
          'item_name': '',
          'item_amount': 0
        });
        $scope.indx = vm.exitems.length - 1;
        $scope.$watch(vm.exitems, function() {
          $timeout(function() {
            angular.element('.autodd').focus();
          }, 10);

        })

      }
    };
    //when enter key barcode pressed
    $scope.barcodekeyPressed = function($event, inputValue) {
      if (event.keyCode == 13 || event.which == 13) {
        $timeout(function() {
          $('.md-autocomplete-suggestions li:first-child').click();
          $('.qty').focus();
        }, 300);
      }
    };
    //filter sale material category data for branch wise
    var siCategorys = siCategory.filter(function(smCatergory) {
      if (smCatergory.branch_id == $rootScope.user[0].branch_id) {
        return smCatergory
      }
    })
    vm.salecategorys = siCategorys; //pass category while add new sale material items

    //popup for add new sale material data
    vm.showAddTableDialogs = function(ev, siInfo) {
      $mdDialog.show({
        controller: 'addSaleDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/sale-item/item/dialog/si-additem.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          siItems: vm.rmitems,
          siCategory: vm.salecategorys,
          siInfo: siInfo,
          dietType: dietType,
          branch_data : branch_data

        }
      });
    };
    // Add Table dialog
    //popup for add new vendor data
    vm.showAddTableDialog = function(ev, vItem) {
      $mdDialog.show({
        controller: 'addVendorDialogController',
        templateUrl: 'app/main/admin/vendor/vendor.addcategory.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          vendor: vItem,
          vendors_all: vm.food

        },
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false
      })
    };
    //number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };

    // Add placeholder for autocomplete
    $timeout(function() {
      $(".foodItem-auto input").attr("placeholder", "Enter the purchase item");
    }, 500);

    //filter branch data for branch wise
    var branchfilter = branch_data.filter(function(branch) {
      if (branch.branch_id == $rootScope.user[0].branch_id)
        return branch
    })
    $scope.branch_name = branchfilter[0].branch_name; //apply branch name
    //jspdf syntax for get div as pdf format
    var doc = new jsPDF();
    var specialElementHandlers = {
      '#editor': function(element, renderer) {
        return true;
      }
    };
    //export pdf function
    $scope.SaveExportPdf = function(purchase_order_id) {
      $scope.purchase_order_id = purchase_order_id;
      $scope.ReportTime = new Date()
      $timeout(function() {
        doc.fromHTML($('#purchasesalematerial').html(), 15, 15, {
          'width': 170,
          'elementHandlers': specialElementHandlers
        });
        doc.save("" + moment(new Date()).format('MMM DD,YYYY') + "-Purchase Sale Material-" + $scope.branch_name + ".pdf");
        if ($scope.params.id) {
          // redirect state to purchase order list
          $state.go('app.smSalesOrder', { id: '' })
        } else {
          // redirect state to add purchase order
          $state.go("app.addSales", {}, { reload: "app.addSales" })
        }

      }, 1000)

    };

    // Set active tab for initial time
    $scope.prTabName = "tabBillInfo";
    vm.sistocks = siItems //autocomplete data
    vm.vendors = getvendors; //all vendor data
    //when tap change in payment status clear old inputs of payment status
    $scope.clear_advancePaid = function() {
      vm.expayment.note = ''
      vm.expayment.received_amount = ''
      vm.expayment.cheque_no = ''
      vm.expayment.transcation_no = ''
    }

    //when tap change in payment status clear old inputs of payment status
    $scope.clear_payment = function() {
      if (vm.expayment.payment_status == 'fully paid') {
        vm.expayment.received_amount = ''
      }
      if (vm.expayment.cheque_no) {
        vm.expayment.transcation_no = ''
      }
      if (vm.expayment.transcation_no) {
        vm.expayment.cheque_no = ''
      }

    }
    // Methods
    $scope.params = $stateParams; //accessing url parameter
    /*
       -------------------------------------------------

       Add scenario init sale material data

       -------------------------------------------------
       */
    //add purpuse
    if (!$scope.params.id) {
      vm.exitems = [{}]
      vm.purchase = {}
      vm.expayment = {}
      vm.file = ''
      vm.expayment.paid_date = new Date();
      vm.purchase.selectOrdered = 'delivered';
    }
    /*
    -------------------------------------------------

    Edit scenario init sale material data

    -------------------------------------------------
    */
    else { //edit purpose
      var purchase_order_id = $scope.params.id;
      // Getting data inventory sales order table
      api.inventory_salesdata.getaData.get({ purchase_order_id: purchase_order_id },
        function(response) {
          vm.purchase = response[0];
          if (vm.purchase.status == 'delivered') {
            $scope.disable_state = true;
          } else {
            $scope.disable_state = false;
          }
          $scope.url = response[0].billname;
          $scope.image_name_copy = angular.copy($scope.url) //make copy delete the receipt
          vm.purchase.Description = vm.purchase.Description == 'undefined' ? '' : vm.purchase.Description
          vm.purchase.due_date = response[0].due_date == '' ? '' : new Date(response[0].due_date);
          vm.purchase.DeliveryDate = new Date(response[0].DeliveryDate);
        })
      // Getting data inventory sales items table
      api.inventory_salesItems.getID.get({ purchase_order_id: purchase_order_id },
        function(response) {
          vm.exitems = response;
        })
      // Getting data purchase expense payment table
      api.expense_payment_sales.getID.get({ expense_bill_id: purchase_order_id },
        function(response) {
          vm.expayment = response[0];
          calculateTotals() //call watch function
          vm.expayment.paid_date = new Date(response[0].paid_date);
          vm.expayment.payment_type = response[0].payment_type
          vm.expayment.transcation_no = vm.expayment.transcation_no == null ? '' : response[0].transcation_no
          vm.expayment.cheque_no = vm.expayment.cheque_no == null ? '' : response[0].cheque_no

        })

    }

    //store payment types in array
    vm.payment = [{
      "name": 'Unpaid',
      "value": 'unpaid'
    }, {
      "name": 'Fully Paid',
      "value": 'fully paid'
    }, {
      "name": 'Advance Paid',
      "value": 'advance paid'
    }];

    //store order types in array
    vm.orderstatus = [{
      "status": 'ordered',
      "value": 'Ordered'
    }, {
      "status": 'delivered',
      "value": 'Delivered'
    }];

    vm.myDate = new Date(); //assign today date

    // Add Row
    //----------------
    $scope.addRow = function() {
      vm.exitems.push({
        'item_name': '',
        'item_amount': '0'
      });
    };

    //cancel function
    $scope.cancel = function(ev) {
      if ($scope.newsales.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go("app.addSales", {}, { reload: "app.addSales" })
        }, function() {
          // Canceled
        });
      } else {
        $state.go("app.addSales", {}, { reload: "app.addSales" })
      }
    }
    //cancel function while staff  in edit status
    $scope.canceledit = function(ev) {
      if ($scope.newsales.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $state.go('app.smSalesOrder', { id: '' })
        }, function() {
          // Canceled
        });
      } else {
        $state.go('app.smSalesOrder', { id: '' })
      }
    }
    // Remove Row
    $scope.removeRow = function(expenseitem, ev, index) {
      if (!expenseitem.inventory_salesItems_id) {
        vm.exitems.splice(index, 1);
      } else {
        var confirm = $mdDialog.confirm()
          .title('Delete')
          .htmlContent('Are you sure you want to delete this item?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {

          var item_quantity = { 'item_quantity': expenseitem.quantity * expenseitem.containQty }

          //this service is for when staff edit exist row items in list to update the quanity
          api.deleteAndupdate_salematerial_quantity.getID.update({ siItemID: expenseitem.smItemID, inventory_salesItems_id: expenseitem.inventory_salesItems_id }, item_quantity,
            function(response) {
              api.delete_salematerial_items.getID.delete({ inventory_salesItems_id: expenseitem.inventory_salesItems_id },
                function(response) {
                  //success callback
                  deleteItem(expenseitem);
                },
                function(response) {
                  // error callback
                }
              );

            },
            function() {
              // Canceled
            });
        });
      };
      /**
       * Delete index of the Item
       */
      function deleteItem(fmitem) {
        vm.exitems.splice(vm.exitems.indexOf(expenseitem), 1);

        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      }

    }

    //load all data for autocomplete
    vm.food = loadAll(); //load all vendors in autocomplete
    vm.rmitems = loadrm(); //load all sale material items in auto complete
    vm.foodItemName = null;
    vm.rmname = null;

    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;
    vm.querySearchrm = querySearchrm;
    vm.selectedItemChange = selectedItemChange;

    //focus tax data
    $scope.focustax = function() {
      $timeout(function() {
        angular.element('#tax-focus').focus();
      }, 100);
    }
    $scope.focustaxSgst = function() {
      $timeout(function() {
        angular.element('#taxSgst-focus').focus();
      }, 100);
    }
    //focus discount data
    $scope.focusdiscount = function() {
      $timeout(function() {
        angular.element('#discount-focus').focus();
      }, 100);
    }

    //watch variable function
    var calculateTotals = function() {
      /*-----------------------------------
       EDIT purpose calculation manipulation started
      -------------------------------------*/
      if ($scope.params.id) { //it happens while in edit status
        if (vm.expayment.tax_status) {
          vm.exitems.tax_status = vm.expayment.tax_status
        }
        var discount = vm.expayment.discount;
        if (discount) {
          vm.exitems.discount = discount
        }
        //auto open status for tax
        if (vm.expayment.tax_type) {
          vm.exitems.tax_type = vm.expayment.tax_type
        }

        if (vm.expayment.tax_cgst) {
          $scope.OpenTax = true;
          $scope.hideclose = true;
        };
        if (vm.expayment.tax_sgst) {
          $scope.OpenTax = true;
          $scope.hideclose = true;
        };
        //auto open status for discount
        if (vm.expayment.discount) {
          $scope.OpenPermission = true;
          $scope.hideclose = true;

        };
        // if exclude condition
        if (vm.expayment.tax_status == 'exclude') {
          if (vm.expayment.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = vm.expayment.tax_cgst
            vm.exitems.tax_sgstValue = vm.expayment.tax_sgst
            vm.exitems.tax_cgst = vm.expayment.tax_cgst
            vm.exitems.tax_sgst = vm.expayment.tax_sgst
            vm.exitems.taxamount = parseInt(vm.exitems.tax_cgst) + parseInt(vm.exitems.tax_sgst)
          } else if (vm.expayment.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.expayment.subtotal / 100) * vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.expayment.subtotal / 100) * vm.expayment.tax_sgstPercent
            vm.exitems.tax_cgst = vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgst = vm.expayment.tax_sgstPercent
            vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
          }
        }
        // if include condition
        if (vm.expayment.tax_status == 'include') {
          if (vm.expayment.tax_type == 'amount') {
            vm.exitems.tax_cgst = vm.expayment.tax_cgst
            vm.exitems.tax_sgst = vm.expayment.tax_sgst
          } else if (response[0].tax_type == 'percent') {
            vm.exitems.tax_cgst = vm.expayment.tax_cgstPercent
            vm.exitems.tax_sgst = vm.expayment.tax_sgstPercent
          }
          vm.exitems.taxamount = 0
        }
      };
      /*-----------------------------------
             EDIT purpose ended
        -------------------------------------*/
      /*-----------------------------------
       Add purpose calculation manipulation started
      -------------------------------------*/
      var subtotals = 0;
      angular.forEach(vm.exitems, function(smitem) {
        smitem.item_subtotal = smitem.quantity * smitem.smrate;
        smitem.quantity = (smitem.quantity != null) ? smitem.quantity : '';
        smitem.smrate = (smitem.smrate != null) ? smitem.smrate : '';
        subtotals += smitem.quantity * smitem.smrate;
      })
      vm.exitems.subtotal = subtotals;

      $scope.dataChange = function() {
        cals();
      };
      cals();

      function cals() {
        var tax_cgstPercent = (vm.exitems.tax_cgst != null) ? vm.exitems.tax_cgst : 0;
        var tax_sgstPercent = (vm.exitems.tax_sgst != null) ? vm.exitems.tax_sgst : 0;
        vm.exitems.discount = (vm.exitems.discount != null) ? vm.exitems.discount : '';
        // if exclude condition
        if (vm.exitems.tax_status == 'exclude') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = (tax_cgstPercent == '') ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = (tax_sgstPercent == '') ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = parseInt(vm.exitems.tax_cgstValue) + parseInt(vm.exitems.tax_sgstValue)
        } // if include condition
        else if (vm.exitems.tax_status == 'include') {
          if (vm.exitems.tax_type == 'amount') {
            vm.exitems.tax_cgstValue = tax_cgstPercent == '' ? 0 : tax_cgstPercent;
            vm.exitems.tax_sgstValue = tax_sgstPercent == '' ? 0 : tax_sgstPercent
          } else if (vm.exitems.tax_type == 'percent') {
            vm.exitems.tax_cgstValue = (vm.exitems.subtotal / 100) * tax_cgstPercent
            vm.exitems.tax_sgstValue = (vm.exitems.subtotal / 100) * tax_sgstPercent
          }
          vm.exitems.taxamount = (vm.exitems.subtotal / 100) * 0;
        }

        vm.roundtotal = vm.exitems.subtotal + vm.exitems.taxamount - vm.exitems.discount;
        vm.exitems.total_amount = Math.round(vm.roundtotal);
      }

      //remove row condition :- Disable first index while removing rows,
      if (vm.exitems.length > 1) {
        $scope.formitem = false;
      } else {
        $scope.formitem = true;
      }
    };

    $scope.$watch('vm.exitems', calculateTotals, true); //watch function ng-repeat array name
    // Clear the discount :- Calculation
    $scope.clearDis = function() {
      if (!vm.exitems.discount) {
        vm.exitems.discount = 0;
      };
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) + parseInt(vm.exitems.discount)
      vm.exitems.discount = '';
    }
    // Clear the Tax :- Calculation
    $scope.clrTax = function() {
      vm.exitems.total_amount = parseInt(vm.exitems.total_amount) - parseInt(vm.exitems.taxamount)
      vm.exitems.tax_cgst = '';
      vm.exitems.tax_sgst = '';
      vm.exitems.taxamount = 0;
    }

    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.vendor_name.indexOf(lowercaseQuery) === 0);
      };
    }

    function querySearchrm(query) {
      var results = query ? vm.rmitems.filter(createFilterForRm(query)) : vm.rmitems;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 10, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterForRm(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(food) {
        if (vm.branchFilterData[0].barcode_enable == 1) {
          return (food.smname.indexOf(query) >= 0);
        } else {
          return (food.smname.indexOf(lowercaseQuery) >= 0);
        };
      };


    }


    function selectedItemChange(index, fmitem) {
      return fmitem.smrate = fmitem.smname.smrate, fmitem.quantity = fmitem.smname.quantity, fmitem.containQty = fmitem.smname.containQty
    }


    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      //filter vendors for branch wise
      var vendor_data = vm.vendors.filter(function(vendor) {
        if ((vendor.branch_id == $rootScope.user[0].branch_id) && (vendor.vendor_type == 'dealer')) {
          return vendor
        }
      })
      var foodList = vendor_data //assign filterd vendors in autocomplete
      return foodList.map(function(food) {
        return {
          vendor_name: food.company_name.toLowerCase(),
          display: food.company_name,
          vendorID: food.vendorID
        };
      });
    }



    //load all sale materials items in autocomplete
    function loadrm() {
      //filter sale material items for branch wise
      var sistockss = vm.sistocks.filter(function(smitems) {
        if (smitems.branch_id == $rootScope.user[0].branch_id) {
          return smitems
        }
      })
      var salestocks = sistockss //assign filtered smitems for autocomplete
      return salestocks.map(function(food) {
        if (vm.branchFilterData[0].barcode_enable != 1) {
          return {
            smname: food.siname.toLowerCase(),
            display: food.siname,
            quantity: 1,
            smrate: food.PurchasePrice,
            containQty: food.containQty,
            smCatergoryID: food.siCatergoryID,
            smItemID: food.siItemID,
          };
        } else {
          return {
            smname: food.barcode,
            display: food.siname,
            quantity: 1,
            smrate: food.PurchasePrice,
            containQty: food.containQty,
            smCatergoryID: food.siCatergoryID,
            smItemID: food.siItemID,
          };
        }
      });
    }


    //function for Breadcrumb Label with id
    $rootScope.get_BreadcrumbLabel = function() {
      if ($scope.params.id) {
        return $scope.params.id
      } else if (!$scope.params.id) {
        return "Dealer Order"
      }
    }

    $scope.removeupload = function() {
      vm.file = ''
    }
    $scope.removeFile = function(ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this?')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        var file = {
          'file': angular.copy($scope.image_name_copy),
          'expense_bill_id': $scope.params.id
        };
        var expense_bill_id = $scope.params.id;
        api.salesbill_folder.getaData.save(file,
          function(response) {
            $scope.url = ''
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Receipt deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          });

      })
    };

    //updateBill function for only update data in db 

    $scope.update_purchase = function(exportPdfClicked) {
      $scope.newsales.$setSubmitted();

      if ($scope.newsales.$valid) {
        updateservice(exportPdfClicked);
        if (!exportPdfClicked) {
          $state.go('app.smSalesOrder', { id: '' })
        }
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Order updated successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });

      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //saveBill function for only save data in db
    $scope.add_purchase = function(exportPdfClicked) {

      $scope.newsales.$setSubmitted();

      if ($scope.newsales.$valid) {
        saveservice(exportPdfClicked)
        if (!exportPdfClicked) {
          // redirect when click on save button
          $state.go("app.addDealer", {}, { reload: "app.addDealer" })
        }
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Order added successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      } else {
        $mdToast.show({
          template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    function updateservice(exportPdfClicked) {

      if (vm.file) {
        Upload.upload({
          url: 'http://localhost:1100/update_salesbill', //webAPI exposed to upload the file
          data: { file: vm.file, inventory_salesOrder_id: $scope.params.id } //pass file as data, should be user ng-model
        }).then(function(resp) { //upload function returns a promise
        })
      }
      var purchase_orer = vm.purchase;
      var purchase_item = vm.exitems[0].smname;

      var itemdatas = vm.exitems.map(function(item) {
        // Compare data and update stock in stock table if delivered status
        if (siItems.siname = item.searchText && purchase_orer.status == "delivered") {
          var item_quantity = { 'item_quantity': item.quantity * item.containQty, 'editeditems': item, 'smItemID': item.smItemID }
          //filter only new item
          var editadditem = [item].filter(function(addednewitem) {
            if (addednewitem.smname.smItemID) {
              return addednewitem
            }
          })
          //filter only database item
          var editdbitem = [item].filter(function(getExistingitem) {
            if (getExistingitem.inventory_salesItems_id) {
              return getExistingitem
            }
          })

          //this service is for when staff edit exist row items in list to update the quanity
          api.update_salematerial_quantity.getID.update({ siItemID: item.smItemID }, item_quantity,
            function(response) {

            });

          if (editadditem.length) {
            var item_quantitys = { 'item_quantity': item.quantity * item.containQty }
            //this service is for when staff added new row items in list to update the quanity
            api.updateInventory_salequantity.getID.update({ siItemID: item.smname.smItemID }, item_quantitys,
              function(response) {});
          }
        }
        return { 'smItemID': item.smname.smItemID, 'smCatergoryID': item.smname.smCatergoryID, 'containQty': item.containQty, 'smname': item.smname.smname, 'quantity': item.quantity, 'expiry_date': item.expiry_date, 'smrate': item.smrate, 'item_subtotal': item.item_subtotal }
      });
      /*
      -------------------------------------------
      update data in inventory sales order table 
      -------------------------------------------
      */
      var purchase_orders = [{
        'vendor_name': purchase_orer.vendor_name.vendor_name == undefined ? purchase_orer.vendor_name : purchase_orer.vendor_name.vendor_name,
        'vendor_id': purchase_orer.vendor_name.vendorID ? purchase_orer.vendor_name.vendorID : purchase_orer.vendor_id,
        'Description': purchase_orer.Description,
        'status': purchase_orer.status,
        'due_date': purchase_orer.due_date == null ? '' : purchase_orer.due_date,
        'DeliveryDate': purchase_orer.DeliveryDate,
        'branch_id': $rootScope.user[0].branch_id,
        'modifiedID': $rootScope.user[0].staffID,
        'order_bill_type': purchase_orer.order_bill_type
      }];
      api.update_inventorySale_order.getID.update({ purchase_order_id: $scope.params.id }, purchase_orders,
        function(response) {});
      var payment = vm.expayment;
      /*-------------------------------------------
        update data in expense payment table 
        -------------------------------------------*/
      var expensepayment = [{
        'note': payment.note,
        'received_amount': payment.received_amount,
        'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
        'payment_type': payment.payment_type,
        'transcation_no': payment.transcation_no == "null" ? '' : payment.transcation_no,
        'cheque_no': payment.cheque_no == "null" ? '' : payment.cheque_no,
        'status': 'sales',
        'tax_cgst': vm.exitems.tax_cgstValue,
        'tax_sgst': vm.exitems.tax_sgstValue,
        'tax_status': vm.exitems.tax_status,
        'tax_type': vm.exitems.tax_type,
        'tax_cgstPercent': vm.exitems.tax_cgst,
        'tax_sgstPercent': vm.exitems.tax_sgst,
        'discount': vm.exitems.discount,
        'subtotal': vm.exitems.subtotal,
        'paid_date': payment.paid_date,
        'total_amount': vm.exitems.total_amount

      }];

      api.update_expensepayment_sales.getID.update({ expense_bill_id: $scope.params.id }, expensepayment,
        function(response) {});
      /*-------------------------------------------
         update data in inventory sales item
         -------------------------------------------*/
      //update sales_Payment
      api.update_inventorySale_items.getID.update({ purchase_order_id: $scope.params.id }, {'barcode_enable': vm.branchFilterData[0].barcode_enable, 'itemData' : vm.exitems},
        function(response) {
          if (exportPdfClicked) {
            $scope.SaveExportPdf($scope.params.id);
          }
        });

    }

    function saveservice(exportPdfClicked) {
      var purchase_orer = vm.purchase;
      var purchase_item = vm.exitems[0].rmname;

      var itemdatas = vm.exitems.map(function(item) {
        // if barcode enabled barcode no change to item 
        if(vm.branchFilterData[0].barcode_enable == 1) {
          item.smname.smname = item.smname.display;
        };
        console.log(item.smname.smname);
        //check full raw material items and staff purchased items if delivered status
        if (siItems.siname = item.searchText && purchase_orer.status == "delivered") {
          var item_quantity = { 'item_quantity': item.quantity * item.containQty }
          // update quantity in stock table
          api.updateInventory_salequantity.getID.update({ siItemID: item.smname.smItemID }, item_quantity,
            function(response) {});
        }
        return { 'smItemID': item.smname.smItemID, 'smCatergoryID': item.smname.smCatergoryID, 'containQty': item.containQty, 'smname': item.smname.smname, 'quantity': item.quantity, 'expiry_date': item.expiry_date, 'smrate': item.smrate, 'item_subtotal': item.item_subtotal }
      });
      var file = vm.file ? vm.file : [{ 'file': null }]
      /*
      -------------------------------
      Add receipt and get inserted id
      -------------------------------
      */
      Upload.upload({
        url: 'http://localhost:1100/uploadsales', //webAPI exposed to upload the file

        data: { file: file } //pass file as data, should be user ng-model

      }).then(function(resp) { //upload function returns a promise
        var inventory_salesOrder_id = resp.data.insertId;

        var inventory_sales_order = [{
          'vendor_name': purchase_orer.vendor_name.vendor_name,
          'vendor_id': purchase_orer.vendor_name.vendorID,
          'Description': purchase_orer.Description,
          'status': purchase_orer.status,
          'DeliveryDate': purchase_orer.DeliveryDate,
          'due_date': purchase_orer.due_date,
          'staffID': $rootScope.user[0].staffID,
          'modifiedID': $rootScope.user[0].staffID,
          'branch_id': $rootScope.user[0].branch_id,
          'inventory_salesOrder_id': inventory_salesOrder_id,
          'order_bill_type': 'dealer'
        }];
        /*
         -------------------------------------------
         Add data in inventory sales order table using inserted id
         -------------------------------------------
         */
        api.inventory_sales_order.getAll.save(inventory_sales_order,
          function(response) {
            var salesorderitem = { 'itemdata': itemdatas, 'inventory_salesOrder_id': inventory_salesOrder_id };
            /*-------------------------------------------
                 Add data in inventory sales item table
              -------------------------------------------*/
            api.inventory_sale_items.getAll.save(salesorderitem,
              function(response) {
                /*-------------------------------------------
                    Add data in expense payment table
                 -------------------------------------------*/
                var payment = vm.expayment;
                var expensepayment = [{
                  'note': payment.note,
                  'received_amount': payment.received_amount,
                  'payment_status': payment.payment_status == undefined ? 'unpaid' : payment.payment_status,
                  'payment_type': payment.payment_status == 'unpaid' ? '' : payment.payment_type,
                  'transcation_no': payment.transcation_no,
                  'cheque_no': payment.cheque_no,
                  'status': 'sales',
                  'tax_cgst': vm.exitems.tax_cgstValue,
                  'tax_sgst': vm.exitems.tax_sgstValue,
                  'tax_status': vm.exitems.tax_status,
                  'tax_type': vm.exitems.tax_type,
                  'tax_cgstPercent': vm.exitems.tax_cgst,
                  'tax_sgstPercent': vm.exitems.tax_sgst,
                  'discount': vm.exitems.discount,
                  'subtotal': vm.exitems.subtotal,
                  'total_amount': vm.exitems.total_amount,
                  'paid_date': payment.paid_date,
                  'inventory_salesOrder_id': inventory_salesOrder_id

                }];

                api.expensepayment.getAll.save(expensepayment,
                  function(response) {
                    if (exportPdfClicked) {
                      // send purchase order id for export pdf
                      $scope.SaveExportPdf(inventory_salesOrder_id);
                    }
                  });
              });
          })
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('food-settings')
    .controller('CustomerDialoggController', CustomerDialoggController)
    .directive('validNumber', function() {
      return {
        require: '?ngModel',
        link: function(scope, element, attrs, ngModelCtrl) {
          if (!ngModelCtrl) {
            return;
          }

          ngModelCtrl.$parsers.push(function(val) {
            var clean = val.replace(/^[^1-9]*|[^0-9]/g, '');
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.on('keypress', function(event) {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    });


  /** @ngInject */ //customer_mobile, customer_id, customer_name, customer_email, customer_address, customer_city

  function CustomerDialoggController($scope, $rootScope, $q, $timeout, $translate, locality, $state, customer_list, $mdToast, $mdDialog, api, customer_data, customer_details, customer_Added) {
    var vm = this;

    vm.title = 'Add';
    //filter locality for branch wise
    var localityy = locality.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.locality = localityy; //assign filtered locality to dropdown

    //customer_data is available then it will be consider as a edit purpose
    if (customer_data) {
      vm.title = 'Edit';
      $scope.customer_data = { 'customer_id': customer_data.customer_id, 'customer_city': customer_data.customer_city, 'customer_mobile': customer_data.searchText ? customer_data.searchText : customer_data.customer_mobile, 'customer_name': customer_data.customer_name, 'customer_email': customer_data.customer_email, 'localityID': customer_data.localityID, 'customer_address': customer_data.customer_address, 'localityName': customer_data.customer_locality, 'whatsapp': customer_data.whatsapp }
      $scope.Allcustomer = angular.copy($scope.customer_data);
    }
    $scope.customer = customer_data ? $scope.customer_data : customer_data //check whether add customer or edit customer depending on customer data

    // Internal methods
    // ******************************
    vm.food = loadAll();
    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;
    $timeout(function() {
      $(".foodItem-auto input").attr("placeholder", $translate.instant('BILLINGS.CUSTOMER-LIST.LOCALITY'));
    }, 500);
    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      var deferred = $q.defer();
      $timeout(function() {
        deferred.resolve(results);
      }, Math.random() * 1000, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        return (food.localityName.indexOf(lowercaseQuery) === 0);
      };

    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {

      var foodList = vm.locality
      return foodList.map(function(food) {
        return {
          localityName: food.localityName.toLowerCase(),
          display: food.localityName,
          localityID: food.localityID
        };
      });
    }
    // restrict the customer name max or min exceeds 
    $scope.user = {
      name: {
        required: true,
        minlength: 3,
        maxlength: 30
      }
    }

    //number validation
    $scope.phonenumber = phonenumber;

    function phonenumber(e) {
      if (e.target.value.length > 9) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };
    // restrict the customer mobile max or min exceeds 

    $scope.number = {
      name: {
        required: true,
        minlength: 10,
        maxlength: 12
      }
    }
    //save customer detail
    $scope.submit_customer = function(customer) {
      var new_customer = [$scope.customer].map(function(data) {
        var locality_name = [];
        locality.map(function(localitydata) {
          if (localitydata.localityID == data.localityID) {
            locality_name.push(localitydata.localityName)
          }
        })
        return { 'customer_mobile': data.customer_mobile, 'customer_city': data.customer_city, 'customer_name': data.customer_name, 'localityID': data.localityName.localityID, 'customer_locality': data.localityName.localityName, 'customer_address': data.customer_address, 'customer_email': data.customer_email, 'branch_id': $rootScope.user[0].branch_id, 'whatsapp': data.whatsapp }
      })
      $scope.customer_details = customer_details

      api.save_customer.getAll.save(new_customer, // Success
        function(response) {
          if (response.insertId) {
            $state.go("app.customerlist", {}, { reload: "app.customerlist" })
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Customer added successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $mdDialog.hide();
          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Mobile number already exists try another one!</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        })
    }
    //update customer detail
    $scope.update_customer = function(customer) {
      if (!customer_list) { //update scenerio if edit from customer list page
        var customer_datas = [customer].map(function(data) {
          return { 'customer_mobile': data.customer_mobile,'branch_id': $rootScope.user[0].branch_id, 'customer_city': data.customer_city, 'customer_id': data.customer_id, 'customer_name': data.customer_name, 'localityID': data.localityName.localityID ? data.localityName.localityID : customer_data.localityID, 'customer_locality': data.localityName.localityName ? data.localityName.localityName : customer_data.customer_locality, 'customer_address': data.customer_address, 'customer_email': data.customer_email, 'whatsapp': data.whatsapp }
        })

      } else { //update scenerio if edit from customer analytics page
        var customer_datas = [$scope.customer].map(function(data) {
          var locality_name = [];
          locality.map(function(localitydata) {
            if (localitydata.localityID == data.localityID) {
              locality_name.push(localitydata.localityName)
            }
          })
          return { 'customer_mobile': data.customer_mobile,'branch_id': $rootScope.user[0].branch_id, 'customer_city': data.customer_city, 'customer_id': data.customer_id, 'customer_name': data.customer_name, 'localityID': data.localityName.localityID ? data.localityName.localityID : customer_data.localityID, 'customer_locality': data.localityName.localityName ? data.localityName.localityName : customer_data.customer_locality, 'customer_address': data.customer_address, 'customer_email': data.customer_email, 'whatsapp': data.whatsapp }
        })
      }

      api.update_customer.getID.update({ customer_id: customer.customer_id }, customer_datas[0],
        function(response) {
          if (!response.data) {
            $state.go("app.customerlist", {}, { reload: "app.customerlist" })
            $rootScope.$broadcast("salesId", $scope.customer);
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Customer updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $mdDialog.hide();
          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Mobile number already exists try another one!</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        });
    }

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('whatsappfinishedcampaign', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.Whatsapp-Campaign-list', {
        url: '/Whatsapp-Campaign-list',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/campaign/whatsappfinishedcampaign/whatsappfinishedcampaign.html',
            controller: 'WhatsappfinishedCampaignController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Campaign-list'
        },
        resolve: {
          branch: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          campaignn: function(apiResolver) {
            return apiResolver.resolve('campaignn.getAll@get');
          },
          whatsapp_campaigns: function(apiResolver) {
            return apiResolver.resolve('whatsapp_campaigns.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          campaigndetailss: function(apiResolver) {
            return apiResolver.resolve('campaigndetailss.getAll@get');
          },

        }
      })
      .state('app.whatsappcampaignanalytics', {
        url: '/whatsapp-Campaign-list/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/campaign/whatsappfinishedcampaign/whatsapp-campaign-analytics/whatsapp-campaign-analytics.html',
            controller: 'WhatsappfinishedCampaignController as vm'
          }
        },
        resolve: {
          branch: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },

          campaignn: function(apiResolver) {
            return apiResolver.resolve('campaignn.getAll@get');
          },
          
          whatsapp_campaigns: function(apiResolver) {
            return apiResolver.resolve('whatsapp_campaigns.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          campaigndetailss: function(apiResolver) {
            return apiResolver.resolve('campaigndetailss.getAll@get');
          },
        },

        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id) {
              return 'app.Whatsapp-Campaign-list';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"
          //  label: '{{ "BILLINGS.CUSTOMERS" | translate }}'
        }
      });


    // Translation

  }
})();

(function () {
  'use strict';

  angular
    .module('whatsappfinishedcampaign')
    .controller('WhatsappfinishedCampaignController', WhatsappfinishedCampaignController);


  /** @ngInject */
  function WhatsappfinishedCampaignController(customer_details, $mdDialog, $mdToast, $filter, dietType, branch, $state, $stateParams, api, $cookies, $rootScope, $scope, campaigndetailss, campaignn ) {
    var vm = this;
    //get staff data with id
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function (response) {
        $scope.staff_name = response[0].name;
      });
    // Checking user permissions
    $scope.whatsapppermission = [];
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format which is taken by cookies
    for (var i = 0; i < permissions.length; i++) {
      if (permissions[i] == 53) {
        $scope.whatsapppermission.push("data");
      }
    };
    // checking branch permissions
    $scope.whatsappbranchpermission = [];
    var branchpermissions = JSON.parse("[" + branch[0].permissions + "]"); //covert as array format which is taken by cookies
    for (var i = 0; i < branchpermissions.length; i++) {
      if (branchpermissions[i] == 53) {
        $scope.whatsappbranchpermission.push("data");
      }
    };
    if ($scope.whatsapppermission.length > 0 && $scope.whatsappbranchpermission.length > 0) {
      $scope.whatsapppermission = true // if true means permission will be applied
    };

    //request to server if he have a permission of marketing
    var marketingPermission = []
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from cookies data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 52) || permissions[i] == 52) {
        marketingPermission.push("data");
      }
    }
    $scope.params = $stateParams;

    // Pagination
    $scope.pagination_query = {
      page: 1,
      limit: 10
    };

    $scope.loadCampaigns = function () {
      const params = {
        page: $scope.pagination_query.page,
        limit: $scope.pagination_query.limit,
        search: $scope.pagination_query.searchText || ''
      };
      //api.customer_infodiet.getID.get
      api.whatsapp_campaigns.getAll.get(params, function (response) {
        vm.campaign_datas = response[0].data;
        $scope.totalItems = response[0].total;
      });
    };
    // Initial load
    $scope.loadCampaigns();
    // Watch for changes in page or limit
    $scope.$watchGroup(['pagination_query.page', 'pagination_query.limit',  'pagination_query.searchText'], function (newValues, oldValues) {
      if (newValues !== oldValues) {
        $scope.loadCampaigns();
      }
    });
    // Clear search text
    //-----------------------
    $scope.clearText_campaingns = function() {
      console.log(clearText_campaingns);
      $scope.pagination_query.searchText = '';
    }

    
    //get finished campaign data with only status flag 1
    var campaignevent = []
    campaignn.map(function (data) {
      // Get data for user
      if ((data.staffID == $rootScope.user[0].staffID) && (data.branch_id == $rootScope.user[0].branch_id) && (data.status_flag == 1) && (data.senderId == 'whatsapp') && $cookies.get('admin') != 'admin') {
        campaignevent.push({ 'campaignID': data.campaignID, 'campaignName': data.campaignName, 'createdOn': new Date(data.createdOn) })
      }
      // Get data for admin
      else if ((data.branch_id == $rootScope.user[0].branch_id) && (data.status_flag == 1) && (data.senderId == 'whatsapp') && $cookies.get('admin') == 'admin') {
        campaignevent.push({ 'campaignID': data.campaignID, 'campaignName': data.campaignName, 'createdOn': new Date(data.createdOn) })
      }
    })
    vm.row_index = campaignevent.reverse() //finished campagin box data
    //get number of customers sent per campaign
    $scope.getCustomerCount = function (cam) {
      $scope.campaignStatus = campaigndetailss.filter(function (campaigndetails) {
        return [cam].some(function (campaign) {
          return campaigndetails.campaignID == campaign.campaignID
        })
      })
      //get how much of sms delivered
      $scope.DeliveredCount = [];
      $scope.campaignStatus.filter(function (item) {
        if (item.status == 'DELIVERED')
          $scope.DeliveredCount.push(item)
      })
    };
    $scope.purchaseorder_query = {
      filter: '',
      limit: '10',
      order: 'customername',
      page: 1,
      branch_id: $rootScope.user[0].branch_id
    };
    //clear text function  while search
    $scope.clearText = function () {
      $scope.purchaseorder_query.filter = '';
    }
    //pass campaign id when click particular campaign box
    $scope.campaignfilter = function (id) {
      $state.go('app.whatsappcampaignanalytics', { id: id.campaignID })
    };

    // Delete the campaign changing status flag
    $scope.removeRow = function (campaign, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this campaign?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        api.deleteCampaign.getID.delete({ campaignID: campaign.campaignID },
          function (response) {
            //success callback
            deleteItem(campaign);
          },
          function (response) {
            // error callback
          }
        );

      }, function () {
        // Canceled
      });


      /**
       * Delete Item
       */
      function deleteItem(campaign) {
        vm.campaign_datas.splice(vm.campaign_datas.indexOf(campaign), 1); //here all lists of clicked index deleted
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }

    }
    /*
    -----------------------------------
    
    Particular Campaign
    
    -----------------------------------
    */

    //if url contains id this condition will be worked
    if ($scope.params.id) {
      //filter clicked campaign table data which is local stored data
      $scope.campaigndata = campaignn.filter(function (campaign) {
        if (campaign.campaignID == $scope.params.id)
          return campaign
      })
      // vm.imgUrls = $scope.campaigndata[0].authKey.split(',');
      //Image manipulation
      if (typeof $scope.campaigndata[0].Images === 'string') {
        try {
          $scope.campaigndata[0].Images = JSON.parse($scope.campaigndata[0].Images);
        } catch (e) {
          console.error('Image parsing failed:', e);
          $scope.campaigndata[0].Images = [];
        }
      }


      $scope.CampaignCreated = new Date($scope.campaigndata[0].createdOn); //format created time as from string to date
      //filter clicked campaign details table data
      var campaignfilters = campaigndetailss.filter(function (campaigndetails) {
        return [$scope.params.id].some(function (paramsId) {
          return campaigndetails.campaignID == paramsId
        })
      })
      //get campaign data with id for get last sync time in database
      api.getcampaign.getID.get({ campaignID: $scope.params.id },
        function (response) {
          // Empty data not allowed
          if (response[0].lastsync != null) {
            $scope.dblastSync = new Date(response[0].lastsync);
          }
        })
      //counts for get message status
      $scope.DELIVERED = [];
      $scope.FAILED = [];
      $scope.Submitted = [];
      campaignfilters.map(function (item) {
        if (item.status == 'DELIVERED') {
          $scope.DELIVERED.push(item)
        }
        if (item.status == 'SUBMITTED') {
          $scope.Submitted.push(item)
        }
        if (item.status == 'FAILED') {
          $scope.FAILED.push(item)
        }
      })
      //calculate total number of customers per campaign
      $scope.total = $scope.DELIVERED.length + $scope.FAILED.length + $scope.Submitted.length
      //get list of customers data in array for md-table
      var array = [];
      // Get customer full data of that particular campaign
      campaignfilters.forEach(function (item) {
        api.customer_infodiet.getID.get({ salesorder_id: item.customerID },
          function (response) {
            array.push({ 'customerMobile': response[0].customer_mobile, 'deliverydate': item.deliverydate == null ? '' : new Date(item.deliverydate), 'customercity': response[0].customer_city, 'customerlocality': response[0].customer_locality, 'customername': response[0].customer_name, status: item.status })
          })
      })
      vm.getpurchase = array //assign filtered customers such who all are in that campaign
      $scope.purchaseorder_count = campaignfilters.length; //Length count for pagination of md-table
    }
    //function for Breadcrumb Label with idnewBill
    $rootScope.getBreadcrumbLabel = function () {
      if ($scope.params.id) {
        var campaignname = campaignn.filter(function (o1) {
          if (o1.campaignID == $scope.params.id)
            return o1
        })
        return campaignname[0].campaignName
      } else if (!$scope.params.id) {
        return "Campaign-list"
      }
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('addwhatsappcampaign', ['ngFileUpload'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $breadcrumbProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State

    $breadcrumbProvider.setOptions({
    });
    $stateProvider

      .state('app.addwhatsappcampaign', {
        url: '/addwhatsappcampaign/',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/campaign/whatsappnewcampaign/whatsappnewcampaign.html',
            controller: 'NewWhatsappCampaignController as vm'
          }

        },
        ncyBreadcrumb: {
          label: "New Campaign"
        },
        resolve: {
          branch: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('addwhatsappcampaign')
    .controller('NewWhatsappCampaignController', NewWhatsappCampaignController);


  /** @ngInject */
  function NewWhatsappCampaignController($scope, $http, $cookies, $state, $filter, dietType, locality, branch, $timeout, $location, msNavigationService, Upload, $rootScope, customer_details, $mdDialog, $mdToast, api) {
    // Data
    //----------------
    var vm = this;
    vm.settings = dietType.settings; //corporate_settings which is came from general json
    vm.whatsapp = dietType.whatsapp;
    //service for get staff data with id for showing ex: hi staff name
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function (response) {
        $scope.staff_name = response[0].name;
      })

    $scope.load = false;
    var wa_acceptCookie = $cookies.get('wa_accept');
    if(wa_acceptCookie == 'yes') {
      $scope.agreeContinueContidion = false;
    } else {
      $scope.agreeContinueContidion = true;
    }
    $scope.stepsModel = [];
    // for multiple files:
    $scope.uploadFiles = function (files, errFiles) {
      vm.file = files;
      //var files = event.target.files; //FileList object         
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var reader = new FileReader();
        reader.onload = $scope.imageIsLoaded;
        reader.readAsDataURL(file);
      }
    }
    $scope.agreeContinue = function (agreeCheked) {
      if(agreeCheked == "yes") {
        $cookies.put('wa_accept', 'yes');
      }
      $scope.agreeContinueContidion = false;
    }
    $scope.imageIsLoaded = function (e) {
      $scope.$apply(function () {
        $scope.stepsModel.push(e.target.result);
      });
    };
    // Checking user permissions
    $scope.whatsapppermission = [];
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format which is taken by cookies
    for (var i = 0; i < permissions.length; i++) {
      if (permissions[i] == 53) {
        $scope.whatsapppermission.push("data");
      }
    };
    // checking branch permissions
    $scope.whatsappbranchpermission = [];
    var branchpermissions = JSON.parse("[" + branch[0].permissions + "]"); //covert as array format which is taken by cookies
    for (var i = 0; i < branchpermissions.length; i++) {
      if (branchpermissions[i] == 53) {
        $scope.whatsappbranchpermission.push("data");
      }
    };
    if ($scope.whatsapppermission.length > 0 && $scope.whatsappbranchpermission.length > 0) {
      $scope.whatsapppermission = true // if true means permission will be applied
    };

    $scope.$watch('vm.selected.length', function (value) {
      var limit = vm.whatsapp.limit;
      if (value > limit) {
        alert('Please select only ' + limit + ' customers.');
        vm.selected = [];
      }
    });



    var whatsapp_settings = []
    api.branch_data.getID.get({ branch_id: $rootScope.user[0].branch_id }, function (responses) {
      whatsapp_settings.push({
        "wa_api": responses[0].wa_api,
        "wa_total_count": responses[0].wa_total_count,
        "wa_delivered_count": responses[0].wa_delivered_count,
        "wa_expiry_date": responses[0].wa_expiry_date
      });
      // Now do everything after data is available
      $scope.expiryDate = new Date(whatsapp_settings[0].wa_expiry_date);
      $scope.formattedExpiryDate = moment(responses[0].wa_expiry_date).format("DD-MM-YYYY");
      var today = new Date();
      var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);      
      $scope.balanceCount = parseInt(whatsapp_settings[0].wa_total_count || 0) - parseInt(whatsapp_settings[0].wa_delivered_count || 0);
      //$scope.balanceCount = 0;
      var balanceZero = $scope.balanceCount <= 0;
      var expired = $scope.expiryDate < yesterday;
      if (balanceZero || expired) {
        $scope.expiryService = true;
      } else {
        $scope.expiryService = false;
      }
    });

    // DATA
    //----------------
    //assign interconnection true or false
    $scope.internetconnection = $rootScope.online;
    //step form ng-model value initially have empty
    vm.horizontalStepper = {
      step1: {},
      step2: {},
      step3: {},
      step4: {},
      step5: {}
    };
    // $scope.value = new Date(0, 0, 1, 14, 57); //date for assign today

    //get interconnection using watch function from toolbar controller
    $scope.$on("internetChecking", function (event, internetconnection) {
      if (internetconnection === false) {
        $mdToast.show({
          template: '<md-toast class="error"><span flex>You are in offline</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        $('#forms').find("button[type='submit']").prop('disabled', true); //disable submit button while internet is offline
      }
    })

    function submitHorizontalStepper(event) {
      // Show the model data in a dialog
      vm.showDataDialog(event, vm.horizontalStepper);

      // Reset the form model
      vm.horizontalStepper = {
        step1: {},
        step2: {},
        step3: {},
        step4: {},
        step5: {}
      };
    }

    //clear search text while search
    $scope.clearText = function () {
      $scope.purchaseorder_query.filter = '';
    };
    //remove and upload new receipt it happens in front end
    $scope.removeupload = function (index) {
      vm.file.splice(index, 1);
      $scope.stepsModel.splice(index, 1);
    }

    //condition for internet is online for getting msg count from thirty party
    if ($rootScope.online) {
      /* api.getmsgPromotional.getID.get({ branch_id: $rootScope.user[0].branch_id },
         function (response) {
           var filterbranch = branch.filter(function (item) {
             if (item.branch_id == $rootScope.user[0].branch_id) {
               return item
             }
           })
           $scope.promotional = filterbranch[0].promotionalCount; //get promotional count from live
           $scope.transcational = filterbranch[0].transcationalCount; //get transcational count from live
 
         }) */
    }
    //get locality in branch wise
    var localityy = locality.filter(function (locality) {
      if (locality.branch_id == $rootScope.user[0].branch_id) {
        return locality
      }
    })
    //map filtered localities for our convenient
    var localities = localityy.map(function (locality) {
      return { 'localityID': locality.localityID, 'localityName': locality.localityName }
    })
    vm.locality = localities //assign localities to dropdown
    var localityArray = [] //get locality id for location filter

    //get all locality id's
    localities.map(function (localityID) {
      localityArray.push(localityID.localityID)
    })
    $scope.localityy = localityArray //get all locality id's and apply for default init select all localities in dropdown

    vm.lastvisits = [
      { 'visitid': '', 'visits': 'All' },
      { 'visitid': 'one', 'visits': 'One time visits' },
      { 'visitid': '3MA', 'visits': 'Last 3 months visits' },
      { 'visitid': '3MNA', 'visits': 'Last 3 months not visits' },
      { 'visitid': '6MA', 'visits': 'Last 6 months visits' },
      { 'visitid': '6MNA', 'visits': 'Last 6months not visits' }
    ];

    $scope.myDate = new Date(); //apply new date for select date
    //syntax for apply time and restrict this time(9am) to this time(9pm)
    $scope.myDates = new Date(1970, 0, 1, $scope.myDate.getHours(), $scope.myDate.getMinutes(), 0);

    //retrict date backward from md picker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict 30 next day move on forward from md picker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() + 30
    );

    //get from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');

    //query for get customer details
    $scope.purchaseorder_query = {
      filter: '',
      limit: vm.whatsapp.limit,
      order: 'ordertime',
      nameorder: 'customer_name',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };

   //$scope.selected = [] //Pushed selected Customer to this array
   // --- Selection setup (NEW) ---
    vm.selected = []; // selected customers (array of objects)

    // unique id accessor - change if your key is different
    vm.idFor = function (c) {
      return c && (c.customer_id || c.id || c.customer_mobile);
    };

    // Check if single row is selected
    vm.isSelected = function (customer) {
      var id = vm.idFor(customer);
      return vm.selected.some(function (s) { return vm.idFor(s) === id; });
    };

    // Toggle a single row selection. stopPropagation so the row click doesn't interfere
    vm.toggleSelection = function (customer, $event) {
      if ($event) $event.stopPropagation();
      var id = vm.idFor(customer);
      var idx = vm.selected.findIndex(function (s) { return vm.idFor(s) === id; });
      if (idx === -1) {
        vm.selected.push(customer);
      } else {
        vm.selected.splice(idx, 1);
      }
    };

    // Row click (kept empty; if you want row click to toggle selection call toggleSelection here)
    vm.rowClicked = function (customer, $event) {
      // For now, do nothing (or open details). If you want row click to select:
      // vm.toggleSelection(customer);
    };

    // Compute visible rows using same filter/order/limit logic as your table
    vm.getVisibleRows = function () {
      // apply filter
      var filtered = $filter('filter')(vm.getpurchase || [], $scope.purchaseorder_query ? $scope.purchaseorder_query.filter : '');
      // apply orderBy (note: original used reverse elsewhere; we replicate the view order here)
      var ordered = $filter('orderBy')(filtered, $scope.purchaseorder_query ? $scope.purchaseorder_query.order : undefined, true);
      // apply pagination limitTo
      var limit = ($scope.purchaseorder_query && $scope.purchaseorder_query.limit) ? $scope.purchaseorder_query.limit : ordered.length;
      var page = ($scope.purchaseorder_query && $scope.purchaseorder_query.page) ? $scope.purchaseorder_query.page : 1;
      var start = (page - 1) * limit;
      return $filter('limitTo')(ordered, limit, start);
    };

    // Are all visible rows selected?
    vm.isAllVisibleSelected = function () {
      var visible = vm.getVisibleRows();
      if (!visible || visible.length === 0) return false;
      return visible.every(function (row) { return vm.isSelected(row); });
    };

    // Toggle select/unselect all visible rows
    vm.toggleAllVisible = function ($event) {
      if ($event) $event.stopPropagation();
      var visible = vm.getVisibleRows();
      if (!visible || visible.length === 0) return;

      if (vm.isAllVisibleSelected()) {
        // remove visible rows from selection
        visible.forEach(function (row) {
          var id = vm.idFor(row);
          var idx = vm.selected.findIndex(function (s) { return vm.idFor(s) === id; });
          if (idx !== -1) vm.selected.splice(idx, 1);
        });
      } else {
        // add visible rows if not already selected
        visible.forEach(function (row) {
          if (!vm.isSelected(row)) vm.selected.push(row);
        });
      }
    };

    //success function customer list from the server
    function getCustomerList(desserts) {
      var customerwhatsappuser = []
      for (var i = 0; i < desserts[0].results.length; i++) {
        if (desserts[0].results[i].whatsapp == 1) {
          customerwhatsappuser.push(desserts[0].results[i]);
        }
      };

      //collect counts from server
      $scope.deliveryLength = customerwhatsappuser;
      vm.getpurchase = customerwhatsappuser.reverse()
      vm.full_customer = customerwhatsappuser.reverse();
      $scope.purchaseorder_count = customerwhatsappuser.reverse().length
    }

    //service for customer list
    $scope.customPagination = function () {
      $scope.reload = function () {
        $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, getCustomerList).$promise;
        /*$timeout(function() {
          $scope.reload();
        }, 500000); */
      };
      $scope.reload();
    };

    //locality change function
    $scope.customer_change = function (locality, lastvisit) {
      customer_filter_success(locality, lastvisit)
    }
    $scope.customer_change(); //default page load function will run

    function customer_filter_success(localitys, lastvisit) {
      //this condition if page loading default loaded all localities of customers
      if ((localitys == undefined || localitys == '') && (lastvisit == undefined || lastvisit == '')) {
        $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, getCustomerList).$promise;
      }
      //If user change locality or last visit dropdown this condition will apply
      else if (localitys != '' || lastvisit != '') {
        var filterdata = []
        //Here localitys is LOCATION ID
        //angular foreach is for whenever  locality is checked in dropdown,that each locality of customers will be filtered
        angular.forEach(localitys, function (locality, key) {
          //Here locality is LOCATION ID
          var onetime = []; //here onetime visited customers will be filtered
          vm.full_customer.filter(function (filteredCustomers) {
            //WHEN dropdown selected for all localities and staff changed 'one time' lastvisits this condition will be entered
            //condition for check if the 'all locality' checked in dropdown && get all 'one time' customers && if the lastvisit dropdown is selected 'one time'
            //so here filtered all localities of one time customers
            if (locality == '' && filteredCustomers.total_visit == 1 && lastvisit == 'one') {
              onetime.push(filteredCustomers) //pushed all localities of one time customers pushed
            }
            //WHEN dropdown selected for all localities and staff change only lastvisits this condition will be entered but except one time
            //condition for if the 'all locality' checked && when lastvisit dropdowm is 'not' checked one time
            else if (locality == '' && lastvisit != 'one') {
              //Here meaning of lastvisit by the days
              if (lastvisit == '6MA') {
                // last customer visit 180 days
                var lastday = 180
              } else if (lastvisit == '6MNA') {
                // last customer not visit 180 days
                var lastday = 180
              } else if (lastvisit == '3MA') {
                // last customer visit 90 days
                var lastday = 90
              } else if (lastvisit == '3MNA') {
                // last customer not visit 90 days
                var lastday = 90
              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); // get  difference of customers orderdate to compare this date of all customers
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered

              //compare all customers last ordered difference days and clicked lastvisit days
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then last 3 months or last 6 months visited customers will be pushed
              if (days <= lastday && (lastvisit == '6MA' || lastvisit == '3MA')) {
                onetime.push(filteredCustomers)
              }
              //if compare all customers last ordered days is greater than or equal to  clicked lastvisit days Then last 3 months or last 6 months not visited  customers will be pushed
              if (days > lastday && (lastvisit == '6MNA' || lastvisit == '3MNA')) {
                onetime.push(filteredCustomers)
              }

            }
          })
          vm.full_customer.filter(function (filteredCustomers) {
            //condition for check if the 'particular localities' checked in dropdown && get all 'one time' customers && if the lastvisit dropdown is selected 'one time'
            //so staff clicked last 6 months visited || last 6 months not visited for particular localities
            if (filteredCustomers.localityID == locality && filteredCustomers.total_visit == 1 && lastvisit == 'one') {
              if (lastvisit == '6MA') {
                var lastday = 180
              } else if (lastvisit == '6MNA') {

              } else if (lastvisit == 'one') {
                // var lastday=1
              } else if (lastvisit == '3MA') {
                var lastday = 90
              } else if (lastvisit == '3MNA') {

              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); //so get all differences of how many days back they last ordered
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered
              var lastfinal = lastday == undefined ? days : lastday //here if last visit is checked ALL in dropdown then all locality of customers will be filtered otherwise particular clicked localities of customers will be filtered
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months not visited customers will be pushed
              if (days <= lastfinal && lastvisit != '3MNA') {
                filterdata.push(filteredCustomers)
              }
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months not visited customers will be pushed
              if (days > lastfinal && lastvisit == '3MNA') {
                filterdata.push(filteredCustomers)
              }
            }
            //condition for check if the 'particular localities' checked in dropdown && except all 'one time' customers && except all '3 months not visited' customers 
            //so staff clicked last 6 months visited || last 6 months not visited for particular localities
            else if (filteredCustomers.localityID == locality && lastvisit != 'one' && lastvisit != '3MNA') {
              if (lastvisit == '6MA') {
                var lastday = 180
              } else if (lastvisit == '6MNA') {
                var lastday = 180
              } else if (lastvisit == 'one') {
                var lastday = 1
              } else if (lastvisit == '3MA') {
                var lastday = 90
              } else if (lastvisit == '3MNA') {
                var lastday = 90
              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); //so get all differences of how many days back they last ordered
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered
              var lastfinal = lastday == undefined ? days : lastday //here if last visit is checked ALL in dropdown then all locality of customers will be filtered otherwise particular clicked localities of customers will be filtered
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  6 months not visited customers will be pushed
              if (days <= lastfinal && lastvisit != '6MNA') {
                filterdata.push(filteredCustomers)
              }
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  6 months  visited customers will be pushed
              if (days > lastfinal && lastvisit == '6MNA') {
                filterdata.push(filteredCustomers)
              }
            }
            //so staff clicked last 3 months visited || last 3 months not visited for particular localities
            else if (filteredCustomers.localityID == locality && lastvisit != 'one' && lastvisit != '6MNA') {
              if (lastvisit == '6MA') {
                var lastday = 180
              } else if (lastvisit == '6MNA') {
                var lastday = 180
              } else if (lastvisit == 'one') {
                var lastday = 1
              } else if (lastvisit == '3MA') {
                var lastday = 90
              } else if (lastvisit == '3MNA') {
                var lastday = 90
              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); // ms of difference
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered
              var lastfinal = lastday == undefined ? days : lastday //here if last visit is checked ALL in dropdown then all locality of customers will be filtered otherwise particular clicked localities of customers will be filtered
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months not visited customers will be pushed
              if (days <= lastfinal && lastvisit != '3MNA') {
                filterdata.push(filteredCustomers)
              }
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months  visited customers will be pushed
              if (days > lastfinal && lastvisit == '3MNA') {
                filterdata.push(filteredCustomers)
              }
            }
          })
          //this is for one time visit customers or not at least one time visit customers
          if (locality == '') {
            vm.getpurchase = onetime //here apply to table of filtered customers
          }
          //this is when customer visit of particular period like last 3 month
          else {
            vm.getpurchase = filterdata; //here apply to table of filtered customers
          }
        })
      }
    }
    //search query filter
    $scope.$watch('purchaseorder_query.filter', function (newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.customPagination();
    });

    // horizontal ng-model name 
    vm.horizontalStepper = {
      step1: {}
    };
    // Data
    vm.horizontalStepper = {};
    // Methods
    vm.submitHorizontalStepper = submitHorizontalStepper;
    vm.showbrowserWA = true; // browser open checking here.

    //function for submit
    function submitHorizontalStepper(event) {

      /*  $http.get('server/session.json').then(function(data) {
          QRsuccessConditon();
        }, function (data) {
          QRscanConditon()      
        });
  */
      QRsuccessConditon();
      function QRsuccessConditon() {
        //console.log(browserOpen);
        // var browsershow = browserOpen;
        var confirm = $mdDialog.confirm()
          .title('Confirm')
          .htmlContent('Ensure that your mobile and your PC is always connected to the internet during sending.')
          .ariaLabel('delete Tax')
          .targetEvent(event)
          .ok('OK')
          .cancel('CANCEL');
        $mdDialog.show(confirm).then(function () {
          // if confirm success
          $scope.load = true;
          var file = vm.file;
        /*  if (file) {
            var i;
            $scope.filedbname = [];
            for (i = 0; i < vm.file.length; i++) {
              Upload.upload({
                url: 'http://localhost:1100/whatsappnewimgupload', //webAPI exposed to upload the file
                data: { file: file[i] } //pass file as data, should be user ng-model

              }).then(function (resp) {
                $scope.filedbname.push("../assets/uploads/whatsapp/" + resp.data);
              });
            };

          }; */

          if (vm.file && vm.file.length > 0) {
            var formData = new FormData();
            for (var i = 0; i < vm.file.length; i++) {
              formData.append('images', vm.file[i]); // 'images' must match backend
            }
            $http.post('http://localhost:1100/api/whatsappnewimgupload', formData, {
              headers: { 'Content-Type': undefined },
              transformRequest: angular.identity
            }).then(function (resp) {
              $scope.filedbname = resp.data.imageUrls;
              whatsappImgServe($scope.filedbname); // 👈 Run this AFTER upload completes
            }).catch(function (err) {
              console.error('Upload failed', err);
              whatsappImgServe(); // 👈 Even if upload fails, proceed
            });
          } else {
            whatsappImgServe();
          }
        
          //upload image to folder and database





        }, function () {
          // cancelled
        });
      }
      function whatsappImgServe(filedbname) {
        var WAAPIKEY = whatsapp_settings[0].wa_api;
        if (filedbname) {
          var imagePath = filedbname;
        } else {
          var imagePath = '';
        }
        // campaign full data to local database
        var campaign_data = [vm.horizontalStepper.step1].map(function (data) {
          // Getting branch data for sender id auth key
          var filterbranch = branch.filter(function (branch) {
            if (branch.branch_id == $rootScope.user[0].branch_id) {
              return branch
            }
          })
          return { 'campaignName': data.campaignName, 'message': data.message, 'msgroute': '', 'campaignDate': '', 'campaignTime': '', 'Images':imagePath, 'senderId': 'whatsapp', 'userId': '', 'WAAPIKEY': WAAPIKEY, 'status_flag': 1, 'staffID': $rootScope.user[0].staffID, 'branch_id': $rootScope.user[0].branch_id }
        });
        // campaing details customers data
        var msgdetails = [];
        vm.selected.map(function (no) {
          msgdetails.push({ 'customer_mobile': no.customer_mobile, 'customer_id': no.customer_id, 'message': campaign_data[0].message + vm.whatsapp.stopMessage })
        });

        var fulldata = {
          'campaingdetails': campaign_data,
          'messagedetails': msgdetails,
          // 'browsershow': browsershow
        };

        api.whatsappcampaign.getAll.save(fulldata,
          function (response) {
            $scope.load = false;
            if (response[0] == '0') {
              $mdToast.show({
                template: '<md-toast class="error"><span flex>Authenication Failed. Submit Again and please Scan Qr Code again in whatsapp web.</span></md-toast>',
                position: 'bottom right',
                hideDelay: 30000,
                action: "close"
              });
            }
            if (response[0] == '2') {
              $mdToast.show({
                template: '<md-toast class="success"><span flex>Message sent successfully</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });
              // $state.go("app.addwhatsappcampaign", {}, { reload: "app.addwhatsappcampaign" });
              vm.horizontalStepper = '';
            }
            if (response[0] == '3') {
              $mdToast.show({
                template: '<md-toast class="success"><span flex>Message sent successfully and Failed some message</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });
              //$state.go("app.addwhatsappcampaign", {}, { reload: "app.addwhatsappcampaign" });
              vm.horizontalStepper = '';
            }
            if (response[0] == '4') {
              $mdToast.show({
                template: '<md-toast class="error"><span flex>Message sent not successfully pls try again</span></md-toast>',
                position: 'bottom right',
                hideDelay: 30000,
                action: "close"
              });
            }
            if (response[0] == '7') {
              //QRsuccessConditon(false);        
              QRscanConditon();

            }

          });
       }


    }
    // submit finished

  }

})();

(function() {
  'use strict';

  angular
    .module('finishedcampaign', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.Campaign-list', {
        url: '/Campaign-list',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/campaign/finishedcampaign/finishedcampaign.html',
            controller: 'finishedCampaignController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Campaign-list'
        },
        resolve: {

          campaignn: function(apiResolver) {
            return apiResolver.resolve('campaignn.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          campaigndetailss: function(apiResolver) {
            return apiResolver.resolve('campaigndetailss.getAll@get');
          },

        }
      })
      .state('app.campaignanalytics', {
        url: '/Campaign-list/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/campaign/finishedcampaign/campaign-analytics/campaign-analytics.html',
            controller: 'finishedCampaignController as vm'
          }
        },
        resolve: {

          campaignn: function(apiResolver) {
            return apiResolver.resolve('campaignn.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          campaigndetailss: function(apiResolver) {
            return apiResolver.resolve('campaigndetailss.getAll@get');
          },
        },

        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id) {
              return 'app.Campaign-list';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"
          //  label: '{{ "BILLINGS.CUSTOMERS" | translate }}'
        }
      });


    // Translation

  }
})();

(function() {
  'use strict';

  angular
    .module('finishedcampaign')
    .controller('finishedCampaignController', finishedCampaignController);


  /** @ngInject */
  function finishedCampaignController(customer_details, $mdDialog, $mdToast, $filter, dietType, $state, $stateParams, api, $cookies, $rootScope, $scope, campaigndetailss, campaignn) {
    var vm = this;
    //get staff data with id
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })

    //request to server if he have a permission of marketing
    var marketingPermission = []
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from cookies data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 52) || permissions[i] == 52) {
        marketingPermission.push("data");
      }
    }
    $scope.params = $stateParams;
    //send data to serve if internet is online
    if ($rootScope.online == true && marketingPermission.length == 1) {
      // Service will happen when campaign list page load and particular campaing also
      // This service for update delivery report and update last sync for particular campaign id
      api.getcampaignlist.getID.get({ campaignID: !$scope.params.id ? 0 : $scope.params.id, host: dietType.SmsStatusReceive[0].host, path: dietType.SmsStatusReceive[0].urlpath },
        function(response) {
          $scope.lastSync = response[0].synctime;
          if (response[0].msgreports) {
            //here only pending data of msg reports filterd from live db 
            //purpose for update local database of campaign details table
            var serverResponse = response[0].msgreports.filter(function(liveMsgStatus) {
              return campaigndetailss.some(function(localMsgStatus) {
                return liveMsgStatus.request_id == localMsgStatus.requestID && localMsgStatus.status == 'SUBMITTED'
              })
            })
          }
          //update data to campaign details table if data came from server for pending report
          api.updatecampaignlist.getID.update({ campaignID: 2 }, serverResponse,
            function(response) {

            })
        })
    };
    //get finished campaign data with only status flag 1
    var campaignevent = []
    campaignn.map(function(data) {
      // Get data for user
      if ((data.staffID == $rootScope.user[0].staffID) && (data.branch_id == $rootScope.user[0].branch_id) && (data.status_flag == 1) && (data.senderId != 'whatsapp') && $cookies.get('admin') != 'admin') {
        campaignevent.push({ 'campaignID': data.campaignID, 'campaignName': data.campaignName, 'createdOn': new Date(data.createdOn) })
      }
      // Get data for admin
      else if ((data.branch_id == $rootScope.user[0].branch_id) && (data.status_flag == 1) && (data.senderId != 'whatsapp') &&  $cookies.get('admin') == 'admin') {
        campaignevent.push({ 'campaignID': data.campaignID, 'campaignName': data.campaignName, 'createdOn': new Date(data.createdOn) })
      }
    })
    vm.row_index = campaignevent.reverse() //finished campagin box data
    //get number of customers sent per campaign
    $scope.getCustomerCount = function(cam) {
      $scope.campaignStatus = campaigndetailss.filter(function(campaigndetails) {
        return [cam].some(function(campaign) {
          return campaigndetails.campaignID == campaign.campaignID
        })
      })
      //get how much of sms delivered
      $scope.DeliveredCount = [];
      $scope.campaignStatus.filter(function(item) {
        if (item.status == 'DELIVERED')
          $scope.DeliveredCount.push(item)
      })
    };
    $scope.purchaseorder_query = {
      filter: '',
      limit: '10',
      order: 'customername',
      page: 1,
      branch_id: $rootScope.user[0].branch_id
    };
    //clear text function  while search
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }
    //pass campaign id when click particular campaign box
    $scope.campaignfilter = function(id) {
      $state.go('app.campaignanalytics', { id: id.campaignID })
    };

    // Delete the campaign changing status flag
    $scope.removeRow = function(campaign, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this campaign?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.deleteCampaign.getID.delete({ campaignID: campaign.campaignID },
          function(response) {
            //success callback
            deleteItem(campaign);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });


      /**
       * Delete Item
       */
      function deleteItem(campaign) {
        vm.row_index.splice(vm.row_index.indexOf(campaign), 1); //here all lists of clicked index deleted
        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }

    }
/*
-----------------------------------

Particular Campaign

-----------------------------------
*/

    //if url contains id this condition will be worked
    if ($scope.params.id) {
      //filter clicked campaign table data which is local stored data
      $scope.campaigndata = campaignn.filter(function(campaign) {
        if (campaign.campaignID == $scope.params.id)
          return campaign
      })
      $scope.CampaignCreated = new Date($scope.campaigndata[0].createdOn); //format created time as from string to date
      //filter clicked campaign details table data
      var campaignfilters = campaigndetailss.filter(function(campaigndetails) {
        return [$scope.params.id].some(function(paramsId) {
          return campaigndetails.campaignID == paramsId
        })
      })
      //get campaign data with id for get last sync time in database
      api.getcampaign.getID.get({ campaignID: $scope.params.id },
        function(response) {
          // Empty data not allowed
          if (response[0].lastsync != null) {
            $scope.dblastSync = new Date(response[0].lastsync);
          }
        })
      //counts for get message status
      $scope.DELIVERED = [];
      $scope.FAILED = [];
      $scope.Submitted = [];
      campaignfilters.map(function(item) {
        if (item.status == 'DELIVERED') {
          $scope.DELIVERED.push(item)
        }
        if (item.status == 'SUBMITTED') {
          $scope.Submitted.push(item)
        }
        if (item.status == 'FAILED') {
          $scope.FAILED.push(item)
        }
      })
      //calculate total number of customers per campaign
      $scope.total = $scope.DELIVERED.length + $scope.FAILED.length + $scope.Submitted.length
      //get list of customers data in array for md-table
      var array = [];
      // Get customer full data of that particular campaign
      campaignfilters.forEach(function(item) {
        api.customer_infodiet.getID.get({ salesorder_id: item.customerID },
          function(response) {
            array.push({ 'customerMobile': response[0].customer_mobile, 'deliverydate': item.deliverydate == null ? '' : new Date(item.deliverydate), 'customercity': response[0].customer_city, 'customerlocality': response[0].customer_locality, 'customername': response[0].customer_name, status: item.status })
          })
      })
      vm.getpurchase = array //assign filtered customers such who all are in that campaign
      $scope.purchaseorder_count = campaignfilters.length; //Length count for pagination of md-table
    }
    //function for Breadcrumb Label with idnewBill
    $rootScope.getBreadcrumbLabel = function() {
      if ($scope.params.id) {
        var campaignname = campaignn.filter(function(o1) {
          if (o1.campaignID == $scope.params.id)
            return o1
        })
        return campaignname[0].campaignName
      } else if (!$scope.params.id) {
        return "Campaign-list"
      }
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('addcampaign', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $breadcrumbProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State

    $breadcrumbProvider.setOptions({
    });
    $stateProvider

      .state('app.newCampaign', {
        url: '/addcampaign/',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/campaign/newcampaign/campaign.html',
            controller: 'NewCampaignController as vm'
          }

        },
        ncyBreadcrumb: {
          label: "New Campaign"
        },
        resolve: {
          branch: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('addcampaign')
    .controller('NewCampaignController', NewCampaignController);


  /** @ngInject */
  function NewCampaignController($scope, $cookies, $state, $filter, dietType, locality, branch, $timeout, $location, msNavigationService, $rootScope, customer_details, $mdDialog, $mdToast, api) {
    // Data
    //----------------

    var vm = this;
    vm.settings = dietType.settings; //corporate_settings which is came from general json
    //service for get staff data with id for showing ex: hi staff name
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })

    //while staff typing message then the message count here calculated
    $scope.msgcount = function(msglength) {
      if (msglength > 0 && msglength < 161) {
        return 1
      } else if (msglength > 160 && msglength < 307) {
        return 2
      } else if (msglength > 306 && msglength < 460) {
        return 3
      } else if (msglength == 0) {
        return 0
      }
    }
    // DATA
    //----------------
    //assign interconnection true or false
    $scope.internetconnection = $rootScope.online;
    //step form ng-model value initially have empty
    vm.horizontalStepper = {
      step1: {},
      step2: {},
      step3: {},
      step4: {},
      step5: {}
    };
    // $scope.value = new Date(0, 0, 1, 14, 57); //date for assign today


    //get interconnection using watch function from toolbar controller
    $scope.$on("internetChecking", function(event, internetconnection) {
      if (internetconnection === false) {
        $mdToast.show({
          template: '<md-toast class="error"><span flex>You are in offline</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        $('#forms').find("button[type='submit']").prop('disabled', true); //disable submit button while internet is offline
      }
    })

    function submitHorizontalStepper(event) {
      // Show the model data in a dialog
      vm.showDataDialog(event, vm.horizontalStepper);

      // Reset the form model
      vm.horizontalStepper = {
        step1: {},
        step2: {},
        step3: {},
        step4: {},
        step5: {}
      };
    }

    //clear search text while search
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }

    //condition for internet is online for getting msg count from thirty party
    if ($rootScope.online) {
      api.getmsgPromotional.getID.get({ branch_id: $rootScope.user[0].branch_id },
        function(response) {
          var filterbranch = branch.filter(function(item) {
            if (item.branch_id == $rootScope.user[0].branch_id) {
              return item
            }
          })
          $scope.promotional = filterbranch[0].promotionalCount; //get promotional count from live
          $scope.transcational = filterbranch[0].transcationalCount; //get transcational count from live

        })
    }
    //get locality in branch wise
    var localityy = locality.filter(function(locality) {
      if (locality.branch_id == $rootScope.user[0].branch_id) {
        return locality
      }
    })
    //map filtered localities for our convenient
    var localities = localityy.map(function(locality) {
      return { 'localityID': locality.localityID, 'localityName': locality.localityName }
    })
    vm.locality = localities //assign localities to dropdown
    var localityArray = [] //get locality id for location filter

    //get all locality id's
    localities.map(function(localityID) {
      localityArray.push(localityID.localityID)
    })
    $scope.localityy = localityArray //get all locality id's and apply for default init select all localities in dropdown

    vm.lastvisits = [
      { 'visitid': '', 'visits': 'All' },
      { 'visitid': 'one', 'visits': 'One time visits' },
      { 'visitid': '3MA', 'visits': 'Last 3 months visits' },
      { 'visitid': '3MNA', 'visits': 'Last 3 months not visits' },
      { 'visitid': '6MA', 'visits': 'Last 6 months visits' },
      { 'visitid': '6MNA', 'visits': 'Last 6months not visits' }
    ];

    $scope.myDate = new Date(); //apply new date for select date
    //syntax for apply time and restrict this time(9am) to this time(9pm)
    $scope.myDates = new Date(1970, 0, 1, $scope.myDate.getHours(), $scope.myDate.getMinutes(), 0);

    //retrict date backward from md picker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict 30 next day move on forward from md picker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() + 30
    );

    //get from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');

    //query for get customer details
    $scope.purchaseorder_query = {
      filter: '',
      limit: '10',
      order: 'ordertime',
      nameorder: 'customer_name',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };

    $scope.selected = [] //Pushed selected Customer to this array

    //success function customer list from the server
    function getCustomerList(desserts) {
      //collect counts from server
      $scope.deliveryLength = desserts[0].results
      vm.getpurchase = desserts[0].results.reverse()
      vm.full_customer = desserts[0].results.reverse();
      $scope.purchaseorder_count = desserts[0].results.reverse().length
    }

    //service for customer list
    $scope.customPagination = function() {
      $scope.reload = function() {
        $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, getCustomerList).$promise;
        /*$timeout(function() {
          $scope.reload();
        }, 500000); */
      };
      $scope.reload();
    };

    //locality change function
    $scope.customer_change = function(locality, lastvisit) {
      customer_filter_success(locality, lastvisit)
    }
    $scope.customer_change(); //default page load function will run

    function customer_filter_success(localitys, lastvisit) {
      //this condition if page loading default loaded all localities of customers
      if ((localitys == undefined || localitys == '') && (lastvisit == undefined || lastvisit == '')) {
        $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, getCustomerList).$promise;
      }
      //If user change locality or last visit dropdown this condition will apply
      else if (localitys != '' || lastvisit != '') {
        var filterdata = []
        //Here localitys is LOCATION ID
        //angular foreach is for whenever  locality is checked in dropdown,that each locality of customers will be filtered
        angular.forEach(localitys, function(locality, key) {
          //Here locality is LOCATION ID
          var onetime = []; //here onetime visited customers will be filtered
          vm.full_customer.filter(function(filteredCustomers) {
            //WHEN dropdown selected for all localities and staff changed 'one time' lastvisits this condition will be entered
            //condition for check if the 'all locality' checked in dropdown && get all 'one time' customers && if the lastvisit dropdown is selected 'one time'
            //so here filtered all localities of one time customers
            if (locality == '' && filteredCustomers.total_visit == 1 && lastvisit == 'one') {
              onetime.push(filteredCustomers) //pushed all localities of one time customers pushed
            }
            //WHEN dropdown selected for all localities and staff change only lastvisits this condition will be entered but except one time
            //condition for if the 'all locality' checked && when lastvisit dropdowm is 'not' checked one time
            else if (locality == '' && lastvisit != 'one') {
              //Here meaning of lastvisit by the days
              if (lastvisit == '6MA') {
                // last customer visit 180 days
                var lastday = 180
              } else if (lastvisit == '6MNA') {
                // last customer not visit 180 days
                var lastday = 180
              } else if (lastvisit == '3MA') {
                // last customer visit 90 days
                var lastday = 90
              } else if (lastvisit == '3MNA') {
                // last customer not visit 90 days
                var lastday = 90
              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); // get  difference of customers orderdate to compare this date of all customers
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered

              //compare all customers last ordered difference days and clicked lastvisit days
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then last 3 months or last 6 months visited customers will be pushed
              if (days <= lastday && (lastvisit == '6MA' || lastvisit == '3MA')) {
                onetime.push(filteredCustomers)
              }
              //if compare all customers last ordered days is greater than or equal to  clicked lastvisit days Then last 3 months or last 6 months not visited  customers will be pushed
              if (days > lastday && (lastvisit == '6MNA' || lastvisit == '3MNA')) {
                onetime.push(filteredCustomers)
              }

            }
          })
          vm.full_customer.filter(function(filteredCustomers) {
            //condition for check if the 'particular localities' checked in dropdown && get all 'one time' customers && if the lastvisit dropdown is selected 'one time'
            //so staff clicked last 6 months visited || last 6 months not visited for particular localities
            if (filteredCustomers.localityID == locality && filteredCustomers.total_visit == 1 && lastvisit == 'one') {
              if (lastvisit == '6MA') {
                var lastday = 180
              } else if (lastvisit == '6MNA') {

              } else if (lastvisit == 'one') {
                // var lastday=1
              } else if (lastvisit == '3MA') {
                var lastday = 90
              } else if (lastvisit == '3MNA') {

              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); //so get all differences of how many days back they last ordered
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered
              var lastfinal = lastday == undefined ? days : lastday //here if last visit is checked ALL in dropdown then all locality of customers will be filtered otherwise particular clicked localities of customers will be filtered
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months not visited customers will be pushed
              if (days <= lastfinal && lastvisit != '3MNA') {
                filterdata.push(filteredCustomers)
              }
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months not visited customers will be pushed
              if (days > lastfinal && lastvisit == '3MNA') {
                filterdata.push(filteredCustomers)
              }
            }
            //condition for check if the 'particular localities' checked in dropdown && except all 'one time' customers && except all '3 months not visited' customers 
            //so staff clicked last 6 months visited || last 6 months not visited for particular localities
            else if (filteredCustomers.localityID == locality && lastvisit != 'one' && lastvisit != '3MNA') {
              if (lastvisit == '6MA') {
                var lastday = 180
              } else if (lastvisit == '6MNA') {
                var lastday = 180
              } else if (lastvisit == 'one') {
                var lastday = 1
              } else if (lastvisit == '3MA') {
                var lastday = 90
              } else if (lastvisit == '3MNA') {
                var lastday = 90
              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); //so get all differences of how many days back they last ordered
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered
              var lastfinal = lastday == undefined ? days : lastday //here if last visit is checked ALL in dropdown then all locality of customers will be filtered otherwise particular clicked localities of customers will be filtered
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  6 months not visited customers will be pushed
              if (days <= lastfinal && lastvisit != '6MNA') {
                filterdata.push(filteredCustomers)
              }
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  6 months  visited customers will be pushed
              if (days > lastfinal && lastvisit == '6MNA') {
                filterdata.push(filteredCustomers)
              }
            }
            //so staff clicked last 3 months visited || last 3 months not visited for particular localities
            else if (filteredCustomers.localityID == locality && lastvisit != 'one' && lastvisit != '6MNA') {
              if (lastvisit == '6MA') {
                var lastday = 180
              } else if (lastvisit == '6MNA') {
                var lastday = 180
              } else if (lastvisit == 'one') {
                var lastday = 1
              } else if (lastvisit == '3MA') {
                var lastday = 90
              } else if (lastvisit == '3MNA') {
                var lastday = 90
              }
              var currentTimes = new Date(); //store today date
              var endTimes = new Date(filteredCustomers.ordertime); //get all customers of orderedtimes
              var mss = (currentTimes - endTimes); // ms of difference
              var days = Math.round(mss / 86400000); //so get all differences of how many days back they last ordered
              var lastfinal = lastday == undefined ? days : lastday //here if last visit is checked ALL in dropdown then all locality of customers will be filtered otherwise particular clicked localities of customers will be filtered
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months not visited customers will be pushed
              if (days <= lastfinal && lastvisit != '3MNA') {
                filterdata.push(filteredCustomers)
              }
              //if compare all customers last ordered days is lesser than or equal to  clicked lastvisit days Then except  3 months  visited customers will be pushed
              if (days > lastfinal && lastvisit == '3MNA') {
                filterdata.push(filteredCustomers)
              }
            }
          })
          //this is for one time visit customers or not at least one time visit customers
          if (locality == '') {
            vm.getpurchase = onetime //here apply to table of filtered customers
          }
          //this is when customer visit of particular period like last 3 month
          else {
            vm.getpurchase = filterdata; //here apply to table of filtered customers
          }
        })
      }
    }
    //search query filter
    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.customPagination();
    });

    // horizontal ng-model name 
    vm.horizontalStepper = {
      step1: {}
    };
    // Data
    vm.horizontalStepper = {};
    // Methods
    vm.submitHorizontalStepper = submitHorizontalStepper;

    //function for submit
    function submitHorizontalStepper(event) {
      // campaign full data to local database
      var campaign_data = [vm.horizontalStepper.step1].map(function(data) {
        if (data.msgtype == 'Schedule') {
          // to filter date and time while select and enter time by user
          var userEnteredTime = data.campaignDate.toString(); // user enter time change as string format
          var indexcount = userEnteredTime.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
          var camDate = userEnteredTime.substring(0, indexcount); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient
          var date_time = new Date(data.campaignTime).toString(); //get like wed apr with time
          var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
          var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
          var time = ordertiming[0] + ":" + ordertiming[1] + ":" + '00' //find whether the hour is AM or PM
        }
        // Getting branch data for sender id auth key
        var filterbranch = branch.filter(function(branch) {
          if (branch.branch_id == $rootScope.user[0].branch_id) {
            return branch
          }
        })
        return { 'campaignName': data.campaignName, 'message': data.message, 'msgroute': data.msgroute, 'campaignDate': camDate ? camDate : '', 'campaignTime': time ? time : '', 'senderId': filterbranch[0].sender_id, 'userId': filterbranch[0].user_id, 'authKey': filterbranch[0].authKey, 'status_flag': 1, 'staffID': $rootScope.user[0].staffID, 'branch_id': $rootScope.user[0].branch_id }
      })

      //
      if (vm.horizontalStepper.step1.msgtype == 'Schedule') {
        var date_time = new Date(vm.horizontalStepper.step1.campaignTime).toString(); //get like wed apr with time
        var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
        var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
        var time = ordertiming[0] + ":" + ordertiming[1] + ":" + '00' //find whether the hour is AM or PM
        var schdate = new Date(vm.horizontalStepper.step1.campaignDate);
        var dd = schdate.getDate();
        var mm = schdate.getMonth() + 1;
        var yyyy = schdate.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        schdate = yyyy + '-' + mm + '-' + dd;
      }
      // data for second service for msg 91 and campaign details local table
      var campaignName = vm.horizontalStepper.step1.campaignName;
      var message = vm.horizontalStepper.step1.message;
      var msgtype = vm.horizontalStepper.step1.msgtype;
      var msgroute = vm.horizontalStepper.step1.msgroute;
      //service for store data in campaign local table
      api.campaign.getAll.save(campaign_data,
        function(response) {
          var msgdetails = [];
           // Getting branch data for sender id and auth key
          var filterbranch = branch.filter(function(branch) {
            if (branch.branch_id == $rootScope.user[0].branch_id) {
              return branch
            }
          });

          $scope.selected.map(function(no) {
            msgdetails.push({ 'campaignName': campaignName, 'msgroute': msgroute, 'campaignID': response.insertId, 'customer_mobile': no.customer_mobile, 'msgtype': msgtype, 'customer_id': no.customer_id, 'date': schdate ? schdate : "", 'message': message, 'time': time ? time : "", 'senderId': filterbranch[0].sender_id, 'authKey': filterbranch[0].authKey })
          })
          api.campaigndetails.getAll.save(msgdetails,
            function(response) {})
        })
      $mdToast.show({
        template: '<md-toast class="success"><span flex>message sent successfully</span></md-toast>',
        position: 'bottom right',
        hideDelay: 3000,
        action: "close"
      });
      $state.go("app.newCampaign", {}, { reload: "app.newCampaign" })

    }
    //filter branch and get authkey and sender id
    if ($rootScope.user) {
      var authKey_data = branch.filter(function(item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })
      $scope.sender_id = authKey_data[0].sender_id;
      $scope.authKey = authKey_data[0].authKey
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.billing.returnbills', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.returnbills', {
        url: '/returnbills',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/returnbills/returnbills.html',
            controller: 'ReturnBillsController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "BILLINGS.RETURN-BILLS" | translate }}'
        },
        resolve: {

        }
      })
      .state('app.viewreturnbill', {
        url: '/returnbills/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/returnbills/view-returnbill/view-returnbill.html',
            controller: 'ReturnBillsController as vm'
          }
        },
        resolve: {

        },

        ncyBreadcrumb: {
          parent: 'app.returnbills',    // static parent is fine for view page
          label: "{{ getBreadcrumbLabel() }}"
        }
      });

    // Translation
    //  $translatePartialLoaderProvider.addPart('app/main/cashier/billing/paidbills');

    // Api
    msApiProvider.register('bills.returnbills', ['app/data/returnbills/returnbills.json']);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.billing.returnbills')
    .controller('ReturnBillsController', ReturnBillsController);


  /** @ngInject */
  function ReturnBillsController(api, $rootScope, $scope, $resource, $state, $stateParams,  $mdPanel ) {

    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;

    
    // Clear search text
    //-----------------------

    $scope.clearText = function () {
      $scope.doordelivery_query.filter = '';
    }




    vm.returnBills = [];

    // ensure vm exists
    var vm = $scope.vm = $scope.vm || {};

    // query defaults (use numbers)
    $scope.return_query = {
      filter: '',
      limit: 10,                 // number, not string
      order: 'nameToLower',
      page: 1,
      branch_id: $rootScope.user[0].branch_id
    };

    // expose loader
    $scope.loadReturnBills = function () {
      // compute offset for server-side paging if your API expects it
      var limit = parseInt($scope.return_query.limit, 10) || 10;
      var page = parseInt($scope.return_query.page, 10) || 1;
      var offset = (page - 1) * limit;

      // payload for API - send offset if server accepts it
      var payload = angular.extend({}, $scope.return_query, { offset: offset });

      // set the promise so md-progress uses it
      $scope.promise = api.return_order.getAll.get(payload).$promise;

      $scope.promise
        .then(function (resp) {
          console.log('Return bills loaded', resp);

          $scope.returnBills = resp.returns || [];        // used by the ng-repeat in template
          $scope.returnBillCount = resp.count || 0;       // used by md-table-pagination
          console.log('Return Bills Count:', $scope.returnBillCount);
          if (typeof returnbill_success === 'function') returnbill_success(resp);
        })
        .catch(function (err) {
          console.error('Failed to load return bills', err);
          vm.returnBills = [];
          vm.returnBillCount = 0;
        });



    };

    // initial load
    $scope.loadReturnBills();


    $scope.viewreturn = function (returnBill) {
      // if your state is 'app.viewreturnbill' use that, otherwise use 'app.returnbills.viewreturnbill'
      $state.go('app.viewreturnbill', { id: returnBill.returnorder_id });
      $scope.returnBill = returnBill;
    };
    $scope.addreturn = function () {
      $state.go('app.addreturnbill');
    };
    // safe breadcrumb label function on $rootScope
    $rootScope.getBreadcrumbLabel = function () {
      // use $state.params or $stateParams (both work); prefer $state.params for runtime changes
      var id = ($state && $state.params && $state.params.id) || ($stateParams && $stateParams.id);
      if (!id) return ''; // nothing to show yet

      // safe search — return an identifier or the id if not found
      var list = $scope.returnBills || []; // may be empty initially
      var found = list.find(function (rb) { return String(rb.returnorder_id) === String(id); });
      if (found) {
        // prefer a human friendly label (return_no) if present
        return found.return_no || found.returnorder_id || String(id);
      }
      // if list not loaded or not found, just show the id
      return String(id);
    };





    

  }
})();

(function() {
  'use strict';

  angular
    .module('app.billing.trashBills', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.trashBills', {
        url: '/trashBills',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/trashbills/trashbills.html',
            controller: 'TrashBillsController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "BILLINGS.TRASH-BILLS" | translate }}'
        },
        resolve: {
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          sales_order_data: function(apiResolver) {
            return apiResolver.resolve('sales_order_data.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          taxs: function(apiResolver) {
            return apiResolver.resolve('taxs.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
        }
      });

    // Translation
    //  $translatePartialLoaderProvider.addPart('app/main/cashier/billing/paidbills');

    // Api
    msApiProvider.register('bills.paidBills', ['app/data/paidbills/paidbills.json']);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.billing.trashBills')
    .controller('TrashBillsController', TrashBillsController)
    .directive('exportToCsv', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var el = element[0];
          element.on('click', function (e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            //var today=new Date()
            var today = new Date(scope.myDate).toString(); //get like wed apr with time
            today = new Date(today).toUTCString();
            today = today.split(' ').slice(0, 4).join(' ');
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: (today) + 'Trash Posbills' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function TrashBillsController(sales_order_data, branch_data, staffRole, point, customer_details, api, dietType, taxs, $cookies, $rootScope, $scope, $resource, $state, $stateParams, $timeout, $mdToast, $mdPanel, $mdDialog) {
    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;

    vm.settings = dietType.settings; //get corporate settings from general json
    vm.dbbackupPath = dietType.dbbackupPath; //get corporate settings from general json
    vm.dealerLists = dietType.newbill.dealerLists; // 
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin');
    $scope.stewardPermission = $cookies.get('steward');
    vm.staffs = staffRole;
    var dietType_all = [{ 'label': 'All Diet Type', 'value': '' }]
    //get diet type list from genral json
    var diets = dietType.newbill.dietTypeLists.map(function (dietType) {
      return { 'label': dietType.label, 'value': dietType.value }
    })
    vm.dietType = dietType_all.concat(diets); //concat all diet array and actual diet array
    $rootScope.user = $cookies.getObject('user');
    //get staff data with staff data
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function (response) {
        $scope.staff_name = response[0].name;
      })
    //store permissions in array
    $scope.admin = []
    $scope.salesbillss = []
    $scope.saleseditt = []
    $scope.salesdeletee = []
    $scope.mdtableselected = []; // dummy assign
    //get permissions from cookies
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 1) {
        $scope.salesbillss.push("salesbills");
      } else if (permissionss[i] == 12) {
        $scope.saleseditt.push("salesbills");
      } else if (permissionss[i] == 13) {
        $scope.salesdeletee.push("salesbills");
      }
    }
    // DATA
    //----------------

    vm.paymentmodelist = [{
      "name": 'All Paid Type',
      "value": ''
    }, {
      "name": 'Cash',
      "value": 'cash'
    }, {
      "name": 'Online',
      "value": 'card'
    }];
    //month filter or day filter
    $scope.OpenDayWise = true
    $scope.OpenMonthWise = false
    $scope.OpenDayWises = function () {
      $scope.OpenDayWise = true
      $scope.OpenMonthWise = false
    }
    $scope.OpenMonthWises = function () {
      $scope.OpenMonthWise = true
      $scope.OpenDayWise = false
    }
    //get data from general json
    api.dietType.get(function (dietType) {
      vm.settings = dietType.settings;
    }, function (err) { });
    //Front end data to apply md pickers

    $scope.myDate = new Date(); // assign today data to md picker
    //retrict date only 30 days move on backward from md pciker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() - 30
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    $scope.staffs = "admin"
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': 'admin', 'name': 'All Staff' }]
    //filter only pos staffs
    $scope.pos_staff = staffRole.filter(function (staff) {
      return sales_order_data.some(function (fullsalesorderdata) {
        return (staff.staffID == fullsalesorderdata.staffID && staff.status == 'active' && fullsalesorderdata.sales_dietType != 'ODC' && staff.branch_id == fullsalesorderdata.branch_id)
      })
    })

    vm.staffRole = staff_all.concat($scope.pos_staff); //concat all and pos staff arrays
    //showing month only in date filter which is supported in angularjs materila 1.10
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function (date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function (dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
      type: 'date',
      required: false,
      binding: 'applicant.pickADate',
      label: 'Standard Date Field - picking day, month and year',
      startView: 'day',
      mode: 'day',
      locale: ymdFormat
    },
    {
      type: 'date',
      required: true,
      binding: 'applicant.dateOfBirth',
      label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
      startView: 'month',
      mode: 'month',
      locale: monthFormat
    },
    {
      type: 'date',
      required: false,
      binding: 'applicant.expectedGraduation',
      startView: 'month',
      label: 'Credit Card Expiry - Year/Month picker',
      mode: 'month',
      locale: monthFormat
    }
    ];
    //success of data in finished bill
    function trashbill_success(desserts) {
      //collect counts from server
      //console.log(desserts[0]);
      $scope.dinein_amount = desserts[0].dinein_amount;
      $scope.takeaway_amount = desserts[0].takeaway_amount;
      $scope.doordelivery_amount = desserts[0].doordelivery_amount;
      $scope.dinein_total = desserts[0].dinein_total;
      $scope.takeaway_total = desserts[0].takeaway_total;
      $scope.doordelivery_total = desserts[0].doordelivery_total;
      $scope.payment_transferred = desserts[0].payment_transferred_total;
      $scope.payment_received = desserts[0].payment_received_total;

      // $scope.paidbill_count = desserts[0].paidbill_count
      $scope.paidbill_count = desserts[0].paidbill_count
      vm.currentbill_serviceID = desserts[0].results.map(function (item) {
        var date_time = new Date(item.ordertime).toString(); //get like wed apr with time
        var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
        var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
        var delivertiming = item.sales_deliveryStatus == "Immediate" ? "Immediate" : (item.sales_deliveryTime.split(' '))
        var delivertime = delivertiming == "Immediate" ? "Immediate" : (delivertiming[4] + " " + delivertiming[5])
        if (item.sales_dietType == "doordelivery" || item.sales_dietType == "takeaway") {

          var currentTimes = new Date();
          var sales_deliveryDates = (new Date(item.sales_deliveryDate) > new Date() || new Date(item.sales_deliveryDate) < new Date()) ? new Date(item.sales_deliveryDate) : ''
          var date_time = sales_deliveryDates.toString()
          var sales_deliveryDate = date_time.substring(0, date_time.lastIndexOf(':') + -6)
          //caluclute diff bewteen days like 7 days remaining
          var endTimes = new Date(item.sales_deliveryDate)
          var mss = (endTimes - currentTimes); // ms of difference
          var days = Math.round(mss / 86400000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdownn = (days == 1 ? days + "day left" : days + "days left");
          var remainingtimes = mss < 0 ? "" : finalCountdownn

          var currentTime = new Date();
          var endTime = new Date(item.sales_deliveryTime);
          var ms = (endTime - currentTime); // ms of difference
          //var days = Math.round(ms/ 86400000);
          var hrs = Math.round((ms % 86400000) / 3600000);
          var mins = Math.round(((ms % 86400000) % 3600000) / 60000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdown = (hrs + " h:" + mins + "m left");

          if (new Date(item.sales_deliveryDate) > new Date()) {
            var period = ""
          } else if (new Date(item.sales_deliveryDate).toDateString() == new Date().toDateString()) {
            var period = "TODAY"
          } else if (new Date(item.sales_deliveryDate) < new Date()) {
            var period = "EXPIRED"
          }
          if (item.sales_deliveryStatus != "Immediate") {
            var remainingtime = mss < 0 ? period : remainingtimes
          } else {
            var remainingtime = "";
          }
        }
        var Delivery_date = sales_deliveryDate == undefined ? '' : sales_deliveryDate + "," + " " + delivertime == undefined ? '' : delivertime;
        var cashpay = item.payment_mode == 'cash' && item.payment_received == 0 ? item.payment_total : item.payment_received;
        var onlinepay = item.payment_mode == 'card' && item.payment_transferred == 0 ? item.payment_total : item.payment_transferred;

        return { 'staffID': item.staffID, 'thirdparty_id': item.thirdparty_id, 'thirdparty_name': item.thirdparty_name, 'showdeliverdate': new Date(item.sales_deliveryDate), 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'customer_id': item.customer_id, 'additional_charge': item.additional_charge, 'tax_rate': item.tax_rate, 'tax_sgst': item.tax_sgst, 'payment_mode': item.payment_mode, 'discount': item.discount, 'remainingtime': remainingtime, 'or': item.ordertime, 'status': item.status, 'showorderdate': date_time.substring(0, date_time.lastIndexOf(':') + 3), 'ordertime': time, 'salesorder_id': item.salesorder_id, 'sales_dietType': item.sales_dietType, 'manageBy': item.manageBy, 'payment_total': item.payment_total, 'tableitem': item.tableitem, 'dealer_status': item.dealer_status, 'payment_status': item.payment_status, 'payment_received': item.payment_received, 'payment_transferred': item.payment_transferred, 'sales_deliveryTime': item.sales_deliveryStatus == "Immediate" ? "Immediate" : Delivery_date, 'cashpay': cashpay, 'onlinepay': onlinepay }
      })
      vm.paidbill = vm.currentbill_serviceID;

      // 
      //Month wise data per day total amount collecting for gst
      var resultsdata = desserts[0].results;
      // remove duplicate date
      var hash = Object.create(null),
        dateUniq = [];
      for (i = 0; i < resultsdata.length; i++) {
        var date = moment(resultsdata[i].ordertime).format('D/MMM/YYYY');
        if (!hash[date]) {
          hash[date] = true;
          dateUniq.push(date);
        }
      }
      // Per day total amount
      var perdaytotal = dateUniq.map(function (value1) {
        var total = 0;
        for (var i = 0; i < resultsdata.length; i++) {
          var value2_order = moment(desserts[0].results[i].ordertime).format('D/MMM/YYYY');
          if (value2_order === value1) {
            total += parseInt(desserts[0].results[i].payment_total);
          }
        }
        var merger = { "date": value1, "total_amount": total }
        return merger
      });
      vm.perdaytotalDatas = perdaytotal;
      /* end month wise data */


    }

    $scope.changeDate = changeDate;
    //function for change date, dietype, paidtype etc in dropdown
    function changeDate(myDate, DietType, customerType, PaidType, staff, monthyear) {
      $scope.retrieve = "rmInfo"
      $scope.load = true
      getDessertsss(myDate, DietType, customerType, PaidType, staff, monthyear) // callback funtion
      $timeout(function () {
        $scope.load = false
      }, 500);
    }
    $scope.getDessertsss = getDessertsss;
    function getDessertsss(myDate, DietType, customerType, PaidType, staff, monthyear) {
      if (myDate == undefined || DietType == undefined || PaidType == undefined || customerType == undefined) {
        var Diet = ''
        var Paid = ''
        var CustomerType = '';
        var dbstring = new Date();
        var dd = dbstring.getDate();
        var mm = dbstring.getMonth() + 1;
        var yyyy = dbstring.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        dbstring = yyyy + '-' + mm + '-' + dd;
      } else {
        var Diet = DietType;
        var Paid = PaidType;
        var CustomerType = customerType == 'all' ? '' : customerType;
        if (myDate) {
          var dbstring = new Date(myDate);
          var dd = dbstring.getDate();
          var mm = dbstring.getMonth() + 1;
          var yyyy = dbstring.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }

          if (mm < 10) {
            mm = '0' + mm;
          }
          dbstring = yyyy + '-' + mm + '-' + dd;
        }

      }
      if (monthyear) {
        var month = new Date(monthyear).getMonth() + 1;
        var year = new Date(monthyear).getFullYear()
      }
      if ($cookies.get('admin') != 'admin') {
        // if user
        $scope.doordelivery_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          date: dbstring ? dbstring : '',
          DietType: Diet,
          customerType: CustomerType,
          PaidType: Paid,
          month: month ? month : '',
          year: year ? year : ''
        };
      }
      if ($cookies.get('admin') == 'admin') {
        // if admin
        var staffID = staff == undefined ? 'admin' : staff
        $scope.doordelivery_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          date: dbstring ? dbstring : '',
          DietType: Diet,
          customerType: CustomerType,
          PaidType: Paid,
          month: month ? month : '',
          year: year ? year : ''
        };
      }

      $scope.reload = function () {
        $scope.promise = api.trashbill_service.getAll.get($scope.doordelivery_query, trashbill_success).$promise;
      };
      $scope.reload();
    };

    getDessertsss();

    $scope.$watch('doordelivery_query.filter', function (newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.doordelivery_query.page ? $scope.doordelivery_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.doordelivery_query.page = 1
      }
      if (!newValue) {
        $scope.doordelivery_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss = getDessertsss;
      $scope.reload();
    });

    // Clear search text
    //-----------------------

    $scope.clearText = function () {
      $scope.doordelivery_query.filter = '';
    }


    // GET CATEGORY NAME
    //---------------- 
    //filter who was created for particular bill
    $scope.paidbill_staffnames = function (rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //to find who was edit this bill
    $scope.update_staff = function (rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    //get customer number
    $scope.paidbill_customermobiles = function (rmInfo) {
      for (var i = 0; i < customer_details.length; i++) {
        if (customer_details[i].customer_id == rmInfo.customer_id) {
          return customer_details[i].customer_mobile
        }
      }
    };

    vm.paidbillss = $rootScope.datas; //assign filtered datas from the service
    //refresh button kindly we are not using this
    $scope.refresh = function () {
      vm.paidbillss = $rootScope.datas;
    }

    var originatorEv;
    vm.openMenu = function ($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
    //filter tax data for branch wise
    var taxss = taxs.filter(function (data) {
      return [$rootScope.user[0].branch_id].some(function (branch_id) {
        return data.branch_id == branch_id
      })
    })


    //check whether the branch conatins points data if not assign 0 value default
    if (point.length) { // no data in database
      var point_data = point.filter(function (item) {
        // check branch 
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })

      //check whether the branch conatins points data   
      if (point_data.length) {
        $scope.points = point_data;
      }
      // If not data for particular data
      else {
        var point_data = [{
          'amount': 0,
          'perpoint_amount': 0,
          'EnableFirstTime': 0,
          'FirstTimePoint': 0,
          'enablepoint': 0
        }]
        $scope.points = point_data;
      }
    }
    //// If not data in database
    else {
      var point_data = [{
        'amount': 0,
        'perpoint_amount': 0,
        'EnableFirstTime': 0,
        'FirstTimePoint': 0,
        'enablepoint': 0
      }]
      $scope.points = point_data;
    }

    // Delete the purchase order
    $scope.removeRow = function (item, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this bill?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        var customer_ids = item.customer_id;
        if (customer_ids) {
          var oldpointsdb = [];
          // Based on id getting points
          customer_details.map(function (customer) {
            if (customer_ids == customer.customer_id) {
              oldpointsdb.push(customer.pointsEarned)
            }
          });

          var billPoints = Math.floor(item.payment_total / $scope.points[0].amount);
          var dbPoints = Math.floor(oldpointsdb[0])
          var pointsValue = (parseFloat(dbPoints) - parseFloat(billPoints));
          var updatePoints = pointsValue < 0 ? 0 : pointsValue;
          var pointsEarned = [{ 'pointsEarned': updatePoints }]

          api.update_earnpoint.getID.update({ customer_id: customer_ids }, pointsEarned,
            function (response) { });
        }
        // Getting items using sale order id
        api.dietitems.getaData.get({ salesorder_id: item.salesorder_id },
          function (response) {
            vm.fmitems = response;
            var Items = vm.fmitems.map(function (item) {
              return { 'fmItemID': item.fmItemID, 'item_quantity': item.sales_quantity };
            });
            // Increase stock data of each item
            api.deleteAndupdate_newbill_quantity.getID.update({ siItemID: Items[0].fmItemID, salesitem_id: 'multidelete' }, Items,
              function (response) {

              },
              function () {
                // Canceled
              });
          });
        // Delete sale order with relationship tables
        api.delete_pos_ordered.getID.delete({ salesorder_id: item.salesorder_id },
          function (response) {
            //success callback
            deleteItem(item);
          },
          function (response) {
            // error callback
          }
        );

      }, function () {
        // Canceled
      });

      /**
       * Delete index of the  Item
       */
      function deleteItem(item) {
        vm.paidbill.splice(vm.paidbill.indexOf(item), 1);
        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //check whether tax data contains or not
    if (taxss.length) {
      if (taxss.length == 1) {
        var tax_data = [{ 'taxName': taxss[0].taxName, 'taxRate': taxss[0].taxRate }, { 'taxName': 'SGST', 'taxRate': 0 }]
      } else {
        var tax_data = taxss;
      }
    } else {
      var tax_data = [{ 'taxName': 'CGST', 'taxRate': 0 }, { 'taxName': 'SGST', 'taxRate': 0 }]
    }
    //filter points data for branch wise
    var point_data = point.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    //open popup for view purpose
    $scope.paidbillDialog = function (ev, paidbill) {
      $mdDialog.show({
        controller: 'viewbillController',
        templateUrl: 'app/main/cashier/billing/bill-dialog/bill-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          salebills: paidbill.salesorder_id,
          customer_id: paidbill.customer_id,
          taxs: tax_data,
          point: point_data,
          dietType: dietType,
          branch_data: branch_data,
          editbill: 'trashbill',
          printInfo: 'trashbill'

        }
      })
    }
    var printInfo = 'trashbill';
    // function for edit data from viewbill to newbill when popup opened

    //click print function
    $scope.printToCart = function (paidbill) {
      $scope.id = paidbill.salesorder_id;
      var customer_id = paidbill.customer_id;
      var salesId = paidbill.salesorder_id;
      var vm = this;
      var printBill = angular.copy($scope.id)
      $rootScope.$broadcast("salesId", salesId, tax_data, point_data, customer_id, branch_data, printInfo, dietType);

    };




  }
})();

(function() {
  'use strict';

  angular
    .module('app.billing.currentBills', ['md.data.table'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.currentBills', {
        url: '/orderedBills',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/currentbills/currentbills.html',
            controller: 'CurrentBillsController as vm'
          }
        },

        ncyBreadcrumb: {
          label: '{{ "BILLINGS.ORDERED-BILLS" | translate }}'

        },
        resolve: {
          currentbill_service: function(apiResolver) {
            return apiResolver.resolve('currentbill_service.getAll@get');
          },
          current_mergebill: function(apiResolver) {
            return apiResolver.resolve('current_mergebill.getAll@get');
          },
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          taxs: function(apiResolver) {
            return apiResolver.resolve('taxs.getAll@get');
          }
        }
      });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/cashier/billing/currentbills');


    // Api
    //  msApiProvider.register('bills.currentBills', ['app/data/currentbills/currentbills.json']);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.billing.currentBills')
    .controller('printbillController', printbillController);

  /** @ngInject */
  function printbillController($scope, api, $rootScope, $window, $timeout, $location, $mdDialog, $state, $stateParams) {
    var vm = this;
    var originatorEv;
    $scope.closeDialog = function () {
      $mdDialog.hide();
    }
    $scope.qrcode = "images/no-image.png";
    //get id from currentbill controller for pirnt function    
    //this listening function datas came from broadcast
    $scope.$on("salesId", function (event, id, taxs, point, customer_id, branch_data, printInfo, dietType) {
      $scope.salesId = id;
      $scope.points = point;
      $scope.hideRate = dietType.newbill.tax_status[0];
      $scope.logoUrl = "assets/images/login/print-logo.png";

      //filter data branch wise
      var filterbranch = branch_data.filter(function (item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })

      vm.branchFilterData = filterbranch;
      $scope.branchfooter = filterbranch[0].print_footer
      $scope.branchaddress = filterbranch[0].address;
      var branchGstNoCheck = (filterbranch[0].GstNo == 'null' || !filterbranch[0].GstNo) ? '' : filterbranch[0].GstNo;
      $scope.branchGstNo = branchGstNoCheck;
      $scope.contact_number = filterbranch[0].contact_number
      vm.taxs = taxs;
      vm.settings = dietType.settings;
      vm.print = dietType.print;
      $scope.qrcode_status = 0; //default qrcode status off
      $scope.qrcode_width = vm.print.qrcode_width;
      $scope.qrcode_height = vm.print.qrcode_height;
      //get salesorder_id from currentbill for edit
      var salesorder_ids = $scope.salesId;
      //service for get billing datas
      api.salesorder_diet.getID.get({ salesorder_id: salesorder_ids },
        function (response) {
          $scope.response = response;
          console.log(response);
          vm.billing = {
            'tableno': response[0].tableitem,
            'dietType': response[0].sales_dietType,
            'staff': response[0].manageBy,
            'staffID': response[0].staffID
          }
          // vm.editeeeed=1;
          vm.activedealer = response[0].dealer_status;
        })

      //service for get  customer_info
      api.customer_infodiet.getID.get({ salesorder_id: customer_id },
        function (response) {
          $scope.customer = response[0];
          $scope.pointsEarned = Math.floor(response[0].pointsEarned);
        })

      //service for get payment datas
      api.payment_diet.getID.get({ salesorder_id: salesorder_ids },
        function (response) {
          $scope.printpayment = response;
          $scope.paymentMode = response[0].payment_mode;
          vm.billing.tax = response[0].tax_rate
          vm.billing.tax_sgst = response[0].tax_sgst
          vm.billing.discount = response[0].discount
          vm.billing.discount_type = response[0].discount_type
          $scope.total_pointdiscount = response[0].pointdiscount;
          vm.billing.additional_charge = response[0].additional_charge
          $scope.payment = response[0];
          vm.billing.roundtotal = $scope.payment.payment_total
        })


      //service for get billing datas for calculate totals
      api.dietitems.getaData.get({ salesorder_id: salesorder_ids },
        function (response) {
          $scope.fmitems = response;
          vm.fmitems = response;
          var subtotal = 0;
          var totalqty = 0;
          $scope.sales_quantity = 0;
          angular.forEach(vm.fmitems, function (fmitem) {
            var item = (fmitem != null) ? fmitem.salesitem_rate : 0;
            var qty = (fmitem != null) ? fmitem.sales_quantity : 0;
            fmitem.subitemtotal = item * qty;
            $scope.sales_quantity += fmitem.sales_quantity;
            totalqty += parseInt(fmitem.sales_quantity);
            subtotal += item * qty;
            vm.fmitems.subTotal = subtotal
            if (dietType.settings.indivudual_exclude) {
              //tax_status 1 is for exclude(added tax in current item)
              //tax_status 2 is for include(not added tax in current item)
              $scope.fullcgst = 0
              $scope.fullsgst = 0
              $scope.fullrate = 0
              $scope.fullexcluderate = 0
              angular.forEach(vm.fmitems, function (fmitem) {
                if (fmitem.tax_status == 'exclude') {
                  fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
                  fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
                  fmitem.tax_cgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  fmitem.tax_sgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
                  $scope.fullexcluderate += (fmitem.sales_quantity * fmitem.salesitem_rate)
                  $scope.totalTax = $scope.fullcgst + $scope.fullsgst
                  $scope.excludesubTotal = subtotal + $scope.totalTax;
                } else if (fmitem.tax_status == 'include') {
                  fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
                  fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
                  fmitem.tax_cgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  fmitem.tax_sgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
                  $scope.totalTax = $scope.fullcgst + $scope.fullsgst
                }
              })

            }
            var savings = 0
            //get offer discount
            for (var i = 0; i < vm.fmitems.length; i++) {
              if (vm.fmitems[i].offerprice) {
                //savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].offerprice));
                savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].salesitem_rate))
              }
            }

            $scope.savedamount = savings;
          })
          vm.totalqty = totalqty;
          //if global tax
          if (dietType.settings.global_tax) {
            vm.billing.discount_percent = ((subtotal + vm.billing.tax + vm.billing.tax_sgst + vm.billing.additional_charge) / 100) * vm.billing.discount;
          } //if exclude tax then tax should be add here 
          else if (response[0].tax_status == 'exclude') {
            vm.billing.discount_percent = (($scope.excludesubTotal + vm.billing.additional_charge) / 100) * vm.billing.discount;
          } //if include tax then tax should not be add here 
          else if (response[0].tax_status == 'include') { //include status in bill
            vm.billing.discount_percent = ((subtotal + vm.billing.additional_charge) / 100) * vm.billing.discount;
          }
          vm.billing.subTotal = vm.fmitems.subTotal
        })

      //view customer_feedback

      api.customer_feedbackdiet.getID.get({ salesorder_id: salesorder_ids },
        function (response) {
          $scope.feedback = response[0];

        })


      $timeout(function () {
        var w = window.open('', '_blank', 'width=' + filterbranch[0].printsize + ',height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        w.document.write($('#printBill').html()); //only part of the page to print, using jquery
        //$timeout(function() {
        w.document.close(); //this seems to be the thing doing the trick
        w.focus();
        w.print();
        w.close();
        //}, 250);
        if (printInfo == 'orderedbill') {
          $state.go("app.currentBills", {}, { reload: "app.currentBills" })
        } else if (printInfo == 'finishedbill') {
          $state.go("app.paidBills", {}, { reload: "app.paidBills" })
        } else if (printInfo == 'trashbill') {
          $state.go("app.trashBills", {}, { reload: "app.trashBills" })
        }
      }, vm.print.print_delay);

    })

  }
})();

(function() {
  'use strict';

  angular
    .module('app.billing.paidBills', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.paidBills', {
        url: '/finishedBills',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/paidbills/paidbills.html',
            controller: 'PaidBillsController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "BILLINGS.FINISHED-BILLS" | translate }}'
        },
        resolve: {
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          sales_order_data: function(apiResolver) {
            return apiResolver.resolve('sales_order_data.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          taxs: function(apiResolver) {
            return apiResolver.resolve('taxs.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
        }
      });

    // Translation
    //  $translatePartialLoaderProvider.addPart('app/main/cashier/billing/paidbills');

    // Api
    msApiProvider.register('bills.paidBills', ['app/data/paidbills/paidbills.json']);

  }
})();

(function() {
  'use strict';

  angular
    .module('app.billing.paidBills')
    .controller('PaidBillsController', PaidBillsController)
    .directive('exportToCsv', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            //var today=new Date()
            var today = new Date(scope.myDate).toString(); //get like wed apr with time
            today = new Date(today).toUTCString();
            today = today.split(' ').slice(0, 4).join(' ');
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: (today) + 'Paid Posbills' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function PaidBillsController(sales_order_data, branch_data, staffRole, point, customer_details, api, dietType, taxs, $cookies, $rootScope, $scope, $resource, $state, $stateParams, $timeout,$mdToast, $mdPanel, $mdDialog) {
    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;
  
    vm.settings = dietType.settings; //get corporate settings from general json
    vm.dbbackupPath = dietType.dbbackupPath; //get corporate settings from general json
    vm.dealerLists = dietType.newbill.dealerLists; // 
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin');
    $scope.stewardPermission = $cookies.get('steward');
    vm.staffs = staffRole;
    var dietType_all = [{ 'label': 'All Diet Type', 'value': '' }]
    //get diet type list from genral json
    var diets = dietType.newbill.dietTypeLists.map(function(dietType) {
      return { 'label': dietType.label, 'value': dietType.value }
    })
    vm.dietType = dietType_all.concat(diets); //concat all diet array and actual diet array
    $rootScope.user = $cookies.getObject('user');
    //get staff data with staff data
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
     //store permissions in array
    $scope.admin = []
    $scope.salesbillss = []
    $scope.saleseditt = []
    $scope.salesdeletee = []
    $scope.mdtableselected = []; // dummy assign
        //get permissions from cookies
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 1) {
        $scope.salesbillss.push("salesbills");
      } else if (permissionss[i] == 12) {
        $scope.saleseditt.push("salesbills");
      } else if (permissionss[i] == 13) {
        $scope.salesdeletee.push("salesbills");
      }
    }
    // DATA
    //----------------
    
    vm.paymentmodelist = [{
      "name": 'All Paid Type',
      "value": ''
    }, {
      "name": 'Cash',
      "value": 'cash'
    }, {
      "name": 'Online',
      "value": 'card'
    }];
    //month filter or day filter
    $scope.OpenDayWise = true
    $scope.OpenMonthWise = false
    $scope.OpenDayWises = function() {
      $scope.OpenDayWise = true
      $scope.OpenMonthWise = false
    }
    $scope.OpenMonthWises = function() {
      $scope.OpenMonthWise = true
      $scope.OpenDayWise = false
    }
    //get data from general json
    api.dietType.get(function(dietType) {
      vm.settings = dietType.settings;
    }, function(err) {});
    //Front end data to apply md pickers

    $scope.myDate = new Date(); // assign today data to md picker
    //retrict date only 30 days move on backward from md pciker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() - 30
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    $scope.staffs = "admin"
    vm.staffRoles = staffRole;
    var staff_all = [{ 'staffID': 'admin', 'name': 'All Staff' }]
    //filter only pos staffs
    $scope.pos_staff = staffRole.filter(function(staff) {
      return sales_order_data.some(function(fullsalesorderdata) {
        return (staff.staffID == fullsalesorderdata.staffID && staff.status == 'active' && fullsalesorderdata.sales_dietType != 'ODC' && staff.branch_id == fullsalesorderdata.branch_id)
      })
    })

    vm.staffRole = staff_all.concat($scope.pos_staff); //concat all and pos staff arrays
  //showing month only in date filter which is supported in angularjs materila 1.10
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();

    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];
    //success of data in finished bill
    function paidbill_success(desserts) {
      //collect counts from server
      //console.log(desserts[0]);
      $scope.dinein_amount = desserts[0].dinein_amount;
      $scope.takeaway_amount = desserts[0].takeaway_amount;
      $scope.doordelivery_amount = desserts[0].doordelivery_amount;
      $scope.dinein_total = desserts[0].dinein_total;
      $scope.takeaway_total = desserts[0].takeaway_total;
      $scope.doordelivery_total = desserts[0].doordelivery_total;
      $scope.tax_sgst = desserts[0].tax_sgst;
      $scope.tax_cgst = desserts[0].tax_cgst;
      $scope.payment_transferred = desserts[0].payment_transferred_total;
      $scope.payment_received = desserts[0].payment_received_total;

      // $scope.paidbill_count = desserts[0].paidbill_count
      $scope.paidbill_count = desserts[0].paidbill_count
      vm.currentbill_serviceID = desserts[0].results.map(function(item) {
        var date_time = new Date(item.ordertime).toString(); //get like wed apr with time
        var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
        var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
        var delivertiming = item.sales_deliveryStatus == "Immediate" ? "Immediate" : (item.sales_deliveryTime.split(' '))
        var delivertime = delivertiming == "Immediate" ? "Immediate" : (delivertiming[4] + " " + delivertiming[5])
        if (item.sales_dietType == "doordelivery" || item.sales_dietType == "takeaway") {

          var currentTimes = new Date();
          var sales_deliveryDates = (new Date(item.sales_deliveryDate) > new Date() || new Date(item.sales_deliveryDate) < new Date()) ? new Date(item.sales_deliveryDate) : ''
          var date_time = sales_deliveryDates.toString()
          var sales_deliveryDate = date_time.substring(0, date_time.lastIndexOf(':') + -6)
          //caluclute diff bewteen days like 7 days remaining
          var endTimes = new Date(item.sales_deliveryDate)
          var mss = (endTimes - currentTimes); // ms of difference
          var days = Math.round(mss / 86400000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdownn = (days == 1 ? days + "day left" : days + "days left");
          var remainingtimes = mss < 0 ? "" : finalCountdownn

          var currentTime = new Date();
          var endTime = new Date(item.sales_deliveryTime);
          var ms = (endTime - currentTime); // ms of difference
          //var days = Math.round(ms/ 86400000);
          var hrs = Math.round((ms % 86400000) / 3600000);
          var mins = Math.round(((ms % 86400000) % 3600000) / 60000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdown = (hrs + " h:" + mins + "m left");
         
          if (new Date(item.sales_deliveryDate) > new Date()) {
            var period = ""
          } else if (new Date(item.sales_deliveryDate).toDateString() == new Date().toDateString()) {
            var period = "TODAY"
          } else if (new Date(item.sales_deliveryDate) < new Date()) {
            var period = "EXPIRED"
          }
          if (item.sales_deliveryStatus != "Immediate") {
            var remainingtime = mss < 0 ? period : remainingtimes
          } else {
            var remainingtime = "";
          }
        }
        var Delivery_date = sales_deliveryDate == undefined ? '' : sales_deliveryDate + "," + " " + delivertime == undefined ? '' : delivertime;
        var cashpay = item.payment_mode == 'cash' && item.payment_received == 0 ? item.payment_total : item.payment_received;
        var onlinepay = item.payment_mode == 'card' && item.payment_transferred == 0 ? item.payment_total : item.payment_transferred;

        return { 'staffID': item.staffID,'thirdparty_id':item.thirdparty_id,'thirdparty_name': item.thirdparty_name, 'showdeliverdate': new Date(item.sales_deliveryDate), 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'customer_id': item.customer_id, 'additional_charge': item.additional_charge, 'tax_rate': item.tax_rate, 'tax_sgst': item.tax_sgst, 'payment_mode': item.payment_mode, 'discount': item.discount, 'remainingtime': remainingtime, 'or': item.ordertime, 'status': item.status, 'showorderdate': date_time.substring(0, date_time.lastIndexOf(':') + 3), 'ordertime': time, 'salesorder_id': item.salesorder_id, 'sales_dietType': item.sales_dietType, 'manageBy': item.manageBy, 'payment_total': item.payment_total, 'tableitem': item.tableitem, 'dealer_status': item.dealer_status, 'payment_status': item.payment_status, 'payment_received': item.payment_received, 'payment_transferred': item.payment_transferred, 'sales_deliveryTime': item.sales_deliveryStatus == "Immediate" ? "Immediate" : Delivery_date, 'cashpay': cashpay, 'onlinepay': onlinepay }
      })
      vm.paidbill = vm.currentbill_serviceID;

        // 
        //Month wise data per day total amount collecting for gst
        var resultsdata = desserts[0].results;
        // remove duplicate date
        var hash = Object.create(null),
        dateUniq = []; 
        for (i = 0; i < resultsdata.length; i++) {
            var date = moment(resultsdata[i].ordertime).format('D/MMM/YYYY');
            if (!hash[date]) {
                hash[date] = true;
                dateUniq.push(date);
            }
        }
        // Per day total amount
        var perdaytotal = dateUniq.map(function(value1) {
            var total = 0;
            for (var i = 0; i < resultsdata.length; i++) {
                var value2_order = moment(desserts[0].results[i].ordertime).format('D/MMM/YYYY');
                if (value2_order === value1) {
                    total += parseInt(desserts[0].results[i].payment_total);
                }
            }
            var merger = { "date": value1, "total_amount": total }
            return merger
        });
        vm.perdaytotalDatas = perdaytotal;
        /* end month wise data */


    }

    $scope.changeDate = changeDate;
    //function for change date, dietype, paidtype etc in dropdown
    function changeDate(myDate, DietType, customerType, PaidType, staff, monthyear) {
      $scope.retrieve = "rmInfo"
      $scope.load = true
      getDessertsss(myDate, DietType, customerType, PaidType, staff, monthyear) // callback funtion
      $timeout(function() {
        $scope.load = false
      }, 500);
    }
    $scope.getDessertsss = getDessertsss;
    function getDessertsss(myDate, DietType, customerType, PaidType, staff, monthyear) {
      if (myDate == undefined || DietType == undefined || PaidType == undefined || customerType == undefined) {
        var Diet = ''
        var Paid = ''
        var CustomerType = '';
        //dbstring = yyyy + '-' + mm + '-' + dd;
        var dbstring = moment(new Date()).format('YYYY-MM-DD');
      } else {
        var Diet = DietType;
        var Paid = PaidType;
        var CustomerType = customerType == 'all' ? '' : customerType;
        if (myDate) {
          var dbstring = moment(myDate).format('YYYY-MM-DD');
        }
      }
      if (monthyear) {
        var month = new Date(monthyear).getMonth() + 1;
        var year = new Date(monthyear).getFullYear()
      }
      console.log(dbstring);
      console.log(month);
      console.log(year);

      if ($cookies.get('admin') != 'admin') {
        // if user
        $scope.doordelivery_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: $rootScope.user[0].staffID,
          branch_id: $rootScope.user[0].branch_id,
          date: dbstring ? dbstring : '',
          DietType: Diet,
          customerType: CustomerType,
          PaidType: Paid,
          month: month ? month : '',
          year: year ? year : ''
        };
      }
      if ($cookies.get('admin') == 'admin') {
           // if admin
        var staffID = staff == undefined ? 'admin' : staff
        $scope.doordelivery_query = {
          filter: '',
          limit: '10',
          order: 'nameToLower',
          page: 1,
          staffID: staffID,
          branch_id: $rootScope.user[0].branch_id,
          date: dbstring ? dbstring : '',
          DietType: Diet,
          customerType: CustomerType,
          PaidType: Paid,
          month: month ? month : '',
          year: year ? year : ''
        };
      }

      $scope.reload = function() {
        $scope.promise = api.paidbill_service.getAll.get($scope.doordelivery_query, paidbill_success).$promise;
      };
      $scope.reload();
    };

    getDessertsss();

    $scope.$watch('doordelivery_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.doordelivery_query.page ? $scope.doordelivery_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.doordelivery_query.page = 1
      }
      if (!newValue) {
        $scope.doordelivery_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss = getDessertsss;
      $scope.reload();
    });

    // Clear search text
    //-----------------------

    $scope.clearText = function() {
      $scope.doordelivery_query.filter = '';
    }


    // GET CATEGORY NAME
    //---------------- 
    //filter who was created for particular bill
    $scope.paidbill_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //to find who was edit this bill
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
   //get customer number
    $scope.paidbill_customermobiles = function(rmInfo) {
      for (var i = 0; i < customer_details.length; i++) {
        if (customer_details[i].customer_id == rmInfo.customer_id) {
          return customer_details[i].customer_mobile
        }
      }
    };

    vm.paidbillss = $rootScope.datas; //assign filtered datas from the service
    //refresh button kindly we are not using this
    $scope.refresh = function() {
      vm.paidbillss = $rootScope.datas;
    }

    var originatorEv;
    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
    //filter tax data for branch wise
    var taxss = taxs.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })


        //check whether the branch conatins points data if not assign 0 value default
        if (point.length) { // no data in database
          var point_data = point.filter(function(item) {
            // check branch 
            if (item.branch_id == $rootScope.user[0].branch_id) {
              return item
            }
          })
    
          //check whether the branch conatins points data   
          if (point_data.length) {
            $scope.points = point_data;
          }
          // If not data for particular data
          else {
            var point_data = [{
              'amount': 0,
              'perpoint_amount': 0,
              'EnableFirstTime': 0,
              'FirstTimePoint': 0,
              'enablepoint': 0
            }]
            $scope.points = point_data;
          }
        }
        //// If not data in database
        else {
          var point_data = [{
            'amount': 0,
            'perpoint_amount': 0,
            'EnableFirstTime': 0,
            'FirstTimePoint': 0,
            'enablepoint': 0
          }]
          $scope.points = point_data;
        }
    
          // Delete the purchase order
    $scope.removeRow = function(item, ev, index) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this bill?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {

        var customer_ids = item.customer_id;
        if(customer_ids) {
              var oldpointsdb = [];
                // Based on id getting points
                customer_details.map(function(customer) {
                  if (customer_ids == customer.customer_id) {
                    oldpointsdb.push(customer.pointsEarned)
                  }
                });

          var billPoints = Math.floor(item.payment_total / $scope.points[0].amount);
          var dbPoints = Math.floor(oldpointsdb[0])
          var pointsValue = (parseFloat(dbPoints) - parseFloat(billPoints));
          var updatePoints = pointsValue < 0 ? 0 : pointsValue;
          var pointsEarned = [{ 'pointsEarned': updatePoints }]

      api.update_earnpoint.getID.update({ customer_id: customer_ids }, pointsEarned,
        function(response) {});
          }
            // Getting items using sale order id
            api.dietitems.getaData.get({ salesorder_id: item.salesorder_id },
            function(response) {
              vm.fmitems = response;
              var Items = vm.fmitems.map(function(item) {
                return { 'fmItemID': item.fmItemID, 'item_quantity': item.sales_quantity };            
              });
              // Increase stock data of each item
              api.deleteAndupdate_newbill_quantity.getID.update({ siItemID: Items[0].fmItemID, salesitem_id: 'multidelete'}, Items,
                function(response) {             

                },
                function() {
                  // Canceled
                });
            });
            console.log('trash')
            var items = ['1','2']
            // trash sale order with relationship tables
          api.trash_pos_ordered.getID.update({ salesorder_id: item.salesorder_id }, items,
              function(response) {
                //success callback
                deleteItem(item);
              },
              function(response) {
                // error callback
              }
            ); 

          }, function() {
            // Canceled
          });

          /**
           * 
           * Delete index of the  Item
           */
          function deleteItem(item) {
            vm.paidbill.splice(vm.paidbill.indexOf(item), 1);
            $mdToast.show({
              template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        }
  
  //check whether tax data contains or not
    if (taxss.length) {
      if(taxss.length==1){
        var tax_data = [{ 'taxName': taxss[0].taxName, 'taxRate': taxss[0].taxRate }, { 'taxName': 'SGST', 'taxRate': 0 }]
      }else{
        var tax_data = taxss; 
      }
    } else {
       var tax_data = [{ 'taxName': 'CGST', 'taxRate': 0 }, { 'taxName': 'SGST', 'taxRate': 0 }]
    }
    //filter points data for branch wise
    var point_data = point.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    //open popup for view purpose
    $scope.paidbillDialog = function(ev, paidbill) {
      $mdDialog.show({
        controller: 'viewbillController',
        templateUrl: 'app/main/cashier/billing/bill-dialog/bill-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          salebills: paidbill.salesorder_id,
          customer_id: paidbill.customer_id,
          taxs: tax_data,
          point: point_data,
          dietType: dietType,
          branch_data: branch_data,
          editbill: 'finishedbill',
          printInfo: 'finishedbill'

        }
      })
    }
    var printInfo = 'finishedbill';
        // function for edit data from viewbill to newbill when popup opened
    $scope.Editpos = function(salesorder_id,customer_id) {
      var id = salesorder_id;
      $scope.params = $stateParams;
      $state.go('app.newBill', { id: salesorder_id, customer_id: customer_id, editbill:  'finishedbill' })
    };
    //click print function
    $scope.printToCart = function(paidbill) {
      $scope.id = paidbill.salesorder_id;
      var customer_id = paidbill.customer_id;
      var salesId = paidbill.salesorder_id;
      var vm = this;
      var printBill = angular.copy($scope.id)
      $rootScope.$broadcast("salesId", salesId, tax_data, point_data, customer_id, branch_data, printInfo, dietType);

    };
/*==========================================================================
                                      Download db
     ========================================================================== */
    if (vm.settings.databasebackup & vm.dbbackupPath.paidBillPage) {
      downloaded();
      function downloaded() {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var hours = dateObj.getHours();
        var Min = dateObj.getMinutes();
        var sec = dateObj.getSeconds();
        var millsec = dateObj.getMilliseconds();

        var newdate = month + "-" + day + "-" + year + "-" + hours + "-" + Min + "-" + sec + "-" + millsec;
        //  var date = new Date().toJSON();      
        var downloadPath = vm.dbbackupPath.downloadpath;
        var mysqlDumpPath = vm.dbbackupPath.mysqlDumpPath;
        var data = {
          Date: newdate,
          mysqlDumpPath: mysqlDumpPath,
          downloadPath: downloadPath
        }
        api.dbdownload.getAll.save(data,
          // Success
          function(response) {

          });
      };
    }
// end



  }
})();

(function () {
  'use strict';

  angular
    .module('app.billing.newBill')
    .controller('NewBillController', NewBillController)
    .directive('validNumber', function () {
      return {
        require: '?ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
          if (!ngModelCtrl) {
            return;
          }

          ngModelCtrl.$parsers.push(function (val) {
            var clean = val.replace(/^[^1-9]*|[^0-9]/g, '');
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.on('keypress', function (event) {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    })
    .directive('navigatable', function () {
      return function (scope, element, attr) {

        element.on('keyup', ['input[type="text"]', '.autodd input'], handleNavigation);

        function handleNavigation(e) {

          var key = e.keyCode ? e.keyCode : e.which;
          if ($("tr:last-child").hasClass("selection") && e.keyCode == 39) {

          }

          var arrow = { left: 37, up: 38, right: 39, down: 40 };

          if ($.inArray(e.which, [arrow.left, arrow.up, arrow.right, arrow.down]) < 0) { return; }

          var input = e.target;
          var td = $(e.target).closest('td');
          var moveTo = null;

          switch (e.which) {

            case arrow.left:
              {
                if (input.selectionStart == 0) {
                  moveTo = td.prev('td:has(input,textarea)');
                }
                break;
              }
            case arrow.right:
              {
                if (input.selectionEnd == input.value.length) {
                  moveTo = td.next('td:has(input,textarea)');
                };
                break;
              }

            case arrow.up:
            case arrow.down:
              {

                var tr = td.closest('tr');
                var pos = td[0].cellIndex;
                var moveToRow = null;
                if ($('table md-autocomplete-wrap').hasClass('md-menu-showing')) { } else {
                  if (e.which == arrow.down) {
                    moveToRow = tr.next('tr');
                  } else if (e.which == arrow.up) {
                    moveToRow = tr.prev('tr');
                  }

                  if (moveToRow.length) {
                    moveTo = $(moveToRow[0].cells[pos]);

                  }
                  break;
                }
              }

          }

          if (moveTo && moveTo.length) {
            e.preventDefault();

            moveTo.find('input,textarea').each(function (i, input) {
              input.focus();
              input.select();
            });

          }


        }
      };
    })



  /** @ngInject */
  function NewBillController(fmitem_sale, locality, dietType, ThirdParty, $cookies, point, branch_data, userRole, $mdpTimePicker, customer_details, $mdpDatePicker, $rootScope, $document, $window, $state, $stateParams, $mdDialog, $mdToast, $http, api, staffRole, $q, $log, $scope, $timeout, TableNo, taxs, corporate_settings_Data, fmCategory, siCategory, $translate, $filter) {
    // Data
    //----------------
    var vm = this;
    // Local data base
    //$rootScope.domain_connectivity = corporate_settings_Data.domain.connectivity_select;

    // filter branch data 
    vm.branchFilterData = branch_data.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });

    //  console.log(vm.branchFilterData[0].barcode_enable);


    vm.tablenos = TableNo.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });
    //filter tax data branch wise
    var tax_data = taxs.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });

    //clear thirdparty when tab change in dietType
    $scope.clearThirdparty = function (e, dietType) {
      //console.log(e.which);
      if (dietType == 'dinein') {
        vm.billing.thirdparty_id = ''
      };
      // Clear cash when click door delivery
      if (dietType == vm.dietType[2].value) {
        vm.payment.payment_mode = '';
      } else {
        vm.payment.payment_mode = 'cash';
      };
    };
    // dealer and customer

    //When enter in diettype focus to table autocomplete
    $scope.select = function (e) {
      if (e.which === 13) {
        $('input[type=search]').focus();
      };
    };

    //check whether tax data contains or not
    if (tax_data.length) {
      if (tax_data.length == 1) {
        vm.taxs = [{ 'taxName': tax_data[0].taxName, 'taxRate': tax_data[0].taxRate }, { 'taxName': 'SGST', 'taxRate': 0 }]
      } else {
        vm.taxs = tax_data;
      }
    } else {
      vm.taxs = [{ 'taxName': 'CGST', 'taxRate': 0 }, { 'taxName': 'SGST', 'taxRate': 0 }]
    }

    //filter stff role  for branch wise
    var userRoles = userRole.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    //filter staffs for order taken
    var staffRoles = staffRole.filter(function (item) {
      if (userRoles.length) {
        if (item.branch_id == $rootScope.user[0].branch_id && userRoles[0].roleID == item.roleID && item.status == "active") {
          return item
        }
      }
    })
    var staff_all = [{ 'name': 'None', 'staffID': '' }]
    vm.staffs = staff_all.concat(staffRoles); //concat two array and order taken array

    //Login user which branch he is
    var filterbranch = branch_data.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    //filter third party data for branch wise
    vm.ThirdParties = ThirdParty.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    var ThirdParty_all = [{ 'thirdparty_name': 'None', 'thirdparty_id': '' }]
    vm.ThirdPartys = ThirdParty_all.concat(vm.ThirdParties); //concat all third party array and filtered third party array
    //depending on third party id will show name in third party order no input
    $scope.getThirdPartyName = function (thirdparty_id) {
      for (var i = 0; i < vm.ThirdParties.length; i++) {
        if (vm.ThirdParties[i].thirdparty_id == thirdparty_id)
          return vm.ThirdParties[i].thirdparty_name
      }
    }
    //apply data to frond end
    $scope.prTabName = dietType.newbill.activeTab;
    vm.dietType = dietType.newbill.dietTypeLists;
    $scope.hideTax = dietType.newbill.tax_status[0].value;
    $scope.hideRate = dietType.newbill.tax_status[0];
    vm.settings = dietType.settings || {};
    vm.barcode = dietType.barcode;
    vm.print = dietType.print;
    vm.dealerLists = dietType.newbill.dealerLists;
    vm.customerpoints = dietType.customerpoints;
    vm.validation = dietType.validation;
    $scope.feedbackjson = dietType.newbill.feedbackLists[0];
    $scope.branchfooter = filterbranch[0].print_footer;
    $scope.branchaddress = filterbranch[0].address;
    var branchGstNoCheck = (filterbranch[0].GstNo == 'null' || !filterbranch[0].GstNo) ? '' : filterbranch[0].GstNo;
    $scope.branchGstNo = branchGstNoCheck;
    $scope.contact_number = filterbranch[0].contact_number
    $scope.params = $stateParams;
    $rootScope.user = $cookies.getObject('user');

    //payment types which shows in dropdown
    vm.paymentTypes = [{
      "name": 'Fully paid',
      "value": 'paid'
    }, {
      "name": 'Advance',
      "value": 'advance'
    }, {
      "name": 'Unpayable',
      "value": 'unpaid'
    }];

    //payment online types which shows in dropdown
    vm.onlineTypes = dietType.onlineTypes;
    //clear data when staff change other payments ex. cash, online, card & online
    $scope.disble_unpaid_data = function () {
      vm.payment.unpaid_reason = ''
      vm.payment.unpaid_description = ''
    }
    $scope.clear_card = function () {
      vm.payment.transcation_no = ''
      vm.payment.payment_received = ''
      vm.payment.payment_transferred = ''
      vm.payment.online_type = ''

    }
    // feed points value to remaining points input
    $scope.initData = function () {
      if ($scope.customer) {
        vm.userPoints = $scope.customer.pointsEarned;
      } else {
        vm.userPoints = $scope.customer_data.pointsEarned;
      };
    };

    $scope.changedata = function () {
      if (vm.payment.payment_mode == 'card' || vm.payment.payment_mode == 'cash & card') {
        vm.payment.online_type = 0;
      } else {
        vm.payment.online_type = '';
      }
    }
    //check whether the branch conatins points data if not assign 0 value default
    if (point.length) { // no data in database
      var point_data = point.filter(function (item) {
        // check branch 
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })

      //check whether the branch conatins points data   
      if (point_data.length) {
        $scope.points = point_data;
      }
      // If not data for particular data
      else {
        var point_data = [{
          'amount': 0,
          'perpoint_amount': 0,
          'EnableFirstTime': 0,
          'FirstTimePoint': 0,
          'enablepoint': 0
        }]
        $scope.points = point_data;
      }
    }
    //// If not data in database
    else {
      var point_data = [{
        'amount': 0,
        'perpoint_amount': 0,
        'EnableFirstTime': 0,
        'FirstTimePoint': 0,
        'enablepoint': 0
      }]
      $scope.points = point_data;
    }

    //filter only number values
    $scope.filterValue = function ($event) {
      if (isNaN(String.fromCharCode($event.keyCode))) {
        $event.preventDefault();
      }
    };

    //filter locality data branch wise which came from db
    var localityy = locality.filter(function (data) {
      return [$rootScope.user[0].branch_id].some(function (branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.locality = localityy;
    // staff id filter
    //filter third party data for branch wise
    vm.staffIDPrint = ThirdParty.filter(function (item) {
      if (item.branch_id == $rootScope.user[0].staffID) {
        return item
      }
    })

    // only number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    // Phone number validation
    $scope.phonenumber = phonenumber;

    function phonenumber(e) {
      if (e.target.value.length > 9) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };

    $scope.myDate = new Date(); //apply today date

    //retrict date only 30 days move on backward from md pciker
    $scope.minDates = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );
    $scope.billinfo = true //initial tab activtion
    //tap when tab
    $scope.errormsgBillinfo = function () {
      $scope.billinfo = true;
      $scope.customerinfo = false
      $scope.showfeedback = false
      $scope.showpayment = false
    }
    //tap when tab
    $scope.feedbacks = function () {
      $scope.showfeedback = true;
      $scope.customerinfo = false
      $scope.billinfo = false
      $scope.showpayment = false

    }
    $scope.paymenttab = function () {
      $scope.showfeedback = false;
      $scope.customerinfo = false
      $scope.billinfo = false;
      $scope.showpayment = true;
    }
    //tap when tab
    $scope.errormsgCustomer = function () {
      $scope.customerinfo = true
      $scope.showfeedback = false;
      $scope.billinfo = false
      $scope.showpayment = false
    }
    // Get staff Name using login id
    api.getstaff.getID.get({ staffID: $rootScope.user[0].staffID },
      function (response) {
        vm.staffName = response[0].name;
      })
    //clear payment values depending on tab change
    $scope.disble_paymentmode = function () {
      if (vm.payment.payment_status == 'unpaid') {
        vm.payment.transcation_no = ''
        vm.payment.payment_received = ''
        vm.payment.payment_transferred = ''
        vm.payment.unpaid_reason = ''
        vm.payment.payment_mode = ''
        vm.payment.online_type = ''
        vm.payment.unpaid_description = ''
      }
      if (vm.payment.payment_status == 'advance') {
        vm.payment.transcation_no = ''
        vm.payment.online_type = ''
        vm.payment.payment_received = ''
        vm.payment.payment_transferred = ''
        vm.payment.unpaid_reason = ''
        vm.payment.unpaid_description = ''
      }
      if (vm.payment.payment_status == 'paid') {
        vm.payment.transcation_no = ''
        vm.payment.online_type = ''
        vm.payment.payment_received = ''
        vm.payment.payment_transferred = ''
        vm.payment.unpaid_reason = ''
        vm.payment.unpaid_description = ''
      }
    }
    $scope.myDate = new Date();
    //retrict date only 30 days move on backward from md pciker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() + 150
    );
    vm.controlShow = 0;
    vm.no_edit_bill = 0;
    // New Bill
    //----------------
    /*
    -------------------------------------------------

    Add scenario init new bill data

    -------------------------------------------------
    */
    // Edit service for get customer information

    if (!$scope.params.id) {
      vm.billing = {
        'tableno': '',
        'dietType': '',
        'paymentselect': '',
        'paymentmode': ''
      }
      vm.billing.sales_deliveryDate = new Date(); // delivery date
      $scope.customer = ''
      vm.fmitems = [{}]
      // vm.payment = '';
      vm.payment = {}
      vm.payment.payment_status = 'paid';
      // restrict the customer name max or min exceeds 
      $scope.feedback = {}
      vm.billing.deliveryTime = "Immediate";
      vm.billing.dietType = "dinein";
      vm.billing.enterTime = new Date();
      if (vm.settings.ngit_cash) {
        vm.payment.payment_mode = 'cash';
      }
      // Clear old points and apply points to amount
      if (!vm.customerpoints.directlyapplypointamount) {
        vm.controlShow = 1;
      }
      vm.activedealer = dietType.newbill.activedealer;
    }
    /*
         -------------------------------------------------

         Edit scenario init new bill data

         -------------------------------------------------
         */
    else {

      // Edit Bill
      //----------------
      vm.payment = ''; // ng-init clear purpose
      //get salesorder_id from currentbill for edit
      var customer_id = $scope.params.customer_id;
      var existing_customer_id = $scope.params.customer_id;
      var salesorder_ids = $scope.params.id
      $scope.salesId = $scope.params.id
      if (!vm.customerpoints.directlyapplypointamount) {
        vm.controlShow = 0;
      }

      //service for get all  salesorder items
      api.dietitems.getaData.get({ salesorder_id: salesorder_ids },
        function (response) {

          $scope.response = response;
          vm.fmitemsResponse = angular.copy(response); // kot print compare which is edited or add
          vm.fmitems = response;
          // console.log(vm.fmitems);
          //apply data and calculation for printbill 
          $scope.fmitems = response;
          var subtotal = 0;
          $scope.sales_quantity = 0;
          angular.forEach($scope.fmitems, function (fmitem) {
            //console.log(fmitem.profit_difference)
            var item = (fmitem != null) ? fmitem.salesitem_rate : 0;
            var qty = (fmitem != null) ? fmitem.sales_quantity : 0;
            subtotal += item * qty;
            $scope.sales_quantity += fmitem.sales_quantity;
            $scope.fmitems.subTotal = subtotal;
            $scope.fmitems.profit_difference = fmitem.profit_difference;
          })

        });
      // Edit service for get all  salesorder datas
      api.salesorder_diet.getID.get({ salesorder_id: salesorder_ids },
        function (response) {
          //$scope.response = response;
          vm.billing = {
            'tableno': response[0].tableitem,
            'thirdparty_id': response[0].thirdparty_id,
            'thirdparty_orderno': response[0].thirdparty_orderno,
            'dietType': response[0].sales_dietType,
            'staff': response[0].orderTakenID,
            'deliveryTime': response[0].sales_deliveryStatus,
            'enterTime': response[0].sales_deliveryTime,
            'return_bill_no': response[0].return_bill_no,
            'return_salebill_no': response[0].return_salebill_no
          }
          var DeLiveryTime = response[0].sales_deliveryTime == '' ? '' : new Date(response[0].sales_deliveryTime);
          var DeLiveryDate = response[0].sales_deliveryDate == 'undefined' ? '' : new Date(response[0].sales_deliveryDate);
          vm.activedealer = response[0].dealer_status;
          // If take away and door delivery only allow data to delivery date and time
          if (response[0].sales_dietType == "takeaway" || response[0].sales_dietType == "doordelivery" || response[0].sales_deliveryStatus == "Schedule") {
            vm.billing.enterTime = DeLiveryTime
            vm.billing.sales_deliveryDate = DeLiveryDate
          }
        });
      api.customer_infodiet.getID.get({ salesorder_id: customer_id },
        function (response) {
          $scope.customer_data = response[0];
        });

      // Edit service for get customer information
      /*  api.customer_infodiet.getID.get({ salesorder_id: customer_id},
          function(response) {
            console.log(response);
           // $scope.customer_data = response[0];
          }) */
      //Edit service for get all sales payments
      api.payment_diet.getID.get({ salesorder_id: salesorder_ids },
        function (response) {
          // console.log(response)
          $scope.payment_round_total = response[0].payment_total;
          $scope.total_pointdiscount = response[0].pointdiscount;
          // points calculation earned point to know
          if ($scope.customer_data) {
            $scope.customer_data.pointsEarned = Math.floor(response[0].pointdiscount / point_data[0].perpoint_amount);
            vm.no_edit_bill = !$scope.total_pointdiscount ? 0 : 1
            // console.log(vm.no_edit_bill);
          }
          vm.billing.discount_type = response[0].discount_type == 'undefined' ? 'amount' : response[0].discount_type;
          vm.billing.discount = response[0].discount;
          var subtotal = 0;
          vm.billing.subTotal = 0;
          angular.forEach(vm.fmitems, function (fmitem) {
            // console.log(fmitem)
            //calculate itemfulltotal 
            var item = (fmitem.sales_items != null) ? fmitem.salesitem_rate : 0;
            var qty = (fmitem.sales_items != null) ? fmitem.sales_quantity : 0;
            fmitem.subitemtotal = item * qty;
            subtotal += item * qty;
          })
          vm.billing.tax = 0;
          vm.billing.tax_sgst = 0;
          vm.billing.tax_cgstInclude = 0;
          vm.billing.tax_sgstInclude = 0;

          if (dietType.settings.global_tax) {
            vm.billing.subTotal = subtotal
            vm.billing.tax = (subtotal / 100) * vm.taxs[0].taxRate;
            vm.billing.tax_sgst = (subtotal / 100) * vm.taxs[1].taxRate;
          } else if (dietType.settings.indivudual_exclude) {
            //tax_status 1 is for exclude(added tax in current item)
            //tax_status 2 is for include(not added tax in current item)
            $scope.fullcgst = 0;
            $scope.fullsgst = 0;
            $scope.fullrate = 0;
            $scope.fullcgstpercent = 0;
            $scope.fullsgstpercent = 0;
            $scope.fullexcluderate = 0;
            angular.forEach(vm.fmitems, function (fmitem) {
              //apply data if tax status is exclude in local corporate folder
              if (fmitem.tax_status == 'exclude') { //exclude status in bill
                fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
                fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
                fmitem.tax_cgstPerItem = (fmitem.item_subrate / 100) * fmitem.tax_cgst;
                fmitem.tax_sgstPerItem = (fmitem.item_subrate / 100) * fmitem.tax_sgst;
                // New bill and current bill
                vm.billing.tax_cgstInclude += (fmitem.item_subrate / 100) * fmitem.tax_cgst;
                vm.billing.tax_sgstInclude += (fmitem.item_subrate / 100) * fmitem.tax_sgst;
                vm.billing.subTotal = subtotal + (vm.billing.tax_cgstInclude + vm.billing.tax_sgstInclude);
                // for tax calculation
                $scope.fullcgstpercent += fmitem.tax_cgst;
                $scope.fullsgstpercent += fmitem.tax_sgst;
                // Print bill calculation
                $scope.fullcgst += (fmitem.item_subrate / 100) * fmitem.tax_cgst;
                $scope.fullsgst += (fmitem.item_subrate / 100) * fmitem.tax_sgst;
                $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
                $scope.fullexcluderate += (fmitem.sales_quantity * fmitem.salesitem_rate)
                $scope.totalTax = $scope.fullcgst + $scope.fullsgst
                $scope.excludesubTotal = subtotal + $scope.totalTax;
              } else if (fmitem.tax_status == 'include') { //include status in bill
                //apply data if tax status is include in local corporate folder
                fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
                fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
                vm.billing.tax_cgstInclude += (fmitem.item_subrate / 100) * fmitem.tax_cgst;
                vm.billing.tax_sgstInclude += (fmitem.item_subrate / 100) * fmitem.tax_sgst;
                vm.billing.subTotal = subtotal;
                fmitem.tax_cgstPerItem = (fmitem.item_subrate / 100) * fmitem.tax_cgst;
                fmitem.tax_sgstPerItem = (fmitem.item_subrate / 100) * fmitem.tax_sgst;
                // for tax calculation
                $scope.fullcgstpercent += fmitem.tax_cgst;
                $scope.fullsgstpercent += fmitem.tax_sgst;
                //  Print bill calculation
                $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
                $scope.totalTax = $scope.fullcgst + $scope.fullsgst;
              }

            })
          }
          var savings = 0
          //get offer discount
          for (var i = 0; i < vm.fmitems.length; i++) {
            if (vm.fmitems[i].offerprice) {
              //savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].offerprice))
              savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].salesitem_rate))
            }
          }
          $scope.savedamount = savings;
          $scope.total_pointdiscount = parseInt(response[0].pointdiscount);
          //offer+point discount
          vm.billing.additional_charge = response[0].additional_charge;

          if (vm.billing.discount_type == 'amount') {
            var discount = (vm.billing.discount != null) ? vm.billing.discount : '';
            var pointdiscount = $scope.total_pointdiscount != null ? $scope.total_pointdiscount : 0;
            var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : '';
            vm.billing.roundtotal = response[0].payment_total;
          } else if (vm.billing.discount_type == 'percent') {
            var discount = (vm.billing.discount != null) ? vm.billing.discount : '';
            var pointdiscount = $scope.total_pointdiscount != null ? $scope.total_pointdiscount : 0;
            var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : '';
            // Data should be in percent so calculate to amount
            if (dietType.settings.global_tax) {
              vm.billing.discount_percent = ((vm.billing.subTotal + vm.billing.tax + vm.billing.tax_sgst + additional_charge) / 100) * discount;
            } //if exclude status to calculate in discount percent
            else if (vm.fmitems[0].tax_status == 'exclude') {
              vm.billing.discount_percent = ((vm.billing.subTotal + vm.billing.additional_charge) / 100) * vm.billing.discount;
            } else if (vm.fmitems[0].tax_status == 'include') { //include status in bill

              vm.billing.discount_percent = ((vm.billing.subTotal + vm.billing.additional_charge) / 100) * vm.billing.discount;
            }
            vm.billing.roundtotal = response[0].payment_total;
          }

          vm.billing.discount = response[0].discount; // for input value
          vm.billing.additional_charge = response[0].additional_charge

          vm.payment = response[0];
          if (vm.payment.unpaid_description) {
            $scope.OpenDescription = true;
          }

          if (vm.billing.discount && !vm.billing.return_bill_no) {
            $scope.OpenPermission = true;
            $scope.hideclose = true;
          };
          if (vm.billing.return_bill_no) {
            $scope.OpenPermissionreturn = true;
            $scope.hideclose = hide;
            $scope.disabledreturnbill = true;
          };

          if (vm.billing.additional_charge) {
            $scope.OpenCharge = true;
          }

          vm.payment.payment_status = (response[0].payment_status != '') ? response[0].payment_status : 'paid';

        })

      //Edit service for get customer feedback
      api.customer_feedbackdiet.getID.get({ salesorder_id: salesorder_ids },
        function (response) {
          $scope.feedback = response[0];
        });
      vm.fmitemsKot = []; // KOT print data
    }
    /*--------------
    Edit scenario end
    ------------*/
    // var MENUITEM = $translate.instant('RESTRAUNTANT.ENTER-THE-ITEMS');   
    // Add placeholder for autocomplete
    $timeout(function () {
      $(".foodItem-auto input").attr("placeholder", $translate.instant('RESTRAUNTANT.ENTER-THE-ITEMS'));
    }, 500);

    //autofocus for diet type
    $scope.focus = focus;

    function focus() {
      $timeout(function () {
        angular.element('#radio-focus').focus();
      }, 100);
    }
    //autofocus for sales_Payment
    $scope.focuspay = focuspay;

    function focuspay() {
      $timeout(function () {
        angular.element('#radio-focuspay').focus();
      }, 100);
    }
    //autofocus for manageby
    $scope.focusmanage = focusmanage;

    function focusmanage() {
      $timeout(function () {
        angular.element('#radio-focusmanage').focus();
      }, 100);
    }


    //autofocus for customer
    $scope.focuscustomer = focuscustomer;

    function focuscustomer() {
      $timeout(function () {
        angular.element('#radio-focuscustomer').focus();
      }, 100);
    }

    if (vm.settings.dinein_permission) {
      $timeout(function () {
        angular.element('#radio-focus').focus();
      }, 100);
    } else {
      $timeout(function () {
        angular.element('table tr td input[type=search]').focus();
      }, 100);
    }
    /*
        $timeout(function() {
          angular.element('#radio-focus').focus();
        }, 100);
     */


    vm.paymentmode = '%';
    vm.paymentmodelist = [{
      "name": '₹',
      "value": '₹'
    }, {
      "name": '%',
      "value": '%'
    }];



    $scope.addRow = addRow;

    // Add Row
    //----------------
    function addRow() {
      vm.fmitems.push({});
      $scope.indx = vm.fmitems.length - 1;
      $scope.$watch(vm.fmitems, function () {
        $timeout(function () {
          angular.element('.autodd').focus();
        }, 10);
      })
    };
    //when enter key pressed new row will be pushed
    $scope.keyPressed = function (keyEvent) {

      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        vm.fmitems.push({});
        $scope.indx = vm.fmitems.length - 1;
        $scope.$watch(vm.fmitems, function () {
          $timeout(function () {
            angular.element('.autodd input').focus();
          }, 10);

        })

      }
    };
    //when enter key pressed new row will be pushed
    $scope.keyPressedNextMove = function (keyEvent, index) {
      if (keyEvent.keyCode == 13 || keyEvent.which == 13) {
        $timeout(function () {
          $('.qty').focus().select();
        }, 10);

        //})
      }
    };
    // Highlight row when focus input
    $scope.setfoucus = function (index) {
      var highlightRow = "table tr:nth-child(" + (index + 1) + ")";
      $('table tr').removeClass("selection");
      $(highlightRow).addClass("selection");
    }

    //when enter key barcode pressed
    $scope.barcodekeyPressed = function ($event, inputValue) {
      //console.log($event.target.offsetParent.classList); 
      /* var invalidList = $event.target.offsetParent.classList;
       if ($event.keyCode == 13 || $event.which == 13) {
         $timeout(function() {
             var itemLength = $('.md-autocomplete-suggestions-container:not(.ng-hide) ul li').length;
             if(itemLength == 1) {
               $('.md-autocomplete-suggestions-container:not(.ng-hide) li:first-child').click();
               $('.qty').focus().select();
             };
             let invalid = [];
             for (let i = 0; i < invalidList.length; i++) {
               if (invalidList[i] == 'md-input-invalid') {
                 invalid.push(invalidList[i]); 
               }
             }
             if(invalid.length==0 && itemLength < 1) {
               $('.qty').focus().select();
             }
         }, vm.barcode.scanner_delay);      
       }
       */
      //var ulId = $event.target.attributes[13].nodeValue;
      //console.log($event.target.attributes[13].nodeValue);
      if ($event.keyCode == 13 || $event.which == 13) {
        var validList = $event.target.classList;
        var valid = [];
        for (var i = 0; i < validList.length; i++) {
          if (validList[i] == 'ng-valid-md-require-match' || validList[i] == 'ng-valid') {
            valid.push(validList[i]);
          }
        };
        var setint = setInterval(function () {
          var itemLength = $('.md-autocomplete-suggestions-container:not(.ng-hide) li').length;
          var autocompleteopen = $('.md-autocomplete-suggestions-container:not(.ng-hide)').length;
          if (itemLength == 1) {
            $('.md-autocomplete-suggestions-container:not(.ng-hide) li:first-child').click();
            //$('ul#'+ulId+' li:first-child').trigger("click");
            $('.qty').focus();
            $timeout(function () {
              $('.qty').select();
            }, 0);
            clearInterval(setint);
          } else if (itemLength > 0 && autocompleteopen) {
            clearInterval(setint);
          }
          if (valid.length > 0 && autocompleteopen == 0) {
            $('.qty').select();
            clearInterval(setint);
          }
        }, vm.barcode.scanner_interval_delay);
        setTimeout(function () {
          clearInterval(setint);
        }, vm.barcode.scanner_timeout_intervalFunction); //10 seconds
      }
    };



    // Remove Row
    $scope.removeRow = function (fmitem, ev, index) {
      if (!fmitem.salesitem_id) {
        vm.fmitems.splice(index, 1);
      } else {
        var confirm = $mdDialog.confirm()
          .title('Delete')
          .htmlContent('Are you sure you want to delete this item?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');
        $mdDialog.show(confirm).then(function () {
          var item_quantity = { 'item_quantity': fmitem.sales_quantity }
          //this service is for when staff edit exist row items in list to update the quanity
          api.deleteAndupdate_newbill_quantity.getID.update({ siItemID: fmitem.fmItemID, salesitem_id: fmitem.salesitem_id }, item_quantity,
            function (response) {
              api.deletesales_items.getID.delete({ salesitem_id: fmitem.salesitem_id },
                function (response) {
                  //success callback
                  deleteItem(fmitem);
                },
                function (response) {
                  // error callback
                }
              );

            },
            function () {
              // Canceled
            });
        })
        var deleteItemData = { 'display': fmitem.display, 'sales_items': fmitem.sales_items, 'sales_quantity': fmitem.sales_quantity, 'type': "deleted" }
        vm.fmitemsKot.push(deleteItemData)
      };
      /**
       * Delete Item
       */
      function deleteItem(fmitem) {
        vm.fmitems.splice(vm.fmitems.indexOf(fmitem), 1);
        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //function for Breadcrumb Label with idnewBill
    $rootScope.getBreadcrumbLabel = function () {
      if ($scope.params.id) {
        return $scope.params.id
      } else if (!$scope.params.id) {
        return "New Bill"
      }
    }

    $scope.clearpointdiscount = true;
    //clear tab and close point button
    $scope.clearIconpointdiscount = function () {
      $scope.clearpointdiscount = false;
    }
    //when customer have credit point tab will be auto open
    $scope.clearcustomerChangepointdiscount = function () {
      $scope.clearpointdiscount = true;
    }

    $scope.OpenRemainPoints = false;
    //clear tab and close point button
    $scope.openRemainpointdiscount = function () {
      $scope.OpenRemainPoints = true;
    }
    vm.clearPointback = 0;
    vm.pointOldCountNotIncrease = 0;
    // Total Calculation
    //watch funcion as stored in variable for if  changing front end values will be changed
    var calculateTotals = function () {
      var subtotal = 0;
      var totalqty = 0;
      var profit;
      vm.billing.subTotal = 0
      $scope.sales_quantity = 0;
      angular.forEach(vm.fmitems, function (fmitem) {
        var item = (fmitem.salesitem_rate != null) ? fmitem.salesitem_rate : 0;
        var qty = (fmitem.sales_quantity != null) ? fmitem.sales_quantity : 0;
        fmitem.subitemtotal = item * qty;
        $scope.sales_quantity += parseInt(fmitem.sales_quantity);
        totalqty += parseInt(fmitem.sales_quantity);
        subtotal += item * qty;
        var purchase_Price = (fmitem.PurchasePrice == undefined) ? 0 : fmitem.PurchasePrice;
        var contain_Qty = (fmitem.containQty == undefined) ? 0 : fmitem.containQty;

        if (fmitem.fmItemID) {
          fmitem.profit_difference = fmitem.profit_difference;
        } else {
          // Default contain_Qty to 1 if it is 0
          var cQty = (contain_Qty == 0) ? 1 : contain_Qty;
          var profit = 0;
          if (purchase_Price == 0) {
            profit = 0;
          } else {
            var cost_per_unit = purchase_Price / cQty;
            var profit_per_unit = item - cost_per_unit;
            profit = profit_per_unit * qty;
          }
          fmitem.profit_difference = (profit < 0) ? 0 : profit;
        }
        //console.log(fmitem.profit_difference);
      })
      // console.log(profit)
      // console.log($scope.profit_difference);
      $scope.dataChange = function () {
        // discount type (ex. %, rs)
        cals();
      };
      // Apply point amount
      $scope.applypointamount = function (ev) {
        var confirm = $mdDialog.confirm()
          .title('Apply points')
          .htmlContent('Are you sure do you want to apply points to discount in amount? Incase you applied the points and saved the bill. That bill cannot be edit')
          .ariaLabel('apply points')
          .targetEvent(ev)
          .ok('OK')
          .cancel('Cancel');
        $mdDialog.show(confirm).then(function () {
          vm.customerpoints.directlyapplypointamount = 1;
          vm.clearPointback = 1;
          cals();
        }, function () {
          // Canceled
        });

      };
      $scope.clearPointback = function () {
        vm.clearPointback = 0;
        vm.customerpoints.directlyapplypointamount = 0;
        cals();
      }

      // Clear points it is reflect anywhere
      $scope.clearpointvalue = function () {
        vm.pointOldCountNotIncrease = 1;
        cals();
      }
      $scope.dataopen = function () {
        // when the change the customer calculation will happen
        cals();
      };
      cals();

      function cals() {
        data();
        // vm.billing.subTotal = subtotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem);
        vm.totalqty = totalqty;
        vm.billing.tax = 0;
        vm.billing.tax_sgst = 0;
        vm.billing.tax_cgstInclude = 0;
        vm.billing.tax_sgstInclude = 0;
        if (dietType.settings.global_tax) {
          vm.billing.tax = (subtotal / 100) * vm.taxs[0].taxRate;
          vm.billing.tax_sgst = (subtotal / 100) * vm.taxs[1].taxRate;
          vm.billing.subTotal = subtotal;
        } else if (dietType.settings.indivudual_exclude) {
          //tax_status 1 is for exclude(added tax in current item)
          //tax_status 2 is for include(not added tax in current item)
          $scope.fullcgst = 0;
          $scope.fullsgst = 0;
          $scope.fullrate = 0;
          $scope.fullcgstpercent = 0;
          $scope.fullsgstpercent = 0;
          $scope.fullexcluderate = 0;
          angular.forEach(vm.fmitems, function (fmitem) {
            if (fmitem.tax_status == 'exclude') { //bill in exclude status
              //tax status exlude which came from local corporate folder
              fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
              fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
              fmitem.tax_cgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
              fmitem.tax_sgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
              vm.billing.tax_cgstInclude += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
              vm.billing.tax_sgstInclude += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
              vm.billing.subTotal = subtotal + (vm.billing.tax_cgstInclude + vm.billing.tax_sgstInclude);
              // for tax calculation
              $scope.fullcgstpercent += fmitem.tax_cgst;
              $scope.fullsgstpercent += fmitem.tax_sgst;
              // For print bill data
              $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
              $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
              $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
              $scope.fullexcluderate += (fmitem.sales_quantity * fmitem.salesitem_rate);
              $scope.totalTax = $scope.fullcgst + $scope.fullsgst
              $scope.excludesubTotal = subtotal + $scope.totalTax;

            } else if (fmitem.tax_status == 'include') { //bill in include status
              //tax status include which came from local corporate folder
              vm.billing.subTotal = subtotal;
              fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
              fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
              fmitem.tax_cgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
              fmitem.tax_sgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
              vm.billing.tax_cgstInclude += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
              vm.billing.tax_sgstInclude += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
              // for tax calculation
              $scope.fullcgstpercent += fmitem.tax_cgst;
              $scope.fullsgstpercent += fmitem.tax_sgst;
              // For print bill data
              $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
              $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
              $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
              $scope.totalTax = $scope.fullcgst + $scope.fullsgst;
            }
          })
        }
        if (!vm.billing.discount) {
          vm.billing.discount = '';
        };
        if (!vm.billing.additional_charge) {
          vm.billing.additional_charge = '';
        };

        //this is for existing customer point discount reduction 
        //checking validations and allow pointdiscount if have customer info entered
        function data(roundtotal) {
          if ($scope.points[0].enablepoint == 1 && ($scope.customer || $scope.customer_data) && $scope.clearpointdiscount == true) {
            if ($scope.newBill.autocompleteCustomer.$valid == true) { // validation customer
              if (($scope.customer && $scope.customer.searchText != 0)) {
                // $scope.userPoints = angular.copy($scope.customer.pointsEarned);
                var point = $scope.customer.pointsEarned //applying point already customer earned.
              }
              // for update purpose
              else if ($scope.customer_data && $scope.newBill.autocompleteCustomer.$dirty == false) {
                // = angular.copy($scope.customer_data.pointsEarned);
                var point = $scope.customer_data.pointsEarned //applying point already customer earned.
              }
              // calculation point value with per point amount

              if (!vm.customerpoints.directlyapplypointamount) {
                $scope.total_pointdiscount = 0.00;
              } else {
                $scope.total_pointdiscount = (point == undefined ? 0 : point) * $scope.points[0].perpoint_amount;
              }

            } else {
              $scope.total_pointdiscount = 0.00;
              $scope.point = '';
            }
          } else {
            $scope.total_pointdiscount = 0.00;
            $scope.point = '';
          }
        }
        //calclulation function done here  
        //if discount type is default in amount       
        if (vm.billing.discount_type == 'amount' || vm.billing.discount_type == undefined) {
          var discount = (vm.billing.discount != null) ? vm.billing.discount : 0;
          var pointdiscount = $scope.total_pointdiscount != null ? $scope.total_pointdiscount : 0;
          var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : 0;
          $scope.total = vm.billing.subTotal + vm.billing.tax + vm.billing.tax_sgst - discount + additional_charge;
          vm.billing.roundtotal = Math.round($scope.total);
          //check the condition for pointdiscount reduction
          //The condtion is whether the customer is ate above the admin specified amount
          if (vm.billing.roundtotal >= $scope.points[0].amount) {
            // total sales amount great the point amount will reduce
            vm.billing.roundtotal = vm.billing.roundtotal - pointdiscount;
          } else {
            $scope.total_pointdiscount = 0.00;
            $scope.point = '';
          };
          if (vm.billing.roundtotal < 0) {
            /* $mdToast.show({
               template: '<md-toast class="warning"><span flex>Point discount amount is greater than total amount. So we change total amount to 0</span></md-toast>',
               position: 'bottom right',
               hideDelay: 3000,
               action: "close"
             });*/
            vm.billing.roundtotal = 0;
          };

        } //if discount type is changed to percentage 
        else if (vm.billing.discount_type == 'percent' || vm.billing.discount_type == undefined) {
          var discount = (vm.billing.discount != null) ? vm.billing.discount : 0;
          var pointdiscount = $scope.total_pointdiscount != null ? $scope.total_pointdiscount : 0;
          var additional_charge = (vm.billing.additional_charge != null) ? vm.billing.additional_charge : 0;
          // vm.billing.discount_percent = ((subtotal + vm.billing.tax + vm.billing.tax_sgst + additional_charge) / 100) * discount;

          if (dietType.settings.global_tax) {
            vm.billing.discount_percent = ((vm.billing.subTotal + vm.billing.tax + vm.billing.tax_sgst + additional_charge) / 100) * discount;
          } else if (vm.fmitems[0].tax_status == 'exclude') {

            vm.billing.discount_percent = ((vm.billing.subTotal + vm.billing.additional_charge) / 100) * vm.billing.discount;
          } else if (vm.fmitems[0].tax_status == 'include') { //include status in bill

            vm.billing.discount_percent = ((vm.billing.subTotal + vm.billing.additional_charge) / 100) * vm.billing.discount;
          }

          //vm.billing.discount_percent = (discount / 100) * (subtotal + vm.billing.tax + vm.billing.tax_sgst + additional_charge);
          $scope.total = vm.billing.subTotal + vm.billing.tax + vm.billing.tax_sgst - vm.billing.discount_percent + additional_charge;
          //check the condition for pointdiscount reduction
          //The condtion is whether the customer is ate above the admin specified amount
          vm.billing.roundtotal = Math.round($scope.total);
          if (vm.billing.roundtotal >= $scope.points[0].amount) {
            vm.billing.roundtotal = vm.billing.roundtotal - pointdiscount;
          } else {
            $scope.total_pointdiscount = 0.00;
            $scope.point = '';
          }
          if (vm.billing.roundtotal < 0) {
            /*  $mdToast.show({
                template: '<md-toast class="warning"><span flex>Point discount amount is greater than total amount. So we change total amount to 0</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });*/
            vm.billing.roundtotal = 0;
          };
        }
        //remove row condition :- Disable first index while removing rows,
        if (vm.fmitems.length > 1) {
          $scope.formitem = false;
        } else {
          $scope.formitem = true;
        }
        vm.payment.payment_transferred = vm.payment.payment_received ? vm.billing.roundtotal - vm.payment.payment_received : ''
      }

      if ($scope.receivecash) {
        $scope.balanceCalculation();
      }
    };

    $scope.$watch('vm.fmitems', calculateTotals, true); //watch food ng-models
    var calculate_payment_transferred = function () {
      // received amount calculation to view balance in cash and online type
      vm.payment.payment_transferred = vm.payment.payment_received ? vm.billing.roundtotal - vm.payment.payment_received : '';
    }

    $scope.$watch('vm.payment', calculate_payment_transferred, true); //watch payemnt ng-models
    //clear discount then reply to original amount
    $scope.clearDis = function () {
      if (!vm.billing.discount) {
        vm.billing.discount = 0;
      };
      if (!vm.billing.discount_percent) {
        vm.billing.discount_percent = 0;
      };
      //filter data depending on discount type
      if (vm.billing.discount_type == 'amount') { // when discount in amount type
        vm.billing.roundtotal = parseInt(vm.billing.roundtotal) + parseInt(vm.billing.discount);
        if ($scope.customer && $scope.customer.searchText != 0 && $scope.points[0].enablepoint == 1 && vm.billing.roundtotal >= $scope.points[0].amount && $scope.newBill.autocompleteCustomer.$valid) {
          var point = $scope.customer.pointsEarned
          $scope.total_pointdiscount = (point == undefined ? 0 : point) * $scope.points[0].perpoint_amount;
        }
        if ($scope.customer_data && $scope.points[0].enablepoint == 1 && vm.billing.roundtotal >= $scope.points[0].amount && $scope.newBill.autocompleteCustomer.$dirty == false) {
          var point = $scope.customer_data.pointsEarned
          $scope.total_pointdiscount = (point == undefined ? 0 : point) * $scope.points[0].perpoint_amount;
          $scope.total_pointdiscount = $scope.total_pointdiscount;
        }
        vm.billing.discount = '';
        vm.billing.discount_percent = '';
      } else if (vm.billing.discount_type == 'percent') { // when discount in point type
        vm.billing.roundtotal = parseInt(vm.billing.roundtotal) + parseInt(Math.round(vm.billing.discount_percent));
        if ($scope.customer && $scope.customer.searchText != 0 && $scope.points[0].enablepoint == 1 && vm.billing.roundtotal >= $scope.points[0].amount && $scope.newBill.autocompleteCustomer.$valid) {
          var point = $scope.customer.pointsEarned
          $scope.total_pointdiscount = (point == undefined ? 0 : point) * $scope.points[0].perpoint_amount;
          $scope.total_pointdiscount = $scope.total_pointdiscount;
        }
        if ($scope.customer_data && $scope.points[0].enablepoint == 1 && vm.billing.roundtotal >= $scope.points[0].amount && $scope.newBill.autocompleteCustomer.$dirty == false) {
          var point = $scope.customer_data.pointsEarned
          $scope.total_pointdiscount = (point == undefined ? 0 : point) * $scope.points[0].perpoint_amount;
          $scope.total_pointdiscount = $scope.total_pointdiscount;
        }
        vm.billing.discount_percent = '';
        vm.billing.discount = '';
      }
    }

    //clear additional_charge then reply to original amount
    $scope.clearCharge = function () {
      if (!vm.billing.additional_charge) {
        vm.billing.additional_charge = 0;
      };
      vm.billing.roundtotal = parseInt(vm.billing.roundtotal) - parseInt(vm.billing.additional_charge);
      vm.billing.additional_charge = '';
    }
    $scope.focusdicount = function () {
      $timeout(function () {
        angular.element('#discount-focus').focus();
      }, 100);
    }
    $scope.focusaddCharge = function () {
      $timeout(function () {
        angular.element('#additional_charge-focus').focus();
      }, 100);


    }
    $scope.balancecash = '0.00';
    // Received Cash and Balance Cash
    $scope.balanceCalculation = function () {
      var receivecash = $scope.receivecash != null ? $scope.receivecash : '0';
      $scope.balancecash = receivecash - vm.billing.roundtotal;
    }





    $scope.appitemSelected = [];

    $scope.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    };

    $scope.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    // Add items show and hide condition

    /* $scope.formname = 'newBill';
     $scope.appitemSelected = [];
     vm.fmitems = []; */
    //while select the food items get data for selected index and assign it.
    $scope.selectedMenuItemChange = function (appitemSelected) {
      var fmitem = appitemSelected;
      var len = fmitem.length;
      for (var i = 0; i < len; i++) {
        // vm.fmitems.push(fmitem[i]);
        vm.fmitems.push({
          "searchText": fmitem[i].display,
          sales_items: {
            "sales_items": fmitem[i].display,
            "sales_quantity": fmitem[i].sales_quantity,
            "display": fmitem[i].display,
            "salesitem_rate": fmitem[i].offerprice ? fmitem[i].offerprice : fmitem[i].salesitem_rate,
            "tax_sgst": fmitem[i].tax_sgst,
            "tax_cgst": fmitem[i].tax_cgst,
            "tax_status": fmitem[i].tax_status,
            "offerprice": fmitem[i].offerprice,
            "fmItemID": fmitem[i].fmItemID,
            "fmCatergoryID": fmitem[i].fmCatergoryID,
            "type": fmitem[i].type,
            "fmcatergoryName": fmitem[i].fmcatergoryName
          },
          "salesitem_rate": fmitem[i].offerprice ? fmitem[i].offerprice : fmitem[i].salesitem_rate,
          "actualprice": fmitem[i].salesitem_rate,
          "offerprice": fmitem[i].offerprice,
          "tax_sgst": fmitem[i].tax_sgst,
          "tax_cgst": fmitem[i].tax_cgst,
          "tax_status": fmitem[i].tax_status,
          "sales_quantity": fmitem[i].sales_quantity,
          "fmcatergoryName": fmitem[i].fmcatergoryName
        })
      }
      $scope.appitemSelected = [];
    }
    $scope.showPopupMenu = function () {
      $('.dialogMenuItems').show();
      $('body #layout-vertical-navigation #content-container #content').addClass('top0');
      $('md-toolbar').hide();
      $('.dialogMenuItems .md-menu-toolbar').show();
      $('.bill-color-bg').hide();
    }
    $scope.hidePopupMenu = function () {
      $('.dialogMenuItems').hide();
      $('body #layout-vertical-navigation #content-container #content').removeClass('top0');
      $('md-toolbar').show();
      $('.dialogMenuItems .md-menu-toolbar').hide();
      $('.bill-color-bg').show();
    }
    // ******************************
    // Steward APP
    // ******************************
    $scope.stewardPermision = $cookies.get('steward');
    $scope.windowSize = $(document).width();
    $(window).bind('resize', function () {
      $scope.windowSize = $(document).width();
    });
    $scope.formname = 'newBills';
    //if ($scope.stewardPermision == 'steward' && $scope.windowSize < 960) {
    if ($scope.windowSize < 600) {
      $scope.formname = 'newBill';
      $scope.appitemSelected = [];
      vm.fmitems = [];
    }
    /*   //while select the food items get data for selected index and assign it.
       $scope.selectedMenuItemChange = function (appitemSelected) {
         var fmitem = appitemSelected;
         var len = fmitem.length;
         for (var i = 0; i < len; i++) {
           // vm.fmitems.push(fmitem[i]);
           vm.fmitems.push({
             "searchText": fmitem[i].display,
             sales_items: {
               "sales_items": fmitem[i].display,
               "sales_quantity": fmitem[i].sales_quantity,
               "display": fmitem[i].display,
               "salesitem_rate": fmitem[i].offerprice ? fmitem[i].offerprice : fmitem[i].salesitem_rate,
               "tax_sgst": fmitem[i].tax_sgst,
               "tax_cgst": fmitem[i].tax_cgst,
               "tax_status": fmitem[i].tax_status,
               "offerprice": fmitem[i].offerprice,
               "fmItemID": fmitem[i].fmItemID,
               "fmCatergoryID": fmitem[i].fmCatergoryID,
               "type": fmitem[i].type,
               "fmcatergoryName": fmitem[i].fmcatergoryName
             },
             "salesitem_rate": fmitem[i].offerprice ? fmitem[i].offerprice : fmitem[i].salesitem_rate,
             "actualprice": fmitem[i].salesitem_rate,
             "offerprice": fmitem[i].offerprice,
             "tax_sgst": fmitem[i].tax_sgst,
             "tax_cgst": fmitem[i].tax_cgst,
             "tax_status": fmitem[i].tax_status,
             "sales_quantity": fmitem[i].sales_quantity,
             "fmcatergoryName": fmitem[i].fmcatergoryName
           })
         }
         $scope.appitemSelected = [];
       }
       $scope.showPopupMenu = function () {
         $('.dialogMenuItems').show();
         $('body #layout-vertical-navigation #content-container #content').addClass('top0');
         $('md-toolbar').hide();
         $('.dialogMenuItems .md-menu-toolbar').show();
         $('.bill-color-bg').hide();
       }
       $scope.hidePopupMenu = function () {
         $('.dialogMenuItems').hide();
         $('body #layout-vertical-navigation #content-container #content').removeClass('top0');
         $('md-toolbar').show();
         $('.dialogMenuItems .md-menu-toolbar').hide();
       }
     }
     $scope.item_query = {
       filter: ''
     } */
    $scope.clearText = function () {
      $scope.item_query.filter = '';
    }
    $scope.increment = function (value) {
      //console.log(value);
      //value.count++
      //console.log(value++)
      // if (incremented) { return; }
      //return value.count++
      //incremented = true;
    };
    $scope.decrement = function (value) {
      // if (decremented) { return; }
      return value.count--
      //decremented = true;
    };

    /* end Steward APP */
    // ******************************
    // Internal methods
    // ******************************


    vm.food = loadAll();
    vm.foodItemName = null;
    vm.searchText = null;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;


    /**
     * Search for food... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      var results = query ? vm.food.filter(createFilterFor(query)) : vm.food;
      /* Order change option */
      if (query) {
        var myArray = results;
        //console.log('first result');
        var matchedResults = []; //matched first word letter
        var unmatchedResults = []; //matched second word letter
        function filter(letter) {
          var len = myArray.length;
          for (var i = 0; i < len; i++) {
            if (myArray[i].sales_items.indexOf(letter) == 0) {
              matchedResults.push(myArray[i]);
            } else {
              unmatchedResults.push(myArray[i]);
            }
          }
        }
        filter(query);
        var mergeResults = matchedResults.concat(unmatchedResults);
        //console.log('merge results');
      } else {
        var mergeResults = results;
      }


      // console.log(results);
      var deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(mergeResults);
      }, Math.random() * 10, false);
      return deferred.promise;
    }
    /**
     * Create filter function for a query string
     */

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(food) {
        // console.log(food);
        if (vm.branchFilterData[0].barcode_enable == 1) {
          return (food.sales_items.indexOf(query) >= 0);
        } else {
          return (food.sales_items.indexOf(lowercaseQuery) >= 0);

        };
      };

    }
    //while select the food items get data for selected index and assign it.
    function selectedItemChange(index, fmitem) {
      // console.log(fmitem);
      if (vm.branchFilterData[0].barcode_enable != 1) {
        $timeout(function () {
          $('.qty').select();
        }, 100);
      }
      if (vm.activedealer == 0) {
        return fmitem.salesitem_rate = fmitem.sales_items.offerprice ? fmitem.sales_items.offerprice : fmitem.sales_items.salesitem_rate, fmitem.actualprice = fmitem.sales_items.salesitem_rate, fmitem.offerprice = fmitem.sales_items.offerprice, fmitem.tax_sgst = fmitem.sales_items.tax_sgst, fmitem.tax_cgst = fmitem.sales_items.tax_cgst, fmitem.tax_status = fmitem.sales_items.tax_status, fmitem.sales_quantity = fmitem.sales_items.sales_quantity, fmitem.stock_quantity = fmitem.sales_items.stock_quantity, fmitem.fmcatergoryName = fmitem.sales_items.fmcatergoryName, fmitem.PurchasePrice = (fmitem.sales_items.PurchasePrice == undefined || fmitem.sales_items.PurchasePrice == null) ? 0 : fmitem.sales_items.PurchasePrice, fmitem.containQty = (fmitem.sales_items.containQty == undefined || fmitem.sales_items.containQty == null) ? 0 : fmitem.sales_items.containQty
      } else {
        return fmitem.salesitem_rate = fmitem.sales_items.dealer_price ? fmitem.sales_items.dealer_price : fmitem.sales_items.offerprice ? fmitem.sales_items.offerprice : fmitem.sales_items.salesitem_rate, fmitem.actualprice = fmitem.sales_items.salesitem_rate, fmitem.offerprice = fmitem.sales_items.offerprice ? fmitem.sales_items.offerprice : fmitem.sales_items.salesitem_rate, fmitem.tax_sgst = fmitem.sales_items.tax_sgst, fmitem.tax_cgst = fmitem.sales_items.tax_cgst, fmitem.tax_status = fmitem.sales_items.tax_status, fmitem.sales_quantity = fmitem.sales_items.sales_quantity, fmitem.stock_quantity = fmitem.sales_items.stock_quantity, fmitem.fmcatergoryName = fmitem.sales_items.fmcatergoryName, fmitem.PurchasePrice = (fmitem.sales_items.PurchasePrice == undefined || fmitem.sales_items.PurchasePrice == null) ? 0 : fmitem.sales_items.PurchasePrice, fmitem.containQty = (fmitem.sales_items.containQty == undefined || fmitem.sales_items.containQty == null) ? 0 : fmitem.sales_items.containQty
      }

    }
    /**
     * Build `states` list of key/value pairs
     */


    /**
     * Build `states` list of key/value pairs
     */
    //load data to auto complete
    function loadAll() {
      var fmitem_sales = fmitem_sale.filter(function (item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      });

      //filter food categories for branch wise 
      vm.foodcategorys = fmCategory.filter(function (data) {
        return [$rootScope.user[0].branch_id].some(function (branch_id) {
          return data.branch_id == branch_id
        });
      });
      // filter sale material categories for branch wise
      vm.salecategorys = siCategory.filter(function (data) {
        return [$rootScope.user[0].branch_id].some(function (branch_id) {
          return data.branch_id == branch_id
        })
      });
      // Get sale catergory id
      var siCatergoryID = vm.salecategorys.map(function (data) {
        var empty_payment = { 'fmCatergoryID': data.siCatergoryID, 'fmCatergoryName': data.siCatergoryName };
        return empty_payment
      });
      // Get food beverage catergory id
      var fmCatergoryID = vm.foodcategorys.map(function (data) {
        var empty_payment = { 'fmCatergoryID': data.fmCatergoryID, 'fmCatergoryName': data.fmCatergoryName };
        return empty_payment
      });

      // merge food and beverage catergory and sale material category
      vm.itemCatergoryId = fmCatergoryID.concat(siCatergoryID);

      var mergeCatagoryItem = [];
      angular.forEach(fmitem_sales, function (item) {
        for (var i = 0; i < vm.itemCatergoryId.length; i++) {
          // console.log(vm.itemCatergoryId[i].fmCatergoryID)
          if (vm.itemCatergoryId[i].fmCatergoryID == item.fmCatergoryID) {
            var test = {
              barcode: item.barcode,
              branch_id: item.branch_id,
              fmCatergoryID: item.fmCatergoryID,
              fmItemID: item.fmItemID,
              fmItemName: item.fmItemName,
              fmItemPrice: item.fmItemPrice,
              fmItemQty: item.fmItemQty,
              offerprice: item.offerprice,
              dealer_price: item.dealer_price,
              tax_cgst: item.tax_cgst,
              tax_sgst: item.tax_sgst,
              tax_status: item.tax_status,
              type: item.type,
              image_url: item.image_url || '',
              fmcatergoryName: vm.itemCatergoryId[i].fmCatergoryName,
              PurchasePrice: item.PurchasePrice,
              containQty: item.containQty
            }
            mergeCatagoryItem.push(test);
          }
        }

      });
      var foodList = mergeCatagoryItem;
      return foodList.map(function (food) {
        if (vm.branchFilterData[0].barcode_enable != 1) {
          return {
            sales_items: food.fmItemName.toLowerCase(),
            sales_quantity: 1,
            display: food.fmItemName,
            salesitem_rate: food.fmItemPrice,
            tax_sgst: food.tax_sgst,
            tax_cgst: food.tax_cgst,
            tax_status: food.tax_status,
            offerprice: food.offerprice,
            dealer_price: food.dealer_price,
            fmItemID: food.fmItemID,
            fmCatergoryID: food.fmCatergoryID,
            type: food.type,
            fmItemType: food.fmItemType,
            fmcatergoryName: food.fmcatergoryName,
            image_url: food.image_url || '',
            PurchasePrice: food.PurchasePrice,
            containQty: food.containQty
          };
        } else {
          return {
            sales_items: (food.barcode == null || food.barcode == undefined || food.barcode == "") ? food.fmItemName.toLowerCase() : food.barcode,
            sales_quantity: 1,
            display: food.fmItemName,
            salesitem_rate: food.fmItemPrice,
            tax_sgst: food.tax_sgst,
            tax_cgst: food.tax_cgst,
            tax_status: food.tax_status,
            offerprice: food.offerprice,
            dealer_price: food.dealer_price,
            fmItemID: food.fmItemID,
            fmCatergoryID: food.fmCatergoryID,
            type: food.type,
            fmItemType: food.fmItemType,
            fmcatergoryName: food.fmcatergoryName,
            image_url: food.image_url || '',
            PurchasePrice: food.PurchasePrice,
            containQty: food.containQty
          };

        }

      });
      console.log(mergeCatagoryItem);

    }


    // ******************************
    // Internal methods
    // ******************************

    //customer autocomplete entry
    vm.customer_data = loadAlll();
    vm.searchText = null;
    vm.querySearchh = querySearchh;
    vm.selectedItemChangge = selectedItemChangge;



    function querySearchh(query) {
      // $scope.customer={searchText:query}
      $scope.mobile = query
      var results = query ? vm.customer_data.filter(createFilterForr(query)) : vm.customer_data;
      var deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, Math.random() * 10, false);
      return deferred.promise;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterForr(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(customer) {
        return (customer.customer_mobile.indexOf(lowercaseQuery) === 0);
      };
    }

    //while select the food items get data for selected index and assign it.: "customer_Added"
    function selectedItemChangge(customer) {
      $scope.customer = customer
      if ($scope.customer_data) {
        $scope.customer_data = '' // clear data after updated
        $scope.customer = ''
        focuscustomer()
      }
      return customer.customer_name = customer.customer_mobile.customer_name, customer.localityID = customer.customer_mobile.localityID, customer.pointsEarned = customer.customer_mobile.pointsEarned, customer.customer_id = customer.customer_mobile.customer_id, customer.customer_email = customer.customer_mobile.customer_email, customer.customer_address = customer.customer_mobile.customer_address, customer.customer_locality = customer.customer_mobile.customer_locality, customer.customer_city = customer.customer_mobile.customer_city, customer.whatsapp = customer.customer_mobile.whatsapp
    }

    /**
     * Build `states` list of key/value pairs
     */
    //load all customers in auto complete
    function loadAlll() {
      //filter customer data for branch wise
      var customer_detailss = customer_details.filter(function (item) {
        if (item.branch_id == $rootScope.user[0].branch_id) {
          return item
        }
      })
      $scope.customer_details = customer_detailss;
      var customer_list = $scope.customer_data == '' ? $scope.customer_details : customer_detailss
      return customer_list.map(function (customer) {
        return {
          customer_id: customer.customer_id,
          pointsEarned: customer.pointsEarned,
          initpointsEarned: customer.pointsEarned,
          customer_mobile: customer.customer_mobile,
          customer_email: customer.customer_email,
          display: $scope.customer_data == '' ? customer.customer_mobile.customer_mobile : customer.customer_mobile,
          customer_address: customer.customer_address,
          customer_locality: customer.customer_locality,
          localityID: customer.localityID,
          customer_city: customer.customer_city,
          customer_name: customer.customer_name,
          whatsapp: customer.whatsapp
        };

      });
    };

    // When press enter key customer popup will open
    $scope.openCustomerDialog = function (ev, customer) {
      if ($('md-virtual-repeat-container').hasClass('md-not-found')) {
        if (ev.which == 13 && $('#radio-focuscustomer input[type=search]').focus()) {
          $timeout(function () {
            $(".customerClick").trigger("click");
          }, 10);
          //showAddTableDialog(ev, customer);
          // $('.md-virtual-repeat-container.md-autocomplete-suggestions-container').css({'display':'none'});
        }
      }
    };

    vm.showAddTableDialog = showAddTableDialog;

    function showAddTableDialog(ev, customer) {
      // angular.element('#clearcustomer').triggerHandler('click');
      $mdDialog.show({
        controller: 'CustomerDialogsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cashier/billing/newbill/customer/dialog/add_customer_dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          customer_data: customer,
          point: point_data,
          locality: locality,
          customer_details: vm.customer_data,
          customer_Added: "customer_Added",
          dietType: dietType
        },
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false
      })

    };
    //clear old customer data in auto complete
    $scope.clearcustomer = function (ev) {
      this.customer.searchText = ''
      this.customer.customer_mobile = ''
    }

    //broadcast data came from CustomerDialogController
    $scope.$on("salesId", function (event, customer) {
      $timeout(function () {
        angular.element('#clearcustomer').triggerHandler('click');
        $scope.customer.searchText = customer.customer_mobile;
        $scope.customer.customer_mobile = customer;
        // using customer id get customer analytics details ex. last visit
        $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, customerlist_success).$promise;
      }, 500)
    });
    //function for clear all inputs after submit
    function clearform() {
      vm.billing = {
        'tableno': '',
        'dietType': '',
        'staff': '',
        'paymentselect': '',
        'paymentmode': '',
      }

      vm.fmitems = [{}]
      vm.payment = '';
      $scope.customer = ''
      $scope.newBill.$setUntouched(); // Validation error removed /[^0-9]/g, ''
      vm.billing.deliveryTime = "Immediate"
      vm.billing.dietType = "dinein"
    }

    //payment datas
    vm.paymentstate = [{
      "name": 'paid',
      "value": 'paid'
    }, {
      "name": 'Unpaid',
      "value": 'unpaid'
    }];

    vm.paymentmodelist = [{
      "name": 'Cash',
      "value": 'cash'
    }, {
      "name": 'Online',
      "value": 'card'
    }, {
      "name": 'C&O',
      "value": 'cash & card'
    }];

    vm.discountTypes = [{
      "currency": '%'
    },
    {
      "currency": '$'
    }
    ];
    //cancel button for add scenerio
    $scope.cancel = function (ev) {
      if ($scope.newBill.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          $state.go("app.newBill", {}, { reload: "app.newBill" })
        }, function () {
          // Canceled
        });
      } else {
        $state.go("app.newBill", {}, { reload: "app.newBill" })
      }
    }
    //cancel button for add scenerio
    $scope.cancelDealer = function (ev, oldvalue, newvalue) {
      // item entered checking if not equal undefined have datas
      var itemcheking = vm.fmitems[0].fmcatergoryName;
      // Post scenario
      if (!$scope.params.id) {
        if (itemcheking != undefined) {
          var confirm = $mdDialog.confirm()
            .title('Cancel')
            .htmlContent('Are you sure you want to cancel this data?')
            .ariaLabel('delete Tax')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');
          $mdDialog.show(confirm).then(function () {
            vm.fmitems = [{}]
            vm.activedealer = newvalue;
            $timeout(function () {
              angular.element('table tr td input[type=search]').focus();
            }, 100);
          }, function () {
            vm.activedealer = oldvalue;
            // Canceled
          });
        }
      }
      // Update scenario
      else {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Once saved the data. You cannot edit this option')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK, Got it')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          vm.activedealer = oldvalue;
        }, function () {
          vm.activedealer = oldvalue;
        });

      }

    }

    //cancel button for edit scenerio
    $scope.canceledit = function (ev) {
      if ($scope.newBill.$dirty) {
        var confirm = $mdDialog.confirm()
          .title('Cancel')
          .htmlContent('Are you sure you want to cancel this?')
          .ariaLabel('delete Tax')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
          if ($scope.params.id && $scope.params.editbill == 'orderedbill') {
            $state.go('app.currentBills', { id: '', customer_id: '', editbill: '' })
          } else if ($scope.params.id && $scope.params.editbill == 'finishedbill') { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.paidBills', { id: '', customer_id: '', editbill: '' })
          } else if (!$scope.params.id) { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
          } else if ($scope.params.id && $scope.params.editbill == 'currentbill') { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
          }
        }, function () {
          // Canceled
        });
      } else {
        $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
      }
    }

    //success function 

    /*
    here get all customers of particular information like last visit,total eat
    and after selected particular customer in auto complete then here compare all customer data and selected customer id and retrieve to 
     page information for particular selected customer
    */
    function customerlist_success(desserts) {
      //check customer autocomplete and get customer id
      var customer_id = [];
      // New bill scenario
      if ($scope.customer) {
        vm.customer_data.map(function (fullCustomer) {
          if ($scope.customer.searchText == fullCustomer.customer_mobile) {
            customer_id.push(fullCustomer.customer_id)
          }

        })
      }
      //check customer autocomplete and get customer id
      if ($scope.customer_data) {
        vm.customer_data.map(function (fullCustomer) {
          if ($scope.customer_data.customer_mobile == fullCustomer.customer_mobile) {
            customer_id.push(fullCustomer.customer_id)
          }

        })
      }

      //apply data to particular customer like last visit total eat
      var customer_filter = [];
      desserts[0].results.filter(function (fullCustomerdbData) {
        if (fullCustomerdbData.customer_id == customer_id[0])
          customer_filter.push(fullCustomerdbData)
      })
      if (customer_filter.length == 0) {
        $scope.ordertime = ''
        $scope.lastvisit = 'today'
        $scope.total_visit = 0
        $scope.avgtotal = 0
        $scope.totaleat = 0
      } else {
        if (customer_filter[0].salesorder_id) {
          $scope.ordertime = customer_filter[0].ordertime
          $scope.lastvisit = customer_filter[0].lastvisit
          $scope.total_visit = customer_filter[0].total_visit
          $scope.avgtotal = customer_filter[0].avgtotal
          $scope.customer_address = customer_filter[0].customer_address
          $scope.customer_email = customer_filter[0].customer_email
          $scope.customer_mobile = customer_filter[0].customer_mobile
          $scope.customer_name = customer_filter[0].customer_name
          $scope.totaleat = customer_filter[0].total
          $scope.doordelivery = customer_filter[0].doordelivery
          $scope.takeaway = customer_filter[0].takeaway
          $scope.dinein = customer_filter[0].dinein
          $scope.deliveryLength = desserts[0].results
          $scope.purchaseorder_count = desserts[0].purchaseorder_count // apply total_count for doordelivery section
          vm.getpurchase = desserts[0].results.reverse()
        } else if (!customer_filter[0].salesorder_id) {
          $scope.ordertime = ''
          $scope.lastvisit = 'today'
          $scope.total_visit = 0
          $scope.avgtotal = 0
          $scope.totaleat = 0
        }
      }
    }

    $scope.customer_info = customer_info; //initial activation


    //it will happended both when page load retrieve all customers info and staff click particular customer in autocomplete
    function customer_info() {
      var admin_permission = $cookies.get('admin')
      $scope.permission = $cookies.get('admin')
      $rootScope.user = $cookies.getObject('user');
      $scope.purchaseorderr_query = {
        filter: '',
        limit: '10',
        order: 'ordertime',
        nameorder: 'customer_name',
        page: 1,
        customer_id: $scope.params.id,
        staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
        branch_id: $rootScope.user[0].branch_id
      };
      $scope.purchaseorder_query = {
        filter: '',
        limit: '10',
        order: 'ordertime',
        nameorder: 'customer_name',
        page: 1,
        staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
        branch_id: $rootScope.user[0].branch_id
      };
      $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, customerlist_success).$promise;
    }
    customer_info();

    //update function to db
    function updateservice() {
      var feedback_data = {
        'feedback_service': $scope.feedback.feedback_service.no ? $scope.feedback.feedback_service.no : $scope.feedback.feedback_service,
        'feedback_staff': $scope.feedback.feedback_staff.no ? $scope.feedback.feedback_staff.no : $scope.feedback.feedback_staff,
        'feedback_food': $scope.feedback.feedback_food.no ? $scope.feedback.feedback_food.no : $scope.feedback.feedback_food,
        'feedback_money': $scope.feedback.feedback_money.no ? $scope.feedback.feedback_money.no : $scope.feedback.feedback_money,
      }
      var customer_id = [];
      if ($scope.customer) {
        vm.customer_data.map(function (item) {
          if ($scope.customer.searchText == item.customer_mobile) {
            customer_id.push(item.customer_id)
          }
        })
      }

      if ($scope.customer_data) {
        vm.customer_data.map(function (item) {
          if ($scope.customer_data.customer_mobile == item.customer_mobile) {
            customer_id.push(item.customer_id)
          }
        })
      }
      // Create new customer in that page
      var CUSTOMERID = vm.customer_data.length == 0 ? null : vm.customer_data[0].customer_id;
      // Existing customer in that page
      var CUSTOMERIDS = vm.customer_data.length == 0 ? null : customer_id[0];
      var customer_id = customer_id[0] == undefined && (vm.customer_data.length == 0 || vm.customer_data[0].data == 'customer_Added') ? CUSTOMERID : CUSTOMERIDS
      var customer_ids = customer_id == undefined ? '' : customer_id //check empty or not
      //get user data from cookies
      var staffID = $rootScope.user[0].staffID;
      //collecting all bill datas
      var billing = vm.billing;
      var fmitem = vm.fmitems;
      var salesorder_ids = vm.fmitems[0].salesorder_id;
      var payment = vm.payment;
      // apply only if the dietType is doordelivery or  takeaway   
      if ((billing.dietType == "doordelivery" || billing.dietType == "takeaway") && billing.deliveryTime == "Schedule") {
        // to filter date and time while select and enter time by user
        var userEnteredTime = vm.billing.enterTime.toString(); // user enter time change as string format
        var indexcount = userEnteredTime.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
        var Date_time = userEnteredTime.substring(0, indexcount); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient
        // to filter and take date and time with 12 hours
        var deliverytiming = (Date_time.split(' ')[4]).split(':'); //only get time and split it as array  
        var hours = (deliverytiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + deliverytiming[1] + " " + (deliverytiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM and produce time
        var takedate = (Date_time.split(' ')) // split user entered time&date for take date purpose
        var deliverdate = takedate[0] + " " + takedate[1] + " " + takedate[2] + " " + takedate[3] //  get date
        var deliverytime = deliverdate + " " + time // final date + time
        // to filter date and time while select and enter time by user
        var userEnteredDate = vm.billing.sales_deliveryDate.toString(); // user enter time change as string format
        var indexcounts = userEnteredDate.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
        var Date_period = userEnteredDate.substring(0, indexcounts); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient
        var takedateonly = (Date_period.split(' ')) // split user entered time&date for take date purpose
        var deliverdates = takedateonly[0] + " " + takedateonly[1] + " " + takedateonly[2] + " " + takedateonly[3] //  get date
        var scheduletime = deliverdates + " " + time // final date + time
      }

      //get status ordered or finished
      if ((vm.payment.payment_status != 'paid' && !vm.payment.payment_mode && vm.payment.payment_status != 'unpaid') || vm.payment.payment_status == 'advance' || (vm.payment.payment_status != 'unpaid' && !vm.payment.payment_mode)) {
        // If not clicked any thing payment type status is ordered
        var bill_status = "ordered"
      } else if (((vm.payment.payment_mode == "cash" || "card" || "cash & card") || vm.payment.unpaid_reason == "complementary" || "miscellaneous" || "other" || "guest" || vm.payment.payment_mode != '') && (vm.payment.payment_status == 'unpaid' || vm.payment.payment_status == 'paid')) {
        // If clicked any payment type
        if (new Date(scheduletime) > new Date()) {
          // Checking schedule time for status
          var bill_status = "ordered"
        } else {
          var bill_status = "finished"
        }
      }

      var ordertakenedBy = [];
      staffRole.map(function (staff) {
        if (billing.staff == staff.staffID) {
          ordertakenedBy.push(staff.name)
        }
      })
      var thirdparty_name = []
      vm.ThirdPartys.map(function (thirdparty) {
        if (billing.thirdparty_id == thirdparty.thirdparty_id) {
          thirdparty_name.push(thirdparty.thirdparty_name)
        }
      })

      // Getting data to insert for sales_order customer_id.length == 0 ? '' : customer_id[0]
      var data = [{
        'tableitem': billing.tableno,
        'thirdparty_id': billing.thirdparty_id,
        'thirdparty_name': thirdparty_name[0] ? thirdparty_name[0] : '',
        'thirdparty_orderno': billing.thirdparty_orderno,
        'manageBy': ordertakenedBy[0] == undefined ? '' : ordertakenedBy[0],
        'orderTakenID': billing.staff,
        'dealer_status': vm.activedealer,
        'sales_deliveryTime': deliverytime == undefined ? '' : deliverytime,
        'sales_deliveryDate': billing.sales_deliveryDate,
        'sales_deliveryStatus': ((billing.dietType == "doordelivery" || billing.dietType == "takeaway")) ? billing.deliveryTime : null,
        'sales_dietType': billing.dietType,
        'status': bill_status,
        'customer_id': customer_ids,
        'modifiedID': staffID,
      }];

      //here calculate the point for the current bill
      // Checking custom id
      // customer_ids is new customer and existing customer
      if (customer_ids) {
        var oldpointsdb = [];
        // Based on id getting points
        vm.customer_data.map(function (item) {
          if (customer_ids == item.customer_id) {
            oldpointsdb.push(item.pointsEarned)
          }
        });

        /*--------------------------
        No direct apply point amount
        ----------------------------*/
        // Checking roundtotal greater than minium point value

        if (((vm.billing.roundtotal >= $scope.points[0].amount) || ($scope.payment_round_total >= $scope.points[0].amount)) && !vm.customerpoints.directlyapplypointamount) {

          if ($scope.payment_round_total == vm.billing.roundtotal) {
            // equal defualt edit billing amount which mean bill not edited
            $scope.pointsEarned = oldpointsdb[0];
            //console.log('aaaaaa')
          } else if ($scope.payment_round_total < vm.billing.roundtotal) {
            // greater the defualt edit billing amount
            var oldPoint = Math.floor($scope.payment_round_total / $scope.points[0].amount);
            var updatedPoint = Math.floor(vm.billing.roundtotal / $scope.points[0].amount);
            var differencePoint = updatedPoint - oldPoint;
            //console.log(differencePoint);
            $scope.pointsEarned = (differencePoint + oldpointsdb[0]);
            // console.log('bbbbbb')
          } else if ($scope.payment_round_total > vm.billing.roundtotal) {
            // lesser the defualt edit billing amount
            var oldPoint = Math.floor($scope.payment_round_total / $scope.points[0].amount);
            var updatedPoint = Math.floor(vm.billing.roundtotal / $scope.points[0].amount);
            var differencePoint = oldPoint - updatedPoint;
            var pointsValue = (parseFloat(oldpointsdb[0]) - parseFloat(differencePoint));
            $scope.pointsEarned = pointsValue < 0 ? '0' : pointsValue;
            // console.log('cccc')
          }
        } else {
          // Incase applied points to amount it will call
          $scope.pointsEarned = oldpointsdb[0];
        }

        // add new customer
        if (($scope.params.customer_id == '' || $scope.params.customer_id == undefined) && !vm.customerpoints.directlyapplypointamount) {
          var newPoints = Math.floor(vm.billing.roundtotal / $scope.points[0].amount);
          $scope.pointsEarned = (newPoints + oldpointsdb[0]);
          //console.log('dddd')
        }
        /*--------------------------
        direct apply point amount
        ----------------------------*/
        if (($scope.params.customer_id == '' || $scope.params.customer_id == undefined) && vm.customerpoints.directlyapplypointamount && $scope.clearpointdiscount == true) {
          // console.log('eee')
          $scope.pointsEarned = Math.floor(vm.billing.roundtotal / $scope.points[0].amount);
        } else if (($scope.params.customer_id == '' || $scope.params.customer_id == undefined) && vm.customerpoints.directlyapplypointamount && $scope.clearpointdiscount == false) {
          // console.log('fff')
          var newPoints = Math.floor(vm.billing.roundtotal / $scope.points[0].amount);
          $scope.pointsEarned = (newPoints + oldpointsdb[0]);
        }
      };

      //console.log($scope.pointsEarned);
      var Roundtotal = billing.roundtotal == undefined ? 0 : billing.roundtotal;
      vm.tax_cgst_fullamount = billing.tax + vm.billing.tax_cgstInclude;
      vm.tax_sgst_fullamount = billing.tax_sgst + vm.billing.tax_sgstInclude;
      //var discountAmount = (billing.discount != "") ? billing.discount : 0;
      //var additionalCharge = (billing.additional_charge != "") ? billing.additional_charge : 0;
      //vm.round = vm.billing.subTotal - $scope.total_pointdiscount - discountAmount + additionalCharge;

      // Tax calculation issues when add discount and additional charge so tax calculate from total
      if (dietType.settings.global_tax && (($scope.total_pointdiscount != 0) || (billing.discount != "") || (billing.additional_charge != ""))) {
        vm.tax_cgst_fullamount = (Roundtotal / (100 + (vm.taxs[0].taxRate + vm.taxs[1].taxRate))) * vm.taxs[0].taxRate;
        vm.tax_sgst_fullamount = (Roundtotal / (100 + (vm.taxs[0].taxRate + vm.taxs[1].taxRate))) * vm.taxs[1].taxRate;

      } else if (!dietType.settings.global_tax && (dietType.newbill.tax_status[0].value == "include") && (($scope.total_pointdiscount != 0) || (billing.discount != "") || (billing.additional_charge != ""))) {
        vm.tax_cgst_fullamount = (Roundtotal / 100) * ($scope.fullcgstpercent / vm.fmitems.length);
        vm.tax_sgst_fullamount = (Roundtotal / 100) * ($scope.fullsgstpercent / vm.fmitems.length);

      } else if (!dietType.settings.global_tax && (dietType.newbill.tax_status[0].value == "exclude") && (($scope.total_pointdiscount != 0) || (billing.discount != "") || (billing.additional_charge != ""))) {
        vm.tax_cgst_fullamount = (Roundtotal / (100 + (($scope.fullcgstpercent / vm.fmitems.length) * 2))) * ($scope.fullcgstpercent / vm.fmitems.length);
        vm.tax_sgst_fullamount = (Roundtotal / (100 + (($scope.fullsgstpercent / vm.fmitems.length) * 2))) * ($scope.fullsgstpercent / vm.fmitems.length);
      }
      var editsalespayment = [{
        'payment_status': (payment.payment_mode || payment.payment_status == 'unpaid') ? payment.payment_status : '',
        'payment_mode': payment.payment_mode == null ? '' : payment.payment_mode,
        'online_type': payment.online_type,
        'payment_received': payment.payment_received == undefined ? '' : payment.payment_received,
        'payment_transferred': payment.payment_transferred == undefined ? '' : payment.payment_transferred,
        'transcation_no': payment.transcation_no == undefined ? '' : payment.transcation_no,
        'unpaid_reason': payment.unpaid_reason == undefined ? '' : payment.unpaid_reason,
        'unpaid_description': payment.unpaid_description == undefined ? '' : payment.unpaid_description,
        'payment_total': payment.payment_status == 'unpaid' ? 0 : Roundtotal,
        'tax_rate': vm.tax_cgst_fullamount,
        'tax_sgst': vm.tax_sgst_fullamount,
        'additional_charge': billing.additional_charge,
        'discount': billing.discount,
        'pointdiscount': $scope.total_pointdiscount,
        'discount_type': vm.billing.discount_type
      }];


      var payload = {
        feedback_data: {
          'feedback_service': $scope.feedback.feedback_service.no ? $scope.feedback.feedback_service.no : $scope.feedback.feedback_service,
          'feedback_staff': $scope.feedback.feedback_staff.no ? $scope.feedback.feedback_staff.no : $scope.feedback.feedback_staff,
          'feedback_food': $scope.feedback.feedback_food.no ? $scope.feedback.feedback_food.no : $scope.feedback.feedback_food,
          'feedback_money': $scope.feedback.feedback_money.no ? $scope.feedback.feedback_money.no : $scope.feedback.feedback_money,
        },
        salesorder_data: data,            // already prepared in your code
        editsalespayment: editsalespayment,
        fmitems: fmitem,
        updated_items: vm.fmitems,        // includes stock update logic
        customer_id: customer_ids,
        pointsEarned: $scope.pointsEarned
      };
      api.updateAll.getID.update({ salesorder_id: $scope.params.id }, payload, function (response) {
      });
      var customer_data_details = null;
      if (customer_ids) {
        customer_data_details = {
          customer_id: customer_ids,
          WAAPIKEY: vm.branchFilterData[0].wa_api
        };
      }

      var items = [

      ];

      var WAfinalPayload = {
        feedback: {
          'feedback_service': $scope.feedback.feedback_service.no ? $scope.feedback.feedback_service.no : $scope.feedback.feedback_service,
          'feedback_staff': $scope.feedback.feedback_staff.no ? $scope.feedback.feedback_staff.no : $scope.feedback.feedback_staff,
          'feedback_food': $scope.feedback.feedback_food.no ? $scope.feedback.feedback_food.no : $scope.feedback.feedback_food,
          'feedback_money': $scope.feedback.feedback_money.no ? $scope.feedback.feedback_money.no : $scope.feedback.feedback_money,
        },
        order: data[0],            // already prepared in your code
        payment: editsalespayment[0],
        items: vm.fmitems,
        updated_items: vm.fmitems,        // includes stock update logic
        customer: customer_data_details,
        points: $scope.pointsEarned,
        branchdetails: vm.branchFilterData[0],
        salesId: $scope.salesId,
        mode: 'update'
      }



      // WhatsApp integration
      if (vm.branchFilterData[0].wa_api && customer_ids && vm.branchFilterData[0].wa_billsend == 1) {
        api.WAbill.getAll.save(WAfinalPayload, function (response) {
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Whatsapp Msg Send successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }, function (error) {

          var errorMsg = error.data && error.data.error ? error.data.error : 'Error in sending WhatsApp';
          $mdToast.show({
            template: '<md-toast class="error"><span flex>{{vm.message}}</span></md-toast>',
            locals: { message: errorMsg },
            controller: function ($scope, $mdToast, message) {
              var vm = this;
              vm.message = message;
            },
            controllerAs: 'vm',
            position: 'bottom right',
            hideDelay: 3000
          });
        });
      }
    }
    /*
    update service end
    */

    $scope.customer_details = customer_details;
    //feedback Service
    $scope.feedback_service = [{
      "no": '1',
      "class": 'first',
      "name": 'service1'
    }, {
      "no": '2',
      "class": 'second',
      "name": 'service2'
    }, {
      "no": '3',
      "class": 'third',
      "name": 'service3'
    }, {
      "no": '4',
      "class": 'four',
      "name": 'service4'
    }, {
      "no": '5',
      "class": 'five',
      "name": 'service5'

    }];
    //feedback Service
    $scope.feedback_staff = [{
      "no": '1',
      "class": 'first',
      "name": 'staff1'
    }, {
      "no": '2',
      "class": 'second',
      "name": 'staff2'
    }, {
      "no": '3',
      "class": 'third',
      "name": 'staff3'
    }, {
      "no": '4',
      "class": 'four',
      "name": 'staff4'
    }, {
      "no": '5',
      "class": 'five',
      "name": 'staff5'
    }];
    $scope.feedback_food = [{
      "no": '1',
      "class": 'first',
      "name": 'food1'
    }, {
      "no": '2',
      "class": 'second',
      "name": 'food2'
    }, {
      "no": '3',
      "class": 'third',
      "name": 'food3'
    }, {
      "no": '4',
      "class": 'four',
      "name": 'food4'
    }, {
      "no": '5',
      "class": 'five',
      "name": 'food5'
    }];
    $scope.feedback_quality = [{
      "no": '1',
      "class": 'first',
      "name": 'quality1'
    }, {
      "no": '2',
      "class": 'second',
      "name": 'quality2'
    }, {
      "no": '3',
      "class": 'third',
      "name": 'quality3'
    }, {
      "no": '4',
      "class": 'four',
      "name": 'quality4'
    }, {
      "no": '5',
      "class": 'five',
      "name": 'quality5'
    }];
    $scope.feedback = {
      'feedback_service': '',
      'feedback_staff': '',
      'feedback_food': '',
      'feedback_money': ''
    };

    $scope.serviceActive = function (menuItem) {
      $scope.activeMenu = menuItem;
    };
    $scope.staffActive = function (menuItems) {
      $scope.staffactiveMenu = menuItems;
    };
    $scope.qualityActive = function (menuItem) {
      $scope.qualityactiveMenu = menuItem;
    };
    $scope.moneyActive = function (menuItem) {
      $scope.moneyactiveMenu = menuItem;
    };

    function saveservice(print, stewardPrint) {
      // Get customer_id
      var customer_id = [];
      vm.customer_data.map(function (item) {
        if ($scope.customer.searchText == item.customer_mobile) {
          customer_id.push(item.customer_id);
        }
      });

      var CUSTOMERID = vm.customer_data.length == 0 ? null : vm.customer_data[0].customer_id;
      var CUSTOMERIDS = vm.customer_data.length == 0 ? null : customer_id[0];
      var customer_id = customer_id[0] == undefined && (vm.customer_data.length == 0 || vm.customer_data[0].data == 'customer_Added') ? CUSTOMERID : CUSTOMERIDS;
      var customer_ids = customer_id == undefined ? '' : customer_id;


      var billing = vm.billing;

      // prepare item data
      var itemdatas = vm.fmitems.map(function (item) {
        if (vm.branchFilterData[0].barcode_enable == 1) {
          item.sales_items.sales_items = item.sales_items.display;
        }
        return {
          'item': item.sales_items.sales_items,
          'fmItemType': item.sales_items.fmItemType,
          'offerprice': item.offerprice,
          'actualprice': item.actualprice,
          'profit_difference': item.profit_difference,
          'qty': item.sales_quantity,
          'itemprice': item.salesitem_rate,
          'itemsubtotal': item.subitemtotal,
          'tax_cgst': item.tax_cgst,
          'tax_sgst': item.tax_sgst,
          'tax_status': item.sales_items.tax_status,
          'fmItemID': item.sales_items.fmItemID,
          'fmCatergoryID': item.sales_items.fmCatergoryID
        };
      });

      var staffID = $rootScope.user[0].staffID;
      var branch_id = $rootScope.user[0].branch_id;



      // apply only if the dietType is doordelivery or  takeaway   
      if ((billing.dietType == "doordelivery" || billing.dietType == "takeaway") && billing.deliveryTime == "Schedule") {
        // to filter date and time while select and enter time by user
        var userEnteredTime = vm.billing.enterTime.toString(); // user enter time change as string format
        var indexcount = userEnteredTime.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
        var Date_time = userEnteredTime.substring(0, indexcount); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient
        // to filter and take date and time with 12 hours
        var deliverytiming = (Date_time.split(' ')[4]).split(':'); //only get time and split it as array  
        var hours = (deliverytiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + deliverytiming[1] + " " + (deliverytiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM and produce time
        var takedate = (Date_time.split(' ')) // split user entered time&date for take date purpose
        var deliverdate = takedate[0] + " " + takedate[1] + " " + takedate[2] + " " + takedate[3] //  get date
        var deliverytime = deliverdate + " " + time // final date + time
        // to filter date and time while select and enter time by user
        var userEnteredDate = vm.billing.sales_deliveryDate.toString(); // user enter time change as string format
        var indexcounts = userEnteredDate.lastIndexOf(':') // to count number  of  if letter or number counts in the userEnteredTime
        var Date_period = userEnteredDate.substring(0, indexcounts); // apply that count to remove unwanted lines like GMT india standaredtine for our convenient
        var takedateonly = (Date_period.split(' ')) // split user entered time&date for take date purpose
        var deliverdates = takedateonly[0] + " " + takedateonly[1] + " " + takedateonly[2] + " " + takedateonly[3] //  get date
        var scheduletime = deliverdates + " " + time // final date + time
      }


      // bill status
      if ((vm.payment.payment_status != 'paid' && !vm.payment.payment_mode && vm.payment.payment_status != 'unpaid') || vm.payment.payment_status == 'advance' || (vm.payment.payment_status != 'unpaid' && !vm.payment.payment_mode)) {
        // If not clicked anything in payment type
        var bill_status = "ordered"
      } else if (((vm.payment.payment_mode == "cash" || "card" || "cash & card") || vm.payment.unpaid_reason == "complementary" || "miscellaneous" || "other" || "guest" || vm.payment.payment_mode != '') && (vm.payment.payment_status == 'unpaid' || vm.payment.payment_status == 'paid')) {
        // If clicked anything in payment type
        if (new Date(scheduletime) > new Date()) {
          // schedule time checking
          var bill_status = "ordered"
        } else {
          var bill_status = "finished"
        }
      }

      var payment = vm.payment;
      // Order data (sales_order table)
      var orderData = {
        'tableitem': billing.tableno,
        'thirdparty_id': billing.thirdparty_id || '',
        'thirdparty_orderno': billing.thirdparty_orderno || '',
        'orderTakenID': billing.staff || '',
        'sales_deliveryStatus': billing.deliveryTime,
        'sales_deliveryDate': billing.sales_deliveryDate,
        'sales_deliveryTime': billing.enterTime.toString(),
        'sales_dietType': billing.dietType,
        'status': bill_status,
        'customer_id': customer_ids,
        'staffID': staffID,
        'branch_id': branch_id,
        'return_bill_no': billing.return_bill_no || '',
        'return_salebill_no': billing.return_salebill_no || ''
      };

      // Payment data
      var Roundtotal = billing.roundtotal || 0;
      var salespayment = {
        'payment_status': (payment.payment_mode || payment.payment_status == 'unpaid') ? payment.payment_status : 'ordered',
        'payment_mode': payment.payment_mode,
        'online_type': payment.online_type,
        'payment_received': payment.payment_received == undefined ? '' : payment.payment_received,
        'payment_transferred': payment.payment_transferred == undefined ? '' : payment.payment_transferred,
        'transcation_no': payment.transcation_no == undefined ? '' : payment.transcation_no,
        'unpaid_reason': payment.unpaid_reason == undefined ? '' : payment.unpaid_reason,
        'unpaid_description': payment.unpaid_description == undefined ? '' : payment.unpaid_description,
        'payment_total': payment.payment_status == 'unpaid' ? 0 : Roundtotal,
        'tax_rate': vm.tax_cgst_fullamount,
        'tax_sgst': vm.tax_sgst_fullamount,
        'additional_charge': billing.additional_charge,
        'discount': billing.discount,
        'pointdiscount': $scope.total_pointdiscount,
        'discount_type': billing.discount_type
      };


      // Feedback data
      var feedback_data = {
        'feedback_service': $scope.feedback.feedback_service.no || '',
        'feedback_staff': $scope.feedback.feedback_staff.no || '',
        'feedback_food': $scope.feedback.feedback_food.no || '',
        'feedback_money': $scope.feedback.feedback_money.no || ''
      };

      // Points (if applicable)
      var points = null;
      if (customer_ids && payment.payment_status == 'paid') {
        points = {
          customer_id: customer_ids,
          pointsEarned: Math.floor($scope.pointsEarned)
        };
      }
      var customer_data_details = null;
      if (customer_ids) {
        customer_data_details = {
          customer_id: customer_ids,
          WAAPIKEY: vm.branchFilterData[0].wa_api
        };
      }

      // Final JSON object to send to /saveOrder
      var finalPayload = {
        order: orderData,
        items: itemdatas,
        payment: salespayment,
        feedback: feedback_data,
        points: points,
        customer: customer_data_details,
        branchdetails: vm.branchFilterData[0],
        //ordertime: moment().tz(process.env.TZ_CLIENT).format('YYYY-MM-DD HH:mm:ss')
      };
      //console.log("Final Payload to be sent to /saveOrder", finalPayload);
      // 🔹 Call single API
      api.salesorder.getAll.save(finalPayload, function (response) {
        $scope.salesId = response.salesorder_id;
        $scope.qrcode = response.qrcode;
        // whatsapp integration data
        var WAfinalPayload = {
          order: orderData,
          items: itemdatas,
          payment: salespayment,
          feedback: feedback_data,
          points: points,
          salesId: $scope.salesId,
          customer: customer_data_details,
          branchdetails: vm.branchFilterData[0],
          mode: 'new'
          //ordertime: moment().tz(process.env.TZ_CLIENT).format('YYYY-MM-DD HH:mm:ss')
        };




        if (vm.branchFilterData[0].wa_api && customer_ids && vm.branchFilterData[0].wa_billsend == 1) {
          api.WAbill.getAll.save(WAfinalPayload, function (response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Whatsapp Msg Send successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }, function (error) {

            var errorMsg = error.data && error.data.error ? error.data.error : 'Error in sending WhatsApp';
            $mdToast.show({
              template: '<md-toast class="error"><span flex>{{vm.message}}</span></md-toast>',
              locals: { message: errorMsg },
              controller: function ($scope, $mdToast, message) {
                var vm = this;
                vm.message = message;
              },
              controllerAs: 'vm',
              position: 'bottom right',
              hideDelay: 3000
            });
          });
        }

        $scope.logoUrl = "../../../assets/images/login/print-logo.png";
        $scope.qrcode_status = vm.print.qrcode;
        $scope.qrcode_width = vm.print.qrcode_width;
        $scope.qrcode_height = vm.print.qrcode_height;

        var savings = 0;
        //get offer discount
        for (var i = 0; i < vm.fmitems.length; i++) {
          if (vm.fmitems[i].offerprice) {
            savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].salesitem_rate))
          }
        }
        $scope.savedamount = savings;
        console.log("Saved Amount:", $scope.savedamount);

       // 🔥 Helper: get rendered HTML safely
        function getPrintContent(id) {
          var element = document.getElementById(id);
          if (!element) return '';
          return element.cloneNode(true).innerHTML;
        }
        // 🔥 Print function (mobile safe)
        function printContent(content, callback) {
          var iframe = document.createElement('iframe');
          iframe.style.position = 'fixed';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = '0';
          document.body.appendChild(iframe);
          var doc = iframe.contentWindow.document;
          doc.open();
          doc.write(
            '<html>\n' +
            '  <head>\n' +
            '    <title>Print</title>\n' +
            '    <style>\n' +
            '      body { margin:0; padding:0; }\n' +
            '      table { width:100%; border-collapse: collapse; }\n' +
            '    </style>\n' +
            '  </head>\n' +
            '  <body>\n' +
            '    ' + content + '\n' +
            '  </body>\n' +
            '</html>'
          );
          doc.close();
          setTimeout(function () {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
            if (callback) callback();
          }, vm.print.print_delay || 700);
        }
        // 🔥 MAIN FLOW
        if (print) {
          printBill().then(function (data) {
            if (data === 'success' && vm.print.kotprint) {
              $timeout(function () {
                var kotContent = getPrintContent('KOTPrint');
                printContent(kotContent, function () {
                  $state.go("app.newBill", {}, { reload: "app.newBill" });
                  $scope.reload();
                });

              }, 300); // give Angular time
            }
          });
          function printBill() {
            var deferred = $q.defer();
            if (stewardPrint) {
              deferred.resolve('success');
              return deferred.promise;
            } else {
              $timeout(function () {
                var billContent = getPrintContent('printBill'); // ✅ FIXED ID
                printContent(billContent, function () {
                  deferred.resolve('success');
                  if (!vm.print.kotprint) {
                    $state.go("app.newBill", {}, { reload: "app.newBill" });
                    $scope.reload();
                  }
                });
              }, 300); // ✅ IMPORTANT delay
              return deferred.promise;
            }
          }
          $timeout(function () {
            $scope.reload();
          }, 500);
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Order updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        } else {
          $state.go("app.newBill", {}, { reload: "app.newBill" });
          $scope.reload();
        }
      },
        function (error) {
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Error saving order</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }
      );
    }



    //save to  stored datas in database
    $scope.save = {
      submit: function () {
        $scope.newBill.$setSubmitted();
        if ($scope.newBill.$valid) {
          saveservice();
        } else {
          $mdToast.show({
            template: '<md-toast class="error"><span flex >Please fill valid data for all required fields</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }
      }
    };

    //save to direct print and stored datas in database
    $scope.savePrint = {
      submit: function (print, stewardPrint) {
        $scope.newBill.$setSubmitted();
        if ($scope.newBill.$valid) {
          saveservice(print, stewardPrint);
          //calculate time during print statement
          //var date_time = new Date().toString();
          //$scope.fmitems = [{ 'ordertime': date_time.substring(0, date_time.lastIndexOf(':') + 3) }]
          $scope.paymentMode = vm.payment.payment_mode;
          var date_time = new Date()
          $scope.fmitems = [{ 'ordertime': date_time }]

          $mdToast.show({
            template: '<md-toast class="success"><span flex>Order added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

          /*   $timeout(function() {
               $scope.reload();
               $state.go("app.newBill", {}, { reload: "app.newBill" });
             }, 500) */

        } else {
          $mdToast.show({
            template: '<md-toast class="error"><span flex>Please fill valid data for all required fields</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }
      }
    };

    //save to update  datas in database
    $scope.edit = {
      update: function () {
        $scope.newBill.$setSubmitted();

        if ($scope.newBill.$valid) {
          updateservice();
          if ($scope.params.id && $scope.params.editbill == 'orderedbill') {
            $state.go('app.currentBills', { id: '', customer_id: '', editbill: '' })
          } else if ($scope.params.id && $scope.params.editbill == 'finishedbill') { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.paidBills', { id: '', customer_id: '', editbill: '' })
          } else if (!$scope.params.id) { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
          } else if ($scope.params.id && $scope.params.editbill == 'currentbill') { // Constant defined in CollectionsLibraryAvailableController 
            $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
          }
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Order updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
          $timeout(function () {
            $scope.reload();
          }, 500)
        } else {
          $mdToast.show({
            template: '<md-toast class="error"><span flex>Please fill valid data for all required fields</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }
      }

    }

    //save to update  datas in database and direct to print
    $scope.updatePrint = {
      update: function (stewardPrint) {
        $scope.newBill.$setSubmitted();
        if ($scope.newBill.$valid) {
          updateservice();
          //apply data to edit while print
          var savings = 0;
          //get offer discount
          for (var i = 0; i < vm.fmitems.length; i++) {
            if (vm.fmitems[i].offerprice) {
              //savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].offerprice));
              savings += vm.fmitems[i].sales_quantity * (parseInt(vm.fmitems[i].actualprice) - parseInt(vm.fmitems[i].salesitem_rate))
            }
          }
          $scope.paymentMode = vm.payment.payment_mode;
          $scope.savedamount = savings;
          $scope.logoUrl = "../../../assets/images/login/print-logo.png";
          //print section


          printBill().then(function (data) {
            vm.fmitems = vm.fmitemsKot;
            if (data == 'success' && vm.print.kotprint) {
              $timeout(function () {
                var w = window.open('', '_blank', 'width=400,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                w.document.write($('#KOTPrint').html()); //only part of the page to print, using jquery
                w.document.close(); //this seems to be the thing doing the trick
                w.focus();
                $timeout(function () {
                  w.print();
                  w.close();
                }, vm.print.print_delay);
                if ($scope.params.id && $scope.params.editbill == 'orderedbill') {
                  $state.go('app.currentBills', { id: '', customer_id: '', editbill: '' })
                } else if ($scope.params.id && $scope.params.editbill == 'finishedbill') { // Constant defined in CollectionsLibraryAvailableController 
                  $state.go('app.paidBills', { id: '', customer_id: '', editbill: '' })
                } else if (!$scope.params.id) { // Constant defined in CollectionsLibraryAvailableController 
                  $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
                } else if ($scope.params.id && $scope.params.editbill == 'currentbill') { // Constant defined in CollectionsLibraryAvailableController 
                  $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
                }
                $scope.reload();
              }, 100);
            }
          });

          function printBill() {
            var deferred = $q.defer();
            if (stewardPrint) {
              deferred.resolve('success');
              return deferred.promise;
            }
            else {
              var printout = $timeout(function () {
                var w = window.open('', '_blank', 'width=400,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                w.document.write($('#printBills').html()); //only part of the page to print, using jquery
                w.document.close(); //this seems to be the thing doing the trick
                w.focus();
                $timeout(function () {
                  w.print();
                  w.close();
                  deferred.resolve('success');
                }, vm.print.print_delay);
                // if kot print is not required reload the page
                if (!vm.print.kotprint) {
                  if ($scope.params.id && $scope.params.editbill == 'orderedbill') {
                    $state.go('app.currentBills', { id: '', customer_id: '', editbill: '' })
                  } else if ($scope.params.id && $scope.params.editbill == 'finishedbill') { // Constant defined in CollectionsLibraryAvailableController 
                    $state.go('app.paidBills', { id: '', customer_id: '', editbill: '' })
                  } else if (!$scope.params.id) { // Constant defined in CollectionsLibraryAvailableController 
                    $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
                  } else if ($scope.params.id && $scope.params.editbill == 'currentbill') { // Constant defined in CollectionsLibraryAvailableController 
                    $state.go('app.newBill', { id: '', customer_id: '', editbill: '' })
                  }
                  $scope.reload();
                }
              }, 100);
              return deferred.promise;
            }

          };

          $timeout(function () {
            $scope.reload();
          }, 500)

          $mdToast.show({
            template: '<md-toast class="success"><span flex>Order updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        } else {
          $mdToast.show({
            template: '<md-toast class="error"><span flex>Please fill valid data for all required fields</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }
      }

    }

    // mobile responsive check
    $scope.winsize601 = $window.innerWidth <= 601; // Adjust width as needed
    angular.element($window).bind('resize', function () {
      $scope.winsize601 = $window.innerWidth <= 601;
      $scope.$apply(); // Update scope  
    });

    //service for get currentbill newbill info
    $scope.reload = function () {
      api.currentrow_service.getID.get({ staffID: $rootScope.user[0].staffID },
        function (response) {
          var filter_bill = response.slice().reverse()
          $scope.row_index = filter_bill.slice(0, 8).map(function (item) {
            var date_time = new Date(item.ordertime).toString(); //get like wed apr with time
            var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
            var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
            var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM')
            return { 'showorderdate': date_time.substring(0, date_time.lastIndexOf(':') + 3), 'ordertime': time, 'customer_id': item.customer_id, 'salesorder_id': item.salesorder_id, 'payment_total': item.payment_total, 'tableitem': item.tableitem }
          })
        })
    };
    $scope.reload();

    //id pass to edit
    $scope.Editdiet = function (salesorder_id, customer_id) {
      var id = salesorder_id;
      $scope.params = $stateParams;
      $state.go('app.newBill', { id: salesorder_id, customer_id: customer_id, editbill: 'currentbill' })
    };

    //view customer
    $scope.viewCustomer = function (customer) {

      //var url = $state.href('/customer-list/', 1);
      // window.open(url,'_blank');

      //  $state.go('app.customeranalytics', { id: customer })
    };

    /**
     * Random color change
     */
    $scope.doc_classes_colors = [
      "#23bf72",
      "#e59e00",
      "#f46e75",
      "#a8b817",
      "#ed7e2b",
      "#5a9af9",
      "#b39a7e",
      "#7ea6ad"

    ];
    $scope.getRandomColor = function () {
      $scope.bgColor = $scope.doc_classes_colors[Math.floor(Math.random() * $scope.doc_classes_colors.length)];
    };
    /**
     * Keycode
     */
    onkeydown = function (e) {
      // bill info

      if (e.keyCode == '112') {
        e.preventDefault();
        $timeout(function () {
          $scope.prTabName = 'tabBillInfo';
          $scope.customerinfo = false;
          $scope.showfeedback = false;
          $scope.billinfo = true;
          focus()
        }, 10);
      }
      // Print
      else if (e.keyCode == '123') {
        e.preventDefault();
        angular.element('#print').triggerHandler('click');
      }
      // Save
      else if ((e.ctrlKey && e.keyCode == 'S'.charCodeAt(0)) || e.keyCode == '122') {
        e.preventDefault();
        angular.element('#save').triggerHandler('click');
      }
      // Cancel
      else if (e.keyCode == '116' || e.keyCode == '121') {
        e.preventDefault();
        angular.element('#cancel').triggerHandler('click');
      }
      // delete
      else if (e.keyCode == '46' || e.keyCode == '118') {
        e.preventDefault();
        var items = $("table tr");
        var index = items.filter(".selection").index();
        var rowClass = "table tr:nth-child(" + (index + 1) + ")";
        $(rowClass).find('.removeRow').triggerHandler('click');
        //angular.element('.removeRow').triggerHandler('click');
        if (index != 0) {
          var highlightRow = "table tr:nth-child(" + (index) + ")";
          $('table tr').removeClass("selection");
          $(highlightRow).find("input[type=search]").focus();
        } else {
          var highlightRow = "table tr:nth-child(" + (index + 1) + ")";
          $('table tr').removeClass("selection");
          $(highlightRow).find("input[type=search]").focus();
        }
      }
      // Customer Info
      else if (e.keyCode == '113') {
        e.preventDefault();
        $timeout(function () {
          $scope.prTabName = 'tabCustomerInfo';
          $scope.showfeedback = false;
          $scope.billinfo = false;
          $scope.customerinfo = true;
          focuscustomer()
        }, 10);
      }
      // feedback
      else if (e.keyCode == '114') {
        e.preventDefault();
        $timeout(function () {
          $scope.prTabName = 'tabFeedback';
          $scope.billinfo = false;
          $scope.customerinfo = false;
          $scope.showfeedback = true;
        }, 10);
      }

    }


    vm.fetchreturnOrder = function (event, orderid) {
      api.return_order.getID.get({ id: orderid },
        function (response) {
          vm.billing.discount = response.total_refund;
          vm.billing.return_salebill_no = response.original_salesorder_id;
          $scope.$watch('vm.fmitems', calculateTotals, true); //watch food ng-models
        }
      );
    }



  }

})();

(function() {
  'use strict';

  angular
    .module('app.billing.currentBills')
    .controller('CurrentBillsController', CurrentBillsController);
  /** @ngInject */
  function CurrentBillsController($scope, $filter,$mdToast, point, taxs, branch_data, $interval, $window, dietType, $q, current_mergebill, $cookies, api, $state, $rootScope, $stateParams, $http, $timeout, currentbill_service, $mdDialog, staffRole) {
    var vm = this;
    // DATA
    //----------------
    //get staff data from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    //get corporate settings from genral json
    api.dietType.get(function(dietType) {
      vm.settings = dietType.settings;
    }, function(err) {});
    //store permissions in array
    $scope.admin = []
    $scope.salesbillss = []
    $scope.saleseditt = []
    $scope.salesdeletee = []
    $scope.mdtableselected = []; // dummy assign
    //get permissions from cookies
    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 1) {
        $scope.salesbillss.push("salesbills");
      } else if (permissionss[i] == 12) {
        $scope.saleseditt.push("salesbills");
      } else if (permissionss[i] == 13) {
        $scope.salesdeletee.push("salesbills");
      }
    }
    //get staff data from cookies
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })

    vm.staffs = staffRole; //assign all staff data
    var data = vm.dietin1;
    $scope.filter = {
      options: {
        debounce: 500
      }
    };
    //sql queries of conditions for separate dinein,takeaway.doordelivery
    $scope.dinein_query = {
      filter: '',
      limit: '10',
      order: 'nameToLower',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };
    $scope.takeaway_query = {
      filter: '',
      limit: '10',
      order: 'nameToLower',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };
    $scope.doordelivery_query = {
      filter: '',
      limit: '10',
      order: 'nameToLower',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };
    //success function of dinein from the server
    function dinein_success(desserts) {

      //collect counts from server
      $scope.dinein_count = desserts[0].dinein_count // apply total_count for dinein section

      vm.currentbill_serviceID = desserts[0].results.map(function(item) {

        var date_time = new Date(item.ordertime).toString(); //get like wed apr with time
        var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
        var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
        var delivertiming = item.sales_deliveryStatus == "Immediate" ? "Immediate" : (item.sales_deliveryTime.split(' '))
        var delivertime = delivertiming == "Immediate" ? "Immediate" : (delivertiming[4] + " " + delivertiming[5])
        var splitdeliverytime = delivertime.toString().split(' ')[0].split(':')

        if (item.sales_dietType == "doordelivery" || item.sales_dietType == "takeaway") {

          var currentTimes = new Date();
          var endTimes = new Date(item.sales_deliveryDate);
          var mss = (endTimes - currentTimes); // ms of difference
          var days = Math.round(mss / 86400000);
          //return  hrs + " h:" + mins + "m left" 
          var finalCountdownn = (days + " days");
          var remainingtimes = mss < 0 ? "" : finalCountdownn

          var currentTime = new Date();
          var endTime = new Date(item.sales_deliveryTime);
          var ms = (endTime - currentTime); // ms of difference
          //var days = Math.round(ms/ 86400000);
          var hrs = Math.round((ms % 86400000) / 3600000);
          var mins = Math.round(((ms % 86400000) % 3600000) / 60000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdown = (hrs + " h:" + mins + "m left");
          var remainingtime = remainingtimes + "," + ms < 0 ? "EXPIRED" : finalCountdown
        }

        var food_items = [];
        currentbill_service.forEach(function(fullItemData) {
          if (fullItemData.staffID == $rootScope.user[0].staffID && fullItemData.salesorder_id == item.salesorder_id)
            food_items.push(fullItemData.sales_items);
        });
        return { 'sales_items': food_items.length, 'customer_id': item.customer_id, 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'staffID': item.staffID, 'remainingtime': remainingtime, 'status': item.status, 'showdeliverdate': item.sales_deliveryTime, 'showorderdate': date_time.substring(0, date_time.lastIndexOf(':') + 3), 'ordertime': time, 'salesorder_id': item.salesorder_id, 'sales_dietType': item.sales_dietType, 'manageBy': item.manageBy, 'payment_total': item.payment_total, 'payment_received': item.payment_received, 'payment_mode': item.payment_mode, 'tableitem': item.tableitem, 'payment_status': item.payment_status, 'sales_deliveryTime': delivertime }

      })
      $scope.dinein = vm.currentbill_serviceID // apply total_count for dinein section     
    }
    //service for dinein 
    $scope.getDesserts = function() {
      $scope.reload = function() {
        $scope.promise = api.dinein.getAll.get($scope.dinein_query, dinein_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000); */
      };
      $scope.reload();
    };

    //success function of takeaway from the server
    function takeaway_success(desserts) {
      //collect counts from server

      var filter_takaway = desserts[0].results.filter(function(item) {
        if ((new Date(item.sales_deliveryDate) > new Date() || new Date(item.sales_deliveryDate).toDateString() == new Date().toDateString() || item.payment_status != 'paid') && item.payment_status != 'unpaid')
          return item
      })
      $scope.takeaway_count = filter_takaway.length
      vm.currentbill_serviceID = filter_takaway.map(function(item) {
        var date_time = new Date(item.ordertime).toString(); //get like wed apr with time
        var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
        var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
        var delivertiming = item.sales_deliveryStatus == "Immediate" ? "Immediate" : (item.sales_deliveryTime.split(' '))
        var delivertime = delivertiming == "Immediate" ? "Immediate" : (delivertiming[4] + " " + delivertiming[5])
        var splitdeliverytime = delivertime.toString().split(' ')[0].split(':')

        if (item.sales_dietType == "doordelivery" || item.sales_dietType == "takeaway") {
          var currentTimes = new Date();
          var sales_deliveryDates = (new Date(item.sales_deliveryDate) > new Date() || new Date(item.sales_deliveryDate) < new Date()) ? new Date(item.sales_deliveryDate) : ''
          var date_time = sales_deliveryDates.toString()
          var sales_deliveryDate = date_time.substring(0, date_time.lastIndexOf(':') + -6)
          var endTimes = new Date(item.sales_deliveryDate)
          var mss = (endTimes - currentTimes); // ms of difference
          var days = Math.round(mss / 86400000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdownn = (days == 1 ? days + "day left" : days + "days left");
          var remainingtimes = mss < 0 ? "" : finalCountdownn

          var currentTime = new Date();
          var endTime = new Date(item.sales_deliveryTime);
          var ms = (endTime - currentTime); // ms of difference
          //var days = Math.round(ms/ 86400000);
          var hrs = Math.round((ms % 86400000) / 3600000);
          var mins = Math.round(((ms % 86400000) % 3600000) / 60000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdown = (hrs + " h:" + mins + "m left");
          if (new Date(item.sales_deliveryDate) > new Date()) {
            var period = ""
          } else if (new Date(item.sales_deliveryDate).toDateString() == new Date().toDateString()) {
            var period = "TODAY"
          } else if (new Date(item.sales_deliveryDate) < new Date()) {
            var period = "EXPIRED"
          }
          if (item.sales_deliveryStatus != "Immediate") {
            var remainingtime = mss < 0 ? period : remainingtimes
          } else {
            var remainingtime = "";
          }
        }

        var food_items = [];
        currentbill_service.forEach(function(fullItemData) {
          if (fullItemData.staffID == $rootScope.user[0].staffID && fullItemData.salesorder_id == item.salesorder_id)
            food_items.push(fullItemData.sales_items);
        });
        return { 'sales_items': food_items.length, 'payment_received': item.payment_received, 'payment_mode': item.payment_mode, 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'customer_id': item.customer_id, 'or': item.ordertime, 'dl': item.sales_deliveryTime, 'staffID': item.staffID, 'remainingtime': remainingtime, 'status': item.status, 'showorderdate': date_time.substring(0, date_time.lastIndexOf(':') + 3), 'ordertime': time, 'salesorder_id': item.salesorder_id, 'sales_dietType': item.sales_dietType, 'manageBy': item.manageBy, 'payment_total': item.payment_total, 'tableitem': item.tableitem, 'payment_status': item.payment_status, 'sales_deliveryTime': item.sales_deliveryStatus == "Immediate" ? "Immediate" : sales_deliveryDate + "," + " " + delivertime }

      })
      vm.takeaway = vm.currentbill_serviceID //apply service data to data table
    }
    //service for takeaway 
    $scope.getDessertss = function() {
      $scope.reload = function() {
        $scope.promise = api.takeaway.getAll.get($scope.takeaway_query, takeaway_success).$promise;
        /* $timeout(function() {
           $scope.reload();
         }, 30000); */
      };
      $scope.reload();
    };


    //success function of doordelivery from the server
    function doordelivery_success(desserts) {
      //collect counts from server
      // apply total_count for doordelivery section

      var filter = desserts[0].results.filter(function(item) {
        if ((new Date(item.sales_deliveryDate) > new Date() || new Date(item.sales_deliveryDate).toDateString() == new Date().toDateString()) || item.payment_status != 'paid')
          return item
      })

      $scope.doordelivery_count = filter.length
      vm.currentbill_serviceID = filter.map(function(item) {

        var date_time = new Date(item.ordertime).toString(); //get like wed apr with time
        var ordertiming = (date_time.split(' ')[4]).split(':'); //only get time and split it as array    
        var hours = (ordertiming[0] % 12) || 12; // convert to 12-hour style
        var time = hours + ":" + ordertiming[1] + " " + (ordertiming[0] < 12 ? 'AM' : 'PM') //find whether the hour is AM or PM
        var delivertiming = item.sales_deliveryStatus == "Immediate" ? "Immediate" : (item.sales_deliveryTime.split(' '))
        var delivertime = delivertiming == "Immediate" ? "Immediate" : (delivertiming[4] + " " + delivertiming[5])
        var splitdeliverytime = delivertime.toString().split(' ')[0].split(':')

        if (item.sales_dietType == "doordelivery" || item.sales_dietType == "takeaway") {
          var currentTimes = new Date();
          var sales_deliveryDates = (new Date(item.sales_deliveryDate) > new Date() || new Date(item.sales_deliveryDate) < new Date()) ? new Date(item.sales_deliveryDate) : ''
          var date_time = sales_deliveryDates.toString()
          var sales_deliveryDate = date_time.substring(0, date_time.lastIndexOf(':') + -6)
          var endTimes = new Date(item.sales_deliveryDate)
          var mss = (endTimes - currentTimes); // ms of difference
          var days = Math.round(mss / 86400000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdownn = (days == 1 ? days + "day left" : days + "days left");
          var remainingtimes = mss < 0 ? "" : finalCountdownn

          var currentTime = new Date();
          var endTime = new Date(item.sales_deliveryTime);

          var ms = (endTime - currentTime); // ms of difference
          //var days = Math.round(ms/ 86400000);
          var hrs = Math.round((ms % 86400000) / 3600000);
          var mins = Math.round(((ms % 86400000) % 3600000) / 60000);
          //return  hrs + " h:" + mins + "m left"
          var finalCountdown = (hrs + " h:" + mins + "m left");
          if (new Date(item.sales_deliveryDate) > new Date()) {
            var period = ""
          } else if (new Date(item.sales_deliveryDate).toDateString() == new Date().toDateString()) {
            var period = "TODAY"
          } else if (new Date(item.sales_deliveryDate) < new Date()) {
            var period = "EXPIRED"
          }
          if (item.sales_deliveryStatus != "Immediate") {
            var remainingtime = mss < 0 ? period : remainingtimes
          } else {
            var remainingtime = "";
          }
        }
        //collect counts of food_items of length
        var food_items = [];
        currentbill_service.forEach(function(fullItemData) {
          if (fullItemData.staffID == $rootScope.user[0].staffID && fullItemData.salesorder_id == item.salesorder_id)
            food_items.push(fullItemData.sales_items);
        });
        return { 'sales_items': food_items.length, 'payment_received': item.payment_received, 'payment_mode': item.payment_mode, 'customer_id': item.customer_id, 'modifiedID': item.modifiedID, 'last_modified': new Date(item.last_modified), 'staffID': item.staffID, 'remainingtime': remainingtime, 'status': item.status, 'showdeliverdate': item.sales_deliveryTime, 'showorderdate': date_time.substring(0, date_time.lastIndexOf(':') + 3), 'ordertime': time, 'salesorder_id': item.salesorder_id, 'sales_dietType': item.sales_dietType, 'manageBy': item.manageBy, 'payment_total': item.payment_total, 'tableitem': item.tableitem, 'payment_status': item.payment_status, 'sales_deliveryTime': item.sales_deliveryStatus == "Immediate" ? "Immediate" : sales_deliveryDate + "," + " " + delivertime }
      })
      vm.doordelivery = vm.currentbill_serviceID //apply service data to data table
    }
console.log($scope.doordelivery_query)
    //service for doordelivery
    $scope.getDessertsss = function() {
      $scope.reload = function() {
        $scope.promise = api.doordelivery.getAll.get($scope.doordelivery_query, doordelivery_success).$promise;
        /*$timeout(function() {
          $scope.reload();
        }, 30000); */
      };
      $scope.reload();
    };



    //watch function in dinein,takeaway and doordelivery for search box 
    $scope.$watch('dinein_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.dinein_query.page ? $scope.dinein_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.dinein_query.page = 1
      }
      if (!newValue) {
        $scope.dinein_query.page = bookmark ? bookmark : 1
      }
      $scope.getDesserts();
    });

    $scope.$watch('takeaway_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.takeaway_query.page ? $scope.takeaway_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.takeaway_query.page = 1
      }

      if (!newValue) {
        $scope.takeaway_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertss();
    });

    $scope.$watch('doordelivery_query.filter', function(newValue, oldValue) {
      if (!oldValue) {
        var bookmark = $scope.doordelivery_query.page ? $scope.doordelivery_query.page : 1
      }

      if (newValue !== oldValue) {
        $scope.doordelivery_query.page = 1
      }

      if (!newValue) {
        $scope.doordelivery_query.page = bookmark ? bookmark : 1
      }

      $scope.getDessertsss();
    });


    // GET dienin staffs
    //---------------- 
    $scope.dinein_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };

    // GET takeaway staffs
    //---------------- 
    $scope.takeaway_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };


    // GET doordelivery staffs
    //---------------- 
    $scope.doordelivery_staffnames = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.staffID) {
          return vm.staffs[i].name
        }
      }
    };
    //to find who was edit this bill
    $scope.update_staff = function(rmInfo) {
      for (var i = 0; i < vm.staffs.length; i++) {
        if (vm.staffs[i].staffID == rmInfo.modifiedID) {
          return vm.staffs[i].name
        }
      }
    };
    //clear search text
    $scope.clearText = function() {
      $scope.dinein_query.filter = '';
      $scope.doordelivery_query.filter = '';
      $scope.takeaway_query.filter = ''
    }
    //while search to restrict to view in no data found div
    $scope.keyPressed = function(rmInfo) {
      $scope.retrieve = rmInfo
    }

      // Delete the purchase order
    $scope.removeRow = function(item, ev, index) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this bill?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.delete_pos_ordered.getID.delete({ salesorder_id: item.salesorder_id },
          function(response) {
            //success callback
            deleteItem(item);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

      /**
       * Delete index of the  Item
       */
      function deleteItem(item) {
        if(item.sales_dietType=='dinein'){
        $scope.dinein.splice($scope.dinein.indexOf(item), 1);
        }else if(item.sales_dietType=='takeaway'){
        vm.takeaway.splice(vm.takeaway.indexOf(item), 1);
        }else if(item.sales_dietType=='doordelivery'){
        vm.doordelivery.splice(vm.doordelivery.indexOf(item), 1);
        }
        $mdToast.show({
          template: '<md-toast class="success"><span flex>deleted successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    }

    //filter tex data for branch wise
    var taxss = taxs.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    //check whether tax data contains or not
    if (taxss.length) {
      if (taxss.length == 1) {
        var tax_data = [{ 'taxName': taxss[0].taxName, 'taxRate': taxss[0].taxRate }, { 'taxName': 'SGST', 'taxRate': 0 }]
      } else {
        var tax_data = taxss;
      }
    } else {
      var tax_data = [{ 'taxName': 'CGST', 'taxRate': 0 }, { 'taxName': 'SGST', 'taxRate': 0 }]
    }
    //filter poins data for branch wise
    var point_data = point.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })

    var printInfo = 'orderedbill'; //this is for url redirct identity
    //print function for selected id
    $scope.printToCart = function(currentbill, ev) {
      $scope.id = currentbill.salesorder_id;
      var salesId = currentbill.salesorder_id;
      var vm = this;
      var printBill = angular.copy($scope.id)
      $rootScope.$broadcast("salesId", salesId, tax_data, point_data, currentbill.customer_id, branch_data, printInfo, dietType);
    }


    var originatorEv;
    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
    // ACTIVE TAB
    //----------------
    $scope.currentNavItem = 'diet-in';

    // EDIT ACTION
    //----------------
    //function for edit to new bill
    $scope.Editdiet = function(salesorder_id, customer_id) {
      var id = salesorder_id;
      $scope.params = $stateParams;
      $state.go('app.newBill', { id: salesorder_id, customer_id: customer_id, editbill: 'orderedbill' })
    };
    //merge bill popup
    vm.showTAMergeBillDialog = function(ev, currentbill) {
      $mdDialog.show({
        controller: MergeBillController,
        templateUrl: 'app/main/cashier/billing/currentbills/take.away.merge.bill.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        focusOnOpen: false,
        locals: {
          currentbills: currentbill
        }
      });
    };
    //merge bill controller
    function MergeBillController($scope, $mdDialog, currentbills, $mdToast) {
      $rootScope.user = $cookies.getObject('user');
      $scope.salesorder_id = currentbills.salesorder_id;
      $scope.salesitem_id = currentbills.salesitem_id;
      $scope.sales_dietType = currentbills.sales_dietType;
      // function for sales datas depending on staffid
      $scope.reload = function() {
        api.current_mergebill_service.getID.get({ staffID: $rootScope.user[0].staffID },
          function(response) {
            $scope.response = response;

            // map the response data for split diet Type like dinein
            vm.merge_dinein = current_mergebill.map(function(a) {
              if (a.sales_dietType == "dinein" && a.status == "ordered" && a.staffID == $rootScope.user[0].staffID && a.salesorder_id != currentbills.salesorder_id) {
                return { 'salesorder_id': a.salesorder_id, 'checked': false, 'salesitem_id': a.salesitem_id, 'payment_total': a.payment_total, 'status': a.status, 'sales_dietType': a.sales_dietType }
              }

            })

            // map the response data for split diet Type like takeaway
            vm.merge_takeaway = current_mergebill.map(function(a) {
              if (a.sales_dietType == "takeaway" && a.status == "ordered" && a.staffID == $rootScope.user[0].staffID && a.salesorder_id != currentbills.salesorder_id) {
                return { 'salesorder_id': a.salesorder_id, 'checked': false, 'salesitem_id': a.salesitem_id, 'payment_total': a.payment_total, 'status': a.status, 'sales_dietType': a.sales_dietType }
              }

            })


            // map the response data for split diet Type like doordelivery
            vm.merge_doordelivery = current_mergebill.map(function(a) {
              if (a.sales_dietType == "doordelivery" && a.status == "ordered" && a.staffID == $rootScope.user[0].staffID && a.salesorder_id != currentbills.salesorder_id) {
                return { 'salesorder_id': a.salesorder_id, 'checked': false, 'salesitem_id': a.salesitem_id, 'payment_total': a.payment_total, 'status': a.status, 'sales_dietType': a.sales_dietType }
              }

            })

            //filter  undefined datas in dinein from currentbill_service
            var merge_dinein = vm.merge_dinein.filter(function(dinein) {
              if (!undefined) {
                return dinein
              }
            })

            //filter  undefined datas in takeaway from currentbill_service
            var merge_takeaway = vm.merge_takeaway.filter(function(takeaway) {
              if (!undefined) {
                return takeaway
              }
            })


            //filter undefined datas in  doordelivery from currentbill_service
            var merge_doordelivery = vm.merge_doordelivery.filter(function(doordelivery) {
              if (!undefined) {
                return doordelivery
              }
            })

            //assign value to ng-repeat in front view
            if (currentbills.sales_dietType == "dinein") {
              $scope.TAMergeBills = merge_dinein;
            } else if (currentbills.sales_dietType == "takeaway") {
              $scope.TAMergeBills = merge_takeaway;
            } else if (currentbills.sales_dietType == "doordelivery") {
              $scope.TAMergeBills = merge_doordelivery;
            }

            //filter for get payment_total while user click id
            $scope.payment_total = [];
            response.forEach(function(fulldata) {
              if (fulldata.salesorder_id == currentbills.salesorder_id)
                $scope.payment_total.push(fulldata.payment_total);
            });

          })

        $timeout(function() {
          $scope.reload();
        }, 30000)

      };
      $scope.reload();

      $scope.TAMergeBillDtOptions = {
        dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        paging: false,
        info: false,
        autoWidth: false,
        responsive: true,
        searching: false,
        ordering: false
      };

      $scope.TAMergeBillHeaders = [{
          "id": 1,
          "label": "",
          "title": ""
        },
        {
          "id": 2,
          "label": "Ordered No",
          "title": "ORDERED NO"
        },
        {
          "id": 3,
          "label": "Amount",
          "title": "AMOUNT"
        },
        {
          "id": 4,
          "label": "Status",
          "title": "STATUS"
        }
      ];
      //remove old select which checking checkbox
      $scope.updateSelection = function(position, itens, title, mergebill) {
        angular.forEach(itens, function(subscription, index) {
          $scope.deleteindex = index;
          if (position != index)
            subscription.checked = false;
          $scope.selected = title;
          $scope.selected = []
          $scope.selected.push(mergebill)
        });
      }

      //radio button selected items
      $scope.selected = [];
      $scope.toggle = function(item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
        $scope.selected = [];
      };

      $scope.exists = function(item, list) {
        return list.indexOf(item) > -1;
      };


      //save funtion for merge bill
      $scope.Merge_Bill = function() {
        $scope.selected_Mergebills = angular.copy($scope.selected)
        $scope.current_mergebill_service = angular.copy($scope.response)
        var to_merge = [];
        var from_merge = [];
        $scope.selected_Mergebills.map(function(item) {
          //filter only items depending on salesorder_id for count length of items
          //To Merge all data for merge
          $scope.current_mergebill_service.forEach(function(a) {
            if (a.staffID == $rootScope.user[0].staffID && a.salesorder_id == item.salesorder_id)
              to_merge.push({ 'salesorder_id': a.salesorder_id, 'salesitem_id': a.salesitem_id, 'fmItemID': a.fmItemID, 'status': a.status, 'staffID': a.staffID, 'ordertime': a.ordertime, 'sales_items': a.sales_items, 'sales_quantity': a.sales_quantity, 'salesitem_rate': a.salesitem_rate, 'item_subrate': a.item_subrate, 'discount': a.discount, 'payment_total': parseInt(a.payment_total), 'tax': a.tax_rate, 'tax_sgst': a.tax_sgst });
          });
          //From Merge all data for merge
          $scope.current_mergebill_service.forEach(function(a) {
            if (a.staffID == $rootScope.user[0].staffID && a.salesorder_id == $scope.salesorder_id)
              from_merge.push({ 'salesorder_id': a.salesorder_id, 'salesitem_id': a.salesitem_id, 'status': a.status, 'staffID': a.staffID, 'fmItemID': a.fmItemID, 'ordertime': a.ordertime, 'sales_items': a.sales_items, 'sales_quantity': a.sales_quantity, 'salesitem_rate': a.salesitem_rate, 'item_subrate': a.item_subrate, 'discount': a.discount, 'payment_total': parseInt(a.payment_total), 'tax': a.tax_rate, 'tax_sgst': a.tax_sgst });
          });


        });
        //take data of food items matched for update in database 
        var food_items_matched = [];
        to_merge.map(function(to_merge) {
          from_merge.forEach(function(from_merge) {
            if (from_merge.fmItemID == to_merge.fmItemID) {
              food_items_matched.push({ 'fmItemID': from_merge.fmItemID, 'salesitem_id': from_merge.salesitem_id, 'status': from_merge.status, 'staffID': from_merge.staffID, 'salesorder_id': from_merge.salesorder_id, 'ordertime': from_merge.ordertime, 'sales_items': from_merge.sales_items, 'sales_quantity': from_merge.sales_quantity + to_merge.sales_quantity, 'salesitem_rate': from_merge.salesitem_rate, 'item_subrate': from_merge.item_subrate + to_merge.item_subrate, 'discount': from_merge.discount + to_merge.discount, 'payment_total': parseInt(from_merge.payment_total) + parseInt(to_merge.payment_total), 'tax': from_merge.tax + to_merge.tax, 'tax_sgst': from_merge.tax_sgst + to_merge.tax_sgst });
            }
          })
        })
        //take data of food items mismatched for post in database 
        var merge_data = to_merge.concat(from_merge)
        var filter_data = merge_data.filter(function(o1) {
          return !food_items_matched.some(function(o2) {
            return (o1.fmItemID == o2.fmItemID)
          })
        })
        //take and split from filter_data and exclude from_merge data for post in database 
        var filter_postdata = filter_data.filter(function(o1) {
          return !from_merge.some(function(o2) {
            return (o1.fmItemID == o2.fmItemID)
          })
        })
        var update_salesorder_item = [];
        var update_sales_payment = [];

        //map data  and update for different tables in database
        food_items_matched.map(function(a) {
          // for item table
          update_salesorder_item.push({ 'salesitem_id': a.salesitem_id, 'salesorder_id': to_merge[0].salesorder_id, 'sales_items': a.sales_items, 'sales_quantity': a.sales_quantity, 'salesitem_rate': a.salesitem_rate, 'item_subrate': a.item_subrate, 'ordertime': a.ordertime, 'fmItemID': a.fmItemID });
           // for payment table
          update_sales_payment.push({ 'salesorder_id': to_merge[0].salesorder_id, 'discount': a.discount == undefined ? null : a.discount, 'payment_total': a.payment_total, 'tax': a.tax == undefined ? null : a.tax, 'tax_sgst': a.tax_sgst == undefined ? null : a.tax_sgst });

        })
        var post_salesorder_item = [];
        var update_postPayment = [];
        //map data and post  for different tables in database
        filter_postdata.map(function(a) {
          // mismatch item
          post_salesorder_item.push({ 'salesorder_id': $scope.salesorder_id, 'to_merge_salesorder_id': to_merge[0].salesorder_id, 'sales_items': a.sales_items, 'sales_quantity': a.sales_quantity, 'salesitem_rate': a.salesitem_rate, 'item_subrate': a.item_subrate, 'fmItemID': a.fmItemID, 'ordertime': a.ordertime });
          // update_postPayment.push({ 'salesorder_id': $scope.salesorder_id, 'discount': a.discount == undefined ? null : a.discount, 'payment_total': a.payment_total, 'tax': a.tax == undefined ? null : a.tax,'tax_sgst': a.tax_sgst == undefined ? null : a.tax_sgst });
        })

        var food_ids = []; //&&  weekday(ordertime) BETWEEN " + weekday_start + " AND " + weekday_end + "
        filter_data.map(function(item) {
          if (food_ids.indexOf(item.salesorder_id) === -1) {
            food_ids.push(item.salesorder_id)

          }
        })
        // Make a map for `id: name`
        var tagMap = filter_data.reduce(function(map, tag) {
          map[tag.salesorder_id] = { 'salesorder_id': tag.salesorder_id, 'discount': tag.discount == undefined ? null : tag.discount, 'payment_total': tag.payment_total, 'tax': tag.tax == undefined ? null : tag.tax, 'tax_sgst': tag.tax_sgst == undefined ? null : tag.tax_sgst }
          return map // return callback
        }, {});
        // Quickly select names from the map:
        var selectedNames = food_ids.map(function(id) {
          return tagMap[id] //pass id to another function
        });
        var ans = {};
        for (var i = 0; i < selectedNames.length; ++i) {
          for (var obj in selectedNames[i]) {
            if (!obj.salesorder_id) {
              ans[obj] = ans[obj] ? ans[obj] + selectedNames[i][obj] : selectedNames[i][obj];
            }
          }
        }
        var q = [ans].map(function(a) {
          update_postPayment.push({ 'salesorder_id': $scope.salesorder_id, 'discount': a.discount == undefined ? null : a.discount, 'payment_total': a.payment_total, 'tax': a.tax == undefined ? null : a.tax, 'tax_sgst': a.tax_sgst == undefined ? null : a.tax_sgst });
        })
        // service for post the data for replace with salesorder_id
        api.post_salesorder_item.getAll.save(post_salesorder_item,
          function(response) {})

        api.update_postPayment.getID.update({ salesorder_id: $scope.salesorder_id }, update_postPayment,
          function(response) {});
        // service for update the data for replace with salesorder_id
        api.update_salesorder_item.getID.update({ salesorder_id: $scope.salesorder_id }, update_salesorder_item,
          function(response) {})

        api.update_sales_payment.getID.update({ salesorder_id: $scope.salesorder_id }, update_sales_payment,
          function(response) {});
        $mdDialog.hide();
        $mdToast.show({
          template: '<md-toast class="success"><span flex>BILL Merged successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        $window.location.reload();
        //$state.go("app.currentBills", {}, { reload: "app.currentBills" })       
      }
      //cancel button
      $scope.closeDialog = function() {
        $mdDialog.hide();

      };

    }
    //view bill popup
    vm.showDietInDialog = function(ev, currentbill) {
      $mdDialog.show({
        controller: 'viewbillController',
        templateUrl: 'app/main/cashier/billing/bill-dialog/bill-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        focusOnOpen: false,
        locals: {
          salebills: currentbill.salesorder_id,
          customer_id: currentbill.customer_id,
          taxs: tax_data,
          point: point_data,
          dietType: dietType,
          branch_data: branch_data,
          editbill: 'orderedbill',
          printInfo: 'orderedbill'
        },

      })
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.billing.currentBills')
    .controller('viewbillController', viewbillController);

  /** @ngInject */
  function viewbillController($scope, api, $timeout, editbill, branch_data, dietType, $cookies, taxs, point, printInfo, $rootScope, $mdDialog, $state, $stateParams, customer_id, salebills) {
    var vm = this;
    var originatorEv;
    $scope.closeDialog = function() {
      $mdDialog.hide();
    }
    $scope.permission = $cookies.get('admin')
    $scope.points = point;
    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
    $scope.salesorder_id = salebills;
    $scope.feedbackjson = dietType.newbill.feedbackLists[0];
    $scope.settings = dietType.settings;
    $scope.hideRate = dietType.newbill.tax_status[0];
    $scope.admin = []
    $scope.salesbillss = []
    $scope.saleseditt = []
    $scope.salesdeletee = []
    $scope.expensebillss = []
    $scope.expenseeditt = []
    $scope.expensedeletee = []
    $scope.Inventoryy = []
    $scope.Rawmaterialss = []
    $scope.salematerialss = []
    $scope.ODCC = []
    $scope.odceditt = []
    $scope.odcdeletee = []
    $scope.Marketingg = []

    var permissionss = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissionss.length; i++) {
      if (permissionss[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissionss[i] == 1) {
        $scope.salesbillss.push("salesbills");
      } else if (permissionss[i] == 12) {
        $scope.saleseditt.push("salesbills");
      } else if (permissionss[i] == 13) {
        $scope.salesdeletee.push("salesbills");
      } else if (permissionss[i] == 2) {
        $scope.expensebillss.push("expensebills");
      } else if (permissionss[i] == 22) {
        $scope.expenseeditt.push("salesbills");
      } else if (permissionss[i] == 23) {
        $scope.expensedeletee.push("salesbills");
      } else if (permissionss[i] == 3) {
        $scope.Inventoryy.push("inventory");
      } else if (permissionss[i] == 31) {
        $scope.Rawmaterialss.push("raw material");
      } else if (permissionss[i] == 32) {
        $scope.salematerialss.push("sales material");
      } else if (permissionss[i] == 4) {
        $scope.ODCC.push("ODC");
      } else if (permissionss[i] == 42) {
        $scope.odceditt.push("salesbills");
      } else if (permissionss[i] == 43) {
        $scope.odcdeletee.push("salesbills");
      } else if (permissionss[i] == 5) {
        $scope.Marketingg.push("Marketing");
      }
    }

    if (!salebills) {
      vm.billing = {
        'tableno': '',
        'dietType': '',
        'staff': '',
        'paymentselect': '',
        'paymentmode': '',
        'vm.user': ''
      }
      vm.fmitems = [{}]
      vm.user = '';
      $scope.feedback = ''
    } else {

      $scope.taxs = taxs;
      //get salesorder_id from currentbill for edit
      var salesorder_ids = salebills;
      api.dietitems.getaData.get({ salesorder_id: salesorder_ids },
        function(response) {
          $scope.responsedata = response;
          $scope.fmitems = response;
          var subtotal = 0;
          angular.forEach($scope.fmitems, function(fmitem) {
            var item = (fmitem != null) ? fmitem.salesitem_rate : 0;
            var qty = (fmitem != null) ? fmitem.sales_quantity : 0;
            fmitem.subitemtotal = item * qty;
            subtotal += item * qty;
            $scope.fmitems.subTotal = subtotal;

            if (dietType.settings.indivudual_exclude) {
              //tax_status 1 is for exclude(added tax in current item)
              //tax_status 2 is for include(not added tax in current item)
              $scope.fullcgst = 0
              $scope.fullsgst = 0
              $scope.fullrate = 0
              $scope.fullexcluderate = 0
              angular.forEach($scope.fmitems, function(fmitem) {
                if (fmitem.tax_status == 'exclude') {
                  fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
                  fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
                  fmitem.tax_cgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  fmitem.tax_sgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
                  $scope.fullexcluderate += (fmitem.sales_quantity * fmitem.salesitem_rate)
                  $scope.totalTax = $scope.fullcgst + $scope.fullsgst
                  $scope.excludesubTotal = subtotal + $scope.totalTax;
                } else if (fmitem.tax_status == 'include') {
                  fmitem.tax_cgst = (fmitem.tax_cgst != null) ? fmitem.tax_cgst : 0;
                  fmitem.tax_sgst = (fmitem.tax_sgst != null) ? fmitem.tax_sgst : 0;
                  fmitem.tax_cgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  fmitem.tax_sgstPerItem = (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullcgst += (fmitem.subitemtotal / 100) * fmitem.tax_cgst;
                  $scope.fullsgst += (fmitem.subitemtotal / 100) * fmitem.tax_sgst;
                  $scope.fullrate += (fmitem.sales_quantity * fmitem.salesitem_rate) - (fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem)
                  $scope.totalTax = $scope.fullcgst + $scope.fullsgst
                }
              })
            }
            var savings = 0;
            for (var i = 0; i < $scope.fmitems.length; i++) {
              if ($scope.fmitems[i].offerprice) {
                savings += $scope.fmitems[i].sales_quantity * (parseInt($scope.fmitems[i].actualprice) - parseInt($scope.fmitems[i].offerprice))
              }
            }
            $scope.savedamount = savings;
          })
        })


      //view salesorder

      api.salesorder_diet.getID.get({ salesorder_id: salesorder_ids },
        function(response) {
          $scope.response = response;
          $scope.view_deliverytime = response[0].sales_deliveryStatus == "Immediate" ? "Immediate" : response[0].sales_deliveryTime
          vm.billing = {
            'tableno': response[0].tableitem,
            'dietType': response[0].sales_dietType,
            'staff': response[0].manageBy,
          }
          $scope.manageBy = response[0].manageBy;
        })

      //view customer_info
      api.customer_infodiet.getID.get({ salesorder_id: customer_id },
        function(response) {
          $scope.customer = response[0];
          $scope.pointsEarned = response[0].pointsEarned
        })

      //view sales_payment
      api.payment_diet.getID.get({ salesorder_id: salesorder_ids },
        function(response) {
          
          $scope.payment = response[0];
          $scope.total_pointdiscount = response[0].pointdiscount;
        })

      //view customer_feedback
      api.customer_feedbackdiet.getID.get({ salesorder_id: salesorder_ids },
        function(response) {
          $scope.feedback = response[0];
        })
    }

    // function for edit data from viewbill to newbill when popup opened
    $scope.Editdiet = function() {
      var id = salebills;
      $scope.params = $stateParams;
      $state.go('app.newBill', { id: salebills, customer_id: customer_id, editbill: editbill })
    };

    // function for print data from viewbill to newbill when popup opened
    $scope.printToCart = function() {
      $rootScope.$broadcast("salesId", salebills, taxs, point, customer_id, branch_data, printInfo, dietType);
    }

    vm.paymentmode = 'cash';
    vm.paymentmodelist = [{
      "name": 'Cash',
      "value": 'cash'
    }, {
      "name": 'Card',
      "value": 'card'
    }, {
      "name": 'Cash & Card',
      "value": 'cash & card'
    }, {
      "name": 'Unpaid',
      "value": 'unpaid'
    }];


    $scope.foodTimeline = [{
      badgeClass: 'default',
      title: 'Food Ordered',
      content: '2 Biriyani, 2 Cola, 2 Dosai',
      manage: 'Updated By Rajendran',
      time: '12.55 pm'
    }, {
      badgeClass: 'default',
      title: 'Ate',
      content: '',
      manage: 'Updated By Rajendran',
      time: '01.15 pm'
    }, {
      badgeClass: 'default',
      title: 'Bill Printed',
      content: '',
      manage: 'Updated By Rajendran',
      time: '01.15 pm'
    }, {
      badgeClass: 'default',
      title: 'Paid',
      content: '4000 - Cash',
      manage: 'Updated By Rajendran',
      time: '01.17 pm'
    }];

  }
})();

(function() {
  'use strict';

  angular
    .module('app.billing.addreturnbill', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.addreturnbill', {
        url: '/addreturnbillnew',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/billing/addreturnbill/addreturnbill.html',
            controller: 'AddReturnController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{"Return Bills > Add Return Bill"}}'
        },
        resolve: {

          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },

          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          }

        }
      });

    // Translation
    //  $translatePartialLoaderProvider.addPart('app/main/cashier/billing/paidbills');

    // Api
    msApiProvider.register('bills.paidBills', ['app/data/paidbills/paidbills.json']);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.billing.addreturnbill')
    .controller('AddReturnController', AddReturnController);


  /** @ngInject */
  function AddReturnController( staffRole, api, dietType,  $rootScope, $scope, $resource, $state, $stateParams, $timeout, $mdToast, $mdPanel, $mdDialog) {
    var vm = this;
    this._mdPanel = $mdPanel;
    var originatorEv;



    vm.saleorderitems = vm.saleorderitems || [];
    vm.exitems = vm.exitems || { subtotal: 0, total_amount: 0 };

    // initialize items after loading from server
    vm.initItems = function () {
      vm.saleorderitems.forEach(function (item) {
        item.sales_quantity = Number(item.sales_quantity) || 0;    // original sold qty
        item.salesitem_rate = Number(item.salesitem_rate) || 0;  // rate
        // default return qty to 0 (or you can default to 1 or item.sales_quantity if desired)
        if (typeof item.return_qty === 'undefined' || item.return_qty === null) {
          item.return_qty = 0;
        }
        // compute item_subrate from return_qty initially
        //if(item.tax_status === 'include'){
        item.unit_price = Math.round((item.item_subrate / item.sales_quantity) * 100) / 100;
        item.item_subrate = Math.round((item.return_qty * item.unit_price) * 100) / 100;
        item.selected = !!item.selected;
        /*} else {
          var rateWithTax = item.salesitem_rate * (1 + ((Number(item.tax_sgst) || 0) / 100) + ((Number(item.tax_cgst) || 0) / 100));
          item.item_subrate = Math.round((item.return_qty * rateWithTax) * 100) / 100;
          item.selected = !!item.selected;
        } */

      });
      vm.updateTotals();
    };

    // called when checkbox toggles
    vm.onSelectItem = function (item, index) {
      item.selected = !!item.selected;
      if (item.selected) {
        // If you want to pre-fill return_qty when selecting, uncomment one of these:
        // item.return_qty = 1;                        // default 1
        // item.return_qty = item.sales_quantity;     // default max (full return)
        // Focus input (requires $timeout injected)
        if (typeof $timeout !== 'undefined') {
          $timeout(function () {
            var el = document.getElementById('qty-' + item.salesitem_id);
            if (el) { el.focus(); el.select && el.select(); }
          }, 0);
        }
      } else {
        // when unchecking keep return_qty but still update totals
        vm.updateLineSubtotal(item);
        vm.updateTotals();
      }
    };

    // qty changed by user
    vm.onQtyChange = function (item) {
      // sanitize value
      item.return_qty = Math.max(0, Math.floor(Number(item.return_qty) || 0));
      // never allow return_qty > sold quantity
      if (item.return_qty > item.sales_quantity) {
        item.return_qty = item.sales_quantity;
      }
      vm.updateLineSubtotal(item);
      vm.updateTotals();
    };

    // optional blur
    vm.onQtyBlur = function (item) {
      vm.onQtyChange(item);
    };

    // update a single line subtotal using return_qty * rate
    vm.updateLineSubtotal = function (item) {
      // console.log("Updating line subtotal for item:", item);
      //item.item_subrate;
      item.unit_price = Math.round((item.item_subrate / item.sales_quantity) * 100) / 100;
      var qty = Number(item.return_qty) || 0;
      var rate = Number(item.unit_price) || 0;
      item.item_subrate = Math.round((qty * rate) * 100) / 100;
    };

    // overall totals from returned items (sum of item_subrate)
    vm.updateTotals = function () {
      var subtotal = 0;

      // Sum only rows that are selected (and have a positive return_qty)
      vm.saleorderitems.forEach(function (it) {
        if (it.selected) {
          // Ensure line subtotal is up-to-date (in case qty edited but not yet recalculated)
          // If you already call updateLineSubtotal on change, this is optional:
          it.item_subrate = Math.round(((Number(it.return_qty) || 0) * (Number(it.salesitem_rate) || 0)) * 100) / 100;

          subtotal += Number(it.item_subrate) || 0;
        }
      });

      vm.exitems.subtotal = Math.round(subtotal * 100) / 100;

      // compute total_amount (add tax/discount if needed)
      vm.exitems.total_amount = vm.exitems.subtotal;
    };

    vm.fetchSalesOrder = function (orderid) {
      console.log("Navigating to return bill view for ID:", orderid);
      vm.initItems();
      // if your state is 'app.viewreturnbill' use that, otherwise use 'app.returnbills.viewreturnbill'
      //$state.go('app.viewreturnbill', { id: returnBill.returnorder_id });
      //$scope.returnBill = returnBill;
      api.return_salesorder.getID.get({ id: orderid },
        function (response) {
          console.log("Successfully fetched sales order:", response);

          vm.salesorder_id = response.sale.salesorder_id;
          vm.exitems.subtotal;
          vm.exitems.total_amount;
          vm.saleorderitems = response.items;
          console.log("Sale order items:", vm.saleorderitems);

        },
        function (error) {
          console.error("Error fetching sales order:", error);
          console.error("Error details:", error.data);
          if (error.status === 404) {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Searched Bill is not Found</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        }
      );
    };


    // controller (inside function ReturnCtrl(...) where vm = this)

    vm.modified_name = [];
    staffRole.map(function (staff) {
      if ($rootScope.user[0].staffID == staff.staffID) {
        vm.modified_name.push(staff.name)
      }
    })
    vm.returnTypes = dietType.ReturnTypes;
    // Save button handler
    $scope.add_purchase = function () {
      // Build list of selected items with return_qty > 0
      var items = (vm.saleorderitems || []).filter(function (it) {
        return it.selected && Number(it.return_qty) > 0;
      }).map(function (it) {
        return {
          // return_order_items fields
          item_id: it.fmItemID || it.item_id || it.salesitem_id,
          qty_returned: Number(it.return_qty) || 0,
          price: Number(it.salesitem_rate) || 0
        };
      });

      if (!items || items.length === 0) {
        // show friendly message
        alert('Please select at least one item and enter quantity to return.');
        return;
      }

      // compute total_refund as sum of (qty_returned * price)
      var total_refund = items.reduce(function (sum, it) {
        return sum + (Number(it.qty_returned) * Number(it.price));
      }, 0);
      // Build return_order object as required
      var orderreturnpayload = {
        // top-level return_order fields
        original_salesorder_id: vm.salesorder_id || 0,
        total_refund: Math.round(total_refund * 100) / 100,
        refund_method: vm.refund_method || 'damage',
        created_by: $rootScope.user[0].staffID || null,
        modified_name: vm.modified_name[0] || null,
        // items

      };
      var returnitems = items;
      // disable save UI (optional)
      vm.savingReturn = true;

      // POST to server
      // Update this URL to match your server route if different

      var fulldata = {
        'orderreturnpayload': orderreturnpayload,
        'returnitems': returnitems,
        // 'browsershow': browsershow
      };

      api.return_order.getAll.save(fulldata,
        function (response) {
          vm.salesorder_id = ''; 
          vm.saleorderitems = [];
          vm.exitems = { subtotal: 0, total_amount: 0 };
          vm.refund_method = 'cash';
          $scope.saleorderno = '';

          $mdToast.show({
            template: '<md-toast class="success"><span flex>Successfully Created</span></md-toast>',
            position: 'bottom right',
          });
        },
        function (error) {
          $mdToast.show({
            template: '<md-toast class="error"><span flex>Error</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        }
      );
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('tablesettings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.tablesettings', {
        url: '/tablesettings',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/tablesettings/tablesettings.html',
            controller: 'TableSettingsController as vm'
          }
        },
        resolve: {
          TableNo: function(apiResolver) {
            return apiResolver.resolve('TableNo.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: '{{ "RESTRAUNTANT.TABLE-NO" | translate }}'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('tablesettings')
    .controller('TableSettingsDialogController', TableSettingsDialogController);

  /** @ngInject */

  function TableSettingsDialogController($scope, $rootScope, msNavigationService, $mdDialog, $mdToast, api, TableNo) {
    var vm = this;
    // DATA
    //----------------

    vm.tablesinfo = TableNo;


    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    //save function for add table number to databse
    $scope.addNewTable = function(tableinfo) {
      var data = [tableinfo].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'table_no': item.table_no }
      })
      api.TableNo.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { table_id: response.insertId })
          console.log(mergeData)
          vm.tablesinfo.unshift(mergeData);
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Table added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
          $mdDialog.hide(); // close popup                 
        },
        // Error
        function(response) {
          console.error(response);
        }
      );
    };
    // end add tabl no
    // only number validation of autocomplete
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };



    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('si-item')
    .controller('SiItemController', SiItemController);



  function SiItemController($scope, msNavigationService, $rootScope, dietType, siCategory, branch_data, $mdDialog, $mdToast, api, $stateParams, $state, $timeout, $window) {
    var vm = this;

       
    
      //JsBarcode("#code128", "Hi!");
    // DATA
    //----------------   
    vm.settings = dietType.settings || {};
    vm.print = dietType.print;
    $scope.mdtableselected = []; // dummy assign
    //filter sale material categories for branch wise
    var siCategorys = siCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    });

    vm.branchFilterData = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    });


    vm.salecategorys = siCategorys; //assign sale material categories data to dropdown
    $scope.clearText = function() {
      vm.search = '';
    }
    //open popup window for edit purpose
    // Add Table dialog
    vm.showAddTableDialogs = function(ev, siInfo) {
      $mdDialog.show({
        controller: 'addSaleDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/sale-item/item/dialog/si-additem.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          // FmInfo: fmInfo,
          siItems: vm.saleMenusInfo,
          siCategory: vm.salecategorys,
          siInfo: siInfo,
          dietType: dietType,
          branch_data: vm.branchFilterData

        }
      });
    };

    // GET CATEGORY NAME
    //---------------- 
    $scope.getCategoryName = function(siInfo) {
      if (!vm.salecategorys) {
        return;
      }
      for (var i = 0; i < vm.salecategorys.length; i++) {
        if (vm.salecategorys[i].siCatergoryID == siInfo.siCatergoryID) {
          return vm.salecategorys[i].siCatergoryName
        }
      }
    };

    $scope.getDesserts = getDesserts; //method for function call
    $scope.saleitems_query = {
      filter: '',
      limit: '200',
      page: 1,
      branch_id: $rootScope.user[0].branch_id,
      category: ''
    };

    function getDesserts() {
      $scope.saleitems_query = {
        filter: '',
        limit: '200',
        page: $scope.saleitems_query.page,
        branch_id: $rootScope.user[0].branch_id,
        category: '',
      };

      $scope.reload = function() {
        $scope.promise = api.siItemLimit.getAll.get($scope.saleitems_query, paidexpense_success).$promise;
      };
      $scope.reload();
    }

    getDesserts(); //function call for access inside of the function

    function paidexpense_success(desserts) {      
      $scope.paidexpense_count = desserts[0].paidexpense_count;
      vm.saleMenusInfo = desserts[0].results;
    }

    //balance expense filter
    $scope.$watch('saleitems_query.filter', function(newValue, oldValue) {
      console.log(newValue);
      console.log(oldValue);

      if (!oldValue) {
        var bookmark = $scope.saleitems_query.page ? $scope.saleitems_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.saleitems_query.page = 1
      }
      if (!newValue) {
        $scope.saleitems_query.page = bookmark ? bookmark : 1
      };
      $scope.getDesserts = getDesserts; //method for function
      $scope.reload();
    });
    // Delete alert
    vm.deleteContactConfirm = function(siInfo, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Item?')
        .ariaLabel('delete Item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.siItems.getID.delete({ siItemID: siInfo.siItemID },
          function(response) {

            $mdToast.show({
              template: '<md-toast class="success"><span flex>Items deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

            //success callback
            deleteItem(siInfo);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteItem(siInfo) {
      vm.saleMenusInfo.splice(vm.saleMenusInfo.indexOf(siInfo), 1);
    }
    //clear text function while search
    $scope.clearTexts = function() {
      $scope.saleitems_query.filter = '';
    }

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
   /*
    ------------------------------------------

    View Customer 

    ------------------------------------------
    */
    $scope.params = $stateParams; //syntax for get url id
    if ($scope.params.id) {
      console.log($scope.params.id)

      $scope.getNumber = function(num) {
        return new Array(num);   
      }
      //edit sales_customer
     // JsBarcode(".barcode").init();


      $scope.barcode_settings =[{
        "title1": "hello",
        "title2":"hello2",
        "format":"CODE128",
        "width":"6.2",
        "height":"2.1",
        "showlabel":true,
        "alignment":'center',
        "font_size":"12px",  
        "paper_width":"21.59",
        "paper_height":"27.94",
        "columns":3,
        "rows":10,
        "page_alignment":"center",
        "top_margin":"1.27",
        "left_margin":"0.9",
        "row_space":"0.5",
        "column_space":"0.5"        
      }]

      //function for Breadcrumb Label with idnewBill
      $rootScope.getBreadcrumbLabel = function() {
          return $scope.params.name;
      } 

      vm.barcode_settings2 =[{"hello":"hello"}, {"hello":"hello"}];
     
      JsBarcode(".barcode1", "978020137923", {
        format: "CODE128",
        lineColor: "#000",
        width:2,
        height:90,
        displayValue: true
      }); 

    };

    //$scope.number = $scope.barcode_settings[0].columns * $scope.barcode_settings[0].rows;
    $scope.number = 6;
    $scope.getNumber = function(num) {
        return new Array(num);   
    }

    $scope.viewCustomer = function(siInfo) {
      var barcode = 978020137923;
      $state.go('app.barcode', { id: siInfo.siItemID, name: siInfo.siname, barcode: barcode})
    };

    $scope.savePrint = function(siInfo) {
      $timeout(function() {
        var w = window.open('', '_blank', 'width=800,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        w.document.write($('#printBarcode').html()); //only part of the page to print, using jquery
        //$timeout(function() {
          w.document.close(); //this seems to be the thing doing the trick
         // w.focus();
         // w.print();
         // w.close();
        //}, 250);
          
      }, vm.print.print_delay);
  
    }

    


  }

})();

(function() {
  'use strict';

  angular
    .module('si-category', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.si-category', {
        url: '/sale-item-category',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/sale-item/catergory/si-category.html',
            controller: 'SiCategoryController as vm'
          }
        },
        resolve: {
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          }
        },
        ncyBreadcrumb: {

          label: "{{'FOOD.SALE-MATERIAL-CATEGORY' | translate }}"

        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('si-category')
    .controller('SiCategoryController', SiCategoryController);

  /** @ngInject */
  function SiCategoryController($scope, msNavigationService, $rootScope, siCategory, $mdDialog, $mdToast, api) {
    var vm = this;
    // DATA
    //----------------

    // filter sale material categories for branch wise
    var siCategorys = siCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.salecategorys = siCategorys; //assign sale material categories for branch wise

    // Add New Category
    $scope.addNewCategory = function(salecategory) {
      var data = [salecategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'siCatergoryName': item.siCatergoryName }
      })
      api.siCategory.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { siCatergoryID: response.insertId })
          vm.salecategorys.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast  class="success"><span flex>Catergory added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {

        }
      );
    };
    // Cancel add item data clear
    $scope.cancelAddItem = function() {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.salecategory = {};
      $scope.addCategory.$setUntouched(); // Validation error removed
    }

    // Edit alert
    $scope.updateaData = function(salecategory) {
      api.siCategory.getID.update({ siCatergoryID: salecategory.siCatergoryID }, salecategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Category updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {}
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(salecategory) {
      salecategory.backupName = angular.copy(salecategory.siCatergoryName);
    };
    $scope.cancelItem = function(salecategory) {
      salecategory.siCatergoryName = angular.copy(salecategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(salecategory, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Category?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');


      $mdDialog.show(confirm).then(function() {

        api.siCategory.getID.delete({ siCatergoryID: salecategory.siCatergoryID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Category deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

            //success callback
            deleteContact(salecategory);

          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteContact(salecategory) {
      vm.salecategorys.splice(vm.salecategorys.indexOf(salecategory), 1);

    }


  }
})();

(function() {
  'use strict';

  angular
    .module('rm-item')
    .controller('RmitemController', RmitemController);



  function RmitemController($scope, msNavigationService, $mdDialog, foodUnit, $rootScope, $mdToast, rmItems, rmCategory, api) {
    var vm = this;

    // DATA
    //---------------- 

    //filter raw material items for branch wise  
    var rmdata = rmItems.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    //filter raw categories items for branch wise  
    var rmCategorys = rmCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.rawMenusInfo = rmdata; //assign filtered raw material items to table
    vm.rawcategorys = rmCategorys; //assign filtered raw material categories to dropdown

    //clear search text while search
    $scope.clearText = function() {
      vm.search = '';
    }

    //open popup window for edit current raw material items
    // Add Table dialog
    vm.showAddTableDialog = function(ev, rmInfo) {
      $mdDialog.show({
        controller: 'addRawDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/raw-material/item/dialog/rm-additem.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          // FmInfo: fmInfo,
          rmItems: vm.rawMenusInfo,
          rmCategory: vm.rawcategorys,
          rmInfo: rmInfo,
          foodUnit: foodUnit,

        }
      });
    };

    // GET CATEGORY NAME
    //---------------- 
    $scope.getCategoryName = function(rmInfo) {
      if (!vm.rawcategorys) {
        return;
      }
      for (var i = 0; i < vm.rawcategorys.length; i++) {
        if (vm.rawcategorys[i].rmCatergoryID == rmInfo.rmCatergoryID) {
          return vm.rawcategorys[i].rmCatergoryName
        }
      }
    };

    // Delete alert
    vm.deleteContactConfirm = function(rmInfo, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Item?')
        .ariaLabel('delete Item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.rmItems.getID.delete({ rmItemID: rmInfo.rmItemID },
          function(response) {

            $mdToast.show({
              template: '<md-toast class="success"><span flex>Item deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

            //success callback
            deleteItem(rmInfo);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteItem(rmInfo) {
      vm.rawMenusInfo.splice(vm.rawMenusInfo.indexOf(rmInfo), 1);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('rm-category', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.rm-category', {
        url: '/raw-material-category',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/raw-material/catergory/rm-category.html',
            controller: 'RmCategoryController as vm'
          }
        },
        resolve: {
          rmCategory: function(apiResolver) {
            return apiResolver.resolve('rmCategory.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: "{{'FOOD.RAW-MATERIAL-CATEGORY' | translate }}"
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('rm-category')
    .controller('RmCategoryController', RmCategoryController);


  function RmCategoryController($scope, msNavigationService, $mdDialog, $rootScope, $mdToast, rmCategory, api) {
    var vm = this;
    // DATA
    //----------------

    //filter raw material categories data for branch wise
    var rmCategorys = rmCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.rawcategorys = rmCategorys; //assign filterd raw material categories to table

    // Add New Category
    $scope.addNewCategory = function(rawcategory) {
      var data = [rawcategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'rmCatergoryName': item.rmCatergoryName }
      })
      api.rmCategory.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { rmCatergoryID: response.insertId })
          vm.rawcategorys.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Category added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {}
      );
    };
    // Cancel add item data clear
    $scope.cancelAddItem = function() {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.rawcategory = {};
      $scope.addCategory.$setUntouched(); // Validation error removed
    }

    // Edit alert
    $scope.updateaData = function(rawcategory) {
      api.rmCategory.getID.update({ rmCatergoryID: rawcategory.rmCatergoryID }, rawcategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Catergory updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {}
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(rawcategory) {
      rawcategory.backupName = angular.copy(rawcategory.rmCatergoryName);
    };
    $scope.cancelItem = function(rawcategory) {
      rawcategory.rmCatergoryName = angular.copy(rawcategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(rawcategory, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Category?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {

        api.rmCategory.getID.delete({ rmCatergoryID: rawcategory.rmCatergoryID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Category deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

            //success callback
            deleteContact(rawcategory);

          },
          function(response) {
            // error callback
            console.log("error");
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteContact(rawcategory) {
      vm.rawcategorys.splice(vm.rawcategorys.indexOf(rawcategory), 1);

    }

  }

})();

(function() {
  'use strict';

  angular
    .module('food-settings')
    .controller('FoodSettingsDialogController', FoodSettingsDialogController);

  /** @ngInject */

  function FoodSettingsDialogController($scope, msNavigationService, $mdDialog,dietType,$rootScope, $mdToast, api, FmInfo, fmItems, fmCategory, foodType, foodUnit) {
    var vm = this;


    // Text
    vm.title = 'Edit';

    // DATA
    //---------------- 
    vm.fmInfos = fmItems;
    vm.fmInfo = angular.copy(FmInfo);
    vm.foodtypes = foodType;
    vm.foodcategorys = fmCategory;
    vm.foodUnits = foodUnit;
    vm.settings = dietType.settings;
    vm.dietType=dietType.newbill.tax_status

 $scope.onlynumberDot = onlynumberDot;

    function onlynumberDot(e) {
      if (e.which != 8 && e.which != 0 && e.which != 46 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };

  // Phone number validation
    $scope.onlynumbers = onlynumbers;

    function onlynumbers(e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          e.preventDefault();
        }
    };

    if (!vm.fmInfo) {
      vm.fmInfo = {
        'fmItemType': '',
        'fmCatergoryID': '',
        'fmItemName': '',
        'fmItemQty': '',
        'fmItemUnit': vm.foodUnits[0].value,
        'fmItemPrice': ''
      };
    vm.fmInfo.tax_status=dietType.settings.global_tax ? '' : dietType.newbill.tax_status[0].value
      // Text
      vm.title = 'Add';
      vm.newFMItem = true;

    }
    // Close Dialog
    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    // Add New Category
    //----------------
    $scope.addFMItem = function() {
      var fmInfo = vm.fmInfo;
       var data = [fmInfo].map(function(item) {
      return { 'branch_id':$rootScope.user[0].branch_id,'status_flag': 1, 'fmItemName': item.fmItemName, 'tax_sgst': item.tax_sgst,'tax_cgst': item.tax_cgst,'tax_status': item.tax_status,'fmItemType': item.fmItemType, 'fmItemQty': item.fmItemQty, 'fmItemUnit': item.fmItemUnit, 'fmItemPrice': item.fmItemPrice,'offerprice':item.offerprice, 'dealer_price':item.dealer_price, 'actual_price':item.actual_price, 'fmCatergoryID': item.fmCatergoryID }
        })
      api.fmItems.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { fmItemID: response.insertId })
          vm.fmInfos.unshift(mergeData);
           $mdToast.show({
              template: '<md-toast class="success"><span flex>Items added successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          $mdDialog.hide(); // close popup 
        },
        // Error
        function(response) {
          console.error(response);
        }
      );
    };

    // Edit New Category
    //----------------
    $scope.editFMItem = function(fmInfo) {
      var fmInfo = vm.fmInfo;
      api.fmItems.getID.update({ fmItemID: fmInfo.fmItemID }, fmInfo,
        function(response) {
          for (var i = 0; i < vm.fmInfos.length; i++) {
            if (vm.fmInfos[i].fmItemID === vm.fmInfo.fmItemID) {
              vm.fmInfos[i] = angular.copy(vm.fmInfo);
              break;
            }
          };

          $mdDialog.hide(); // close popup 
         $mdToast.show({
              template: '<md-toast class="success"><span flex>Items updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

        },
        // Error
        function(response) {
          console.error(response);
        }
      );

    };

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

      /*  // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function() {
  'use strict';

  angular
    .module('super-admin-dashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.superAdminDashboard', {
        url: '/super-admin-dashboard',
        views: {
           'content@app': {
            templateUrl: 'app/main/super-admin/super-admin-dashboard/super-admin-dashboard.html',
            controller: 'SuperAdminDashboardController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Dashboard'
        },
        bodyClass: 'superadmindashboard'
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('super-admin-dashboard')
    .controller('SuperAdminDashboardController', SuperAdminDashboardController);

  /** @ngInject */
  function SuperAdminDashboardController(msNavigationService,$state,$rootScope) {
    var vm = this;
console.log("hello"+$rootScope.user[0].permissions)



      msNavigationService.clearNavigation();


       msNavigationService.saveItem('super-admin-dashboard', {
        title: 'Dashboard',
        icon: 'icon-tile-four',

        state: 'app.superAdminDashboard'
      });


      // Navigation
      msNavigationService.saveItem('cashier', {
        title: 'Manage Branches',
        group: true,
        translate: 'COMPANY.MANAGE-BRANCHES'
      });

      msNavigationService.saveItem('branchlist', {
        title: 'List of Branches',
        icon: 'icon-format-list-bulleted',
        state: 'app.branchlist',
        translate: 'COMPANY.LISTOFBRANCHES'
      });
      msNavigationService.saveItem('addbranch', {
        title: 'Add Branch',
        icon: 'icon-folder-plus',
        state: 'app.addbranch',
        translate: 'COMPANY.ADD-BRANCH'
       
      });
      // Navigation
      msNavigationService.saveItem('design', {
        title: 'Design',
        group: true
      
      });

      msNavigationService.saveItem('design-color', {
        title: 'Color',
        icon: 'icon-format-color-fill',
        state: 'app.designColor',
      });

      msNavigationService.saveItem('accountDetails', {
        title: 'Account Details',
        group: true
        //translate : 'COMPANY.MANAGE-BRANCHES'
      });



      msNavigationService.saveItem('restaurantaccount', {
        title: 'Account Details',
        icon: 'icon-account-box-outline',
        state: 'app.restaurantaccount',
        translate: 'COMPANY.ACCOUNT-DETAILS'
      });

      $state.go('app.superAdminDashboard');
    
    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('restaurantaccount', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.restaurantaccount', {
        url: '/account-details',
        views: {
          'content@app': {
            templateUrl: 'app/main/super-admin/restaurant-account/restaurant-account.html',
            controller: 'RestaurantAccountController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "COMPANY.ACCOUNT-DETAILS" | translate }}'
        },
        
      });


  }
})();

(function() {
  'use strict';

  angular
    .module('restaurantaccount')
    .controller('RestaurantAccountController', RestaurantAccountController);

  /** @ngInject */
  function RestaurantAccountController(msNavigationService) {
    var vm = this;

    // Data
    vm.dashboardText = 'Welcome to dashboard';

    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('editjsonsettings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.editjsonsettings', {
        url: '/edit-settings',
        views: {
          'content@app': {
            templateUrl: 'app/main/super-admin/edit-json-settings/edit-json-settings.html',
            controller: 'EditJsonSettingsController as vm'
          }
        },

        ncyBreadcrumb: {
           label: 'Edit Json Settings'
        },
        resolve: {
          getLocalJsonIUrl: function(apiResolver) {
          return apiResolver.resolve('getLocalJsonIUrl@get');
        }
      }

      });


  }
})();

(function () {
  'use strict';

  angular
    .module('editjsonsettings')
    .controller('EditJsonSettingsController', EditJsonSettingsController);

  /** @ngInject */
  function EditJsonSettingsController($scope, $rootScope, $state, $stateParams, $timeout, $mdDialog, $http, getLocalJsonIUrl, api) {
    var vm = this;

    var domain_category = $rootScope.user[0].domain_category;
    console.log(domain_category);

    var datas = getLocalJsonIUrl;
    console.log(datas);
    $scope.tax = 2;

    var info =
      [
        { "name": "Ford", "models": 'ehh' },
        { "name": "BMW", "models": 'ehh' },
        { "name": "Fiat", "models": 'ehh' }
      ]


    $scope.update = function () {
      // console.log(datas);
      api.update_local_json.getAll.save({ 'domain_category': domain_category },
        function (response) {
          console.log(response)
        },
        // Error
        function (response) {

        })
    }
    




    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('branchlist', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.branchlist', {
        url: '/branch-list',
        views: {
          'content@app': {
            templateUrl: 'app/main/super-admin/branch-list/branch-list.html',
            controller: 'BranchListController as vm'
          }
        },
         resolve: {
        branch_data: function (apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
        }
    },
        ncyBreadcrumb: {
           label: '{{ "COMPANY.LISTOFBRANCHES" | translate }}'
        },

      });


  }
})();

(function() {
  'use strict';

  angular
    .module('branchlist')
    .controller('BranchListController', BranchListController);

  /** @ngInject */
  function BranchListController($scope, $state,$stateParams, $timeout, $mdDialog,branch_data) {
    var vm = this;
    
$scope.branch_data=branch_data;
//redirect for edit purpose
    $scope.submit=function(branch_id){
      $scope.params = $stateParams;
      $state.go('app.addbranch', { id: branch_id })
      }

    vm.branchesinfo = [{
      "branchName" : "Tambaram",
      "status" : "Active"
    },
    {
      "branchName" : "Adyar",
      "status" : "Active"
    },
    {
      "branchName" : "Chrompet",
      "status" : "Active"
    },
    {
      "branchName" : "T.Nagar",
      "status" : "Active"
    },
    ];


   
    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('design-color', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.designColor', {
        url: '/design-color',
        views: {
          'content@app': {
            templateUrl: 'app/main/super-admin/design-color/design-color.html',
            controller: 'DesignColorController as vm'
          }
        },
        ncyBreadcrumb: {
           label: 'Color'
        },
        
      });


  }
})();

(function() {
  'use strict';

  angular
    .module('design-color')
    .controller('DesignColorController', DesignColorController);

  /** @ngInject */
  function DesignColorController(msNavigationService) {
    var vm = this;

    // Data
    vm.colorlist = [{
      "name": 'Red',
      "value": '#f44336',
      "selected" : "no"
    },
    {
      "name": 'Pink',
      "value": '#e91e63',
      "selected" : "no"
    },
    {
      "name": 'Purple',
      "value": '#9c27b0',
      "selected" : "yes"
    },
    {
      "name": 'Deep Purple',
      "value": '#673ab7',
      "selected" : "yes"
    },{
      "name": 'Indigo',
      "value": '#3f51b5',
      "selected" : "no"
    },
    {
      "name": 'Blue',
      "value": '#2196f3',
      "selected" : "no"
    },
    {
      "name": 'Light Blue',
      "value": '#03a9f4',
      "selected" : "yes"
    },
    {
      "name": 'Cyan',
      "value": '#00bcd4',
      "selected" : "yes"
    }];

    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('ssadmin-dashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.ssAdminDashboard', {
        url: '/ssadmin-dashboard',
        views: {
           'content@app': {
            templateUrl: 'app/main/ssadmin/ssadmin-dashboard/ssadmin-dashboard.html',
            controller: 'SSAdminDashboardController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Dashboard'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('ssadmin-dashboard')
    .controller('SSAdminDashboardController', SSAdminDashboardController);

  /** @ngInject */
  function SSAdminDashboardController(msNavigationService) {
    var vm = this;



    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('addbranch', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.addbranch', {
        url: '/add-branch/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/super-admin/add-branch/add-branch.html',
            controller: 'AddBranchController as vm'
          }
        },

        ncyBreadcrumb: {
          label: "{{getBreadcrumbLabel()}}"
        },
          resolve: {
          corporate_settings: function(apiResolver) {
            return apiResolver.resolve('corporate_settings@get');
          },
             dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
           printsize: function(apiResolver) {
            return apiResolver.resolve('printsize@get');
          },
               staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          }
        }

      });


  }
})();


(function () {
  'use strict';

  angular
    .module('addbranch')
    .controller('AddBranchController', AddBranchController);

  /** @ngInject */
  function AddBranchController(msNavigationService, $state, staffRole, printsize, corporate_settings, dietType, $rootScope, $mdToast, $scope, api, $stateParams) {
    var vm = this;

    // Data
    vm.dashboardText = 'Welcome to dashboard';
    $scope.printSize = printsize.newbill.printSize //get print size from local json
    vm.domainTypes = corporate_settings.domain.categories //get domain categories from local json
    $scope.minDate = new Date() //assign today date by default
    $scope.params = $stateParams;


    vm.barcodePrinter = [{
      "name": 'Disable',
      "value": 0
    }, {
      "name": 'Enable',
      "value": 1
    }];
    /*----------------------
    Add scenario init branch  data
    -----------------------*/
    if (!$scope.params.id) {
      $scope.branch = {
        'branch_name': '',
        'contact_number': '',
        'address': '',
        'GstNo': '',
        'city': '',
        'state': '',
        'pincode': '',
        'barcode_enable': 0

      }
    }
    /*----------------------
      edit scenario init branch  data
      -----------------------*/
    else {
      //service for get branch data with id
      api.branch_data.getID.get({ branch_id: $scope.params.id },
        function (response) {
          $scope.branch = response[0];
          console.log(response[0])
          //service for get staff data with id
          api.getstaff.getID.get({ staffID: response[0].staffID },
            function (response) {
              $scope.admin.personname = response[0].name
              $scope.admin.username = response[0].username
            })
          //store permissions in array
          $scope.admin = []
          $scope.salesbillss = []
          $scope.dealerbillss = []
          $scope.expensebillss = []
          $scope.Inventoryy = []
          $scope.Rawmaterialss = []
          $scope.salematerialss = []
          $scope.ODCC = []
          $scope.Marketingg = []
          $scope.customerr = []
          $scope.smss = []
          $scope.whatsappp = []
          $scope.uploaddbb = []
          $scope.stewardappp = []

          var permissionss = JSON.parse("[" + response[0].permissions + "]"); //covert as array format in came from db data
          //check permissions for particular branch
          for (var i = 0; i < permissionss.length; i++) {
            if (permissionss[i] == 0) {
              $scope.admin.push("admin");
            } else if (permissionss[i] == 1) {
              $scope.salesbillss.push("salesbills");
            } else if (permissionss[i] == 2) {
              $scope.expensebillss.push("expensebills");
            } else if (permissionss[i] == 3) {
              $scope.Inventoryy.push("inventory");
            } else if (permissionss[i] == 31) {
              $scope.Rawmaterialss.push("raw material");
            } else if (permissionss[i] == 32) {
              $scope.salematerialss.push("sales material");
            } else if (permissionss[i] == 4) {
              $scope.ODCC.push("ODC");
            } else if (permissionss[i] == 5) {
              $scope.Marketingg.push("Marketing");
            } else if (permissionss[i] == 51) {
              $scope.customerr.push("customer");
            } else if (permissionss[i] == 52) {
              $scope.smss.push("sms");
            } else if (permissionss[i] == 53) {
              $scope.whatsappp.push("whatsapp");
            } else if (permissionss[i] == 6) {
              $scope.uploaddbb.push("uploaddbb");
            } else if (permissionss[i] == 7) {
              $scope.dealerbillss.push("dealerbills");
            } else if (permissionss[i] == 99) {
              $scope.stewardappp.push("stewardapp");
            }

          }
          //merge permissions 
          var merge_Permissions = $scope.admin.concat($scope.salesbillss).concat($scope.dealerbillss).concat($scope.expensebillss).concat($scope.inventoryy).concat($scope.Rawmaterialss).concat($scope.salematerialss).concat($scope.ODCC).concat($scope.Marketingg).concat($scope.uploaddbb).concat($scope.stewardappp);
          var set = new Set(merge_Permissions);
          merge_Permissions = Array.from(set);
          $scope.modules = merge_Permissions; //assign permissions for modules
        })

    }
    //update branch data to branch table and staff table
    $scope.update = function () {
      var permis = [$scope.salesbill, $scope.dealersbill, $scope.expensebill, $scope.inventory, $scope.salesmaterial, $scope.rawmaterial, $scope.odc, $scope.customer, $scope.marketing, $scope.sms, $scope.whatsapp, $scope.uploaddb, $scope.stewardapp]
      var fulldata = permis.filter(function (data) {
        if (data != '')
          return data
      })
      //store permission in variable
      var permissions = JSON.parse("[" + fulldata.toString() + ',' + 0 + ',' + 12 + ',' + 22 + ',' + 23 + ',' + 42 + ',' + 43 + "]"); //covert as array format in came from db data and edit, delete permission
      var branch = $scope.branch
      var addBranch = [{
        'branch_name': branch.branch_name,
        'corporate_name': branch.corporate_name,
        'corporate_id': dietType.settings.corporate_id,
        'expiry_date': branch.expiry_date,
        'domain_category': branch.domain_category,
        'contact_number': branch.contact_number,
        'address': branch.address,
        'GstNo': branch.GstNo,
        'city': branch.city,
        'state': branch.state,
        'pincode': branch.pincode,
        'printsize': branch.printsize,
        'print_footer': branch.print_footer,
        'sender_id': branch.sender_id == null ? '' : branch.sender_id,
        'authKey': branch.authKey == null ? '' : branch.authKey,
        'wa_api': branch.wa_api == null ? '' : branch.wa_api,
        'wa_total_count': branch.wa_total_count == null ? '' : branch.wa_total_count,
        'wa_delivered_count': branch.wa_delivered_count == null ? '' : branch.wa_delivered_count,
        'wa_expiry_date': branch.wa_expiry_date == null ? '' : branch.wa_expiry_date,
        'wa_billsend': branch.wa_billsend == null ? '' : branch.wa_billsend,
        'upi_id': branch.upi_id == null ? '' : branch.upi_id,
        'upi_name': branch.upi_name == null ? '' : branch.upi_name,
        'user_id': branch.user_id == null ? '' : branch.user_id,
        'staffID': branch.staffID,
        'permissions': permissions.toString(),
        'barcode_enable': branch.barcode_enable,
      }]
      /*----------------------
      update branch data to branch table
    -----------------------*/
      api.update_branch_data.getID.update({ branch_id: $scope.params.id }, addBranch,
        function (response) {
          var filterstaff = staffRole.filter(function (data) {
            if (data.staffID == branch.staffID)
              return data
          })
          var updateuser = [{
            'name': $scope.admin.personname,
            'branch_id': $scope.params.id,
            'username': $scope.admin.username,
            'old_username': (filterstaff[0].username == $scope.admin.username) ? false : $scope.addbranch.username.$dirty,
            'password': $scope.admin.updatepassword ? $scope.admin.updatepassword : 'old_password',
            'mobile': branch.contact_number,
            'address': branch.address,
            'city': branch.city,
            'state': branch.state,
            'permission': permissions
          }];
          /*-----------------------------
          update branch data to staff table
          -----------------------*/
          api.updateuser.getID.update({ staffID: branch.staffID }, updateuser,
            function (response) {
              if (!response.data) {
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Branch Updated successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
                $state.go('app.addbranch', { id: '' })

              } else {
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>username already exists with this branch try another one!</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              }
            })
        })
    }

    $scope.submit = function () {
      var branch = $scope.branch;
      var admin = $scope.admin
      var permis = [$scope.salesbill, $scope.dealersbill, $scope.expensebill, $scope.inventory, $scope.salesmaterial, $scope.rawmaterial, $scope.odc, $scope.marketing, $scope.customer, $scope.sms, $scope.whatsapp, $scope.uploaddb, $scope.stewardapp]
      var fulldata = permis.filter(function (data) {
        if (data != '')
          return data
      })
      var permissions = JSON.parse("[" + fulldata.toString() + ',' + 0 + ',' + 12 + ',' + 22 + ',' + 23 + ',' + 42 + ',' + 43 + "]"); //covert as array format in came from db data
      var addBranch = [{
        'corporate_name': branch.corporate_name,
        'branch_name': branch.branch_name,
        'corporate_id': dietType.settings.corporate_id,
        'expiry_date': branch.expiry_date,
        'domain_category': branch.domain_category,
        'contact_number': branch.contact_number,
        'address': branch.address,
        'GstNo': branch.GstNo,
        'city': branch.city,
        'state': branch.state,
        'pincode': branch.pincode,
        'printsize': branch.printsize,
        'print_footer': branch.print_footer,
        'sender_id': branch.sender_id,
        'authKey': branch.authKey,
        'wa_api': branch.wa_api == null ? '' : branch.wa_api,
        'wa_total_count': branch.wa_total_count == null ? '' : branch.wa_total_count,
        'wa_delivered_count': branch.wa_delivered_count == null ? '' : branch.wa_delivered_count,
        'wa_expiry_date': branch.wa_expiry_date == null ? '' : branch.wa_expiry_date,
        'wa_billsend': branch.wa_billsend == null ? '' : branch.wa_billsend,
        'upi_id': branch.upi_id == null ? '' : branch.upi_id,
        'upi_name': branch.upi_name == null ? '' : branch.upi_name,
        'user_id': branch.user_id,
        'permissions': permissions.toString(),
        'barcode_enable': branch.barcode_enable,
      }];
      /*----------------------
      save branch data to branch table
    -----------------------*/
      api.addBranch.getAll.save(addBranch,
        // Success
        function (response) {

          var addAdmin = [{
            'name': admin.personname,
            'username': admin.username,
            'password': admin.password,
            'position': 'admin',
            'mobile': branch.contact_number,
            'address': branch.address,
            'city': branch.city,
            'state': branch.state,
            'permissions': permissions.toString(),
            'status': 'active',
            'branch_id': response.insertId

          }];
          var Insertedbranch_id = response.insertId //get insertedid(branch_id) for staff table
          /*-----------------------------
          add branch data to staff table with insertid
          -----------------------*/
          api.addAdmin.getAll.save(addAdmin,
            // Success
            function (response) {
              if (response.code == '204') {
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>Email already exists with this branch try another one!</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });

              } else {
                var InsertedStaffID = response[0].branch_id //get insertedid(staffID) for branch table
                //store insert id for send to service
                var addBranch = [{
                  'staffID': InsertedStaffID
                },
                { 'update': 1 }
                ]
                /*-----------------------------------------
               update staffID  to branch table with insertid
              ------------------------------------------*/
                api.update_branch_data.getID.update({ branch_id: Insertedbranch_id }, addBranch,
                  function (response) {
                    $mdToast.show({
                      template: '<md-toast class="success"><span flex>Corporate Added successfully</span></md-toast>',
                      position: 'bottom right',
                      hideDelay: 3000,
                      action: "close"
                    });
                    $state.go("app.addbranch", {}, { reload: "app.addbranch" })
                  })



              }

            })
        })
    }

    $rootScope.getBreadcrumbLabel = function () {
      if ($scope.params.id) {
        return 'Edit Branch'
      } else if (!$scope.params.id) {
        return "Add Branch"
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('settings-level', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.settingsLevel', {
        url: '/settings-level',
        views: {
           'content@app': {
            templateUrl: 'app/main/ssadmin/settings-level/settings-level.html',
            controller: 'settingsLevelController as vm'
          }
        },
        resolve  : {
                LEVELS: function (msApi)
                {
                    return msApi.resolve('levels@get');
                }
            }, 

        ncyBreadcrumb: {
          label: 'Levels'
        }
      });


        // Api
        msApiProvider.register('levels', ['app/data/settings/level/level.json']);


  }
})();

(function() {
  'use strict';

  angular
    .module('settings-level')
    .controller('settingsLevelController', settingsLevelController);

  /** @ngInject */
  function settingsLevelController($scope, LEVELS, $http, api, msNavigationService, $mdDialog, $mdToast) {
  var vm = this;

  
      
// DATA
    //----------------
    vm.levels = LEVELS.data;

	console.log(LEVELS.data)

    // Add dialog
    vm.showAddLevelDialog = function(ev) {
      $mdDialog.show({
        controller: DialogController,
        templateUrl: 'app/main/ssadmin/settings-level/settings-level.addlevel.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose      : false,
        focusOnOpen: false
      })
    }; 
	
	$scope.getLevels = function(){
		$scope.levelDetails = [];
		api.readLevels().then(function(dataArr) {
			console.log(dataArr)
			var det = [];
			angular.forEach(dataArr, function(obj, key) {
				console.log(obj)
				var data = {
				  "levelIdentifier" : obj.level_id,
				  "name": obj.level_type,
				  "assignedAppModules": [],
				  "branchescount" : obj.branch_count   
				};
				
				api.readModulesById(obj.module_id).then(function(modulesData) {
					console.log(modulesData)
					var modArr = [];
					angular.forEach(modulesData, function(objMod, keyMod) {
						var modData = {appModuleName: objMod.module_name_alias}
						console.log(modData)
						
						modArr.push(modData)
					});
					data.assignedAppModules = modArr;
					det.push(data);
					$scope.levelDetails=det;
				});
				//det.push(data);
			})
			
			//$scope.levelDetails=det;
		});
	
	
		
		/**/
	}
	
	$scope.getLevels();
	
   function DialogController($scope, $mdDialog) {
      $scope.closeDialog = function() {
        $mdDialog.hide();
      }}

  // Delete alert
	vm.showAlert = function(ev) 
	{
		var confirm = $mdDialog.confirm({
			title              : 'Delete',
			textContent        : 'Are you sure you want to delete this level?',
			ariaLabel          : 'delete table no',
			targetEvent        : ev,
			clickOutsideToClose: false,
			escapeToClose      : true,
			ok                 : 'Remove',
			cancel             : 'Cancel'
		});

		   $mdDialog.show(confirm).then(function ()
		{
			
		}, function ()
		{
			// Canceled
		});

	}
	
	
	


    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('editcompany', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.editcompany', {
        url: '/editcompany',
        views: {
          'content@app': {
            templateUrl: 'app/main/ssadmin/editcompany/editcompany.html',
            controller: 'editCompanyController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Edit Company'
        },

      });


  }
})();

(function () {
  'use strict';
  angular
  .module('editcompany')
  .controller('editCompanyController', editCompanyController);

  /** @ngInject */

  function editCompanyController(msNavigationService, $scope, $location, fileReader, $mdToast, $mdDialog, $http, api) {
    var vm = this;
	
	$scope.displayDetails = function(){
		var company_identifier = $location.search().cid;
		//var company_identifier = 2;
		$scope.useraccountpassword = "";
		api.readCompanyById(company_identifier).then(function(dataArr) {
		
			var companyDet = dataArr[0];
			$scope.companyname = companyDet.company_name;
			$scope.companyaddress =  companyDet.address;
			$scope.companycity =  companyDet.city;
			$scope.companystate =  companyDet.state;
			$scope.companypincode =  companyDet.pincode;
			$scope.companyemail =  companyDet.email_id;
			$scope.companymobile1 = companyDet.contact_number;
			$scope.companyalternateNumber = companyDet.alternate_contact_number;
			$scope.companylevel = companyDet.level;
			$scope.companydomain = companyDet.domain_name;
			if(companyDet.branch_count == 0){
				$scope.companybranchescount = "unlimited"
				$scope.companycount = 0;
			}else{
				$scope.companybranchescount = "limited"
				$scope.companycount = companyDet.branch_count;
			}
			
			api.getUserByCompanyId(company_identifier).then(function(userDetails) {
				$scope.userpersonname = userDetails[0].personal_name;
				$scope.useraccountemail = userDetails[0].email_id;
			});
			
			var custom_level = companyDet.app_mod_id;
			if(custom_level){
				/*
				api.readModulesByLevel(dataArr[0].level).then(function(modId_Arr) {
					api.readModulesById(modId_Arr[0].module_id).then(function(modulesData) {
						console.log(modulesData)
					});
				});*/
				$scope.companycustomLevels = true
				api.readModulesById(companyDet.app_mod_id).then(function(modulesData) {
					angular.forEach(modulesData, function(obj, key) {
						$scope[obj.module_name] = true;
						console.log($scope[obj.module_name])
					})
				});
			}
			
		});
	}
	
	$scope.displayDetails();
	
	
	$scope.submitCompanyDet = function () {
		var company_identifier = $location.search().cid;
		//var company_identifier = 2;
		var moduleList = [];

      $scope.sales ? moduleList.push(1) : "";
      $scope.expense ? moduleList.push(2) : "";
      $scope.manager ? moduleList.push(3) : "";

      var moduleList = moduleList.join();

      var companyInfoList = {
        type: "company_details",
		whereclause : "company_id",
		company_id : company_identifier,
        company_name: $scope.companyname,
        address: $scope.companyaddress,
        city: $scope.companycity,
        state: $scope.companystate,
        pincode: $scope.companypincode,
        email_id: $scope.companyemail,
        contact_number: $scope.companymobile1,
        alternate_contact_number: $scope.companyalternateNumber ? $scope.companyalternateNumber : "",
		level: $scope.companylevel,
        custom_level: $scope.companycustomLevels ? 1 : 0,
        branch_count: $scope.companybranchesCount == "Unlimited" ? 0 : ($scope.companycount ? $scope.companycount : 1),
        domain_name: $scope.companydomain,
        app_mod_id: moduleList
      }

      var userList = {
        type: "company_credentials",
		whereclause : "company_id",
		company_id : company_identifier,
        email_id: $scope.useraccountemail,
        personal_name: $scope.userpersonname,
		level: $scope.companylevel
      }
	  
	  if($scope.useraccountpassword){		  
        userList.password = $scope.useraccountpassword
	  }

      api.update(companyInfoList).then(function () {
        userList.company_id = company_identifier
          api.update(userList).then(function (userResponse) {
			$mdToast.show({
			  template: '<md-toast><span flex>Details Updated successfully</span></md-toast>',
			  position: 'top right',
			  hideDelay: 3000,
			  action : "close"
			})
			
			$location.path("/list-of-company")
			//success statements
          });
      });

    };
	
    
  }
})();
(function() {
  'use strict';

  angular
    .module('listcompany', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.listcompany', {
        url: '/list-of-company',
        views: {
          'content@app': {
            templateUrl: 'app/main/ssadmin/listcompany/listcompany.html',
            controller: 'ListCompanyController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'List of Company'
        },

      });


  }
})();

(function() {
  'use strict';

  angular
    .module('listcompany')
    .controller('ListCompanyController', ListCompanyController);

  /** @ngInject */
  function ListCompanyController($scope, $timeout, $mdDialog, $http, api) {
	var vm = this;
	
	$scope.status = "test";
	
    /*var compListAPI = api.getCompanyList.get({
		headers:'Access-Control-Allow-Origin'
                
		
	},function(response){
		console.log(response)
	}, function(err){
		console.log(err)
	});*/
	$scope.companyInfoList = [];
	api.readCompanies().then(function(dataArr) {
		var det = [];
		angular.forEach(dataArr, function(obj, key) {
			console.log(obj)
			var data = {
			  "companyIdentifier" : obj.company_id,
			  "companyName": obj.company_name,
			  "companyemailid" : obj.email_id,
			  "companyLogo": "/assets/images/logos/bhats-logo.gif",
			  "companyLevel" : obj.level,
			  "companyBranches" : obj.branch_count ? obj.branch_count : "Unlimited",
			  "companyStatus" : "Active"     
			};
			det.push(data);
		})
		$scope.companyInfoList=det;
	});
   /*$scope.companyInfoList = [{
      "companyName": "Henkala",
      "companyemailid" : "info@henkala.com",
      "companyLogo": "/assets/images/logos/bhats-logo.gif",
      "companyLevel" : "Low/ Custom",
      "companyBranches" : 8,
      "companyStatus" : "Active"     
    },{
      "companyName": "Bhats",
      "companyemailid" : "info@bhats.com",
      "companyLogo": "assets/images/login/logo.png",
      "companyLevel" : "Medium",
      "companyBranches" : 8,
      "companyStatus" : "Active"
    }
   ];*/

	console.log($scope.companyInfoList)

    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('createcompany', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.createcompany', {
        url: '/addcompany',
        views: {
          'content@app': {
            templateUrl: 'app/main/ssadmin/createcompany/createcompany.html',
            controller: 'createCompanyController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Add Company'
        },
        
      });


  }
})();

(function () {
  'use strict';
  //console.log("Add Company");
  angular
  .module('createcompany')
  .controller('createCompanyController', createCompanyController);

  /** @ngInject */

  function createCompanyController(msNavigationService, $scope,  $location, fileReader, $mdToast, $mdDialog, $http, api) {
    var vm = this;
    // Data
	//console.log($route)
    vm.dashboardText = 'Welcome to dashboard';
	console.log($scope.company)
    $scope.imageSrc = "";
			
	$scope.showActionToast = function(content) {
		var pinTo = "top left";
		var toast = $mdToast.simple()
		.textContent(content)
		.action('Close')
		.highlightAction(true)
		.highlightClass('md-accent')// Accent is used by default, this just demonstrates the usage.
		.position(pinTo);
		$mdToast.show(toast).then(function(response) {
			if ( response == 'ok' ) {
				$mdToast.hide()
				//alert('You clicked the \'UNDO\' action.');
			}
		});
	};
	
    $scope.submitCompanyDet = function () {

      var moduleList = [];

      $scope.vm.sales ? moduleList.push(1) : "";
      $scope.vm.expense ? moduleList.push(2) : "";
      $scope.vm.manager ? moduleList.push(3) : "";

      var moduleList = moduleList.join();

      var companyInfoList = {
        type: "company_details",
        company_name: $scope.company.name,
        address: $scope.company.address,
        city: $scope.company.city,
        state: $scope.company.state,
        pincode: $scope.company.pincode,
        email_id: $scope.company.email,
        contact_number: $scope.company.mobile1,
        alternate_contact_number: $scope.company.alternateNumber ? $scope.company.alternateNumber : "",
        custom_level: $scope.company.customLevels ? 1 : 0,
        branch_count: $scope.company.branchesCount == "Unlimited" ? 0 : ($scope.company.count ? $scope.company.count : 1),
        domain_name: $scope.company.domain,
        app_mod_id: moduleList,
		level: $scope.company.level
      }

      var userList = {
        type: "company_credentials",
        email_id: $scope.user.accountemail,
        password: $scope.user.accountpassword,
        personal_name: $scope.user.personname,
		level: $scope.company.level
      }

      api.write(companyInfoList).then(function (compResponse) {
        userList.company_id = compResponse.insertId
          api.write(userList).then(function (userResponse) {
			$mdToast.show({
			  template: '<md-toast><span flex>Details Added successfully</span></md-toast>',
			  position: 'top right',
			  hideDelay: 3000,
			  action : "close"
			})
			$location.path("/list-of-company")
			//success statements
          });
      });

    };

    $scope.$on("fileProgress", function (e, progress) {
      $scope.progress = progress.loaded / progress.total;
    });
  }
})();
(function() {
  'use strict';

  angular
    .module('app.permission-denied', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.permission-denied', {
        url: '/permission-denied',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/permission-denied/permission-denied.html',
            controller: 'PermissionDeniedController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Permission Denied'
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.permission-denied')
    .controller('PermissionDeniedController', PermissionDeniedController);

  /** @ngInject */
  function PermissionDeniedController(msNavigationService) {
    var vm = this;

    // Data
    vm.dashboardText = 'Welcome to dashboard';

    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.profile', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.profile', {
        url: '/profile',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/profile/profile.html',
            controller: 'ProfileController as vm'
          }
        },

        resolve: {
          userRole: function(apiResolver) {
            return apiResolver.resolve('userRole.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: 'Profile'
        }
      })

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/cashier/profile');

  }
})();

(function() {
  'use strict';

  angular
    .module('app.profile')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($scope, api, $cookies, $rootScope, userRole, $state) {
    var vm = this;
    $rootScope.user = $cookies.getObject('user');
    // Data
    vm.dashboardText = 'Welcome to dashboard';
    // Methods
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.profile = response[0];
        vm.user = $scope.profile
        $scope.cancel = function() {
          $state.go("app.profile", {}, { reload: "app.profile" })
        }
        // GET role NAME
        for (var i = 0; i < userRole.length; i++) {
          if (userRole[i].roleID == response[0].roleID) {
            $scope.role_name = userRole[i].role_name

          }
        }
      })

    $scope.submit = function() {
      var user = vm.user;
      var updateuser = [{
        'name': user.name,
        'mobile': user.mobile,
        'email': user.email,
        'password': $scope.password ? $scope.password : 'old_password'
      }]
      api.update_profile.getID.update({ staffID: vm.user.staffID }, updateuser,
        function(response) {
          $state.go("app.profile", {}, { reload: "app.profile" })

        })

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.onlinestorage', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.onlinestorage', {
        url: '/onlinestoragedb',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/online-storage-db/online-storage-db.html',
            controller: 'OnlineStorageController as vm'
          }
        },

        resolve: {
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: 'Sync Data'
        }
      })

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/cashier/profile');

  }
})();

(function() {
  'use strict';

  angular
    .module('app.onlinestorage')
    .controller('OnlineStorageController', OnlineStorageController);

  /** @ngInject */
  function OnlineStorageController($scope, api, $cookies, $rootScope, $mdToast, $timeout, $state, dietType, branch_data) {
    var vm = this;
    $rootScope.user = $cookies.getObject('user');
    //assign interconnection true or false
    $scope.internetconnection = $rootScope.online;
    // Data
    vm.settings = dietType.settings;
    vm.onlineTypes = dietType.onlineTypes;
    vm.dbbackupPath = dietType.dbbackupPath;
    vm.dbstorage = dietType.dbstorage;

    //filter coporate details for branch wise
    var filterbranch = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    $scope.branchdata = filterbranch[0]; //assign currently logged in branch data
   // console.log($scope.branchdata.permissions);
    //console.log($rootScope.user[0]);
    // Checking permissions
    $scope.uploaddb = [];
    var permissions = JSON.parse("[" + $scope.branchdata.permissions + "]"); //covert as array format which is taken by cookies
    for (var i = 0; i < permissions.length; i++) {
      if (permissions[i] == 6) {
        $scope.uploaddb.push("data");
      }
    };
    if ($scope.uploaddb.length > 0) {
      $scope.uploaddb = true // if true means permission will be applied
    };

    $scope.branch_data = branch_data[0];
    $scope.branch_id = $rootScope.user[0].branch_id;
    $scope.uploadDBTime = branch_data[0].uploadDBTime;
    /*==========================================================================
                                      Download db
               ========================================================================== */
    if (vm.settings.databasebackup) {
      downloaded();

      function downloaded() {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var hours = dateObj.getHours();
        var Min = dateObj.getMinutes();
        var sec = dateObj.getSeconds();
        var millsec = dateObj.getMilliseconds();

        var newdate = month + "-" + day + "-" + year + "-" + hours + "-" + Min + "-" + sec + "-" + millsec;
        //  var date = new Date().toJSON();      
        var downloadPath = vm.dbbackupPath.downloadpath;
        var mysqlDumpPath = vm.dbbackupPath.mysqlDumpPath;
        var data = {
          Date: newdate,
          mysqlDumpPath: mysqlDumpPath,
          downloadPath: downloadPath
        }
        api.dbdownload.getAll.save(data,
          // Success
          function(response) {

          });
      };
    }
    //get interconnection using watch function from toolbar controller
    $scope.$on("internetChecking", function(event, internetconnection) {
      if (internetconnection === false) {
        $mdToast.show({
          template: '<md-toast class="error"><span flex>You are in offline</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
      }
    });


$scope.syncbutton = true;

    /*==========================================================================
                                      Store db in gdrive
     ========================================================================== */
    //console.log(vm.dbstorage.folderID);
    //get logged in staff  data from db 
    if($scope.uploaddb.length != 0) {
    syncingfunction();
    }

    function syncingfunction() {
      $scope.load = true;
      $timeout(function() {
        api.gdrive.getID.get({ folderID: vm.dbstorage.folderID, uploadPath: vm.dbstorage.uploadpath },
          function(response) {

            // last upload time update in branch table
            var dateq = moment(new Date()).format('MMM DD, YYYY, h:mm:ss a');
            var addBranch = [{
              'uploadDBTime': dateq
            }];

            api.update_branch_data.getID.update({ branch_id: $scope.branch_id }, addBranch,
              function(response) {
                $scope.load = false;
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Synced Data Successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              });
            $scope.uploadDBTime = dateq;
            $scope.syncbutton = false;
            $scope.successUpload = true;
          },
          // Error
          function(response) {
            $scope.load = false;
            $scope.errorUpload = true;
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Sync Data Error. Please check your internet connection</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        );
      }, 5000);
    }
    if($scope.uploaddb.length != 0) {
    $scope.sync = function() {
      syncingfunction();
    };
  }
    // end



  }
})();

(function() {
  'use strict';

  angular
    .module('app.dashboard', ['nvd3'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.dashboard', {
        url: '/dashboard',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/dashboard/dashboard.html',
            controller: 'DashboardController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Dashboard'
        },
        resolve: {
          DashboardData: function(msApi) {
            return msApi.resolve('dashboard.project@get');
          },
          DashboardData1: function(msApi) {
            return msApi.resolve('dashboard.analytics@get');
          },
          fmCategory: function(apiResolver) {
            return apiResolver.resolve('fmCategory.getAll@get');
          },
          inventoryfood: function(apiResolver) {
            return apiResolver.resolve('inventoryfood.getAll@get');
          },
            sales_order_data: function(apiResolver) {
            return apiResolver.resolve('sales_order_data.getAll@get');
          },
           expense_bill_data: function(apiResolver) {
            return apiResolver.resolve('expense_bill_data.getAll@get');
          },
          rawmaterial_bill_data: function(apiResolver) {
            return apiResolver.resolve('rawmaterial_bill_data.getAll@get');
          },
          salematerial_bill_data: function(apiResolver) {
            return apiResolver.resolve('salematerial_bill_data.getAll@get');
          },
            fmitem_sale: function(apiResolver) {
            return apiResolver.resolve('fmitem_sale.getAll@get');
          },
           dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          campaignn: function (apiResolver) {
            return apiResolver.resolve('campaignn.getAll@get');
          },
          branch_data: function (apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
           odc_category: function(apiResolver) {
            return apiResolver.resolve('odc_category@get');
          },
          rmcategorydata: function(apiResolver) {
            return apiResolver.resolve('rmcategorydata.getAll@get');
          },
            siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },
        },
        bodyClass: 'dashboard-project'
      });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/cashier/dashboard');
    // Api
    msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    // Api
    msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);

  }
})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('DashboardController', DashboardController)
    .filter('thousandSuffix', function($filter) {
      return function(input, decimals, $scope) {
        var exp, rounded,
          suffixes = ['Lac', 'M', 'G', 'T', 'P', 'E'];

        if (window.isNaN(input)) {
          return null;
        }

        if (input < 100000) {
          return $filter('number')(input);
        }

        exp = Math.floor(Math.log(input) / Math.log(100000));

        return (input / Math.pow(100000, exp)).toFixed(decimals) + suffixes[exp - 1];
      };
    });

  /** @ngInject */
  function DashboardController($scope, $state, $filter, fmitem_sale, campaignn, branch_data, expense_bill_data, rawmaterial_bill_data, salematerial_bill_data, inventoryfood, sales_order_data, odc_category, siCategory, fmCategory, DashboardData, rmcategorydata, $timeout, api, $stateParams, $cookies, msNavigationService, $rootScope, dietType, $mdToast) {
    var vm = this;

    vm.dashboardData = DashboardData; //this api data came from local folder
    $scope.inventoryHide = [];
    $scope.rawHide = [];
    $scope.saleHide = [];
    $scope.adminpermission = [];
    $scope.uploaddb = [];
    $scope.todayDate = new Date();
    $scope.stewardappHide = true;
    $scope.stewardappShow = false;
    $scope.mdtableselected = []; // dummy assign
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format which is taken by cookies
    console.log(permissions);
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 3) || permissions[i] == 3) {
        $scope.inventoryHide.push("data");
      }
      if (permissions[i] == 0) {
        $scope.adminpermission.push('admin')
      }
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 31) || permissions[i] == 31) {
        $scope.rawHide.push("data");
      }
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 32) || permissions[i] == 32) {
        $scope.saleHide.push("data");
      }
       if (permissions[i] == 6) {
        $scope.uploaddb.push("data");
      } 
    }
    //tab change to hide other tabs in inventory
    if ($scope.inventoryHide.length && $scope.rawHide.length) {
      $scope.currentNavItem = 'rawmaterial';
    }
    if ($scope.inventoryHide.length && $scope.saleHide.length) {
      $scope.currentNavItem = 'salematerial';
    }
    if ($scope.inventoryHide.length && $scope.saleHide.length && $scope.rawHide.length) {
      $scope.currentNavItem = 'rawmaterial';
    }
    if($cookies.get('steward') == 'steward') {
      $scope.stewardappHide = false;
      $scope.stewardappShow = true;
    }
    console.log($scope.stewardappp)
    $scope.getdate = function(d) {
      return new Date(d)
    }
    $scope.doordelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.odcdelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.expensedelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.rawdelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.saledelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.thirdparty_query = {
      filter: '',
      limit: '10',
      order: 'count',
      page: 1
    }
    // ODC category
    vm.odc_categorys = odc_category.odcbill.odc_categories;
    $scope.getOdcCategory = function(tag) {
      for (var i = 0; i < vm.odc_categorys.length; i++) {
        if (vm.odc_categorys[i].value == tag.odc_categoryID)
          return vm.odc_categorys[i].label
      }
    }
    //api call from domain category folder such which json will apply all the modules like bakery,garments

    vm.settings = dietType.settings;
    vm.onlineTypes = dietType.onlineTypes;
    vm.dbbackupPath = dietType.dbbackupPath;
    vm.dbstorage = dietType.dbstorage;


    //get logged in staff  data from db 
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })

    // Data
    vm.dashboardText = 'Welcome to dashboard';
    $rootScope.user = $cookies.getObject('user'); // get data from cookies
    $cookies.remove('admin');

    $filter('number')($scope.number, $scope.fractionSize) //filter the number as fraction format like 55,342

    //Front end data to apply md pickers
    $scope.myDate = new Date(); // assign today data to md picker
    //retrict date only 30 days move on backward from md pciker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() - 30
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    /* ==============================================================
    Print Daily Data 
    ==============================================================*/

    $scope.ReportTime = new Date();
    $scope.printToCart = function(printSectionId) {
        var innerContents = document.getElementById(printSectionId).innerHTML;
        var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><body onload="window.print()">' + innerContents + '</body></html>');
        popupWinindow.document.close();
      }


    /*==========================================================================
                               export pdf and send email
        ========================================================================== */
    $scope.exportemail = function() {
      api.purchaseexpense_analytics.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.purchasetaxx = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.purchasetaxCgstt = response[0].taxCgst_info;
          $scope.purchasetaxSgstt = response[0].taxSgst_info;
          $scope.purchasetotal_paidd = response[0].total_paid + response[0].advance_paid;
          $scope.purchasetotal_balancee = response[0].total_balance;
          $scope.purchasepaid_cashh = response[0].paid_cash + response[0].advancepaid_cash;
          $scope.purchasepaid_cardd = response[0].paid_card + response[0].advancepaid_card;
          $scope.purchasepaid_chequee = response[0].paid_cheque + response[0].advancepaid_cheque;
          $scope.purchasepaid_onlinee = response[0].paid_online + response[0].advancepaid_online;
          api.dashboard_analytics_date.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id, month: 'month', year:'month' },
            function(response) {
              $scope.items_Data = response[0].posbill_fulldata;
              $scope.total_cashh = response[0].total_cash;
              $scope.total_cardd = response[0].total_card;
              $scope.orderedtotal_cashh = response[0].orderedtotal_cash;
              $scope.orderedtotal_cardd = response[0].orderedtotal_card;
              $scope.dinein_amountt = response[0].dinein_amount;
              $scope.takeaway_amountt = response[0].takeaway_amount;
              $scope.doordelivery_amountt = response[0].doordelivery_amount;
              $scope.dinein_totall = response[0].dinein_total;
              $scope.takeaway_totall = response[0].takeaway_total;
              $scope.doordelivery_totall = response[0].doordelivery_total;
              $scope.overviewtax_cgstt = response[0].tax_cgst;
              $scope.overviewtax_sgstt = response[0].tax_sgst;
              $scope.tax_cgstt = response[0].tax_cgst;
              $scope.tax_sgstt = response[0].tax_sgst;
              $scope.overview_posOrder_countt = response[0].total_posOrder;
              $scope.overview_posPaid_countt = response[0].dinein_total + response[0].takeaway_total + response[0].doordelivery_total;
              $scope.overview_posTotall = response[0].total_cash + response[0].total_card + response[0].orderedtotal_cash + response[0].orderedtotal_card;
              api.expense_analytics.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
                function(response) {
                  $scope.expensetaxx = response[0].taxCgst_info + response[0].taxSgst_info;
                  $scope.expensetaxCgstt = response[0].taxCgst_info;
                  $scope.expensetaxSgstt = response[0].taxSgst_info;
                  $scope.total_paidd = response[0].total_paid + response[0].advance_paid;
                  $scope.total_balancee = response[0].total_balance;
                  $scope.generalpaid_cashh = response[0].paid_cash + response[0].advancepaid_cash;
                  $scope.generalpaid_cardd = response[0].paid_card + response[0].advancepaid_card;
                  $scope.generalpaid_chequee = response[0].paid_cheque + response[0].advancepaid_cheque;
                  $scope.generalpaid_onlinee = response[0].paid_online + response[0].advancepaid_online;
                  $scope.overview_expenseTotall = response[0].total_paid + response[0].advance_paid + response[0].total_balance;
                  api.odc_analytics_data.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
                    function(response) {
                      $scope.overviewodc_paymentt = response[0];
                      $scope.odc_paymentt = response[0];
                      $scope.Odctax_cgst = response[0].tax_cgst;
                      $scope.Odctax_sgst = response[0].tax_sgst;
                      $scope.overvie_wodcTax_cgstt = response[0].tax_cgst;
                      $scope.overviewodc_wodcTax_sgstt = response[0].tax_sgst;
                      api.salesexpense_analytics.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
                        function(response) {
                          $scope.salestaxx = response[0].taxCgst_info + response[0].taxSgst_info;
                          $scope.salestaxCgstt = response[0].taxCgst_info;
                          $scope.salestaxSgstt = response[0].taxSgst_info;
                          $scope.saletotal_paidd = response[0].total_paid + response[0].advance_paid;
                          $scope.saletotal_balancee = response[0].total_balance;
                          $scope.salespaid_cashh = response[0].paid_cash + response[0].advancepaid_cash;
                          $scope.salespaid_cardd = response[0].paid_card + response[0].advancepaid_card;
                          $scope.salespaid_chequee = response[0].paid_cheque + response[0].advancepaid_cheque;
                          $scope.salespaid_onlinee = response[0].paid_online + response[0].advancepaid_online;

                        })
                    })
                })
            })

        })
    }
    $scope.exportemail();
    var doc = new jsPDF('p', 'pt', 'letter');
    var specialElementHandlers = {
      '#editor': function(element, renderer) {
        return true;
      }
    };
    var branchfilter = branch_data.filter(function(data) {
      if (data.branch_id == $rootScope.user[0].branch_id)
        return data
    })
    $scope.branch_name = branchfilter[0].branch_name;

    $scope.pdf = function(d) {
      $scope.ReportTime = new Date();
      $timeout(function() {
        doc.fromHTML($('#content3').html(), 40, 40, {
          'width': 800,
          'elementHandlers': specialElementHandlers
        });
        doc.save("" + moment(new Date()).format('MMM DD,YYYY') + "-Daily Report-" + $scope.branch_name + ".pdf");
        $state.go("app.dashboard", {}, { reload: "app.dashboard" })
      }, 100)
    };
    /*==========================================================================
                                      Store db in gdrive
     ========================================================================== */
     //assign interconnection true or false
    $scope.internetconnection = $rootScope.online; // if online
    $scope.uploadDBTime = branch_data[0].uploadDBTime; // last uploaded time
    var differenceTime = moment(new Date()).diff($scope.uploadDBTime, 'minutes'); // current time and last upload time difference in minutes
    $scope.branch_id = $rootScope.user[0].branch_id;
    // condition 1. permission 2. interval time 3. internet connection
    if($scope.uploaddb == "data" & (differenceTime > vm.dbstorage.intervalTime) & $scope.internetconnection) { 
      console.log('entered')
        api.gdrive.getID.get({ folderID: vm.dbstorage.folderID, uploadPath: vm.dbstorage.uploadpath },
          function(response) {
            // last upload time update in branch table
            var dateq = moment(new Date()).format('MMM DD, YYYY, h:mm:ss a');
            var addBranch = [{
              'uploadDBTime': dateq
            }];

            api.update_branch_data.getID.update({ branch_id: $scope.branch_id }, addBranch,
              function(response) {
                console.log(response);
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Synced Data Successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              });
         
          },
          // Error
          function(response) {
            //$scope.load = false;
           // $scope.errorUpload = true;
            $mdToast.show({
              template: '<md-toast class="info"><span flex>Please check your internet connection to sync the data.</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        );
      }

    /*==========================================================================
                           POS analytics
    ========================================================================== */
    var cashier_data = []
    //permission for cashier in view of analytics
    var salesbillss = []
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 1) || permissions[i] == 1) {
        salesbillss.push("data");
      }
      if (permissions[i] == 1) {
        cashier_data.push("datas");
      }
    }

    $scope.salesbillLength = cashier_data.length; //check permission

    if (salesbillss.length > 0) {
      $scope.cashier_analytics_permission = true // if true means permission will be applied
    }



    $scope.changeDate = changeDate;
    //function for change date for show data depending on date
    function changeDate(myDate) {
      $scope.load = true
      cashier_analytics(myDate) // callback funtion

      $timeout(function() {
        $scope.load = false //auto reload to access the db in each 0.5 seconds
      }, 500);

    }


    //service for today's  date of cashier anaytic data from server
    function cashier_analytics(myDate) {

      if (myDate == undefined) {
        // Init today date
        var dbstring = new Date();
        var dd = dbstring.getDate();
        var mm = dbstring.getMonth() + 1;
        var yyyy = dbstring.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        dbstring = yyyy + '-' + mm + '-' + dd;
      } else {
        // if change the date
        var dbstring = new Date(myDate);
        var dd = dbstring.getDate();
        var mm = dbstring.getMonth() + 1;
        var yyyy = dbstring.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        dbstring = yyyy + '-' + mm + '-' + dd; //covert data format for get data from db 

      }
      api.dashboard_analytics_date.getID.get({ date: dbstring, toDate:'month', staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id, month: 'month', year: 'month' },
        function(response) {
          console.log(response)
          //response for collect analytics data from the server -this is for when user land on this page then will be today data of analytics showed.
          //get finished events
          /*-----------------------------------
          Today task filterning for pos bills
          ------------------------------------------*/
          $scope.pos_today_delivery = [];
          sales_order_data.filter(function(a) {
            if (new Date(a.sales_deliveryDate).toDateString() == new Date().toDateString() && a.staffID == $rootScope.user[0].staffID && a.branch_id == $rootScope.user[0].branch_id && a.sales_dietType != 'ODC' && a.sales_dietType != 'dinein' && a.sales_deliveryStatus != 'Immediate') {
              $scope.pos_today_delivery.push(a)
            }
            return
          });
          $scope.total_cash = response[0].total_cash;
          $scope.total_card = response[0].total_card;
          $scope.orderedtotal_cash = response[0].orderedtotal_cash;
          $scope.orderedtotal_card = response[0].orderedtotal_card;
          $scope.dinein_amount = response[0].dinein_amount;
          $scope.takeaway_amount = response[0].takeaway_amount;
          $scope.doordelivery_amount = response[0].doordelivery_amount;
          $scope.dinein_total = response[0].dinein_total;
          $scope.takeaway_total = response[0].takeaway_total;
          $scope.doordelivery_total = response[0].doordelivery_total;
          $scope.onlinePaymentTypeAmount = response[0].onlinePaymentTypeAmount;
          $scope.tax_cgst = response[0].tax_cgst;
          $scope.tax_sgst = response[0].tax_sgst;
          var total = response[0].dinein_total + response[0].takeaway_total + response[0].doordelivery_total;
          $scope.dinein_percent = (response[0].dinein_total / total) * 100;
          $scope.takeaway_percent = (response[0].takeaway_total / total) * 100;
          $scope.doordelivery_percent = (response[0].doordelivery_total / total) * 100
          $scope.overview_posOrder_countt = response[0].total_posOrder;
          //pagination query for today hot sales
          $scope.posbill_query = {
            filter: '',
            limit: '10',
            order: 'count',
            page: 1
          };

          //get sales items and filter no sales items to merge data and show it in today hot sales
          var filter_postdata = fmitem_sale.filter(function(fullItemsData) {
            return !response[0].posbill_fulldata.some(function(saleItemsData) {
              return (fullItemsData.fmItemID == saleItemsData.fmItemID)
            })
          })
          // assign no sales items 0 value
          var filter_postdatas = filter_postdata.map(function(o) {
            return { sales_items: o.fmItemName, count: 0, fmItemID: o.fmItemID, fmCatergoryID: o.fmCatergoryID, total: 0 }
          })

          $scope.posbill_data = filter_postdatas.concat(response[0].posbill_fulldata); //appy data to front end
          $scope.posbill_count = $scope.posbill_data.length; //md data table pagination length
          $scope.thirdparty = response[0].thirdparty_fulldata; //appy data to front end
          $scope.thirdparty_length = $scope.thirdparty.length;
          //pie chart analtic data which shows in tw
          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget6": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": $scope.total_cash + $scope.orderedtotal_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": $scope.total_card + $scope.orderedtotal_card //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget6 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            //ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget6.currentRange = range;
              angular.forEach(analytic_data.widget6.mainChart, function(data, index) {
                vm.widget6.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };
              });
            },
            init: function() {
              vm.widget6.changeRange('TW');
            }
          };

          // Initialize Widget 6
          vm.widget6.init();

          //pie chart analtic data which shows in tw
          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget67": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Total Orders",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": $scope.dinein_total + $scope.takeaway_total + $scope.doordelivery_total //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Pending Orders",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": $scope.overview_posOrder_countt //here response card_percent of data applied 
                  },
                  
                },
                {
                  "label": "Finished Orders",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": ($scope.dinein_total + $scope.takeaway_total + $scope.doordelivery_total) - $scope.overview_posOrder_countt //here response card_percent of data applied 
                  },
                  
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget67 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: [ '#ffb000', '#f44336', '#23bf72'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            //ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget67.currentRange = range;
              angular.forEach(analytic_data.widget67.mainChart, function(data, index) {
                vm.widget67.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };
              });
            },
            init: function() {
              vm.widget67.changeRange('TW');
            }
          };

          // Initialize Widget 6
          vm.widget67.init();

        })
    }
    cashier_analytics();


    /*==========================================================================
                           ODC analytics
    ========================================================================== */
    var oda_data = [];
    //permission for cashier in view of analytics
    var odcbills = [];

    //check permission
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 4) || permissions[i] == 4) {
        odcbills.push("data");
      }
      if (permissions[i] == 4) {
        oda_data.push("datas");
      }
    }

    $scope.odcLength = oda_data.length;

    if (odcbills.length > 0) {
      $scope.odc_analytics_permission = true // if true means permission will be applied
    }

    $scope.changeOdc = changeOdc; //method to access functions
    //function for change date for show data depending on date
    function changeOdc(myDate) {
      $scope.load = true
      odc_analytics(myDate) // callback funtion
      $timeout(function() {
        $scope.load = false
      }, 500);

    }


    //service for today's  date of cashier anaytic data from server
    function odc_analytics(myDate) {
      if (myDate == undefined) {
        // Init last month value
        var dbstring = 'LM';
      } else {
        // if changed
        var dbstring = myDate;
      }

      //api call to db which depending on dropdown filter
      api.odc_analytics_data.getID.get({ date: dbstring, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          //below datas are odc analytic datas which came from db
          $scope.odc_payment = response[0];
          $scope.Odctax_cgst = response[0].tax_cgst;
          $scope.Odctax_sgst = response[0].tax_sgst;
          var food_ids = [];
          //to filter data which remove duplicates in catergory id
          response[0].selectedNames.map(function(item) {
            if (food_ids.indexOf(item.odc_categoryID) === -1) {
              food_ids.push(item.odc_categoryID)

            }
          })
          var customer_details = response[0].selectedNames
          // Get category and prepare value to apply in donut chart
          //self loop apply in tag map
          var tagMap = response[0].selectedNames.reduce(function(map, tag) {
            var category_name = [];
            for (var i = 0; i < vm.odc_categorys.length; i++) {
              if (vm.odc_categorys[i].value == tag.odc_categoryID)
                category_name.push(vm.odc_categorys[i].label)
            }
            map[tag.odc_categoryID] = { 'label': category_name[0], "values": { "TW": tag.values.TW }, "odc_categoryID": tag.odc_categoryID }
            return map // return callback
          }, {});

          // Quickly select names from the map:
          var selectedCategories = food_ids.map(function(id) {
            return tagMap[id] //pass id to another function
          });

          var odc_piechart_Data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget6": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": selectedCategories
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget66 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            //ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget66.currentRange = range;

              angular.forEach(odc_piechart_Data.widget6.mainChart, function(data, index) {
                vm.widget66.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };
              });
            },
            init: function() {
              vm.widget66.changeRange('TW');
            }
          };

          // Initialize Widget 6
          vm.widget66.init();



        })

    }
    odc_analytics(); //call function for access inside the function


    /*==========================================================================
                          Expense analytics
    ========================================================================== */

    //permission for cashier in view of analytics
    var expense_billdata = [];
    var expensebillss = [];
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 2) || permissions[i] == 2) {
        expensebillss.push("data");
      }
      if (permissions[i] == 2) {
        expense_billdata.push("data");
      }
    }
    $scope.expenseLength = expense_billdata.length;
    if (expensebillss.length > 0) {
      $scope.expense_analytics_permission = true; // if true means permission will be applied
    }


    //expense expense_schedule data
    $scope.expense_schedule = [{
      "name": 'Last Week',
      "value": 'LW'
    }, {
      "name": 'Last Month',
      "value": 'LM'
    }, {
      "name": ' Last 3Months',
      "value": '3MA'
    }, {
      "name": 'Last 6Months',
      "value": '6MA'
    }];

    //expense expense_schedule data
    $scope.expense_scheduless = [{
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];

    $rootScope.user = $cookies.getObject('user'); //get object of logged in user data from the cookies

    $scope.expenseChange = expenseChange;
    //function for change date for show data depending on date
    function expenseChange(expense, id) {
      $scope.load = true
      expense_analytics(expense) // callback funtion

      $timeout(function() {
        $scope.load = false
      }, 500);

    }

    //service for today's  date of expense anaytic data from server
    function expense_analytics(expense) {
      if (expense == undefined) {
        var expense_change = "LM"
      } else {
        var expense_change = expense
      }

      //api call to db
      api.expense_analytics.getID.get({ date: expense_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          /*---------------------------
          filterning for today task for due date
          -------------------------------*/
          $scope.expense_today_delivery = []; //&& a.ordertime < new Date()
          // filter today expense for today task.
          expense_bill_data.filter(function(a) {
            if (new Date(a.created_on).toDateString() == new Date().toDateString() && a.staffID == $rootScope.user[0].staffID && a.branch_id == $rootScope.user[0].branch_id) {
              $scope.expense_today_delivery.push(a)
            }
            return
          });

          $scope.expensetax = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.expensetaxCgst = response[0].taxCgst_info;
          $scope.expensetaxSgst = response[0].taxSgst_info;

          $scope.total_paid = response[0].total_paid + response[0].advance_paid;
          $scope.total_balance = response[0].total_balance;
          var paid_cash = response[0].paid_cash + response[0].advancepaid_cash;
          var paid_card = response[0].paid_card + response[0].advancepaid_card;
          var paid_cheque = response[0].paid_cheque + response[0].advancepaid_cheque;
          var paid_online = response[0].paid_online + response[0].advancepaid_online;


          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": paid_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_card //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Cheque",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_cheque //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Online Transcation",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_online //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget7 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget7.currentRange = range;

              angular.forEach(analytic_data.widget7.mainChart, function(data, index) {
                vm.widget7.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget7.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget7.init();


          var odc_data = {
            "ranges": {
              "TW": "This Week",
              "LW": "Last Week",
              "2W": "2 Weeks Ago"
            },
            "mainChart": [{
              // "key": response[0].total_categories.key,
              "values": {
                "2W": [
                  { "x": "Mon", "y": 9 },
                  { "x": "Tue", "y": 12 },
                  { "x": "Wed", "y": 9 },
                  { "x": "Thu", "y": 12 },
                  { "x": "Fri", "y": 7 },
                  { "x": "Sat", "y": 8 },
                  { "x": "Sun", "y": 16 }
                ],
                "LW": [
                  { "x": "Mon", "y": 12 },
                  { "x": "Tue", "y": 8 },
                  { "x": "Wed", "y": 7 },
                  { "x": "Thu", "y": 13 },
                  { "x": "Fri", "y": 7 },
                  { "x": "Sat", "y": 6 },
                  { "x": "Sun", "y": 10 }
                ],
                "TW": response[0].total_categories
              }
            }]
          }

          // Widget 5
          vm.widget5 = {
            //title       : vm.dashboardData.widget5.title,
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'multiBarChart',
                  color: ['#ffb000', '#b3e5fc'],
                  height: 420,
                  margin: {
                    top: 8,
                    right: 16,
                    bottom: 32,
                    left: 32
                  },
                  clipEdge: true,
                  groupSpacing: 0.3,
                  reduceXTicks: false,
                  stacked: true,
                  duration: 250,
                  x: function(d) {
                    return d.x;
                  },
                  y: function(d) {
                    return d.y;
                  },
                  yAxis: {
                    tickFormat: function(d) {
                      return d;
                    }
                  },
                  legend: {
                    margin: {
                      top: 8,
                      bottom: 32
                    }
                  },
                  controls: {
                    margin: {
                      top: 8,
                      bottom: 32
                    }
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },

            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: odc_data.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget5.currentRange = range;


              angular.forEach(odc_data.mainChart, function(chartData, index) {
                vm.widget5.mainChart.data[index] = {
                  key: chartData.key,
                  values: chartData.values[range]
                };
              });


            },
            init: function() {

              vm.widget5.changeRange('TW');
            }
          };
          vm.widget5.init();


          $scope.expense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.expense_query_count = response[0].total_results.length;
          $scope.expense_data = response[0].total_results; //apply data to front end

        })



    }
    expense_analytics();

    /*==========================================================================
                           inventory food and beverage analytics
    ========================================================================== */


    //permission for cashier in view of analytics
    var inventory_billdata = [];
    var inventorybillss = [];

    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 3) || permissions[i] == 3) {
        inventorybillss.push("data");
      }
      if (permissions[i] == 3) {
        inventory_billdata.push("datas");
      }
    }
    $scope.inventoryLength = inventory_billdata.length;

    if (inventorybillss.length > 0) {
      $scope.inventory_analytics_permission = true // if true means permission will be applied
    }

    //expense expense_schedule data
    $scope.inventory_schedule = [{
      "name": 'All Days',
      "value": 'AD'
    }, {
      "name": 'Sunday',
      "value": 'SUY'
    }, {
      "name": 'Monday',
      "value": '3MA'
    }, {
      "name": 'Tuesday',
      "value": 'TUY'
    }, {
      "name": 'Wednesday',
      "value": 'WY'
    }, {
      "name": 'Thursday',
      "value": 'THY'
    }, {
      "name": 'Friday',
      "value": 'FY'
    }, {
      "name": 'Saturday',
      "value": 'SAY'
    }];

    vm.weekdays = [{
      "name": 'All',
      "value": 'today'
    }, {
      "name": 'Sun',
      "value": 'last7days'
    }, {
      "name": 'Mon',
      "value": 'last30days'
    }, {
      "name": 'Tue',
      "value": 'last7days'
    }, {
      "name": 'Wed',
      "value": 'last30days'
    }, {
      "name": 'Thu',
      "value": 'last30days'
    }, {
      "name": 'Fri',
      "value": 'last7days'
    }, {
      "name": 'Sat',
      "value": 'last30days'
    }];

    //select box data for catagory filter in food items
    var All_category_items = [{ fmCatergoryID: "All", fmCatergoryName: "All Catergory" }]
    var fmdata = fmCategory.map(function(fm) {
      return { 'fmCatergoryID': fm.fmCatergoryID, 'fmCatergoryName': fm.fmCatergoryName, 'branch_id': fm.branch_id }
    })
    //select box data for caegory filter in raw items
    var All_sale_category_items = [{ smCatergoryID: "All", smCatergoryName: "All Catergory" }]

    var smdatas = siCategory.map(function(sm) {
      return { 'fmCatergoryID': sm.siCatergoryID, 'fmCatergoryName': sm.siCatergoryName, 'branch_id': sm.branch_id }
    })

    //filter data branch wise
    var fulldata = fmdata.concat(smdatas);
    var fulldatas = fulldata.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    vm.fmCategory = All_category_items.concat(fulldatas);
    //food and beverage items pagination
    $scope.inventory_food = {
      filter: '',
      limit: '10',
      order: 'total',
      page: 1
    };

    //function for dropdown filter in food items
    $scope.getFood_items = function(stu) {
      $scope.food_load = true
      var food = $rootScope.food_Data
      var foodID = stu;

      //category filter which match id
      if (stu == "All") {
        $scope.food_beverage = $rootScope.food_Data
        $scope.inventory_food_count = $rootScope.food_Data.length;
        $timeout(function() {
          $scope.food_load = false
        }, 500);
        return;
      }

      //category filter which match id
      var food_Datas = [];
      for (var i = 0; i < food.length; i++) {
        if (food[i].fmCatergoryID == foodID) {
          food_Datas.push(food[i]);
          $scope.inventory_food_count = food_Datas.length;
          $scope.food_beverage = food_Datas;
          continue;
          return;

        }
      }
      $timeout(function() {
        $scope.food_load = false
      }, 500);
    };



    $scope.inventoryChange = inventoryChange;
    //change data in dropdwon
    function inventoryChange(weekdays, inventory, id) {

      $scope.dayset = weekdays;
      $scope.inventory_foodRaw_load = true;
      inventory_analytics(inventory, weekdays) // callback funtion
      $timeout(function() {
        $scope.inventory_foodRaw_load = false
      }, 500);
    }

    $scope.activeMenu = vm.weekdays[0]; //initial apply
    $scope.setActive = function(menuItem) {
      $scope.weekday_load = true
      $scope.activeMenu = menuItem //apply active menu such whether its sunday or monday
      $timeout(function() {
        $scope.weekday_load = false
      }, 500);
    }


    //service for today's  date of food and beverage anaytics data from server
    function inventory_analytics(inventory, weekdays) {
      $scope.inventory_foodRaw_load = true
      if (weekdays == undefined) {
        var weekday = "All"
      } else {
        var weekday = weekdays
      }
      if (inventory == undefined) {
        var inventory_change = "LM"
      } else {
        var inventory_change = inventory
      }
      api.inventory_analytics.getID.get({ weekday: weekday, date: inventory_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },

        function(response) {
          $scope.inventory_food_count = response.length;
          $scope.food_beverage = response; //appy data to front end
          $rootScope.food_Data = response;
          $timeout(function() {
            $scope.inventory_foodRaw_load = false
          }, 500);
        })

    }
    inventory_analytics();

    /*==========================================================================
                               inventory raw material analytics ex. ordered qty, price
      ============================================================================== */
    // Filterning today task raw material delivery date
    $scope.inventoryRaw_today_delivery = [];
    rawmaterial_bill_data.filter(function(a) {
      if (new Date(a.DeliveryDate).toDateString() == new Date().toDateString() && a.staffID == $rootScope.user[0].staffID && a.branch_id == $rootScope.user[0].branch_id) {
        $scope.inventoryRaw_today_delivery.push(a)
      }
      return
    });
    //select box data for caegory filter in raw items
    var All_raw_category_items = [{ rmCatergoryID: "All", rmCatergoryName: "All Catergory" }]
    var rmcategorydatas = rmcategorydata.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    var rmdata = rmcategorydatas.map(function(rm) {
      return { 'rmCatergoryID': rm.rmCatergoryID, 'rmCatergoryName': rm.rmCatergoryName }
    })

    vm.rmCategory = All_raw_category_items.concat(rmdata); //concat data
    $scope.rawmaterial_query = {
      filter: '',
      limit: '10',
      order: 'total',
      page: 1
    };
    //function for dropdown filter in raw items
    $scope.getRaw_items = function(stu) {
      $scope.raw_load = true
      var rawmaterial = $rootScope.raw_Data
      var rmID = stu;
      if (stu == "All") {
        $scope.raw_data = $rootScope.raw_Data
        $scope.rawmaterial_count = $rootScope.raw_Data.length;
        $timeout(function() {
          $scope.raw_load = false
        }, 500);

        return;
      }

      var rawmaterial_datas = [];
      for (var i = 0; i < rawmaterial.length; i++) {
        if (rawmaterial[i].rmCatergoryID == rmID) {
          rawmaterial_datas.push(rawmaterial[i]);
          $scope.rawmaterial_count = rawmaterial_datas.length;
          $scope.raw_data = rawmaterial_datas;
          continue;
          return;

        }
      }
      $timeout(function() {
        $scope.raw_load = false
      }, 500);

    };


    $scope.rawmaterialChange = rawmaterialChange;
    //function for change date for show data depending on date
    function rawmaterialChange(rawmaterial, id) {
      $scope.load = true
      rawmaterial_analytics(rawmaterial) // callback funtion
      $timeout(function() {
        $scope.load = false
      }, 500);
    }

    //service for today's  date of expense anaytic data from server
    function rawmaterial_analytics(rawmaterial) {
      if (rawmaterial == undefined) {
        var rawmaterial_change = "LM"
      } else {
        var rawmaterial_change = rawmaterial
      }
      api.rawmaterial_analytics.getID.get({ date: rawmaterial_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.rawmaterial_count = response.length;
          $rootScope.raw_Data = response;
          $scope.raw_data = response; //apply data to front end

        })
    }
    rawmaterial_analytics();

    /*==========================================================================
                               inventory_ salematerial_analytics ex. ordered qty, price
      ============================================================================== */
    // Filterning data for today task for delivery purpose
    $scope.inventorySale_today_delivery = [];
    salematerial_bill_data.filter(function(a) {
      if (new Date(a.DeliveryDate).toDateString() == new Date().toDateString() && a.staffID == $rootScope.user[0].staffID && a.branch_id == $rootScope.user[0].branch_id) {
        $scope.inventorySale_today_delivery.push(a)
      }
      return
    });

    //expense expense_schedule data
    $scope.inventory_schedules = [{
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];

    //select box data for caegory filter in raw items
    var All_sale_category_items = [{ smCatergoryID: "All", smCatergoryName: "All Catergory" }];
    var siCategorys = siCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    var smdata = siCategorys.map(function(sm) {
      return { 'smCatergoryID': sm.siCatergoryID, 'smCatergoryName': sm.siCatergoryName }
    })

    vm.smCategory = All_sale_category_items.concat(smdata);
    $scope.salematerial_query = {
      filter: '',
      limit: '10',
      order: 'total',
      page: 1
    };
    //function for dropdown filter in raw items
    $scope.getSale_items = function(stu) {
      $scope.sale_load = true
      var salematerial = $rootScope.sale_Data
      var smID = stu;
      if (stu == "All") {
        $scope.sale_data = $rootScope.sale_Data
        $scope.salematerial_count = $rootScope.sale_Data.length;
        $timeout(function() {
          $scope.sale_load = false
        }, 500);
        return;
      }

      var salematerial_datas = [];
      for (var i = 0; i < salematerial.length; i++) {
        if (salematerial[i].smCatergoryID == smID) {
          salematerial_datas.push(salematerial[i]);
          $scope.salematerial_count = salematerial_datas.length;
          $scope.sale_data = salematerial_datas;
          continue;
          return;
        }
      }
      $timeout(function() {
        $scope.sale_load = false
      }, 500);

    };


    $scope.salematerialChange = salematerialChange;
    //function for change date for show data depending on date
    function salematerialChange(salematerial, id) {
      $scope.load = true
      salematerial_analytics(salematerial) // callback funtion
      $timeout(function() {
        $scope.load = false
      }, 500);
    }


    //service for today's  date of expense anaytic data from server
    function salematerial_analytics(salematerial) {
      if (salematerial == undefined) {
        var salematerial_change = "LM"
      } else {
        var salematerial_change = salematerial
      }
      api.salematerial_analytics.getID.get({ date: salematerial_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.salematerial_count = response.length;
          $rootScope.sale_Data = response;
          $scope.sale_data = response; //apply data to front end

        })
    }
    salematerial_analytics();




    /*==========================================================================
                     Purchase raw material payment analytics
    ==========================================================================*/


    $scope.purchaseexpenseChange = purchaseexpenseChange;
    //function for change date for show data depending on date
    function purchaseexpenseChange(expense, id) {
      $scope.load = true;
      purchaseexpense_analytics(expense) // callback funtion
      $timeout(function() {
        $scope.load = false;
      }, 500);

    }

    //service for today's  date of expense anaytic data from server
    function purchaseexpense_analytics(expense) {
      if (expense == undefined) {
        // Init default value
        var expense_change = "LM"
      } else {
        // If change
        var expense_change = expense
      }
      api.purchaseexpense_analytics.getID.get({ date: expense_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.purchasetax = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.purchasetaxCgst = response[0].taxCgst_info;
          $scope.purchasetaxSgst = response[0].taxSgst_info;
          $scope.purchasetotal_paid = response[0].total_paid + response[0].advance_paid;
          $scope.purchasetotal_balance = response[0].total_balance;
          var paid_cash = response[0].paid_cash + response[0].advancepaid_cash;
          var paid_card = response[0].paid_card + response[0].advancepaid_card;
          var paid_cheque = response[0].paid_cheque + response[0].advancepaid_cheque;
          var paid_online = response[0].paid_online + response[0].advancepaid_online;

          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": paid_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_card //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Cheque",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_cheque //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Online Transcation",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_online //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget34 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget34.currentRange = range;

              angular.forEach(analytic_data.widget7.mainChart, function(data, index) {
                vm.widget34.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget34.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget34.init();
          $scope.purchaseexpense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.purchaseexpense_query_count = response[0].total_results.length;
          $scope.purchaseexpense_data = response[0].total_results; //apply data to front end

        })
    }
    purchaseexpense_analytics();




    /*==========================================================================
                      Purchase sale material payment analytics
    ========================================================================== */


    $scope.SalesexpenseChange = SalesexpenseChange;
    //function for change date for show data depending on date
    function SalesexpenseChange(expense, id) {
      $scope.load = true
      salesExpense_analytics(expense) // callback funtion
      $timeout(function() {
        $scope.load = false
      }, 500);

    }

    //service for today's  date of expense anaytic data from server
    function salesExpense_analytics(expense) {
      if (expense == undefined) {
        // Init default value
        var expense_change = "LM"
      } else {
        // If changed
        var expense_change = expense
      }
      api.salesexpense_analytics.getID.get({ date: expense_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },

        function(response) {
          $scope.salestax = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.salestaxCgst = response[0].taxCgst_info;
          $scope.salestaxSgst = response[0].taxSgst_info;
          $scope.saletotal_paid = response[0].total_paid + response[0].advance_paid;
          $scope.saletotal_balance = response[0].total_balance;
          var paid_cash = response[0].paid_cash + response[0].advancepaid_cash;
          var paid_card = response[0].paid_card + response[0].advancepaid_card;
          var paid_cheque = response[0].paid_cheque + response[0].advancepaid_cheque;
          var paid_online = response[0].paid_online + response[0].advancepaid_online;

          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": paid_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_card //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Cheque",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_cheque //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Online Transcation",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_online //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget78 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget78.currentRange = range;

              angular.forEach(analytic_data.widget7.mainChart, function(data, index) {
                vm.widget78.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget78.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget78.init();
          $scope.saleexpense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.saleexpense_query_count = response[0].total_results.length;
          $scope.saleexpense_data = response[0].total_results; //apply data to front end

        })

    }
    salesExpense_analytics();

    /*==========================================================================
                      SMS Marketing
      ========================================================================== */

    vm.sms_date = [{
      "name": 'Today',
      "value": 'today'
    }, {
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];

    //permission for cashier in view of analytics
    var sms = [];

    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 52) || permissions[i] == 52) {
        sms.push("data");
      }
    }


    if (sms.length > 0) {
      $scope.sms = true // if true means permission will be applied
    }

    $scope.SmsChange = SmsChange;
    //function for change date for show data depending on date
    function SmsChange(sms, id) {
      $scope.inventory_foodSms_load = true
      sms_analytics(sms) // callback funtion

      $timeout(function() {
        $scope.inventory_foodSms_load = false
      }, 500);

    }

    //service for today's  date of expense anaytic data from server
    function sms_analytics(sms) {
      if (sms == undefined) {
        // Init default value
        var sms_change = "LM"
      } else {
        // If change
        var sms_change = sms
      }
      api.sms_analytics.getID.get({ date: sms_change, staffID: $rootScope.user[0].staffID, branch_id: $rootScope.user[0].branch_id },

        function(response) {
          $scope.sms_count = branch_data.filter(function(data) {
            if (data.branch_id == $rootScope.user[0].branch_id)
              return data
          })
          $scope.sms_data = response[0];
          var sms_analytics_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Pending",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": response[0].PENDING //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Delivered",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": response[0].DELIVERED //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Faild",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": response[0].FAILED //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget79 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget79.currentRange = range;

              angular.forEach(sms_analytics_data.widget7.mainChart, function(data, index) {
                vm.widget79.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget79.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget79.init();
        })
    }
    sms_analytics();

    // GET Online types NAME
    //---------------- 
    $scope.getOnlineTypeNames = function(onlinePaymentTypeAmount) {
      if (!vm.onlineTypes) {
        return;
      }
      for (var i = 0; i < vm.onlineTypes.length; i++) {
        if (vm.onlineTypes[i].values == onlinePaymentTypeAmount.values) {
          return vm.onlineTypes[i].names
        }
      }
    };
// end   


  }
})();

(function() {
  'use strict';

  angular
    .module('customer-list', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.customerlist', {
        url: '/customer-list',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/customer-list/customer-list.html',
            controller: 'CustomerListController as vm'
          }
        },
        resolve: {
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
        },

        ncyBreadcrumb: {

          // label:"{{getBreadcrumbLabel()}}"
          label: '{{ "BILLINGS.CUSTOMERS" | translate }}'
        }
      })
      .state('app.customeranalytics', {
        url: '/customer-list/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/cashier/customer-list/customer-analytics/customer-analytics.html',
            controller: 'CustomerListController as vm'
          }
        },
        resolve: {
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          },
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },
            dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          customer_details: function(apiResolver) {
            return apiResolver.resolve('customer_details.getAll@get');
          },
        },

        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id) {
              return 'app.customerlist';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"
          //  label: '{{ "BILLINGS.CUSTOMERS" | translate }}'
        }
      });


    // Api
    // msApiProvider.register('settingstax', ['app/data/settings/tax/tax.json']);


  }
})();

(function() {
  'use strict';

  angular
    .module('customer-list')
    .controller('CustomerListController', CustomerListController)
    .directive('exportToCustomerCsv', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            //var today=new Date()
            var today = new Date(scope.myDate).toString(); //get like wed apr with time
            today = new Date(today).toUTCString();
            today = today.split(' ').slice(0, 4).join(' ');
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Customer Data' + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function CustomerListController($scope, $cookies, locality, dietType, $state, $filter, $stateParams, point, $timeout, $location, msNavigationService, $rootScope, customer_details, $mdDialog, $mdToast, api) {
    var vm = this;
    $scope.mdtableselected = []; // dummy assign
    // DATA
    //----------------
    //filter locality data for branch wise which is came from database
    var localityy = locality.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.locality = localityy; //assign filtered data to drodown
    //clear text function while search
    $scope.clearText = function() {
      $scope.purchaseorder_query.filter = '';
    }
    vm.settings = dietType.settings; //assign corporate category from general json
    vm.download = dietType.download;
    vm.dietTypeLists = dietType.newbill.dietTypeLists


    $scope.domaincatergory = $rootScope.user[0].domain_category;
    //pass customer id to another status such as customer analytics
    $scope.viewCustomer = function(customer) {
      $state.go('app.customeranalytics', { id: customer.customer_id })
    };
    // Add Table dialog
    $scope.params = $stateParams;

    // Add customer dialog customer_mobile, id, name, email, address, city
    vm.showAddTableDialog = function(ev, customer) {
      if ($scope.params.id) {
        var data = 'list'
      } else {
        var data = ''
      }
      $mdDialog.show({
        controller: 'CustomerDialoggController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cashier/customer-list/dialog/add_customer_dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          customer_data: customer,
          customer_list: data,
          locality: locality,
          customer_details: customer_details,
          customer_Added: "customer_Added"
        },
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false
      })
    };



    // Add customer dialog customer_mobile, id, name, email, address, city
    vm.customerviewDialog = function(ev, customer) {
      $mdDialog.show({
        controller: 'CustomerDialoggController',
        controllerAs: 'vm',
        templateUrl: 'app/main/cashier/customer-list/dialog/customer_view.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          customer_data: customer,
          customer_details: customer_details,
          customer_Added: "customer_Added"
        },
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false
      })
    };
    //get staff data with id 
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    //get data from cookies
    var admin_permission = $cookies.get('admin')
    $scope.permission = $cookies.get('admin')
    $rootScope.user = $cookies.getObject('user');

    //query for get customer details
    $scope.purchaseorder_query = {
      filter: '',
      limit: '10',
      order: 'ordertime',
      nameorder: 'customer_name',
      page: 1,
      staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
      branch_id: $rootScope.user[0].branch_id
    };
    $scope.params = $stateParams; //syntax for get url id

    //success function of customer_list from the server
    function customer_list_success(desserts) {
      //collect counts from server
      $scope.deliveryLength = desserts[0].results
      //$scope.purchaseorder_count = desserts[0].purchaseorder_count // apply total_count for doordelivery section
      vm.getpurchase = desserts[0].results.reverse()
      $scope.purchaseorder_count = desserts[0].results.reverse().length
    }
  
    //service for get customer list
    $scope.getDessertsss = function() {
      $scope.reload = function() {
        $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, customer_list_success).$promise;

      };
      $scope.reload();
    };
 
 
    /*
    ------------------------------------------

    View Customer 

    ------------------------------------------
    */
  
    if ($scope.params.id) {
      //edit sales_customer
      $scope.points = point; //condition for  get points feature is enable or not
      // Getting particular customer details
      api.customer_infodiet.getID.get({ salesorder_id: $scope.params.id },
        function(response) {
          $scope.customer = response[0];
        });
        vm.loader = true;
      //customer_food_analytics success
      function customer_food_analytics(desserts) {
        vm.loader = false;
        $scope.hidelastvisit = desserts[0].results[0].customer_id; //if customer is not at leat one time visit then no data found div will showed
        var customer_lastVisits = desserts[0].cus_fulldata.reverse().map(function(item) {
          var format_lastvisit_dates = moment(item.x).format('MMM D,YYYY h:mm:ss');
          return { 'customer_id': item.customer_id, 'x': item.billno, 'y': item.y, 'date':format_lastvisit_dates}
        });
        vm.customer_lastVisits = customer_lastVisits;
        vm.customerBillOrders = desserts[0].cus_fulldata;

        var odc_data = {
          "ranges": {
            "TW": "This Week",
            "LW": "Last Week",
            "2W": "2 Weeks Ago"
          },
          "mainChart": [{
            // "key": response[0].total_categories.key,
            "values": {
              "2W": [
                { "x": "Mon", "y": 9 },
                { "x": "Tue", "y": 12 },
                { "x": "Wed", "y": 9 },
                { "x": "Thu", "y": 12 },
                { "x": "Fri", "y": 7 },
                { "x": "Sat", "y": 8 },
                { "x": "Sun", "y": 16 }
              ],
              "LW": [
                { "x": "Mon", "y": 12 },
                { "x": "Tue", "y": 8 },
                { "x": "Wed", "y": 7 },
                { "x": "Thu", "y": 13 },
                { "x": "Fri", "y": 7 },
                { "x": "Sat", "y": 6 },
                { "x": "Sun", "y": 10 }
              ],
              "TW": desserts[0].results.reverse().slice(0, 10)
            }
          }]
        }

        // Widget 5
        vm.widget5 = {
          //title       : vm.dashboardData.widget5.title,
          mainChart: {
            config: {
              refreshDataOnly: true,
              deepWatchData: true
            },
            options: {
              chart: {
                type: 'multiBarChart',
                color: ['#f848a7', 'orange'],
                height: 420,
                width: 1298,
                margin: {
                  top: 8,
                  right: 200,
                  bottom: 32,
                  left: 32
                },
                clipEdge: true,
                groupSpacing: 0.4,
                reduceXTicks: false,
                stacked: true,
                duration: 250,
                x: function(d) {
                  return d.x;
                },
                y: function(d) {
                  return d.y;
                },
                yAxis: {
                  tickFormat: function(d) {
                    return d;
                  }
                },
                legend: {
                  margin: {
                    top: 8,
                    bottom: 32
                  }
                },
                controls: {
                  margin: {
                    top: 8,
                    bottom: 32
                  }
                },
                tooltip: {
                  gravity: 's',
                  classes: 'gravity-s'
                }
              }
            },
            data: []
          },

          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          ranges: odc_data.ranges,
          currentRange: '',
          changeRange: function(range) {
            vm.widget5.currentRange = range;


            angular.forEach(odc_data.mainChart, function(chartData, index) {
              vm.widget5.mainChart.data[index] = {
                key: chartData.key,
                values: chartData.values[range]
              };
            });
          },
          init: function() {

            vm.widget5.changeRange('TW');
          }
        };
        vm.widget5.init();

        $scope.date = new Date()
        var odc_datas = {
          "ranges": {
            "TW": "This Week",
            "LW": "Last Week",
            "2W": "2 Weeks Ago"
          },
          "mainChart": [{
            // "key": response[0].total_categories.key,
            "values": {
              "2W": [
                { "x": "Mon", "y": 9 },
                { "x": "Tue", "y": 12 },
                { "x": "Wed", "y": 9 },
                { "x": "Thu", "y": 12 },
                { "x": "Fri", "y": 7 },
                { "x": "Sat", "y": 8 },
                { "x": "Sun", "y": 16 }
              ],
              "LW": [
                { "x": "Mon", "y": 12 },
                { "x": "Tue", "y": 8 },
                { "x": "Wed", "y": 7 },
                { "x": "Thu", "y": 13 },
                { "x": "Fri", "y": 7 },
                { "x": "Sat", "y": 6 },
                { "x": "Sun", "y": 10 }
              ],
              "TW": customer_lastVisits.slice(0, 10)
            }
          }]
        }


      }
      // Getting feedback data for particular customer
      function customer_feedback_analytics(desserts) {
        $scope.feedback = desserts[0];
        //FEEDBAK SERVICE PERCENT CALCULATION
        var service = $scope.feedback.Feedback_service[0].GREAT + $scope.feedback.Feedback_service[0].GOOD + $scope.feedback.Feedback_service[0].OK + $scope.feedback.Feedback_service[0].BAD + $scope.feedback.Feedback_service[0].POOR;
        $scope.feedback_service_GREAT = ($scope.feedback.Feedback_service[0].GREAT / service) * 100;
        $scope.feedback_service_GOOD = ($scope.feedback.Feedback_service[0].GOOD / service) * 100;
        $scope.feedback_service_OK = ($scope.feedback.Feedback_service[0].OK / service) * 100;
        $scope.feedback_service_BAD = ($scope.feedback.Feedback_service[0].BAD / service) * 100;
        $scope.feedback_service_POOR = ($scope.feedback.Feedback_service[0].POOR / service) * 100;
        $scope.feedback_Service_review = (5 * $scope.feedback.Feedback_service[0].GREAT + 4 * $scope.feedback.Feedback_service[0].GOOD + 3 * $scope.feedback.Feedback_service[0].OK + 2 * $scope.feedback.Feedback_service[0].BAD + 1 * $scope.feedback.Feedback_service[0].POOR) / service;

        //FEEDBAK STAFF PERCENT CALCULATION
        var staff = $scope.feedback.Feedback_staff[0].GREAT + $scope.feedback.Feedback_staff[0].GOOD + $scope.feedback.Feedback_staff[0].OK + $scope.feedback.Feedback_staff[0].BAD + $scope.feedback.Feedback_staff[0].POOR;
        $scope.feedback_staff_GREAT = ($scope.feedback.Feedback_staff[0].GREAT / service) * 100;
        $scope.feedback_staff_GOOD = ($scope.feedback.Feedback_staff[0].GOOD / service) * 100;
        $scope.feedback_staff_OK = ($scope.feedback.Feedback_staff[0].OK / service) * 100;
        $scope.feedback_staff_BAD = ($scope.feedback.Feedback_staff[0].BAD / service) * 100;
        $scope.feedback_staff_POOR = ($scope.feedback.Feedback_staff[0].POOR / service) * 100;
        $scope.feedback_staff_review = (5 * $scope.feedback.Feedback_staff[0].GREAT + 4 * $scope.feedback.Feedback_staff[0].GOOD + 3 * $scope.feedback.Feedback_staff[0].OK + 2 * $scope.feedback.Feedback_staff[0].BAD + 1 * $scope.feedback.Feedback_staff[0].POOR) / staff;


        //FEEDBAK FOOD PERCENT CALCULATION
        var food = $scope.feedback.Feedback_food[0].GREAT + $scope.feedback.Feedback_food[0].GOOD + $scope.feedback.Feedback_food[0].OK + $scope.feedback.Feedback_food[0].BAD + $scope.feedback.Feedback_food[0].POOR;
        $scope.feedback_food_GREAT = ($scope.feedback.Feedback_food[0].GREAT / service) * 100;
        $scope.feedback_food_GOOD = ($scope.feedback.Feedback_food[0].GOOD / service) * 100;
        $scope.feedback_food_OK = ($scope.feedback.Feedback_food[0].OK / service) * 100;
        $scope.feedback_food_BAD = ($scope.feedback.Feedback_food[0].BAD / service) * 100;
        $scope.feedback_food_POOR = ($scope.feedback.Feedback_food[0].POOR / service) * 100;
        $scope.feedback_food_review = (5 * $scope.feedback.Feedback_food[0].GREAT + 4 * $scope.feedback.Feedback_food[0].GOOD + 3 * $scope.feedback.Feedback_food[0].OK + 2 * $scope.feedback.Feedback_food[0].BAD + 1 * $scope.feedback.Feedback_food[0].POOR) / food;


        //FEEDBAK MONEY PERCENT CALCULATION
        var money = $scope.feedback.Feedback_money[0].GREAT + $scope.feedback.Feedback_money[0].GOOD + $scope.feedback.Feedback_money[0].OK + $scope.feedback.Feedback_money[0].BAD + $scope.feedback.Feedback_money[0].POOR;
        $scope.feedback_money_GREAT = ($scope.feedback.Feedback_money[0].GREAT / service) * 100;
        $scope.feedback_money_GOOD = ($scope.feedback.Feedback_money[0].GOOD / service) * 100;
        $scope.feedback_money_OK = ($scope.feedback.Feedback_money[0].OK / service) * 100;
        $scope.feedback_money_BAD = ($scope.feedback.Feedback_money[0].BAD / service) * 100;
        $scope.feedback_money_POOR = ($scope.feedback.Feedback_money[0].POOR / service) * 100;
        $scope.feedback_money_review = (5 * $scope.feedback.Feedback_money[0].GREAT + 4 * $scope.feedback.Feedback_money[0].GOOD + 3 * $scope.feedback.Feedback_money[0].OK + 2 * $scope.feedback.Feedback_money[0].BAD + 1 * $scope.feedback.Feedback_money[0].POOR) / money;


      }

      //Getting general data for particular customer
      function customerlist_service_success(desserts) {

        //collect counts from server
        var customer_filter = [];
        desserts[0].results.filter(function(item) {
          if (item.customer_id == $scope.params.id)  {
            customer_filter.push(item)
          }
        })
        //assign the details of customer for depending on orders
        $scope.ordertime = customer_filter[0].ordertime
        $scope.lastvisit = customer_filter[0].lastvisit
        $scope.total_visit = customer_filter[0].total_visit
        $scope.avgtotal = customer_filter[0].avgtotal
        $scope.pointsEarned = customer_filter[0].pointsEarned
        $scope.customer_address = customer_filter[0].customer_address
        $scope.customer_email = customer_filter[0].customer_email
        $scope.customer_mobile = customer_filter[0].customer_mobile
        $scope.customer_name = customer_filter[0].customer_name
        $scope.total = customer_filter[0].total
        $scope.doordelivery = customer_filter[0].doordelivery
        $scope.takeaway = customer_filter[0].takeaway
        $scope.dinein = customer_filter[0].dinein
        $scope.deliveryLength = desserts[0].results
        $scope.purchaseorder_count = desserts[0].purchaseorder_count // apply total_count for doordelivery section
        vm.getpurchase = desserts[0].results.reverse()
        var analytic_data = {
          "projects": [{
              "name": "ACME Corp. Backend App"
            },
            {
              "name": "ACME Corp. Frontend App"
            },
            {
              "name": "Creapond"
            },
            {
              "name": "Withinpixels"
            }
          ],
          "widget6": {
            "title": "Task Distribution",
            "ranges": {
              "TW": "Today",
              "LW": "Last Week",
              "2W": "2 Weeks Ago"
            },
            "mainChart": [{
                "label": vm.dietTypeLists[0].label,
                "values": {
                  "2W": 18,
                  "LW": 19,
                  "TW": $scope.dinein //here number of dinein applied 
                }
              },
              {
                "label": vm.dietTypeLists[0].label,
                "values": {
                  "2W": 17,
                  "LW": 16,
                  "TW": $scope.takeaway //here number of takeaway applied 
                }
              },
              {
                "label": vm.dietTypeLists[0].label,
                "values": {
                  "2W": 18,
                  "LW": 19,
                  "TW": $scope.doordelivery //here number of doordelivery applied 
                }
              },
            ]
          },

        }

        //default syntax of analytics data writing from the circular bar
        //widget6
        vm.widget6 = {
          title: 's',
          mainChart: {
            config: {
              refreshDataOnly: true,
              deepWatchData: true
            },
            options: {
              chart: {
                type: 'pieChart',
                color: ['#23bf72', '#ffb000', '#fb7b7c'],
                height: 400,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                },
                donut: true,
                clipEdge: true,
                cornerRadius: 0,
                labelType: 'percent',
                padAngle: 0.02,
                x: function(d) {
                  return d.label;
                },
                y: function(d) {
                  return d.value;
                },
                tooltip: {
                  gravity: 's',
                  classes: 'gravity-s'
                }
              }
            },
            data: []
          },
          //ranges: vm.dashboardData.widget6.ranges,
          currentRange: '',
          changeRange: function(range) {
            vm.widget6.currentRange = range;

            angular.forEach(analytic_data.widget6.mainChart, function(data, index) {
              vm.widget6.mainChart.data[index] = {
                label: data.label,
                value: data.values[range]
              };
            });
          },
          init: function() {
            vm.widget6.changeRange('TW');
          }
        };
        // Initialize Widget 6
        vm.widget6.init();
        // Hidding
        if(vm.dietTypeLists[1] == undefined) {
          $timeout(function () {
            $('.nvd3 .nv-legend .nv-series:nth-child(2), .nvd3 .nv-legend .nv-series:nth-child(3)').css({'display':'none'})
          }, 100);        
        }

      }


      
      //get data from cookies
      var admin_permission = $cookies.get('admin')
      $scope.permission = $cookies.get('admin')
      $rootScope.user = $cookies.getObject('user');
      $scope.purchaseorderr_query = {
        filter: '',
        limit: '10',
        order: 'ordertime',
        nameorder: 'customer_name',
        page: 1,
        customer_id: $scope.params.id,
        staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
        branch_id: $rootScope.user[0].branch_id
      };
      $scope.purchaseorder_query = {
        filter: '',
        limit: '10',
        order: 'ordertime',
        nameorder: 'customer_name',
        page: 1,
        staffID: admin_permission == 'admin' ? '' : $rootScope.user[0].staffID,
        branch_id: $rootScope.user[0].branch_id,
        customer_id: $scope.params.id
      };
      $scope.promise = api.customeranalyticfeedback_service.getAll.get($scope.purchaseorderr_query, customer_feedback_analytics).$promise;
      $scope.promise = api.customeranalyticfood_service.getAll.get($scope.purchaseorderr_query, customer_food_analytics).$promise;
      $scope.promise = api.customerlist_service.getAll.get($scope.purchaseorder_query, customerlist_service_success).$promise;
    } else {
      
    }

         // function for edit data from viewbill to newbill when popup opened
         $scope.Editpos = function(salesorder_id,customer_id) {
          var id = salesorder_id;
          $scope.params = $stateParams;
          $state.go('app.newBill', { id: salesorder_id, customer_id: customer_id, editbill:  'finishedbill' })
        };


    //function for Breadcrumb Label with idnewBill
    $rootScope.getBreadcrumbLabel = function() {
      if ($scope.params.id) {
        var customer = customer_details.filter(function(customer) {
          if (customer.customer_id == $scope.params.id)
            return customer
        })
        return customer[0].customer_name
      } else if (!$scope.params.id) {
        return "Customers"
      }
    }
    //while searching text in search text pagination is here restricted
    $scope.$watch('purchaseorder_query.filter', function(newValue, oldValue) {

      if (!oldValue) {
        var bookmark = $scope.purchaseorder_query.page ? $scope.purchaseorder_query.page : 1
      }
      if (newValue !== oldValue) {
        $scope.purchaseorder_query.page = 1
      }

      if (!newValue) {
        $scope.purchaseorder_query.page = bookmark ? bookmark : 1
      }
      $scope.getDessertsss();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('general', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.general', {
        url: '/general',
        views: {
          'content@app': {
            templateUrl: 'app/main/captain/general/general.html',
            controller: 'GeneralController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'General'
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('general')
    .controller('GeneralController', GeneralController);

  /** @ngInject */
  function GeneralController(msNavigationService) {
    var vm = this;

  }
})();

(function() {
  'use strict';

  angular
    .module('blank', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.blank', {
        url: '/blank',
        views: {
          'content@app': {
            templateUrl: 'app/main/captain/blank/blank.html',
            controller: 'BlankController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Blank'
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('blank')
    .controller('BlankController', BlankController);

  /** @ngInject */
  function BlankController(msNavigationService) {
    var vm = this;

    // Data
    vm.dashboardText = 'Welcome to dashboard';

    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('vendors', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.vendors', {
        url: '/vendors',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/vendor/vendor.html',
            controller: 'VendorCategoryController as vm'
          }
        },
        resolve: {
          vendor: function(apiResolver) {
            return apiResolver.resolve('vendor.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: "{{'VENDOR.VENDORS' | translate }}"
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('vendors')
    .controller('VendorCategoryController', VendorCategoryController);

  /** @ngInject */
  function VendorCategoryController($scope, msNavigationService, api, $rootScope, $mdDialog, $mdToast, vendor) {
    var vm = this;

    //filter vendor data for branch wise which is came from database
    var Vendors = vendor.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    vm.vendors = Vendors; //assign filtered vendor data to table


    //clear text funtion while search
    $scope.clearText = function() {
      vm.search = '';
    }


    //popup window for edit purpose
    // Add Table dialog
    vm.showAddTableDialog = function(ev, vItem) {
      $mdDialog.show({
        controller: 'addVendorDialogController',
        templateUrl: 'app/main/admin/vendor/vendor.addcategory.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {
          vendor: vItem,
          vendors_all: vm.vendors
        },
        clickOutsideToClose: false,
        escapeToClose: true,
        focusOnOpen: false
      })
    };


    // Delete alert
    vm.deleteContactConfirm = function(vItem, ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this vendor?')
        .ariaLabel('delete Item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.vendor.getID.delete({ vendorID: vItem.vendorID },
          function(response) {

            $mdToast.show({
              template: '<md-toast class="success"><span flex>Vendor deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

            //success callback
            deleteItem(vItem);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteItem(vItem) {
      vm.vendors.splice(vm.vendors.indexOf(vItem), 1);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('vendors')
    .controller('addVendorDialogController', addVendorDialogController);

  /** @ngInject */

  function addVendorDialogController($scope, $mdDialog, $rootScope, api, vendor, vendors_all, $mdToast) {
    var vm = this;


    $scope.user = vendor; //get clicked vendor data for edit purpose and assign to input


    //create vendor type for apply front end checkbox
    $scope.vendor_type = [{
      "label": "Company",
      "value": "company"
    }, {
      "label": "Person",
      "value": "person"
    },  {
      "label": "Dealer",
      "value": "dealer"
    }
  ]
    // only number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    $scope.title = 'Edit';

    //check whether page is add or edit
    if (!$scope.user) {
      $scope.user = {
        'company_name': '',
        'name': '',
        'mobile': '',
        'phone': '',
        'email': '',
        'address': '',
        'gst_no': '',
        'vendor_type': 'company'

      };

      $scope.title = 'Add';
      $scope.newRMItem = true;
    }

    // Edit New Category
    //----------------
    $scope.editItem = function(vItem) {
      var vendorinfo = $scope.user;
      var vendorID = $scope.user.vendorID;
      api.vendor.getID.update({ vendorID: vendorID }, vendorinfo,
        function(response) {
          $mdDialog.hide(); // close popup 
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Vendor updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {

        }
      );

    };
    //save function for to add vendor datas to database
    $scope.addvendor = function() {
      vm = this;
      var vendors = $scope.user;
      vm.rmInfo = $scope.user
      //this is for when staff add new vendor from user side this datas will merged in user side vendor autocomplete
      //so this array is created for our convenient 
      var newvendor = [{
        'address': vm.rmInfo.address,
        'company_name': vm.rmInfo.company_name,
        'vendor_type': vm.rmInfo.vendor_type,
        'email': vm.rmInfo.email,
        'gst_no': vm.rmInfo.gst_no,
        'mobile': vm.rmInfo.mobile,
        'name': vm.rmInfo.name,
        'phone': vm.rmInfo.phone,
        'vendor_name': vm.rmInfo.company_name,
        'display': vm.rmInfo.company_name
      }];
      //this is for store vendor data to databse
      var newvendors = [{
        'address': vm.rmInfo.address,
        'company_name': vm.rmInfo.company_name,
        'vendor_type': vm.rmInfo.vendor_type,
        'email': vm.rmInfo.email,
        'gst_no': vm.rmInfo.gst_no,
        'mobile': vm.rmInfo.mobile,
        'name': vm.rmInfo.name,
        'phone': vm.rmInfo.phone,
        'branch_id': $rootScope.user[0].branch_id
      }];

      api.vendor.getAll.save(newvendors[0],
        // Success
        function(response) {
          var mergeData = angular.merge(newvendor[0], { vendorID: response.insertId })
          vendors_all.unshift(mergeData); 
          $mdDialog.hide();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Vendor added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
          // close popup 
        },
        // Error
        function(response) {}
      );
    };

    $scope.closeDialog = function() {
      $mdDialog.hide();
    }
    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('viewcashier', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.viewcashier', {
        parent: 'app.userslist',
        url: '/viewcashier',
        views: {
           'content@app': {
            templateUrl: 'app/main/admin/viewcashier/viewcashier.html',
            controller: 'ViewCashierController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "USERS.VIEW-CASHIER" | translate }}'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('viewcashier')
    .controller('ViewCashierController', ViewCashierController);

  /** @ngInject */
  function ViewCashierController($scope, msNavigationService) {
    var vm = this;

$scope.cashiersinfo = {
        name : "Amal ausline",
        emailid : "amaldx4@gmail.com",
        mobileno : "925456782",
        photo : "http://1ofdmq2n8tc36m6i46scovo2e.wpengine.netdna-cdn.com/wp-content/uploads/2014/04/Steven_Hallam-slide.jpg",
        status : "Active",
        anotherRole : "Manager",
        permission : "Access waiter app",
        lastactive : " Feb 5 at 9:50 PM",
        lastactiveTimeFull : "Tue, Feb 5, 2017 at 9:50 PM"
        
    };



    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('users-role', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.usersrole', {
        url: '/users-role',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/users-role/users-role.html',
            controller: 'UsersRoleController as vm'
          }
        },
        resolve: {
          userRole: function(apiResolver) {
            return apiResolver.resolve('userRole.getAll@get');
          }
        },

        ncyBreadcrumb: {
          label: '{{ "USERS.STAFF-ROLE" | translate }}'
        }
      });


    // Api
    msApiProvider.register('usersrole', ['app/data/users/users-role/users-role.json']);


  }
})();

(function() {
  'use strict';

  angular
    .module('users-role')
    .controller('UsersRoleController', UsersRoleController);

  /** @ngInject */
  function UsersRoleController($scope, userRole, $rootScope, msNavigationService, api, $mdDialog, $mdToast) {
    var vm = this;


    //filter staff roles for branch wise
    var userRoles = userRole.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    // DATA
    //----------------
    vm.usersrole = userRoles; //assign  filtered staff roles to table

    //open popup for edit purpose
    // Add Table dialog
    vm.showAddUserRoleDialog = function(ev, userrole) {
      $mdDialog.show({
        controller: UserRoleDialogController,
        templateUrl: 'app/main/admin/users-role/users-role.addrole.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          userrole: userrole,
          Allusersroles: vm.usersrole
        }
      })
    };

    //popup function will be called here
    function UserRoleDialogController($scope, $mdDialog, userrole, Allusersroles) {
      $scope.title = 'Edit';
      $scope.userrole = angular.copy(userrole); //angular copy for when change edit data in input it will be affected in tables also.
      $scope.Allusersroles = Allusersroles; //assign staff roles to front end
      //check whether add or edit
      if (!userrole) {
        $scope.role_name = ''
        $scope.newRMItem = true;
        $scope.title = 'Add'
      }
      //save function for staff roles
      $scope.addRole = function() {
        var data = [$scope.userrole].map(function(item) {
          return { 'branch_id': $rootScope.user[0].branch_id, 'role_name': item.role_name }
        })
        api.add_userrole.getAll.save(data[0],
          // Success
          function(response) {
            var mergeData = angular.merge(data[0], { roleID: response.insertId })
            $scope.Allusersroles.push(mergeData);
            $mdDialog.hide();
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Staff role added successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            // close popup 
          },
          // Error
          function(response) {}
        );

      }
      //edit function for staff roles
      $scope.editRole = function(Role) {
        var userrole = $scope.userrole;

        api.add_userrole.getID.update({ roleID: Role.roleID }, userrole,
          function(response) {
            for (var i = 0; i < $scope.Allusersroles.length; i++) {
              if ($scope.Allusersroles[i].roleID === $scope.userrole.roleID) {
                $scope.Allusersroles[i] = angular.copy($scope.userrole);
                break;
              }
            };

            $mdDialog.hide(); // close popup 
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Staff role updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

          },
          // Error
          function(response) {}
        );

      };

      //cancel function
      $scope.closeDialog = function() {
        $mdDialog.hide();
      }
    }

    // Delete alert
    vm.deleteContactConfirm = function(staff, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this role?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.add_userrole.getID.delete({ roleID: staff.roleID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Staff role deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteContact(staff);

          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteContact(staff) {
      vm.usersrole.splice(vm.usersrole.indexOf(staff), 1);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('ThirdParty', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.ThirdParty', {
        url: '/ThirdParty',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/third-party-integration/settings-thirdparty.html',
            controller: 'ThirdPartyController as vm'
          }
        },
        resolve: {
          ThirdParty: function(apiResolver) {
            return apiResolver.resolve('ThirdParty.getAll@get');
          },

        },
        ncyBreadcrumb: {
          label: "{{'BILLINGS.THIRD-PARTY-INTEGRATION' | translate}}"
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('ThirdParty')
    .controller('ThirdPartyController', ThirdPartyController);

  /** @ngInject */
  function ThirdPartyController($scope, $rootScope, msNavigationService, $mdDialog, $mdToast, ThirdParty, api) {
    var vm = this;
    // DATA
    //----------------
    //filter third party data for branch wise which is came from database
    var ThirdPartys = ThirdParty.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.ThirdParty = ThirdPartys; //assign filtered third party data to table

    // number validation
    $scope.restrict = restrict;

    function restrict(e) {
      if (e.target.value.length > 39) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };

    // Add New Category
    $scope.addNewCategory = function(foodcategory) {
      var data = [foodcategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'thirdparty_name': item.thirdparty_name }
      })
      api.ThirdParty.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { thirdparty_id: response.insertId })
          vm.ThirdParty.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>ThirdParty added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {}
      );
    };



    // Cancel add item data clear
    $scope.cancelAddItem = function(addCategory) {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.addCategory.$setUntouched(); // Validat
      $scope.foodcategory = {};
    }

    // Edit alert
    $scope.updateaData = function(foodcategory) {
      api.ThirdParty.getID.update({ thirdparty_id: foodcategory.thirdparty_id }, foodcategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>ThirdParty updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {}
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(foodcategory) {
      foodcategory.backupName = angular.copy(foodcategory.thirdparty_name);
    };
    $scope.cancelItem = function(foodcategory) {
      foodcategory.exCatergoryName = angular.copy(foodcategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(foodcategory, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this ThirdParty?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.ThirdParty.getID.delete({ thirdparty_id: foodcategory.thirdparty_id },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>ThirdParty deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteContact(foodcategory);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteContact(foodcategory) {
      vm.ThirdParty.splice(vm.ThirdParty.indexOf(foodcategory), 1);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('users-list', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.userslist', {
        url: '/users-list',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/users-list/users-list.html',
            controller: 'UsersListController as vm'
          }
        },
        resolve: {
          userRole: function(apiResolver) {
            return apiResolver.resolve('userRole.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
        },
        ncyBreadcrumb: {
          label: '{{ "USERS.LIST-OF-STAFF" | translate }}'
        }
      });




  }
})();

(function() {
  'use strict';

  angular
    .module('users-list')
    .controller('UsersListController', UsersListController);

  /** @ngInject */
  function UsersListController($scope, msNavigationService, $rootScope, userRole, staffRole, $state) {
    var vm = this;

    var role_all = [{ 'roleID': 'All', 'role_name': 'All Roles' }] //create new array for concat with exist array
    
    var userRoles = userRole.map(function(staff_Role) {
      return { 'roleID': staff_Role.roleID, 'role_name': staff_Role.role_name, 'branch_id': staff_Role.branch_id }
    })
   
    var role_Data = role_all.concat(userRoles); //concat two array
    //filter staff roles for branch wise
    var userRoless = userRoles.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    // DATA
    //----------------
    vm.usersrole = userRoles; //assign filtered staff roles to front end
    vm.userRole = role_all.concat(userRoless); //concat work to merge two array (merge user role array and all array)
    // clear function for while search
    $scope.clearText = function() {
      vm.search = '';
    }

    // to get all staff permissions for know what they have permission modules 
    $scope.getAppaccess = function(access) {
      // hide switch branch and user for user 
      var admin = []
      var salesbills = []
      var expensebills = []
      var inventory = []
      var rawmaterial = []
      var salematerial = []
      var ODC = []
      var Marketing = []
      var customer = []
      var sms = []
      var whatsapp = []

      //covert as array format in came from db data
      var permissions = JSON.parse("[" + access.permissions + "]");
      for (var i = 0; i < permissions.length; i++) {
        if (permissions[i] == 0) {
          admin.push("admin");
        } else if (permissions[i] == 1) {
          salesbills.push("salesbills");
        } else if (permissions[i] == 2) {
          expensebills.push("expensebills");
        } else if (permissions[i] == 3) {
          inventory.push("inventory");
        } else if (permissions[i] == 31) {
          rawmaterial.push("raw material");
        } else if (permissions[i] == 32) {
          salematerial.push("sales material");
        } else if (permissions[i] == 4) {
          ODC.push("ODC");
        } else if (permissions[i] == 5) {
          Marketing.push("Marketing");
        } else if (permissions[i] == 51) {
          customer.push("customer");
        } else if (permissions[i] == 52) {
          sms.push("sms");
        } else if (permissions[i] == 53) {
          whatsapp.push("whatsapp");
        }
      }

      var merge_permissions = admin.concat(salesbills).concat(expensebills).concat(inventory).concat(rawmaterial).concat(salematerial).concat(ODC).concat(Marketing).concat(customer).concat(sms).concat(whatsapp);
      var set = new Set(merge_permissions);
      merge_permissions = Array.from(set);
      $scope.modules = merge_permissions;
    }

    //filter staff datas for branch wise and except super admin(9)
    var Staffs = staffRole.filter(function(staff) {
      if (staff.branch_id == $rootScope.user[0].branch_id && staff.permissions != 9) {
        return staff
      }
    })

    vm.staff = Staffs; //assign filtered staffs to front end

    //get role function for particular staff.whenever page loads this function has called
    $scope.getRole = function(role) {
      if (!userRole) {
        return;
      }
      for (var i = 0; i < userRole.length; i++) {
        if (userRole[i].roleID == role.roleID) {
          return userRole[i].role_name
        }
      }
    };

    // This function for when admin filter role wise then role wise assigned staffs will be came in front end 
    $scope.getuserRole = function(role) {
      if (role.roleID == "All") {
        vm.staff = Staffs;
        return;
      }
      vm.staff = [];
      for (var i = 0; i < Staffs.length; i++) {
        if (Staffs[i].roleID == role.roleID) {
          vm.staff.push(Staffs[i]);
          continue;
          return
        }
      }
    }

    //pass id to another state for edit purpuse
    $scope.EditStaff = function(staffID) {
      $state.go('app.adduser', { id: staffID })
    }


    // DATA
    //----------------
    //assign headers to tables
    vm.headers = [{
        "label": "User details",
        "title": "STAFF DETAILS"
      },
      {
        "label": "Mobile_no",
        "title": "MOBILE NO"
      },
      {
        "label": "Role",
        "title": "Role"
      },
      {
        "label": "App Access",
        "title": "App Access"
      },
      {
        "label": "Actions",
        "title": "Actions"
      }
    ];

  }
})();

(function() {
  'use strict';

  angular
    .module('tablesettings')
    .controller('TableSettingsController', TableSettingsController);

  /** @ngInject */
  function TableSettingsController($scope, msNavigationService, $rootScope, $mdDialog, $mdToast, TableNo, $http, $stateParams, api) {
    var vm = this;

    // only number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    // DATA
    //----------------
    //filter table data for branch wise which is came from database 
    var TableNos = TableNo.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.tablesinfo = TableNos; //assign filterd table data to table
      

    // Edit 
    $scope.updateaData = function(tableinfo) {
      console.log(tableinfo.table_id);
      api.TableNo.getID.update({ table_id: tableinfo.table_id }, tableinfo,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Table updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {
          console.error(response);
        }
      );

    };
    //open popup for edit purpose
    // Add Table dialog
    vm.showAddTableDialog = function(ev, tableinfo) {
      $mdDialog.show({
        controller: 'TableSettingsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/tablesettings/dialog/tablesettings.addtable.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          TableNo: vm.tablesinfo
        }
      });
    };

    // Delete alert
    vm.deleteContactConfirm = function(tableinfo, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this table?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.TableNo.getID.delete({ table_id: tableinfo.table_id },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Table deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            console.log("success");
            deleteContact(tableinfo);

          },
          function(response) {
            // error callback
            console.log("error");
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete row index in the table 
     */
    function deleteContact(tableinfo) {
      vm.tablesinfo.splice(vm.tablesinfo.indexOf(tableinfo), 1);
    }

    var originatorEv;

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('settings-tax', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.settingstax', {
        url: '/tax',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/settings-tax/settings-tax.html',
            controller: 'SettingTaxController as vm'
          }
        },
        resolve: {
          taxs: function(apiResolver) {
            return apiResolver.resolve('taxs.getAll@get');
          }
        },

        ncyBreadcrumb: {
          label: '{{ "BILLINGS.TAX" | translate }}'
        }
      });


    // Api
   // msApiProvider.register('settingstax', ['app/data/settings/tax/tax.json']);


  }
})();

(function() {
  'use strict';

  angular
    .module('settings-tax')
    .controller('SettingTaxController', SettingTaxController);

  /** @ngInject */
  function SettingTaxController($scope, taxs, $rootScope, $state, msNavigationService, $mdDialog, $mdToast, api) {
    var vm = this;

    // DATA
    //----------------.

    //filter tax data for branch wise which is came from database
    var taxs_data = taxs.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.taxs = taxs_data; //assign filterd tax data to table
    $scope.max = 100; //assign tax percentage validation to restrict below 100
    // only number validation 
    $scope.onlynumberDot = onlynumberDot;

    function onlynumberDot(e) {
      if (e.which != 8 && e.which != 0 && e.which != 46 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };
    // only number validation of autocomplete
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };

    // Add New Category
    $scope.addTax = function(taxs) {
      var data = [taxs].map(function(item) {
        return { 'taxRate': item.taxRate, 'taxName': item.taxName, 'branch_id': $rootScope.user[0].branch_id }
      })
      api.taxs.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { taxID: response.insertId })
          vm.taxs.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Tax added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {}
      );
    };
    // Cancel add item data clear
    $scope.cancelAddItem = function() {
      clearForm();

    };
    //add item data clear and validation error clear
    function clearForm() {
      $scope.taxs = {}; //empty tax after submit
      $scope.settingsTax.$setPristine(); //enable submit button when only change the content in the input
      $scope.settingsTax.$setUntouched(); // Validation error removed
    };

    // Edit alert
    //check enabled tax or not in frontend   if - not enabled if condition will be worked otherwise
    // if enabled else condition will be worked
    vm.editTax = function(tax) {
      if ($scope.enableTax == false || $scope.enableTax == undefined) {
        var emptytax = [{ 'taxID': vm.taxs[0].taxID, 'taxName': 'CGST', 'taxRate': 0 }, { 'taxID': vm.taxs[1].taxID, 'taxName': 'SGST', 'taxRate': 0 }]
        angular.forEach(emptytax, function(value, key) {
          api.taxs.getID.update({ taxID: value.taxID }, value,
            function(response) {
              vm.show = true; // hide edit mode
            },
            // Error
            function(response) {}
          );
        })
        $mdToast.show({
          template: '<md-toast class="success"><span flex>Tax disbled successfully</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000,
          action: "close"
        });
        $state.go("app.settingstax", {}, { reload: "app.settingstax" })
      } else {
        api.taxs.getID.update({ taxID: tax.taxID }, tax,
          function(response) {
            vm.show = true; // hide edit mode
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Tax updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

          },
          // Error
          function(response) {}
        );
      }

    };
    // While edit a item take old value backup  
    $scope.editItem = function(tax) {
      tax.backupName = angular.copy(tax.taxName);
      tax.backupRate = angular.copy(tax.taxRate);
    };
    $scope.cancelItem = function(tax) {
      tax.taxName = angular.copy(tax.backupName);
      tax.taxRate = angular.copy(tax.backupRate);
    };

    // Delete alert
    vm.deleteTaxConfirm = function(tax, ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Tax?')
        .ariaLabel('delete Tax')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.taxs.getID.delete({ taxID: tax.taxID },
          function(response) {

            $mdToast.show({
              template: '<md-toast class="success"><span flex>Tax deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

            //success callback
            deleteItem(tax);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     *  Delete row index in the table 
     */
    function deleteItem(tax) {
      vm.taxs.splice(vm.taxs.indexOf(tax), 1);
    };
    /**
     *  Check ODC Permission to show the help text
     */
    odcbills();

    function odcbills() {
      $scope.odcPermissions = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 4) || permissions[i] == 4) {
          $scope.odcPermissions.push("data");
        }
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('print', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.print', {
        url: '/printsettings',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/print/print.html',
            controller: 'printsettingsController as vm'
          }
        },
        resolve: {
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
           dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          printsize: function(apiResolver) {
            return apiResolver.resolve('printsize@get');
          }
        },
        ncyBreadcrumb: {
          label: 'Print Details'
        }
      });

  }
})();

(function() {
  'use strict';

  angular
    .module('print')
    .controller('printsettingsController', printsettingsController);

  /** @ngInject */
  function printsettingsController($scope, branch_data, dietType,printsize, api, $mdToast, $state, $rootScope, $stateParams, msNavigationService, $timeout, $q) {
    var vm = this;

    //filter print data for branch wise
    var filterbranch = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    $scope.branchid = filterbranch[0].branch_id; //get currently logged in branch id for edit purpuse

    $scope.params = $stateParams; //it is used for get params id in url
    $scope.printSize = printsize.newbill.printSize //assign printsize array data to dropdown which is came from general json
    $scope.branch = filterbranch[0] //assign filtered branch data
//update print settings to branch table
    $scope.update = function(branchid) {
      var branch = $scope.branch
      var addBranch = [{
        'corporate_name': filterbranch[0].corporate_name,
        'corporate_id': filterbranch[0].corporate_id,
        'expiry_date': filterbranch[0].expiry_date,
        'domain_category': filterbranch[0].domain_category,
        'branch_name': filterbranch[0].branch_name,
        'contact_number': branch.contact_number,
        'address': branch.address,
        'GstNo':branch.GstNo,
        'city': filterbranch[0].city,
        'state': filterbranch[0].state,
        'pincode': filterbranch[0].pincode,
        'printsize': branch.printsize,
        'print_footer': branch.print_footer,
        'sender_id': filterbranch[0].sender_id,
        'authKey': filterbranch[0].authKey,
        'wa_api': filterbranch[0].wa_api == null ? '' : filterbranch[0].wa_api,  
        'user_id': filterbranch[0].user_id,
        'staffID': filterbranch[0].staffID,
        'permissions': filterbranch[0].permissions,
        'barcode_enable': filterbranch[0].barcode_enable
      }]
      api.update_branch_data.getID.update({ branch_id: branchid }, addBranch,
        function(response) {
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Print details updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
          $state.go('app.print', { id: '' })
        })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('point-settings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.pointsettings', {
        url: '/point-settings',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/points/point-settings.html',
            controller: 'PointSettingsController as vm'
          }
        },
        resolve: {
          point: function(apiResolver) {
            return apiResolver.resolve('points.getAll@get');
          }

        },
        ncyBreadcrumb: {
          label: 'Points'
        }
      });

  }
})();

(function() {
  'use strict';

  angular
    .module('point-settings')
    .controller('PointSettingsController', PointSettingsController);

  /** @ngInject */
  function PointSettingsController($scope, $state, $rootScope, msNavigationService, $mdDialog, $mdToast, point, api) {
    var vm = this;

    vm.fmInfo = {} //to empty initially for inputs
    // DATA
    //----------------   
    //filter points data for branch wise
    var point_data = point.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    //to check to whether this branch have points or not
    if (point_data.length > 0) { 
      if (point_data[0].enablepoint == 1) { // check enable point
        vm.fmInfo = point_data[0];
        vm.fmInfo.enablepoint = true; // check checkbox of enable point in frontend
        vm.fmInfo.EnableFirstTime = point_data[0].EnableFirstTime == 1 ? true : false; // check/uncheck checkbox of first time point in frontend
      }
    }
    // Add points data to database
    //----------------
    $scope.addFMItem = function() {
      if (point_data.length == 0) {
        var fmInfo = vm.fmInfo;
        var data = [vm.fmInfo].map(function(item) {
          return { 'amount': item.amount, 'enablepoint': item.enablepoint, 'FirstTimePoint': item.FirstTimePoint, 'EnableFirstTime': item.EnableFirstTime, 'perpoint_amount': item.perpoint_amount, 'branch_id': $rootScope.user[0].branch_id }
        })
        api.points.getAll.save(data[0],
          // Success  $scope.settingsTax.$setUntouched()
          function(response) {
            vm.fmInfo = {};
            $scope.addfoodForm.$setUntouched();
            $state.go("app.pointsettings", {}, { reload: "app.pointsettings" })
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Added successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $mdDialog.hide(); // close popup 
          },
          // Error
          function(response) {}
        );
      } else {
        // Edit points data to update in database
        var fmInfo = vm.fmInfo;
        api.points.getID.update({ pointsID: point_data[0].pointsID }, fmInfo,
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

          },
          // Error
          function(response) {}
        );
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('food-settings-combo', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.foodsettingscombo', {
        url: '/combo',
        views: {
           'content@app': {
            templateUrl: 'app/main/admin/food-settings-combo/food-settings-combo.html',
            controller: 'FoodSettingsComboController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "RESTRAUNTANT.COMBO-PACK" | translate }}'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('food-settings-combo')
    .controller('FoodSettingsComboController', FoodSettingsComboController);

  /** @ngInject */
  function FoodSettingsComboController($scope, msNavigationService, $mdDialog, $mdToast) {
  var vm = this;

// DATA
    //----------------

    vm.headers = [{
        "label": "Food & Beverage",
        "title": "Combo Name"
      },      
        {
        "label": "Type",
        "title": "Food Items"
      },
       {
        "label": "Price",
        "title": "PRICE"
      },
      {
        "label": "Actions",
        "title": "ACTIONS"
      }
    ];

  vm.combopacksinfo = [{
      "comboName" : "Tandori Chicken",
      "photo" : "http://media1.sailusfood.com/wp-content/uploads/2010/04/egg-biryani.jpg",
      "comboItems" : [
      {"itemName" : "Biriyani",
      "itemQuantity" : "1/2 Plate"
    },
     {"itemName" : "Tandori Chicken",
      "itemQuantity" : "6 Pieces"
    },
     {"itemName" : "Tandori Chicken",
      "itemQuantity" : "6 Pieces"
    }],
      "comboPrice" : "160"

     },{
      "comboName" : "Vegetarian",
      "photo" : "http://media1.sailusfood.com/wp-content/uploads/2010/04/egg-biryani.jpg",
      "comboItems" : [
        {"itemName" : "Veg- Biriyani",
      "itemQuantity" : "1 Plate"
    },
     {"itemName" : "Naan Bread",
      "itemQuantity" : "2"
    }
      ],
      "comboPrice" : "160"
    }];

// Add Table dialog
    vm.showAddComboDialog = function(ev) {
      $mdDialog.show({
        controller: DialogController,
        templateUrl: 'app/main/admin/food-settings-combo/food-settings-combo.addcombo.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose      : false,
        focusOnOpen: false
      })
    };

    function DialogController($scope, $mdDialog) {
      $scope.closeDialog = function() {
        $mdDialog.hide();
      }}

// Delete alert
vm.showAlert = function(ev) 
        {
            var confirm = $mdDialog.confirm({
                title              : 'Delete Combo Pack',
                textContent        : 'Are you sure you want to delete this Combo Pack?',
                ariaLabel          : 'delete combo pack',
                targetEvent        : ev,
                clickOutsideToClose: false,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

               $mdDialog.show(confirm).then(function ()
            {
                
            }, function ()
            {
                // Canceled
            });

        }

    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('food-settings-category', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.foodsettingcategory', {
        url: '/food-category',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/food-settings-category/food-settings-category.html',
            controller: 'FoodSettingCategoryController as vm'
          }
        },
        resolve: {
          fmCategory: function(apiResolver) {
            return apiResolver.resolve('fmCategory.getAll@get');
          }
        },
        ncyBreadcrumb: {
          label: '{{ "RESTRAUNTANT.MENU-CATEGORY" | translate }}'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('food-settings-category')
    .controller('FoodSettingCategoryController', FoodSettingCategoryController);

  /** @ngInject */
  function FoodSettingCategoryController($scope, msNavigationService, $rootScope, $mdDialog, $mdToast, fmCategory, api) {
    var vm = this;
    // DATA
    //----------------

    //filter food categories for branch wise
    var fmCategorys = fmCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.foodcategorys = fmCategorys; //assign filtered food categories for table


    // Catergory name length restrict
    $scope.restrict = restrict;

    function restrict(e) {
      if (e.target.value.length > 59) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };

    // Add New Category
    $scope.addNewCategory = function(foodcategory) {
      var data = [foodcategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'fmCatergoryName': item.fmCatergoryName }
      })
      api.fmCategory.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { fmCatergoryID: response.insertId })
          vm.foodcategorys.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Category added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {

        }
      );
    };
    // Cancel add item data clear
    $scope.cancelAddItem = function() {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.foodcategory = {};
      $scope.addCategory.$setUntouched(); // Validation error removed
    }

    // Edit alert
    $scope.updateaData = function(foodcategory) {
      api.fmCategory.getID.update({ fmCatergoryID: foodcategory.fmCatergoryID }, foodcategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Category updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {

        }
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(foodcategory) {
      foodcategory.backupName = angular.copy(foodcategory.fmCatergoryName);
    };
    $scope.cancelItem = function(foodcategory) {
      foodcategory.fmCatergoryName = angular.copy(foodcategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(foodcategory, ev) {
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Category?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.fmCategory.getID.delete({ fmCatergoryID: foodcategory.fmCatergoryID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Category deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteContact(foodcategory);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteContact(foodcategory) {
      vm.foodcategorys.splice(vm.foodcategorys.indexOf(foodcategory), 1);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('locality', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.locality', {
        url: '/locality',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/locality/settings-locality.html',
            controller: 'LocalityController as vm'
          }
        },
        resolve: {
          locality: function(apiResolver) {
            return apiResolver.resolve('locality.getAll@get');
          },

        },
        ncyBreadcrumb: {
          label: "{{'BILLINGS.CUSTOMER-LIST.LOCALITY' | translate}}"
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('locality')
    .controller('LocalityController', LocalityController);

  /** @ngInject */
  function LocalityController($scope, $rootScope, msNavigationService, $mdDialog, $mdToast, locality, api) {
    var vm = this;
    // DATA
    //----------------
  //filter localities for branch wise
    var localitys = locality.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.localitys = localitys; //assign filtered localities to table

    // number validation
    $scope.restrict = restrict;

    function restrict(e) {
      if (e.target.value.length > 39) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };

    // Add New Category
    $scope.addNewCategory = function(foodcategory) {
      var data = [foodcategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'localityName': item.localityName }
      })
      api.locality.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { localityID: response.insertId })
          vm.localitys.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Locality added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {}
      );
    };



    // Cancel add item data clear
    $scope.cancelAddItem = function(addCategory) {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.addCategory.$setUntouched(); // Validat
      $scope.foodcategory = {};
    }

    // Edit alert
    $scope.updateaData = function(foodcategory) {
      api.locality.getID.update({ localityID: foodcategory.localityID }, foodcategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Locality updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {

        }
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(foodcategory) {
      foodcategory.backupName = angular.copy(foodcategory.localityName);
    };
    $scope.cancelItem = function(foodcategory) {
      foodcategory.exCatergoryName = angular.copy(foodcategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(foodcategory, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Locality?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.locality.getID.delete({ localityID: foodcategory.localityID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Locality deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteContact(foodcategory);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete row index in the table
     */
    function deleteContact(foodcategory) {
      vm.localitys.splice(vm.localitys.indexOf(foodcategory), 1);
    }

    var originatorEv;

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('food-settings')
    .controller('FoodSettingsController', FoodSettingsController);

  /** @ngInject */
  function FoodSettingsController($scope, msNavigationService, $rootScope, dietType, $mdDialog, $mdToast, fmItems, fmCategory, foodType, foodUnit, api) {
    var vm = this;

    // DATA
    //----------------

    //filter food items for branch wise   
    var fmdata = fmItems.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    vm.foodMenusInfo = fmdata; //assign filtered food items data to table

    //filter food categories for branch wise 
    var fmCategorys = fmCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.foodcategorys = fmCategorys; //assign filtered food category data for dropdown
    vm.foodtypes = foodType.data; //get food type from local json
    vm.foodUnits = foodUnit.data; //get food unit from local json

    //clear search text function
    $scope.clearText = function() {
      vm.search = '';
    }
    // Add Table dialog
    vm.showAddTableDialog = function(ev, fmInfo) {
      $mdDialog.show({
        controller: 'FoodSettingsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/food-settings/dialog/food-settings.addfood.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: false,
        locals: {
          FmInfo: fmInfo,
          fmItems: vm.foodMenusInfo,
          fmCategory: vm.foodcategorys,
          foodType: vm.foodtypes,
          foodUnit: vm.foodUnits,
          dietType: dietType
        }
      });
    };
    // GET CATEGORY NAME
    //---------------- 
    $scope.getCategoryName = function(fmInfo) {
      if (!vm.foodcategorys) {
        return;
      }
      for (var i = 0; i < vm.foodcategorys.length; i++) {
        if (vm.foodcategorys[i].fmCatergoryID == fmInfo.fmCatergoryID) {
          return vm.foodcategorys[i].fmCatergoryName
        }
      }
    };


    // Delete alert
    vm.deleteContactConfirm = function(fmInfo, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Item?')
        .ariaLabel('delete Item')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.fmItems.getID.delete({ fmItemID: fmInfo.fmItemID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Items deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteItem(fmInfo);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteItem(fmInfo) {
      vm.foodMenusInfo.splice(vm.foodMenusInfo.indexOf(fmInfo), 1);
    }



    // Delete alert
    vm.showAlert = function(ev) {
      var confirm = $mdDialog.confirm({
        title: 'Delete Item',
        textContent: 'Are you sure you want to delete this Item?',
        ariaLabel: 'delete food item',
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: true,
        ok: 'Remove',
        cancel: 'Cancel'
      });

      $mdDialog.show(confirm).then(function() {

      }, function() {
        // Canceled
      });

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('editcashier', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.editcashier', {
        parent: 'app.viewcashier',
        url: '/editcashier',
        views: {
           'content@app': {
            templateUrl: 'app/main/admin/editcashier/editcashier.html',
            controller: 'EditCashierController as vm'
          }
        },
        ncyBreadcrumb: {
          label: '{{ "USERS.EDIT-CASHIER" | translate }}' 
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('editcashier')
    .controller('EditCashierController', EditCashierController);

  /** @ngInject */
  function EditCashierController($scope, msNavigationService, $timeout, $q) {
    var vm = this;



  $scope.skill = {
     
        skill_title : 'Angular'
};





$scope.cashiersinfo = {
        name : "Amal ausline",
        emailid : "amaldx4@gmail.com",
        mobileno : "925456782",
        photo : "http://1ofdmq2n8tc36m6i46scovo2e.wpengine.netdna-cdn.com/wp-content/uploads/2014/04/Steven_Hallam-slide.jpg",
        status : "Active",
        anotherRole : "Manager",
        permission : "Access waiter app",
        lastactive : " Feb 5 at 9:50 PM",
        lastactiveTimeFull : "Tue, Feb 5, 2017 at 9:50 PM"
        
    };






    //  msNavigationService.deleteItem('cashier');
    //  msNavigationService.deleteItem('dashboard');

    // Methods

    //////////
  }
})();



(function() {
  'use strict';

  angular
    .module('expense-category', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.expense-category', {
        url: '/expense-category',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/expense-category/expense-category.html',
            controller: 'ExpenseCategoryController as vm'
          }
        },
        resolve: {
          exCategory: function(apiResolver) {
            return apiResolver.resolve('exCategory.getAll@get');
          },

        },
        ncyBreadcrumb: {
          label: "{{'EXPENSE.EXPENSE-CATEGORY' | translate}}"
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('expense-category')
    .controller('ExpenseCategoryController', ExpenseCategoryController);

  /** @ngInject */
  function ExpenseCategoryController($scope, $rootScope, msNavigationService, $mdDialog, $mdToast, exCategory, api) {
    var vm = this;
    // DATA
    //----------------

    //filter tax data for branch wise which is came from database
    var exCategorys = exCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.excategorys = exCategorys;

    // number validation
    $scope.restrict = restrict;

    function restrict(e) {
      if (e.target.value.length > 39) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };

    // Add New Category
    $scope.addNewCategory = function(foodcategory) {
      var data = [foodcategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'exCatergoryName': item.exCatergoryName }
      })
      api.exCategory.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { exCatergoryID: response.insertId })
          vm.excategorys.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Category added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {}
      );
    };



    // Cancel add item data clear
    $scope.cancelAddItem = function(addCategory) {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.addCategory.$setUntouched(); // Validat
      $scope.foodcategory = {};
    }

    // Edit alert
    $scope.updateaData = function(foodcategory) {
      api.exCategory.getID.update({ exCatergoryID: foodcategory.exCatergoryID }, foodcategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Category updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {}
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(foodcategory) {
      foodcategory.backupName = angular.copy(foodcategory.exCatergoryName);
    };
    $scope.cancelItem = function(foodcategory) {
      foodcategory.exCatergoryName = angular.copy(foodcategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(foodcategory, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Category?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.exCategory.getID.delete({ exCatergoryID: foodcategory.exCatergoryID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Category deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteContact(foodcategory);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete row index in the table 
     */
    function deleteContact(foodcategory) {
      vm.excategorys.splice(vm.excategorys.indexOf(foodcategory), 1);
    }

    var originatorEv;

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('corporatedetails', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.corporatedetails', {
        url: '/corporatedetails',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/corporate-details/corporate-details.html',
            controller: 'corporatedetailsController as vm'
          }
        },
        resolve: {
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          }
        },
        ncyBreadcrumb: {
          label: 'Corporate Details'
        }
      })
      .state('app.editcorporate', {
        url: '/editcorporate/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/corporate-details/editbranch.html',
            controller: 'corporatedetailsController as vm'
          }
        },
        resolve: {
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          }
        },
        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id) {    //if url contains id,the state name and branch name will be show on breadcrump
              return 'app.corporatedetails';
            } else if (!$scope.state.params.id) { //if url not contains id,the state name and id will be show on breadcrump 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('corporatedetails')
    .controller('corporatedetailsController', corporatedetailsController);

  /** @ngInject */
  function corporatedetailsController($scope, branch_data, api, $mdToast, $state, dietType, $rootScope, $stateParams, msNavigationService, $timeout, $q) {
    var vm = this;
    //filter coporate details for branch wise
    var filterbranch = branch_data.filter(function(item) {
      if (item.branch_id == $rootScope.user[0].branch_id) {
        return item
      }
    })
    $scope.branchdata = filterbranch[0]; //assign currently logged in branch data

    $scope.branchid = filterbranch[0].branch_id; //assign branch id for pass this id to editcorporate state

    //While click on edit button redirect and pass id to another state
    $scope.editcorporate = function(branch_id) {
      $state.go('app.editcorporate', { id: branch_id })
    };
    // barcode printer
    vm.barcodePrinter = [{
      "name": 'Disable',
      "value": 0
    }, {
      "name": 'Enable',
      "value": 1
    }]; 

    //api call from domain category folder such which json will apply all the modules like bakery,garments
    api.dietType.get(function(dietType) {
      vm.settings = dietType.settings;
    }, function(err) {});


    // Store permissions in an array 
    var admin = []
    var salesbills = []
    var expensebills = []
    var inventory = []
    var rawmaterial = []
    var salematerial = []
    var ODC = []
    var Marketing = []
    var customer = []
    var sms = []
    var whatsapp = []
    var SuperAdmin = []


    //covert as array format permission data which stored in cookies
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]");
    // Checking permission modules
    for (var i = 0; i < permissions.length; i++) {
      if (permissions[i] == 0) {
        admin.push("admin");
      } else if (permissions[i] == 1) {
        salesbills.push("salesbills");
      } else if (permissions[i] == 2) {
        expensebills.push("expensebills");
      } else if (permissions[i] == 3) {
        inventory.push("inventory");
      } else if (permissions[i] == 31) {
        rawmaterial.push("raw material");
      } else if (permissions[i] == 32) {
        salematerial.push("sales material");
      } else if (permissions[i] == 4) {
        ODC.push("ODC");
      } else if (permissions[i] == 5) {
        Marketing.push("Marketing");
      } else if (permissions[i] == 9) {
        SuperAdmin.push("Super Admin");
      } else if (permissions[i] == 51) {
        customer.push("customer");
      } else if (permissions[i] == 52) {
        sms.push("sms");
      }  else if (permissions[i] == 53) {
        whatsapp.push("whatsapp");
      }
    }
    //merge permission modules data after check
    var merge_permissions = admin.concat(salesbills).concat(expensebills).concat(inventory).concat(rawmaterial).concat(salematerial).concat(ODC).concat(Marketing).concat(customer).concat(sms).concat(whatsapp);
    var set = new Set(merge_permissions);
    merge_permissions = Array.from(set);
    $scope.modules = merge_permissions;

    $scope.sms = sms; //Enable authkey and userid if sms permission available
    $scope.whatsapp = whatsapp; //Enable authkey and userid if sms permission available
    $scope.params = $stateParams; //Url parameter 

      $scope.global_staffID = $rootScope.user[0].global_staffID;
      $scope.staffID = $rootScope.user[0].staffID;    

    //condition for check page has url params id or not for edit purpose
    if ($scope.params.id) {
      $scope.branch = filterbranch[0];
      $scope.update = function() {
        var branch = $scope.branch
        var addBranch = [{
          'corporate_name': branch.corporate_name,
          'corporate_id': branch.corporate_id,
          'expiry_date': branch.expiry_date,
          'domain_category': branch.domain_category,
          'branch_name': branch.branch_name,
          'contact_number': branch.contact_number,
          'address': branch.address,
          'GstNo': branch.GstNo,
          'city': branch.city,
          'state': branch.state,
          'pincode': branch.pincode,
          'printsize': branch.printsize,
          'print_footer': branch.print_footer,
          'sender_id': branch.sender_id,
          'authKey': branch.authKey,
          'wa_api': branch.wa_api,          
          'user_id': branch.user_id,
          'staffID': branch.staffID,
          'permissions': branch.permissions,
          'barcode_enable': branch.barcode_enable,
          'wa_billsend': branch.wa_billsend == null ? '' : branch.wa_billsend,
          'upi_id': branch.upi_id == null ? '' : branch.upi_id,
          'upi_name': branch.upi_name == null ? '' : branch.upi_name,
        }]
        //update branch date to database
        api.update_branch_data.getID.update({ branch_id: $scope.params.id }, addBranch,
          function(response) {
            console.log(response);
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Corporate details updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $state.go('app.corporatedetails', { id: '' })
          })
      }

    }

    //function for Breadcrumb Label with idnewBill
    $rootScope.getBreadcrumbLabel = function() {
      if ($scope.params.id) {
        var branched = branch_data.filter(function(o1) {
          if (o1.branch_id == $scope.params.id)
            return o1
        })
        return branched[0].branch_name
      } else if (!$scope.params.id) {
        return "Corporate Details"
      }
    }


    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('banquet-hall', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.banquethall', {
        url: '/banquethall',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/banquet-hall/settings-banquet.html',
            controller: 'BanquetHallController as vm'
          }
        },
        resolve: {
          banquethall: function(apiResolver) {
            return apiResolver.resolve('banquethall.getAll@get');
          },

        },
        ncyBreadcrumb: {
          label: '{{"ODC.BANQUET-HALL"|translate}}'
        }
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('banquet-hall')
    .controller('BanquetHallController', BanquetHallController);

  /** @ngInject */
  function BanquetHallController($scope, $rootScope, msNavigationService, $mdDialog, $mdToast, banquethall, api) {
    var vm = this;
    // DATA
    //----------------
//filter banquet hall data for branch wise
    var banquethalls = banquethall.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    vm.banquethalls = banquethalls; //assign filered banquet hall for dropdown

    // number validation
    $scope.restrict = restrict;

    function restrict(e) {
      if (e.target.value.length > 39) {
        if (e.which != 8 && e.which != 0) {
          e.preventDefault();
        }
      }
    };

    // Add New Category
    $scope.addNewCategory = function(foodcategory) {
      var data = [foodcategory].map(function(item) {
        return { 'branch_id': $rootScope.user[0].branch_id, 'BanquetHallName': item.BanquetHallName }
      })
      api.BanquetHall.getAll.save(data[0],
        // Success
        function(response) {
          var mergeData = angular.merge(data[0], { BanquetHallID: response.insertId })
          vm.banquethalls.unshift(mergeData);
          vm.show = true; // hide box mode
          clearForm();
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Banquet hall added successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });
        },
        // Error
        function(response) {}
      );
    };



    // Cancel add item data clear
    $scope.cancelAddItem = function(addCategory) {
      clearForm();
    }
    //add item data clear and validation error clear
    function clearForm() {
      $scope.addCategory.$setUntouched(); // Validat
      $scope.foodcategory = {};
    }

    // Edit alert
    $scope.updateaData = function(foodcategory) {
      api.BanquetHall.getID.update({ BanquetHallID: foodcategory.BanquetHallID }, foodcategory,
        function(response) {
          vm.show = true; // hide edit mode
          $mdToast.show({
            template: '<md-toast class="success"><span flex>Banquet hall updated successfully</span></md-toast>',
            position: 'bottom right',
            hideDelay: 3000,
            action: "close"
          });

        },
        // Error
        function(response) {}
      );

    };
    // While edit a item take old value backup  
    $scope.editItem = function(foodcategory) {
      foodcategory.backupName = angular.copy(foodcategory.BanquetHallName);
    };
    $scope.cancelItem = function(foodcategory) {
      foodcategory.BanquetHallName = angular.copy(foodcategory.backupName);
    };
    // Delete alert
    vm.deleteContactConfirm = function(foodcategory, ev) {

      var confirm = $mdDialog.confirm()
        .title('Delete')
        .htmlContent('Are you sure you want to delete this Banquet hall?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.BanquetHall.getID.delete({ BanquetHallID: foodcategory.BanquetHallID },
          function(response) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Banquet hall deleted successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            //success callback
            deleteContact(foodcategory);
          },
          function(response) {
            // error callback
          }
        );

      }, function() {
        // Canceled
      });

    };
    /**
     * Delete table
     */
    function deleteContact(foodcategory) {
      vm.banquethalls.splice(vm.banquethalls.indexOf(foodcategory), 1);
    }

    var originatorEv;

    vm.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('admindashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.admindashboard', {
        url: '/admin-dashboard',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/admindashboard/admindashboard.html',
            controller: 'AdminDashboardController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Dashboard'
        },

        resolve: {
          DashboardData: function(msApi) {
            return msApi.resolve('dashboard.project@get');
          },
          DashboardData1: function(msApi) {
            return msApi.resolve('dashboard.analytics@get');
          },
          fmCategory: function(apiResolver) {
            return apiResolver.resolve('fmCategory.getAll@get');
          },
          dietType: function(apiResolver) {
            return apiResolver.resolve('dietType@get');
          },
          odc_category: function(apiResolver) {
            return apiResolver.resolve('odc_category@get');
          },
          inventoryfood: function(apiResolver) {
            return apiResolver.resolve('inventoryfood.getAll@get');
          },
          campaignn: function(apiResolver) {
            return apiResolver.resolve('campaignn.getAll@get');
          },
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
          fmitem_sale: function(apiResolver) {
            return apiResolver.resolve('fmitem_sale.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          },
          sales_order_data: function(apiResolver) {
            return apiResolver.resolve('sales_order_data.getAll@get');
          },
          expense_bill_data: function(apiResolver) {
            return apiResolver.resolve('expense_bill_data.getAll@get');
          },
          rawmaterial_bill_data: function(apiResolver) {
            return apiResolver.resolve('rawmaterial_bill_data.getAll@get');
          },
          salematerial_bill_data: function(apiResolver) {
            return apiResolver.resolve('salematerial_bill_data.getAll@get');
          },
          rmcategorydata: function(apiResolver) {
            return apiResolver.resolve('rmcategorydata.getAll@get');
          },
          siCategory: function(apiResolver) {
            return apiResolver.resolve('siCategory.getAll@get');
          },
        },
        bodyClass: 'dashboard-project'
      });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/cashier/dashboard');
    // Api
    msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    // Api
    msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);




  }
})();

(function() {
  'use strict';

  angular
    .module('admindashboard')
    .controller('AdminDashboardController', AdminDashboardController)
    .filter('unique', function() {
      return function(arr, field) {
        return _.uniq(arr, function(a) { return a[field]; });
      };
    })
    .filter('thousandSuffix', function($filter) {
      return function(input, decimals, $scope) {
        var exp, rounded,
          suffixes = [' Lac', 'M', 'G', 'T', 'P', 'E'];

        if (window.isNaN(input)) {
          return null;
        }

        if (input < 100000) {
          return $filter('number')(input);
        }

        exp = Math.floor(Math.log(input) / Math.log(100000));

        return (input / Math.pow(100000, exp)).toFixed(decimals) + suffixes[exp - 1];
      };
    })
    .directive('exportToSoldCsv', function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var el = element[0];
          element.on('click', function(e) {
            var table = e.target.nextElementSibling;
            var csvString = '';
            for (var i = 0; i < table.rows.length; i++) {
              var rowData = table.rows[i].cells;
              for (var j = 0; j < rowData.length; j++) {
                csvString = csvString + rowData[j].innerHTML + ",";
              }
              csvString = csvString.substring(0, csvString.length - 1);
              csvString = csvString + "\n";
            }
            //var today=new Date()
            var today = new Date(scope.myDate).toString(); //get like wed apr with time
            today = new Date(today).toUTCString();
            today = today.split(' ').slice(0, 4).join(' ');
            csvString = csvString.substring(0, csvString.length - 1);
            var a = $('<a/>', {
              style: 'display:none',
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              download: 'Sold Items Data -' + (today) + '.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          });
        }
      }
    });


  /** @ngInject */
  function AdminDashboardController(msNavigationService, $filter, campaignn, branch_data, sales_order_data, salematerial_bill_data, rawmaterial_bill_data, expense_bill_data, fmitem_sale, $state, siCategory, DashboardData, odc_category, inventoryfood, $stateParams, fmCategory, rmcategorydata, staffRole, api, $timeout, $rootScope, $cookies, $scope, $mdToast, dietType) {
    var vm = this;
    vm.dashboardData = DashboardData; //get data from local json
    $scope.todayDate = new Date();
    $scope.domaincatergory = $rootScope.user[0].domain_category;
    // Getting corporate settings
    // Set active tab for initial time
    vm.settings = dietType.settings; //get data from genral json
    vm.onlineTypes = dietType.onlineTypes;
    vm.dbbackupPath = dietType.dbbackupPath;
    vm.dbstorage = dietType.dbstorage;
    vm.download = dietType.download;
    $scope.feedbackjson = dietType.newbill.feedbackLists[0]; //get data from genral json

 //showing month only in date filter which is supported in angularjs materila 1.10
    var monthFormat = buildLocaleProvider("MMM-YYYY");
    var ymdFormat = buildLocaleProvider("YYYY-MM-DD");
    $scope.monthyear = new Date();
    moment.suppressDeprecationWarnings = true;// warning message removed in console
    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    var monthFormat = buildLocaleProvider("MMM-YYYY");
    $scope.dateFields = [{
        type: 'date',
        required: false,
        binding: 'applicant.pickADate',
        label: 'Standard Date Field - picking day, month and year',
        startView: 'day',
        mode: 'day',
        locale: ymdFormat
      },
      {
        type: 'date',
        required: true,
        binding: 'applicant.dateOfBirth',
        label: 'Date of Birth (date picker that starts with month and year, but still needs day)',
        startView: 'month',
        mode: 'month',
        locale: monthFormat
      },
      {
        type: 'date',
        required: false,
        binding: 'applicant.expectedGraduation',
        startView: 'month',
        label: 'Credit Card Expiry - Year/Month picker',
        mode: 'month',
        locale: monthFormat
      }
    ];

    vm.dropdownfilter = ["Default", "Date", "Month", "Period"];
    vm.odc_categorys = odc_category.odcbill.odc_categories;
    $scope.inventoryHide = [];
    $scope.rawHide = [];
    $scope.saleHide = [];
    $scope.adminpermission = [];
    $scope.mdtableselected = [];
    $scope.mdtableselected_food = []; // dummy assign
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 3) || permissions[i] == 3) {
        $scope.inventoryHide.push("data");
      }
      if (permissions[i] == 0) {
        $scope.adminpermission.push('admin')
      }
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 31) || permissions[i] == 31) {
        $scope.rawHide.push("data");
      }
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 32) || permissions[i] == 32) {
        $scope.saleHide.push("data");
      }
    }
    if ($scope.inventoryHide.length && $scope.rawHide.length) {
      $scope.currentNavItem = 'rawmaterial';
    }
    if ($scope.inventoryHide.length && $scope.saleHide.length) {
      $scope.currentNavItem = 'salematerial';
    }
    if ($scope.inventoryHide.length && $scope.saleHide.length && $scope.rawHide.length) {
      $scope.currentNavItem = 'rawmaterial';
    }
    // ODC catergory name
    $scope.getOdcCategory = function(tag) {
      for (var i = 0; i < vm.odc_categorys.length; i++) {
        if (vm.odc_categorys[i].value == tag.odc_categoryID)
          return vm.odc_categorys[i].label
      }
    }

    // Identify which tab is selected for overview analytics based pass value
  /*  $scope.onTabChanges = function(currentTabIndex){
      localStorage.setItem('TabActive',currentTabIndex);
    };    
    if(localStorage.getItem('TabActive') === undefined){
      $scope.selectedIndex = 0;
    }
    else{
      $scope.selectedIndex = localStorage.getItem('TabActive');
    } */


    // service for get loggin user or admin data
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })
    $filter('number')($scope.number, $scope.fractionSize)

    $cookies.put('admin', "admin");
    vm.staffRoles = staffRole;
    var staff_all = [{ 'name': 'All Staff', 'staffID': 'admin' }]

    var staffrole = staffRole.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    //main admin permission to restrict overview
    $scope.toplevel_admin = branch_data.filter(function(branch) {
      return staffRole.some(function(staff) {
        return branch.staffID == $rootScope.user[0].staffID
      })
    })

    $scope.s = function() {
      vm.staffRole = vm.staffRole
    }
    $scope.staffs = "admin"

    $scope.myDate = new Date(); // assign today data to md picker
    //retrict date only 30 days move on backward from md pciker
    $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate() - 30
    );

    //retrict next day move on forward from md pciker
    $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth(),
      $scope.myDate.getDate()
    );

    $scope.doordelivery_query = {
      filter: '',
      limit: '10',
      order: 'nameToLower',
      page: 1
    };
    $scope.odcdelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.expensedelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.rawdelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.saledelivery_query = {
      filter: '',
      limit: '5',
      order: 'nameToLower',
      page: 1
    }
    $scope.paidbill_count = 12;
    $scope.thirdparty_query = {
      filter: '',
      limit: '10',
      order: 'count',
      page: 1
    }


    vm.paymentmodelist = [{
      "name": 'Today',
      "value": 'today'
    }, {
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];


    vm.catergorys = 'Allcatergory';

    vm.catergory = [{
      "name": 'All catergory',
      "value": 'Allcatergory'
    }, {
      "name": 'Vegetable',
      "value": 'last7days'
    }, {
      "name": 'Fruit',
      "value": 'last30days'
    }];
    vm.weekdays = [{
      "name": 'All',
      "value": 'today'
    }, {
      "name": 'Sun',
      "value": 'last7days'
    }, {
      "name": 'Mon',
      "value": 'last30days'
    }, {
      "name": 'Tue',
      "value": 'last7days'
    }, {
      "name": 'Wed',
      "value": 'last30days'
    }, {
      "name": 'Thu',
      "value": 'last30days'
    }, {
      "name": 'Fri',
      "value": 'last7days'
    }, {
      "name": 'Sat',
      "value": 'last30days'
    }];


    vm.vendor = [{
      "name": 'Today',
      "price": 'today',
      "perc": '10'
    }, {
      "name": 'Last 7 days',
      "price": 'last7days',
      "perc": '10'
    }, {
      "name": 'Last 30 days',
      "price": 'last30days',
      "perc": '10'
    }, {
      "name": 'Last 90 days',
      "price": 'last90days',
      "perc": '10'
    }, {
      "name": 'Last ere days',
      "price": 'last180days',
      "perc": '10'
    }, {
      "name": 'Today 2',
      "price": 'today 2 ',
      "perc": '10'
    }, {
      "name": 'Last 7 days 2',
      "price": 'last7days',
      "perc": '10'
    }, {
      "name": 'Last 30 days',
      "price": 'last30days',
      "perc": '10'
    }, {
      "name": 'Last 90 days',
      "price": 'last90days',
      "perc": '10'
    }, {
      "name": 'Last retre days',
      "price": 'last180days',
      "perc": '10'
    }, {
      "name": 'Last 90 days',
      "price": 'last90days',
      "perc": '10'
    }, {
      "name": 'Last 180 days',
      "price": 'last180days',
      "perc": '10'
    }];

    /*
    Active menu weekdays */
    $scope.activeMenu = vm.weekdays[0];

    $scope.setActive = function(menuItem) {
      $scope.activeMenu = menuItem
    }
    $scope.tadx = 'res';
 /*==========================================================================
                                      Store db in gdrive
     ========================================================================== */
     //assign interconnection true or false
    $scope.internetconnection = $rootScope.online; // if online
    $scope.uploadDBTime = branch_data[0].uploadDBTime; // last uploaded time
    var differenceTime = moment(new Date()).diff($scope.uploadDBTime, 'minutes'); // current time and last upload time difference in minutes
    $scope.branch_id = $rootScope.user[0].branch_id;
    // condition 1. permission 2. interval time 3. internet connection
    if($scope.uploaddb == "data" & (differenceTime > vm.dbstorage.intervalTime) & $scope.internetconnection) { 
        api.gdrive.getID.get({ folderID: vm.dbstorage.folderID, uploadPath: vm.dbstorage.uploadpath },
          function(response) {
            // last upload time update in branch table
            var dateq = moment(new Date()).format('MMM DD, YYYY, h:mm:ss a');
            var addBranch = [{
              'uploadDBTime': dateq
            }];

            api.update_branch_data.getID.update({ branch_id: $scope.branch_id }, addBranch,
              function(response) {
                $mdToast.show({
                  template: '<md-toast class="success"><span flex>Synced Data Successfully</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });
              });
         
          },
          // Error
          function(response) {
            //$scope.load = false;
           // $scope.errorUpload = true;
            $mdToast.show({
              template: '<md-toast class="info"><span flex>Please check your internet connection to sync the data.</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        );
      }

    /*==========================================================================
                         Pos Bill analytics
    ========================================================================== */

    //permission for cashier in view of analytics
    var salesbillss = [];
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 1) || permissions[i] == 1) {
        salesbillss.push("data");
      }
    }

    if (salesbillss.length > 0) {
      var admin = ''
      $scope.cashier_analytics_permission = true // if true means permission will be applied
    }

    $scope.todayDrop = false;
    $scope.changeDate = changeDate;
    //function for change date for show data depending on date
    function changeDate(dropdownfilter, staff, myDate, toDates,pos, d) {
       $scope.load = true;
       $scope.todayDrop = true;
      cashier_analytics(dropdownfilter, myDate, toDates,staff, pos) // callback funtion
     

    }

    $scope.newdate = function(d) {
      $scope.newdate_data = d
    }

    $scope.pos = 'pos';
    $scope.overviewpos = 'overviewpos'
    $scope.expenses = 'expenses';
    $scope.overviewexpense = 'overviewexpense';
    $scope.purchaseexpense = 'purchaseexpense';
    $scope.overviewpurchaseexpense = 'overviewpurchaseexpense';
    $scope.odcs = 'odc';
    $scope.overviewodc = 'overviewodc';
    $scope.monthdata = 'month';
    $scope.monthyear = 1;
    //service for today's  date of cashier anaytic data from server
    function cashier_analytics(dropdownfilter, myDate, toDates, staff, pos) {
      //dbstring = myDate;
     if(dropdownfilter == undefined) {
          // Init default value
          var dbstring = new Date();
          var dd = dbstring.getDate();
          var mm = dbstring.getMonth() + 1;
          var yyyy = dbstring.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }
  
          if (mm < 10) {
            mm = '0' + mm;
          }
          dbstring = yyyy + '-' + mm + '-' + dd;
          var toDate = 'month';
          var month = 'month';
          var year = 'month';
      }   
      else if(dropdownfilter == 'overviewpos') {
        dbstring = myDate;
        var toDate = 'month';
        var month = 'month';
        var year = 'month';
        
      }        
      else if(dropdownfilter == 'Default') {
        // Default filter touched
        dbstring = myDate;
        var toDate = 'month';
        var month = 'month';
        var year = 'month';
      }
      else if(dropdownfilter == 'Date') {
        var dbstring = new Date(myDate);
        var dd = dbstring.getDate();
        var mm = dbstring.getMonth() + 1;
        var yyyy = dbstring.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        dbstring = yyyy + '-' + mm + '-' + dd;
        var toDate = 'month';
        var month = 'month';
        var year = 'month';
      } 
      else if(dropdownfilter == 'Month') {
        var dbstring = new Date(myDate);
        var dd = dbstring.getDate();
        var mm = dbstring.getMonth() + 1;
        var yyyy = dbstring.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        dbstring = yyyy + '-' + mm + '-' + dd;
        var toDate = 'month';
        var month = new Date(myDate).getMonth() + 1;
        var year = new Date(myDate).getFullYear();
      }
      else if(dropdownfilter == 'Period') {
        //from date
        var dbstring = new Date(myDate);
          var dd = dbstring.getDate();
          var mm = dbstring.getMonth() + 1;
          var yyyy = dbstring.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }
  
          if (mm < 10) {
            mm = '0' + mm;
          }
          dbstring = yyyy + '-' + mm + '-' + dd;
// todate
          var todbstring = new Date(toDates);
          var todd = todbstring.getDate();
          var tomm = todbstring.getMonth() + 1;
          var toyyyy = todbstring.getFullYear();
          if (todd < 10) {
            todd = '0' + todd;
          }
  
          if (tomm < 10) {
            tomm = '0' + tomm;
          }
          toDate = toyyyy + '-' + tomm + '-' + todd;
        var month = 'month';
        var year = 'month';    
      }
      var staffID = staff == undefined ? 'admin' : staff;
      var admin_permission = $cookies.get('admin');

      api.dashboard_analytics_date.getID.get({ date: dbstring, toDate: toDate, staffID: staffID, branch_id: $rootScope.user[0].branch_id, month : month, year: year },
        function(response) {

          console.log(response);
          // dropdown who has pos permission list in dropdown
          $scope.pos_staff = staffRole.filter(function(o1) {
            return sales_order_data.some(function(o2) {
              return (o1.staffID == o2.staffID && o1.status == 'active' && o2.sales_dietType != 'ODC' && o1.branch_id == o2.branch_id)
            })
          });
          /*-----------------------------------
          Today task filterning for pos bills
          ------------------------------------------*/
          $scope.pos_today_delivery = []
          sales_order_data.filter(function(a) {
            if (new Date(a.sales_deliveryDate).toDateString() == new Date().toDateString() && a.branch_id == $rootScope.user[0].branch_id && a.sales_dietType != 'ODC' && a.sales_dietType != 'dinein' && a.sales_deliveryStatus != 'Immediate') {
              $scope.pos_today_delivery.push(a)
            }
            return
          });

          vm.staffRole = staff_all.concat($scope.pos_staff);

          $scope.posbill_query = {
            filter: '',
            limit: '10',
            order: 'count',
            page: 1
          };

          $scope.takenorder_query = {
            filter: '',
            limit: '10',
            countorder: 'total',
            order: 'orderTakenCount',
            page: 1
          };
          //get sales items and filter no sales items to merge data and show it in today hot sales
          var filter_postdata = fmitem_sale.filter(function(o1) {
            return !response[0].posbill_fulldata.some(function(o2) {
              return (o1.fmItemID == o2.fmItemID)
            })
          });
          $scope.posbillDailyData =response[0].posbill_fulldata;
          // assign no sales items 0 value
          var filter_postdatas = filter_postdata.map(function(o) {
            return { sales_items: o.fmItemName, count: 0, fmItemID: o.fmItemID, fmCatergoryID: o.fmCatergoryID, total: 0 }
          })

          $scope.posbill_data = filter_postdatas.concat(response[0].posbill_fulldata); //appy data to front end
          $scope.posbill_count = $scope.posbill_data.length; //md data table pagination length
          // all staffs ordertaken information
          var filter_ordertaken = response[0].ordertakenBy_fulldata.filter(function(o1) {
            return staffRole.some(function(o2) {
              return (o1.orderTakenID == o2.staffID && o2.status == 'active')
            })
          });

          $scope.ordertaken_details = filter_ordertaken; //appy data to front end
          $scope.ordertaken_length = $scope.ordertaken_details.length; //md data table pagination length
          $scope.thirdparty = response[0].thirdparty_fulldata; //appy data to front end
          $scope.thirdparty_length = $scope.thirdparty.length;

          if (pos == 'pos' || pos == undefined || pos == 'month') {
            //response for collect analytics data from the server -this is for when user land on this page then will be today data of analytics showed.
            $scope.total_cash = response[0].total_cash;
            $scope.total_card = response[0].total_card;
            $scope.orderedtotal_cash = response[0].orderedtotal_cash;
            $scope.orderedtotal_card = response[0].orderedtotal_card;
            $scope.dinein_amount = response[0].dinein_amount;
            $scope.takeaway_amount = response[0].takeaway_amount;
            $scope.doordelivery_amount = response[0].doordelivery_amount;
            $scope.total_profit_amount = response[0].total_profit_amount;

            $scope.dinein_total = response[0].dinein_total;
            $scope.takeaway_total = response[0].takeaway_total;
            $scope.doordelivery_total = response[0].doordelivery_total;
            $scope.onlinePaymentTypeAmount = response[0].onlinePaymentTypeAmount;
            var total = response[0].dinein_total + response[0].takeaway_total + response[0].doordelivery_total;
            $scope.dinein_percent = (response[0].dinein_total / total) * 100;
            $scope.takeaway_percent = (response[0].takeaway_total / total) * 100;
            $scope.tax_cgst = response[0].tax_cgst;
            $scope.tax_sgst = response[0].tax_sgst;
            $scope.doordelivery_percent = (response[0].doordelivery_total / total) * 100
            $scope.dinein_percent = (response[0].dinein_total / total) * 100;
            $scope.feedback = response[0];
            //FEEDBAK SERVICE PERCENT CALCULATION
            var service = $scope.feedback.Feedback_service[0].GREAT + $scope.feedback.Feedback_service[0].GOOD + $scope.feedback.Feedback_service[0].OK + $scope.feedback.Feedback_service[0].BAD + $scope.feedback.Feedback_service[0].POOR;
            $scope.feedback_service_GREAT = ($scope.feedback.Feedback_service[0].GREAT / service) * 100;
            $scope.feedback_service_GOOD = ($scope.feedback.Feedback_service[0].GOOD / service) * 100;
            $scope.feedback_service_OK = ($scope.feedback.Feedback_service[0].OK / service) * 100;
            $scope.feedback_service_BAD = ($scope.feedback.Feedback_service[0].BAD / service) * 100;
            $scope.feedback_service_POOR = ($scope.feedback.Feedback_service[0].POOR / service) * 100;
            $scope.feedback_Service_review = (5 * $scope.feedback.Feedback_service[0].GREAT + 4 * $scope.feedback.Feedback_service[0].GOOD + 3 * $scope.feedback.Feedback_service[0].OK + 2 * $scope.feedback.Feedback_service[0].BAD + 1 * $scope.feedback.Feedback_service[0].POOR) / service;

            //FEEDBAK STAFF PERCENT CALCULATION
            var staff = $scope.feedback.Feedback_staff[0].GREAT + $scope.feedback.Feedback_staff[0].GOOD + $scope.feedback.Feedback_staff[0].OK + $scope.feedback.Feedback_staff[0].BAD + $scope.feedback.Feedback_staff[0].POOR;
            $scope.feedback_staff_GREAT = ($scope.feedback.Feedback_staff[0].GREAT / service) * 100;
            $scope.feedback_staff_GOOD = ($scope.feedback.Feedback_staff[0].GOOD / service) * 100;
            $scope.feedback_staff_OK = ($scope.feedback.Feedback_staff[0].OK / service) * 100;
            $scope.feedback_staff_BAD = ($scope.feedback.Feedback_staff[0].BAD / service) * 100;
            $scope.feedback_staff_POOR = ($scope.feedback.Feedback_staff[0].POOR / service) * 100;
            $scope.feedback_staff_review = (5 * $scope.feedback.Feedback_staff[0].GREAT + 4 * $scope.feedback.Feedback_staff[0].GOOD + 3 * $scope.feedback.Feedback_staff[0].OK + 2 * $scope.feedback.Feedback_staff[0].BAD + 1 * $scope.feedback.Feedback_staff[0].POOR) / staff;


            //FEEDBAK FOOD PERCENT CALCULATION
            var food = $scope.feedback.Feedback_food[0].GREAT + $scope.feedback.Feedback_food[0].GOOD + $scope.feedback.Feedback_food[0].OK + $scope.feedback.Feedback_food[0].BAD + $scope.feedback.Feedback_food[0].POOR;
            $scope.feedback_food_GREAT = ($scope.feedback.Feedback_food[0].GREAT / service) * 100;
            $scope.feedback_food_GOOD = ($scope.feedback.Feedback_food[0].GOOD / service) * 100;
            $scope.feedback_food_OK = ($scope.feedback.Feedback_food[0].OK / service) * 100;
            $scope.feedback_food_BAD = ($scope.feedback.Feedback_food[0].BAD / service) * 100;
            $scope.feedback_food_POOR = ($scope.feedback.Feedback_food[0].POOR / service) * 100;
            $scope.feedback_food_review = (5 * $scope.feedback.Feedback_food[0].GREAT + 4 * $scope.feedback.Feedback_food[0].GOOD + 3 * $scope.feedback.Feedback_food[0].OK + 2 * $scope.feedback.Feedback_food[0].BAD + 1 * $scope.feedback.Feedback_food[0].POOR) / food;


            //FEEDBAK MONEY PERCENT CALCULATION
            var money = $scope.feedback.Feedback_money[0].GREAT + $scope.feedback.Feedback_money[0].GOOD + $scope.feedback.Feedback_money[0].OK + $scope.feedback.Feedback_money[0].BAD + $scope.feedback.Feedback_money[0].POOR;
            $scope.feedback_money_GREAT = ($scope.feedback.Feedback_money[0].GREAT / service) * 100;
            $scope.feedback_money_GOOD = ($scope.feedback.Feedback_money[0].GOOD / service) * 100;
            $scope.feedback_money_OK = ($scope.feedback.Feedback_money[0].OK / service) * 100;
            $scope.feedback_money_BAD = ($scope.feedback.Feedback_money[0].BAD / service) * 100;
            $scope.feedback_money_POOR = ($scope.feedback.Feedback_money[0].POOR / service) * 100;
            $scope.feedback_money_review = (5 * $scope.feedback.Feedback_money[0].GREAT + 4 * $scope.feedback.Feedback_money[0].GOOD + 3 * $scope.feedback.Feedback_money[0].OK + 2 * $scope.feedback.Feedback_money[0].BAD + 1 * $scope.feedback.Feedback_money[0].POOR) / money;


          }

          if (pos == 'overviewpos' || pos == undefined) {
            $scope.overviewtax_cgst = response[0].tax_cgst;
            $scope.overviewtax_sgst = response[0].tax_sgst;
            $scope.overview_posOrder_count = response[0].total_posOrder;
            //$scope.overview_posTotal = response[0].total_cash + response[0].total_card + response[0].orderedtotal_cash + response[0].orderedtotal_card;
            $scope.overview_posTotal = response[0].dinein_amount + response[0].doordelivery_amount + response[0].doordelivery_total;
            $scope.overview_posPaid_count = response[0].dinein_total + response[0].takeaway_total + response[0].doordelivery_total;
            var overview_order_current = $scope.overview_posOrder_count + $scope.overview_posPaid_count;
            $scope.overview_paidTotal_percent = ($scope.overview_posOrder_count / overview_order_current) * 100;
            $scope.overview_posTotal_percent = ($scope.overview_posPaid_count / overview_order_current) * 100;
          }

          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget6": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": $scope.total_cash + $scope.orderedtotal_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": $scope.total_card + $scope.orderedtotal_card //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget6 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            //ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget6.currentRange = range;
              angular.forEach(analytic_data.widget6.mainChart, function(data, index) {
                vm.widget6.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };
              });
            },
            init: function() {
              vm.widget6.changeRange('TW');
            }
          };

          // Initialize Widget 6
          vm.widget6.init();
          $scope.load = false;
          $scope.todayDrop = false;
        })

    }
    cashier_analytics(); //default load access inside of the function
    $scope.odcrestrict = 'LM';

    /*==========================================================================
                           ODC_analytics
    ========================================================================== */
    var oda_data = [];
    //permission for cashier in view of analytics
    var odcbills = [];
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 4) || permissions[i] == 4) {
        odcbills.push("data");
      }
      if (permissions[i] == 4) {
        oda_data.push("datas");
      }
    }

    $scope.odcLength = oda_data.length;
    if (oda_data.length > 0) {
      $scope.odc_analytics_permission = true // if true means permission will be applied
    }


    $scope.changeOdc = changeOdc;
    //function for change date for show data depending on date
    function changeOdc(myDate, staff, odc) {
      $scope.load = true
      odc_analytics(myDate, staff, odc) // callback funtion
     
    }


    //service for today's  date of cashier anaytic data from server
    function odc_analytics(myDate, staff, odc) {
      if (myDate == undefined) {
        var dbstring = 'today';
      } else {
        var dbstring = myDate;
      }
      var staffID = staff == undefined ? 'admin' : staff
      //tadx
      api.odc_analytics_data.getID.get({ date: dbstring, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          //if odc tab clicked this condition of data will returned
          if (odc == 'odc' || odc == undefined) {
            if (odc == undefined) {
              $scope.odcrestrict = 'LM';
            } else {
              $scope.odcrestrict = dbstring;
              $scope.staffdata = staffID;
            }
            $scope.Odctax_cgst = response[0].tax_cgst;
            $scope.Odctax_sgst = response[0].tax_sgst;
          }
          //if overviewodc tab clicked this condition of data will returned
          if (odc == 'overviewodc' || odc == undefined) {
            $scope.overview_restrict = dbstring;
            $scope.overviewodc_payment = response[0];
            $scope.overvie_wodcTax_cgst = response[0].tax_cgst;
            $scope.overviewodc_wodcTax_sgst = response[0].tax_sgst;
          }
          $scope.odc_payment = response[0];
          var food_ids = []
          //to filter data which remove duplicates in catergory id
          response[0].selectedNames.map(function(item) {
            if (food_ids.indexOf(item.odc_categoryID) === -1) {
              food_ids.push(item.odc_categoryID)

            }
          })
          var customer_details = response[0].selectedNames
          // Get category and prepare value to apply in donut chart
          var tagMap = response[0].selectedNames.reduce(function(map, tag) {
            var category_name = []
            for (var i = 0; i < vm.odc_categorys.length; i++) {
              if (vm.odc_categorys[i].value == tag.odc_categoryID)
                category_name.push(vm.odc_categorys[i].label)
            }
            map[tag.odc_categoryID] = { 'label': category_name[0], "values": { "TW": tag.values.TW }, "odc_categoryID": tag.odc_categoryID, "staffID": tag.staffID }
            return map // return callback
          }, {});


          // Quickly select names from the map:
          var selectedCategories = food_ids.map(function(id) {
            return tagMap[id] //pass id to another function
          });
          /*-----------------------------------
            filter staffs who have odc permissions
            ------------------------------------------*/
          $scope.odc_staff = staffRole.filter(function(o1) {
            return sales_order_data.some(function(o2) {
              return (o1.staffID == o2.staffID && o1.status == 'active' && o2.sales_dietType == 'ODC' && o1.branch_id == o2.branch_id)
            })
          })
          vm.odc_staffs = staff_all.concat($scope.odc_staff);

          var odc_piechart_Data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget6": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": selectedCategories

            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget66 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            //ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget66.currentRange = range;
              angular.forEach(odc_piechart_Data.widget6.mainChart, function(data, index) {
                vm.widget66.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };
              });
            },
            init: function() {
              vm.widget66.changeRange('TW');
            }
          };

          // Initialize Widget 6
          vm.widget66.init();
          $scope.load = false;
        })

    }
    odc_analytics();



    /*==========================================================================
                           expense_analytics
    ========================================================================== */

    //permission for cashier in view of analytics
    var expensebillss = []

    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 2) || permissions[i] == 2) {
        expensebillss.push("data");
      }
    }

    if (expensebillss.length > 0) {
      $scope.expense_analytics_permission = true // if true means permission will be applied
    }


    //expense expense_schedule data
    $scope.expense_types = [{
      "name": 'General Expense',
      "value": 'GE'
    }, {
      "name": 'RawMaterial Expense',
      "value": 'RE'
    }, {
      "name": 'SaleMaterial Expenses',
      "value": 'SE'
    }];



    //expense expense_schedule data
    $scope.expense_schedule = [{
      "name": 'Today',
      "value": 'today'
    }, {
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];




    //permission for expense in view of analytics
    var expensebillss = [];


    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 2) || permissions[i] == 2) {
        expensebillss.push("data");
      }
    }

    if (expensebillss.length > 0) {
      $scope.expense_analytics_permission = true // if true means permission will be applied
    }


    $rootScope.user = $cookies.getObject('user'); //get object of logged in user data from the cookies

    $scope.newdates = function(d) {
      $scope.newdate_datas = d
    }

    $scope.expenseChange = expenseChange;
    //function for change date for show data depending on date
    function expenseChange(staff, expense, expenses, id) {
      $scope.load = true
      expense_analytics(expense, staff, expenses) // callback funtion
    }

    //service for today's  date of expense anaytic data from server
    function expense_analytics(expense, staff, expenses) {
      if (expense == undefined) {
        // Default init value
        var expense_change = new Date();
        var dd = expense_change.getDate();
        var mm = expense_change.getMonth() + 1;
        var yyyy = expense_change.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        expense_change = yyyy + '-' + mm + '-' + dd;
      }
      // If change
      else if (expense == 'today' || expense == 'LW' || expense == 'LM' || expense == '3MA' || expense == '6MA') {
        var expense_change = expense

      }
      // If change
      else {
        var expense_change = new Date(expense);
        var dd = expense_change.getDate();
        var mm = expense_change.getMonth() + 1;
        var yyyy = expense_change.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        expense_change = yyyy + '-' + mm + '-' + dd;

      }

      var staffID = staff == undefined ? 'admin' : staff

      api.expense_analytics.getID.get({ date: expense_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          /*-----------------------------------
          filter staffs who have expense permissions
          ------------------------------------------*/
          $scope.expense_staff = staffRole.filter(function(o1) {
            return expense_bill_data.some(function(o2) {
              return (o1.staffID == o2.staffID && o1.status == 'active' && o1.branch_id == o2.branch_id)
            })
          })
          vm.expense_staffs = staff_all.concat($scope.expense_staff);
          /*-----------------------------------
          Today task filterning for expense bills
          ------------------------------------------*/
          $scope.expense_today_delivery = [] //&& a.ordertime < new Date()
          expense_bill_data.filter(function(a) {
            if (new Date(a.created_on).toDateString() == new Date().toDateString() && a.branch_id == $rootScope.user[0].branch_id) {
              $scope.expense_today_delivery.push(a)
            }
            return
          });
          //if expense tab clicked this will returned
          if (expenses == 'expenses' || expenses == undefined) {
            //response for collect analytics data from the server -this is for when user land on this page then will be today data of analytics showed.
            $scope.expensetax = response[0].taxCgst_info + response[0].taxSgst_info;
            $scope.expensetaxCgst = response[0].taxCgst_info;
            $scope.expensetaxSgst = response[0].taxSgst_info;
            $scope.total_paid = response[0].total_paid + response[0].advance_paid;
            $scope.total_balance = response[0].total_balance;
            var paid_cash = response[0].paid_cash + response[0].advancepaid_cash;
            var paid_card = response[0].paid_card + response[0].advancepaid_card;
            var paid_cheque = response[0].paid_cheque + response[0].advancepaid_cheque;
            var paid_online = response[0].paid_online + response[0].advancepaid_online;
          }
          //if overviewexpense tab clicked this will returned
          if (expenses == 'overviewexpense' || expenses == undefined) {
            $scope.overview_expenseTotal = response[0].total_paid + response[0].advance_paid + response[0].total_balance;
            $scope.overview_expensetax = response[0].taxCgst_info + response[0].taxSgst_info;
          }



          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": paid_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_card //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Cheque",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_cheque //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Online Transcation",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_online //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget7 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget7.currentRange = range;

              angular.forEach(analytic_data.widget7.mainChart, function(data, index) {
                vm.widget7.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget7.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget7.init();


          var odc_data = {
            "ranges": {
              "TW": "This Week",
              "LW": "Last Week",
              "2W": "2 Weeks Ago"
            },
            "mainChart": [{
              // "key": response[0].total_categories.key,
              "values": {
                "2W": [
                  { "x": "Mon", "y": 9 },
                  { "x": "Tue", "y": 12 },
                  { "x": "Wed", "y": 9 },
                  { "x": "Thu", "y": 12 },
                  { "x": "Fri", "y": 7 },
                  { "x": "Sat", "y": 8 },
                  { "x": "Sun", "y": 16 }
                ],
                "LW": [
                  { "x": "Mon", "y": 12 },
                  { "x": "Tue", "y": 8 },
                  { "x": "Wed", "y": 7 },
                  { "x": "Thu", "y": 13 },
                  { "x": "Fri", "y": 7 },
                  { "x": "Sat", "y": 6 },
                  { "x": "Sun", "y": 10 }
                ],
                "TW": response[0].total_categories
              }
            }]
          }


          // Widget 5
          vm.widget5 = {
            //title       : vm.dashboardData.widget5.title,
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'multiBarChart',
                  color: ['#03a9f4', '#b3e5fc'],
                  height: 420,
                  margin: {
                    top: 8,
                    right: 16,
                    bottom: 32,
                    left: 32
                  },
                  clipEdge: true,
                  groupSpacing: 0.3,
                  reduceXTicks: false,
                  stacked: true,
                  duration: 250,
                  x: function(d) {
                    return d.x;
                  },
                  y: function(d) {
                    return d.y;
                  },
                  yAxis: {
                    tickFormat: function(d) {
                      return d;
                    }
                  },
                  legend: {
                    margin: {
                      top: 8,
                      bottom: 32
                    }
                  },
                  controls: {
                    margin: {
                      top: 8,
                      bottom: 32
                    }
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },

            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: odc_data.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget5.currentRange = range;


              angular.forEach(odc_data.mainChart, function(chartData, index) {
                vm.widget5.mainChart.data[index] = {
                  key: chartData.key,
                  values: chartData.values[range]
                };
              });


            },
            init: function() {

              vm.widget5.changeRange('TW');
            }
          };
          vm.widget5.init();
          $scope.load = false;
          $scope.expense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.expense_query_count = response[0].total_results.length; //md-data table pagination length
          $scope.expense_data = response[0].total_results; //apply data to front end

        })

    }
    expense_analytics(); //default call access inside of the function



    /*==========================================================================
                               inventory food and beverage analytics
       ========================================================================== */


    //expense expense_schedule data
    $scope.inventory_schedules = [{
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];


    //permission for cashier in view of analytics
    var inventorybillss = [];

    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 3) || permissions[i] == 3) {
        inventorybillss.push("data");
      }
    }

    if (inventorybillss.length > 0) {
      $scope.inventory_analytics_permission = true // if true means permission will be applied
    }

    //expense expense_schedule data
    $scope.inventory_schedule = [{
      "name": 'All Days',
      "value": 'AD'
    }, {
      "name": 'Sunday',
      "value": 'SUY'
    }, {
      "name": 'Monday',
      "value": '3MA'
    }, {
      "name": 'Tuesday',
      "value": 'TUY'
    }, {
      "name": 'Wednesday',
      "value": 'WY'
    }, {
      "name": 'Thursday',
      "value": 'THY'
    }, {
      "name": 'Friday',
      "value": 'FY'
    }, {
      "name": 'Saturday',
      "value": 'SAY'
    }];

    vm.weekdays = [{
      "name": 'All',
      "value": 'today'
    }, {
      "name": 'Sun',
      "value": 'last7days'
    }, {
      "name": 'Mon',
      "value": 'last30days'
    }, {
      "name": 'Tue',
      "value": 'last7days'
    }, {
      "name": 'Wed',
      "value": 'last30days'
    }, {
      "name": 'Thu',
      "value": 'last30days'
    }, {
      "name": 'Fri',
      "value": 'last7days'
    }, {
      "name": 'Sat',
      "value": 'last30days'
    }];


    //select box data for catagory filter in food items
    var All_category_items = [{ fmCatergoryID: "All", fmCatergoryName: "All Catergory" }]
    var fmdata = fmCategory.map(function(fm) {
      return { 'fmCatergoryID': fm.fmCatergoryID, 'fmCatergoryName': fm.fmCatergoryName, 'branch_id': fm.branch_id }
    })
    //select box data for caegory filter in raw items
    var All_sale_category_items = [{ smCatergoryID: "All", smCatergoryName: "All Catergory" }]

    var smdatas = siCategory.map(function(sm) {
      return { 'fmCatergoryID': sm.siCatergoryID, 'fmCatergoryName': sm.siCatergoryName, 'branch_id': sm.branch_id }
    })

    var fulldata = fmdata.concat(smdatas);
    var fulldatas = fulldata.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    vm.fmCategory = All_category_items.concat(fulldatas);


    //md data table default values.
    $scope.inventory_food = {
      filter: '',
      limit: '10',
      order: 'total',
      page: 1
    };

    //function for dropdown filter in food items
    $scope.getFood_items = function(stu) {
      $scope.food_load = true
      var food = $rootScope.food_Data
      var foodID = stu;
      if (stu == "All") {
        $scope.food_beverage = $rootScope.food_Data
        $scope.inventory_food_count = $rootScope.food_Data.length;
        $timeout(function() {
          $scope.food_load = false
        }, 500);
        return;
      }

      var food_Datas = [];
      for (var i = 0; i < food.length; i++) {
        if (food[i].fmCatergoryID == foodID) {
          food_Datas.push(food[i]);
          $scope.inventory_food_count = food_Datas.length;
          $scope.food_beverage = food_Datas;
          continue;
          return;

        }
      }

      $timeout(function() {
        $scope.food_load = false
      }, 500);


    };

    $scope.inventoryChange = inventoryChange;
    //function for change date for show data depending on date
    function inventoryChange(weekdays, inventory, staff, id) {
      $scope.inventory_foodRaw_load = true;

      inventory_analytics(inventory, weekdays, staff) // callback funtion
      $scope.dayset = weekdays;
      $timeout(function() {
        $scope.inventory_foodRaw_load = false
      }, 500);
      

    }
    $scope.activeMenu = vm.weekdays[0];
    $scope.setActive = function(menuItem) {
      $scope.weekday_load = true
      $scope.activeMenu = menuItem
      $timeout(function() {
        $scope.weekday_load = false
      }, 500);
    }


    //service for today's  date of expense anaytic data from server
    function inventory_analytics(inventory, weekdays, staff) {
      $scope.inventory_foodRaw_load = true
      if (weekdays == undefined) {
        var weekday = "All"
      } else {
        var weekday = weekdays
      }
      if (inventory == undefined) {
        var inventory_change = "LM"
      } else {
        var inventory_change = inventory
      }

      var staffID = staff == undefined ? 'admin' : staff
      api.inventory_analytics.getID.get({ weekday: weekday, date: inventory_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },

        function(response) {
          $scope.inventory_food = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.inventory_food_count = response.length; //md-data table pagination count
          $scope.food_beverage = response; //appy data to front end
          $rootScope.food_Data = response;
          $timeout(function() {
            $scope.inventory_foodRaw_load = false
          }, 500);
        })

    }
    inventory_analytics(); //default access inside of the function


    /*==========================================================================
                              inventory raw material analytics ex. ordered qty, price
      ============================================================================== */
    /*-----------------------------------
       today task of raw material for delivery date
       ------------------------------------------*/
    $scope.inventoryRaw_today_delivery = []
    rawmaterial_bill_data.filter(function(a) {
      if (new Date(a.DeliveryDate).toDateString() == new Date().toDateString() && a.branch_id == $rootScope.user[0].branch_id) {
        $scope.inventoryRaw_today_delivery.push(a)
      }
      return
    });

    //select box data for caegory filter in raw items
    var All_raw_category_items = [{ rmCatergoryID: "All", rmCatergoryName: "All Catergory" }]
    //filter raw material category for branch wise
    var rmcategorydatas = rmcategorydata.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    var rmdata = rmcategorydatas.map(function(rm) {
      return { 'rmCatergoryID': rm.rmCatergoryID, 'rmCatergoryName': rm.rmCatergoryName }
    })

    vm.rmCategory = All_raw_category_items.concat(rmdata);
    //filter staffs who have permissions of inventory raw material
    $scope.purchae_rawmaterial_staff = staffRole.filter(function(o1) {
      return rawmaterial_bill_data.some(function(o2) {
        return (o1.staffID == o2.staffID && o1.status == 'active' && o1.branch_id == o2.branch_id)
      })
    })
    //filter staffs who have permissions of inventory sale material
    $scope.purchae_salematerial_staff = staffRole.filter(function(o1) {
      return salematerial_bill_data.some(function(o2) {
        return (o1.staffID == o2.staffID && o1.status == 'active' && o1.branch_id == o2.branch_id)
      })
    })
    //merge all both purchase raw material and sale material staffs for dropdown
    vm.inventory_staffs = staff_all.concat($scope.purchae_rawmaterial_staff).concat($scope.purchae_salematerial_staff);

    $scope.rawmaterial_query = {
      filter: '',
      limit: '10',
      order: 'total',
      page: 1
    };
    //function for dropdown filter in raw items

    $scope.getRaw_items = function(stu) {
      $scope.raw_load = true
      var rawmaterial = $rootScope.raw_Data
      var rmID = stu;
      if (stu == "All") {
        $scope.raw_data = $rootScope.raw_Data
        $scope.rawmaterial_count = $rootScope.raw_Data.length;
        $timeout(function() {
          $scope.raw_load = false
        }, 500);

        return;
      }

      var rawmaterial_datas = [];
      for (var i = 0; i < rawmaterial.length; i++) {
        if (rawmaterial[i].rmCatergoryID == rmID) {
          rawmaterial_datas.push(rawmaterial[i]);
          $scope.rawmaterial_count = rawmaterial_datas.length;
          $scope.raw_data = rawmaterial_datas;
          continue;
          return;

        }
      }
      $timeout(function() {
        $scope.raw_load = false
      }, 500);

    };


    $scope.rawmaterialChange = rawmaterialChange;
    //function for change date for show data depending on date
    function rawmaterialChange(rawmaterial, staff, id) {
      $scope.load = true
      rawmaterial_analytics(rawmaterial, staff) // callback funtion
    }


    //service for today's  date of expense anaytic data from server
    function rawmaterial_analytics(rawmaterial, staff) {
      if (rawmaterial == undefined) {
        var rawmaterial_change = "LM"
      } else {
        var rawmaterial_change = rawmaterial
      }
      var staffID = staff == undefined ? 'admin' : staff
      api.rawmaterial_analytics.getID.get({ date: rawmaterial_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.rawmaterial_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.rawmaterial_count = response.length; //md data table pagination count
          $rootScope.raw_Data = response; //apply all data when clicked all catefories
          $scope.raw_data = response; //apply data to front end

        })
        $scope.load = false;
    }
    rawmaterial_analytics(); //default load to access funtion


    /*==========================================================================
                               inventory_ salematerial_analytics ex. ordered qty, price
      ============================================================================== */

    /*-----------------------------------
     today task of sale material for delivery date
     ------------------------------------------*/
    $scope.inventorySale_today_delivery = []
    salematerial_bill_data.filter(function(a) {
      if (new Date(a.DeliveryDate).toDateString() == new Date().toDateString() && a.staffID == $rootScope.user[0].staffID && a.branch_id == $rootScope.user[0].branch_id) {
        $scope.inventorySale_today_delivery.push(a)
      }
      return
    });


    //select box data for caegory filter in raw items
    var All_sale_category_items = [{ smCatergoryID: "All", smCatergoryName: "All Catergory" }]
    //filter sale material categories for branch wise
    var siCategorys = siCategory.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })
    var smdata = siCategorys.map(function(sm) {
      return { 'smCatergoryID': sm.siCatergoryID, 'smCatergoryName': sm.siCatergoryName }
    })
    //concat all and filter category
    vm.smCategory = All_sale_category_items.concat(smdata);


    $scope.salematerial_query = {
      filter: '',
      limit: '10',
      order: 'total',
      page: 1
    };
    //function for dropdown filter in raw items

    $scope.getSale_items = function(stu) {
      $scope.sale_load = true
      var salematerial = $rootScope.sale_Data
      var smID = stu;
      if (stu == "All") {
        $scope.sale_data = $rootScope.sale_Data
        $scope.salematerial_count = $rootScope.sale_Data.length;
        $timeout(function() {
          $scope.sale_load = false
        }, 500);

        return;
      }

      var salematerial_datas = [];
      for (var i = 0; i < salematerial.length; i++) {
        if (salematerial[i].smCatergoryID == smID) {
          salematerial_datas.push(salematerial[i]);
          $scope.salematerial_count = salematerial_datas.length; //md-data table pagination
          $scope.sale_data = salematerial_datas; //apply full data 
          continue;
          return;

        }
      }
      $timeout(function() {
        $scope.sale_load = false //pre load hide
      }, 500);

    };


    $scope.salematerialChange = salematerialChange;
    //function for change date for show data depending on date
    function salematerialChange(salematerial, staff, id) {
      $scope.load = true
      salematerial_analytics(salematerial, staff) // callback funtion
    }


    //service for today's  date of expense anaytic data from server
    function salematerial_analytics(salematerial, staff) {
      if (salematerial == undefined) {
        var salematerial_change = "LM"
      } else {
        var salematerial_change = salematerial
      }

      var staffID = staff == undefined ? 'admin' : staff
      api.salematerial_analytics.getID.get({ date: salematerial_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.salematerial_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.salematerial_count = response.length; //md-data table pagination length
          $rootScope.sale_Data = response; //apply data when click all category
          $scope.sale_data = response; //apply data to front end

        })
        $scope.load = false;
    }
    salematerial_analytics();

    /*==========================================================================
                      Purchase raw material payment analytics
        ==========================================================================*/

    $scope.purchaseexpenseChange = purchaseexpenseChange;
    //function for change date for show data depending on date
    function purchaseexpenseChange(date, staff, id) {
      $scope.load = true
      purchaseexpense_analytics(date, staff) // callback funtion
    }

    //service for today's  date of expense anaytic data from server
    function purchaseexpense_analytics(date, staff) {
      var date_change = date == undefined ? 'LM' : date
      var staffID = staff == undefined ? 'admin' : staff

      api.purchaseexpense_analytics.getID.get({ date: date_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.purchasetax = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.purchasetaxCgst = response[0].taxCgst_info;
          $scope.purchasetaxSgst = response[0].taxSgst_info;
          $scope.purchasetotal_paid = response[0].total_paid + response[0].advance_paid;
          $scope.purchasetotal_balance = response[0].total_balance;

          var paid_cash = response[0].paid_cash + response[0].advancepaid_cash;
          var paid_card = response[0].paid_card + response[0].advancepaid_card;
          var paid_cheque = response[0].paid_cheque + response[0].advancepaid_cheque;
          var paid_online = response[0].paid_online + response[0].advancepaid_online;

          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": paid_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_card //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Cheque",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_cheque //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Online Transcation",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_online //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget34 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget34.currentRange = range;

              angular.forEach(analytic_data.widget7.mainChart, function(data, index) {
                vm.widget34.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget34.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget34.init();
          $scope.load = false;

          $scope.purchaseexpense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.purchaseexpense_query_count = response[0].total_results.length; //md-data table pagination length
          $scope.purchaseexpense_data = response[0].total_results; //apply data to front end

        })



    }
    purchaseexpense_analytics(); //default load access to function

    // overview 

    $scope.overviewpurchaseexpenseChange = overviewpurchaseexpenseChange;
    //function for change date for show data depending on date
    function overviewpurchaseexpenseChange(date, staff, id) {

      $scope.load = true
      overviewpurchaseexpense_analytics(date, staff) // callback funtion
    }

    //service for today's  date of expense anaytic data from server
    function overviewpurchaseexpense_analytics(date, staff) {

      var date_change = date == undefined ? 'today' : date
      var staffID = staff == undefined ? 'admin' : staff

      api.purchaseexpense_analytics.getID.get({ date: date_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          
            $scope.overviewpurchasetax = response[0].taxCgst_info + response[0].taxSgst_info;
            $scope.overviewpurchasetotal_paid = response[0].total_paid + response[0].advance_paid;
            $scope.overviewpurchasetotal_balance = response[0].total_balance;


    

          $scope.purchaseexpense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.purchaseexpense_query_count = response[0].total_results.length; //md-data table pagination length
          $scope.purchaseexpense_data = response[0].total_results; //apply data to front end

        })
        $scope.load = false


    }
    overviewpurchaseexpense_analytics(); //default load access to function


    /*==========================================================================
                      Purchase sale material payment analytics
    ========================================================================== */
    $scope.SalesexpenseChange = SalesexpenseChange;
    //function for change date for show data depending on date
    function SalesexpenseChange(date, staff, id) {
      $scope.load = true
      salesExpense_analytics(date, staff) // callback funtion
      $timeout(function() {
        $scope.load = false
      }, 500);

    }

    //service for today's  date of expense anaytic data from server
    function salesExpense_analytics(date, staff) {
      var date_change = date == undefined ? 'LM' : date
      var purchaseexpense ='purchaseexpense';
      var staffID = staff == undefined ? 'admin' : staff
      api.salesexpense_analytics.getID.get({ date: date_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.salestax = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.salestaxCgst = response[0].taxCgst_info;
          $scope.salestaxSgst = response[0].taxSgst_info;
          $scope.saletotal_paid = response[0].total_paid + response[0].advance_paid;
          $scope.saletotal_balance = response[0].total_balance;       

          var paid_cash = response[0].paid_cash + response[0].advancepaid_cash;
          var paid_card = response[0].paid_card + response[0].advancepaid_card;
          var paid_cheque = response[0].paid_cheque + response[0].advancepaid_cheque;
          var paid_online = response[0].paid_online + response[0].advancepaid_online;

          var analytic_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Cash",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": paid_cash //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Card",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_card //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Cheque",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_cheque //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Online Transcation",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": paid_online //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget78 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget78.currentRange = range;

              angular.forEach(analytic_data.widget7.mainChart, function(data, index) {
                vm.widget78.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget78.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget78.init();
          $scope.saleexpense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.saleexpense_query_count = response[0].total_results.length; //md pagination length
          $scope.saleexpense_data = response[0].total_results; //apply data to front end

        })
    }
    salesExpense_analytics(); //default load to Access funtion

    // overview analytics

    $scope.OverviewSalesexpenseChange = OverviewSalesexpenseChange;
    //function for change date for show data depending on date
    function OverviewSalesexpenseChange(date, staff, id) {
      $scope.load = true
      overviewsalesExpense_analytics(date, staff) // callback funtion
    }

    //service for today's  date of expense anaytic data from server
    function overviewsalesExpense_analytics(date, staff) {
      var date_change = date == undefined ? 'today' : date
      var purchaseexpense ='purchaseexpense';
      var staffID = staff == undefined ? 'admin' : staff
      api.salesexpense_analytics.getID.get({ date: date_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.overviewsalestax = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.overviewsalestaxCgst = response[0].taxCgst_info;
          $scope.overviewsalestaxSgst = response[0].taxSgst_info;
          $scope.overviewsaletotal_paid = response[0].total_paid + response[0].advance_paid;
          $scope.overviewsaletotal_balance = response[0].total_balance;       

 
          $scope.saleexpense_query = {
            filter: '',
            limit: '10',
            order: 'total',
            page: 1
          };
          $scope.saleexpense_query_count = response[0].total_results.length; //md pagination length
          $scope.saleexpense_data = response[0].total_results; //apply data to front end
          $scope.load = false
        })
    }
    overviewsalesExpense_analytics(); //default load to Access funtion

    /*==========================================================================
                      SMS Marketing
      ========================================================================== */
    vm.sms_date = [{
      "name": 'Today',
      "value": 'today'
    }, {
      "name": 'Last 7 days',
      "value": 'LW'
    }, {
      "name": 'Last 30 days',
      "value": 'LM'
    }, {
      "name": 'Last 90 days',
      "value": '3MA'
    }, {
      "name": 'Last 180 days',
      "value": '6MA'
    }];

    //permission for cashier in view of analytics
    var sms = []

    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
    for (var i = 0; i < permissions.length; i++) {
      if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 52) || permissions[i] == 52) {
        sms.push("data");
      }
    }


    if (sms.length > 0) {
      $scope.sms = true // if true means permission will be applied
    }

    $scope.SmsChange = SmsChange;
    //function for change date for show data depending on date
    function SmsChange(sms, staff, id) {
      $scope.inventory_foodSms_load = true
      sms_analytics(sms, staff) // callback funtion

      $timeout(function() {
        $scope.inventory_foodSms_load = false
      }, 500);

    }

    //service for today's  date of expense anaytic data from server
    function sms_analytics(sms, staff) {
      if (sms == undefined) {
        var sms_change = "LM"
      } else {
        var sms_change = sms
      }

      var staffID = staff == undefined ? 'admin' : staff

      api.sms_analytics.getID.get({ date: sms_change, staffID: staffID, branch_id: $rootScope.user[0].branch_id },

        function(response) {
          //filter staffs who have permissions for sms
          $scope.sms_staff = staffRole.filter(function(o1) {
            return campaignn.some(function(o2) {
              return (o1.staffID == o2.staffID && o1.status == 'active' && o1.branch_id == o2.branch_id)
            })
          })
          vm.sms_staffs = staff_all.concat($scope.sms_staff);
          //filter branch data for branch wise for get promotional and transcational count
          $scope.sms_count = branch_data.filter(function(data) {
            if (data.branch_id == $rootScope.user[0].branch_id)
              return data
          })
          $scope.sms_data = response[0]; //apply data to front end
          var sms_analytics_data = {
            "projects": [{
                "name": "ACME Corp. Backend App"
              },
              {
                "name": "ACME Corp. Frontend App"
              },
              {
                "name": "Creapond"
              },
              {
                "name": "Withinpixels"
              }
            ],
            "widget7": {
              "title": "Task Distribution",
              "ranges": {
                "TW": "Today",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
              },
              "mainChart": [{
                  "label": "Pending",
                  "values": {
                    "2W": 18,
                    "LW": 19,
                    "TW": response[0].PENDING //here response cash_percent of data applied 
                  }
                },
                {
                  "label": "Delivered",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": response[0].DELIVERED //here response card_percent of data applied 
                  }
                },
                {
                  "label": "Faild",
                  "values": {
                    "2W": 17,
                    "LW": 16,
                    "TW": response[0].FAILED //here response card_percent of data applied 
                  }
                }
              ]
            },

          }

          //default syntax of analytics data writing from the circular bar
          //widget6
          vm.widget79 = {
            title: 's',
            mainChart: {
              config: {
                refreshDataOnly: true,
                deepWatchData: true
              },
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#23bf72', '#ffb000', '#fb7b7c', '#b2c222', '#c8b9a7', '#fc9946', '#6ba5ff'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  donut: true,
                  clipEdge: true,
                  cornerRadius: 0,
                  labelType: 'percent',
                  padAngle: 0.02,
                  x: function(d) {
                    return d.label;
                  },
                  y: function(d) {
                    return d.value;
                  },

                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: []
            },
            // ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function(range) {
              vm.widget79.currentRange = range;

              angular.forEach(sms_analytics_data.widget7.mainChart, function(data, index) {
                vm.widget79.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };


              });
            },
            init: function() {

              vm.widget79.changeRange('TW');
            }
          };


          // Initialize Widget 6
          vm.widget79.init();
        })
    }
    sms_analytics();

    // GET Online types NAME
    //---------------- 
    $scope.getOnlineTypeNames = function(onlinePaymentTypeAmount) {
      if (!vm.onlineTypes) {
        return;
      }
      for (var i = 0; i < vm.onlineTypes.length; i++) {
        if (vm.onlineTypes[i].values == onlinePaymentTypeAmount.values) {
          return vm.onlineTypes[i].names
        }
      }
    };
    /*==========================================================================
                              Download db
       ========================================================================== */
    if (vm.settings.databasebackup) {
      downloaded();
      function downloaded() {
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var hours = dateObj.getHours();
        var Min = dateObj.getMinutes();
        var sec = dateObj.getSeconds();
        var millsec = dateObj.getMilliseconds();

        var newdate = month + "_" + day + "_" + year + "_" + hours + "h_" + Min + "m_" + sec + "s_" + millsec + "ms";
        //  var date = new Date().toJSON();      
        var downloadPath = vm.dbbackupPath.downloadpath;
        var mysqlDumpPath = vm.dbbackupPath.mysqlDumpPath;
        var data = {
          Date: newdate,
          mysqlDumpPath: mysqlDumpPath,
          downloadPath: downloadPath
        }
        api.dbdownload.getAll.save(data,
          // Success
          function(response) {
          /*  $mdToast.show({
              template: '<md-toast class="success"><span flex>Backup successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            }); */

          },
          // Error
          function(response) {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Data Backup Error</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });

          }
        );
      };

    }
    /* ==============================================================
    Print Daily Data 
    ==============================================================*/

    $scope.ReportTime = new Date();
    $scope.printToCart = function(printSectionId) {
        var innerContents = document.getElementById(printSectionId).innerHTML;
        var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWinindow.document.open();
        popupWinindow.document.write('<html><body onload="window.print()">' + innerContents + '</body></html>');
        popupWinindow.document.close();
      }

    /*==========================================================================
                               export pdf and send email
        ========================================================================== */
      
    $scope.exportemail = function() {
      api.purchaseexpense_analytics.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
        function(response) {
          $scope.purchasetaxx = response[0].taxCgst_info + response[0].taxSgst_info;
          $scope.purchasetaxCgstt = response[0].taxCgst_info;
          $scope.purchasetaxSgstt = response[0].taxSgst_info;
          $scope.purchasetotal_paidd = response[0].total_paid + response[0].advance_paid;
          $scope.purchasetotal_balancee = response[0].total_balance;
          $scope.purchasepaid_cashh = response[0].paid_cash + response[0].advancepaid_cash;
          $scope.purchasepaid_cardd = response[0].paid_card + response[0].advancepaid_card;
          $scope.purchasepaid_chequee = response[0].paid_cheque + response[0].advancepaid_cheque;
          $scope.purchasepaid_onlinee = response[0].paid_online + response[0].advancepaid_online;
          api.dashboard_analytics_date.getID.get({ date: 'today', toDate: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id, month:'month', year:'month' },
            function(response) {
              $scope.items_Data = response[0].posbill_fulldata;
              $scope.total_cashh = response[0].total_cash;
              $scope.total_cardd = response[0].total_card;
              $scope.orderedtotal_cashh = response[0].orderedtotal_cash;
              $scope.orderedtotal_cardd = response[0].orderedtotal_card;
              $scope.dinein_amountt = response[0].dinein_amount;
              $scope.total_profit_amount = response[0].total_profit_amount;
              $scope.takeaway_amountt = response[0].takeaway_amount;
              $scope.doordelivery_amountt = response[0].doordelivery_amount;
              $scope.dinein_totall = response[0].dinein_total;
              $scope.takeaway_totall = response[0].takeaway_total;
              $scope.doordelivery_totall = response[0].doordelivery_total;
              $scope.overviewtax_cgstt = response[0].tax_cgst;
              $scope.overviewtax_sgstt = response[0].tax_sgst;
              $scope.tax_cgstt = response[0].tax_cgst;
              $scope.tax_sgstt = response[0].tax_sgst;
              $scope.overview_posOrder_countt = response[0].total_posOrder;
              $scope.overview_posPaid_countt = response[0].dinein_total + response[0].takeaway_total + response[0].doordelivery_total;
              $scope.overview_posTotall = response[0].total_cash + response[0].total_card + response[0].orderedtotal_cash + response[0].orderedtotal_card;
              api.expense_analytics.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
                function(response) {
                  $scope.expensetaxx = response[0].taxCgst_info + response[0].taxSgst_info;
                  $scope.expensetaxCgstt = response[0].taxCgst_info;
                  $scope.expensetaxSgstt = response[0].taxSgst_info;
                  $scope.total_paidd = response[0].total_paid + response[0].advance_paid;
                  $scope.total_balancee = response[0].total_balance;
                  $scope.generalpaid_cashh = response[0].paid_cash + response[0].advancepaid_cash;
                  $scope.generalpaid_cardd = response[0].paid_card + response[0].advancepaid_card;
                  $scope.generalpaid_chequee = response[0].paid_cheque + response[0].advancepaid_cheque;
                  $scope.generalpaid_onlinee = response[0].paid_online + response[0].advancepaid_online;
                  $scope.overview_expenseTotall = response[0].total_paid + response[0].advance_paid + response[0].total_balance;
                  api.odc_analytics_data.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
                    function(response) {
                      $scope.overviewodc_paymentt = response[0];
                      $scope.odc_paymentt = response[0];
                      $scope.Odctax_cgst = response[0].tax_cgst;
                      $scope.Odctax_sgst = response[0].tax_sgst;
                      $scope.overvie_wodcTax_cgstt = response[0].tax_cgst;
                      $scope.overviewodc_wodcTax_sgstt = response[0].tax_sgst;
                      api.salesexpense_analytics.getID.get({ date: 'today', staffID: 'admin', branch_id: $rootScope.user[0].branch_id },
                        function(response) {
                          $scope.salestaxx = response[0].taxCgst_info + response[0].taxSgst_info;
                          $scope.salestaxCgstt = response[0].taxCgst_info;
                          $scope.salestaxSgstt = response[0].taxSgst_info;
                          $scope.saletotal_paidd = response[0].total_paid + response[0].advance_paid;
                          $scope.saletotal_balancee = response[0].total_balance;
                          $scope.salespaid_cashh = response[0].paid_cash + response[0].advancepaid_cash;
                          $scope.salespaid_cardd = response[0].paid_card + response[0].advancepaid_card;
                          $scope.salespaid_chequee = response[0].paid_cheque + response[0].advancepaid_cheque;
                          $scope.salespaid_onlinee = response[0].paid_online + response[0].advancepaid_online;

                        })
                    })
                })
            })

        })
    };

    $scope.exportemail();
    var doc = new jsPDF('p', 'pt', 'letter');
    var specialElementHandlers = {
      '#editor': function(element, renderer) {
        return true;
      }
    };
    var branchfilter = branch_data.filter(function(data) {
      if (data.branch_id == $rootScope.user[0].branch_id)
        return data
    })
    $scope.branch_name = branchfilter[0].branch_name;

    $scope.pdf = function(d) {
      $scope.ReportTime = new Date()
      $timeout(function() {
        doc.fromHTML($('#content3').html(), 40, 40, {
          'width': 800,
          'elementHandlers': specialElementHandlers
        });

        doc.save("" + moment(new Date()).format('MMM DD,YYYY') + "-Daily Report-" + $scope.branch_name + ".pdf");

        $state.go("app.admindashboard", {}, { reload: "app.admindashboard" })
      }, 100)
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('adduser', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.adduser', {
        url: '/adduser/:id/',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/adduser/adduser.html',
            controller: 'AddUserController as vm'
          }

        },
        resolve: {
          userRole: function(apiResolver) {
            return apiResolver.resolve('userRole.getAll@get');
          },
          staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          }
        },
        ncyBreadcrumb: {
          parent: function($scope, $stateParams) {
            if ($scope.state.params.id) {
              return 'app.userslist';
            } else if (!$scope.state.params.id) { // Constant defined in CollectionsLibraryAvailableController 
              return null;
            }
          },
          label: "{{getBreadcrumbLabel()}}"
        }
        /*   ncyBreadcrumb: {
             label: "{{'USERS.ADD-STAFF' | translate}}"
           }*/
      });



  }
})();

(function() {
  'use strict';

  angular
    .module('adduser')
    .controller('AddUserController', AddUserController);

  /** @ngInject */
  function AddUserController(msNavigationService, $location, staffRole, $mdDialog, $state, $mdToast, $rootScope, $stateParams, $cookies, $scope, api, userRole) {
    var vm = this;

    // Assign permission into array 
    $scope.admin = []
    $scope.salesbills = []
    $scope.expensebills = []
    $scope.Inventory = []
    $scope.Rawmaterial = []
    $scope.salematerials = []
    $scope.ODC = []
    $scope.Marketing = []
    $scope.customerview = []
    $scope.smsview = []
    $scope.whatsappview = []
    $scope.stewardapp = []

    //covert as array format in came from cookies data
    var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]");
    for (var i = 0; i < permissions.length; i++) {
      if (permissions[i] == 0) {
        $scope.admin.push("admin");
      } else if (permissions[i] == 1) {
        $scope.salesbills.push("salesbills");
      } else if (permissions[i] == 2) {
        $scope.expensebills.push("expensebills");
      } else if (permissions[i] == 3) {
        $scope.Inventory.push("inventory");
      } else if (permissions[i] == 31) {
        $scope.Rawmaterial.push("raw material");
      } else if (permissions[i] == 32) {
        $scope.salematerials.push("sales material");
      } else if (permissions[i] == 4) {
        $scope.ODC.push("ODC");
      } else if (permissions[i] == 5) {
        $scope.Marketing.push("Marketing");
      } else if (permissions[i] == 51) {
        $scope.customerview.push("customer");
      } else if (permissions[i] == 52) {
        $scope.smsview.push("sms");
      } else if (permissions[i] == 53) {
        $scope.whatsappview.push("whatsapp");
      } else if (permissions[i] == 99) {
        $scope.stewardapp.push("stewardapp");
      }

    }

    //merge the permissions what currently have this branch
    var merge_permissions = [$scope.admin, $scope.salesbills, $scope.expensebills, $scope.Inventory, $scope.Rawmaterial, $scope.salematerials, $scope.ODC, $scope.Marketing, $scope.customer, $scope.sms, $scope.whatsapp, $scope.stewardapp];
    $scope.modules = merge_permissions;

    //filter staff role for apply dropdown
    var userRoles = userRole.filter(function(data) {
      return [$rootScope.user[0].branch_id].some(function(branch_id) {
        return data.branch_id == branch_id
      })
    })

    vm.userRoles = userRoles; //assign filtered staff role for dropdown
    $scope.params = $stateParams;

    // only number validation
    $scope.onlynumber = onlynumber;

    function onlynumber(e) {
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    };


    //condition for if the page contains url  parmas id or not
    if (!$scope.params.id) {
      vm.user = ''
    } else {
      api.getstaff.getID.get({ staffID: $scope.params.id },
        function(response) {
          vm.user = response[0];
          $scope.accessapp = response[0].permissions;
          vm.user.role = response[0].roleID
          vm.user.mobile1 = response[0].mobile
          vm.user.mobile2 = response[0].mobile_secondary
          vm.user.birthDate = new Date(response[0].DOB)
          vm.user.joinDate = new Date(response[0].JOD)
          $scope.selected = response[0].permissions
          $scope.accountStatus = response[0].status

          $scope.admin = []
          $scope.salesbillss = []
          $scope.saleseditt = []
          $scope.salesdeletee = []
          $scope.expensebillss = []
          $scope.expenseeditt = []
          $scope.expensedeletee = []
          $scope.Inventoryy = []
          $scope.Rawmaterialss = []
          $scope.salematerialss = []
          $scope.ODCC = []
          $scope.odceditt = []
          $scope.odcdeletee = []
          $scope.Marketingg = []
          $scope.customerr = []
          $scope.smss = []
          $scope.whatsappp = []
          $scope.stewardappp = []

          //covert as array format in came from db data
          var permissionss = JSON.parse("[" + response[0].permissions + "]");
          for (var i = 0; i < permissionss.length; i++) {
            if (permissionss[i] == 0) {
              $scope.admin.push("admin");
            } else if (permissionss[i] == 1) {
              $scope.salesbillss.push("salesbills");
            } else if (permissionss[i] == 12) {
              $scope.saleseditt.push("salesbills");
            } else if (permissionss[i] == 13) {
              $scope.salesdeletee.push("salesbills");
            } else if (permissionss[i] == 2) {
              $scope.expensebillss.push("expensebills");
            } else if (permissionss[i] == 22) {
              $scope.expenseeditt.push("salesbills");
            } else if (permissionss[i] == 23) {
              $scope.expensedeletee.push("salesbills");
            } else if (permissionss[i] == 3) {
              $scope.Inventoryy.push("inventory");
            } else if (permissionss[i] == 31) {
              $scope.Rawmaterialss.push("raw material");
            } else if (permissionss[i] == 32) {
              $scope.salematerialss.push("sales material");
            } else if (permissionss[i] == 4) {
              $scope.ODCC.push("ODC");
            } else if (permissionss[i] == 42) {
              $scope.odceditt.push("salesbills");
            } else if (permissionss[i] == 43) {
              $scope.odcdeletee.push("salesbills");
            } else if (permissionss[i] == 5) {
              $scope.Marketingg.push("Marketing");
            } else if (permissionss[i] == 51) {
              $scope.customerr.push("customer");
            } else if (permissionss[i] == 52) {
              $scope.smss.push("sms");
            } else if (permissionss[i] == 53) {
              $scope.whatsappp.push("whatsapp");
            } else if (permissionss[i] == 99) {
              $scope.stewardappp.push("stewardapp");
            }

          }

          if (response[0].permissions != '') {
            $scope.appaccess = true
          }
        })
    }

    //validation for input
    $scope.user = {
      name: {
        required: true,
        minlength: 3,
        maxlength: 30
      }
    }

    // Salary mode
    vm.salarymodeselect = 'monthly';

    //staff salary type
    vm.salarymodelist = [{
      "name": 'Monthly',
      "value": 'monthly'
    }, {
      "name": 'Weekly',
      "value": 'weekly'
    }, {
      "name": 'Daily',
      "value": 'daily'
    }];

    //function for Breadcrumb Label with idnewBill
    $rootScope.getBreadcrumbLabel = function() {
      if ($scope.params.id) {
        var staffRoles = staffRole.filter(function(staff) {
          if (staff.staffID == $scope.params.id)
            return staff
        })
        return staffRoles[0].name
      } else if (!$scope.params.id) {
        return "Add Staff"
      }
    }


    //function for to deactivate or active staff account
    $scope.staffInactive = function(ev) {
      var staffRoles = staffRole.filter(function(staff) {
        if (staff.staffID == $scope.params.id)
          return staff
      })
      if (staffRoles[0].status == 'active') {
        var accountStatus = { 'data': 'inactive' }
      } else if (staffRoles[0].status == 'inactive') {
        var accountStatus = { 'data': 'active' }
      }
      var confirm = $mdDialog.confirm()
        .title('Account')
        .htmlContent('Are you sure you want to ' + accountStatus.data + ' this account?')
        .ariaLabel('delete contact')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function() {
        api.getInactive.getID.update({ staffID: $scope.params.id }, accountStatus,
          function(response) {
            vm.user = ''
            $scope.datas = ''
            $scope.selected = ''

            $state.go('app.userslist')
            if (staffRoles[0].status == 'active') {
              $mdToast.show({
                template: '<md-toast class="success"><span flex>Account Deactived</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });

            } else if (staffRoles[0].status == 'inactive') {
              $mdToast.show({
                template: '<md-toast class="success"><span flex>Account Actived</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000,
                action: "close"
              });

            }
          })
      }, function() {
        // Canceled
      });
    }

    function uncheckParent() {
      //POS bills
      if (!$scope.salesbill) {
        $scope.salesedit = '';
      };
      //Expense
      if (!$scope.expensebill) {
        $scope.expenseedit = '';
        $scope.expensedelete = '';
      };
      //ODC
      if (!$scope.odc) {
        $scope.odcedit = '';
        $scope.odcdelete = '';
      };
      //Inventory
      if (!$scope.inventory) {
        $scope.rawmaterial = '';
        $scope.salesmaterial = '';
      } else if ($scope.inventory && !$scope.rawmaterial && !$scope.salesmaterial) {
        $scope.inventory = '';
      };
      //Marketing
      if (!$scope.marketing) {
        $scope.customer = '';
        $scope.sms = '';
      } else if ($scope.marketing && !$scope.customer && !$scope.sms) {
        $scope.marketing = '';
      };
    }
    //function for update staff datas to db
    $scope.update = function() {
       uncheckParent();
      var role = $scope.user;
      //var permission_data = $scope.datas ? $scope.datas : $scope.selected
      var user = vm.user;
      $rootScope.user = $cookies.getObject('user');
      var permis = [$scope.salesbill, $scope.salesedit, $scope.salesdelete, $scope.expensebill, $scope.expenseedit, $scope.expensedelete, $scope.inventory, $scope.salesmaterial, $scope.rawmaterial, $scope.odc, $scope.odcedit, $scope.odcdelete, $scope.marketing, $scope.customer, $scope.sms, $scope.whatsapp, $scope.stewardapp]
      var fulldata = permis.filter(function(data) {
        if (data != '')
          return data
      });
      // console.log(permis);
      if ($scope.selectedAll == true) { //checking admin permission
        var position = 'admin';
        var permissions = JSON.parse("[" + fulldata.toString() + ',' + 0 + "]"); //covert as array format in came from db data
      } else {
        var position = 'staff'
        var permissions = JSON.parse("[" + fulldata.toString() + "]");
      }
      var filterstaff = staffRole.filter(function(data) {
        if (data.staffID == $scope.params.id)
          return data
      })
      var updateuser = [{
        'roleID': user.role,
        'branch_id': $rootScope.user[0].branch_id,
        'name': user.name,
        'mobile': user.mobile1,
        'mobile_secondary': user.mobile2,
        'email': user.email,
        'Qualification': user.Qualification,
        'DOB': user.birthDate,
        'address': user.address,
        'city': user.city,
        'state': user.state,
        'country': user.country,
        'JOD': user.joinDate,
        'position': position,
        'salarymode': user.salarymode,
        'salary': user.salary,
        'permission': permissions,
        'username': user.username,
        'old_username': (filterstaff[0].username == user.username) ? false : $scope.addUser.username.$dirty,
        'password': user.updatepassword ? user.updatepassword : 'old_password'
      }];
      api.adduser.getID.update({ staffID: $scope.params.id }, updateuser,
        function(response) {
          if (!response.data) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Staff updated successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $state.go("app.userslist", {}, { reload: "app.userslist" })

          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Username/Email id already exists. Please try another one.</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        });

    }


    //function for save staff dates to db
    $scope.submit = function() {
      uncheckParent();
      var role = $scope.user;
      // var permission_data = $scope.datas ? $scope.datas : $scope.selected
      var user = vm.user;
      $rootScope.user = $cookies.getObject('user');
      var branch = $scope.branch;
      var admin = $scope.admin
      var permis = [$scope.salesbill, $scope.salesedit, $scope.salesdelete, $scope.expensebill, $scope.expenseedit, $scope.expensedelete, $scope.inventory, $scope.salesmaterial, $scope.rawmaterial, $scope.odc, $scope.odcedit, $scope.odcdelete, $scope.marketing, $scope.customer, $scope.sms, $scope.stewardapp]
      var fulldata = permis.filter(function(data) {
        if (data != '')
          return data
      });
     // console.log(permis);
      if ($scope.selectedAll == true) {
        //  var permission_data = $scope.datas ? $scope.datas : $scope.selected
        var permissions = JSON.parse("[" + fulldata.toString() + ',' + 0 + "]"); //covert as array format in came from db data
        var position = 'admin'
      } else {
        var position = 'staff'
        var permissions = JSON.parse("[" + fulldata.toString() + "]");
      }

      var adduser = [{
        'roleID': user.role,
        'branch_id': $rootScope.user[0].branch_id,
        'name': user.name,
        'mobile': user.mobile1,
        'mobile_secondary': user.mobile2,
        'email': user.email,
        'Qualification': user.Qualification,
        'DOB': user.birthDate,
        'address': user.address,
        'city': user.city,
        'state': user.state,
        'country': user.country,
        'JOD': user.joinDate,
        'salarymode': user.salarymode,
        'salary': user.salary,
        'permission': permissions,
        'position': position,
        'username': user.username,
        'password': user.password
      }];
      api.adduser.getAll.save(adduser,
        function(response) {
          if (response.insertId) {
            $mdToast.show({
              template: '<md-toast class="success"><span flex>Staff added successfully</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
            $state.go("app.adduser", {}, { reload: "app.adduser" })

          } else {
            $mdToast.show({
              template: '<md-toast class="error"><span flex>username already exists with this branch try another one!</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000,
              action: "close"
            });
          }
        });
    }

    vm.birthDate = new Date();
    vm.joinDate = new Date();

  }
})();

(function() {
  'use strict';

  angular
    .module('app.auth.resetPassword', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.authResetPassword', {
      url: '/auth/resetPassword',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.authResetPassword': {
          templateUrl: 'app/main/auth/reset-password/reset-password.html',
          controller: 'ResetPasswordController as vm'
        }
      },
      bodyClass: 'reset-password'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/auth/reset-password');

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.resetPassword')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($state)
    {
        var vm = this;

        // Data

        // Methods

        vm.authResetPassword = function(){
          $state.go('app.authLogin')  
        };

        //////////
    }
})();

(function() {
  'use strict';

  angular
    .module('app.auth.login',  ['indexedDB'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $urlRouterProvider, msApiProvider, $indexedDBProvider) {
    // State
    $urlRouterProvider.otherwise("/");
    $stateProvider.state('app.authLogin', {
      url: '/',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.authLogin': {
          templateUrl: 'app/main/auth/login/login.html',
          controller: 'LoginController as vm'
        }
      },
       resolve: {
        corporate_settings_Data: function (msApi) {
            return msApi.resolve('corporate_settings@get');}
        },
      bodyClass: 'login'
    });
    // Api
    msApiProvider.register('corporate_settings', ['app/data/corporate_settings/corporate_settings.json']);

      $indexedDBProvider.connection('TF')
      .upgradeDatabase(1, function(event, db, tx){
        var objStore = db.createObjectStore('staff', {keyPath: "staffID"});

       // objStore.createIndex('name_idx', 'name', {unique: false});
        //objStore.createIndex('age_idx', 'age', {unique: false});
      })
      .upgradeDatabase(2, function(event, db, tx){
        var branch = db.createObjectStore('branch', {keyPath: "branch_id"});
      })
      .upgradeDatabase(3, function(event, db, tx){
        var branch = db.createObjectStore('redirect', {keyPath: "username"});
      });
       


  }

})();

(function() {
  'use strict';

  angular
    .module('app.auth.login')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, api, $timeout, $http, $log, $q, $scope, $cookies, $rootScope, $mdToast, $mdDialog, $location, $interval,corporate_settings_Data, $indexedDB) {

    var vm = this;
   
    $rootScope.domain_connectivity = corporate_settings_Data.domain.connectivity_select;
    if($scope.domain_connectivity == 3) {
      $scope.serverOnlines = true;
      var increaseCounter = function() {
        api.TableNo.getAll.get(
          function(response) {
            $scope.serverOnlines = true;
            //$interval.cancel(promise);
          },
          function() {
            $scope.serverOnlines = false;
          });
      };
      var promise = $interval(increaseCounter, 1000);
    } 

    // Methods
    chgDailyImg();

    function chgDailyImg() {
      var imagearray = new Array();
      imagearray[0] = "assets/images/login/bg/1.jpg";
      imagearray[1] = "assets/images/login/bg/2.jpg";
      imagearray[2] = "assets/images/login/bg/3.jpg";
      imagearray[3] = "assets/images/login/bg/4.jpg";
      imagearray[4] = "assets/images/login/bg/5.jpg";
      imagearray[5] = "assets/images/login/bg/6.jpg";
      imagearray[6] = "assets/images/login/bg/7.jpg";

      var d = new Date(); /*** create a date object for use ***/
      var i = d.getDay(); /*** use the date object to get the day of the week - this will be a number from 0 to 6 - sunday=0, saturday=6 -it's the way counting works in javascript it starts at 0 like in the arrays ***/
      var todayimage = imagearray[i];
      // Data
      vm.loginData = {
        backgroundImageUrl: todayimage,
        // backgroundImageOverlayColor: 'rgba(17, 109, 170, 0.8)',
        loginLogoUrl: 'assets/images/login/logo.svg'
      };

    }
    // Server connected checking
    $scope.serverloading = true;
    var increaseCounter = function() {
      api.TableNo.getAll.get(
        function(response) {
          $scope.serverloading = false;
          $interval.cancel(promise);
        },
        function() {});
    };
    var promise = $interval(increaseCounter, 1000);

   
    //function for when staff click login button
    vm.authLogin = function() {
      //console.log(vm.user.password);
      $rootScope.enterword = vm.user.password;
      //store loggin details in  loginuser array
      var loginuser = [{
        'username': vm.user.email,
        'password': vm.user.password
      }]
      $scope.loading = true; //page md-process circular start load when click login
      //console.log($scope.enterword);
      //service for check whether the username or password is match or mismatch

      
      
      if ($scope.serverOnlines && $scope.domain_connectivity == 3) {
        // loginuser
        var localstaffs = [];
        var localbranchs = [];
        var localredirect = [];
        $indexedDB.openStore('staff', function (store) {
          store.getAll().then(function (people) {
            // Update scope
            localstaffs.push(people);
          });
        });

        $indexedDB.openStore('branch', function (store) {
          store.getAll().then(function (branch) {
            // Update scope
            localbranchs.push(branch);
          });
        });

        $indexedDB.openStore('redirect', function (store) {
          store.getAll().then(function (branch) {
            // Update scope
            localredirect.push(branch);
          });
        });

        $timeout(function () {
          $scope.localstaffsData = localstaffs[0];
          $scope.localbranchData = localbranchs[0];
          $scope.localredirectData = localredirect[0];
          var redirectUrl = [];
          // username checking
          for (var i = 0; i <= $scope.localstaffsData.length; i++) {
            if ($scope.localstaffsData[i].username == loginuser[0].username) {
              if ($scope.localstaffsData[i].password == loginuser[0].password) {
                console.log('password matched')
                // branch checking
                for (var i = 0; i <= $scope.localbranchData.length; i++) {
                  if ($scope.localbranchData[i].branch_id == $scope.localstaffsData[i].branch_id) {
                    // redirect checking
                    for (var i = 0; i <= $scope.localredirectData.length; i++) {
                      if ($scope.localredirectData[i].username = $scope.localstaffsData[i].username) {
                        var required_datas = [{ 'domain_category': $scope.localbranchData[i].domain_category, 'branch_id': $scope.localbranchData[i].branch_id, 'staffID': $scope.localbranchData[i].staffID, 'permissions': $scope.localbranchData[i].permissions, 'position': $scope.localbranchData[i].position, 'global_staffID': responses[0].branchresult[0].staffID, 'wa_api': response.data[0].wa_api}]
                        $cookies.putObject('user', required_datas);
                        $cookies.put('auth', $scope.localstaffsData[i].permissions); //put authdata in cookies
                        // $cookies.putObject('globals', $rootScope.globals); //put global url identity data in cookies
                        $cookies.put('loginuser', $scope.localstaffsData[i].username);
                        redirectUrl.push($scope.localredirectData[i].redirect)
                         //$location.path('/role');

                        //to store logged data for global url page identity
                        var authdata = Base64.encode($scope.localbranchData[i].username + ':' + $scope.localbranchData[i]);
                        if (authdata) {
                          $rootScope.globals = {
                            currentUser: {
                              authdata: authdata
                            }
                          }
                        }
                        //$location.path('/'+$scope.localredirectData[i].redirect);
                        break;
                      }
                    };
                    break;
                  }
                };

              } else {
                $scope.loading = false;
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>Invalid offline Email ID / Password</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000
                });
              }



              //usernamematched.push($scope.loadingData[i]); 
              break;
            } else {
              $scope.loading = false;
              $mdToast.show({
                template: '<md-toast class="error"><span flex>Your username is mismatched / check with online</span></md-toast>',
                position: 'bottom right',
                hideDelay: 3000
              });
            }
          }
          $timeout(function () {
            if (redirectUrl[0]) {
              $scope.loading = false;
              //$state.go('app.role');
              $state.go('app.' + redirectUrl[0]);
              //

            }
          }, 500);
        }, 200);




      } else {
      api.login.getAll.save(loginuser,
        function(response) {
          console.log(response);
         if(response.code == 200) {
          var loginresponsedata  = response.data[0];
         }
          // when online error condition and offline condition this function will call to login
          function loginredirect() {
            console.log('enter 3')
            //console.log($scope.enterword);
            api.branch_data.getID.get({ branch_id: loginresponsedata.branch_id },
              function(responses) {
                console.log(responses)
                $scope.loading = false; //md-process circular stopped
                //CHECKING Local DATABSE-if corporate id match and contains expiry date 
                if (responses[0].expiry_date) {
                  var days = Math.round((new Date(responses[0].expiry_date) - new Date()) / 86400000);

                  if (new Date(responses[0].expiry_date) > new Date() && (days == 7 || days == 6 || days == 5 || days == 4 || days == 3 || days == 2 || days == 1)) {
                    $mdToast.show({
                      template: '<md-toast class="error"><span flex>Your account will expire within ' + days + ' days</span></md-toast>',
                      position: 'bottom right',
                      hideDelay: 8000
                    });
                  }
                  if (new Date(responses[0].expiry_date) < new Date()) {
                    $mdToast.show({
                      template: '<md-toast class="error"><span flex>Your account has expired kindly contact administrator</span></md-toast>',
                      position: 'bottom right',
                      hideDelay: 8000
                    });
                    return
                  }
                }
                console.log('enter 3')
                if($scope.domain_connectivity == 3) {
                  console.log('enter 3')
                  // Local data base
                  $indexedDB.openStore('branch', function (store) {

                    store.insert({
                      "branch_id": response.data[0].branch_id
                    }).then(function (e) {
                      console.log(e)
                    });
                    //store.clear().then(function () { });
                   /* store.insert({
                      "staffID": response.data[0].staffID, "name": response.data[0].name, "mobile": response.data[0].mobile, "username": response.data[0].username, "password": response.data[0].mobile,
                      "position": response.data[0].position, "permissions": response.data[0].permissions, "status": response.data[0].status, "branch_id": response.data[0].branch_id, "roleID": response.data[0].roleID
                    }).then(function (e) {
                    }); */
                  });
                }
                var domain_category = responses[0].domain_category;
                var required_datas = [{ 'domain_category': domain_category, 'branch_id': response.data[0].branch_id, 'staffID': response.data[0].staffID, 'permissions': response.data[0].permissions, 'position': response.data[0].position, 'global_staffID': responses[0].branchresult[0].staffID, 'wa_api': response.data[0].wa_api }]
                $cookies.putObject('user', required_datas);

                //check whther staff is admin or not
                var log = []
                var permissions = JSON.parse("[" + response.data[0].permissions + "]"); //covert as array format in came from db data
                for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i] == 0) {
                    log.push("admin");
                  }
                }
                //check whther steward is or not
                var steward = []
                var permissions = JSON.parse("[" + response.data[0].permissions + "]"); //covert as array format in came from db data
                for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i] == 99) {
                    log.push("admin");
                  }
                }
                //check whther staff is superadmin or not
                var superAdmin = []
                if (response.data[0].permissions == 9) {
                  superAdmin.push("admin");
                }
                //to store logged data for global url page identity
                var authdata = Base64.encode(response.data[0].username + ':' + response.data);
                if (authdata) {
                  $rootScope.globals = {
                    currentUser: {
                      authdata: authdata
                    }
                  }
                  $cookies.put('auth', response.data[0].permissions); //put authdata in cookies
                  $cookies.putObject('globals', $rootScope.globals); //put global url identity data in cookies
                }

                var role = $cookies.get('auth'); //get auth data
                //check whther the staff acount was inactived or not
                if (response.data[0].status == 'inactive') {
                  $rootScope.globals = {};
                  $cookies.remove('globals');
                  $cookies.remove('admin');
                  $cookies.remove('user');
                  $mdToast.show({
                    template: '<md-toast class="error"><span flex>Your account has been deactivated, kindly contact your administrator</span></md-toast>',
                    position: 'bottom right',
                    hideDelay: 8000,
                    action: "close"
                  });
                }
                //redirect function for super admin page
                if (superAdmin.length == 1 && response.data[0].status == 'active') {
                  $timeout(function() {
                    $location.path('/super-admin-dashboard');
                  }, 500);
                }
                //redirect function for admin
                //To check whether admin located multiple branch or single branch
                //if multiple branch means the page will be redirect to branch state
                //if single branch means the page will be redirect to role state
                else if (log.length == 1 && response.data[0].status == 'active') {
                  $timeout(function() {
                    var username = $cookies.get('loginuser')
                    api.getstaffdata.getID.get({ staffID: 17 },
                      function(staffRole) {
                        var filterusernames = staffRole.filter(function(data) {
                          if (data.username == username)
                            return data
                        })
                        api.branch_data.getID.get({ branch_id: '' },
                          function(branch_data) {
                            var filterbranches = branch_data.filter(function(data) {
                              return filterusernames.some(function(staff) {
                                return data.branch_id == staff.branch_id
                              })
                            })
                            if (filterbranches.length > 1) {
                              $location.path('/branch');
                            } else if (filterbranches.length == 1) {
                              $location.path('/role');
                            }
                          })
                      })
                  }, 500);
                }
                //redirect function for user
                //To check whether user located multiple branch or single branch
                //if multiple branch means the page will be redirect to branch state
                //if single branch means the page will be redirect to dashboard state
                else if (log.length == 0  && response.data[0].status == 'active') {
                  $timeout(function() {
                    if(steward.length != 0) {
                      $cookies.put('steward', "steward");
                    }
                    var username = $cookies.get('loginuser')
                    api.getstaffdata.getID.get({ staffID: 17 },
                      function(staffRole) {
                        var filterusernames = staffRole.filter(function(data) {
                          if (data.username == username)
                            return data
                        })
                        api.branch_data.getID.get({ branch_id: '' },
                          function(branch_data) {
                            var filterbranches = branch_data.filter(function(data) {
                              return filterusernames.some(function(staff) {
                                return data.branch_id == staff.branch_id
                              })
                            })
                            if (filterbranches.length > 1) {
                              $location.path('/branch');
                            } else if (filterbranches.length == 1) {
                              $location.path('/dashboard');
                            }
                          })
                      })
                  }, 500);
                }
              }, function(error) {
                $scope.loading = false;
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>Login Problem</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000
                });
              });
          }
          //To check whether server returns data and window system have internet
          if ((response.code == 200) && $rootScope.online === true) {
            //To put username in cookies for whether this user or admin has located in multiple branches
            $cookies.put('loginuser', response.data[0].username);   
                //To Send logged in branch data and whether the corporate id match and check account expiry
                api.branch_datas.getID.get({ branch_id: response.data[0].branch_id, host: "" + 'd' + "" + 'x' + "" + '4' + "" + 's' + "" + 't' + "" + 'u' + "" + 'd' + "" + 'i' + "" + 'o' + ".com", path: "/dlr/api/product/corporateread.php" },
                  function (responses) {
                    $scope.loading = false; // md-process circular stopped
                   // console.log(responses[0].corporatedetail);
                    //CHECKING LIVE DATABSE-if corporate id match and contains expiry date 
                    if (responses[0].corporatedetail.length && responses[0].corporatedetail[0].expiry_date) {
                      var days = Math.round((new Date(responses[0].corporatedetail[0].expiry_date) - new Date()) / 86400000);
                      if (new Date(responses[0].corporatedetail[0].expiry_date) > new Date() && (days == 7 || days == 6 || days == 5 || days == 4 || days == 3 || days == 2 || days == 1)) {
                        $mdToast.show({
                          template: '<md-toast class="error"><span flex>Your account will expire within ' + days + ' days</span></md-toast>',
                          position: 'bottom right',
                          hideDelay: 8000
                        });
                      }
                      ///CHECKING LIVE DATABSE-to check if corporate of expiry date expired it will be intimated
                      if (new Date(responses[0].corporatedetail[0].expiry_date) < new Date()) {
                        $mdToast.show({
                          template: '<md-toast class="error"><span flex>Your account has expired kindly contact administrator</span></md-toast>',
                          position: 'bottom right',
                          hideDelay: 8000
                        });
                        return
                      }
                    }
                    //  CHECKING LOCAL DATABSE-if system have internet but not have internet data(yellow initimation) means it will be check currently logged branch of expiry date
                    else if (responses[0].branchresult[0].expiry_date) {
                      var days = Math.round((new Date(responses[0].branchresult[0].expiry_date) - new Date()) / 86400000);
                      if (new Date(responses[0].branchresult[0].expiry_date) > new Date() && (days == 7 || days == 6 || days == 5 || days == 4 || days == 3 || days == 2 || days == 1)) {
                        $mdToast.show({
                          template: '<md-toast class="error"><span flex>Your account will expire within ' + days + ' days</span></md-toast>',
                          position: 'bottom right',
                          hideDelay: 8000
                        });
                      }
                      //CHECKING LOCAL DATABSE-to check if corporate of expiry date expired it will be intimated
                      if (new Date(responses[0].branchresult[0].expiry_date) < new Date()) {
                        $mdToast.show({
                          template: '<md-toast class="error"><span flex>Your account has expired kindly contact administrator</span></md-toast>',
                          position: 'bottom right',
                          hideDelay: 8000
                        });
                        return
                      }
                    }

                    //TO  save and upload domain  name like garments in cookies
                    var domain_category = responses[0].branchresult[0].domain_category;

                    if($scope.domain_connectivity == 3) {
                      // Local data base for branch
                      $indexedDB.openStore('branch', function (store) {
                        store.clear().then(function () { });
                        store.insert({
                          'branch_id': response.data[0].branch_id, 'domain_category': domain_category, 'staffID': response.data[0].staffID, 'permissions': response.data[0].permissions, 'position': response.data[0].position 
                        }).then(function (e) {
                          console.log(e)
                        });
                      });
                    }

                    var required_datas = [{ 'domain_category': domain_category, 'branch_id': response.data[0].branch_id, 'staffID': response.data[0].staffID, 'permissions': response.data[0].permissions, 'position': response.data[0].position, 'global_staffID': responses[0].branchresult[0].staffID, 'wa_api': response.data[0].wa_api}]
                    $cookies.putObject('user', required_datas); //syntax for put data in cookies

                    //check whther staff is admin or not
                    var log = []
                    var permissions = JSON.parse("[" + response.data[0].permissions + "]"); //covert as array format in came from db data
                    for (var i = 0; i < permissions.length; i++) {
                      if (permissions[i] == 0) {
                        log.push("admin");
                      }
                    }
                    //check whther staff is superadmin or not
                    var superAdmin = []
                    if (response.data[0].permissions == 9) {
                      superAdmin.push("admin");
                    }
                    //to store logged data for global url page identity
                    var authdata = Base64.encode(response.data[0].username + ':' + response.data);
                    if (authdata) {
                      $rootScope.globals = {
                        currentUser: {
                          authdata: authdata
                        }
                      }
                      // auth : username and user details
                      $cookies.put('auth', response.data[0].permissions); //put auth data in cookies
                      // globals url identity if doesn't have in cookie redirect to login condition
                      $cookies.putObject('globals', $rootScope.globals); //put global url identity data in cookies
                    }

                    var role = $cookies.get('auth'); //get auth data

                    //check whther the staff acount was inactived or not
                    if (response.data[0].status == 'inactive') {
                      $rootScope.globals = {};
                      $cookies.remove('globals');
                      $cookies.remove('admin');
                      $cookies.remove('user');
                      $mdToast.show({
                        template: '<md-toast class="error"><span flex>Your account has been deactivated, kindly contact your administrator</span></md-toast>',
                        position: 'bottom right',
                        hideDelay: 8000,
                        action: "close"
                      });
                    }
                    //redirect function for super admin page
                    if (superAdmin.length == 1 && response.data[0].status == 'active') {
                      $timeout(function () {
                        $location.path('/super-admin-dashboard');
                      }, 500);
                    }
                    //redirect function for admin
                    //To check whether admin located multiple branch or single branch
                    //if multiple branch means the page will be redirect to branch state
                    //if single branch means the page will be redirect to role state
                    else if (log.length == 1 && response.data[0].status == 'active') {
                     // console.log('first')
                      $timeout(function () {
                        var username = $cookies.get('loginuser');
                        api.getstaffdata.getID.get({ staffID: 17 },
                          function (staffRole) {
                            var filterusernames = staffRole.filter(function (fullStaff) {
                              // Checking same username and store it
                              if (fullStaff.username == username)
                                return fullStaff
                            })
                            api.branch_data.getID.get({ branch_id: '' },
                              function (branch_data) {
                                var filterbranches = branch_data.filter(function (data) {
                                  return filterusernames.some(function (staff) {
                                    // Checking username and branch
                                    return data.branch_id == staff.branch_id
                                  })
                                });

                                //console.log(filterusernames);

                                if($scope.domain_connectivity == 3) {
                                  // Local data base for branch
                                  $indexedDB.openStore('redirect', function (store) {
                                    var redirect = filterbranches.length > 1 ? 'branch' : 'role';
                                    store.insert({
                                      'username': username, 'redirect': redirect
                                    }).then(function (e) {
                                      console.log(e)
                                    });
                                  });
                                }

                                if (filterbranches.length > 1) {
                                  $location.path('/branch');
                                } else if (filterbranches.length == 1) {
                                  $location.path('/role');
                                }
                              })
                          })
                      }, 500);
                    }
                    //redirect function for user
                    //To check whether user located multiple branch or single branch
                    //if multiple branch means the page will be redirect to branch state
                    //if single branch means the page will be redirect to dashboard state
                    else if (log.length == 0 && response.data[0].status == 'active') {
                      console.log('second')
                      $timeout(function () {
                        var username = $cookies.get('loginuser')
                        api.getstaffdata.getID.get({ staffID: 17 },
                          function (staffRole) {
                            var filterusernames = staffRole.filter(function (data) {
                              if (data.username == username)
                                return data
                            })
                            api.branch_data.getID.get({ branch_id: '' },
                              function (branch_data) {
                                var filterbranches = branch_data.filter(function (data) {
                                  return filterusernames.some(function (staff) {
                                    return data.branch_id == staff.branch_id
                                  })
                                })
                                if (filterbranches.length > 1) {
                                  $location.path('/branch');
                                } else if (filterbranches.length == 1) {
                                  $location.path('/dashboard');
                                }
                              })
                          })
                      }, 500);
                    }
                  }, function (error) {
                      //To Send logged in branch data and whether the corporate id match and check account expiry                    
                      loginredirect();                    
                    //Internal Server Error
                  });            
          }        
          //Data will be checked IN ONLY LOCAL DATABASE WHEN SYSTEM NOT HAVE INTERNET   
          //To check whether server returns data and window system not have internet
          else if ((response.code == 200) && $rootScope.online === false) {
            //To put username in cookies for whether this user or admin has located in multiple branches
            $cookies.put('loginuser', response.data[0].username);
            //To Send logged in branch data and whether the corporate id match and check account expiry
            loginredirect();
          }

          // if username or password mismatched means it will be entered
          else {
            $scope.loading = false;
            $mdToast.show({
              template: '<md-toast class="error"><span flex>Invalid Email ID / Password</span></md-toast>',
              position: 'bottom right',
              hideDelay: 3000
            });
          }
        },
        function() { //this function for server xampp error function,it happens when server did not  return data
          $scope.loading = false //md-process circular loads stopped
          $mdToast.show({
            template: '<md-toast class="error"><span flex>Service could not start on computer</span></md-toast>',
            position: 'bottom right',
            hideDelay: 6000
          });
        });
      }

      /*      if(vm.user.email === 'admin@dx4.com' && vm.user.password === 'dx4') {
              $state.go('app.branch');
            } else {
              vm.user = '';
              $mdToast.show({
                    template: '<md-toast><span flex>Invalid Email ID / Password</span></md-toast>',
                    position: 'bottom right',
                    hideDelay: 3000
                });

            }*/

    }

    vm.forgotPasswordDialog = function(ev) {
      $mdDialog.show({
        controller: forgotPasswordDialogController,
        templateUrl: 'app/main/auth/login/forgot.password.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        focusOnOpen: false
      })
    }
    // Forgot Password
    function forgotPasswordDialogController($scope, $mdDialog) {
      $scope.submitDialog = function() {
        $mdDialog.hide();
        $mdToast.show({
          template: '<md-toast><span flex>New password generated and e-mailed to you</span></md-toast>',
          position: 'bottom right',
          hideDelay: 3000
        });
      };

      $scope.closeDialog = function() {
        $mdDialog.hide();
      };

    }

    var Base64 = {

      keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

      encode: function(input) {
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        do {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);

          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }

          output = output +
            this.keyStr.charAt(enc1) +
            this.keyStr.charAt(enc2) +
            this.keyStr.charAt(enc3) +
            this.keyStr.charAt(enc4);
          chr1 = chr2 = chr3 = "";
          enc1 = enc2 = enc3 = enc4 = "";
        } while (i < input.length);

        return output;
      },

      decode: function(input) {
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        var base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) {
          window.alert("There were invalid base64 characters in the input text.\n" +
            "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
            "Expect errors in decoding.");
        }
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        do {
          enc1 = this.keyStr.indexOf(input.charAt(i++));
          enc2 = this.keyStr.indexOf(input.charAt(i++));
          enc3 = this.keyStr.indexOf(input.charAt(i++));
          enc4 = this.keyStr.indexOf(input.charAt(i++));

          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;

          output = output + String.fromCharCode(chr1);

          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }

          chr1 = chr2 = chr3 = "";
          enc1 = enc2 = enc3 = enc4 = "";

        } while (i < input.length);

        return output;
      }
    };

    // toast

    

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.auth.forgotPassword', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.authForgotPassword', {
      url: '/auth/forgotPassword',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.authForgotPassword': {
          templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
          controller: 'ForgotPasswordController as vm'
        }
      },
      bodyClass: 'forgot-password'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/auth/forgot-password');

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgotPassword')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($state)
    {

        var vm = this;

        vm.authResetPassword = function(){
          $state.go('app.authResetPassword')
        };

        // Data

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('role', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.role', {
        url: '/role',
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/content-only.html',
            controller: 'MainController as vm'
          },
          'content@app.role': {
            templateUrl: 'app/main/role/role.html',
            controller: 'RoleController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Role'
        },
          resolve: {
          branch_data: function (apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
        }
      },
      });

// // Translation
//     $translatePartialLoaderProvider.addPart('app/main/auth/login');


  }
})();

(function () {
  'use strict';

  angular
    .module('role')
    .controller('RoleController', RoleController);

  /** @ngInject */
  function RoleController($scope, $state, $timeout, branch_data, $stateParams, $cookies, msNavigationService, $rootScope) {
    var vm = this;

    $rootScope.user = $cookies.getObject('user');
    console.log($rootScope.user);
    vm.manageadmin = $rootScope.user[0].position;
    vm.branch_data = branch_data;
   
   
   
   vm.selectBranch = function(selectedBranch) {
        // 1. Retrieve the existing 'user' cookie
        var existingUserData = $cookies.getObject('user');
        if (existingUserData && existingUserData.length > 0) {
        
            existingUserData[0].branch_id = selectedBranch.branch_id;
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 1); // 1 day expiry
            $cookies.putObject('user', existingUserData, {'expires': expireDate});
            console.log("Cookie updated with branch ID:", selectedBranch.branch_id);
        } else {
            console.error("User cookie not found or is empty.");
        }
    };


    var user_permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]");
    //var user_permissions = ($rootScope.user[0].permissions);
    $scope.stewardappp = [];
    for (var i = 0; i < user_permissions.length; i++) {
      if (user_permissions[i] == 99) {
        $scope.stewardappp.push("stewardapp");
      }
    }
    vm.logout = logout;
    var branchfilter = branch_data.filter(function (data) {
      if (data.branch_id == $rootScope.user[0].branch_id)
        return data
    })
    $scope.branch_name = branchfilter[0].branch_name;
    function logout() {
      $rootScope.globals = {};
      $cookies.remove('globals');
      $cookies.remove('admin');
      $cookies.remove('user');
      $cookies.remove('steward');
      $timeout(function () {
        $state.go("app.authLogin", {}, { reload: "app.authLogin" })
      }, 1000)
    }

    // Navigate to captain module
    vm.navToCaptain = function () {
      msNavigationService.clearNavigation();
      msNavigationService.saveItem('captain', {
        title: 'Captain',
        icon: 'icon-tile-four',
        weight: 1
      });

      msNavigationService.saveItem('captain.blank', {
        title: 'Blank',
        state: 'app.blank',
        weight: 1
      });

      msNavigationService.saveItem('captain.general', {
        title: 'General',
        state: 'app.general',
        weight: 2
      });

      $state.go('app.blank');
    };

    // Navigate to Ssadmin module
    vm.navToSsadmin = function () {

      msNavigationService.clearNavigation();

      msNavigationService.saveItem('ssadmin-dashboard', {
        title: 'Dashboard',
        icon: 'icon-tile-four',
        state: 'app.ssAdminDashboard'
      });

      // Navigation
      msNavigationService.saveItem('managecompany', {
        title: 'Manage Company',
        group: true,
        //translate : 'COMPANY.MANAGE-BRANCHES'
      });

      msNavigationService.saveItem('listcompany', {
        title: 'List of Company',
        icon: 'icon-domain',
        state: 'app.listcompany',
        //weight: 2
      });

      msNavigationService.saveItem('createcompany', {
        title: 'Add Company',
        icon: 'icon-plus-circle-outline',
        state: 'app.createcompany',
        // weight: 1
      });

      msNavigationService.saveItem('ssadminsettings', {
        title: 'Settings',
        group: true
      });

      msNavigationService.saveItem('settings-level', {
        title: 'Levels',
        icon: 'icon-elevation-rise',
        state: 'app.settingsLevel',
        // weight: 1
      });
      $state.go('app.ssAdminDashboard');
    };


    // Navigate to Super admin module
    vm.navToSuperAdmin = function () {

      $state.go('app.superAdminDashboard');
    };

    // Navigate to admin module
    vm.navToAdmin = function () {
      msNavigationService.clearNavigation();
      $cookies.remove('steward');
      $cookies.put('admin', "admin");
      $state.go("app.admindashboard", {}, { reload: "app.admindashboard" })
      $scope.loading = true;
    };

    // Navigate to cashier module
    vm.navToCashier = function () {
      msNavigationService.clearNavigation();
      $cookies.remove('admin');
      $cookies.remove('steward');
      $state.go("app.dashboard", {}, { reload: "app.dashboard" })
      $scope.loading = true;
    };
    // Navigate to cashier module
    vm.navToSteward = function () {
      msNavigationService.clearNavigation();
      $cookies.remove('admin');
      $cookies.put('steward', "steward");
      $state.go("app.dashboard", {}, { reload: "app.dashboard" })
      $scope.loading = true;
    };

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('branch', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // State
    $stateProvider
      .state('app.branch', {
        url: '/branch',
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/content-only.html',
            controller: 'MainController as vm'
          },
          'content@app.branch': {
            templateUrl: 'app/main/branch/branch.html',
            controller: 'BranchController as vm'
          }
        },
        ncyBreadcrumb: {
          label: 'Branch'
        },
          resolve: {
          branch_data: function(apiResolver) {
            return apiResolver.resolve('branch_data.getAll@get');
          },
           staffRole: function(apiResolver) {
            return apiResolver.resolve('staffRole.getAll@get');
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('branch')
    .controller('BranchController', BranchController);

  /** @ngInject */
  function BranchController($scope, $state, $cookies, staffRole, branch_data, $rootScope, $timeout, msNavigationService) {
    var vm = this;

    vm.logout = logout;

    function logout() {
      $rootScope.globals = {};
      $cookies.remove('globals');
      $cookies.remove('admin');
      $cookies.remove('user');
      $cookies.remove('steward');
      $timeout(function() {
        $state.go("app.authLogin", {}, { reload: "app.authLogin" })
      }, 1000)
    };

    var username = $cookies.get('loginuser')
    var filterusernames = staffRole.filter(function(data) {
      if (data.username == username)
        return data
    })
    $scope.filterbranches = branch_data.filter(function(data) {
      return filterusernames.some(function(staff) {
        return data.branch_id == staff.branch_id
      })
    })
    $scope.removecookies = function(branch) {
      $cookies.remove('user')
      $timeout(function() {
        vm.selectRole(branch)
      }, 1000)
    }
    vm.selectRole = function(branch) {
      var filterstaff = filterusernames.filter(function(data) {
         if(data.branch_id==branch.branch_id)
      return data
   })
      // hide switch branch and user for user 
      var log = []
      angular.forEach(filterstaff[0].permissions, function(value, key) {
        if (value == 0) {
          this.push("data");
        }
      }, log);
      $scope.admin_permission = log.length
     var required_datas = [{ 'switch_branch':1,'domain_category': branch.domain_category, 'branch_id': branch.branch_id, 'staffID': filterstaff[0].staffID, 'permissions': filterstaff[0].permissions, 'position': filterstaff[0].position, 'wa_api':branch.wa_api }]
     $cookies.putObject('user', required_datas);
      if (log.length) {
        $state.go('app.role');
      } else if (log.length == 0) {
        $state.go('app.dashboard');
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('starRating', [])
    .directive('starRating', starRating);

    function starRating() {
    return {
      restrict: 'EA',
      template:
        '<ul class="star-rating" ng-class="{readonly: readonly}">' +
        '  <li ng-repeat="star in stars" class="star" ng-class="{filled: star.filled}" ng-click="toggle($index)">' +
        '    <i class="icon s24 icon-star"></i>' + // or &#9733
        '  </li>' +
        '</ul>',
      scope: {
        ratingValue: '=ngModel',
        max: '=?', // optional (default is 5)
        onRatingSelect: '&?',
        readonly: '=?'
      },
      link: function(scope, element, attributes) {
        if (scope.max == undefined) {
          scope.max = 5;
        }
        function updateStars() {
          scope.stars = [];
          for (var i = 0; i < scope.max; i++) {
            scope.stars.push({
              filled: i < scope.ratingValue
            });
          }
        };
        scope.toggle = function(index) {
          if (scope.readonly == undefined || scope.readonly === false){
            scope.ratingValue = index + 1;
            scope.onRatingSelect({
              rating: index + 1
            });
          }
        };
        scope.$watch('ratingValue', function(oldValue, newValue) {
          if (newValue || newValue === 0) {
            updateStars();
          }
        });
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);

        });
       

    }

})();

(function() {
  'use strict';

  var fuseThemes = {
    default: {

        "primary": {
          "name": "tech-yellow",
          "hues": {
            "default": "500",
            "hue-1": "500",
            "hue-2": "600",
            "hue-3": "400"
          }
        },
        "accent": {
          "name": "tech-green",
          "hues": {
            "default": "500",
            "hue-1": "400",
            "hue-2": "700",
            "hue-3": "A100"
          }
        },
        "warn": {
          "name": "red",
          "hues": {
            "default": "500",
            "hue-1": "300",
            "hue-2": "800",
            "hue-3": "A100"
          }
        },
        "background": {
          "name": "grey",
          "hues": {
            "default": "A100",
            "hue-1": "A100",
            "hue-2": "100",
            "hue-3": "300"
          }
        }
    },
    'pinkTheme': {
      primary: {
        name: 'blue-grey',
        hues: {
          'default': '800',
          'hue-1': '600',
          'hue-2': '400',
          'hue-3': 'A100'
        }
      },
      accent: {
        name: 'pink',
        hues: {
          'default': '400',
          'hue-1': '300',
          'hue-2': '600',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'blue'
      },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    },
    'tealTheme': {
      primary: {
        name: 'fuse-blue',
        hues: {
          'default': '900',
          'hue-1': '600',
          'hue-2': '500',
          'hue-3': 'A100'
        }
      },
      accent: {
        name: 'teal',
        hues: {
          'default': '500',
          'hue-1': '400',
          'hue-2': '600',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'deep-orange'
      },
      background: {
        name: 'lime',
        hues: {
          'default': 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    },
    'darkTheme': {
      primary: {
        name: 'grey',
        hues: {
          'default': '300',
          'hue-1': '600',
          'hue-2': '500',
          'hue-3': 'A100'
        }
      },
      accent: {
        name: 'tech-green',
        hues: {
          'default': '500',
          'hue-1': '400',
          'hue-2': '600',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'grey',
         hues: {
          'default': '500',
        }
      },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    },
    "custom": {
      "primary": {
        "name": "lime",
        "hues": {
          "default": "A200",
          "hue-1": "500",
          "hue-2": "600",
          "hue-3": "400"
        }
      },
      "accent": {
        "name": "cyan",
        "hues": {
          "default": "500",
          "hue-1": "400",
          "hue-2": "700",
          "hue-3": "A100"
        }
      },
      "warn": {
        "name": "red",
        "hues": {
          "default": "500",
          "hue-1": "300",
          "hue-2": "800",
          "hue-3": "A100"
        }
      },
      "background": {
        "name": "grey",
        "hues": {
          "default": "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    }


  };

  angular
    .module('app.core')
    .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'tech-green',
            options: {
                '50': '#def5ea',
                '100': '#a7e5c7',
                '200': '#91dfb9',
                '300': '#65d29c',
                '400': '#39c580',
                '500': '#23bf72',
                '600': '#20ac67',
                '700': '#1c995b',
                '800': '#198650',
                '900': '#157344',
                'A100': '#a7e5c7',
                'A200': '#91dfb9',
                'A400': '#39c580',
                'A700': '#1c995b',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'tech-orange',
            options: {
                '50': '#fdecdb',
                '100': '#f9cd9e',
                '200': '#f8c086',
                '300': '#f4a755',
                '400': '#f18d25',
                '500': '#f0810d',
                '600': '#d8740c',
                '700': '#c0670a',
                '800': '#a85b09',
                '900': '#904d08',
                'A100': '#f9cd9e',
                'A200': '#f8c086',
                'A400': '#f18d25',
                'A700': '#c0670a',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
         {
            name: 'tech-yellow',
            options: {
                '50': '#fff3d9',
                '100': '#ffdf99',
                '200': '#ffd880',
                '300': '#ffc84c',
                '400': '#ffb819',
                '500': '#ffb000',
                '600': '#e69f00',
                '700': '#cc8d00',
                '800': '#b37c00',
                '900': '#996a00',
                'A100': '#f9cd9e',
                'A200': '#f8c086',
                'A400': '#f18d25',
                'A700': '#c0670a',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function() {
  'use strict';

  angular
    .module('app.toolbar', ['ngResource'])
    .run(run)
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $translatePartialLoader, api, $scope, $cookies, $http, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $resource) {
    var vm = this;
    $rootScope.user = $cookies.getObject('user');

//console.log($rootScope.serverOnlines);
    // $translatePartialLoader.addPart("app/corporate/bakary");
    if ($rootScope.user) {
      $translatePartialLoader.addPart("app/corporate/" + $rootScope.user[0].domain_category + "");
      $translate.refresh();
    }
    // hide switch branch and user for user 
    var log = []
    angular.forEach($rootScope.user[0].permissions, function(value, key) {
      if (value == 0) {
        this.push("data");
      }
    }, log);
    $scope.admin_permission = log.length
    // service for get loggin user or admin data
    api.profile_service.getID.get({ staffID: $rootScope.user[0].staffID },
      function(response) {
        $scope.staff_name = response[0].name;
      })

    //get data from local  corporate folder
    $scope.MyData = $resource("app/corporate/" + $rootScope.user[0].domain_category + "/general.json", {}, {
      get: { method: 'GET', isArray: false }
    });
    $scope.MyData.get(function(data) {
    
      vm.settings = data.settings;
    }, function(err) {

    });
    //


    //function for hide salebills
    function salesbills() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 1) || permissions[i] == 1) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for hide odcbills
    function odcbills() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 4) || permissions[i] == 4) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }

    //function for hide expensebills
    function expensebills() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 2) || permissions[i] == 2) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }   
    

    //function for hide expensebills
    function inventory() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 3) || permissions[i] == 3) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for hide expensebills
    function rawmaterial() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 31) || permissions[i] == 31) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for hide expensebills
    function salesmaterial() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 32) || permissions[i] == 32) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }


    //function for hide expensebills
    function Marketing() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 5) || permissions[i] == 5) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }

    //function for hide expensebills
    function customer() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 51) || permissions[i] == 51) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for hide expensebills
    function sms() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 52) || permissions[i] == 52) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for hide whatsadd campaign
    function whatsapp() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 53) || permissions[i] == 53) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for hide dealerbills
    function dealerbills() {
      var log = []
      var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
      for (var i = 0; i < permissions.length; i++) {
        if ((permissions[i] == 0 && $rootScope.user[0].position == 'admin' && permissions[i] == 7) || permissions[i] == 7) {
          log.push("data");
        }
      }
      if (log.length > 0) {
        return false;
      } else {
        return true;
      }
    }
    //function for show trash bills
    function trashbills() {
      $scope.global_staffID = $rootScope.user[0].global_staffID;
      $scope.staffID = $rootScope.user[0].staffID;

      //console.log($scope.global_staffID)
     // console.log($scope.staffID)
      if ($scope.global_staffID == $scope.staffID) {
        return false;
      } else {
        return true;
      }
    }
    //if super admin login
    if ($rootScope.user[0].permissions == 9) {
      msNavigationService.saveItem('super-admin-dashboard', {
        title: 'Dashboard',
        icon: 'icon-tile-four',
        state: 'app.superAdminDashboard'
      });

      // Navigation
      msNavigationService.saveItem('cashier', {
        title: 'Manage Branches',
        group: true,
        translate: 'COMPANY.MANAGE-BRANCHES'
      });

      msNavigationService.saveItem('branchlist', {
        title: 'List of Branches',
        icon: 'icon-format-list-bulleted',
        state: 'app.branchlist',
        translate: 'COMPANY.LISTOFBRANCHES'
      });
      msNavigationService.saveItem('addbranch', {
        title: 'Add Branch',
        icon: 'icon-folder-plus',
        state: 'app.addbranch',
        translate: 'COMPANY.ADD-BRANCH'
      });
      // Navigation
      msNavigationService.saveItem('design', {
        title: 'Design',
        group: true,
      });

      msNavigationService.saveItem('design-color', {
        title: 'Color',
        icon: 'icon-format-color-fill',
        state: 'app.designColor',
      });

      msNavigationService.saveItem('accountDetails', {
        title: 'Account Details',
        group: true,
        //translate : 'COMPANY.MANAGE-BRANCHES'
      });



      msNavigationService.saveItem('restaurantaccount', {
        title: 'Account Details',
        icon: 'icon-account-box-outline',
        state: 'app.restaurantaccount',
        translate: 'COMPANY.ACCOUNT-DETAILS'
      });

    }


    //if admin logged as admin
    if ($cookies.get('admin') == 'admin') {

      msNavigationService.clearNavigation();

      msNavigationService.saveItem('admindashboard', {
        title: 'Dashboard',
        icon: 'icon-chart-line',
        state: 'app.admindashboard',
        weight: 1
      });

      msNavigationService.saveItem('module', {
        title: 'Modules',
        group: true,
        weight: 2
      });

      // Navigation
      msNavigationService.saveItem('module.cashier', {
        title: 'Sales Billings',
        icon: 'icon-receipt',
        translate: 'BILLINGS.POS-BILL',
        hidden: function() {
          return salesbills();

        }
      });

      msNavigationService.saveItem('module.cashier.newBill', {
        title: 'New Bill',
        state: 'app.newBill',
        translate: 'BILLINGS.NEW-BILL',
        hidden: function() {
          return salesbills();

        }
      });

      msNavigationService.saveItem('module.cashier.currentBills', {
        title: 'Current Bills',
        state: 'app.currentBills',
        translate: 'BILLINGS.ORDERED-BILLS',
        hidden: function() {
          return salesbills();

        }
      });

      msNavigationService.saveItem('module.cashier.paidBills', {
        title: 'Paid Bills',
        state: 'app.paidBills',
        translate: 'BILLINGS.FINISHED-BILLS',
        hidden: function() {
          return salesbills();

        }
      });

      msNavigationService.saveItem('module.cashier.returnbills', {
        title: 'Return Bills',
        state: 'app.returnbills',
        translate: 'BILLINGS.RETURN-BILLS',
        hidden: function() {
          return salesbills();

        }
      });

      msNavigationService.saveItem('module.odc', {
        title: 'ODC Bill',
        icon: 'icon-silverware-variant',
        translate: 'ODC.ODC-BANQUET',
        hidden: function() {
          return odcbills();

        }
      });

      msNavigationService.saveItem('module.odc.new-odc', {
        title: 'New ODC',
        state: 'app.new-odc',
        translate: 'ODC.NEW-EVENT',
        hidden: function() {
          return odcbills();

        }
      });

      msNavigationService.saveItem('module.odc.currentOdc', {
        title: 'Current ODC',
        state: 'app.currentOdc',
        translate: 'ODC.UPCOMING-EVENT',
        hidden: function() {
          return odcbills();

        }
      });

      msNavigationService.saveItem('module.odc.paidOdc', {
        title: 'Finished ODC',
        state: 'app.paidOdc',
        translate: 'ODC.FINISHED-EVENT',
        hidden: function() {
          return odcbills();
        }
      });


      msNavigationService.saveItem('module.expense', {
        title: 'Expense',
        icon: 'icon-cash',
        translate: 'EXPENSE.EXPENSE',
        hidden: function() {
          return expensebills();

        }
      });

      msNavigationService.saveItem('module.expense.newExpense', {
        title: 'New Expense',
        state: 'app.newExpense',
        translate: 'EXPENSE.NEW-EXPENSE',
        hidden: function() {
          return expensebills();

        }
      });

      msNavigationService.saveItem('module.expense.balanceExpense', {
        title: 'Balance Expense',
        state: 'app.balanceExpense',
        translate: 'EXPENSE.BALANCE-EXPENSE',
        hidden: function() {
          return expensebills();
        }
      });

      msNavigationService.saveItem('module.expense.paidExpense', {
        title: 'Paid Expense',
        state: 'app.paidExpense',
        translate: 'EXPENSE.PAID-EXPENSE',
        hidden: function() {
          return expensebills();
        }
      });


      msNavigationService.saveItem('module.dealer', {
        title: 'Dealers',
        icon: 'icon-cash',
       // group: true,
      //  translate: 'EXPENSE.EXPENSE',
        hidden: function() {
          return dealerbills();
        } 

      });

      msNavigationService.saveItem('module.dealer.addDealer', {
        title: 'New Dealer Order',
      //  icon: 'icon-plus',
        state: 'app.addDealer',
       // translate: 'EXPENSE.NEW-EXPENSE',
        hidden: function() {
          return dealerbills();
        } 
      });

      msNavigationService.saveItem('module.dealer.smDealerOrder', {
        title: 'Dealer Orders',
        //icon: 'icon-cash',
        state: 'app.smDealerOrder',
        //translate: 'EXPENSE.PAID-EXPENSE',
        hidden: function() {
          return dealerbills();
        } 
      });


      msNavigationService.saveItem('module.inventory-raw-material', {
        title: 'Raw Material',
        icon: 'icon-pizza',
        translate: 'Inventory.RAW-MATERIAL',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-raw-material.stockRawMaterial', {
        title: 'Stock of Raw Material',
        state: 'app.stockRawMaterial',
        translate: 'Inventory.STOCK-OF-RAW-MATERIAL',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-raw-material.deliverToKitchen', {
        title: 'Deliver to Kitchen',
        state: 'app.deliverToKitchen',
        translate: 'Inventory.Deliver to Kitchen',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-raw-material.rmPurchasedOrder', {
        title: 'Purchase Order',
        state: 'app.rmPurchasedOrder',
        translate: 'Inventory.PURCHASE-ORDER',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-raw-material.addPurchase', {
        title: 'Add Purchase Order',
        state: 'app.addPurchase',
        translate: 'Inventory.ADD-PURCHASE-ORDER',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-sale-material', {
        title: 'Sale Material',
        icon: 'icon-package-variant',
        translate: 'Inventory.SALE-MATERIAL',
        hidden: function() {
          return salesmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-sale-material.stockSaleMaterial', {
        title: 'Stock of Sale Material',
        state: 'app.stockSaleMaterial',
        translate: 'Inventory.STOCK-OF-SALE-MATERIAL',
        hidden: function() {
          return salesmaterial();
        }
      });


      msNavigationService.saveItem('module.inventory-sale-material.smPurchasedOrder', {
        title: 'Sales Order',
        state: 'app.smSalesOrder',
        translate: 'Inventory.PURCHASE-ORDER',
        hidden: function() {
          return salesmaterial();
        }
      });

      msNavigationService.saveItem('module.inventory-sale-material.addPurchase', {
        title: 'Add Sales Order',
        state: 'app.addSales',
        translate: 'Inventory.ADD-PURCHASE-ORDER',
        hidden: function() {
          return salesmaterial();
        }
      });
      msNavigationService.saveItem('module.customers', {
        title: 'Customers',
        icon: 'icon-account-circle',
        state: 'app.customerlist',
        translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return customer();
        }
      });

      msNavigationService.saveItem('module.campaign', {
        title: 'SMS Marketing',
        // group: true,
        icon: 'icon-account-circle',
        translate: 'BILLINGS.SMS-MARKETING',
        hidden: function() {
          return sms();
        }
      });

      msNavigationService.saveItem('module.campaign.newCampaign', {
        title: 'New Campaign',
        state: 'app.newCampaign',
        //  translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return sms();
        }
      });
      msNavigationService.saveItem('module.campaign.finishedCampaign', {
        title: 'List of Campaign',
        state: 'app.Campaign-list',
        //  translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return sms();
        }
      });

      msNavigationService.saveItem('module.whatsappcampaign', {
        title: 'Whatsapp Marketing',
        icon: 'icon-account-circle',
        hidden: function() {
          return whatsapp();
        }
        
      });


      msNavigationService.saveItem('module.whatsappcampaign.newCampaign', {
        title: 'New Campaign',
        state: 'app.addwhatsappcampaign',
         hidden: function() {
          return whatsapp();
        }
      });
      msNavigationService.saveItem('module.whatsappcampaign.finishedCampaign', {
        title: 'List of Campaign',
        state: 'app.Whatsapp-Campaign-list',
        hidden: function() {
          return whatsapp();
        }
      });

      msNavigationService.saveItem('settings', {
        title: 'Settings',
        group: true,
        weight: 3
      });

      msNavigationService.saveItem('settings.manageusers', {
        title: 'Staff',
        icon: 'icon-account-multiple',
        translate: 'USERS.STAFFS',
      });

      // Navigation
      msNavigationService.saveItem('settings.manageusers.users-list', {
        title: 'List of Staffs',
        state: 'app.userslist',
        translate: 'USERS.LIST-OF-STAFF'
      });

      msNavigationService.saveItem('settings.manageusers.adduser', {
        title: 'Menu Items',
        state: 'app.adduser',
        translate: 'USERS.ADD-STAFF'
      });
      msNavigationService.saveItem('settings.manageusers.users-role', {
        title: 'Menu Items',
        state: 'app.usersrole',
        translate: 'USERS.STAFF-ROLE'
      });

      var domain_data = $scope.MyData.get(function(data) {
        var food_beverage_permission = data.settings.food_beverage_permission == 0 ? true : false
        msNavigationService.saveItem('settings.food&beverage', {
          // title: 'Food & Beverage',
          icon: 'icon-food',
          translate: 'RESTRAUNTANT.FOOD&BEVERAGE',
          hidden: function() {
            return salesbills() || food_beverage_permission;

          }
        });
      })

      msNavigationService.saveItem('settings.food&beverage.food-settings', {
        title: 'Menu Items',
        state: 'app.foodsettings',
        translate: 'RESTRAUNTANT.MENU-ITEMS',
        hidden: function() {
          return salesbills();
        }
      });

      msNavigationService.saveItem('settings.food&beverage.food-settings-category', {
        title: 'Menu Category',
        state: 'app.foodsettingcategory',
        translate: 'RESTRAUNTANT.MENU-CATEGORY',
        hidden: function() {
          return salesbills();
        }
      });

      msNavigationService.saveItem('settings.raw-material', {
        title: 'Stock of Raw Material',
        icon: 'icon-package',
        translate: 'Inventory.STOCK-OF-RAW-MATERIAL',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('settings.raw-material.rm-item', {
        title: 'Items',
        state: 'app.rm-item',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('settings.raw-material.rm-category', {
        title: 'Category',
        state: 'app.rm-category',
        hidden: function() {
          return rawmaterial();
        }
      });

      msNavigationService.saveItem('settings.sale-material', {
        title: 'Stock of Sale Material',
        icon: 'icon-package',
        translate: 'Inventory.STOCK-OF-SALE-MATERIAL',
        hidden: function() {
          return salesmaterial();
        }
      });

      msNavigationService.saveItem('settings.sale-material.si-item', {
        title: 'Items',
        state: 'app.si-item',
        hidden: function() {
          return salesmaterial();
        }
      });

      msNavigationService.saveItem('settings.sale-material.si-category', {
        title: 'Category',
        state: 'app.si-category',
        hidden: function() {
          return salesmaterial();
        }
      });

      msNavigationService.saveItem('settings.vendors', {
        title: 'Vendors',
        icon: 'icon-account-network',
        state: 'app.vendors',
        translate: 'VENDOR.VENDORS',
        hidden: function() {
          return expensebills() && inventory();
        }
      });

      msNavigationService.saveItem('settings.general', {
        title: 'General Settings',
        icon: 'icon-package'
      });

      msNavigationService.saveItem('settings.general.print', {
        title: 'Print',
        // icon: 'text-white-40 icon-printer',
        state: 'app.print',
        hidden: function() {
          return salesbills();
        }
      });

      var domain_data = $scope.MyData.get(function(data) {
        var tableno_permission = data.settings.tableno_permission == 0 ? true : false
        msNavigationService.saveItem('settings.general.tablesettings', {
          title: 'Table No',
          //  icon: 'icon-chair-school',
          state: 'app.tablesettings',
          translate: 'RESTRAUNTANT.TABLE-NO',
          hidden: function() {
            return salesbills() || tableno_permission;
          }
        });
      });

      var domain_datas = $scope.MyData.get(function(data) {
        var thirdparty_permission = data.settings.thirdparty_permission == 0 ? true : false
        msNavigationService.saveItem('settings.general.ThirdParty', {
          title: 'ThirdParty Integration',
          //  icon: 'icon-chair-school',
          state: 'app.ThirdParty',
          translate: 'BILLINGS.THIRD-PARTY-INTEGRATION',
          hidden: function() {
            return salesbills() || thirdparty_permission;
          }
        });
      });

      msNavigationService.saveItem('settings.general.settingslocality', {
        title: 'Locality',
        // icon: 'icon-account-network',
        state: 'app.locality',
        translate: 'BILLINGS.CUSTOMER-LIST.LOCALITY',
        hidden: function() {
          return salesbills() && odcbills() && customer();
        }
      });
      msNavigationService.saveItem('settings.general.settingsbanquet', {
        title: 'Banquet Hall',
        //icon: 'icon-package-variant',
        state: 'app.banquethall',
        translate: 'ODC.BANQUET-HALL',
        hidden: function() {
          return odcbills();
        }
      });
      msNavigationService.saveItem('settings.general.point-settings', {
        title: 'Customer Points',
        // icon: 'icon-food',
        state: 'app.pointsettings',
        hidden: function() {
          return salesbills();
        }
      });

      msNavigationService.saveItem('settings.general.settingstax', {
        title: 'TAX',
        // icon: 'icon-percent',
        state: 'app.settingstax',
        translate: 'BILLINGS.TAX',
        hidden: function() {
          return salesbills() && odcbills();
        }
      });

      msNavigationService.saveItem('settings.general.expense-category', {
        title: 'Expense Category',
        // icon: 'icon-cash',
        state: 'app.expense-category',
        translate: 'EXPENSE.EXPENSE-CATEGORY',
        hidden: function() {
          return expensebills();
        }
      });

      msNavigationService.saveItem('settings.general.corporatedetails', {
        title: 'Corporate Details',
        // icon: 'icon-account-multiple',
        state: 'app.corporatedetails'
      });

      msNavigationService.saveItem('settings.general.trashBills', {
        title: 'Trash Bills',
        state: 'app.trashBills',
        translate: 'BILLINGS.TRASH-BILLS',
        hidden: function() {
          return trashbills();
        }
      });


    }
    // For user navigation
    if ($cookies.get('admin') != 'admin' && $rootScope.user[0].permissions != 9) {

      msNavigationService.clearNavigation();

      msNavigationService.saveItem('dashboard', {
        title: 'Dashboard',
        icon: 'icon-chart-line',
        state: 'app.dashboard',
        translate: 'DASHBOARD.DASHBOARD_NAV',
        hidden: function() {

        }
      });

      // Navigation
      msNavigationService.saveItem('cashier', {
        title: 'Sales Billings',
        group: true,
        translate: 'BILLINGS.POS-BILL',
        hidden: function() {
          return salesbills();
        }

      });

      msNavigationService.saveItem('cashier.newBill', {
        title: 'New Bill',
        // title: 'New Bill',
        translate: 'BILLINGS.NEW-BILL',
        icon: 'icon-plus',
        state: 'app.newBill',
        hidden: function() {
          return salesbills();
        }

      });


      msNavigationService.saveItem('cashier.currentBills', {
        title: 'Current Bills',
        icon: 'icon-receipt',
        state: 'app.currentBills',
        translate: 'BILLINGS.ORDERED-BILLS',
        hidden: function() {
          return salesbills();
        }

      });

      msNavigationService.saveItem('cashier.paidBills', {
        title: 'Paid Bills',
        icon: 'icon-receipt',
        state: 'app.paidBills',
        translate: 'BILLINGS.FINISHED-BILLS',
        hidden: function() {
          return salesbills();
        }

      });
      msNavigationService.saveItem('odc', {
        title: 'ODC Bill',
        group: true,
        translate: 'ODC.ODC-BANQUET',
        hidden: function() {
          return odcbills();
        }
        //translate : 'BILLINGS.SALE-BILLINGS'
      });

      msNavigationService.saveItem('odc.new-odc', {
        title: 'New ODC',
        icon: 'icon-plus',
        state: 'app.new-odc',
        translate: 'ODC.NEW-EVENT',
        hidden: function() {
          return odcbills();
        }
        //translate: 'EXPENSE.NEW-EXPENSE'
      });

      msNavigationService.saveItem('odc.currentOdc', {
        title: 'Current ODC',
        icon: 'icon-silverware-variant',
        state: 'app.currentOdc',
        translate: 'ODC.UPCOMING-EVENT',
        hidden: function() {
          return odcbills();
        }

      });

      msNavigationService.saveItem('odc.paidOdc', {
        title: 'Finished ODC',
        icon: 'icon-silverware-variant',
        state: 'app.paidOdc',
        translate: 'ODC.FINISHED-EVENT',
        hidden: function() {
          return odcbills();
        }

      });
      // Navigation
      msNavigationService.saveItem('expense', {
        title: 'Expense',
        group: true,
        translate: 'EXPENSE.EXPENSE',
        hidden: function() {
          return expensebills();
        }

      });

      msNavigationService.saveItem('expense.newExpense', {
        title: 'New Expense',
        icon: 'icon-plus',
        state: 'app.newExpense',
        translate: 'EXPENSE.NEW-EXPENSE',
        hidden: function() {
          return expensebills();
        }
      });

      msNavigationService.saveItem('expense.balanceExpense', {
        title: 'Balance Expense',
        icon: 'icon-cash',
        state: 'app.balanceExpense',
        translate: 'EXPENSE.BALANCE-EXPENSE',
        hidden: function() {
          return expensebills();
        }
      });
      msNavigationService.saveItem('expense.paidExpense', {
        title: 'Paid Expense',
        icon: 'icon-cash',
        state: 'app.paidExpense',
        translate: 'EXPENSE.PAID-EXPENSE',
        hidden: function() {
          return expensebills();
        }
      });
      // Navigation

      // Navigation
      msNavigationService.saveItem('dealer', {
        title: 'Dealer',
        group: true,
      //  translate: 'EXPENSE.EXPENSE',
        hidden: function() {
            return dealerbills();
          }

      });

      msNavigationService.saveItem('dealer.addDealer', {
        title: 'New Dealer Order',
        icon: 'icon-plus',
        state: 'app.addDealer',
       // translate: 'EXPENSE.NEW-EXPENSE',
        hidden: function() {
            return dealerbills();
          } 
      });

      msNavigationService.saveItem('dealer.smDealerOrder', {
        title: 'Dealer Orders',
        icon: 'icon-cash',
        state: 'app.smDealerOrder',
        //translate: 'EXPENSE.PAID-EXPENSE',
        hidden: function() {
            return dealerbills();
          } 
      });
      // Navigation


      // Navigation
      msNavigationService.saveItem('inventory', {
        title: 'Inventory',
        group: true,
        translate: 'Inventory.Inventory',
        hidden: function() {
          return inventory();
        }
        //translate : 'BILLINGS.SALE-BILLINGS'
      });


      msNavigationService.saveItem('inventory-raw-material', {
        title: 'Raw Material',
        icon: 'icon-package',
        translate: 'Inventory.RAW-MATERIAL',
        hidden: function() {
          return rawmaterial();
        }
        // translate: 'RESTRAUNTANT.FOOD&BEVERAGE'      
      });

      msNavigationService.saveItem('inventory-raw-material.stockRawMaterial', {
        title: 'Stock of Raw Material',
        translate: 'Inventory.STOCK-OF-RAW-MATERIAL',
        state: 'app.stockRawMaterial',
        hidden: function() {
          return rawmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });

      msNavigationService.saveItem('inventory-raw-material.deliverToKitchen', {
        title: 'Deliver to Kitchen',
        state: 'app.deliverToKitchen',
        translate: 'Inventory.Deliver to Kitchen',
        hidden: function() {
          return rawmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });

      msNavigationService.saveItem('inventory-raw-material.rmPurchasedOrder', {
        title: 'Purchase Order',
        state: 'app.rmPurchasedOrder',
        translate: 'Inventory.PURCHASE-ORDER',
        hidden: function() {
          return rawmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });

      msNavigationService.saveItem('inventory-raw-material.addPurchase', {
        title: 'Add Purchase Order',
        state: 'app.addPurchase',
        translate: 'Inventory.ADD-PURCHASE-ORDER',
        hidden: function() {
          return rawmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });

      msNavigationService.saveItem('inventory-sale-material', {
        title: 'Sale Material',
        icon: 'icon-package',
        translate: 'Inventory.SALE-MATERIAL',
        hidden: function() {
          return salesmaterial();
        }
        // translate: 'RESTRAUNTANT.FOOD&BEVERAGE'      
      });

      msNavigationService.saveItem('inventory-sale-material.stockSaleMaterial', {
        title: 'Stock of Sale Material',
        state: 'app.stockSaleMaterial',
        translate: 'Inventory.STOCK-OF-SALE-MATERIAL',
        hidden: function() {
          return salesmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });


      msNavigationService.saveItem('inventory-sale-material.smPurchasedOrder', {
        title: 'Sales Order',
        state: 'app.smSalesOrder',
        translate: 'Inventory.PURCHASE-ORDER',
        hidden: function() {
          return salesmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });

      msNavigationService.saveItem('inventory-sale-material.addPurchase', {
        title: 'Add Sales Order',
        state: 'app.addSales',
        translate: 'Inventory.ADD-PURCHASE-ORDER',
        hidden: function() {
          return salesmaterial();
        }
        //translate: 'RESTRAUNTANT.MENU-ITEMS'
      });

      // Navigation
      msNavigationService.saveItem('Marketing', {
        title: 'Marketing',
        translate: 'BILLINGS.CUSTOMER-LIST.MARKETING',
        group: true,
        hidden: function() {
          return Marketing();
        }
      });

      msNavigationService.saveItem('Marketing.customers', {
        title: 'Customers',
        icon: 'icon-account-circle',
        state: 'app.customerlist',
        translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return customer();
        }
      });

      msNavigationService.saveItem('SMS', {
        title: 'SMS Marketing',
        icon: 'icon-account-circle',
        translate: 'BILLINGS.SMS-MARKETING',
        hidden: function() {
          return sms();
        }
        // translate: 'RESTRAUNTANT.FOOD&BEVERAGE'      
      });


      msNavigationService.saveItem('SMS.newsms', {
        title: 'New Campaign',
        state: 'app.newCampaign',
        //  translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return sms();
        }
      });
      msNavigationService.saveItem('SMS.finishedCampaign', {
        title: 'List of Campaign',
        state: 'app.Campaign-list',
        //  translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return sms();
        }
      });

      msNavigationService.saveItem('whatsappcampaign', {
        title: 'Whatsapp Marketing',
        icon: 'icon-account-circle',
         hidden: function() {
          return whatsapp();
        }
      });

      msNavigationService.saveItem('whatsappcampaign.newCampaign', {
        title: 'New Campaign',
        state: 'app.addwhatsappcampaign',
        //  translate: 'BILLINGS.CUSTOMERS',
        hidden: function() {
          return whatsapp();
        }
      });
      msNavigationService.saveItem('whatsappcampaign.finishedCampaign', {
        title: 'List of Campaign',
        state: 'app.Whatsapp-Campaign-list',
         hidden: function() {
          return whatsapp();
        }
      });


    }

    // unknown Data
    $rootScope.global = {
      search: ''
    };

    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [{
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not Disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];
    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Spanish',
        'translation': 'TOOLBAR.SPANISH',
        'code': 'es',
        'flag': 'es'
      },
      tr: {
        'title': 'Turkish',
        'translation': 'TOOLBAR.TURKISH',
        'code': 'tr',
        'flag': 'tr'
      }
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
    }


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    var vm = this;


    function logout() {
      /*==========================================================================
                                   Download db
            ========================================================================== */
      api.dietType.get(function(dietType) {
        vm.settings = dietType.settings;
        vm.dbbackupPath = dietType.dbbackupPath;

        if (vm.settings.databasebackup) {
          downloaded();

          function downloaded() {
            var dateObj = new Date();
            var month = dateObj.getUTCMonth() + 1; //months from 1-12
            var day = dateObj.getUTCDate();
            var year = dateObj.getUTCFullYear();
            var hours = dateObj.getHours();
            var Min = dateObj.getMinutes();
            var sec = dateObj.getSeconds();
            var millsec = dateObj.getMilliseconds();

            var newdate = month + "_" + day + "_" + year + "_" + hours + "h_" + Min + "m_" + sec + "s_" + millsec + "ms";
            //  var date = new Date().toJSON();      
            var downloadPath = vm.dbbackupPath.downloadpath;
            var mysqlDumpPath = vm.dbbackupPath.mysqlDumpPath;
            var data = {
              Date: newdate,
              mysqlDumpPath: mysqlDumpPath,
              downloadPath: downloadPath
            }
            api.dbdownload.getAll.save(data,
              // Success
              function(response) {
                /*  $mdToast.show({
                    template: '<md-toast class="success"><span flex>Backup successfully</span></md-toast>',
                    position: 'bottom right',
                    hideDelay: 3000,
                    action: "close"
                  }); */

              },
              // Error
              function(response) {
                $mdToast.show({
                  template: '<md-toast class="error"><span flex>Data Backup Error</span></md-toast>',
                  position: 'bottom right',
                  hideDelay: 3000,
                  action: "close"
                });

              }
            );
          };
        }
      }, function(err) {

      });



      $rootScope.globals = {};
      $cookies.remove('globals');
      $cookies.remove('admin');
      $cookies.remove('user');
      $cookies.remove('steward');
      $timeout(function() {
        $state.go("app.authLogin", {}, { reload: "app.authLogin" })
      }, 1000)
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top right',
          parent: '#content'
        });

        return;
      }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }




    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function(item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function() {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        } else {
          $state.go(item.state);
        }
      }
    }
  }
  /*-------------------------------

  1)This function is for  when staff copy url and paste to another tab then it will 
  check whether brower have cookies or not .if there  is a cookies then page will 
  redircted to desired url otherwise it will goes to login page
  2)And also it will be check system internetconnetion through watch function it will work for 
  globally for all modules
  3)if system is not idle within 1 hour then also lastDigestrun watch function will redirct automatically
  to login page.it means auto logout
  ----------------------------------*/

  function run($rootScope, $location, $window, $cookies, $cookieStore, $http, $document, $timeout, $mdDialog, $state, api, $resource) {
    //identify all navigations for check whether system havre online or not
    $rootScope.online = navigator.onLine;
    //default window listen function for check internet
    //here if not have internet
    /*----------------------------------
    Internet online or offline status
    ----------------------------------------*/
    $window.addEventListener("offline", function() {
      $rootScope.$apply(function() {
        $rootScope.online = false;
        $rootScope.$broadcast("internetChecking", $rootScope.online); //broadcast to sms campaign for hit live url

      }, false);
    })
    //here check have internet
    $window.addEventListener("online", function() {
      $rootScope.$apply(function() {
        $rootScope.online = true;
        $rootScope.$broadcast("internetChecking", $rootScope.online); //broadcast to sms campaign for hit live url
      });
    }, false);

    /*----------------------------------
    Internet server online or server offline status
    ----------------------------------------*/



    /*----------------------------------
    Auto logout
    ----------------------------------------*/

    // Timeout timer value
    var TimeOutTimerValue = 60 * 60 * 3000;

    // Start a timeout
    var TimeOut_Thread = $timeout(function() { LogoutByTimer() }, TimeOutTimerValue);
    var bodyElement = angular.element($document);

    /// Keyboard Events
    bodyElement.on('keydown', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('keyup', function(e) { TimeOut_Resetter(e) });

    /// Mouse Events  
    bodyElement.on('click', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('mousemove', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('DOMMouseScroll', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('mousewheel', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('mousedown', function(e) { TimeOut_Resetter(e) });

    /// Touch Events
    bodyElement.on('touchstart.noPreventDefault', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('touchmove.noPreventDefault', function(e) { TimeOut_Resetter(e) });

    /// Common Events
    bodyElement.on('scroll.noPreventDefault', function(e) { TimeOut_Resetter(e) });
    bodyElement.on('focus', function(e) { TimeOut_Resetter(e) });

    function LogoutByTimer() {
      if ($rootScope.user) {
        console.log('Logout');
        var confirm = $mdDialog.confirm()
          .title('Your session has timed out')
          .htmlContent('Your session has expired. Please login agin.')
          .ariaLabel('delete Item')
          .escapeToClose(false)
          .ok('OK');
        //.cancel('CANCEL');

        $mdDialog.show(confirm).then(function() {
          $rootScope.globals = {};
          $cookies.remove('globals');
          $cookies.remove('admin');
          //  $rootScope.user = {};
          $cookies.remove('user');
          $cookies.remove('steward');
          $timeout(function() {
            $state.go("app.authLogin", {}, { reload: "app.authLogin" })
          }, 1000)

        }, function() {
          // Canceled
        });

      };
    }

    function TimeOut_Resetter(e) {
      $timeout.cancel(TimeOut_Thread);
      /// Reset the timeout
      TimeOut_Thread = $timeout(function() { LogoutByTimer() }, TimeOutTimerValue);
    }

    /*//set internal functin run each one minute once it will check
    var lastDigestRun = new Date(); //default store current time
    setInterval(function() {
      var now = Date.now();
      if (now - lastDigestRun > 60 * 60 * 1000) {
        //logout
        $rootScope.globals = {};
        $cookies.remove('globals');
        $cookies.remove('admin');
        //  $rootScope.user = {};
        $cookies.remove('user');
        $timeout(function() {
          $state.go("app.authLogin", {}, { reload: "app.authLogin" })
        }, 1000)
      }
    }, 60 * 1000); // Change Interval here to test. For eg: 5000 for 5 sec
    */

    //global watch for auto logout and here get corporate settings from general json
    $rootScope.$watch(function() {
      //lastDigestRun = new Date();
      if ($rootScope.user) {
        //get from general json here domain category applied dynamically which is came from cookies
        api.dietType = $resource("app/corporate/" + $rootScope.user[0].domain_category + "/general.json", {}, {
          get: { method: 'GET', isArray: false }
        });
      }

    });

    /*This function is for  when staff copy url and paste to another tab then it will 
     check whether brower have cookies or not .if there  is a cookies then page will 
     redircted to desired url otherwise it will goes to login page*/
    // keep user logged in after page refresh
    /*----------------------------------
    Url redirection with permission
    ----------------------------------------*/
    $rootScope.globals = $cookieStore.get('globals') || {};
    var role = $cookies.get('auth');
    //when page refersh it will check default for whether browser have this global cookies
    if ($rootScope.globals.currentUser) {
      if ($location.path() === '/' && $rootScope.globals.currentUser) {
        $rootScope.user = $cookies.getObject('user');
        var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]");

        var log = []
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i] == 0) {
            log.push("admin");
          }
        }
        var superAdmin = []
        if ($rootScope.user[0].permissions == 9) {
          superAdmin.push("admin");
        }
        if (superAdmin.length == 1) {
          $location.path('/super-admin-dashboard');
        } else if (log.length == 1) {
          if ($rootScope.user[0].switch_branch) {
            $location.path('/branch');
          } else {
            $location.path('/role');
          }
        } else if (log.length == 0) {
          if ($rootScope.user[0].switch_branch) {
            $location.path('/branch');
          } else {
            $location.path('/dashboard');
          }
        }

      }
    }

    //global location change data
    //whenever state changes from one to other it will globally like watch function
    /*---------------------------
        Check permission and URL RESTRAUNTANTSTRICTIONS
      ----------------------------*/
    $rootScope.$on('$locationChangeStart', function(event, next, current) {
      // redirect to login page if not logged in and trying to access a restricted page
      var restrictedPage = $.inArray($location.path(), ['/']) === -1;
      var loggedIn = $rootScope.globals.currentUser;
      if (restrictedPage && !loggedIn) {
        $location.path('/');
      }
      $rootScope.user = $cookies.getObject('user'); //get permission from cookies
      var salesbills = [];
      var dealerbills = [];
      var expensebills = [];
      var inventory = [];
      var rawmaterials = [];
      var salesmaterials = [];
      var odc = [];
      var marketing = [];
      var customer = [];
      var sms = [];
      var branch = [];

      if ($rootScope.user) {
        //permission for salebills 
        var permissions = JSON.parse("[" + $rootScope.user[0].permissions + "]"); //covert as array format in came from db data
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i] == 1 || (permissions[i] == 0 && $rootScope.user[0].position == 'admin')) {
            salesbills.push("data");
          };
          if (permissions[i] == 2 || permissions[i] == 0) {
            expensebills.push("data");
          };
          if (permissions[i] == 3 || permissions[i] == 0) {
            inventory.push("data");
          };
          if (permissions[i] == 31 || permissions[i] == 0) {
            rawmaterials.push("data");
          };
          if (permissions[i] == 32 || permissions[i] == 0) {
            salesmaterials.push("data");
          };
          if (permissions[i] == 4 || permissions[i] == 0) {
            odc.push("data");
          };
          if (permissions[i] == 5 || permissions[i] == 0) {
            marketing.push("data");
          };
          if (permissions[i] == 51 || permissions[i] == 0) {
            customer.push("data");
          };
          if (permissions[i] == 52 || permissions[i] == 0) {
            sms.push("data");
          };
          if (permissions[i] == 7 || permissions[i] == 0) {
            dealerbills.push("data");
          };
          if (permissions[i] == 9) {
            branch.push("data");
          };
        }

      }
      /*---------------------------
        URL RESTRICTIONS
      ----------------------------*/
      //salesbill of pages restriction
      if (($location.path() === '/bill///' && salesbills.length == 0) || ($location.path() === '/orderedBills' && salesbills.length == 0) || ($location.path() === '/finishedBills' && salesbills.length == 0) || ($location.path() === '/role' && salesbills.length == 0) || ($location.path() === '/admin-dashboard' && salesbills.length == 0) || ($location.path() === '/users-list' && salesbills.length == 0) || ($location.path() === '/adduser//' && salesbills.length == 0) || ($location.path() === '/users-role' && salesbills.length == 0) || ($location.path() === '/tablesettings' && salesbills.length == 0) || ($location.path() === '/food-settings' && salesbills.length == 0) || ($location.path() === '/food-category' && salesbills.length == 0) || ($location.path() === '/tax' && salesbills.length == 0) || ($location.path() === '/raw-material-item' && salesbills.length == 0) || ($location.path() === '/raw-material-category' && salesbills.length == 0) || ($location.path() === '/sale-item' && salesbills.length == 0) || ($location.path() === '/sale-item-category' && salesbills.length == 0) || ($location.path() === '/expense-category' && salesbills.length == 0) || ($location.path() === '/vendors' && salesbills.length == 0) || ($location.path() === '/corporatedetails' && salesbills.length == 0) || ($location.path() === '/printsettings' && salesbills.length == 0) || ($location.path() === '/point-settings' && salesbills.length == 0) || ($location.path() === '/locality' && salesbills.length == 0) || ($location.path() === '/banquethall' && salesbills.length == 0) || ($location.path() === '/ThirdParty' && salesbills.length == 0)) {
        $location.path('/permission-denied');
      }

      //ODC of pages restriction
      if (($location.path() === '/odc-banquet///' && odc.length == 0) || ($location.path() === '/currentOdc' && odc.length == 0) || ($location.path() === '/paidOdc' && odc.length == 0) || ($location.path() === '/role' && odc.length == 0) || ($location.path() === '/admin-dashboard' && odc.length == 0) || ($location.path() === '/users-list' && odc.length == 0) || ($location.path() === '/adduser//' && odc.length == 0) || ($location.path() === '/users-role' && odc.length == 0) || ($location.path() === '/tablesettings' && odc.length == 0) || ($location.path() === '/food-settings' && odc.length == 0) || ($location.path() === '/food-category' && odc.length == 0) || ($location.path() === '/tax' && odc.length == 0) || ($location.path() === '/raw-material-item' && odc.length == 0) || ($location.path() === '/raw-material-category' && odc.length == 0) || ($location.path() === '/sale-item' && odc.length == 0) || ($location.path() === '/sale-item-category' && odc.length == 0) || ($location.path() === '/expense-category' && odc.length == 0) || ($location.path() === '/vendors' && odc.length == 0) || ($location.path() === '/corporatedetails' && odc.length == 0) || ($location.path() === '/printsettings' && odc.length == 0) || ($location.path() === '/point-settings' && odc.length == 0) || ($location.path() === '/locality' && odc.length == 0) || ($location.path() === '/banquethall' && odc.length == 0) || ($location.path() === '/ThirdParty' && odc.length == 0)) {
        $location.path('/permission-denied');
      }

      //expensebills of pages restriction
      if (($location.path() === '/expense//' && expensebills.length == 0) || ($location.path() === '/balanceExpense' && expensebills.length == 0) || ($location.path() === '/paidExpense' && expensebills.length == 0) || ($location.path() === '/role' && expensebills.length == 0) || ($location.path() === '/admin-dashboard' && expensebills.length == 0) || ($location.path() === '/users-list' && expensebills.length == 0) || ($location.path() === '/adduser//' && expensebills.length == 0) || ($location.path() === '/users-role' && expensebills.length == 0) || ($location.path() === '/tablesettings' && expensebills.length == 0) || ($location.path() === '/food-settings' && expensebills.length == 0) || ($location.path() === '/food-category' && expensebills.length == 0) || ($location.path() === '/tax' && expensebills.length == 0) || ($location.path() === '/raw-material-item' && expensebills.length == 0) || ($location.path() === '/raw-material-category' && expensebills.length == 0) || ($location.path() === '/sale-item' && expensebills.length == 0) || ($location.path() === '/sale-item-category' && expensebills.length == 0) || ($location.path() === '/expense-category' && expensebills.length == 0) || ($location.path() === '/vendors' && expensebills.length == 0) || ($location.path() === '/corporatedetails' && expensebills.length == 0) || ($location.path() === '/printsettings' && expensebills.length == 0) || ($location.path() === '/point-settings' && expensebills.length == 0) || ($location.path() === '/locality' && expensebills.length == 0) || ($location.path() === '/banquethall' && expensebills.length == 0) || ($location.path() === '/ThirdParty' && expensebills.length == 0)) {
        $location.path('/permission-denied');
      }

      //inventory of pages restriction
      if (($location.path() === '/food-beverage-inventory' && rawmaterials.length == 0) || ($location.path() === '/stock-raw-material' && rawmaterials.length == 0) || ($location.path() === '/deliver-to-kitchen' && rawmaterials.length == 0) || ($location.path() === '/rm-purchased-order' && rawmaterials.length == 0) || ($location.path() === '/add-purchase-order/' && rawmaterials.length == 0) || ($location.path() === '/role' && rawmaterials.length == 0) || ($location.path() === '/admin-dashboard' && rawmaterials.length == 0) || ($location.path() === '/users-list' && rawmaterials.length == 0) || ($location.path() === '/adduser//' && rawmaterials.length == 0) || ($location.path() === '/users-role' && rawmaterials.length == 0) || ($location.path() === '/tablesettings' && rawmaterials.length == 0) || ($location.path() === '/food-settings' && rawmaterials.length == 0) || ($location.path() === '/food-category' && rawmaterials.length == 0) || ($location.path() === '/tax' && rawmaterials.length == 0) || ($location.path() === '/raw-material-item' && rawmaterials.length == 0) || ($location.path() === '/raw-material-category' && rawmaterials.length == 0) || ($location.path() === '/sale-item' && rawmaterials.length == 0) || ($location.path() === '/sale-item-category' && rawmaterials.length == 0) || ($location.path() === '/expense-category' && rawmaterials.length == 0) || ($location.path() === '/vendors' && rawmaterials.length == 0) || ($location.path() === '/corporatedetails' && rawmaterials.length == 0) || ($location.path() === '/printsettings' && rawmaterials.length == 0) || ($location.path() === '/point-settings' && rawmaterials.length == 0) || ($location.path() === '/locality' && rawmaterials.length == 0) || ($location.path() === '/banquethall' && rawmaterials.length == 0) || ($location.path() === '/ThirdParty' && rawmaterials.length == 0)) {
        $location.path('/permission-denied');
      }
      //inventory of pages restriction
      if (($location.path() === '/sm-Sales-order' && salesmaterials.length == 0) || ($location.path() === '/add-sales-order/' && salesmaterials.length == 0) || ($location.path() === '/role' && salesmaterials.length == 0) || ($location.path() === '/admin-dashboard' && salesmaterials.length == 0) || ($location.path() === '/users-list' && salesmaterials.length == 0) || ($location.path() === '/adduser//' && salesmaterials.length == 0) || ($location.path() === '/users-role' && salesmaterials.length == 0) || ($location.path() === '/tablesettings' && salesmaterials.length == 0) || ($location.path() === '/food-settings' && salesmaterials.length == 0) || ($location.path() === '/food-category' && salesmaterials.length == 0) || ($location.path() === '/tax' && salesmaterials.length == 0) || ($location.path() === '/raw-material-item' && salesmaterials.length == 0) || ($location.path() === '/raw-material-category' && salesmaterials.length == 0) || ($location.path() === '/sale-item' && salesmaterials.length == 0) || ($location.path() === '/sale-item-category' && salesmaterials.length == 0) || ($location.path() === '/expense-category' && salesmaterials.length == 0) || ($location.path() === '/vendors' && salesmaterials.length == 0) || ($location.path() === '/corporatedetails' && salesmaterials.length == 0) || ($location.path() === '/printsettings' && salesmaterials.length == 0) || ($location.path() === '/point-settings' && salesmaterials.length == 0) || ($location.path() === '/locality' && salesmaterials.length == 0) || ($location.path() === '/banquethall' && salesmaterials.length == 0) || ($location.path() === '/ThirdParty' && salesmaterials.length == 0)) {
        $location.path('/permission-denied');
      }
      //sms of pages restriction
      if (($location.path() === '/addcampaign/' && sms.length == 0) || ($location.path() === '/Campaign-list' && sms.length == 0) || ($location.path() === '/role' && sms.length == 0) || ($location.path() === '/admin-dashboard' && sms.length == 0) || ($location.path() === '/users-list' && sms.length == 0) || ($location.path() === '/adduser//' && sms.length == 0) || ($location.path() === '/users-role' && sms.length == 0) || ($location.path() === '/tablesettings' && sms.length == 0) || ($location.path() === '/food-settings' && sms.length == 0) || ($location.path() === '/food-category' && sms.length == 0) || ($location.path() === '/tax' && sms.length == 0) || ($location.path() === '/raw-material-item' && sms.length == 0) || ($location.path() === '/raw-material-category' && sms.length == 0) || ($location.path() === '/sale-item' && sms.length == 0) || ($location.path() === '/sale-item-category' && sms.length == 0) || ($location.path() === '/expense-category' && sms.length == 0) || ($location.path() === '/vendors' && sms.length == 0) || ($location.path() === '/corporatedetails' && sms.length == 0) || ($location.path() === '/printsettings' && sms.length == 0) || ($location.path() === '/point-settings' && sms.length == 0) || ($location.path() === '/locality' && sms.length == 0) || ($location.path() === '/banquethall' && sms.length == 0) || ($location.path() === '/ThirdParty' && sms.length == 0)) {
        $location.path('/permission-denied');
      }

      //customer of pages restriction
      if (($location.path() === '/customer-list' && customer.length == 0) || ($location.path() === '/role' && customer.length == 0) || ($location.path() === '/admin-dashboard' && customer.length == 0) || ($location.path() === '/users-list' && customer.length == 0) || ($location.path() === '/adduser//' && customer.length == 0) || ($location.path() === '/users-role' && customer.length == 0) || ($location.path() === '/tablesettings' && customer.length == 0) || ($location.path() === '/food-settings' && customer.length == 0) || ($location.path() === '/food-category' && customer.length == 0) || ($location.path() === '/tax' && customer.length == 0) || ($location.path() === '/raw-material-item' && customer.length == 0) || ($location.path() === '/raw-material-category' && customer.length == 0) || ($location.path() === '/sale-item' && customer.length == 0) || ($location.path() === '/sale-item-category' && customer.length == 0) || ($location.path() === '/expense-category' && customer.length == 0) || ($location.path() === '/vendors' && customer.length == 0) || ($location.path() === '/corporatedetails' && customer.length == 0) || ($location.path() === '/printsettings' && customer.length == 0) || ($location.path() === '/point-settings' && customer.length == 0) || ($location.path() === '/locality' && customer.length == 0) || ($location.path() === '/banquethall' && customer.length == 0) || ($location.path() === '/ThirdParty' && customer.length == 0)) {
        $location.path('/permission-denied');
      }

      //inventory of pages restriction
      if (($location.path() === '/branch-list' && branch.length == 0) || ($location.path() === '/add-branch/' && branch.length == 0) || ($location.path() === '/design-color' && branch.length == 0) || ($location.path() === '/account-details/' && branch.length == 0)) {
        $location.path('/permission-denied');
      }

      //Trash bill of pages restriction
      if (($location.path() === '/trashBills' && $rootScope.user[0].global_staffID != $rootScope.user[0].staffID)) {
        $location.path('/permission-denied');
      }
    });

  }



})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
/*
        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );
*/
        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope, api, $rootScope, $cookies, $resource) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };
    $rootScope.user = $cookies.getObject('user');
    if ($rootScope.user) {
      api.branchname_service.getID.get({ branchID: $rootScope.user[0].branch_id },
        function(response) {
          $scope.branch_name = response[0].branch_name;
          $scope.corporate = response[0].corporate_name
          $scope.corporateSymbol = $scope.corporate.charAt(0);
        });

      // Load settings from general.json to control UI elements like the client logo
      var dietTypeResource = $resource("app/corporate/" + $rootScope.user[0].domain_category + "/general.json", {}, {
        get: { method: 'GET', isArray: false }
      });

      dietTypeResource.get(function(dietType) {
        vm.show_client_image = dietType && dietType.settings && dietType.settings.show_client_image == 1;
      });
    }
    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function() {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }

})();

(function() {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [

      // Breadcrumb
      'ncy-angular-breadcrumb',

      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',

      // Quick Panel
      'app.quick-panel',

      'app.customDirectives',

      // Aunthendication
      'app.auth',

      // Main
      'app.main'
    ]);
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, api, $translatePartialLoader, $translate) {
    // Data
    $rootScope.getDomainCategory = 'app';
    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function(event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
// dev_santhosh

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;
       

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
    }

})();
(function () {
  'use strict';

  angular.module('fuse').factory('api', apiService);
  angular.module('fuse').factory("fileReader", fileReader);
  angular.module('fuse').directive("ngFileSelect", fileReaderDirective);

  /** @ngInject */
  function apiService($resource, $http, $q, $rootScope, $cookies, $timeout) {
    /**
     * You can use this service to define your API urls. The "api" service
     * is designed to work in parallel with "apiResolver" service which you can
     * find in the "app/core/services/api-resolver.service.js" file.
     *
     * You can structure your API urls whatever the way you want to structure them.
     * You can either use very simple definitions, or you can use multi-dimensional
     * objects.
     *
     * Here's a very simple API url definition example:
     *
     *      api.getBlogList = $resource('http://api.example.com/getBlogList');
     *
     * While this is a perfectly valid $resource definition, most of the time you will
     * find yourself in a more complex situation where you want url parameters:
          *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
     *
     * You can also define your custom methods. Custom method definitions allow you to
     * add hardcoded parameters to your API calls that you want to sent every time you
     * make that API call:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
     *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
     *      });
     *
     * In addition to these definitions, you can also create multi-dimensional objects.
     * They are nothing to do with the $resource object, it's just a more convenient
     * way that we have created for you to packing your related API urls together:
     *
     *      api.blog = {
     *                   list     : $resource('http://api.example.com/blog'),
     *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
     *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
     *                       get: {
     *                            method: 'GET',
     *                            params: {
     *                                getByDate: true
     *                            }
     *                       }
     *                   })
     *       }
     *
     * If you look at the last example from above, we overrode the 'get' method to put a
     * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
     * object will also be sent along with whatever data we are sending.
     *
     * All the above methods are using standard $resource service. You can learn more about
     * it at: https://docs.angularjs.org/api/ngResource/service/$resource
     *
     * -----
     *
     * After you defined your API urls, you can use them in Controllers, Services and even
     * in the UIRouter state definitions.
     *
     * If we use the last example from above, you can do an API call in your Controllers and
     * Services like this:
     *
     *      function MyController (api)
     *      {
     *          // Get the blog list
     *          api.blog.list.get({},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the id of 3
     *          var id = 3;
     *          api.blog.getById.get({'id': id},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the date by using custom defined method
     *          var date = 112314232132;
     *          api.blog.getByDate.get({'date': date},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *      }
     *
     * Because we are directly using $resource service, all your API calls will return a
     * $promise object.
     *
     * --
     *
     * If you want to do the same calls in your UI Router state definitions, you need to use
     * "apiResolver" service we have prepared for you:
     *
     *      $stateProvider.state('app.blog', {
     *          url      : '/blog',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver)
     *              {
     *                  return apiResolver.resolve('blog.list@get');
     *              }
     *          }
     *      });
     *
     *  You can even use parameters with apiResolver service:
     *
     *      $stateProvider.state('app.blog.show', {
     *          url      : '/blog/:id',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver, $stateParams)
     *              {
     *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
     *              }
     *          }
     *      });
     *
     *  And the "Blog" object will be available in your BlogController:
     *
     *      function BlogController(Blog)
     *      {
     *          var vm = this;
     *
     *          // Data
     *          vm.blog = Blog;
     *
     *          ...
     *      }
     */
    var api = {};

    // Base Url
    api.baseUrl = 'app/data/';
    api.baseAPIUrl = 'http://localhost:1100/api/';
    //api.baseAPIUrl = 'https://www.r27.techfooddy.online/api/';
    api.getCompanyList = $resource(api.baseAPIUrl + 'getCompanyDet');

    api.readCompanies = function () {
      var deferred = $q.defer();

      $http.get(api.baseAPIUrl + 'getCompanyDet').success(function (data) {
        deferred.resolve(data);
      }).error(function (data, status) {
        deferred.reject(data);
      });

      return deferred.promise;
    }

    api.readLevels = function () {
      var deferred = $q.defer();

      $http.get(api.baseAPIUrl + 'getLevels').success(function (data) {
        deferred.resolve(data);
      }).error(function (data, status) {
        deferred.reject(data);
      });

      return deferred.promise;
    }

    api.write = function (dataObj) {

      var deferred = $q.defer();

      $http.post(api.baseAPIUrl + 'write', { data: dataObj }).success(function (data) {
        deferred.resolve(data);
      }).error(function (data, status) {
        deferred.reject(data);
      });

      return deferred.promise;
    }

    api.update = function (dataObj) {

      var deferred = $q.defer();

      $http.post(api.baseAPIUrl + 'update', { data: dataObj }).success(function (data) {
        deferred.resolve(data);
      }).error(function (data, status) {
        deferred.reject(data);
      });

      return deferred.promise;
    }


    api.readCompanyById = function (comp_id) {
      var deferred = $q.defer();
      $http.get(api.baseAPIUrl + 'getCompanyById?comp_id=' + comp_id).success(function (data) {
        deferred.resolve(data);
        console.log(data);
      }).error(function (data, status) {
        deferred.reject(data);
      });

      return deferred.promise;
    }

    /* login */
    api.login = {
      getAll: $resource(api.baseAPIUrl + 'login', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

    }


    /* expense Menu Category */
    api.exCategory = {
      getAll: $resource(api.baseAPIUrl + 'exCategory', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'exCategory/:exCatergoryID', { exCatergoryID: '@exCatergoryID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* expense Menu Category */
    api.BanquetHall = {
      getAll: $resource(api.baseAPIUrl + 'BanquetHall', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'BanquetHall/:BanquetHallID', { BanquetHallID: '@BanquetHallID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    api.ThirdParty = {
      getAll: $resource(api.baseAPIUrl + 'ThirdParty', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'ThirdParty/:thirdparty_id', { thirdparty_id: '@thirdparty_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* Table NO */
    api.TableNo = {
      getAll: $resource(api.baseAPIUrl + 'getTableNo', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'getTableNo/:table_id', { table_id: '@table_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* Food Menu Category */
    api.fmCategory = {
      getAll: $resource(api.baseAPIUrl + 'fmCategory', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'fmCategory/:fmCatergoryID', { fmCatergoryID: '@fmCatergoryID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* Food Menu Items */
    api.dinein = {
      getAll: $resource(api.baseAPIUrl + 'dinein', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* Food Menu Items */
    api.takeaway = {
      getAll: $resource(api.baseAPIUrl + 'takeaway', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* Food Menu Items */
    api.doordelivery = {
      getAll: $resource(api.baseAPIUrl + 'doordelivery', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.paidbill_service = {
      getAll: $resource(api.baseAPIUrl + 'paidbill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.trashbill_service = {
      getAll: $resource(api.baseAPIUrl + 'trashbill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.paidexpense_service = {
      getAll: $resource(api.baseAPIUrl + 'paidexpense_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    api.balanceexpense_service = {
      getAll: $resource(api.baseAPIUrl + 'balanceexpense_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.purchaseexpense_service = {
      getAll: $resource(api.baseAPIUrl + 'purchaseexpense_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.salesexpense_service = {
      getAll: $resource(api.baseAPIUrl + 'salesexpense_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.paid_purchaseexpense_service = {
      getAll: $resource(api.baseAPIUrl + 'paid_purchaseexpense_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.paid_salesexpense_service = {
      getAll: $resource(api.baseAPIUrl + 'paid_salesexpense_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    api.currentodc_service = {
      getAll: $resource(api.baseAPIUrl + 'currentodc_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'currentodc_service/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    api.delete_pos_ordered = {
      getID: $resource(api.baseAPIUrl + 'delete_pos_ordered/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),

    }

    api.trash_pos_ordered = {
      getAll: $resource(api.baseAPIUrl + 'trash_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'trash_pos_ordered/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),

    }
    api.deleteCampaign = {
      getID: $resource(api.baseAPIUrl + 'deleteCampaign/:campaignID', { campaignID: '@campaignID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),

    }
    api.paidodc_service = {
      getAll: $resource(api.baseAPIUrl + 'paidodc_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.getpurchase_service = {
      getAll: $resource(api.baseAPIUrl + 'getpurchase_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    api.getsales_service = {
      getAll: $resource(api.baseAPIUrl + 'getsales_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.getkitchendata_service = {
      getAll: $resource(api.baseAPIUrl + 'getkitchendata_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /*customer service*/
    api.customerlist_service = {
      getAll: $resource(api.baseAPIUrl + 'customerlist_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'customerlist_service/:customer_id', { customer_id: '@customer_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /*customer service*/
    api.customeranalyticfood_service = {
      getAll: $resource(api.baseAPIUrl + 'customeranalyticfood_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /*customer service*/
    api.customeranalyticfeedback_service = {
      getAll: $resource(api.baseAPIUrl + 'customeranalyticfeedback_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* Food Menu Items */
    api.fmItems = {
      getAll: $resource(api.baseAPIUrl + 'fmItem', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'fmItem/:fmItemID', { fmItemID: '@fmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* Food Menu Items */
    api.points = {
      getAll: $resource(api.baseAPIUrl + 'point', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'point/:pointsID', { pointsID: '@pointsID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* Food Menu Items */
    api.fmitem_sale = {
      getAll: $resource(api.baseAPIUrl + 'fmitem_sale', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'fmitem_sale/:branch_id', { branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //get customer_info
    api.customer_details = {
      getAll: $resource(api.baseAPIUrl + 'customer_details', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'fmItem/:fmItemID', { fmItemID: '@fmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* raw Menu Category */
    api.rmCategory = {
      getAll: $resource(api.baseAPIUrl + 'rmCategory', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'rmCategory/:rmCatergoryID', { rmCatergoryID: '@rmCatergoryID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* raw Menu Category */
    api.siCategory = {
      getAll: $resource(api.baseAPIUrl + 'siCategory', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'siCategory/:siCatergoryID', { siCatergoryID: '@siCatergoryID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* raw Menu Items */
    api.rmItems = {
      getAll: $resource(api.baseAPIUrl + 'rmItem', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'rmItem/:rmItemID', { rmItemID: '@rmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //add userRole
    api.add_userrole = {
      getAll: $resource(api.baseAPIUrl + 'add_userrole', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'add_userrole/:roleID', { roleID: '@roleID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* sale Menu Items */
    api.siItems = {
      getAll: $resource(api.baseAPIUrl + 'siItem', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'siItem/:siItemID', { siItemID: '@siItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    
    api.siItemImage = {
      upload: $resource(api.baseAPIUrl + 'siItem/:siItemID/image', { siItemID: '@siItemID' }, { post: { method: 'POST', headers: { 'Content-Type': undefined } } })
    }


    api.siItemLimit = {
      getAll: $resource(api.baseAPIUrl + 'siItemLimit', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* vendor  */
    api.vendor = {
      getAll: $resource(api.baseAPIUrl + 'vendor', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'vendor/:vendorID', { vendorID: '@vendorID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* save billid datas */

    api.salesorder = {
      getAll: $resource(api.baseAPIUrl + 'salesorder', {}, {
        get: { method: 'GET', isArray: true },
        save: { method: 'POST' }   // 👈 now correctly defined
      }),
      getID: $resource(api.baseAPIUrl + 'salesorder/:salesorderID',
        { salesorderID: '@salesorderID' },
        {
          update: { method: 'PUT' },
          delete: { method: 'DELETE' }
        }
      )
    };

    api.WAbill = {
      getAll: $resource(api.baseAPIUrl + 'WAbill', {}, {
        get: { method: 'GET', isArray: true },
        save: { method: 'POST' }   // 👈 now correctly defined
      })
    };
    api.multiPrinter = {
      getAll: $resource(api.baseAPIUrl + 'multiPrinter', {}, {
        get: { method: 'GET', isArray: true },
        save: { method: 'POST' }   // 👈 now correctly defined
      })
    };
    api.return_order = {
      getAll: $resource(api.baseAPIUrl + 'return_order', {}, {
        get: { method: 'GET', isArray: false },
        save: { method: 'POST' }   // 👈 now correctly defined
      }),
      getID: $resource(api.baseAPIUrl + 'return_order/:id', { id: '@id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    };
        /* vendor  */
    api.return_salesorder = {
      getAll: $resource(api.baseAPIUrl + 'return_salesorder', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'return_salesorder/:id', { id: '@id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    api.updateAll = {
      getID: $resource(api.baseAPIUrl + 'updateAll/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    api.save_customer = {
      getAll: $resource(api.baseAPIUrl + 'save_customer', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    //ADD BRANCH
    api.addBranch = {
      getAll: $resource(api.baseAPIUrl + 'addBranch', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    //ADD ADMIN
    api.addAdmin = {
      getAll: $resource(api.baseAPIUrl + 'addAdmin', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }



    /* saleitems datas */

    api.saleitems = {
      getAll: $resource(api.baseAPIUrl + 'saleitems', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'saleitems/:saleitemsID', { saleitems: '@saleitemsID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* ODC saleitems datas */

    api.odc_saleitems = {
      getAll: $resource(api.baseAPIUrl + 'odc_saleitems', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'odc_saleitems/:saleitemsID', { saleitems: '@saleitemsID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* save customerinfo datas */

    api.customerinfo = {
      getAll: $resource(api.baseAPIUrl + 'customerinfo', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'customerinfo/:customerinfoID', { savebill: '@customerinfoID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* save salespayment datas */

    api.salespayment = {
      getAll: $resource(api.baseAPIUrl + 'salespayment', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'salespayment/:salespaymentID', { savebill: '@salespaymentID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* save salesfeedback datas */

    api.salesfeedback = {
      getAll: $resource(api.baseAPIUrl + 'salesfeedback', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'salesfeedback/:salesfeedbackID', { savebill: '@salesfeedbackID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* save ADDUSER datas  IN ADMIN to database  */

    api.adduser = {
      getAll: $resource(api.baseAPIUrl + 'adduser', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'adduser/:staffID', { staffID: '@staffID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    api.updateuser = {
      getAll: $resource(api.baseAPIUrl + 'updateuser', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),

      getID: $resource(api.baseAPIUrl + 'updateuser/:staffID', { staffID: '@staffID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    api.getInactive = {
      getID: $resource(api.baseAPIUrl + 'getInactive/:staffID', { staffID: '@staffID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get userRole dynamic in admin */
    api.userRole = {
      getAll: $resource(api.baseAPIUrl + 'userRole', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'userRole/:userRoleID', { userRoleID: '@userRoleID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get barnch_Data */
    api.branch_data = {
      getAll: $resource(api.baseAPIUrl + 'branch_data', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'branch_data/:branch_id', { branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get barnch_Data */
    api.branch_datas = {
      getID: $resource(api.baseAPIUrl + 'branch_datas/:branch_id/:host/:path', { branch_id: '@branch_id', host: '@host', path: '@path' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }
      ),
    }


    /* get barnch_Data */
    api.update_branch_data = {
      getID: $resource(api.baseAPIUrl + 'update_branch_data/:branch_id', { branch_id: '@branch_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get staffRole dynamic in newbill */
    api.staffRole = {
      getAll: $resource(api.baseAPIUrl + 'staffRole', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'staffRole/:staffRoleID', { staffRoleID: '@staffRoleID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get staffRole dynamic in newbill */
    api.sales_order_data = {
      getAll: $resource(api.baseAPIUrl + 'sales_order_data', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* get staffRole dynamic in newbill */
    api.expense_bill_data = {
      getAll: $resource(api.baseAPIUrl + 'expense_bill_data', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* get staffRole dynamic in newbill */
    api.rawmaterial_bill_data = {
      getAll: $resource(api.baseAPIUrl + 'rawmaterial_bill_data', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    /* get staffRole dynamic in newbill */
    api.salematerial_bill_data = {
      getAll: $resource(api.baseAPIUrl + 'salematerial_bill_data', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /* get  paidbills in newbill */
    api.paidbills = {
      getAll: $resource(api.baseAPIUrl + 'paidbills', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'paidbills/:paidbillsID', { paidbillsID: '@paidbillsID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get  trashbills in newbill */
    api.trashbills = {
      getAll: $resource(api.baseAPIUrl + 'trashbills', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'trashbills/:trashbillsID', { trashbillsID: '@trashbillsID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get  currentbill_service in newbill */
    api.currentbill_service = {
      getAll: $resource(api.baseAPIUrl + 'currentbill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'currentbill_service/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }
    /* get  currentbill_service in newbill */
    api.currentrow_service = {
      getAll: $resource(api.baseAPIUrl + 'currentrow_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'currentrow_service/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  currentbill_service in newbill */
    api.profile_service = {
      //  getAll: $resource(api.baseAPIUrl + 'currentbill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'profile_service/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }

    api.gdrive = {
      //getAll: $resource(api.baseAPIUrl + 'fmCategory', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'gdrive/:folderID/:uploadPath', { folderID: '@folderID' }, { get: { method: 'GET', isArray: true } }),
    }

    api.update_profile = {
      //  getAll: $resource(api.baseAPIUrl + 'currentbill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'update_profile/:staffID', { staffID: '@staffID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  currentbill_service in newbill */
    api.branchname_service = {
      //  getAll: $resource(api.baseAPIUrl + 'currentbill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'branchname_service/:branchID', { branchID: '@branchID' }, { get: { method: 'GET', isArray: true } }),
    }


    /* get  paidbills in newbill */
    api.update_food_stock = {
      getID: $resource(api.baseAPIUrl + 'update_food_stock/:fmItemID', { fmItemID: '@fmItemID' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  currentbill_service in newbill */
    api.current_mergebill_service = {
      getAll: $resource(api.baseAPIUrl + 'current_mergebill_service', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'current_mergebill_service/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  currentbill_service in newbill */
    api.dashboard_analytics = {
      getID: $resource(api.baseAPIUrl + 'dashboard_analytics/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }


    /* get  currentbill_service in newbill */
    api.odc_analytics_data = {
      getID: $resource(api.baseAPIUrl + 'odc_analytics_data/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  currentbill_service in newbill */
    api.expense_analytics = {
      getID: $resource(api.baseAPIUrl + 'expense_analytics/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }
    /* get  currentbill_service in newbill */
    api.purchaseexpense_analytics = {
      getID: $resource(api.baseAPIUrl + 'purchaseexpense_analytics/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }
    /* get  currentbill_service in newbill */
    api.salesexpense_analytics = {
      getID: $resource(api.baseAPIUrl + 'salesexpense_analytics/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  currentbill_service in newbill */
    api.sms_analytics = {
      getID: $resource(api.baseAPIUrl + 'sms_analytics/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }
    /* get  currentbill_service in newbill */
    api.inventory_analytics = {
      getID: $resource(api.baseAPIUrl + 'inventory_analytics/:date/:weekday/:staffID/:branch_id', { date: '@date', weekday: '@weekday', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get raw mater
    api.inventory_analytics = {
      getID: $resource(api.baseAPIUrl + 'inventory_analytics/:date', { date: '@date' },  { get: { method: 'GET', isArray: true } }),
    }

 /* get  currentbill_service in newbill */
    api.rawmaterial_analytics = {
      getID: $resource(api.baseAPIUrl + 'rawmaterial_analytics/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  currentbill_service in newbill */
    api.salematerial_analytics = {
      getID: $resource(api.baseAPIUrl + 'salematerial_analytics/:date/:staffID/:branch_id', { date: '@date', staffID: '@staffID', branch_id: '@branch_id' }, { get: { method: 'GET', isArray: true } }),
    }


    /* get  currentbill_service in newbill */
    api.current_mergebill = {
      getAll: $resource(api.baseAPIUrl + 'current_mergebill', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    /* get  getdiet for edit in newbill */
    api.dietitems = {

      getaData: $resource(api.baseAPIUrl + 'dietitems/:salesorder_id', { salesorder_id: '@salesorder_id' }, { get: { method: 'GET', isArray: true } }),
      getID: $resource(api.baseAPIUrl + 'dietitems/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }),
    }

    /* get  getdiet for edit in newbill */
    api.odcitems = {

      getaData: $resource(api.baseAPIUrl + 'odcitems/:salesorder_id', { salesorder_id: '@salesorder_id' }, { get: { method: 'GET', isArray: true } }),
      getID: $resource(api.baseAPIUrl + 'odcitems/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }),
    }


    /* get  salesorder_diet for edit in newbill */
    api.salesorder_diet = {

      getID: $resource(api.baseAPIUrl + 'salesorder_diet/:salesorder_id', { salesorder_id: '@salesorder_id' }, { get: { method: 'GET', isArray: true } }),
    }
    //GET STAFF

    api.getstaff = {
      getID: $resource(api.baseAPIUrl + 'getstaff/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }

    api.getstaffdata = {
      getID: $resource(api.baseAPIUrl + 'getstaffdata/:staffID', { staffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),
    }

    /* get  payment_diet for edit in newbill */
    api.payment_diet = {

      getID: $resource(api.baseAPIUrl + 'payment_diet/:salesorder_id', { salesorder_id: '@salesorder_id' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }

      ),
    }


    /* get  payment_diet for edit in newbill */
    api.customer_infodiet = {

      getID: $resource(api.baseAPIUrl + 'customer_infodiet/:salesorder_id', { salesorder_id: '@salesorder_id' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }

      ),
    }

    /* get  payment_diet for edit in newbill */
    api.customer_feedbackdiet = {

      getID: $resource(api.baseAPIUrl + 'customer_feedbackdiet/:salesorder_id', { salesorder_id: '@salesorder_id' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }

      ),
    }

    /* get  payment_diet for edit in newbill */


    //new expense bill

    api.newexpense = {
      getAll: $resource(api.baseAPIUrl + 'newexpense', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'newexpense/:newexpenseID', { newexpenseID: '@newexpenseID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),


    }

    //new getvendors in new expense bill

    api.getvendors = {
      getAll: $resource(api.baseAPIUrl + 'getvendors', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /*  expense_recurring in newbill */

    api.recurring = {
      getAll: $resource(api.baseAPIUrl + 'recurring', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'recurring/:recurringID', { recurringID: '@recurringID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /*  expense_item in newbill */

    api.newexpenseitem = {
      getAll: $resource(api.baseAPIUrl + 'newexpenseitem', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'newexpenseitem/:newexpenseitemID', { newexpenseitemID: '@newexpenseitemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /*  expensepayment in newbill */

    api.expensepayment = {
      getAll: $resource(api.baseAPIUrl + 'expensepayment', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'expensepayment/:expensepaymentID', { expensepaymentID: '@expensepaymentID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /*  expense_balancebill in newbill */

    api.paidbill = {
      getID: $resource(api.baseAPIUrl + 'paidbill/:staffID', { stafffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),

      getAll: $resource(api.baseAPIUrl + 'paidbill', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /*  expense_balancebill in newbill */

    api.balancebill = {
      getID: $resource(api.baseAPIUrl + 'balancebill/:staffID', { stafffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),

      getAll: $resource(api.baseAPIUrl + 'balancebill', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    /* get  balexpense for edit in newexpense */
    api.balexpense = {
      /* getAll: $resource(api.baseAPIUrl + 'getdiet', null,
               {get: {method: 'GET', isArray: true}},
               {save: {method: 'POST'}}
       ),*/
      getaData: $resource(api.baseAPIUrl + 'balexpense/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { get: { method: 'GET', isArray: true } }
        // {delete: {method: 'DELETE'}}
      ),
      getID: $resource(api.baseAPIUrl + 'balexpense/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }
        // {delete: {method: 'DELETE'}}
      ),
    }

    /* get  salesorder_diet for edit in newbill */
    api.expense_payment = {

      getID: $resource(api.baseAPIUrl + 'expense_payment/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }
    api.expense_payment_purchase = {

      getID: $resource(api.baseAPIUrl + 'expense_payment_purchase/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }
    api.expense_payment_sales = {

      getID: $resource(api.baseAPIUrl + 'expense_payment_sales/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }

    /* get  expense_item for edit in newbill */
    api.expense_item = {
      getID: $resource(api.baseAPIUrl + 'expense_item/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { get: { method: 'GET', isArray: true } }),
    }

    /* save billid datas */

    api.inventoryfood_quantity = {
      getAll: $resource(api.baseAPIUrl + 'inventoryfood_quantity', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /*get food_items_stock */

    api.get_food_stock = {
      getAll: $resource(api.baseAPIUrl + 'get_food_stock', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /* get  food_category&items  for inventory */
    api.inventoryfood = {
      getAll: $resource(api.baseAPIUrl + 'inventoryfood', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'inventoryfood/:expense_bill_id', { expense_bill_id: '@expense_bill_id' },

        { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }
      ),
    }


    /* get  purchaseitems  for inventory */
    api.rmstock = {
      getAll: $resource(api.baseAPIUrl + 'rmstock', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'rmstock/:expense_bill_id', { expense_bill_id: '@expense_bill_id' },

        { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }
      ),
    }

    /* get  purchaseitems  for inventory */
    api.smstock = {
      getAll: $resource(api.baseAPIUrl + 'smstock', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'smstock/:purchase_sales_id', { purchase_sales_id: '@purchase_sales_id' },

        { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }
      ),
    }

    /* get  rm_category&items  for inventory */
    api.rmstocks = {
      getAll: $resource(api.baseAPIUrl + 'rmstocks', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'rmstocks/:expense_bill_id', { expense_bill_id: '@expense_bill_id' },

        { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }
      ),
    }

    /* get  rm_category&items  for inventory */
    api.rmcategorydata = {
      getAll: $resource(api.baseAPIUrl + 'rmcategorydata', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'rmcategorydata/:expense_bill_id', { expense_bill_id: '@expense_bill_id' },

        { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }
      ),
    }

    /* get  rm_category&items  for inventory */
    api.smcategorydata = {
      getAll: $resource(api.baseAPIUrl + 'smcategorydata', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'smcategorydata/:inventory_sales_id', { inventory_sales_id: '@inventory_sales_id' },

        { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }
      ),
    }

    //post purchase_order data

    api.purchase_orders = {
      getAll: $resource(api.baseAPIUrl + 'purchase_orders', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.inventory_sales_order = {
      getAll: $resource(api.baseAPIUrl + 'inventory_sales_order', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.campaign = {
      getAll: $resource(api.baseAPIUrl + 'campaign', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.whatsappcampaign = {
      getAll: $resource(api.baseAPIUrl + 'whatsappcampaign', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.whatsappQRscan = {
      getAll: $resource(api.baseAPIUrl + 'whatsappQRscan', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.campaigndetails = {
      getAll: $resource(api.baseAPIUrl + 'campaigndetails', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }



    //post purchase_order data

    api.purchase_items = {
      getAll: $resource(api.baseAPIUrl + 'purchase_items', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    api.inventory_sale_items = {
      getAll: $resource(api.baseAPIUrl + 'inventory_sale_items', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }



    api.purchasedata = {

      getaData: $resource(api.baseAPIUrl + 'purchasedata/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }

    api.inventory_salesdata = {

      getaData: $resource(api.baseAPIUrl + 'inventory_salesdata/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }

    api.purchaseitem = {

      getID: $resource(api.baseAPIUrl + 'purchaseitem/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }
    api.inventory_salesItems = {

      getID: $resource(api.baseAPIUrl + 'inventory_salesItems/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { get: { method: 'GET', isArray: true } }

      ),
    }




    //post purchase_order data

    api.getpurchase = {
      getAll: $resource(api.baseAPIUrl + 'getpurchase', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'getpurchase/:staffID', { stafffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),

    }

    //post purchase_order data

    api.getsales = {
      getAll: $resource(api.baseAPIUrl + 'getsales', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'getsales/:staffID', { stafffID: '@staffID' }, { get: { method: 'GET', isArray: true } }),

    }
    //post delivery kitchen data

    api.rmitemdatas = {
      getAll: $resource(api.baseAPIUrl + 'rmitemdatas', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    api.locality = {
      getID: $resource(api.baseAPIUrl + 'locality/:localityID', { localityID: '@localityID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
      getAll: $resource(api.baseAPIUrl + 'locality', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.dbdownload = {
      getAll: $resource(api.baseAPIUrl + 'dbdownload', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.banquethall = {
      getAll: $resource(api.baseAPIUrl + 'banquethall', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.getmsgPromotional = {
      getID: $resource(api.baseAPIUrl + 'getmsgPromotional/:branch_id', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.campaignn = {
      getAll: $resource(api.baseAPIUrl + 'campaignn', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    api.whatsapp_campaigns = {
      getAll: $resource(api.baseAPIUrl + 'whatsapp_campaigns', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    api.campaigndetailss = {
      getAll: $resource(api.baseAPIUrl + 'campaigndetailss', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /* get  getdiet for edit in newbill */
    api.editkitchendata = {
      getaData: $resource(api.baseAPIUrl + 'editkitchendata/:deliveryto_kitchen_id', { deliveryto_kitchen_id: '@deliveryto_kitchen_id' }, { get: { method: 'GET', isArray: true } }),
      getID: $resource(api.baseAPIUrl + 'editkitchendata/:deliveryto_kitchen_id', { deliveryto_kitchen_id: '@deliveryto_kitchen_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  getdiet for edit in newbill */
    api.updatequantity = {

      getaData: $resource(api.baseAPIUrl + 'updatequantity/:rmItemID', { rmItemID: '@rmItemID' }, { get: { method: 'GET', isArray: true } }),
      getID: $resource(api.baseAPIUrl + 'updatequantity/:rmItemID', { rmItemID: '@rmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get  getdiet for edit in newbill */
    api.updateInventory_salequantity = {

      getaData: $resource(api.baseAPIUrl + 'updateInventory_salequantity/:siItemID', { siItemID: '@siItemID' }, { get: { method: 'GET', isArray: true } }),
      getID: $resource(api.baseAPIUrl + 'updateInventory_salequantity/:siItemID', { siItemID: '@siItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  getdiet for edit in newbill */
    api.update_salematerial_quantity = {
      getID: $resource(api.baseAPIUrl + 'update_salematerial_quantity/:siItemID', { siItemID: '@siItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  getdiet for edit in newbill */
    api.update_newbill_quantity = {
      getID: $resource(api.baseAPIUrl + 'update_newbill_quantity/:siItemID', { siItemID: '@siItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get  getdiet for edit in newbill */
    api.update_rawmaterial_quantity = {
      getID: $resource(api.baseAPIUrl + 'update_rawmaterial_quantity/:rmItemID', { rmItemID: '@rmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  getdiet for edit in newbill */
    api.updatedeliveryeditquantity = {
      getID: $resource(api.baseAPIUrl + 'updatedeliveryeditquantity/:rmItemID', { rmItemID: '@rmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  getdiet for edit in newbill */
    api.deleteAndupdate_salematerial_quantity = {
      getID: $resource(api.baseAPIUrl + 'deleteAndupdate_salematerial_quantity/:siItemID/:inventory_salesItems_id', { siItemID: '@siItemID', inventory_salesItems_id: '@inventory_salesItems_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  getdiet for edit in newbill */
    api.deleteAndupdate_rawmaterial_quantity = {
      getID: $resource(api.baseAPIUrl + 'deleteAndupdate_rawmaterial_quantity/:rmItemID/:purchase_items_id', { rmItemID: '@rmItemID', purchase_items_id: '@purchase_items_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    /* get  getdiet for edit in newbill */
    api.deleteAndupdate_delivery_quantity = {
      getID: $resource(api.baseAPIUrl + 'deleteAndupdate_delivery_quantity/:rmItemID/:deliveryto_kitchen_id', { rmItemID: '@rmItemID', deliveryto_kitchen_id: '@deliveryto_kitchen_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  getdiet for edit in newbill */
    api.deleteAndupdate_newbill_quantity = {
      getID: $resource(api.baseAPIUrl + 'deleteAndupdate_newbill_quantity/:siItemID/:salesitem_id', { siItemID: '@siItemID', salesitem_id: '@salesitem_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  getdiet for edit in newbill */
    api.updatedeliveryquantity = {
      getaData: $resource(api.baseAPIUrl + 'updatedeliveryquantity/:rmItemID', { rmItemID: '@rmItemID' }, { get: { method: 'GET', isArray: true } }

      ),
      getID: $resource(api.baseAPIUrl + 'updatedeliveryquantity/:rmItemID', { rmItemID: '@rmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get  getdiet for edit in newbill */
    api.update_billquantity = {
      getaData: $resource(api.baseAPIUrl + 'update_billquantity/:fmItemID', { fmItemID: '@fmItemID' }, { get: { method: 'GET', isArray: true } }

      ),
      getID: $resource(api.baseAPIUrl + 'update_billquantity/:fmItemID', { fmItemID: '@fmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  getdiet for edit in newbill */
    api.update_earnpoint = {
      getID: $resource(api.baseAPIUrl + 'update_earnpoint/:customer_id', { customer_id: '@customer_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /* get  getdiet for edit in newbill */
    api.updatefoodquantity = {
      getaData: $resource(api.baseAPIUrl + 'updatefoodquantity/:fmItemID', { fmItemID: '@fmItemID' }, { get: { method: 'GET', isArray: true } }

      ),
      getID: $resource(api.baseAPIUrl + 'updatefoodquantity/:fmItemID', { fmItemID: '@fmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  getdiet for edit in newbill */
    api.updateset_quantity = {

      getaData: $resource(api.baseAPIUrl + 'updateset_quantity/:fmItemID', { fmItemID: '@fmItemID' }, { get: { method: 'GET', isArray: true } }

      ),
      getID: $resource(api.baseAPIUrl + 'updateset_quantity/:fmItemID', { fmItemID: '@fmItemID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  updatexpense_data */
    api.updatexpense_data = {

      getaData: $resource(api.baseAPIUrl + 'updateset_quantity/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { get: { method: 'GET', isArray: true } }),
      getID: $resource(api.baseAPIUrl + 'updatexpense_data/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    api.allexpense = {
      getAll: $resource(api.baseAPIUrl + 'expenseall', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    //add image to folder from expense controller
    api.expense_folder = {
      getaData: $resource(api.baseAPIUrl + 'expense_folder', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    //add image to folder from expense controller
    api.purchasebill_folder = {
      getaData: $resource(api.baseAPIUrl + 'purchasebill_folder', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    //add image to folder from expense controller
    api.salesbill_folder = {
      getaData: $resource(api.baseAPIUrl + 'salesbill_folder', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }
    //add image to folder from expense controller
    api.update_purchasebill = {
      getaData: $resource(api.baseAPIUrl + 'update_purchasebill', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }


    //get getsales_order data

    api.getsales_order = {
      getAll: $resource(api.baseAPIUrl + 'getsales_order', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }



    //update sales_order data
    api.updatesalesorder = {

      getID: $resource(api.baseAPIUrl + 'updatesalesorder/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    //update sales_order data 
    api.updatecampaignlist = {

      getID: $resource(api.baseAPIUrl + 'updatecampaignlist/:campaignID', { campaignID: '@campaignID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    /* get  payment_diet for edit in newbill */
    api.getcampaignlist = {

      getID: $resource(api.baseAPIUrl + 'getcampaignlist/:campaignID/:host/:path', { campaignID: '@campaignID', host: '@host', path: '@path' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }

      ),
    }


    /* get  payment_diet for edit in newbill */
    api.getcampaign = {

      getID: $resource(api.baseAPIUrl + 'getcampaign/:campaignID', { campaignID: '@campaignID' }, { get: { method: 'GET', isArray: true } }, { update: { method: 'PUT' } }

      ),
    }
    //update odc data
    api.updateOdcorder = {

      getID: $resource(api.baseAPIUrl + 'updateOdcorder/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //update sales_payment data
    api.editsalespayment = {

      getID: $resource(api.baseAPIUrl + 'editsalespayment/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    //update sales_payment data
    api.update_customer = {

      getID: $resource(api.baseAPIUrl + 'update_customer/:customer_id', { customer_id: '@customer_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //update sales_payment data
    api.editsales_customer = {

      getID: $resource(api.baseAPIUrl + 'editsales_customer/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    //update sales_payment data
    api.editcustomer_feedback = {

      getID: $resource(api.baseAPIUrl + 'editcustomer_feedback/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    //delete salas_items
    api.deletesales_items = {
      getID: $resource(api.baseAPIUrl + 'deletesales_items/:salesitem_id', { salesitem_id: '@salesitem_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    //delete salas_items
    api.deleteodcsales_items = {
      getID: $resource(api.baseAPIUrl + 'deleteodcsales_items/:salesitem_id', { salesitem_id: '@salesitem_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    //delete salas_items
    api.delete_salematerial_data = {
      getID: $resource(api.baseAPIUrl + 'delete_salematerial_data/:inventory_salesOrder_id', { inventory_salesOrder_id: '@inventory_salesOrder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //delete salas_items
    api.delete_rawmaterial_data = {
      getID: $resource(api.baseAPIUrl + 'delete_rawmaterial_data/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }



    //delete salas_items
    api.delete_expense_items = {


      getID: $resource(api.baseAPIUrl + 'delete_expense_items/:expense_item_id', { expense_item_id: '@expense_item_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //delete salas_items
    api.delete_expense = {
      getID: $resource(api.baseAPIUrl + 'delete_expense/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }



    //update new exoense data
    api.update_expense_data = {

      getID: $resource(api.baseAPIUrl + 'update_expense_data/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }



    //update new exoense data
    api.update_newexpenseitem = {

      getID: $resource(api.baseAPIUrl + 'update_newexpenseitem/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }



    //delete salas_items
    api.delete_purchase_items = {
      getID: $resource(api.baseAPIUrl + 'delete_purchase_items/:purchase_items_id', { purchase_items_id: '@purchase_items_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //delete salas_items
    api.delete_salematerial_items = {
      getID: $resource(api.baseAPIUrl + 'delete_salematerial_items/:inventory_salesItems_id', { inventory_salesItems_id: '@inventory_salesItems_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //update new exoense data
    api.update_expensepayment = {

      getID: $resource(api.baseAPIUrl + 'update_expensepayment/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    //update new exoense data
    api.update_expensepayment_purchase = {

      getID: $resource(api.baseAPIUrl + 'update_expensepayment_purchase/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    //update new exoense data
    api.update_expensepayment_sales = {

      getID: $resource(api.baseAPIUrl + 'update_expensepayment_sales/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //update sales_payment data
    api.update_purchase_orders = {

      getID: $resource(api.baseAPIUrl + 'update_purchase_orders/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //update sales_payment data
    api.update_inventorySale_order = {

      getID: $resource(api.baseAPIUrl + 'update_inventorySale_order/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }



    //update sales_payment data
    api.update_purchase_items = {

      getID: $resource(api.baseAPIUrl + 'update_purchase_items/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    //update sales_payment data
    api.update_inventorySale_items = {

      getID: $resource(api.baseAPIUrl + 'update_inventorySale_items/:purchase_order_id', { purchase_order_id: '@purchase_order_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }



    /* vendor  */
    api.expense_deletefile = {

      getID: $resource(api.baseAPIUrl + 'expense_deletefile/:expense_bill_id', { expense_bill_id: '@expense_bill_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    /*----MERGE BILL---*/

    // POST SALESORDER_ITEM IN MERGE BILL
    api.post_salesorder_item = {
      getAll: $resource(api.baseAPIUrl + 'post_salesorder_item', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }



    // update SALESORDER_ITEM IN MERGE BILL
    api.update_salesorder_item = {
      getID: $resource(api.baseAPIUrl + 'update_salesorder_item/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }

    // update SALESORDER_ITEM IN MERGE BILL
    api.update_sales_payment = {
      getID: $resource(api.baseAPIUrl + 'update_sales_payment/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    // update SALESORDER_ITEM IN MERGE BILL
    api.update_postPayment = {
      getID: $resource(api.baseAPIUrl + 'update_postPayment/:salesorder_id', { salesorder_id: '@salesorder_id' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }


    //date wise change data in inventory food

    api.schedule_data = {
      getID: $resource(api.baseAPIUrl + 'schedule_data/:date', { date: '@date' }, { get: { method: 'GET', isArray: true } }),
    }


    //date wise change data in inventory food

    api.dashboard_analytics_date = {
      getID: $resource(api.baseAPIUrl + 'dashboard_analytics_date/:date/:toDate/:staffID/:branch_id/:month/:year', { date: '@date', staffID: '@staffID', branch_id: '@branch_id', month: '@month', year: '@year' }, { get: { method: 'GET', isArray: true } }),
    }


    //get delivery kitchen data

    api.getkitchendata = {
      getAll: $resource(api.baseAPIUrl + 'getkitchendata', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    api.update_local_json = {
      getAll: $resource(api.baseAPIUrl + 'update_local_json', { domain_category: '@domain_category' }, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
    }

    /* Tax */
    api.taxs = {
      getAll: $resource(api.baseAPIUrl + 'tax', null, { get: { method: 'GET', isArray: true } }, { save: { method: 'POST' } }),
      getID: $resource(api.baseAPIUrl + 'tax/:taxID', { taxID: '@taxID' }, { update: { method: 'PUT' } }, { delete: { method: 'DELETE' } }),
    }
    api.rawUnit = $resource('app/data/food/unit/unit.json');
    api.foodType = $resource('app/data/food/type/type.json');
    api.printsize = $resource('app/data/settings/print/print.json');
    api.foodUnit = $resource('app/data/food/unit/unit.json');
    api.corporate_settings = $resource('app/data/corporate_settings/corporate_settings.json');
    $rootScope.user = $cookies.getObject('user');

    // api.dietType = function(){

    //var category = $rootScope.user[0].domain_category;
    //  console.log(category);
    // return $resource("app/corporate/" + category +"/general.json");
    //  };
    //  


    // if($rootScope.user){
    //console.log($rootScope.user[0].domain_category);
    //api.dietType = $resource("app/corporate/" + $rootScope.user[0].domain_category +"/general.json");

    //}
    // api.dietType = $resource('app/data/newbill/dietType.json');
    api.corporate_settings = $resource('app/data/corporate_settings/corporate_settings.json');
    api.odc_category = $resource('app/data/odcbill/odc_category.json');
    api.expense_amountType = $resource('app/data/expensebill/expensebill.json');
    api.dietType = $resource('app/data/newbill/dietType.json');
    api.getLocalJsonIUrl = $resource('app/corporate/restaurants/general.json');



    /*      api.readModulesById = function(module_id) {
                   var deferred = $q.defer();
                   $http.get(api.baseAPIUrl + 'getModulesById?module_id='+module_id).success(function(data) {
                       deferred.resolve(data);
                       console.log(data);
                   }).error(function(data, status) {
                       deferred.reject(data);
                   });

                   return deferred.promise;
               }
               
               api.readModulesByLevel = function(level) {
                   var deferred = $q.defer();
                   $http.get(api.baseAPIUrl + 'readModulesByLevel?level='+level).success(function(data) {
                       deferred.resolve(data);
                       console.log(data);
                   }).error(function(data, status) {
                       deferred.reject(data);
                   });

                   return deferred.promise;
               }
               
               api.getUserByCompanyId = function(comp_id) {
                   var deferred = $q.defer();
                   $http.get(api.baseAPIUrl + 'getUserByCompanyId?comp_id='+comp_id).success(function(data) {
                       deferred.resolve(data);
                       console.log(data);
                   }).error(function(data, status) {
                       deferred.reject(data);
                   });

                   return deferred.promise;
               }
               */




    /*
        appServices.factory('MyService', function($http, $q, Options) {
            return {
                read: function(id) {
                    var deferred = $q.defer();

                    $http.get(Options.baseUrl + '/read/' + id).success(function(data) {
                        deferred.resolve(data);
                    }).error(function(data, status) {
                        deferred.reject(data);
                    });

                    return deferred.promise;
                },

                create: function(data) {
                    var deferred = $q.defer();

                    $http.post(Options.baseUrl + '/create', {data: "my data"}).success(function(data) {
                        deferred.resolve(data);
                    }).error(function(data, status){
                        deferred.reject(data);
                    });

                    return deferred.promise;
                },

                edit: function(data) {
                    var deferred = $q.defer();

                    $http.put(Options.baseUrl + '/edit', {data: "my data"}).success(function(data) {
                        deferred.resolve(data);
                    }).error(function(data, status) {
                        deferred.reject(data);
                    });

                    return deferred.promise;
                },

                delete: function(id) {
                    var deferred = $q.defer();

                    $http.delete(Options.baseUrl + '/delete/' + id).success(function(data) {
                        deferred.resolve(data);
                    }).error(function(data, status) {
                        deferred.reject(data);
                    });

                    return deferred.promise;
                }
            };
        });
        
    */


    // api.sample = $resource(api.baseUrl + 'sample/sample.json');

    return api;
  }

  function fileReader($q, $log) {
    var onLoad = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function (reader, scope) {
      return function (event) {
        scope.$broadcast("fileProgress", {
          total: event.total,
          loaded: event.loaded
        });
      };
    };

    var getReader = function (deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }

  function fileReaderDirective(fileReader, $timeout) {
    return {
      scope: {
        ngModel: '='
      },
      link: function ($scope, el) {
        function getFile(file) {
          fileReader.readAsDataUrl(file, $scope)
            .then(function (result) {
              $timeout(function () {
                $scope.ngModel = result;
              });
            });
        }

        el.on("change", function (e) {
          var file = (e.srcElement || e.target).files[0];
          getFile(file);
        });
      }
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('app.inventory', ['app.inventory.stockSaleMaterial','ngFileUpload','app.inventory.smSalesOrder','app.inventory.stockRawMaterial','app.inventory.addPurchase','app.inventory.addSales', 'app.inventory.deliverToKitchen', 'app.inventory.rmPurchasedOrder'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

  }
})();

(function() {
  'use strict';

  angular
    .module('app.odc', ['app.odc.new-odc','app.odc.paidOdc', 'app.odc.currentOdc'])
    .config(config);

  /** @ngInject */ 
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

  }
})();

(function() {
  'use strict';

  angular
    .module('app.expense', ['app.expense.newExpense','ngFileUpload', 'app.expense.paidExpense', 'app.expense.balanceExpense'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

  }
})();

(function() {
  'use strict';

  angular
    .module('app.dealer', ['ngFileUpload','app.dealer.smDealerOrder','app.dealer.addDealer'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

  }
})();

(function() {
  'use strict';

  angular
    .module('app.billing', ['app.billing.newBill', 'app.billing.paidBills', 'app.billing.returnbills', 'app.billing.addreturnbill','app.billing.trashBills', 'app.billing.currentBills', 'angular-timeline'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

  }
})();

(function() {
  'use strict';

  angular
    .module('app.superadmin', ['super-admin-dashboard','branchlist', 'addbranch', 'design-color', 'restaurantaccount'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // msNavigationServiceProvider.saveItem('blank', {
    //   title: 'Blank',
    //   icon: 'icon-tile-four',
    //   state: 'app.blank',
    //   weight: 1
    // });

  }
})();
(function() {
  'use strict';

  angular
    .module('app.ssadmin', ['ssadmin-dashboard','createcompany', 'editcompany', 'listcompany', 'settings-level'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // msNavigationServiceProvider.saveItem('blank', {
    //   title: 'Blank',
    //   icon: 'icon-tile-four',
    //   state: 'app.blank',
    //   weight: 1
    // });

  }
})();
(function() {
  'use strict';

  angular
    .module('app.cashier', ['app.billing', 'app.dashboard','addcampaign','finishedcampaign','customer-list', 'app.expense', 'app.dealer', 'app.profile', 'app.permission-denied', 'app.inventory', 'app.odc','app.onlinestorage','addwhatsappcampaign', 'whatsappfinishedcampaign'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

 //$translatePartialLoaderProvider.addPart('app/corporate/garments');
    // msNavigationServiceProvider.saveItem('dashboard', {
    //   title: 'Dashboard',
    //   icon: 'icon-tile-four',
    //   state: 'app.dashboard',
    //   translate: 'DASHBOARD.DASHBOARD_NAV',
    // });
    //
    // // Navigation
    // msNavigationServiceProvider.saveItem('cashier', {
    //   title: 'F & B Billing',
    //   group: true
    // });
    //
    // msNavigationServiceProvider.saveItem('cashier.newBill', {
    //   title: 'New Bill',
    //   icon: 'icon-plus',
    //   state: 'app.newBill',
    //   /*stateParams: {
    //       'param1': 'page'
    //    },*/
    //   translate: 'NEWBILL.NEWBILL_NAV'
    // });
    //
    //
    // msNavigationServiceProvider.saveItem('cashier.currentBills', {
    //   title: 'Current Bills',
    //   icon: 'icon-clipboard-text',
    //   state: 'app.currentBills',
    //   translate: 'CURRENTBILLS.CURRENTBILLS_NAV'
    // });
    //
    // msNavigationServiceProvider.saveItem('cashier.paidBills', {
    //   title: 'Paid Bills',
    //   icon: 'icon-receipt',
    //   state: 'app.paidBills',
    //   translate: 'PAIDBILLS.PAIDBILLS_NAV'
    // });





  }
})();

(function() {
  'use strict';

  angular
    .module('app.captain', ['blank', 'general'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    // msNavigationServiceProvider.saveItem('blank', {
    //   title: 'Blank',
    //   icon: 'icon-tile-four',
    //   state: 'app.blank',
    //   weight: 1
    // });

  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin', ['admindashboard', 'adduser','corporatedetails','print','users-list','viewcashier', 'users-role', 
      'editcashier', 'tablesettings','ThirdParty','food-settings','point-settings', 'food-settings-category', 'food-settings-combo', 'settings-tax','banquet-hall','locality','rm-item', 'rm-category', 'si-item', 'si-category', 'vendors', 'expense-category'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {


    // msNavigationServiceProvider.saveItem('blank', {
    //   title: 'Blank',
    //   icon: 'icon-tile-four',
    //   state: 'app.blank',
    //   weight: 1
    // });

  }
})();
(function() {
  'use strict';

  angular
    .module('app.auth', [
      'app.auth.login',
      // 'app.auth.login-v2',
      // 'app.auth.register',
      // 'app.auth.register-v2',
      // 'app.auth.forgotPassword',
      // 'app.auth.resetPassword'
      // 'app.auth.lock',
    ])
    .config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
    	
      
  // var a='app';
       // $translatePartialLoaderProvider.addPart('app/toolbar');
         //$translatePartialLoaderProvider.addPart(a);
    }
})();

(function() {
  'use strict';

  angular
    .module('app.main', ['branch', 'role', 'app.captain', 'app.cashier', 'app.ssadmin', 'app.admin', 'app.superadmin'])
    .config(config);

  /** @ngInject */
  function config($breadcrumbProvider, $translatePartialLoaderProvider) {
    $breadcrumbProvider.setOptions({
      template: '<h2 flex><span ng-repeat="step in steps"><span class="cursor-pointer" ui-sref="{{step.ncyBreadcrumbStateRef}}" >{{step.ncyBreadcrumbLabel}}</span><md-icon class="text-center" md-font-icon="icon icon-chevron-right" ng-if="!$last"></md-icon></span></h2>'
    });


    $translatePartialLoaderProvider.addPart('app');



    // Translation

  }
})();

(function() {
  'use strict';

  /**
   * Directives module of the Fuse
   */
  angular
    .module('app.customDirectives', [

      // Star Rating
      'starRating'

    ]);
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-list class=\"padding-top-0\"><md-subheader class=\"md-no-sticky\"><span class=\"font-size-16\">NOTIFICATIONS\n</span></md-subheader><md-divider></md-divider><md-list-item class=\"md-2-line status-unread\" \nng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3 class=\"layout-row layout-align-space-between-center\">\n<span class=\"flex line-height-normal md-truncate\">Delivery time is nearing</span> <span \nclass=\"flex-none text-black-40 font-size-14 padding-left-5\">1hr ago</span></h3><p><span \nclass=\"font-size-px-14-force padding-top-5 display-block\">Ordred no. 46475</span></p></div></md-list-item><md-list-item\n class=\"md-2-line status-read\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3 \nclass=\"layout-row layout-align-space-between-center\"><span class=\"flex line-height-normal md-truncate\">\nDelivery time is nearing</span> <span class=\"flex-none text-black-40 font-size-14 padding-left-5\">2hr ago</span></h3>\n<p><span class=\"font-size-px-14-force padding-top-5 display-block\">Ordred no. 46477</span></p></div></md-list-item>\n</md-list></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2 layout-column flex\"><div class=\"ui-content flex scrollable\" ms-scroll \nui-view=\"content\"></div></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/branch/branch.html","<div class=\"layout-column layout-align-center-center layout-fill role-container role-bg\"><div class=\"layout-row\"><a \nlayout=\"column\" class=\"role-icon\" ng-click=\"removecookies(branch);\" ng-repeat=\"branch in filterbranches\"><img \nsrc=\"assets/icons/role/branch.svg\"><h3>{{branch.branch_name}}</h3><h6>{{branch.city}}</h6></a></div><md-button \nng-click=\"vm.logout()\" style=\"position: absolute; right: 16px; top: 16px\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon>Logout</md-button></div>");
$templateCache.put("app/main/role/role.html","<div class=\"overlay\" ng-show=\"loading\"><div class=\"center-loader md-whiteframe-14dp\" layout=\"row\"><md-progress-circular\n md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><span>Please Wait...</span></div></div><div \nclass=\"layout-column layout-align-center-center layout-fill role-container role-bg\" \nng-if=\"vm.manageadmin == \'manageadmin\'\"><h1 class=\"mb-32\">Select the Branches</h1><div class=\"branch-container\"><div \nclass=\"branch-box\" ng-repeat=\"branch in vm.branch_data\" ng-click=\"vm.selectBranch(branch); vm.navToAdmin()\"><h3>\n{{branch.branch_name}}</h3></div></div></div><div \nclass=\"layout-column layout-align-center-center layout-fill role-container role-bg\" \nng-if=\"vm.manageadmin != \'manageadmin\'\"><h1 class=\"mb-32\">Select the role of <strong>{{branch_name}}</strong></h1><div \nclass=\"layout-row\"><a ng-click=\"vm.navToAdmin()\" layout=\"column\" class=\"role-icon\"><md-tooltip md-direction=\"bottom\">\nView & Manage all the users data</md-tooltip><img src=\"assets/icons/role/admin.svg\"><h3 translate=\"USERS.ADMIN\">Admin\n</h3></a><a ng-click=\"vm.navToCashier()\" layout=\"column\" class=\"role-icon\"><md-tooltip md-direction=\"bottom\">\nView & Manage only your data</md-tooltip><img src=\"assets/icons/role/user.svg\"><h3>User</h3></a><a \nng-click=\"vm.navToSteward()\" layout=\"column\" class=\"role-icon\" ng-if=\"stewardappp[0] == \'stewardapp\'\"><md-tooltip \nmd-direction=\"bottom\">Create & Manage the your orders</md-tooltip><img src=\"assets/icons/role/steward.svg\"><h3>Steward\n</h3></a></div><md-button ng-click=\"vm.logout()\" style=\"position: absolute; right: 16px; top: 16px\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon>Logout</md-button></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin/adduser/adduser.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg padding-24 mb-24\"><div \nclass=\"m-w-720 medium-large\"><form name=\"addUser\" novalidate><div class=\"sub-head mb-24 mt-8\">\nSelect the {{\'USERS.ROLE\' | translate}}</div><div layout-wrap layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-accent\" ng-hide=\"show\" flex=\"50\"><label>Select {{\'USERS.ROLE\' | translate}}</label><md-select \nng-model=\"vm.user.role\" class=\"md-accent\" required><md-option ng-repeat=\"role in vm.userRoles\" value=\"{{role.roleID}}\">\n{{role.role_name}}</md-option></md-select></md-input-container></div><hr class=\"mb-24 mt-24 md-block\"><div \nclass=\"sub-head mb-24\">Personal details</div><div layout=\"column\" flex><md-input-container class=\"md-accent\"><label>\n{{\'USERS.NAME\' | translate}}</label><input type=\"text\" name=\"name\" ng-model=\"vm.user.name\" \nng-minlength=\"{{user.name.minlength}}\" ng-maxlength=\"{{user.name.maxlength}}\" ng-required=\"user.name.required\"><div \nng-messages=\"addUser.name.$dirty || addUser.name.$error\" role=\"alert\" multiple=\"multiple\"><span \nng-show=\"addUser.name.$error.minlength\">Please enter minimum 3 characters!</span> <span \nng-show=\"addUser.name.$error.maxlength\">Please enter maximum 30 characters!</span><div ng-message=\"required\"><span>\nPlease enter the name</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label>{{\'VENDOR.MOBILE-NO\' | translate}}</label><input type=\"text\" \nname=\"mobile\" ng-keypress=\"onlynumber($event);\" maxlength=\"10\" ng-model=\"vm.user.mobile1\" ng-required=\"true\"><div \nng-messages=\"addUser.mobile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the mobile number</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-accent ml-8\" flex-gt-sm><label>Another {{\'VENDOR.MOBILE-NO\' | translate}}</label><input type=\"text\" \nng-keypress=\"onlynumber($event);\" maxlength=\"10\" ng-model=\"vm.user.mobile2\"></md-input-container></div><div \nlayout-gt-sm=\"row\" class=\"hide\"><md-input-container class=\"md-block md-accent\" flex-gt-sm><label for=\"email\">\n{{\'BILLINGS.CUSTOMER-LIST.EMAIL\' | translate}}</label><input type=\"email\" name=\"email\" ng-model=\"vm.user.email\" \nng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"addUser.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Please enter the valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-accent\" flex-gt-sm><label>{{\'USERS.QUALIFICATION\' | translate}}</label><input \ntype=\"text\" ng-model=\"vm.user.Qualification\"></md-input-container><md-input-container class=\"md-block md-accent\" \nflex-gt-sm><label>DOB</label><md-datepicker ng-model=\"vm.user.birthDate\" class=\"md-accent\" md-current-view=\"year\" \nmd-placeholder=\"Enter date\"></md-datepicker><div class=\"hint ml-56\">MM/DD/YYYY</div></md-input-container></div>\n<md-input-container class=\"md-block md-accent\" flex-gt-sm><label>{{\'BILLINGS.CUSTOMER-LIST.ADDRESS\' | translate}}\n</label><input type=\"text\" ng-model=\"vm.user.address\"></md-input-container><div layout-gt-sm=\"row\" class=\"hide\">\n<md-input-container class=\"md-block md-accent\" flex-gt-sm><label>{{\'BILLINGS.CUSTOMER-LIST.CITY\' | translate}}</label>\n<input type=\"text\" ng-model=\"vm.user.city\"></md-input-container><md-input-container class=\"md-block md-accent ml-8\" \nflex-gt-sm><label>{{\'BILLINGS.CUSTOMER-LIST.STATE\' | translate}}</label><input type=\"text\" ng-model=\"vm.user.state\">\n</md-input-container><md-input-container class=\"md-block md-accent ml-8\" flex-gt-sm><label>\n{{\'BILLINGS.CUSTOMER-LIST.COUNTRY\' | translate}}</label><input type=\"text\" ng-model=\"vm.user.country\">\n</md-input-container></div><div layout-gt-sm=\"row\" class=\"hide\"><md-input-container class=\"md-block md-accent\" \nflex-gt-sm><label>{{\'USERS.JOINING-DATE\' | translate}}</label><md-datepicker ng-model=\"vm.user.joinDate\" \nclass=\"md-accent\" md-current-view=\"year\" md-placeholder=\"Enter date\"></md-datepicker><div class=\"hint ml-56\">MM/DD/YYYY\n</div></md-input-container><md-input-container class=\"md-accent md-block ml-8\" flex-gt-sm><label>\n{{\'USERS.SALARY-MODE\' | translate}}</label><md-select ng-model=\"vm.user.salarymode\" class=\"md-accent\"><md-option \nclass=\"md-accent\" ng-repeat=\"salarymode in vm.salarymodelist\" value=\"{{salarymode.value}}\">{{salarymode.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block md-accent ml-8\" flex-gt-sm><label>\n{{\'USERS.SALARY-PRICE\' | translate}} ₹</label><input type=\"text\" name=\"salary\" ng-keypress=\"onlynumber($event);\" \nmaxlength=\"10\" ng-model=\"vm.user.salary\"><div ng-messages=\"addUser.salary.$error\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"pattern\"><span>Please enter the numbers only (ex. 3000)</span></div></div></md-input-container></div>\n<md-checkbox ng-model=\"appaccess\" ng-checked=\"\" class=\"mt-16\">{{\'USERS.APP-ACCESS\' | translate}}</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Allow to access to login in app and manage.</div><div \nng-show=\"appaccess\" layout=\"column\"><md-input-container class=\"md-block md-accent\"><label for=\"email\">\n{{\'USERS.USERNAME\' | translate}}</label><input type=\"email\" name=\"username\" ng-model=\"vm.user.username\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-required=\"appaccess\"><div ng-messages=\"addUser.username.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the Email id</span></div><div ng-message=\"pattern\">\n<span>Please enter the valid Email id</span></div></div></md-input-container><div ng-hide=\"!params.id\" \nclass=\"layout-row layout-align-start-start\"><md-button class=\"md-primary ml-0 mb-8\" aria-label=\"submit\" \nng-click=\"OpenPassword = !OpenPassword\">Edit Password</md-button></div><md-input-container class=\"md-accent mb-8\" \nng-show=\"OpenPassword\" ng-if=\"params.id\"><label>{{\'USERS.PASSWORD\' | translate}}</label><input type=\"password\" \nng-model=\"vm.user.updatepassword\"></md-input-container><md-input-container ng-if=\"!params.id\" class=\"md-accent\"><label>\n{{\'USERS.PASSWORD\' | translate}}</label><input type=\"password\" ng-model=\"vm.user.password\" ng-required=\"appaccess\">\n</md-input-container><div><div class=\"sub-head mb-24\">{{\'USERS.APP-MODULE\' | translate}}</div><div layout=\"column\" \nclass=\"padding-16 ash-color mb-16\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"params.id && admin.length ? true : \'\'\" ng-model=\"selectedAll\">Admin Permission</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage all the module with full Privileges</div><div \nstyle=\"display: none\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"(stewardapp.length ? selectedAll : \'\') || stewardappp.length\" ng-true-value=\"\'99\'\" ng-false-value=\"\'\'\" \nng-model=\"stewardapp\" ng-disabled=\"selectedAll\" ng-change=\"selectdAll()\"><span translate=\"\">Steward App</span>\n</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\" \nng-show=\"salesbills.length || salesbillss.length\">Manage POS bill and amount</div></div><md-checkbox \nname=\"{{checkbox.name}}\" ng-show=\"salesbills.length || salesbillss.length\" \nng-checked=\"(salesbills.length ? selectedAll : \'\') || salesbillss.length\" ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" \nng-model=\"salesbill\" ng-disabled=\"selectedAll\" ng-change=\"selectdAll()\"><span translate=\"\">BILLINGS.POS-BILL</span>\n</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\" \nng-show=\"salesbills.length || salesbillss.length\">Manage POS bill and amount</div><div layout-gt-sm=\"row\" \nng-show=\"salesbill\" class=\"inner-permission\"><div layout=\"column\"><md-checkbox name=\"{{checkbox.name}}\" \nng-show=\"salesbills.length\" \nng-checked=\"((params.id&&!saleseditt.length ? salesbill : \'\' )||(salesbills.length ? selectedAll : \'\') || saleseditt.length)&&salesbill\" \nng-true-value=\"\'12\'\" ng-false-value=\"\'\'\" ng-model=\"salesedit\" ng-disabled=\"selectedAll\">Edit</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Allow to edit after finished the bills</div></div></div><md-checkbox\n name=\"{{checkbox.name}}\" ng-show=\"expensebills.length\" \nng-checked=\"(expensebills.length ? selectedAll : \'\') || expensebillss.length\" ng-true-value=\"\'2\'\" ng-false-value=\"\'\'\" \nng-model=\"expensebill\" ng-disabled=\"selectedAll\"><span translate=\"\">EXPENSE.EXPENSE</span></md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\" ng-show=\"expensebills.length\">Manage expense bill and amount</div>\n<div layout-gt-sm=\"row\" ng-show=\"expensebill\" class=\"inner-permission\"><div layout=\"column\"><md-checkbox \nname=\"{{checkbox.name}}\" ng-show=\"expensebills.length\" \nng-checked=\"((params.id&&!expenseeditt.length&&!expensedeletee.length ? expensebill : \'\' )||(expensebills.length ? selectedAll : \'\') || expenseeditt.length)&&expensebill\" \nng-true-value=\"\'22\'\" ng-false-value=\"\'\'\" ng-model=\"expenseedit\" ng-disabled=\"selectedAll\">Edit</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Allow to edit after finished the bills</div></div><div \nlayout=\"column\" class=\"ml-16\"><md-checkbox name=\"{{checkbox.name}}\" ng-show=\"expensebills.length\" \nng-checked=\"((params.id&&!expensedeletee.length&&!expenseeditt.length ? expensebill : \'\' )||(expensebills.length ? selectedAll : \'\') || expensedeletee.length)&&expensebill\" \nng-true-value=\"\'23\'\" ng-false-value=\"\'\'\" ng-model=\"expensedelete\" ng-disabled=\"selectedAll\">Delete</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Allow to delete the bills</div></div></div><md-checkbox \nname=\"{{checkbox.name}}\" ng-show=\"ODC.length\" ng-checked=\"(ODC.length ? selectedAll : \'\') || ODCC.length\" \nng-true-value=\"\'4\'\" ng-false-value=\"\'\'\" ng-model=\"odc\" ng-disabled=\"selectedAll\"><span translate=\"\">ODC.ODC-BANQUET\n</span></md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\" ng-show=\"ODC.length\">\nManage ODC/ Banquet bill and amount</div><div layout-gt-sm=\"row\" ng-show=\"odc\" class=\"inner-permission\"><div \nlayout=\"column\"><md-checkbox name=\"{{checkbox.name}}\" ng-show=\"ODC.length||odceditt.length\" \nng-checked=\"((params.id&&!odceditt.length&&!odcdeletee.length ? odc : \'\' )||(ODC.length ? selectedAll : \'\')||odceditt.length)&&odc\" \nng-true-value=\"\'42\'\" ng-false-value=\"\'\'\" ng-model=\"odcedit\" ng-disabled=\"selectedAll\">Edit</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Allow to edit after finished the bills</div></div><div \nlayout=\"column\" class=\"ml-16\"><md-checkbox name=\"{{checkbox.name}}\" ng-show=\"ODC.length||odcdeletee.length\" \nng-checked=\"((params.id&&!odcdeletee.length&&!odceditt.length ? odc : \'\' )||(ODC.length ? selectedAll : \'\')||odcdeletee.length)&&odc\" \nng-true-value=\"\'43\'\" ng-false-value=\"\'\'\" ng-model=\"odcdelete\" ng-disabled=\"selectedAll\">Delete</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Allow to delete the bills</div></div></div><md-checkbox \nname=\"{{checkbox.name}}\" ng-show=\"Inventory.length\" \nng-checked=\"selectedAll ? selectedAll : (rawmaterial||salesmaterial ? inventory : false)\" ng-true-value=\"\'3\'\" \nng-false-value=\"\'\'\" ng-model=\"inventory\" ng-disabled=\"selectedAll\"><span translate=\"\">Inventory.Inventory</span>\n</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\" ng-show=\"Inventory.length|| Inventoryy.length\">\nManage the stock item and purchase orders</div><div layout-gt-sm=\"row\" ng-show=\"inventory\" class=\"inner-permission\">\n<div layout=\"column\" ng-show=\"Rawmaterial.length || Rawmaterialss.length\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"((params.id&&Rawmaterialss.length!=0&&salematerialss.length!=0 ? inventory : \'\' )||(Rawmaterial.length ? selectedAll : \'\')|| Rawmaterialss.length)&&inventory\" \nng-true-value=\"\'31\'\" ng-false-value=\"\'\'\" ng-model=\"rawmaterial\" ng-disabled=\"selectedAll\">Raw Material</md-checkbox>\n<div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage raw material items and purchase orders</div></div><div \nlayout=\"column\" class=\"ml-16\" ng-show=\"salematerials.length || salematerialss.length\"><md-checkbox \nname=\"{{checkbox.name}}\" \nng-checked=\"((params.id&&salematerialss.length!=0&&Rawmaterialss.length!=0 ? inventory : \'\' )  ||(salematerials.length ? selectedAll : \'\')|| salematerialss.length)&&inventory\" \nng-true-value=\"\'32\'\" ng-false-value=\"\'\'\" ng-model=\"salesmaterial\" ng-disabled=\"selectedAll\">Sale Material</md-checkbox>\n<div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage sale material items and purchase orders</div></div>\n</div><md-checkbox name=\"{{checkbox.name}}\" ng-show=\"Marketing.length||Marketingg.length\" \nng-checked=\"selectedAll ? selectedAll : (customer||sms ? marketing : false)\" ng-true-value=\"\'5\'\" ng-false-value=\"\'\'\" \nng-model=\"marketing\" ng-disabled=\"selectedAll\"><span translate=\"\">BILLINGS.CUSTOMER-LIST.MARKETING</span></md-checkbox>\n<div class=\"secondary-text md-block ml-32 mb-24 mtm-16\" ng-show=\"Marketing.length||Marketingg.length\">\nViewing report of customer and sms campaign</div><div layout-gt-sm=\"row\" ng-show=\"marketing\" class=\"inner-permission\">\n<div layout=\"column\" ng-show=\"customerview.length || customerr.length\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"((params.id&&customerr.length!=0&&smss.length!=0 ? marketing : \'\' )||(customerview.length ? selectedAll : \'\')|| customerr.length)&&marketing\" \nng-true-value=\"\'51\'\" ng-false-value=\"\'\'\" ng-model=\"customer\" ng-disabled=\"selectedAll\">customer</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage customer module</div></div><div layout=\"column\" \nclass=\"ml-16\" ng-show=\"smss.length || smsview.length\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"((params.id&&smss.length!=0&&customerr.length!=0 ? marketing : \'\' )||(smsview.length ? selectedAll : \'\') || smss.length)&&marketing\" \nng-true-value=\"\'52\'\" ng-false-value=\"\'\'\" ng-model=\"sms\" ng-disabled=\"selectedAll\">sms campaign</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage sms campaign module</div></div><div layout=\"column\" \nclass=\"ml-16\" ng-show=\"whatsappp.length || whatsappview.length\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"((params.id&&whatsappp.length!=0&&customerr.length!=0 ? marketing : \'\' )||(whatsappview.length ? selectedAll : \'\') || whatsappp.length)&&marketing\" \nng-true-value=\"\'53\'\" ng-false-value=\"\'\'\" ng-model=\"whatsapp\" ng-disabled=\"selectedAll\">Whatsapp campaign</md-checkbox>\n<div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage whatsapp campaign module</div></div></div></div></div>\n</div><div class=\"layout-row layout-align-end-center\"><md-button ng-if=\"params.id&&accountStatus==\'inactive\'\" \nclass=\"md-primary margin-right-0 mb-24 mr-24\" ng-click=\"staffInactive($event)\" aria-label=\"submit\">Active</md-button>\n<md-button ng-if=\"params.id&&accountStatus==\'active\'\" class=\"md-primary margin-right-0 mb-24 mr-24\" \nng-click=\"staffInactive($event)\" aria-label=\"submit\">Inactive</md-button><md-button ng-if=\"!params.id\" \nclass=\"md-raised md-primary margin-right-0 mb-24\" ng-disabled=\"addUser.$invalid\" ng-click=\"submit()\" \naria-label=\"submit\">Submit</md-button><md-button ng-if=\"params.id\" class=\"md-raised md-primary margin-right-0 mb-24\" \nng-disabled=\"addUser.$invalid\" ng-click=\"update()\" aria-label=\"submit\">Update</md-button></div></div></form></div>\n</div>");
$templateCache.put("app/main/admin/admindashboard/admindashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple min-height-alter48px\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300 pl-24\">Welcome back, {{staff_name}}!</span>\n</div></div></div><div class=\"content\"><md-tabs md-dynamic-height md-selected=\"selectedIndex\"><md-tab label=\"Overview\" \nng-click=\"changeOdc(overview_restrict, staff,overviewodc)\" md-on-select=\"onTabChanges(0)\" \nng-if=\"toplevel_admin.length && vm.settings.show_overview_analytics\"><div \nng-include=\"\'app/main/admin/admindashboard/overview/overview.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"Today task\" ng-if=\"vm.settings.show_today_task\" md-on-select=\"onTabChanges(1)\"><div \nng-include=\"\'app/main/admin/admindashboard/today-task/today-task.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'BILLINGS.POS-BILL\' | translate}}\" ng-if=\"cashier_analytics_permission==true\" md-on-select=\"onTabChanges(2)\">\n<div ng-include=\"\'app/main/admin/admindashboard/pos-billing/pos-billing.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'ODC.ODC-BANQUET\' | translate}}\" ng-if=\"odc_analytics_permission==true\" \nng-click=\"changeOdc(odcrestrict, staffdata,odcs)\" md-on-select=\"onTabChanges(3)\"><div \nng-include=\"\'app/main/admin/admindashboard/odc/odc.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'EXPENSE.EXPENSE\' | translate}}\" ng-if=\"expense_analytics_permission==true\" md-on-select=\"onTabChanges(4)\">\n<div ng-include=\"\'app/main/admin/admindashboard/expense/expense.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'Inventory.Inventory\' | translate}}\" ng-if=\"inventory_analytics_permission==true\" \nmd-on-select=\"onTabChanges(5)\"><div ng-include=\"\'app/main/admin/admindashboard/inventory/inventory.html\'\" ms-scroll>\n</div></md-tab><md-tab label=\"{{\'BILLINGS.SMS-MARKETING\' | translate}}\" ng-if=\"sms==true\" \nmd-on-select=\"onTabChanges(6)\"><div ng-include=\"\'app/main/admin/admindashboard/sms-marketing/sms-marketing.html\'\" \nms-scroll></div></md-tab></md-tabs></div><div id=\"content3\" style=\"display: none\"><div \nng-include=\"\'app/main/admin/admindashboard/dailyexport.html\'\"></div></div></div></div>");
$templateCache.put("app/main/admin/admindashboard/dailyexport-backup.html","<style type=\"text/css\">\n#content-daily {padding: 0; font-family: \'Roboto\', Helvetica, Arial, sans-serif; font-weight: normal;font-size: 15px; line-height: 22px; color: #000; width:800px}\r\n#content-daily h1 {font-size:28px; margin-bottom: 0; padding-bottom: 20px; color: #2E7D32}\r\n#content-daily table {width: 800px;background-color: #FFF}\r\n#content-daily td span {display: block;}\r\n#content-daily ul.list {list-style: none; width: 100%; float: left; display: block;}\r\n#content-daily ul.list li {list-style-type: none; margin: 0; padding: 0; float: left; border:1px solid #eee; display: inline-block;}\r\n#content-daily .count-head {font-size:34px; font-weight:400}\r\n#content-daily .container18 {background:#000 !important; height:200pt; border:1px solid #000 !important; width: 800px;}\n</style><div id=\"content-daily\"><div ng-if=\"adminpermission.length\" style=\"width: 100%\"><h1>Daily Report</h1><span>\nDate And Time {{ReportTime | date:\'medium\'}}</span><h1 style=\"font-size:28px; margin-bottom: 0; padding-bottom: 0\">\nOverview</h1><table><tr><td align=\"center\" valign=\"top\"><span style=\"font-size:22px; font-weight:400\">\n{{(overview_posTotall + overviewodc_paymentt.paid_totals) | thousandSuffix : fractionSize}}</span>Income Amount</td><td\n align=\"center\" valign=\"top\"><span style=\"font-size:22px; font-weight:400\">\n{{(overviewtax_cgstt+overvie_wodcTax_cgstt)+(overviewtax_sgstt+overviewodc_wodcTax_sgstt) | thousandSuffix : fractionSize}}\n</span> Tax Amount</td><td align=\"center\" valign=\"top\"><span ng-if=\"expense_analytics_permission==true\">\n{{overview_expenseTotall | thousandSuffix : fractionSize}} Expense Amount</span></td></tr></table></div><div \nng-if=\"cashier_analytics_permission==true\"><h1 style=\"font-size:28px; margin-bottom: 0; padding-bottom: 0\">\n{{\'BILLINGS.POS-BILL\' | translate}}</h1>\n{{ \'BILLINGS.Total Amount\' | translate}}-{{dinein_amountt+takeaway_amountt+doordelivery_amountt | thousandSuffix : fractionSize}}\n<br>\n{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}}- {{total_cashh+total_cardd+orderedtotal_cashh+orderedtotal_cardd | thousandSuffix : fractionSize}}\n<br>\nBalance {{ \'BILLINGS.AMOUNT\' | translate}}-{{(dinein_amountt+takeaway_amountt+doordelivery_amountt)-(total_cashh+total_cardd+orderedtotal_cashh+orderedtotal_cardd) | thousandSuffix : fractionSize}}\n<br>Amount:<br><span class=\"ml-16 label\" ng-if=\"vm.settings.dinein_permission\"><span translate>BILLINGS.DIET-IN</span>\n-{{dinein_amountt | thousandSuffix : fractionSize}}</span><br><span class=\"ml-16 label\" \nng-if=\"vm.settings.takeaway_permission\"><span translate>BILLINGS.TAKE-AWAY</span>\n-{{takeaway_amountt | thousandSuffix : fractionSize}}</span><br><span class=\"ml-16 label\" \nng-if=\"vm.settings.doordelivery_permission\"><span translate>BILLINGS.DOOR-DELIVERY</span>\n-{{doordelivery_amountt | thousandSuffix : fractionSize}}</span><br><div flex \nclass=\"layout-align-center-center layout-row layout-xs-column layout-align-xs-center-center layout-sm-column layout-align-sm-center-center\">\n<span class=\"ml-16 label\">Total Tax- &nbsp; {{tax_sgstt+tax_cgstt | thousandSuffix : fractionSize}}</span><br><span \nclass=\"ml-16 label\">CGST- &nbsp; {{tax_cgstt | thousandSuffix : fractionSize}}</span><br><span class=\"ml-16 label\">\nSGST- &nbsp;{{tax_sgstt | thousandSuffix : fractionSize}}</span><br>Count:<br>\nTotal {{ \'BILLINGS.POS-BILL\' | translate}}-{{dinein_totall+takeaway_totall+doordelivery_totall}}<br><div \nng-if=\"vm.settings.dinein_permission\"><span class=\"label md-truncate\" translate>BILLINGS.DIET-IN</span> - <span>\n{{dinein_totall}}</span></div><div class=\"layout-column mt-8 w-100p\" ng-if=\"vm.settings.takeaway_permission\"><span \nclass=\"label md-truncate\" translate>BILLINGS.TAKE-AWAY</span>- <span>{{takeaway_totall}}</span></div><div \nclass=\"layout-column mt-8 w-100p\" ng-if=\"vm.settings.doordelivery_permission\"><span class=\"label md-truncate\" \ntranslate>BILLINGS.DOOR-DELIVERY</span>- <span>{{doordelivery_totall}}</span></div></div></div><div \nng-if=\"odc_analytics_permission==true\"><h1 style=\"color: orange\">{{ \'ODC.ODC-BANQUET\' | translate}}</h1>\n{{ \'ODC.EVENTS\' | translate}}- {{odc_paymentt.upcoming_events+odc_paymentt.finished_Events | thousandSuffix : fractionSize}}\n<br>{{\'ODC.UPCOMING-EVENTS\' | translate}}-{{odc_paymentt.upcoming_events | thousandSuffix : fractionSize}}<br>\n{{ \'ODC.FINISHED-EVENTS\' | translate}}-{{odc_paymentt.finished_Events | thousandSuffix : fractionSize}}<br>\nTotal {{ \'BILLINGS.AMOUNT\' | translate}}-{{odc_paymentt.paid_totals | thousandSuffix : fractionSize}}<br><span \nclass=\"ml-16 label\">Total Tax- &nbsp; {{Odctax_sgstt+Odctax_cgstt | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">CGST- &nbsp; {{Odctax_cgstt | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nSGST- &nbsp; {{Odctax_sgstt | thousandSuffix : fractionSize}}</span><br>\n{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}}-{{odc_paymentt.received_totals | thousandSuffix : fractionSize}}<br>\nBalance {{ \'BILLINGS.AMOUNT\' | translate}}-{{odc_paymentt.paid_totals-odc_paymentt.received_totals | thousandSuffix : fractionSize}}\n</div><div ng-if=\"expense_analytics_permission==true\"><h1>GENERAL {{\'EXPENSE.EXPENSE\' | translate}}</h1>\n{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}-{{total_paidd+total_balancee | thousandSuffix : fractionSize}}<br>\n{{\'EXPENSE.PAID-EXPENSE\' | translate}}-{{total_paidd | thousandSuffix : fractionSize}}<br>\n{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}-{{total_balancee | thousandSuffix : fractionSize}}<br><span \nclass=\"ml-16 label\">Tax Cgst- &nbsp; {{expensetaxx | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTax Sgst- &nbsp; {{expensetaxCgstt | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTotal Tax- &nbsp; {{expensetaxSgstt | thousandSuffix : fractionSize}}</span><br>\ncash-{{generalpaid_cashh | thousandSuffix : fractionSize}}<br>\ncard-{{generalpaid_cardd | thousandSuffix : fractionSize}}<br>\ncheque-{{generalpaid_chequee | thousandSuffix : fractionSize}}<br>\nonline-{{generalpaid_onlinee | thousandSuffix : fractionSize}}<br></div><div \nng-if=\"inventoryHide.length&&rawHide.length\"><h1 style=\"color: yellow\">PURCHASE {{\'EXPENSE.EXPENSE\' | translate}}</h1>\n{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}-{{purchasetotal_paidd+purchasetotal_balancee | thousandSuffix : fractionSize}}\n<br>{{\'EXPENSE.PAID-EXPENSE\' | translate}}-{{purchasetotal_paidd | thousandSuffix : fractionSize}}<br>\n{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}-{{purchasetotal_balancee | thousandSuffix : fractionSize}}<br><span \nclass=\"ml-16 label\">Tax Cgst- &nbsp; {{purchasetaxCgstt | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Sgst- &nbsp; {{purchasetaxSgstt | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Tax- &nbsp; {{purchasetaxx | thousandSuffix : fractionSize}}</span><br>\ncash-{{purchasepaid_cashh | thousandSuffix : fractionSize}}<br>\ncard-{{purchasepaid_cardd | thousandSuffix : fractionSize}}<br>\ncheque-{{purchasepaid_chequee | thousandSuffix : fractionSize}}<br>\nonline-{{purchasepaid_onlinee | thousandSuffix : fractionSize}}<br></div><div \nng-if=\"inventoryHide.length&&saleHide.length\"><h1 style=\"color: indigo\">SALES {{\'EXPENSE.EXPENSE\' | translate}}</h1>\n{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}-{{saletotal_paidd+saletotal_balancee | thousandSuffix : fractionSize}}<br>\n{{\'EXPENSE.PAID-EXPENSE\' | translate}}-{{saletotal_paidd | thousandSuffix : fractionSize}}<br>\n{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}-{{saletotal_balancee | thousandSuffix : fractionSize}}<br><span \nclass=\"ml-16 label\">Tax Cgst- &nbsp; {{salestaxCgstt | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Sgst- &nbsp; {{salestaxSgstt | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Tax- &nbsp; {{salestaxx | thousandSuffix : fractionSize}}</span><br>\ncash-{{salespaid_cashh | thousandSuffix : fractionSize}}<br>card-{{salespaid_cardd | thousandSuffix : fractionSize}}\n<br>cheque-{{salespaid_chequee | thousandSuffix : fractionSize}}<br>\nonline-{{salespaid_onlinee | thousandSuffix : fractionSize}}<br></div></div><div id=\"editor\"></div>");
$templateCache.put("app/main/admin/admindashboard/dailyexport.html","<style type=\"text/css\">\n#content-daily {\r\n  padding: 0;\r\n  font-family: \'Roboto\', Helvetica, Arial, sans-serif;\r\n  font-weight: normal;\r\n  font-size: 15px;\r\n  line-height: 22px;\r\n  color: #000;\r\n  width: 800px\r\n}\r\n\r\n#content-daily h1 {\r\n  font-size: 28px;\r\n  margin-bottom: 0;\r\n  padding-bottom: 20px;\r\n  color: #2E7D32; text-transform: uppercase;\r\n}\r\n\r\n#content-daily table {\r\n  width: 800px;\r\n}\r\n\r\n#content-daily th {\r\n  font-size: 15px;\r\n  line-height: 22px;\r\n}\r\n\r\n#content-daily td span {\r\n  display: block;\r\n}\r\n\r\n#content-daily ul.list {\r\n  list-style: none;\r\n  width: 100%;\r\n  float: left;\r\n  display: block;\r\n}\r\n\r\n#content-daily ul.list li {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  float: left;\r\n  border: 1px solid #eee;\r\n  display: inline-block;\r\n}\r\n\r\n#content-daily .count-head {\r\n  font-size: 34px;\r\n  font-weight: 400\r\n}\r\n\r\n#content-daily .count-subhead {\r\n  font-size: 24px;\r\n  font-weight: 400\r\n}\r\n\r\n#content-daily .container18 {\r\n  background: #000 !important;\r\n  height: 200pt;\r\n  border: 1px solid #000 !important;\r\n  width: 800px;\r\n}\n</style><div id=\"content-daily\"><div ng-if=\"adminpermission.length\" style=\"width: 100%\"><h1>DAILY REPORT</h1><span>\nDate And Time {{ReportTime | date:\'medium\'}}</span><h1 style=\"font-size:28px; margin-bottom: 0; padding-bottom: 0\">\nOverview</h1><table><tr><th>Income Amount</th><th>Tax Amount</th><th ng-if=\"expense_analytics_permission==true\">\nExpense Amount</th></tr><tr><td><span class=\"count-head\">\n{{(overview_posTotall + overviewodc_paymentt.paid_totals) | thousandSuffix : fractionSize}}</span></td><td><span \nclass=\"count-head\">\n{{(overviewtax_cgstt+overvie_wodcTax_cgstt)+(overviewtax_sgstt+overviewodc_wodcTax_sgstt) | thousandSuffix : fractionSize}}\n</span></td><td ng-if=\"expense_analytics_permission==true\"><span class=\"count-head\">\n{{overview_expenseTotall | thousandSuffix : fractionSize}}</span></td></tr></table></div><div \nng-if=\"cashier_analytics_permission==true\"><h1>{{\'BILLINGS.POS-BILL\' | translate}}</h1><div><span \nclass=\"count-subhead\">Total {{ \'BILLINGS.POS-BILL\' | translate}} {{dinein_totall+takeaway_totall+doordelivery_totall}}\n</span></div><table ng-if=\"domainCatergory=\'restaurants\'\"><tr><th ng-if=\"vm.settings.dinein_permission\"><span \ntranslate>BILLINGS.DIET-IN</span> Count</th><th ng-if=\"vm.settings.takeaway_permission\"><span translate>\nBILLINGS.TAKE-AWAY</span> Count</th><th ng-if=\"vm.settings.doordelivery_permission\"><span translate>\nBILLINGS.DOOR-DELIVERY</span> Count</th></tr><tr><td ng-if=\"vm.settings.dinein_permission\"><span class=\"count-head\">\n{{dinein_totall}}</span></td><td ng-if=\"vm.settings.takeaway_permission\"><span class=\"count-head\">{{takeaway_totall}}\n</span></td><td ng-if=\"vm.settings.doordelivery_permission\"><span class=\"count-head\">{{doordelivery_totall}}</span>\n</td></tr></table><table><tr><th>Total Amount</th><th>Received Amount</th><th>Balance Amount</th></tr><tr><td><span \nclass=\"count-head\">{{dinein_amountt+takeaway_amountt+doordelivery_amountt | thousandSuffix : fractionSize}}</span></td>\n<td><span class=\"count-head\">\n{{total_cashh+total_cardd+orderedtotal_cashh+orderedtotal_cardd | thousandSuffix : fractionSize}}</span></td><td><span \nclass=\"count-head\">\n{{(dinein_amountt+takeaway_amountt+doordelivery_amountt)-(total_cashh+total_cardd+orderedtotal_cashh+orderedtotal_cardd) | thousandSuffix : fractionSize}}\n</span></td></tr></table><table ng-if=\"domainCatergory=\'restaurants\'\"><tr><th ng-if=\"vm.settings.dinein_permission\">\n<span translate>BILLINGS.DIET-IN</span> Amount</th><th ng-if=\"vm.settings.takeaway_permission\"><span translate>\nBILLINGS.TAKE-AWAY</span> Amount</th><th ng-if=\"vm.settings.doordelivery_permission\"><span translate>\nBILLINGS.DOOR-DELIVERY</span> Amount</th></tr><tr><td ng-if=\"vm.settings.dinein_permission\"><span class=\"count-head\">\n{{dinein_amountt | thousandSuffix : fractionSize}}</span></td><td ng-if=\"vm.settings.takeaway_permission\"><span \nclass=\"count-head\">{{takeaway_amountt | thousandSuffix : fractionSize}}</span></td><td \nng-if=\"vm.settings.doordelivery_permission\"><span class=\"count-head\">\n{{doordelivery_amountt | thousandSuffix : fractionSize}}</span></td></tr></table><table><tr><th>Total Tax</th><th>CGST\n</th><th>SGST</th></tr><tr><td><span class=\"count-head\">{{tax_sgstt+tax_cgstt | thousandSuffix : fractionSize}}</span>\n</td><td><span class=\"count-head\">{{tax_cgstt | thousandSuffix : fractionSize}}</span></td><td><span \nclass=\"count-head\">{{tax_sgstt | thousandSuffix : fractionSize}}</span></td></tr></table></div><div \nng-if=\"odc_analytics_permission==true\"><h1>{{ \'ODC.ODC-BANQUET\' | translate}}</h1><table><tr><th>\n{{ \'ODC.EVENTS\' | translate}} Count</th><th>{{\'ODC.UPCOMING-EVENTS\' | translate}} Count</th><th>\n{{ \'ODC.FINISHED-EVENTS\' | translate}} Count</th></tr><tr><td><span class=\"count-head\">\n{{odc_paymentt.upcoming_events+odc_paymentt.finished_Events | thousandSuffix : fractionSize}}</span></td><td><span \nclass=\"count-head\">{{odc_paymentt.upcoming_events | thousandSuffix : fractionSize}}</span></td><td><span \nclass=\"count-head\">{{odc_paymentt.finished_Events | thousandSuffix : fractionSize}}</span></td></tr></table><table><tr>\n<th>Total {{ \'BILLINGS.AMOUNT\' | translate}}</th><th>{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}}</th><th>\nBalance {{ \'BILLINGS.AMOUNT\' | translate}}</th></tr><tr><td><span class=\"count-head\">\n{{odc_paymentt.paid_totals | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{odc_paymentt.received_totals | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{odc_paymentt.paid_totals-odc_paymentt.received_totals | thousandSuffix : fractionSize}}</span></td></tr></table>\n<table><tr><th>Total Tax</th><th>CGST</th><th>SGST</th></tr><tr><td><span class=\"count-head\">\n{{Odctax_sgstt+Odctax_cgstt | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{Odctax_cgstt | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{Odctax_sgstt | thousandSuffix : fractionSize}}</span></td></tr></table></div><div \nng-if=\"expense_analytics_permission==true\"><h1>{{\'EXPENSE.EXPENSE\' | translate}}</h1><table><tr><th>\n{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}</th><th>{{\'EXPENSE.PAID-EXPENSE\' | translate}}</th><th>\n{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}</th></tr><tr><td><span class=\"count-head\">\n{{total_paidd+total_balancee | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{total_paidd | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{total_balancee | thousandSuffix : fractionSize}}</span></td></tr></table><table><tr><th>Total Tax</th><th>CGST</th>\n<th>SGST</th></tr><tr><td><span class=\"count-head\">{{expensetaxx | thousandSuffix : fractionSize}}</span></td><td><span\n class=\"count-head\">{{expensetaxCgstt | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{expensetaxSgstt | thousandSuffix : fractionSize}}</span></td></tr></table></div><div \nng-if=\"inventoryHide.length&&rawHide.length\"><h1>Raw Material Intervory</h1><table><tr><th>Total Puchase Amount</th>\n<th>Paid Amount</th><th>Balance Amount</th></tr><tr><td><span class=\"count-head\">\n{{purchasetotal_paidd+purchasetotal_balancee | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{purchasetotal_paidd | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{purchasetotal_balancee | thousandSuffix : fractionSize}}</span></td></tr></table><table><tr><th>Total Tax</th><th>\nCGST</th><th>SGST</th></tr><tr><td><span class=\"count-head\">{{purchasetaxCgstt | thousandSuffix : fractionSize}}</span>\n</td><td><span class=\"count-head\">{{purchasetaxSgstt | thousandSuffix : fractionSize}}</span></td><td><span \nclass=\"count-head\">{{purchasetaxx | thousandSuffix : fractionSize}}</span></td></tr></table></div><div \nng-if=\"inventoryHide.length&&saleHide.length\"><h1>Sales Material Intervory</h1><table><tr><th>Total Puchase Amount</th>\n<th>Paid Amount</th><th>Balance Amount</th></tr><tr><td><span class=\"count-head\">\n{{saletotal_paidd+saletotal_balancee | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{saletotal_paidd | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{saletotal_balancee | thousandSuffix : fractionSize}}</span></td></tr></table><table><tr><th>Total Tax</th><th>CGST\n</th><th>SGST</th></tr><tr><td><span class=\"count-head\">{{salestaxCgstt | thousandSuffix : fractionSize}}</span></td>\n<td><span class=\"count-head\">{{salestaxSgstt | thousandSuffix : fractionSize}}</span></td><td><span class=\"count-head\">\n{{salestaxx | thousandSuffix : fractionSize}}</span></td></tr></table></div></div><div id=\"editor\"></div>");
$templateCache.put("app/main/admin/banquet-hall/settings-banquet.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"mw-860\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-24\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1;disable()\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\nAdd {{\"ODC.BANQUET-HALL\"|translate}}</md-button></div><div layout=\"row\" ng-show=\"show1\" \nclass=\"padding-16 ash-color mb-24 m-w-620\"><form name=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" \nlayout-wrap><md-input-container md-no-float class=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" \nng-keypress=\"restrict($event)\" ng-model=\"foodcategory.BanquetHallName\" name=\"catname\" \nplaceholder=\"{{\'ODC.BANQUET-HALL\'|translate}} Name\" required><div \nng-messages=\"(addCategory.catname.$touched && addCategory.catname.$error) || addCategory.$invalid\"><div \nng-message=\"required\">Please Enter The {{\"ODC.BANQUET-HALL\"|translate}} Name</div></div></md-input-container></div><div\n layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"cancelAddItem(addCategory); show1 = !show1\">Cancel\n</md-button><md-button class=\"md-primary md-raised\" layout-align-end ng-disabled=\"addCategory.$invalid\" \nng-click=\"addNewCategory(foodcategory); show1 = \'\'\">Add {{\"ODC.BANQUET-HALL\"|translate}}</md-button></div></form></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\">{{\"ODC.BANQUET-HALL\"|translate}}</div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr \nclass=\"cursor-pointer\" ng-repeat=\"foodcategory in vm.banquethalls\"><td width=\"70%\"><span ng-hide=\"show\">\n{{ foodcategory.BanquetHallName}}</span><div ng-show=\"show\"><form name=\"editCategory\" novalidate flex=\"100\">\n<md-input-container class=\"md-accent\"><input type=\"text\" aria-label=\"email\" ng-model=\"foodcategory.BanquetHallName\" \nname=\"name\" required><div ng-messages=\"editCategory.name.$error\"><div ng-message=\"required\">\nPlease Enter The {{\"ODC.BANQUET-HALL\"|translate}} Name</div></div></md-input-container><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" ng-click=\"updateaData(foodcategory); show = \'\'\" \ntitle=\"Save\" ng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(foodcategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(foodcategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(foodcategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/corporate-details/corporate-details.html","<div class=\"layout-column md-whiteframe-1dp white-bg mb-24 m-w-720\"><div layout=\"row\" class=\"p-36 md-accent-bg\"><div \nclass=\"activity layout-align-start-start layout-row\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><h1 \nclass=\"text-white m-0\">{{branchdata.corporate_name}}</h1><h3 class=\"text-white m-0\">{{branchdata.branch_name}}</h3>\n</div></div></div><div layout=\"column\" class=\"layout-align-start-start margin-left-16 mt-16 view-user padding-24\"><span\n class=\"time secondary-text\">Address</span> <span class=\"time primary-text mt-8\">{{branchdata.address}}</span><hr \nclass=\"mv-16 md-block\"><div layout=\"row\" class=\"w-100p\"><div layout=\"column\" flex><span class=\"time secondary-text\">\nContact No</span> <span class=\"time primary-text mt-8\">{{branchdata.contact_number}}</span></div><div layout=\"column\" \nflex ng-if=\"vm.settings.show_barcode\"><span class=\"time secondary-text\">Barcode Printer</span> <span \nclass=\"time primary-text mt-8\">{{branchdata.barcode_enable == 1 ? \"Enabled\" : \"Disabled\"}}</span></div></div><hr \nclass=\"mv-16 md-block\" ng-if=\"sms.length\"><div class=\"sub-head mb-24\" ng-if=\"sms.length\">SMS API details</div><div \nlayout=\"row\" class=\"w-100p\" ng-if=\"sms.length\"><div layout=\"column\" flex><span class=\"time secondary-text\">UserID\n</span> <span class=\"time primary-text mt-8\">{{branchdata.user_id}}</span></div><div layout=\"column\" flex><span \nclass=\"time secondary-text\">SenderID</span> <span class=\"time primary-text mt-8\">{{branchdata.sender_id}}</span></div>\n</div><hr class=\"mv-16 md-block\" ng-if=\"sms.length\"><div layout=\"row\" class=\"w-100p\" ng-if=\"sms.length\"><div \nlayout=\"column\" flex><span class=\"time secondary-text\">AuthKey</span> <span class=\"time primary-text mt-8\">\n{{branchdata.authKey}}</span></div></div><hr class=\"mv-16 md-block\" ng-if=\"whatsapp.length\"><div \nclass=\"sub-head mb-24\" ng-if=\"whatsapp.length\">Whatsapp API details</div><div layout=\"row\" class=\"w-100p\" \nng-if=\"whatsapp.length\"><div layout=\"column\" flex><span class=\"time secondary-text\">API Key</span> <span \nclass=\"time primary-text mt-8\">{{branchdata.wa_api}}</span></div><div layout=\"column\" flex><span \nclass=\"time secondary-text\">Expiry Date</span> <span class=\"time primary-text mt-8\">{{branchdata.wa_expiry_date}}\n</span></div></div><div layout=\"row\" class=\"w-100p mt-24\" ng-if=\"whatsapp.length\"><div layout=\"column\" flex><span \nclass=\"time secondary-text\">Send Bill Via Whatsapp</span> <span class=\"time primary-text mt-8\">\n{{branchdata.wa_billsend == 1 ? \"Yes\" : \"No\"}}</span></div></div><hr class=\"mv-16 md-block\" \nng-if=\"whatsapp.length && (branchdata.wa_billsend == 1)\"><div class=\"sub-head mb-24\" \nng-if=\"whatsapp.length && (branchdata.wa_billsend == 1)\">UPI details</div><div layout=\"row\" class=\"w-100p\" \nng-if=\"whatsapp.length && (branchdata.wa_billsend == 1)\"><div layout=\"column\" flex><span class=\"time secondary-text\">\nUPI Id</span> <span class=\"time primary-text mt-8\">{{branchdata.upi_id}}</span></div><div layout=\"column\" flex><span \nclass=\"time secondary-text\">UPI Name</span> <span class=\"time primary-text mt-8\">{{branchdata.upi_name}}</span></div>\n</div><hr class=\"mv-16 md-block\"><div layout=\"row\" class=\"w-100p\"><div layout=\"column\" flex><div \nclass=\"sub-head mb-24\">App Module</div><span class=\"time primary-text mt-8\"><span class=\"outline-ash-tag mr-8 mb-8\" \nng-repeat=\"log in modules track by $index\">{{log}}</span></span></div></div><hr class=\"mv-16 md-block\"><div \nlayout=\"row\" class=\"layout-align-end-center mt-16\" style=\"width: 100%\"><md-button \nclass=\"md-primary md-raised margin-right-0\" aria-label=\"edit info\" ng-click=\"editcorporate(branchid)\">Edit Info\n</md-button></div></div></div>");
$templateCache.put("app/main/admin/corporate-details/editbranch.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg padding-24 mb-24\"><div \nclass=\"m-w-620 medium-large\"><form name=\"addbranch\" novalidate><div class=\"layout-column mt-8\"><md-input-container \nclass=\"md-accent\" style=\"display: none\"><label>Corporate Name</label><input type=\"text\" name=\"corporateName\" \nmaxlength=\"60\" ng-model=\"branch.corporate_name\" required><div ng-messages=\"addbranch.corporateName.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the Corporate Name</span></div></div>\n</md-input-container><md-input-container class=\"md-accent\"><label><span translate>COMPANY.BRANCH</span> Name</label>\n<input type=\"text\" name=\"branchName\" maxlength=\"60\" ng-model=\"branch.branch_name\" required><div \nng-messages=\"addbranch.branchName.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>COMPANY.BRANCH</span> Name</span></div></div></md-input-container><md-input-container \nclass=\"md-accent\"><label>Address</label><textarea type=\"text\" name=\"branchAddress\" rows=\"2\" ng-model=\"branch.address\" \nrequired></textarea><div ng-messages=\"addbranch.branchAddress.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the <span translate>COMPANY.BRANCH</span> Address</span></div></div>\n</md-input-container><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>Contact No</label><input \ntype=\"text\" name=\"branchMobileNo1\" minlength=\"6\" maxlength=\"15\" ng-model=\"branch.contact_number\" required><div \nng-messages=\"addbranch.branchMobileNo1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease enter the mobile no</div></div></md-input-container><md-input-container class=\"md-accent\" required \nng-if=\"vm.settings.show_barcode\"><label>Barcode Printer</label><md-select ng-model=\"branch.barcode_enable\"><md-option \nng-repeat=\"barcode in vm.barcodePrinter\" value=\"{{barcode.value}}\">{{barcode.name}}</md-option></md-select>\n</md-input-container><div ng-if=\"sms.length\"><div class=\"sub-head mb-24\">SMS API details</div><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label>Auth Key</label><input type=\"text\" name=\"authkey\" \nng-model=\"branch.authKey\"></md-input-container><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>\nSender ID</label><input type=\"text\" maxlength=\"6\" minlength=\"6\" name=\"sentid\" ng-model=\"branch.sender_id\" required><div\n ng-messages=\"addbranch.sentid.$error || addbranch.sentid.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter 6 characters</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label>User ID</label><input type=\"text\" name=\"authkey\" \nng-model=\"branch.user_id\"></md-input-container></div><div ng-if=\"whatsapp.length\"><div class=\"sub-head mb-24\">\nWhatsapp API details</div><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>API Key</label><input \ntype=\"text\" name=\"wa_api\" ng-model=\"branch.wa_api\"></md-input-container></div><div layout=\"row\" class=\"spacer-8 mb-24\">\n<md-input-container class=\"md-block md-accent\" flex=\"100\"><label>Send Bill Via Whatsapp</label><md-select \nng-model=\"branch.wa_billsend\" placeholder=\"Select Status\"><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No\n</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"spacer-8 mb-24\" \nng-if=\"branchdata.wa_billsend == 1 && global_staffID == staffID\"><md-input-container class=\"md-block md-accent\" \nflex=\"50\"><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>UPI Id</label><input type=\"text\" \nname=\"upi_id\" ng-model=\"branch.upi_id\"></md-input-container></md-input-container><md-input-container \nclass=\"md-block md-accent\" flex=\"50\"><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>UPI Name</label>\n<input type=\"text\" name=\"upi_name\" ng-model=\"branch.upi_name\"></md-input-container></md-input-container></div><div \nng-if=\"params.id\" class=\"layout-row layout-align-end-center\"><md-button \nclass=\"md-raised md-primary margin-right-0 mb-24\" ng-disabled=\"addbranch.$invalid || addbranch.$prisitine\" \nng-click=\"update()\" aria-label=\"submit\">Update</md-button></div></div></form></div></div>");
$templateCache.put("app/main/admin/editcashier/editcashier.html","<div class=\"layout-column layout-align-top-stretch layout-fill md-whiteframe-2dp white-bg overflow-auto padding-24\">\n<div class=\"w-420\"><div class=\"layout-column\"><md-input-container class=\"md-accent\"><label>Name</label><input \ntype=\"text\" ng-model=\"cashiersinfo.name\" ng-required=\"true\"></md-input-container><md-input-container class=\"md-accent\">\n<label>Email ID/ Username</label><input type=\"text\" ng-model=\"cashiersinfo.emailid\"></md-input-container><div \nclass=\"layout-row layout-align-start-start\"><md-button class=\"md-accent ml-0 mb-8\" aria-label=\"submit\" \nng-click=\"OpenPassword = !OpenPassword\">Edit Password</md-button></div><div ng-show=\"OpenPassword\" class=\"mb-8\">\n<md-input-container class=\"md-accent\"><label>Password</label><input type=\"text\" ng-model=\"cashiersinfo.password\">\n</md-input-container><md-input-container class=\"md-accent\"><label>Confirm Password</label><input type=\"text\" \nng-model=\"cashiersinfo.confirmpassword\"></md-input-container></div><md-input-container class=\"md-accent\"><label>\nMobile no</label><input type=\"text\" ng-model=\"cashiersinfo.mobileno\" ng-required=\"true\"></md-input-container><h4 \nclass=\"tags secondary-text\">Assigned Role</h4><md-chips ng-model=\"skill\"><md-chip-template><span><strong>\n{{ skill.skill_title}}</strong></span></md-chip-template></md-chips><h4 class=\"tags secondary-text mt-24\">Permissions\n</h4><div layout-wrap layout-gt-sm=\"row\" class=\"padding-16 ash-color mb-16\"><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"vm.captain\" ng-value=\"captain\" ng-checked=\"\">Captain</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox \nng-model=\"vm.cashier\" ng-value=\"cashier\" ng-checked=\"\">Cashier</md-checkbox></div></div><div \nclass=\"layout-row layout-align-end-center mt-24 mb-24\"><md-button class=\"md-raised md-default-theme margin-right-8\" \naria-label=\"submit\" ui-sref=\"app.viewcashier\">Cancel</md-button><md-button class=\"md-raised md-primary margin-right-0\" \naria-label=\"submit\">Edit Info</md-button></div></div></div></div>");
$templateCache.put("app/main/admin/expense-category/expense-category.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"mw-860\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-24\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1;disable()\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\nAdd Category</md-button></div><div layout=\"row\" ng-show=\"show1\" class=\"padding-16 ash-color mb-24 m-w-620\"><form \nname=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" layout-wrap><md-input-container md-no-float \nclass=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" ng-keypress=\"restrict($event)\" \nng-model=\"foodcategory.exCatergoryName\" name=\"catname\" placeholder=\"Category Name\" required><div \nng-messages=\"(addCategory.catname.$touched && addCategory.catname.$error) || addCategory.$invalid\"><div \nng-message=\"required\">Please enter the <span translate>ODC.Category</span> name</div></div></md-input-container></div>\n<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"cancelAddItem(addCategory); show1 = !show1\">Cancel\n</md-button><md-button class=\"md-primary md-raised\" layout-align-end ng-disabled=\"addCategory.$invalid\" \nng-click=\"addNewCategory(foodcategory); show1 = \'\'\">Add {{\'ODC.Category\' | translate}}</md-button></div></form></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate>ODC.Category</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr></thead>\n<tbody><tr class=\"cursor-pointer\" ng-repeat=\"foodcategory in vm.excategorys\"><td width=\"70%\"><span ng-hide=\"show\">\n{{ foodcategory.exCatergoryName}}</span><div ng-show=\"show\"><form name=\"editCategory\" novalidate flex=\"100\">\n<md-input-container class=\"md-accent\"><input type=\"text\" aria-label=\"email\" ng-model=\"foodcategory.exCatergoryName\" \nname=\"name\" required><div ng-messages=\"editCategory.name.$error\"><div ng-message=\"required\">Please enter category name\n</div></div></md-input-container><md-button class=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" \nng-click=\"updateaData(foodcategory); show = \'\'\" title=\"Save\" \nng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin md-font-icon=\"icon-check\">\n</md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(foodcategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(foodcategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(foodcategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/food-settings/food-settings.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div layout=\"row\" \nclass=\"layout-align-start-center mb-16\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \ntranslate>RESTRAUNTANT.MENU-ITEMS</span></md-button><div layout=\"row\" layout-align=\"end start\" flex><div \nclass=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input md-accent\" ng-model=\"vm.search\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex>\n<md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"vm.search\" \nng-click=\"clearText()\"></md-icon></div></div></div><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate>\nRESTRAUNTANT.MENU-ITEMS</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'ODC.TYPE\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'ODC.Category\' | translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"\">BILLINGS.RATE</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"\">Offer rate</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"fmInfo in vm.foodMenusInfo | filter: vm.search\"><td>\n{{ fmInfo.fmItemName }}</td><td>{{ fmInfo.fmItemType }}</td><td>{{ getCategoryName(fmInfo) }}</td><td><span translate>\nBILLINGS.INR</span> {{ fmInfo.fmItemPrice }}</td><td><span translate ng-if=\"fmInfo.offerprice\">BILLINGS.INR</span>\n {{ fmInfo.offerprice }}</td><td><md-button class=\"md-icon-button\" ng-click=\"vm.showAddTableDialog($event, fmInfo)\">\n<md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteContactConfirm(fmInfo, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/admin/food-settings-category/food-settings-category.addcategory.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex w-480 h-400 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-16\">\nAdd <span translate>RESTRAUNTANT.MENU-CATEGORY</span></h2><span class=\"secondary-text\" translate>\nRESTRAUNTANT.MENU-CATEGORY</span><div class=\"layout-row layout-align-start-start\"><md-input-container \nclass=\"md-accent\" flex=\"60\"><input type=\"text\" ng-model=\"tableinfo.tableno\" ng-required=\"true\"></md-input-container>\n<md-button class=\"md-accent ml-8 mt-16 md-icon-button\" title=\"Add Another One\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus\" class=\"mr-8\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-click=\"closeDialog()\">Add <span translate>RESTRAUNTANT.MENU-CATEGORY</span></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/admin/food-settings-category/food-settings-category.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"mw-860\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-16\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \ntranslate>RESTRAUNTANT.MENU-CATEGORY</span></md-button></div><div layout=\"row\" ng-show=\"show1\" \nclass=\"padding-16 ash-color mb-24 m-w-620\"><form name=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" \nlayout-wrap><md-input-container md-no-float class=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" \nng-keypress=\"restrict($event)\" ng-model=\"foodcategory.fmCatergoryName\" name=\"name\" maxlength=\"40\" \nplaceholder=\"Category Name\" required><div ng-messages=\"addCategory.name.$error\"><div ng-message=\"required\">\nPlease enter the <span translate>RESTRAUNTANT.MENU-CATEGORY</span> name</div></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"end start\"><md-button ng-click=\"cancelAddItem(foodcategory); show1 = !show1\">Cancel\n</md-button><md-button class=\"md-primary md-raised\" layout-align-end ng-disabled=\"addCategory.$invalid\" \nng-click=\"addNewCategory(foodcategory); show1 = \'\'\">Add {{\'ODC.Category\' | translate}}</md-button></div></form></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate>RESTRAUNTANT.MENU-CATEGORY</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span>\n</div></th></tr></thead><tbody><tr class=\"cursor-pointer\" ng-repeat=\"foodcategory in vm.foodcategorys\"><td width=\"70%\" \nclass=\"medium\"><span ng-hide=\"show\">{{ foodcategory.fmCatergoryName}}</span><div ng-show=\"show\"><form \nname=\"editCategory\" novalidate flex=\"100\"><md-input-container class=\"md-accent\"><input type=\"text\" \nng-model=\"foodcategory.fmCatergoryName\" name=\"name\" required><div ng-messages=\"editCategory.name.$error\"><div \nng-message=\"required\">Please enter {{\'ODC.Category\' | translate}} name</div></div></md-input-container><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" ng-click=\"updateaData(foodcategory); show = \'\'\" \ntitle=\"Save\" ng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(foodcategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(foodcategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(foodcategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/food-settings-combo/food-settings-combo.addcombo.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-640 h-600 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 \nclass=\"md-title margin-top-0 mb-32 ml-8\">Add <span translate>RESTRAUNTANT.COMBO-PACK</span></h2></div><form \nname=\"addcombopack\" validate><md-input-container class=\"md-accent md-block mt-16 ml-8\" flex=\"50\"><label><span \ntranslate>RESTRAUNTANT.COMBO-PACK</span> Name</label><input type=\"text\" name=\"comboName\" \nng-model=\"vm.combopackinfo.comboName\" required><div ng-messages=\"addcombopack.comboName.$error\"><div \nng-message=\"required\"><span translate>RESTRAUNTANT.COMBO-PACK</span> <span>name field is required</span></div></div>\n</md-input-container><span class=\"small-text ml-8 italic\">Add <span translate>RESTRAUNTANT.MENU-ITEMS</span></span><div\n flex=\"95\" class=\"ash-color p-8 mt-16\"><div layout=\"row\"><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"50\"><input placeholder=\"{{ \'RESTRAUNTANT.MENU-ITEM\' | translate }}\" type=\"text\" name=\"comboItems\" \nng-model=\"vm.combopackinfo.comboItems\" required><div ng-messages=\"addcombopack.comboItems.$error\"><div \nng-message=\"required\"><span>Please enter the </span><span translate>RESTRAUNTANT.MENU-ITEM</span></div></div>\n</md-input-container><md-input-container class=\"md-block md-accent ml-8\" flex=\"35\"><md-select \nng-model=\"foodbeverageinfo.measure\" class=\"md-accent\"><md-option value=\"plate\" selected=\"selected\">1 Plate</md-option>\n<md-option value=\"cup\">1 Cup</md-option><md-option value=\"cup\">1 ml</md-option></md-select></md-input-container>\n<md-button class=\"md-accent md-icon-button ml-8\" style=\"margin-top:16px\" flex=\"10\" title=\"Add Another Item\"><md-icon \nmd-menu-origin md-font-icon=\"icon-plus\" class=\"mr-8\"></md-icon></md-button></div></div><div layout=\"column\" \nclass=\"mt-16\" flex=\"50\"><md-input-container class=\"md-accent md-block ml-8\"><label><span translate>\nRESTRAUNTANT.COMBO-PACK</span> <span translate>BILLINGS.PRICE</span> (<span translate>BILLINGS.INR</span>)</label>\n<input type=\"text\" name=\"comboPrice\" ng-model=\"vm.combopackinfo.comboPrice\" value=\"1\" ng-pattern=\"/^[0-9]/\" required>\n<div ng-messages=\"addcombopack.comboPrice.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>BILLINGS.PRICE</span></span></div><div ng-message=\"pattern\">Enter the numbers only\n</div></div></md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" ng-click=\"closeDialog()\">Add <span translate>\nRESTRAUNTANT.COMBO-PACK</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/food-settings-combo/food-settings-combo.html","<div id=\"food-settings-combo\" class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\">\n<div layout=\"row\" class=\"layout-align-start-center mb-24\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddComboDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \ntranslate>RESTRAUNTANT.COMBO-PACK</span></md-button></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate>\nRESTRAUNTANT.COMBO-PACK</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate>RESTRAUNTANT.ITEMS</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate>BILLINGS.PRICE</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"combopackinfo in ::vm.combopacksinfo\"><td><div layout=\"column\" class=\"layout-column\"><div><span \nclass=\"username mt-10\">{{ combopackinfo.comboName }}</span></div></div></td><td><span \nng-repeat=\"comboItem in combopackinfo.comboItems\" class=\"outline-ash-tag ml-8 mb-8\">\n{{ comboItem.itemName }}- {{ comboItem.itemQuantity }}</span> {{ combopackinfo.comboItem }}</td><td><span translate \nclass=\"grey-col-sec-text\">BILLINGS.INR</span> {{ combopackinfo.comboPrice }}</td><td><md-button class=\"md-icon-button\" \nng-click=\"editKeyword(keyword); editMode = true\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showAlert($event); $event.stopPropagation();\"><md-icon \nmd-menu-origin md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/admin/locality/settings-locality.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"mw-860\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-24\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1;disable()\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\nAdd {{\"BILLINGS.CUSTOMER-LIST.LOCALITY\" | translate}}</md-button></div><div layout=\"row\" ng-show=\"show1\" \nclass=\"padding-16 ash-color mb-24 m-w-620\"><form name=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" \nlayout-wrap><md-input-container md-no-float class=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" \nng-keypress=\"restrict($event)\" ng-model=\"foodcategory.localityName\" name=\"catname\" \nplaceholder=\"{{\'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}} Name\" required><div \nng-messages=\"(addCategory.catname.$touched && addCategory.catname.$error) || addCategory.$invalid\"><div \nng-message=\"required\">Please enter the {{\"BILLINGS.CUSTOMER-LIST.LOCALITY\" | translate}} name</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"end start\"><md-button \nng-click=\"cancelAddItem(addCategory); show1 = !show1\">Cancel</md-button><md-button class=\"md-primary md-raised\" \nlayout-align-end ng-disabled=\"addCategory.$invalid\" ng-click=\"addNewCategory(foodcategory); show1 = \'\'\">\nAdd {{\"BILLINGS.CUSTOMER-LIST.LOCALITY\" | translate}}</md-button></div></form></div><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate>{{\"BILLINGS.CUSTOMER-LIST.LOCALITY\" | translate}}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr class=\"cursor-pointer\" \nng-repeat=\"foodcategory in vm.localitys\"><td width=\"70%\"><span ng-hide=\"show\">{{ foodcategory.localityName}}</span><div\n ng-show=\"show\"><form name=\"editCategory\" novalidate flex=\"100\"><md-input-container class=\"md-accent\"><input \ntype=\"text\" aria-label=\"email\" ng-model=\"foodcategory.localityName\" name=\"name\" required><div \nng-messages=\"editCategory.name.$error\"><div ng-message=\"required\">Please enter category name</div></div>\n</md-input-container><md-button class=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" \nng-click=\"updateaData(foodcategory); show = \'\'\" title=\"Save\" \nng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin md-font-icon=\"icon-check\">\n</md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(foodcategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(foodcategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(foodcategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/points/point-settings.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"m-w-640\"><form \nname=\"addfoodForm\" novalidate><div layout=\"row\"><div flex=\"100\"><md-checkbox ng-model=\"vm.fmInfo.enablepoint\" \naria-label=\"Checkbox 1\">Enable Customer Points</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nAllow to access points-based loyalty program, providing discount based on points.</div></div></div><div \nlayout=\"column\" flex=\"50\" ng-show=\"vm.fmInfo.enablepoint\"><md-input-container class=\"md-accent md-block\"><label>\nEnter the purchase amount to earn a point</label><input type=\"text\" name=\"price\" ng-model=\"vm.fmInfo.amount\" \nng-keypress=\"onlynumber($event);\" maxlength=\"8\" pattern=\"^[1-9][0-9]*$\" required><div \nng-messages=\"addfoodForm.price.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the <span \ntranslate>Amount</span></span></div><div ng-message=\"pattern\">Please enter the valid amount</div></div>\n</md-input-container><md-input-container class=\"md-accent md-block\"><label>Enter the amount to discount for per point\n</label><input type=\"number\" name=\"offer\" ng-model=\"vm.fmInfo.perpoint_amount\" max=\"{{vm.fmInfo.amount}}\" \nng-keypress=\"onlynumbers($event);\" required><div ng-messages=\"addfoodForm.offer.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the <span translate>PerpointAmount</span></span></div><div ng-message=\"max\">\n<span>Please enter below the Rate per item</span></div></div></md-input-container></div><div layout=\"column\" \nng-show=\"vm.fmInfo.enablepoint\"><div flex=\"100\"><md-checkbox ng-model=\"vm.fmInfo.EnableFirstTime\" \naria-label=\"Checkbox 1\">Enable first time</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nAdd default points to new customers while register.</div></div><div flex=\"50\"><md-input-container flex=\"50\" \nclass=\"md-accent md-block\" ng-show=\"vm.fmInfo.enablepoint && vm.fmInfo.EnableFirstTime\"><label><span translate>\nFirst time</span> point</label><input type=\"number\" name=\"offer\" ng-model=\"vm.fmInfo.FirstTimePoint\" \nng-keypress=\"onlynumbers($event);\"><div ng-messages=\"addfoodForm.offer.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the <span translate>PerpointAmount</span></span></div><div ng-message=\"max\">\n<span>Please enter below the Rate per item</span></div></div></md-input-container></div></div></form><div layout=\"row\" \nlayout-align=\"end start\" flex=\"50\"><md-button ng-click=\"Cancel()\">Cancel</md-button><md-button \nclass=\"md-primary md-raised\" layout-align-end ng-disabled=\"addfoodForm.$invalid || addfoodForm.$pristine\" \nng-click=\"addFMItem()\">Save</md-button></div></div></div>");
$templateCache.put("app/main/admin/print/print.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg padding-24 mb-24\"><div class=\"m-w-620\"><form \nname=\"addbranch\" novalidate><div class=\"layout-column mt-8\"><md-input-container class=\"md-block md-accent\" flex-gt-sm>\n<label>Contact No</label><input type=\"text\" name=\"branchMobileNo1\" minlength=\"6\" ng-model=\"branch.contact_number\" \nrequired><div ng-messages=\"addbranch.branchMobileNo1.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\">Please enter the mobile no</div></div></md-input-container><md-input-container class=\"md-accent\">\n<label>Address</label><textarea type=\"text\" name=\"branchAddress\" rows=\"2\" ng-model=\"branch.address\" required>\n</textarea><div ng-messages=\"addbranch.branchAddress.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the <span translate>COMPANY.BRANCH</span> Address</span></div></div>\n</md-input-container><md-input-container class=\"md-accent\"><label>Gst No</label><input type=\"text\" name=\"gst\" \nng-model=\"branch.GstNo\"></md-input-container><md-input-container class=\"md-accent\" flex=\"60\" md-no-float><md-select \nng-model=\"branch.printsize\" placeholder=\"Print Size\" name=\"printsize\" class=\"md-accent\" md-no-asterisk=\"false\" \nrequired><md-option ng-repeat=\"printsize in printSize\" value=\"{{printsize.value}}\">{{printsize.label}}</md-option>\n</md-select></md-input-container><br><br><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>\nPrint Footer Line</label><input type=\"text\" name=\"authkey\" ng-model=\"branch.print_footer\"></md-input-container><div \nclass=\"layout-row layout-align-end-center\"><md-button class=\"md-raised md-primary margin-right-0 mb-24\" \nng-disabled=\"addbranch.$pristine\" ng-click=\"update(branchid)\" aria-label=\"submit\">Update</md-button></div></div></form>\n</div></div>");
$templateCache.put("app/main/admin/settings-tax/settings-tax.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div flex=\"100\"><md-checkbox\n ng-model=\"enableTax\" ng-checked=\"vm.taxs[0].taxRate||vm.taxs[1].taxRate\" aria-label=\"Checkbox 1\">Enable <span \ntranslate>BILLINGS.TAX</span></md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nAllow to add tax in POS bill<span ng-if=\"odcPermissions.length\"> and ODC/ Banquet bill</span>.</div><div class=\"w-920\" \nng-if=\"enableTax\"><div layout=\"row\" class=\"layout-align-start-center mb-16\" ng-hide=\"show1||vm.taxs.length>1\">\n<md-button class=\"md-accent\" aria-label=\"edit info\" ng-click=\"show1 = !show1\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus\"></md-icon>Add <span translate>BILLINGS.TAX</span></md-button></div><div layout=\"row\" \nng-show=\"show1\" class=\"padding-16 ash-color mb-16 m-w-620\"><form name=\"settingsTax\" novalidate flex=\"100\"><div \nlayout=\"row\" layout-wrap><md-input-container md-no-float class=\"md-accent pr-16\" flex=\"50\"><input type=\"text\" \nng-model=\"taxs.taxName\" name=\"taxname\" maxlength=\"30\" placeholder=\"Tax Name\" required><div \nng-messages=\"(settingsTax.taxname.$touched && settingsTax.taxname.$error) || settingsTax.$invalid\"><div \nng-message=\"required\">Please enter the <span translate>BILLINGS.TAX</span><span> name</span></div></div>\n</md-input-container><md-input-container md-no-float class=\"md-accent\" flex=\"50\"><input type=\"number\" \nng-keypress=\"onlynumberDot($event);\" maxlength=\"4\" ng-model=\"taxs.taxRate\" name=\"taxrate\" \nplaceholder=\"{{\'BILLINGS.RATE\' | translate}} %\" required><div \nng-messages=\"(settingsTax.taxrate.$touched && settingsTax.taxrate.$error) || settingsTax.$invalid\"><div \nng-message=\"required\">Please enter the <span translate>BILLINGS.TAX</span><span> rate</span></div><div \nng-message=\"pattern\"><span>Rate value must be less than or equal to 99</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"cancelAddItem(taxs); show1 = !show1;\">Cancel\n</md-button><md-button class=\"md-primary md-raised\" layout-align-end ng-disabled=\"settingsTax.$invalid\" \nng-click=\"addTax(taxs); show1 = \'\'\">Add <span translate>BILLINGS.TAX</span></md-button></div></form></div><span \nclass=\"note\"><strong>Note:</strong> If you modify below value, it will be affect at POS bill<span \nng-if=\"odcPermissions.length\"> and ODC/ Banquet bill</span>.</span><div layout=\"column\" class=\"mt-24 m-w-720\"><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple medium\"><thead><tr><th class=\"secondary-text\" width=\"30%\"><div\n class=\"table-header\"><span class=\"column-title\"><span translate>BILLINGS.TAX</span> NAME</span></div></th><th \nclass=\"secondary-text\" width=\"50%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.RATE\' | translate}} %</span></div></th><th class=\"secondary-text\" width=\"20%\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr><tbody><tr \nng-repeat=\"tax in vm.taxs\"><td ng-hide=\"show\"><span>{{ tax.taxName }}</span></td><td ng-hide=\"show\"><span>\n{{ tax.taxRate }} %</span></td><td ng-show=\"show\" colspan=\"2\"><div layout=\"row\" flex><form name=\"editTax\" novalidate \nflex=\"100\" layout=\"row\"><div flex=\"40\"><md-input-container md-no-float class=\"md-accent md-block pr-16\"><input \ntype=\"text \" ng-model=\"tax.taxName \" placeholder=\"Name\" name=\"name\" required><div ng-messages=\"editTax.name.$error\">\n<div ng-message=\"required\">Please enter the name</div></div></md-input-container></div><div flex=\"60\" layout=\"row\">\n<md-input-container md-no-float class=\"md-accent pr-16\"><input type=\"text\" ng-model=\"tax.taxRate\" name=\"rate\" \nplaceholder=\"Rate\" required ng-keypress=\"onlynumberDot($event);\" maxlength=\"4\"><div ng-messages=\"editTax.rate.$error\">\n<div ng-message=\"required\">Please enter the tax_rate</div></div></md-input-container><span class=\"mt-16\"><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" \nng-disabled=\"editTax.$invalid || editTax.$pristine\" ng-click=\"vm.editTax(tax); $event.stopPropagation(); show = !show\" \ntitle=\"Save \"><md-icon md-menu-origin md-font-icon=\"icon-check \"></md-icon></md-button><md-button \nclass=\"md-hue md-icon-button\" aria-label=\"close \" ng-click=\"cancelItem(tax); show = !show\" title=\"Cancel \"><md-icon \nmd-menu-origin md-font-icon=\"icon-close \"></md-icon></md-button></span></div></form></div></td><td><md-button \nclass=\"md-icon-button\" title=\"Edit \" ng-hide=\"show\" ng-click=\"editItem(tax); show = !show\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil \"></md-icon></md-button></td></tr></tbody></thead></table></div></div></div><div \nlayout=\"row\" class=\"layout-align-start-center mb-16 mt-24\"><md-button class=\"md-primary md-raised\" \nng-disabled=\"enableTax\" aria-label=\"edit info\" ng-click=\"vm.editTax(tax)\">Submit</md-button></div></div></div>");
$templateCache.put("app/main/admin/tablesettings/tablesettings.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"m-w-720\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-16\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \ntranslate>RESTRAUNTANT.TABLE-NO</span></md-button></div><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate>RESTRAUNTANT.TABLE-NO</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate>{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr \nclass=\"cursor-pointer\" ng-repeat=\"tableinfo in vm.tablesinfo\"><td width=\"70%\" class=\"medium\"><span ng-hide=\"show\" \naria-label=\"input\">{{ tableinfo.table_no}}</span><span ng-show=\"show\"><md-input-container class=\"md-accent\"><input \ntype=\"text\" ng-model=\"tableinfo.table_no\" ng-keypress=\"onlynumber($event);\" maxlength=\"3\" name=\"table\" \nng-required=\"true\"></md-input-container><md-button class=\"md-primary md-mini md-raised md-icon-button\" \naria-label=\"save\" ng-click=\"updateaData(tableinfo); show = \'\'\" title=\"Save\"><md-icon md-menu-origin \nmd-font-icon=\"icon-check\"></md-icon></md-button></span><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-show=\"show\" ng-click=\"show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\"></md-icon>\n</md-button></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" ng-click=\"show = !show\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(tableinfo, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/third-party-integration/settings-thirdparty.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"mw-860\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-24\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1;disable()\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\nAdd {{\"BILLINGS.THIRD-PARTY\" | translate}}</md-button></div><div layout=\"row\" ng-show=\"show1\" \nclass=\"padding-16 ash-color mb-24 m-w-620\"><form name=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" \nlayout-wrap><md-input-container md-no-float class=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" \nng-keypress=\"restrict($event)\" ng-model=\"foodcategory.thirdparty_name\" name=\"catname\" \nplaceholder=\"{{\'BILLINGS.THIRD-PARTY\' | translate}} Name\" required><div \nng-messages=\"(addCategory.catname.$touched && addCategory.catname.$error) || addCategory.$invalid\"><div \nng-message=\"required\">Please enter the {{\"BILLINGS.THIRD-PARTY\" | translate}} name</div></div></md-input-container>\n</div><div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"cancelAddItem(addCategory); show1 = !show1\">\nCancel</md-button><md-button class=\"md-primary md-raised\" layout-align-end ng-disabled=\"addCategory.$invalid\" \nng-click=\"addNewCategory(foodcategory); show1 = \'\'\">Add {{\"BILLINGS.THIRD-PARTY\" | translate}}</md-button></div></form>\n</div><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate>{{\"BILLINGS.THIRD-PARTY\" | translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span>\n</div></th></tr></thead><tbody><tr class=\"cursor-pointer\" ng-repeat=\"foodcategory in vm.ThirdParty\"><td width=\"70%\">\n<span ng-hide=\"show\">{{ foodcategory.thirdparty_name}}</span><div ng-show=\"show\"><form name=\"editCategory\" novalidate \nflex=\"100\"><md-input-container class=\"md-accent\"><input type=\"text\" aria-label=\"email\" \nng-model=\"foodcategory.thirdparty_name\" name=\"name\" required><div ng-messages=\"editCategory.name.$error\"><div \nng-message=\"required\">Please enter category name</div></div></md-input-container><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" ng-click=\"updateaData(foodcategory); show = \'\'\" \ntitle=\"Save\" ng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(foodcategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(foodcategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(foodcategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/users-list/users-list.html","<div class=\"layout-row min-height-100 md-whiteframe-2dp white-bg\" id=\"users-list\"><div ms-scroll \nclass=\"scrollable flex-none w-180 left-side-ver-tab\"><md-list><md-list-item ng-repeat=\"userRole in vm.userRole\" \nng-click=\"getuserRole(userRole)\">{{userRole.role_name}}</md-list-item></md-list></div><div \nclass=\"dataTable-primary scrollable p-24\" ms-scroll flex><div class=\"result-info mb-24\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div class=\"hidebelow600\"><span \nclass=\"md-title\" translate>USERS.STAFF</span> <span class=\"secondary-text\"><span>({{vm.staff.length}})</span></span>\n</div><div flex-none layout=\"row\" layout-align=\"start end\" class=\"m-w-320\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.search\" type=\"text\" placeholder=\"Search..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"vm.search\" ng-click=\"clearText()\"></md-icon></div></div></div>\n<table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mobile No</span></div></th><th class=\"secondary-text hidebelow600\"><div class=\"table-header\"><span\n class=\"column-title\">Role</span></div></th><th class=\"secondary-text hidebelow600\"><div class=\"table-header\"><span \nclass=\"column-title\">Access</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr class=\"cursor-pointer\" \nng-repeat=\"userInfo in vm.staff  | filter: vm.search\"><td ng-class=\"currentbill.status\" class=\"border-status\" \nwidth=\"20%\"><div layout=\"column\" class=\"layout-column\"><div><span class=\"username\">{{ userInfo.name }}</span></div>\n<span class=\"time secondary-text\">{{ userInfo.username}}</span></div></td><td width=\"15%\">{{userInfo.mobile}}</td><td \nwidth=\"15%\" class=\"hidebelow600\"><div class=\"flex-none mr-16 mt-8\">{{getRole(userInfo)}}</div></td><td width=\"45%\" \nclass=\"hidebelow600\">{{getAppaccess(userInfo)}}<div class=\"flex-none mr-16 mt-8\"><div layout=\"row\" class=\"w-100p\"><div \nlayout=\"column\" flex><span class=\"time primary-text mt-8\"><span class=\"outline-ash-tag mr-8 mb-8\" \nng-repeat=\"log in modules track by $index\">{{log}}</span></span></div></div></div></td><td width=\"5%\"><md-button \nclass=\"md-icon-button small-button\" aria-label=\"Edit\" title=\"Edit Item\" \nng-click=\"EditStaff(userInfo.staffID);$event.stopPropagation();\"><md-icon md-font-icon=\"text-black-40 icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/admin/vendor/vendor.addcategory.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-640 h-600 medium layout-column\"><md-dialog-content \nclass=\"flex layout-column\"><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32\">\n{{title}} {{\'EXPENSE.VENDOR/PERSON\' | translate}}</h2></div><form name=\"addfoodForm\" novalidate><div layout=\"row\"><div \nflex=\"100\"><md-radio-group class=\"layout-row mb-24 flex\" id=\"radio-focus\" ng-model=\"user.vendor_type\" id=\"myselector\">\n<md-radio-button ng-repeat=\"category in vendor_type\" value=\"{{category.value}}\" class=\"md-accent\">{{category.label}}\n</md-radio-button></md-radio-group><md-input-container class=\"md-accent md-block\" flex=\"50\"><label>\n{{user.vendor_type==\'person\' ? (\'VENDOR.PERSON-NAME\' | translate) : (\'VENDOR.COMPANY-NAME\' | translate)}}</label><input\n type=\"text\" name=\"companyname\" ng-model=\"user.company_name\" required><div \nng-messages=\"addfoodForm.companyname.$error\"><div ng-message=\"required\"><span>Name field is required</span></div></div>\n</md-input-container><div class=\"mt-12\"><md-input-container class=\"md-accent md-block\"><label>\n{{\'BILLINGS.CUSTOMER-LIST.ADDRESS\' | translate}}</label><textarea ng-model=\"user.address\" rows=\"2\" md-select-on-focus>\n</textarea></md-input-container></div><div layout=\"row\" class=\"mt-8\"><md-input-container \nclass=\"md-accent md-block ml-16\" flex=\"50\" ng-if=\"user.vendor_type==\'company\'\"><label><span>\n{{\'VENDOR.CONTACT-PERSON-NAME\' | translate}}</span></label><input type=\"text\" name=\"contactperson\" \nng-model=\"user.name\" value=\"1\" required><div ng-messages=\"addfoodForm.contactperson.$error\"><div ng-message=\"required\">\nPlease enter the contact person name</div></div></md-input-container><div flex><md-input-container \nclass=\"md-accent md-block ml-8\" flex><label><span>{{\'VENDOR.MOBILE-NO\' | translate}}</span></label><input type=\"text\" \nname=\"mobileno\" ng-model=\"user.mobile\" ng-keypress=\"onlynumber($event);\" maxlength=\"10\" value=\"1\" \nng-required=\"user.vendor_type==\'company\'\"><div ng-messages=\"addfoodForm.mobileno.$error\"><div ng-message=\"required\">\nPlease enter the mobile no</div></div></md-input-container></div></div><div layout=\"row\" class=\"mt-12\">\n<md-input-container class=\"md-accent md-block\" flex=\"50\"><label>{{\'VENDOR.PHONE-NO\' | translate}}</label><input \ntype=\"text\" name=\"price\" ng-keypress=\"onlynumber($event);\" maxlength=\"12\" ng-model=\"user.phone\" value=\"1\"><div \nng-messages=\"addfoodForm.price.$error\" multiple=\"multiple\"><div ng-message=\"required\">Please enter the Contact no</div>\n<div ng-message=\"pattern\">Enter the numbers only</div></div></md-input-container><div flex=\"50\" class=\"ml-16\">\n<md-input-container class=\"md-accent md-block\" flex><label>{{\'BILLINGS.CUSTOMER-LIST.EMAIL\' | translate}}</label><input\n type=\"text\" name=\"emailid\" ng-model=\"user.email\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"addfoodForm.emailid.$error\" multiple=\"multiple\"><div ng-message=\"pattern\">Please enter the valid email id\n</div></div></md-input-container></div></div><div class=\"mt-12\"><md-input-container class=\"md-accent md-block\" \nflex=\"50\" ng-if=\"user.vendor_type==\'company\'\"><label>{{\'VENDOR.GST-NO\' | translate}}</label><input type=\"text\" \nname=\"name\" ng-model=\"user.gst_no\" maxlength=\"40\"></md-input-container></div></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-if=\"!newRMItem\" ng-disabled=\"addfoodForm.$invalid || addfoodForm.$pristine\" ng-click=\"editItem(vItem)\">\nEdit {{\'EXPENSE.VENDOR/PERSON\' | translate}}</md-button><md-button class=\"md-accent\" ng-if=\"newRMItem\" \nng-disabled=\"addfoodForm.$invalid\" ng-click=\"addvendor()\">Add {{\'EXPENSE.VENDOR/PERSON\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/vendor/vendor.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column inner-content scrollable\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"mb-8\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \nclass=\"hidebelow600\">{{\'EXPENSE.VENDOR/PERSON\' | translate}}</span></md-button><div layout=\"row\" \nlayout-align=\"end start\" flex><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"vm.search\" ng-click=\"clearText()\"></md-icon></div></div></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'VENDOR.VENDOR-NAME\' | translate}}</span></div></th><th \nclass=\"secondary-text hidebelow600\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'VENDOR.CONTACT-PERSON-NAME\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'VENDOR.MOBILE-NO\' | translate}}</span></div></th><th class=\"secondary-text hidebelow600\">\n<div class=\"table-header\"><span class=\"column-title\">{{\'VENDOR.PHONE-NO\' | translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"vItem in vm.vendors| filter:vm.search\"><td>{{ vItem.company_name }}</td>\n<td class=\"hidebelow600\">{{ vItem.name ? vItem.name : \'-\' }}</td><td>{{ vItem.mobile ? vItem.mobile : \'-\' }}</td><td \nclass=\"hidebelow600\">{{ vItem.phone ? vItem.phone : \'-\' }}</td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.showAddTableDialog($event,vItem)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteContactConfirm(vItem,$event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/admin/users-role/users-role.addrole.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-530 layout-column\"><md-dialog-content class=\"flex layout-column\"><div \nclass=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">{{title}} <span translate>USERS.STAFF-ROLE</span></h2>\n</div><form name=\"adduserrole\" validate><md-input-container class=\"md-accent md-block mt-16 ml-8\" flex=\"100\"><label>\n<span translate>USERS.ROLE</span> Name</label><input type=\"text\" maxlength=\"30\" name=\"rolename\" \nng-model=\"userrole.role_name\" required><div ng-messages=\"adduserrole.rolename.$error\"><div ng-message=\"required\">\nPlease enter the <span translate>USERS.ROLE</span> name</div></div></md-input-container></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-if=\"!newRMItem\" ng-click=\"editRole(userrole)\" ng-disabled=\"adduserrole.$invalid || adduserrole.$pristine\">Edit Role\n</md-button><md-button class=\"md-accent\" ng-if=\"newRMItem\" ng-click=\"addRole()\" ng-disabled=\"adduserrole.$invalid\">\nAdd Role</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/users-role/users-role.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column scrollable role-list p-24\"><div layout=\"column\" \nclass=\"m-w-720\"><div layout=\"row\" class=\"layout-align-start-center mb-16\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"vm.showAddUserRoleDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\">\n</md-icon>Add <span translate>USERS.STAFF-ROLE</span></md-button></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple\"><thead><tr><th class=\"secondary-text\" width=\"30%\"><div class=\"table-header\"><span class=\"column-title\">\n<span translate>USERS.ROLE</span> NAME</span></div></th><th class=\"secondary-text\" width=\"20%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr><tbody><tr \nng-repeat=\"userrole in vm.usersrole\r\n\"><td>{{ userrole.role_name }} <span ng-show=\"$index==0\" class=\"note opa-50 ml-8\">\n(This role assigned to {{ \'BILLINGS.ORDER-TAKEN\' | translate}} in new bill)</span></td><td><md-button \nclass=\"md-icon-button\" flex title=\"Edit\" ng-click=\"vm.showAddUserRoleDialog($event, userrole)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button value=\"{{$index}}\" class=\"md-icon-button\" \nng-hide=\"$index==0\" ng-click=\"vm.deleteContactConfirm(userrole, $event); $event.stopPropagation();\"><md-icon \nmd-menu-origin md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></thead></table></div></div></div>");
$templateCache.put("app/main/admin/viewcashier/viewcashier.html","<div class=\"layout-column layout-align-top-stretch layout-fill md-whiteframe-2dp white-bg overflow-auto padding-24\">\n<div class=\"w-600 view-user\"><div class=\"activity layout-align-start-start layout-row\" layout=\"row\" \nlayout-align=\"start start\"><img ng-src=\"{{ cashiersinfo.photo }}\" class=\"avatar\"><div layout=\"column\" \nclass=\"layout-align-start-start margin-left-16 w-480 mt-16\"><div><span class=\"username mt-8\">{{ cashiersinfo.name }}\n</span></div><span class=\"time secondary-text\">{{ cashiersinfo.emailid }}</span><div \nng-if=\"cashiersinfo.status != \'Active\'\" class=\"mt-16\"><md-icon md-font-icon=\"icon-close-circle\" class=\"red\"></md-icon>\n<span class=\"margin-left-8 red\">{{ cashiersinfo.status}}</span></div><div ng-if=\"cashiersinfo.status != \'Deactive\'\" \nclass=\"mt-16\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"green\"></md-icon><span \nclass=\"margin-left-8 green\">{{ cashiersinfo.status}}</span></div><hr class=\"mv-16 md-block\"><span \nclass=\"time secondary-text\">Mobile No</span> <span class=\"time primary-text mt-8\">{{ cashiersinfo.mobileno }}</span><hr\n class=\"mv-16 md-block\"><div ng-if=\"cashiersinfo.anotherRole != \'\'\" class=\"md-block\"><span class=\"time secondary-text\">\nAssigned to another role</span> <span class=\"time primary-text mt-8\"><div class=\"flex-none mt-16\"><span \ntitle=\"Assign to another role\" class=\"outline-tag\">{{ cashiersinfo.anotherRole }}</span></div></span></div><hr \nclass=\"mv-16 md-block\"><span class=\"time secondary-text\">Permission</span><div class=\"flex-none mt-16\"><span \ntitle=\"Assign to another role\" class=\"outline-tag\">{{ cashiersinfo.permission }}</span></div><hr \nclass=\"mv-16 md-block\"><div layout=\"row\" class=\"layout-align-end-center mt-16\" style=\"width: 100%\"><md-button \nclass=\"md-accent margin-right-0\" aria-label=\"edit info\" ui-sref=\"app.editcashier\">Edit Info</md-button></div></div>\n</div></div></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password\n</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-click=\"vm.authResetPassword()\">SEND RESET LINK\n</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.authLogin\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOCK.USERNAME\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/auth/login/forgot.password.dialog.html","<md-dialog class=\"width-410\" aria-label=\"Forgot password\"><form name=\"forgotPassForm\" novalidate ng-cloak>\n<md-dialog-content><h2 class=\"md-title\">Forgot password</h2><div class=\"padding-top-8\"><md-input-container \nclass=\"md-block md-accent\"><label for=\"email\" translate>LOGIN.EMAIL</label><input type=\"email\" name=\"email\" \nng-model=\"vm.user.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPassForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div><p class=\"margin-0 secondary-text\">\nIf you have forgotten your password you can have a new password generated and e-mailed to you.</p></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-click=\"submitDialog()\" ng-disabled=\"forgotPassForm.$invalid\">Submit</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/auth/login/login.html","<div class=\"overlay\" ng-if=\"loading\"><div class=\"center-loader md-whiteframe-14dp\" layout=\"row\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><span>Please Wait...</span></div></div><div id=\"login\" \nclass=\"flex-scrollable\" layout=\"column\" ms-scroll><div class=\"banner-overlay\" show-gt-md hide-xs></div><div \nid=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\" \nng-style=\"{\'background-image\':\'url({{vm.loginData.backgroundImageUrl}})\'}\"><div layout=\"row\" id=\"login-container\"><div \nlayout=\"column\" layout-align=\"center start\" class=\"left_container\" show-gt-md hide-xs><div class=\"left_wrap_promote\">\n<h1>Best Billing Software</h1><h2>for your businesses</h2><p>\nTechFooddy helps small and medium businesses manage transactions easily, making it simpler to increase profits and grow your business.\n</p></div><div layout=\"row\" layout-align=\"center start\" style=\"margin: 30px 0 0\"><div \nstyle=\"font-size: 40px; font-weight: 700; color:#fff\">5/5</div><img class=\"lozad\" width=\"100\" height=\"17\" \nsrc=\"assets/images/common/apps-rating-star.svg\" style=\"margin:16px 0 0 14px\" data-loaded=\"true\"></div><div \nstyle=\"color:#fff; opacity: 0.85; margin-bottom: 60px; font-size: 14px\">HIGHLY RATED IN GOOGLE</div></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"w100p-login\"><div id=\"login-form\" class=\"md-whiteframe-4dp\"><div \nclass=\"logo-wrapper text-center\"><img ng-src=\"{{vm.loginData.loginLogoUrl}}\" alt=\"Logo\"></div><form name=\"loginForm\" \nnovalidate><span></span><md-input-container class=\"md-block md-accent\"><label for=\"email\" translate>LOGIN.EMAIL</label>\n<input type=\"email\" name=\"email\" ng-model=\"vm.user.email\" ng-pattern=\"/^.+@.+\\..+$/\" required md-autofocus><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-accent\" md-no-float><label for=\"password\" translate>LOGIN.PASSWORD</label><input\n type=\"password\" name=\"password\" ng-model=\"vm.user.password\" required><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required\n</span></div></div></md-input-container><md-button type=\"submit\" ng-if=\"!serverloading\" \nclass=\"md-raised md-primary submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" ng-click=\"vm.authLogin(vm.user)\">LOG IN</md-button><md-button type=\"submit\" \nclass=\"md-raised md-primary submit-button layout-row layout-align-center-center\" aria-label=\"LOG IN\" \nng-disabled=\"true\" ng-if=\"serverloading\"><div layout=\"row\" class=\"layout-align-center-center serverloader\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular><span>Connecting</span></div>\n</md-button></form></div><div class=\"text-center login-footer\"><p class=\"margin-0 text-italic white-text\">\nVersion (4.2.0 11202025)</p><p class=\"margin-0 text-italic white-text padding-top-5\">\nCopyright © 2025 techfooddy.com All rights reserved.</p></div></div></div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nrequired><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" \nng-click=\"vm.authResetPassword()\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/captain/blank/blank.html","<div class=\"layout-column layout-align-center-stretch layout-fill md-whiteframe-2dp white-bg padding-24\"><h1 \nclass=\"text-center md-display-1\">Captain Module - Blank Page</h1></div>");
$templateCache.put("app/main/captain/general/general.html","<div class=\"layout-column layout-align-center-stretch layout-fill md-whiteframe-2dp white-bg padding-24\"><h1 \nclass=\"text-center md-display-1\">Captain Module -- General Page</h1></div>");
$templateCache.put("app/main/cashier/customer-list/customer-list.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable customer-list\"><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 header-panel\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \ntranslate class=\"hidebelow600\">Customer</span></md-button><div layout=\"row\" layout-align=\"end start\" flex><div \nng-if=\"vm.download.customerData\"><a export-to-customer-csv class=\"download-csv mr-10\"><md-tooltip md-direction=\"top\">\nExport customer data to CSV</md-tooltip></a><table style=\"display: none\"><tr><th>Customer Name</th><th>Mobile No</th>\n<th>Locality</th></tr><tr ng-repeat=\"customer in vm.getpurchase  | orderBy: purchaseorder_query.order : true\"><td>\n{{customer.customer_name }}</td><td>{{ customer.customer_mobile }}</td><td>{{ customer.customer_locality }}</td></tr>\n</table></div><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\">\n</md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" ng-click=\"clearText()\"></md-icon>\n</div></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"purchaseorder_query.order\" md-on-reorder=\"getDessertsss\"><tr \nmd-row><th md-column md-order-by=\"customer_name\">{{\'BILLINGS.CUSTOMER-LIST.NAME\' | translate}}</th><th md-column>\n{{\'BILLINGS.CUSTOMER-LIST.MOBILE\' | translate}}</th><th md-column class=\"hidebelow600\">\n{{\'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}}</th><th md-column ng-if=\"vm.settings.show_customer_city\" \nclass=\"hidebelow600\">{{\'BILLINGS.CUSTOMER-LIST.CITY\' | translate}}</th><th md-column \nng-if=\"vm.settings.veg_nonveg_permission\" class=\"hidebelow600\">FoodType</th><th md-column class=\"hidebelow600\">\n{{\'BILLINGS.CUSTOMER-LIST.TOTAL-ORDERED\' | translate}}</th><th md-column md-numeric md-order-by=\"ordertime\" \nclass=\"hidebelow600\">{{\'BILLINGS.CUSTOMER-LIST.LAST-ORDERED\' | translate}}</th><th md-column>\n{{\'BILLINGS.ACTIONS\' | translate}}</th></tr></thead><tbody md-body><tr class=\"cursor-pointer\" md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"customer in vm.getpurchase | limitTo: purchaseorder_query.limit:(purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order : true\" \nhref=\"#\" ng-click=\"viewCustomer(customer);\"><td md-cell><div layout=\"column\" class=\"layout-column\"><div><span \nclass=\"username\">{{customer.customer_name }}</span></div><span class=\"time secondary-text\">{{customer.customer_email}}\n</span></div></td><td md-cell>{{ customer.customer_mobile }}</td><td md-cell class=\"hidebelow600\">\n{{ customer.customer_locality }}</td><td md-cell ng-if=\"vm.settings.show_customer_city\" class=\"hidebelow600\">\n{{ customer.customer_city }}</td><td md-cell ng-if=\"vm.settings.veg_nonveg_permission\" class=\"hidebelow600\">\n{{customer.customerFoodType}}</td><td md-cell class=\"hidebelow600\">{{customer.total_visit}}</td><td md-cell \nclass=\"hidebelow600\">{{ customer.salesorder_id ? (customer.ordertime | date) : \'\'}} <span class=\"username\">\n-{{ customer.salesorder_id ? customer.lastvisit : \'\'}}</span></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.showAddTableDialog($event,customer);$event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></md-table-container><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.getpurchase.length==0\"><h3>\nThere\'re no customers for you to see.</h3></div><md-table-pagination md-limit=\"purchaseorder_query.limit\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"purchaseorder_query.page\" md-total=\"{{purchaseorder_count}}\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/cashier/dashboard/dashboard.html","<div id=\"user-dashboard\" class=\"page-layout min-height-alter48px\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300 pl-24\">\n{{ \'BILLINGS.WELCOME-BACK\' | translate}}, {{staff_name}}!</span></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"Today task\" ng-if=\"vm.settings.show_today_task\"><div \nng-include=\"\'app/main/cashier/dashboard/overview/overview.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{ \'BILLINGS.POS-BILL\' | translate}}\" ng-if=\"cashier_analytics_permission==true\"><div \nng-include=\"\'app/main/cashier/dashboard/pos-billing/pos-billing.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'ODC.ODC-BANQUET\' | translate}}\" ng-if=\"odc_analytics_permission==true\"><div \nng-include=\"\'app/main/cashier/dashboard/odc/odc.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'EXPENSE.EXPENSE\' | translate}}\" ng-if=\"expense_analytics_permission==true\"><div \nng-include=\"\'app/main/cashier/dashboard/expense/expense.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'Inventory.Inventory\' | translate}}\" ng-if=\"inventory_analytics_permission==true\"><div \nng-include=\"\'app/main/cashier/dashboard/inventory/inventory.html\'\" ms-scroll></div></md-tab><md-tab \nlabel=\"{{\'BILLINGS.SMS-MARKETING\' | translate}}\" ng-if=\"sms==true\"><div \nng-include=\"\'app/main/cashier/dashboard/sms-marketing/sms-marketing.html\'\" ms-scroll></div></md-tab></md-tabs></div>\n<div id=\"content3\" style=\"display: none\"><div ng-include=\"\'app/main/admin/admindashboard/dailyexport.html\'\"></div>\n</div></div></div>");
$templateCache.put("app/main/cashier/online-storage-db/online-storage-db.html","<div class=\"layout-column layout-align-start-start min-height-100 white-bg padding-24 syncDB\" ng-if=\"vm.dbstorage\"><div\n layout=\"row\" style=\"width: 100%\"><div flex=\"40\" class=\"mt-24 text-center\"><img src=\"assets/images/sync-desktop.svg\">\n</div><div flex=\"40\" class=\"mt-24\" ng-if=\"uploaddb==true\"><div ng-hide=\"online\" class=\"warm-msg\">\nYou\'re in offline. Please connect to the internet for sync data to online</div><h1>Sync Data to Online</h1><h3 \nclass=\"text-left\">Sync all your data to online storage. It keeps your data safe and secure.</h3><span class=\"tag\">\n<md-icon class=\"mr-8 md-accent\" md-font-icon=\"icon icon-check s20\" aria-label=\"success\" ng-if=\"successUpload\">\n</md-icon>Last Synced Date : {{uploadDBTime}}</span><br><div class=\"warm-msg mt-10\" ng-if=\"errorUpload\">\nSync Data Error. Please check your internet connection and try again</div><md-button \nclass=\"md-raised md-accent layout-row layout-align-center-center mt-40 sync_button\" ng-click=\"sync()\" \nng-disabled=\"!online\" ng-if=\"!load && syncbutton\">&nbsp; Sync Data &nbsp;</md-button><span class=\"mt-32 please_wait\" \nstyle=\"display: block\" ng-if=\"load\">Please Wait Syncing...<span><md-progress-linear md-mode=\"indeterminate\" \nclass=\"mt-16 md-accent\" ng-if=\"load\"></md-progress-linear></span></span></div><div flex=\"40\" class=\"mt-24\" \nng-if=\"uploaddb!=true\"><h1>Upgrade your account</h1><h3 class=\"text-left\">\nTo continue using sync all your data to online storage. It keeps your data safe and secure.</h3><span class=\"tag\">\nContact us to upgrade :</span><br><div class=\"mt-12\">Mobile :- +91 9094858377</div><div class=\"mt-4\">\nEmail :- info@techfooddy.com</div><div class=\"mt-4\">Website :- www.techfooddy.com</div></div><div flex=\"20\"></div>\n</div></div>");
$templateCache.put("app/main/cashier/permission-denied/permission-denied.html","<div \nclass=\"layout-column layout-align-center-center min-height-100 md-whiteframe-2dp white-bg padding-24 text-center no-permission\">\n<h1 class=\"text-center md-display-1\">Permission Denied</h1><h3 class=\"text-center\">\nSorry, You don\'t have permissions to access the page. Please contact your administrator to get permission</h3><img \nsrc=\"assets/images/permission-denied.jpg\" width=\"734\" height=\"446\"></div>");
$templateCache.put("app/main/cashier/profile/profile.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg\" ng-hide=\"s\"><div \nclass=\"layout-row layout-xs-column padding-24\"><img \nclass=\"w-80 h-80 make-round margin-right-48 margin-bottom-32 flex-none\" src=\"assets/images/avatars/profile.jpg\" \nalt=\"avatar\"><ul class=\"user-profile flex\"><li><div class=\"label\">Name</div><div class=\"title\">{{profile.name}}</div>\n</li><li><div class=\"label\">Email ID</div><div class=\"title\">{{profile.email}}</div></li><li><div class=\"label\">\nMobile No</div><div class=\"title\">{{profile.mobile}}</div></li><li><div class=\"label\">Role</div><div class=\"title\">\n<span translate>{{role_name}}</span></div></li><li><div class=\"layout-row layout-align-end-center\"><md-button \nclass=\"md-accent\" aria-label=\"edit info\" ng-click=\"s=!s\">Edit Info</md-button></div></li></ul></div></div><div \nclass=\"layout-column min-height-100 md-whiteframe-2dp white-bg\" ng-show=\"s\"><div \nclass=\"layout-column layout-xs-column padding-24 medium\"><md-input-container class=\"user-profile flex\" flex-gt-sm>\n<label>Name</label><input type=\"text\" name=\"mobile\" ng-model=\"vm.user.name\" ng-required=\"true\"><div \nng-messages=\"addUser.mobile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the mobile number</span></div></div></md-input-container><md-input-container class=\"user-profile flex\" \nflex-gt-sm><label>Email ID</label><input type=\"text\" name=\"mobile\" ng-model=\"vm.user.email\" ng-required=\"true\"><div \nng-messages=\"addUser.mobile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the mobile number</span></div></div></md-input-container><md-input-container class=\"user-profile flex\" \nflex-gt-sm><label>Mobile No</label><input type=\"text\" name=\"mobile\" ng-model=\"vm.user.mobile\" ng-required=\"true\"><div \nng-messages=\"addUser.mobile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the mobile number</span></div></div></md-input-container><span style=\"float: left\"><md-button \nclass=\"md-accent\" ng-click=\"OpenPassword = !OpenPassword\">Edit Password</md-button></span><br><md-input-container \nng-show=\"OpenPassword\" class=\"user-profile flex\" flex-gt-sm><label>Update Password</label><input type=\"password\" \nminlength=\"3\" name=\"password\" ng-model=\"password\"></md-input-container><br><br><div style=\"float: left\"><md-button \nclass=\"md-accent\" ng-click=\"submit()\">Update</md-button><md-button class=\"md-accent\" ng-click=\"cancel()\">cancel\n</md-button></div></div></div>");
$templateCache.put("app/main/super-admin/add-branch/add-branch.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg padding-24 mb-24\"><div class=\"m-w-620\"><form \nname=\"addbranch\" novalidate><div class=\"layout-column mt-8\"><div class=\"sub-head mb-24\"><span translate>COMPANY.BRANCH\n</span> details</div><md-input-container class=\"md-accent\"><label>Corporate Category</label><md-select \nng-model=\"branch.domain_category\" aria-label=\"Change range\" required><md-option ng-repeat=\"domain in vm.domainTypes\" \nvalue=\"{{domain.value}}\">{{domain.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-accent\"><label>Corporate Name</label><input type=\"text\" name=\"corporateName\" maxlength=\"60\" \nng-model=\"branch.corporate_name\" required><div ng-messages=\"addbranch.corporateName.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the Corporate Name</span></div></div>\n</md-input-container><md-input-container class=\"md-accent\"><label><span translate>COMPANY.BRANCH</span> Name</label>\n<input type=\"text\" name=\"branchName\" maxlength=\"60\" ng-model=\"branch.branch_name\" required><div \nng-messages=\"addbranch.branchName.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>COMPANY.BRANCH</span> Name</span></div></div></md-input-container><div layout=\"row\" \nclass=\"small hide-date-picker-icon spacer-8\"><span flex-none class=\"form-label mt-8 w-100\">\nExpiry {{\'ODC.Date\' | translate}}</span><md-input-container class=\"md-block md-accent\" flex=\"50\"><md-datepicker \nng-model=\"branch.expiry_date\" md-min-date=\"minDate\" class=\"md-accent\" md-current-view=\"day\" \nmd-placeholder=\"Enter date\"></md-datepicker></md-input-container></div><md-input-container class=\"md-accent\" required>\n<label>Barcode Printer</label><md-select ng-model=\"branch.barcode_enable\"><md-option \nng-repeat=\"barcode in vm.barcodePrinter\" value=\"{{barcode.value}}\">{{barcode.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-accent\"><label>Address</label><textarea type=\"text\" \nname=\"branchAddress\" rows=\"2\" ng-model=\"branch.address\" required></textarea><div \nng-messages=\"addbranch.branchAddress.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>COMPANY.BRANCH</span> Address</span></div></div></md-input-container><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>Gst N0</label><input type=\"text\" \nname=\"gst\" ng-model=\"branch.GstNo\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label>City</label><input type=\"text\" name=\"companyCity\" ng-model=\"branch.city\" \nrequired><div ng-messages=\"addbranch.companyCity.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Please enter the city</span></div></div></md-input-container><md-input-container class=\"md-block md-accent ml-8\" \nflex-gt-sm><label>Pin code</label><input type=\"text\" name=\"companyPincode\" ng-model=\"branch.pincode\" required><div \nng-messages=\"addbranch.companyPincode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the pincode</span></div></div></md-input-container><md-input-container class=\"md-block md-accent ml-8\" \nflex-gt-sm><label>State</label><input type=\"text\" name=\"companyState\" ng-model=\"branch.state\" required=\"\"><div \nng-messages=\"addbranch.companyState.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the state</span></div></div></md-input-container></div><md-input-container class=\"md-block md-accent\" \nflex-gt-sm><label>Contact No</label><input type=\"text\" name=\"branchMobileNo1\" minlength=\"6\" maxlength=\"15\" \nng-model=\"branch.contact_number\" required><div ng-messages=\"addbranch.branchMobileNo1.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\">Please enter the mobile no</div></div></md-input-container>\n<md-input-container class=\"md-accent\" flex=\"60\" md-no-float><md-select ng-model=\"branch.printsize\" \nplaceholder=\"Print Size\" name=\"printsize\" class=\"md-accent\" md-no-asterisk=\"false\" required><md-option \nng-repeat=\"printsize in printSize\" value=\"{{printsize.value}}\">{{printsize.label}}</md-option></md-select>\n</md-input-container><br><br><md-input-container class=\"md-block md-accent\" flex-gt-sm><label>Print Footer Line</label>\n<input type=\"text\" name=\"authkey\" ng-model=\"branch.print_footer\"></md-input-container><hr class=\"mb-24 mt-16 md-block\" \nng-hide=\"params.id\"><div class=\"sub-head mb-24\" ng-hide=\"params.id\">Account details</div><md-input-container \nclass=\"md-accent\"><label>Name</label><input type=\"text\" name=\"personname\" ng-model=\"admin.personname\" required><div \nng-messages=\"addbranch.personname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the person name</span></div></div></md-input-container><md-input-container class=\"md-block md-accent\" \nflex-gt-sm><label for=\"email\">UserName</label><input type=\"email\" name=\"username\" ng-model=\"admin.username\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"addbranch.username.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the Email id</span></div><div ng-message=\"pattern\"><span>\nPlease enter the valid e-mail address</span></div></div></md-input-container><div ng-hide=\"!params.id\" \nclass=\"layout-row layout-align-start-start\"><md-button class=\"md-primary ml-0 mb-8\" aria-label=\"submit\" \nng-click=\"OpenPassword = !OpenPassword\">Edit Password</md-button></div><md-input-container class=\"md-accent mb-8\" \nng-show=\"OpenPassword\" ng-if=\"params.id\"><label>{{\'USERS.PASSWORD\' | translate}}</label><input type=\"password\" \nng-model=\"admin.updatepassword\"></md-input-container><md-input-container ng-if=\"!params.id\" class=\"md-accent\"><label>\nPassword</label><input type=\"password\" name=\"newpassword\" ng-model=\"admin.password\"><div \nng-messages=\"addbranch.newpassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease enter the password</div></div></md-input-container><div><div><div class=\"sub-head mb-24\">\n{{\'USERS.APP-MODULE\' | translate}}</div><div layout=\"column\" class=\"padding-16 ash-color mb-16\"><md-checkbox \nname=\"{{checkbox.name}}\" ng-checked=\"params.id && modules.length==8 ? true : \'\'\" ng-model=\"selectedAll\">All Module\n</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Select All the Models</div><md-checkbox \nname=\"{{checkbox.name}}\" ng-checked=\"selectedAll || salesbillss.length\" ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" \nng-model=\"salesbill\" ng-disabled=\"selectedAll\">SALES BILL</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage sales bill and amount</div><md-checkbox \nname=\"{{checkbox.name}}\" ng-checked=\"selectedAll || dealerbillss.length\" ng-true-value=\"\'7\'\" ng-false-value=\"\'\'\" \nng-model=\"dealersbill\" ng-disabled=\"selectedAll\">DEALER BILL</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage Dealers bill and amount</div><md-checkbox \nname=\"{{checkbox.name}}\" ng-checked=\"selectedAll || expensebillss.length\" ng-true-value=\"\'2\'\" ng-false-value=\"\'\'\" \nng-model=\"expensebill\" ng-disabled=\"selectedAll\">EXPENSE BILL</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage Expense bill and amount</div><md-checkbox \nname=\"{{checkbox.name}}\" ng-checked=\"selectedAll || ODCC.length\" ng-true-value=\"\'4\'\" ng-false-value=\"\'\'\" \nng-model=\"odc\" ng-disabled=\"selectedAll\">ODC</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nManage Odc bill and amount</div><md-checkbox name=\"{{checkbox.name}}\" ng-checked=\"selectedAll  || Inventoryy.length\" \nng-true-value=\"\'3\'\" ng-false-value=\"\'\'\" ng-model=\"inventory\" ng-disabled=\"selectedAll\">INVENTORY</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Viewing report of sales and expenses</div><div layout-gt-sm=\"row\" \nng-show=\"inventory\" class=\"ml-24\"><div layout=\"column\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"(selectedAll|| Rawmaterialss.length)&&inventory\" ng-true-value=\"\'31\'\" ng-false-value=\"\'\'\" \nng-model=\"rawmaterial\" ng-disabled=\"selectedAll\">Raw Material</md-checkbox><span \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Viewing report of raw materials</span></div><div layout=\"column\">\n<md-checkbox name=\"{{checkbox.name}}\" ng-checked=\"(selectedAll || salematerialss.length)&&inventory\" \nng-true-value=\"\'32\'\" ng-false-value=\"\'\'\" ng-model=\"salesmaterial\" ng-disabled=\"selectedAll\">Sale Material</md-checkbox>\n<span class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Viewing report of sales materials</span></div></div>\n<md-checkbox name=\"{{checkbox.name}}\" ng-checked=\"selectedAll || Marketingg.length\" ng-true-value=\"\'5\'\" \nng-false-value=\"\'\'\" ng-model=\"marketing\" ng-disabled=\"selectedAll\">MARKETING</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Viewing report of customer and sms campaign</div><div \nlayout-gt-sm=\"row\" ng-show=\"marketing\" class=\"ml-24\"><div layout=\"column\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"(selectedAll|| customerr.length)&&marketing\" ng-true-value=\"\'51\'\" ng-false-value=\"\'\'\" ng-model=\"customer\" \nng-disabled=\"selectedAll\">Customer</md-checkbox><span class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nViewing report of customer</span></div><div layout=\"column\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"(selectedAll|| smss.length)&&marketing\" ng-true-value=\"\'52\'\" ng-false-value=\"\'\'\" ng-model=\"sms\" \nng-disabled=\"selectedAll\">SMS campaign</md-checkbox><span class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nViewing report of sms campaign</span></div><div layout=\"column\"><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"(selectedAll|| whatsappp.length)&&marketing\" ng-true-value=\"\'53\'\" ng-false-value=\"\'\'\" ng-model=\"whatsapp\" \nng-disabled=\"selectedAll\">Whatsapp campaign</md-checkbox><span class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nViewing report of whatsapp campaign</span></div></div><md-checkbox name=\"{{checkbox.name}}\" \nng-checked=\"selectedAll || uploaddbb.length\" ng-true-value=\"\'6\'\" ng-false-value=\"\'\'\" ng-model=\"uploaddb\" \nng-disabled=\"selectedAll\">Upload DB to Online Storage</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Keep your data safe and private</div><md-checkbox \nname=\"{{checkbox.name}}\" ng-checked=\"selectedAll || stewardappp.length\" ng-true-value=\"\'99\'\" ng-false-value=\"\'\'\" \nng-model=\"stewardapp\" ng-disabled=\"selectedAll\">Steward App</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Put bill in mobile app</div></div></div><div \nng-if=\"whatsapp || whatsappp.length\"><div class=\"sub-head mb-24\">Whatsapp Modules</div><div layout=\"column\">\n<md-input-container ng-hide=\"!whatsapp\" ng-if=\"whatsapp || whatsappp.length\" class=\"md-block md-accent\" flex-gt-sm>\n<label>Whatsapp API</label><input type=\"text\" name=\"wa_api\" ng-model=\"branch.wa_api\" ng-required=\"whatsapp\">\n</md-input-container><md-input-container ng-hide=\"!whatsapp\" ng-if=\"whatsapp || whatsappp.length\" \nclass=\"md-block md-accent\" flex-gt-sm><label>Total Count</label><input type=\"text\" name=\"wa_total_count\" \nng-model=\"branch.wa_total_count\" ng-required=\"whatsapp\"></md-input-container><md-input-container ng-hide=\"!whatsapp\" \nng-if=\"whatsapp || whatsappp.length\" class=\"md-block md-accent\" flex-gt-sm><label>Delivered Count</label><input \ntype=\"text\" name=\"wa_delivered_count\" ng-model=\"branch.wa_delivered_count\" ng-required=\"whatsapp\"></md-input-container>\n<div layout=\"row\" class=\"small hide-date-picker-icon spacer-8\"><span flex-none class=\"form-label mt-8 w-100\">\nExpiry {{\'ODC.Date\' | translate}}</span><md-input-container class=\"md-block md-accent\" flex=\"50\"><md-datepicker \nng-model=\"branch.wa_expiry_date\" md-min-date=\"minDate\" class=\"md-accent\" md-current-view=\"day\" \nmd-placeholder=\"Enter date\" ng-required=\"whatsapp\"></md-datepicker></md-input-container></div><div layout=\"row\" \nclass=\"small spacer-8\"><span flex-none class=\"form-label mt-8 w-100\">Send Bill Via Whatsapp</span><md-input-container \nclass=\"md-block md-accent\" flex=\"50\"><md-select ng-model=\"branch.wa_billsend\" placeholder=\"Select Status\"><md-option \nvalue=\"1\">True</md-option><md-option value=\"0\">False</md-option></md-select></md-input-container></div><div \nng-if=\"(whatsapp || whatsappp.length) && branch.wa_billsend == 1\"><div class=\"sub-head mb-24\">UPI Details</div><div \nlayout=\"column\"><md-input-container ng-hide=\"!whatsapp\" ng-if=\"whatsapp || whatsappp.length\" \nclass=\"md-block md-accent\" flex-gt-sm><label>UPI Id</label><input type=\"text\" name=\"upi_id\" ng-model=\"branch.upi_id\" \nng-required=\"whatsapp\"></md-input-container></div><div layout=\"column\"><md-input-container ng-hide=\"!whatsapp\" \nng-if=\"whatsapp || whatsappp.length\" class=\"md-block md-accent\" flex-gt-sm><label>UPI Name</label><input type=\"text\" \nname=\"upi_name\" ng-model=\"branch.upi_name\" ng-required=\"whatsapp\"></md-input-container></div></div></div><div \nng-if=\"sms || smss.length\"><div class=\"sub-head mb-24\">SMS Modules</div><div layout=\"column\"><md-input-container \nng-hide=\"!sms\" ng-if=\"sms || smss.length\" class=\"md-block md-accent\" flex-gt-sm><label>Auth Key</label><input \ntype=\"text\" name=\"authkey\" ng-model=\"branch.authKey\" ng-required=\"sms\"></md-input-container><md-input-container \nng-hide=\"!sms\" ng-if=\"sms || smss.length\" class=\"md-block md-accent\" flex-gt-sm><label>User ID</label><input \ntype=\"text\" name=\"authkey\" ng-model=\"branch.user_id\" ng-required=\"sms\"></md-input-container><md-input-container \nng-if=\"sms || smss.length\" ng-hide=\"!sms\" class=\"md-block md-accent\" flex-gt-sm><label>Sender ID</label><input \ntype=\"text\" maxlength=\"6\" minlength=\"6\" name=\"sentid\" ng-model=\"branch.sender_id\" ng-required=\"marketing\" \nng-required=\"sms\"><div ng-messages=\"addbranch.sentid.$error || addbranch.sentid.$touched\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please enter 6 characters</span></div></div></md-input-container>\n</div></div><div ng-if=\"!params.id\" class=\"layout-row layout-align-end-center\"><md-button \nclass=\"md-raised md-primary margin-right-0 mb-24\" ng-disabled=\"addbranch.$invalid\" ng-click=\"submit()\" \naria-label=\"submit\">Submit</md-button></div><div ng-if=\"params.id\" class=\"layout-row layout-align-end-center\">\n<md-button class=\"md-raised md-primary margin-right-0 mb-24\" ng-click=\"update()\" aria-label=\"submit\">Update</md-button>\n</div></div></div></div></form></div></div>");
$templateCache.put("app/main/super-admin/branch-list/branch-list.html","<div class=\"layout-column layout-align-top-stretch layout-fill md-whiteframe-2dp white-bg overflow-auto padding-24\">\n<div class=\"dataTable-primary scrollable\" ms-scroll><table class=\"dataTable row-border\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span translate>COMPANY.BRANCH</span> Names\n</span></div></th><th class=\"secondary-text\">City</th><th class=\"secondary-text\">Actions</th></tr></thead><tbody><tr \nng-repeat=\"branchinfo in ::branch_data\"><td><span>{{ branchinfo.branch_name}}</span></td><td><span>{{ branchinfo.city}}\n</span></td><td><md-button class=\"md-accent\" ng-click=\"submit(branchinfo.branch_id)\">Edit branch</md-button></td></tr>\n</tbody></table></div></div>");
$templateCache.put("app/main/super-admin/design-color/design-color.html","<div layout=\"row\" id=\"design-color\"><div class=\"layout-column min-height-100 padding-24 mb-24\" flex=\"66\"><div \nlayout=\"row\"><div layout=\"column\" flex class=\"mr-32\"><h1>Primary Color</h1><ul class=\"color-list mt-24\"><li \nng-repeat=\"color in vm.colorlist\" style=\"background:{{ color.value }}\">{{ color.name }}<md-icon md-menu-origin \nmd-font-icon=\" icon-checkbox-marked-circle\" class=\"position\"></md-icon></li></ul></div><div layout=\"column\" flex \nclass=\"ml-32\"><h1>Secondary Color</h1><ul class=\"color-list mt-24\"><li ng-repeat=\"color in vm.colorlist\" \nstyle=\"background:{{ color.value }}\">{{ color.name }}<md-icon md-menu-origin \nmd-font-icon=\" icon-checkbox-marked-circle\" class=\"position\"></md-icon></li></ul></div></div><hr class=\"mt-32 mb-24\">\n<div layout=\"row\" layout-align=\"end start\"><md-button class=\"md-raised md-primary\">Sumbit</md-button></div></div><div \nclass=\"layout-column flex ml-24\">Preview screen here</div></div>");
$templateCache.put("app/main/super-admin/edit-json-settings/edit-json-settings.html","<div class=\"layout-column layout-align-top-stretch layout-fill md-whiteframe-2dp white-bg overflow-auto padding-24\">\n<div class=\"dataTable-primary scrollable\" ms-scroll><div class=\"layout-row layout-align-end-center\"><md-button \nclass=\"md-raised md-primary margin-right-0 mb-24\" ng-click=\"update()\" aria-label=\"submit\">Get</md-button></div></div>\n</div>");
$templateCache.put("app/main/super-admin/restaurant-account/restaurant-account.html","<div class=\"layout-column md-whiteframe-1dp white-bg mb-24 m-w-720\"><div layout=\"row\" class=\"p-36 md-accent-bg\"><div \nclass=\"activity layout-align-start-start layout-row\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo-wrapper-col-bg mr-24 md-whiteframe-1dp\" layout=\"column\" layout-align=\"center center\"><img \nng-src=\"assets/images/login/logo.png\" class=\"logo-resize\"></div><div layout=\"column\"><h1 class=\"text-white m-0\">Henkala\n</h1><h4 class=\"text-white m-0\">36 Branches</h4></div></div></div><div layout=\"column\" \nclass=\"layout-align-start-start margin-left-16 mt-16 view-user padding-24\"><span class=\"time secondary-text\">Address\n</span> <span class=\"time primary-text mt-8\">No.4, Rajaji Road, Tambaram, Chennai, Tamil Nadu 600045</span><hr \nclass=\"mv-16 md-block\"><div layout=\"row\" class=\"w-100p\"><div layout=\"column\" flex><span class=\"time secondary-text\">\nContact No.1</span> <span class=\"time primary-text mt-8\">+91 98522 35671</span></div><div layout=\"column\" flex><span \nclass=\"time secondary-text\">Contact No.2</span> <span class=\"time primary-text mt-8\">+91 98522 35671</span></div></div>\n<hr class=\"mv-16 md-block\"><div layout=\"row\" class=\"w-100p\"><div layout=\"column\" flex><span \nclass=\"time secondary-text\">Contact Email</span> <span class=\"time primary-text mt-8\">amalausline@gmail.com</span>\n</div><div layout=\"column\" flex><span class=\"time secondary-text\">Levels</span> <span class=\"time primary-text mt-8\">\nLow/ Custom</span></div></div><hr class=\"mv-16 md-block\"><div layout=\"row\" class=\"w-100p\"><div layout=\"column\" flex>\n<span class=\"time secondary-text\">App Module</span> <span class=\"time primary-text mt-8\"><span \nclass=\"outline-ash-tag mr-8 mb-8\">Sales Bills </span><span class=\"outline-ash-tag mr-8 mb-8\">Expenses Bills</span>\n</span></div><div layout=\"column\" flex><span class=\"time secondary-text\">Branch Count Permission</span> <span \nclass=\"time primary-text mt-8\">Unlimited</span></div></div><hr class=\"mv-16 md-block\"><div layout=\"row\" \nclass=\"layout-align-end-center mt-16\" style=\"width: 100%\"><md-button class=\"md-accent margin-right-0\" \naria-label=\"edit info\" ui-sref=\"app.editcashier\">Edit Info</md-button></div></div></div>");
$templateCache.put("app/main/super-admin/super-admin-dashboard/super-admin-dashboard.html","<div class=\"layout-fill md-whiteframe-2dp white-bg padding-24\" layout-align=\"start start\" id=\"superadmindashboard\">\nComing soon</div>");
$templateCache.put("app/main/ssadmin/createcompany/createcompany.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg padding-24 mb-24\"><div class=\"m-w-720\"><form \nname=\"createcompany\" novalidate><div class=\"sub-head mb-16\">Select the option level</div><md-radio-group \nclass=\"layout-row mt-8\" ng-model=\"company.level\" required><md-radio-button value=\"low\">Low</md-radio-button>\n<md-radio-button value=\"medium\">Medium</md-radio-button><md-radio-button value=\"high\">High</md-radio-button>\n</md-radio-group><hr class=\"mb-24 mt-24 md-block\"><div class=\"sub-head mb-24\">Company details</div><div \nlayout=\"column\" layout-align=\"center center\" class=\"ml-56\" style=\"width: 120px; float:right\"><img \nclass=\"logo-resize mb-16\" src=\"assets/images/logos/default-logo.svg\" alt=\"logo\"> <input class=\"ng-hide\" \nid=\"input-file-id\" multiple=\"multiple\" type=\"file\"><label for=\"input-file-id\" class=\"md-button md-accent\">Add Logo\n</label></div><div layout=\"column\" flex><md-input-container class=\"md-accent\"><label>Company Name</label><input \ntype=\"text\" name=\"companyname\" ng-model=\"company.name\" required><div ng-messages=\"createcompany.companyname.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the Company name</span></div></div>\n</md-input-container><md-input-container class=\"md-accent\"><label>Address</label><textarea type=\"text\" \nname=\"companyAddress\" rows=\"2\" ng-model=\"company.address\" required></textarea><div \nng-messages=\"createcompany.companyAddress.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the Company Address</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label>City</label><input type=\"text\" name=\"companyCity\" ng-model=\"company.city\" \nrequired><div ng-messages=\"createcompany.companyCity.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the city</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-accent ml-8\" flex-gt-sm><label>Pin code</label><input type=\"text\" name=\"companyPincode\" \nng-model=\"company.pincode\" required><div ng-messages=\"createcompany.companyPincode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the pincode</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-accent ml-8\" flex-gt-sm><label>State</label><input type=\"text\" \nname=\"companyState\" ng-model=\"company.state\" required=\"\"><div ng-messages=\"createcompany.companyState.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the state</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block md-accent\" flex-gt-sm><label \nfor=\"email\">Contact Email ID</label><input type=\"email\" name=\"companyEmail\" ng-model=\"company.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"createcompany.companyEmail.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the contact Email</span></div><div \nng-message=\"pattern\"><span>Please enter the valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block ml-8 md-accent\" flex-gt-sm><label>Contact Mobile No</label><input type=\"text\" \nname=\"companyMobileNo1\" ng-model=\"company.mobile1\" required><div ng-messages=\"createcompany.companyMobileNo1.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Please enter the mobile no</div></div></md-input-container>\n<md-input-container class=\"md-block md-accent ml-8\" flex-gt-sm><label>Another Contact No</label><input type=\"text\" \nng-model=\"company.alternateNumber\"></md-input-container></div><hr class=\"mb-24 mt-16 md-block\"><div \nclass=\"sub-head mb-24\">Account details</div><md-input-container class=\"md-accent\"><label>Name</label><input \ntype=\"text\" name=\"personname\" ng-model=\"user.personname\" required><div ng-messages=\"createcompany.personname.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the person name</span></div></div>\n</md-input-container><md-input-container class=\"md-block md-accent\" flex-gt-sm><label for=\"email\">Email ID</label>\n<input type=\"email\" name=\"companyAccountEmail\" ng-model=\"user.accountemail\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"createcompany.companyAccountEmail.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Please enter the Email id</span></div><div ng-message=\"pattern\"><span>Please enter the valid e-mail address\n</span></div></div></md-input-container><md-input-container class=\"md-accent\"><label>Password</label><input \ntype=\"password\" name=\"companyAccountPassword\" minlength=\"4\" ng-model=\"user.accountpassword\" required><div \nng-messages=\"createcompany.companyAccountPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease enter the password</div><div ng-message=\"minlength\">Password length is too short!</div></div>\n</md-input-container><hr class=\"mb-24 mt-16 md-block\"><div class=\"sub-head mb-24\">Choose domain</div><div \nclass=\"layout-row\"><md-input-container class=\"md-accent\"><label>Domain Name</label><input type=\"text\" \nname=\"companyDomain\" ng-model=\"company.domain\" required><div ng-messages=\"createcompany.companyDomain.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the your domain name</span></div></div>\n</md-input-container><span class=\"mt-24\">.dx4studio.com</span></div><md-checkbox ng-model=\"company.customLevels\" \nng-checked=\"\" class=\"mt-16\">Custom Levels</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16 font-size-px-14\">Custom app module, Usage and Users access.</div><div\n ng-show=\"company.customLevels\" layout=\"column\"><div class=\"sub-head mb-24\">App Modules</div><div layout=\"column\" \nclass=\"padding-16 ash-color mb-8\"><md-checkbox ng-model=\"vm.sales\" class=\"md-block\" ng-value=\"sales\" ng-checked=\"\">\nSales Bills</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage sales bill and amount</div>\n<md-checkbox ng-model=\"vm.expense\" class=\"md-block\" ng-value=\"expense\" ng-checked=\"\">Expense Bills</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage Expense bill and amount</div><md-checkbox \nng-model=\"vm.manager\" class=\"md-block\" ng-value=\"manager\" ng-checked=\"\">Manager Module</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Viewing report of sales and expenses</div></div><div \nclass=\"sub-head mb-8 mt-24\">Branches</div><md-checkbox ng-model=\"appaccess\" ng-checked=\"true\">Allow to Create Branch\n</md-checkbox><div ng-show=\"appaccess\" layout=\"column\"><div layout=\"row\" class=\"padding-8 ash-color mb-8\">\n<md-input-container class=\"md-accent md-block ml-8\" flex><label>Branches Count</label><md-select \nng-model=\"company.branchescount\" class=\"md-accent\"><md-option value=\"limited\">Limited</md-option><md-option \nvalue=\"unlimited\">Unlimited</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"md-block md-accent mr-8\" flex><input type=\"text\" placeholder=\"Branches Count\" name=\"limitedcount\" \nng-model=\"company.count\" ng-pattern=\"/^[0-9]*$/\"><div ng-messages=\"addlevel.limitedcount.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Please enter only numbers</span></div></div></md-input-container>\n</div></div></div><div class=\"layout-row layout-align-end-center\"><md-button \nclass=\"md-raised md-primary margin-right-0 mb-24\" aria-label=\"submit\" ng-click=\"submitCompanyDet()\">Submit</md-button>\n</div></div></form></div></div>");
$templateCache.put("app/main/ssadmin/editcompany/editcompany.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg padding-24 mb-24\"><div class=\"m-w-720\"><form \nname=\"editcompany\" novalidate><div class=\"sub-head mb-16\">Select the option level</div><md-radio-group \nclass=\"layout-row mt-8\" ng-model=\"companylevel\" required><md-radio-button value=\"low\">Low</md-radio-button>\n<md-radio-button value=\"medium\">Medium</md-radio-button><md-radio-button value=\"high\">High</md-radio-button>\n</md-radio-group><hr class=\"mb-24 mt-24 md-block\"><div class=\"sub-head mb-24\">Company details</div><div \nlayout=\"column\" flex><md-input-container class=\"md-accent\"><label>Company Name</label><input type=\"text\" \nname=\"companyname\" ng-model=\"companyname\" required></md-input-container><md-input-container class=\"md-accent\"><label>\nAddress</label><textarea type=\"text\" name=\"companyAddress\" rows=\"2\" ng-model=\"companyaddress\" required></textarea><div \nng-messages=\"editcompany.companyAddress.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the Company Address</span></div></div></md-input-container><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label>City</label><input type=\"text\" name=\"companyCity\" ng-model=\"companycity\" \nrequired><div ng-messages=\"editcompany.companyCity.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Please enter the city</span></div></div></md-input-container><md-input-container class=\"md-block md-accent ml-8\" \nflex-gt-sm><label>Pin code</label><input type=\"text\" name=\"companyPincode\" ng-model=\"companypincode\" required><div \nng-messages=\"editcompany.companyPincode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the pincode</span></div></div></md-input-container><md-input-container class=\"md-block md-accent ml-8\" \nflex-gt-sm><label>State</label><input type=\"text\" name=\"companyState\" ng-model=\"companystate\" required=\"\"><div \nng-messages=\"editcompany.companyState.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the state</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-accent\" flex-gt-sm><label for=\"email\">Contact Email ID</label><input type=\"email\" \nname=\"companyEmail\" ng-model=\"companyemail\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div \nng-messages=\"editcompany.companyEmail.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the contact Email</span></div><div ng-message=\"pattern\"><span>Please enter the valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block ml-8 md-accent\" flex-gt-sm><label>\nContact Mobile No</label><input type=\"text\" name=\"companyMobileNo1\" ng-model=\"companymobile1\" required><div \nng-messages=\"editcompany.companyMobileNo1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease enter the mobile no</div></div></md-input-container><md-input-container class=\"md-block md-accent ml-8\" \nflex-gt-sm><label>Another Contact No</label><input type=\"text\" ng-model=\"companyalternateNumber\"></md-input-container>\n</div><hr class=\"mb-24 mt-16 md-block\"><div class=\"sub-head mb-24\">Account details</div><md-input-container \nclass=\"md-accent\"><label>Name</label><input type=\"text\" name=\"personname\" ng-model=\"userpersonname\" required><div \nng-messages=\"editcompany.personname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the person name</span></div></div></md-input-container><md-input-container class=\"md-block md-accent\" \nflex-gt-sm><label for=\"email\">Email ID</label><input type=\"email\" name=\"companyAccountEmail\" \nng-model=\"useraccountemail\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"editcompany.companyAccountEmail.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the Email id</span></div><div ng-message=\"pattern\"><span>Please enter the valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-accent\"><label>Password</label><input type=\"password\" \nname=\"companyAccountPassword\" minlength=\"4\" ng-model=\"useraccountpassword\" autocomplete=\"new-password\" required><div \nng-messages=\"editcompany.companyAccountPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nPlease enter the password</div><div ng-message=\"minlength\">Password length is too short!</div></div>\n</md-input-container><hr class=\"mb-24 mt-16 md-block\"><div class=\"sub-head mb-24\">Choose domain</div><div \nclass=\"layout-row\"><md-input-container class=\"md-accent\"><label>Domain Name</label><input type=\"text\" \nname=\"companyDomain\" ng-model=\"companydomain\" required><div ng-messages=\"editcompany.companyDomain.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the your domain name</span></div></div>\n</md-input-container><span class=\"mt-24\">.dx4studio.com</span></div><md-checkbox ng-model=\"companycustomLevels\" \nng-checked=\"\" class=\"mt-16\">Custom Levels</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16 font-size-px-14\">Custom app module, Usage and Users access.</div><div\n ng-show=\"companycustomLevels\" layout=\"column\"><div class=\"sub-head mb-24\">App Modules</div><div layout=\"column\" \nclass=\"padding-16 ash-color mb-8\"><md-checkbox ng-model=\"sales\" class=\"md-block\" ng-value=\"sales\" ng-checked=\"\">\nSales Bills</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage sales bill and amount</div>\n<md-checkbox ng-model=\"expense\" class=\"md-block\" ng-value=\"expense\" ng-checked=\"\">Expense Bills</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage Expense bill and amount</div><md-checkbox ng-model=\"manager\" \nclass=\"md-block\" ng-value=\"manager\" ng-checked=\"\">Manager Module</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">Viewing report of sales and expenses</div></div><div \nclass=\"sub-head mb-8 mt-24\">Branches</div><md-checkbox ng-model=\"appaccess\" ng-checked=\"true\">Allow to Create Branch\n</md-checkbox><div ng-show=\"appaccess\" layout=\"column\"><div layout=\"row\" class=\"padding-8 ash-color mb-8\">\n<md-input-container class=\"md-accent md-block ml-8\" flex><label>Branches Count</label><md-select \nng-model=\"companybranchescount\" class=\"md-accent\"><md-option value=\"limited\">Limited</md-option><md-option \nvalue=\"unlimited\">Unlimited</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"md-block md-accent mr-8\" flex><input type=\"text\" placeholder=\"Branches Count\" name=\"limitedcount\" \nng-model=\"companycount\" ng-pattern=\"/^[0-9]*$/\"><div ng-messages=\"addlevel.limitedcount.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Please enter only numbers</span></div></div></md-input-container>\n</div></div></div></div><div class=\"layout-row layout-align-end-center\"><md-button \nclass=\"md-raised md-primary margin-right-0 mb-24\" aria-label=\"submit\" ng-click=\"submitCompanyDet()\">Submit</md-button>\n</div></form></div></div>");
$templateCache.put("app/main/ssadmin/listcompany/listcompany.html","<div class=\"layout-column layout-align-top-stretch layout-fill md-whiteframe-2dp white-bg overflow-auto padding-24\">\n<div class=\"dataTable-primary scrollable\" ms-scroll><table class=\"dataTable row-border\"><thead><tr><th width=\"30%\">\nCOMPANY NAME</th><th width=\"15%\">LEVELS</th><th width=\"10%\">BRANCHES</th><th width=\"15%\">STATUS</th><th width=\"30%\">\nACTIONS</th></tr></thead><tbody><tr ng-repeat=\"companyinfo in companyInfoList\"><td class=\"border-status\"><div \nclass=\"activity layout-align-start-start layout-row\" layout=\"row\" layout-align=\"start start\"><span \nstyle=\"width: 140px; height: 44px\" class=\"mr-24\"><img ng-src=\"{{ companyinfo.companyLogo }}\" class=\"logo-resize\">\n</span><div layout=\"column\" class=\"layout-column\"><div><span class=\"username\">{{ companyinfo.companyName }}</span>\n</div><span class=\"time secondary-text\">{{ companyinfo.companyemailid }}</span></div></div></td><td>\n{{ companyinfo.companyLevel }}</td><td>{{ companyinfo.companyBranches }}</td><td><div \nng-if=\"companyinfo.companyStatus != \'Active\'\" class=\"mt-8\"><md-icon md-font-icon=\"icon-close-circle\" class=\"red\">\n</md-icon><span class=\"margin-left-8 red\">{{ companyinfo.companyStatus}}</span></div><div \nng-if=\"companyinfo.companyStatus != \'Deactive\'\" class=\"mt-8\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"green\"></md-icon><span class=\"margin-left-8 green\">{{ companyinfo.companyStatus}}</span></div></td><td>\n<md-button class=\"md-accent\"><a href=\"/editcompany?cid={{ companyinfo.companyIdentifier}}\">EDIT Company</a></md-button>\n<md-button class=\"md-accent\">Visit Company</md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/ssadmin/settings-level/settings-level.addlevel.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-640 h-600 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 \nclass=\"md-title margin-top-0 mb-32 ml-8\">Add Level</h2></div><form name=\"addlevel\" validate><md-input-container \nclass=\"md-accent md-block mt-16 ml-8\" flex=\"50\"><label>Level Name</label><input type=\"text\" name=\"rolename\" \nng-model=\"vm.combopackinfo.rolename\" required><div ng-messages=\"addlevel.rolename.$error\"><div ng-message=\"required\">\nPlease enter the level name</div></div></md-input-container><div class=\"sub-head mb-8 ml-8\">App Modules</div><div \nclass=\"secondary-text mb-16 ml-8 font-size-px-14\">Please select the below app modules for this levels.</div><div \nlayout=\"column\" class=\"padding-16 ash-color mb-16\"><md-checkbox ng-model=\"vm.captain\" class=\"md-block\" \nng-value=\"captain\" ng-checked=\"\">Sales Bills</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nManage sales bill and amount</div><md-checkbox ng-model=\"vm.captain\" class=\"md-block\" ng-value=\"captain\" ng-checked=\"\">\nExpense Bills</md-checkbox><div class=\"secondary-text md-block ml-32 mb-24 mtm-16\">Manage Expense bill and amount</div>\n<md-checkbox ng-model=\"vm.captain\" class=\"md-block\" ng-value=\"captain\" ng-checked=\"\">Manager Module</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mtm-16\">Viewing report of sales and expenses</div></div><hr \nclass=\"md-block mt-24 mb-16\"><div class=\"sub-head mb-8 ml-8 mt-24\">Branches</div><md-checkbox ng-model=\"appaccess\" \nng-checked=\"\" style=\"margin-left:8px\">Allow to Create Branch</md-checkbox><div ng-show=\"appaccess\" layout=\"column\"><div\n layout=\"row\" class=\"padding-8 ash-color ml-8 mb-8\"><md-input-container class=\"md-accent md-block ml-8\" flex><label>\nBranches Count</label><md-select ng-model=\"branchescount\" class=\"md-accent\"><md-option value=\"limited\">Limited\n</md-option><md-option value=\"unlimited\">Unlimited</md-option></md-select></md-input-container><md-input-container \nmd-no-float class=\"md-block md-accent ml-8 mr-8\" flex><input type=\"text\" placeholder=\"Branches Count\" \nname=\"limitedcount\" ng-model=\"company.branch.count\" ng-pattern=\"/^[0-9]*$/\"><div \nng-messages=\"addlevel.limitedcount.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nPlease enter only numbers</span></div></div></md-input-container></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-click=\"closeDialog()\">Add Level</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ssadmin/settings-level/settings-level.html","<div class=\"layout-column layout-align-top-stretch layout-fill md-whiteframe-2dp white-bg overflow-auto padding-24\">\n<div layout=\"column\"><div layout=\"row\" class=\"layout-align-start-center mb-24\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"vm.showAddLevelDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\">\n</md-icon>Add Level</md-button></div><div class=\"dataTable-primary scrollable\" ms-scroll><table \nclass=\"dataTable row-border\"><thead><tr><th class=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span \nclass=\"column-title\">Level Name</span></div></th><th class=\"secondary-text\" width=\"40%\"><div class=\"table-header\"><span\n class=\"column-title\">Access App Modules</span></div></th><th class=\"secondary-text\" width=\"20%\"><div \nclass=\"table-header\"><span class=\"column-title\">Branches Count</span></div></th><th class=\"secondary-text\" width=\"15%\">\n<div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr><tbody><tr \nng-repeat=\"level in levelDetails\"><td>{{ level.name }}</td><td><div class=\"flex-none mr-16 mt-8\"><span \nng-repeat=\"appmodule in level.assignedAppModules\" class=\"outline-ash-tag mr-8 mb-8\">{{ appmodule.appModuleName }}\n</span></div></td><td>{{ level.branchescount }}</td><td><md-button class=\"md-icon-button\" flex title=\"Edit\"><md-icon \nmd-menu-origin md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" flex title=\"Edit\" \nng-click=\"vm.showAlert($event); $event.stopPropagation();\"><md-icon md-menu-origin md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></thead></table></div></div></div>");
$templateCache.put("app/main/ssadmin/ssadmin-dashboard/ssadmin-dashboard.html","<div class=\"layout-fill md-whiteframe-2dp white-bg padding-24\" layout-align=\"start start\" id=\"superadmindashboard\">\nComing soon</div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp layout-row layout-align-space-between-center\"><div \nclass=\"logo layout-row layout-align-start-center\"><div class=\"logo-image\"><img \nsrc=\"assets/images/login/techfooddy-icon.png\"></div><div class=\"margin-left-16\"><div class=\"logo-text\">TechFooddy</div>\n<div class=\"logo-text-sm\"><img src=\"assets/images/login/client-logo.png\" style=\"width: 16px; height: 16px\" \nng-if=\"vm.show_client_image\"> {{corporate}}- {{branch_name}}</div></div></div><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\" \nstyle=\"color: rgba(255, 255, 255, 0.7)\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div class=\"flex-none\" layout=\"row\" layout-align=\"start center\">\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div class=\"layout-row\" layout-align=\"start center\" \nflex><div class=\"padding-horizontal-24\"><div ncy-breadcrumb></div></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" \nclass=\"md-accent\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><md-button \nstyle=\"display: none\" id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><span \nclass=\"notification-badge\">1</span><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon><md-tooltip \nmd-direction=\"bottom\" md-autohide=\"true\">Notification</md-tooltip></md-button><md-button class=\"md-icon-button\" \nui-sref=\"app.onlinestorage\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\" \nng-if=\"vm.settings.connectivity!=1 && vm.settings.topdownloadicon==1\"><md-icon md-font-icon=\"icon-sync\" class=\"icon\">\n</md-icon><md-tooltip md-direction=\"bottom\" md-autohide=\"true\">Sync Data to Online</md-tooltip></md-button><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide show-gt-sm>{{staff_name}}</span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon s24\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"user[0].switch_branch\" class=\"md-indent\" \nui-sref=\"app.branch\"><md-icon md-font-icon=\"icon-swap-horizontal\" class=\"icon\"></md-icon><md-button>Switch Branch\n</md-button></md-menu-item><md-menu-item ng-if=\"admin_permission>0\" class=\"md-indent\" ui-sref=\"app.role\"><md-icon \nmd-font-icon=\"icon-account-switch\" class=\"icon\"></md-icon><md-button>Switch User</md-button></md-menu-item>\n<md-menu-divider ng-if=\"admin_permission>0\"></md-menu-divider><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/admin/admindashboard/expense/expense.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><div \nclass=\"font-size-px-13 ml-8\"><a ng-click=\"OpenPermission = !OpenPermission;\"><span \nng-bind=\"OpenPermission ? \'Default Filter\' : \'Custom Date Filter\'\"></span></a></div><div \nclass=\"small no-error ph-16 small-date-icon filter-dropdown-lg\"><md-select ng-show=\"!OpenPermission\" \nng-init=\"expense = \'today\'\" ng-model=\"expense\" ng-change=\"expenseChange(staff,expense,{{expenses}},$event);\" \naria-label=\"Change range\" class=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"expense in expense_schedule\" \nvalue=\"{{expense.value}}\">{{expense.name}}</md-option></md-select><div class=\"hide-date-picker-icon\" \nng-show=\"OpenPermission\"><md-input-container class=\"md-block md-accent\"><md-datepicker ng-show=\"OpenPermission\" \nng-model=\"myDates\" ng-init=\"myDates = myDate\" md-placeholder=\"Enter date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \naria-label=\"today\" ng-change=\"expenseChange(staff,myDates,$event);newdates(myDates)\"></md-datepicker>\n</md-input-container></div></div><div class=\"medium ph-8 filter-dropdown-md\"><md-select ng-model=\"staff\" \nng-init=\"staff=staffs\" aria-label=\"today\" \nng-change=\"expenseChange(staff,OpenPermission ? newdate_datas : expense,$event)\" class=\"md-accent\" flex=\"100\">\n<md-option ng-repeat=\"staff in vm.expense_staffs\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select>\n</div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" \nflex=\"100\" flex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{\'EXPENSE.EXPENSE\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{total_paid+total_balance | thousandSuffix : fractionSize}}\n</span></div><div class=\"label md-truncate\">{{\'EXPENSE.TOTAL-EXPENSE\' | translate}} (<span translate>BILLINGS.INR\n</span>)</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{total_paid | thousandSuffix : fractionSize}}</span></div>\n<div class=\"label md-truncate\">{{\'EXPENSE.PAID-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div>\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{total_balance | thousandSuffix : fractionSize}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.BALANCE-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)\n</div></div></div><div class=\"layout-row layout-align-start-start tax-text-container\"><div flex \nclass=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">\nTax Cgst- &nbsp; ₹ {{expensetax | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTax Sgst- &nbsp; ₹ {{expensetaxCgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTotal Tax- &nbsp; ₹ {{expensetaxSgst | thousandSuffix : fractionSize}}</span></div></div><ms-widget-front \nclass=\"pie-chart\"><nvd3 config=\"vm.widget7.mainChart.config\" options=\"vm.widget7.mainChart.options\" \ndata=\"vm.widget7.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\">\n<span class=\"h3\">{{\'EXPENSE.VENDORS\' | translate}}</span></div></div><div layout=\"row\" layout-align=\"end center\" \nflex=\"100\" class=\"mt-8 mb-16\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"vm.expensesearch\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div><md-table-container><table md-table \nmd-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"expense_query.order\"><tr md-row><th md-column width=\"12%\">Vendor name</th><th md-column width=\"12%\" \nmd-column md-order-by=\"total\">price</th><th md-column width=\"12%\">%</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"vendor in expense_data | orderBy : expense_query.order : true | filter : vm.expensesearch | limitTo: expense_query.limit: (expense_query.page - 1) * expense_query.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{vendor.vendor_name}}</td><td md-cell>{{vendor.total}}\n</td><td md-cell>{{vendor.total_percent | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination\n md-limit=\"expense_query.limit \" md-limit-options=\"[10] \" md-page=\"expense_query.page \" \nmd-total=\"{{expense_query_count}}\" md-page-select></md-table-pagination></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg expense-category\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Expense Category List</div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-24\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/admindashboard/inventory/inventory.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"inventory_foodRaw_load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><div class=\"medium ph-16 filter-dropdown-lg\"><md-select class=\"md-accent\" \nng-init=\"inventory = \'LM\'\" ng-model=\"inventory\" \nng-change=\"inventoryChange(dayset,inventory,staff,$event);rawmaterialChange(inventory,staff,$event);salematerialChange(inventory,staff,$event);purchaseexpenseChange(inventory,staff,$event);SalesexpenseChange(inventory,staff,$event)\" \naria-label=\"Change range\"><md-option ng-repeat=\"inventory in inventory_schedules\" value=\"{{inventory.value}}\">\n{{inventory.name}}</md-option></md-select></div><div class=\"medium ph-8 filter-dropdown-md\"><md-select \nng-model=\"staff\" aria-label=\"today\" ng-init=\"staff=staffs\" \nng-change=\"inventoryChange(dayset,inventory,staff,$event);rawmaterialChange(inventory,staff,$event);salematerialChange(inventory,staff,$event);purchaseexpenseChange(inventory,staff,$event);SalesexpenseChange(inventory,staff,$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"staff in vm.inventory_staffs | unique:\'staffID\'\" \nvalue=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></div></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nflex=\"100\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\" translate>BILLINGS.SALES-ITEMS</span></div>\n<div layout=\"row\" layout-align=\"end center\" flex class=\"mb-16\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.foodsearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div></div>\n<div layout=\"row\" class=\"week-container light-blue\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><ul class=\"weekdays\"><li ng-repeat=\"weekday in vm.weekdays\" \nng-class=\"{active : activeMenu === weekday}\" class=\"md-accent\"><a \nng-click=\"setActive(weekday,inventory);inventoryChange(weekday.name,inventory,staff,$event);\">{{weekday.name}}</a></li>\n</ul><div layout=\"row\" layout-align=\"end center\"><md-progress-circular class=\"md-accent ml-10 mt-10\" \nng-if=\"weekday_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div></div><div \nclass=\"medium select-small mb-8\" layout=\"row\" layout-align=\"end center\" flex-none><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"food_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\n<md-select ng-model=\"stu\" class=\"md-accent\" aria-label=\"today\" ng-init=\"stu = \'All\'\" ng-change=\"getFood_items(stu)\">\n<md-option ng-repeat=\"food in vm.fmCategory | unique:\'staffID\'\" value=\"{{food.fmCatergoryID}}\">{{food.fmCatergoryName}}\n</md-option></md-select></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected_food\"><thead md-head md-order=\"inventory_food.order\">\n<tr md-row><th md-column width=\"60%\"><span>{{\'BILLINGS.ITEMS\' | translate}}</span></th><th md-column width=\"20%\" \nmd-order-by=\"count\"><span>COUNT</span></th><th width=\"20%\" md-column md-order-by=\"total\"><span>\nAvg.{{\'FOOD.SALES\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nng-repeat=\"food in food_beverage  | orderBy: inventory_food.order : true | filter : vm.foodsearch | limitTo: inventory_food.limit: (inventory_food.page - 1) * inventory_food.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{food.sales_items}}</td><td md-cell>{{food.count}}</td>\n<td md-cell><span translate>BILLINGS.INR</span> {{food.total | number:2}}</td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"inventory_food.limit\" md-limit-options=\"[10]\" \nmd-page=\"inventory_food.page\" md-total=\"{{inventory_food_count}}\" md-page-select></md-table-pagination>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row \" flex=\"100 \" flex-gt-md=\"50 \"><ms-widget-front \nclass=\"white-bg\"><div class=\"light-blue\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" flex=\"100\" \nclass=\"analy-inner-tab\"><md-nav-bar class=\"flex\" md-selected-nav-item=\"currentNavItem\" \nnav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"goto(\'diet-in\')\" name=\"rawmaterial\" \nng-if=\"inventoryHide.length&&rawHide.length\"><div class=\"layout-row layout-align-center-center\">\nPurchase {{\'Inventory.RAW-MATERIAL\' | translate}}</div></md-nav-item><md-nav-item md-nav-click=\"goto(\'take-away\')\" \nname=\"salematerial\" ng-if=\"inventoryHide.length&&saleHide.length\"><div class=\"layout-row layout-align-center-center\">\nPurchase {{\'Inventory.SALE-MATERIAL\' | translate}}</div></md-nav-item></md-nav-bar></div></div><div layout=\"row\" \nclass=\"week-container light-blue\" layout-align=\"start center\" ng-show=\"currentNavItem == \'rawmaterial\'\"><div \nlayout=\"row\" layout-align=\"start center\" flex class=\"mb-16 mt-8\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.rawsearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div><div \nclass=\"medium select-small mb-8\" layout=\"row\" layout-align=\"end center\" flex-none><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"raw_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\n<md-select ng-model=\"stu\" aria-label=\"today\" class=\"md-accent\" ng-init=\"stu = \'All\'\" ng-change=\"getRaw_items(stu)\">\n<md-option ng-repeat=\"food in vm.rmCategory\" value=\"{{food.rmCatergoryID}}\">{{food.rmCatergoryName}}</md-option>\n</md-select></div></div><div layout=\"row\" class=\"week-container light-blue\" layout-align=\"start center\" \nng-show=\"currentNavItem == \'salematerial\'\"><div layout=\"row\" layout-align=\"start center\" flex class=\"mb-16 mt-8\"><div \nclass=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input md-accent\" ng-model=\"vm.salesearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" \nflex></div></div><div class=\"medium select-small mb-8\" layout=\"row\" layout-align=\"end center\" flex-none>\n<md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"sale_load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><md-select ng-model=\"stu\" aria-label=\"today\" class=\"md-accent\" ng-init=\"stu = \'All\'\" \nng-change=\"getSale_items(stu)\"><md-option ng-repeat=\"food in vm.smCategory\" value=\"{{food.smCatergoryID}}\">\n{{food.smCatergoryName}}</md-option></md-select></div></div><div ng-show=\"currentNavItem == \'rawmaterial\'\">\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"rawmaterial_query.order\"><tr md-row><th md-column width=\"50%\">\n{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"30%\">Ordered Qty</th><th width=\"20%\" md-column \nmd-order-by=\"total\">{{\'BILLINGS.PRICE\' | translate}}</th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"rawmaterial in raw_data | orderBy : rawmaterial_query.order  : true | filter : vm.rawsearch | limitTo: rawmaterial_query.limit: (rawmaterial_query.page - 1) * rawmaterial_query.limit\">\n<td md-cell class=\"border-status\">{{rawmaterial.rmname}}</td><td md-cell>{{rawmaterial.Qty}}</td><td md-cell>\n{{rawmaterial.total}}</td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"rawmaterial_query.limit \" md-limit-options=\"[10] \" md-page=\"rawmaterial_query.page\" \nmd-total=\"{{rawmaterial_count}} \" md-page-select></md-table-pagination></div><div \nng-show=\"currentNavItem == \'salematerial\'\"><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head md-order=\"salematerial_query.order\">\n<tr md-row><th md-column width=\"60%\">{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"20%\">Ordered Qty</th><th\n width=\"20%\" md-column md-order-by=\"total\">{{\'BILLINGS.PRICE\' | translate}}</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"salematerial in sale_data | orderBy : salematerial_query.order  : true | filter : vm.salesearch | limitTo: salematerial_query.limit: (salematerial_query.page - 1) * salematerial_query.limit\">\n<td md-cell>{{salematerial.smname}}</td><td md-cell>{{salematerial.Qty}}</td><td md-cell>{{salematerial.total}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"salematerial_query.limit \" \nmd-limit-options=\"[10] \" md-page=\"salematerial_query.page\" md-total=\"{{salematerial_count}} \" md-page-select>\n</md-table-pagination></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap ng-if=\"inventoryHide.length&&rawHide.length\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nPurchase {{\'Inventory.RAW-MATERIAL\' | translate}} {{\'BILLINGS.PAYMENT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{purchasetotal_paid+purchasetotal_balance | thousandSuffix : fractionSize}}</span></div><div \nclass=\"label md-truncate\">{{\'EXPENSE.TOTAL-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div><div\n class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{purchasetotal_paid | thousandSuffix : fractionSize}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.PAID-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)</div>\n</div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{purchasetotal_balance | thousandSuffix : fractionSize}}\n</span></div><div class=\"label md-truncate\">{{\'EXPENSE.BALANCE-EXPENSE\' | translate}} (<span translate>BILLINGS.INR\n</span>)</div></div></div><div class=\"layout-row layout-align-start-start tax-text-container\"><div flex \nclass=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">\nTax Cgst- &nbsp; ₹ {{purchasetaxCgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTotal Sgst- &nbsp; ₹ {{purchasetaxSgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTotal Tax- &nbsp; ₹ {{purchasetax | thousandSuffix : fractionSize}}</span></div></div><ms-widget-front \nclass=\"pie-chart\"><nvd3 config=\"vm.widget34.mainChart.config\" options=\"vm.widget34.mainChart.options\" \ndata=\"vm.widget34.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\">\n<span class=\"h3\">{{\'Inventory.RAW-MATERIAL\' | translate}} {{\'EXPENSE.VENDORS\' | translate}}</span></div></div><div \nlayout=\"row\" layout-align=\"end center\" flex=\"100\" class=\"mt-8 mb-16\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.expensesearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"purchaseexpense_query.order\"><tr md-row><th md-column width=\"12%\">\n{{\'EXPENSE.vendor\' | translate}} name</th><th md-column width=\"12%\" md-column md-order-by=\"total\">\n{{\'BILLINGS.PRICE\' | translate}}</th><th md-column width=\"12%\">{{\'EXPENSE.PERCENTAGE\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"vendor in purchaseexpense_data | orderBy : purchaseexpense_query.order : true | filter : vm.expensesearch | limitTo: purchaseexpense_query.limit: (purchaseexpense_query.page - 1) * purchaseexpense_query.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{vendor.vendor_name}}</td><td md-cell>{{vendor.total}}\n</td><td md-cell>{{vendor.total_percent | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination\n md-limit=\"purchaseexpense_query.limit \" md-limit-options=\"[10] \" md-page=\"purchaseexpense_query.page \" \nmd-total=\"{{purchaseexpense_query_count}}\" md-page-select></md-table-pagination></ms-widget-front></ms-widget></div>\n<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"inventoryHide.length&&saleHide.length\"><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">\nPurchase {{\'Inventory.SALE-MATERIAL\' | translate}} {{\'BILLINGS.PAYMENT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{saletotal_paid+saletotal_balance | thousandSuffix : fractionSize}}</span></div><div class=\"label md-truncate\">\n{{\'EXPENSE.TOTAL-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{saletotal_paid | thousandSuffix : fractionSize}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.PAID-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)</div>\n</div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{saletotal_balance | thousandSuffix : fractionSize}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.BALANCE-EXPENSE\' | translate}} (<span translate>BILLINGS.INR</span>)\n</div></div></div><div class=\"layout-row layout-align-start-start tax-text-container\"><div flex \nclass=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">\nTax Cgst- &nbsp; ₹ {{salestaxCgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTotal Sgst- &nbsp; ₹ {{salestaxSgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nTotal Tax- &nbsp; ₹ {{salestax | thousandSuffix : fractionSize}}</span></div></div><ms-widget-front class=\"pie-chart\">\n<nvd3 config=\"vm.widget78.mainChart.config\" options=\"vm.widget78.mainChart.options\" data=\"vm.widget78.mainChart.data\">\n</nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{\'Inventory.SALE-MATERIAL\' | translate}} {{\'EXPENSE.VENDORS\' | translate}}</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" flex=\"100\" class=\"mt-8 mb-16\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.expensesearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"saleexpense_query.order\"><tr md-row><th md-column width=\"12%\">\n{{\'EXPENSE.vendor\' | translate}} name</th><th md-column width=\"12%\" md-column md-order-by=\"total\">\n{{\'BILLINGS.PRICE\' | translate}}</th><th md-column width=\"12%\">{{\'EXPENSE.PERCENTAGE\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"vendor in saleexpense_data | orderBy : saleexpense_query.order : true | filter : vm.expensesearch | limitTo: expense_query.limit: (saleexpense_query.page - 1) * saleexpense_query.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{vendor.vendor_name}}</td><td md-cell>{{vendor.total}}\n</td><td md-cell>{{vendor.total_percent | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination\n md-limit=\"saleexpense_query.limit \" md-limit-options=\"[10] \" md-page=\"saleexpense_query.page \" \nmd-total=\"{{saleexpense_query_count}}\" md-page-select></md-table-pagination></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/admindashboard/odc/odc.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><div \nclass=\"medium ph-16 filter-dropdown-lg\"><md-select class=\"md-accent\" ng-init=\"odc = \'LM\'\" ng-model=\"odc\" \naria-label=\"today\" ng-change=\"changeOdc(odc,staff,odcs,$event)\" aria-label=\"Change range\"><md-option \nng-repeat=\"inventory in inventory_schedules\" value=\"{{inventory.value}}\">{{inventory.name}}</md-option></md-select>\n</div><div class=\"medium ph-8 filter-dropdown-md\"><md-select ng-model=\"staff\" ng-init=\"staff=staffs\" \naria-label=\"today\" ng-change=\"changeOdc(odc,staff,odcs,$event)\" class=\"md-accent\" flex=\"100\"><md-option \nng-repeat=\"staff in vm.odc_staffs\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></div></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{ \'ODC.ODC-BANQUET\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\">\n{{odc_payment.upcoming_events+odc_payment.finished_Events | thousandSuffix : fractionSize}}</div><div \nclass=\"label md-truncate\">{{ \'ODC.EVENTS\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{odc_payment.upcoming_events | thousandSuffix : fractionSize}}</span></div><div class=\"label md-truncate\">\n{{\'ODC.UPCOMING-EVENTS\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{odc_payment.finished_Events | thousandSuffix : fractionSize}}</span></div><div class=\"label md-truncate\">\n{{ \'ODC.FINISHED-EVENTS\' | translate}}</div></div></div><ms-widget-front class=\"pie-chart\"><nvd3 \nconfig=\"vm.widget66.mainChart.config\" options=\"vm.widget66.mainChart.options\" data=\"vm.widget66.mainChart.data\"></nvd3>\n</ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"30\">\n<ms-widget-front class=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{ \'BILLINGS.PAYMENT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start flex ph-24 pv-8\" ng-if=\"cashier_analytics_permission==true\"><div \nclass=\"layout-column mt-32 w-100p\"><div class=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{odc_payment.paid_totals | thousandSuffix : fractionSize}}\n</span></div><div class=\"label md-truncate\">Total {{ \'BILLINGS.AMOUNT\' | translate}} (<span translate>BILLINGS.INR\n</span>)</div></div><div class=\"layout-row layout-align-start-start tax-text-container\"><div flex \nclass=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">\nTotal Tax- &nbsp; ₹ {{Odctax_sgst+Odctax_cgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nCGST- &nbsp; ₹ {{Odctax_cgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nSGST- &nbsp; ₹ {{Odctax_sgst | thousandSuffix : fractionSize}}</span></div></div></div><div \nclass=\"layout-column mt-32 w-100p\"><div class=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{odc_payment.received_totals | thousandSuffix : fractionSize}}</span></div><div class=\"label md-truncate\">\n{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div></div><div \nclass=\"layout-column mt-32 w-100p\"><div class=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{odc_payment.paid_totals-odc_payment.received_totals | thousandSuffix : fractionSize}}</span></div><div \nclass=\"label md-truncate\">Balance {{ \'BILLINGS.AMOUNT\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div>\n</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nstyle=\"display: none\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nBanquet List</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\">\n<md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/admindashboard/overview/overview.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><div \nclass=\"medium ph-16 filter-dropdown-lg\"><md-select ng-model=\"overview\" aria-label=\"today\" ng-init=\"overview=\'today\'\" \nng-change=\"changeDate({{overviewpos}},staff,overview,$event);expenseChange(staff,overview,{{overviewexpense}},$event);changeOdc(overview,staff,{{overviewodc}},$event); OverviewSalesexpenseChange(overview,staff,$event); overviewpurchaseexpenseChange(overview,staff,$event);\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"overview in vm.paymentmodelist\" value=\"{{overview.value}}\">\n{{overview.name}}</md-option></md-select></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" \nmd-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"80\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h3\">Payment</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-sm-row layout-align-gt-sm-space-around-center layout-align-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{(overview_posTotal + overviewodc_payment.paid_totals) | thousandSuffix : 5}}</span></div><div \nclass=\"label md-truncate\">Income Amount</div><div \nclass=\"layout-align-center-center layout-row flex mt-4 tax-text-container\"><span class=\"ml-16 label\">\nTax- &nbsp; ₹ {{(overviewtax_cgst+overvie_wodcTax_cgst)+(overviewtax_sgst+overviewodc_wodcTax_sgst) | thousandSuffix : 5}}\n</span></div></div><div class=\"cash-count-widget layout-column layout-align-center-center\" \nng-if=\"expense_analytics_permission==true\"><div class=\"title layout-row layout-align-center-center\"><span translate>\nBILLINGS.INR</span> <span>{{overview_expenseTotal | thousandSuffix : 5}}</span></div><div class=\"label md-truncate\" \nng-if=\"expense_analytics_permission==true\">Expense Amount</div><div \nclass=\"layout-align-center-center layout-row flex mt-4 tax-text-container\"><span class=\"ml-16 label\">\nTax- &nbsp; ₹ {{(overview_expensetax) | thousandSuffix : 5}}</span></div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{overviewsaletotal_paid+overviewsaletotal_balance | thousandSuffix : 5}}</span></div><div class=\"label md-truncate\">\nSale Material Expense (<span translate>BILLINGS.INR</span>)</div><div \nclass=\"layout-align-center-center layout-row flex mt-4 tax-text-container\"><span class=\"ml-16 label\">\nTax - &nbsp; ₹ {{overviewsalestax | thousandSuffix : 5}} &nbsp; &nbsp;</span></div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\" ng-if=\"inventoryHide.length&&rawHide.length\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{overviewpurchasetotal_paid+overviewpurchasetotal_balance | thousandSuffix : 5}}</span></div><div \nclass=\"label md-truncate\">Raw Material Expense (<span translate>BILLINGS.INR</span>)</div><div \nclass=\"layout-align-center-center layout-row flex mt-4 tax-text-container\"><span class=\"ml-16 label\">\nTax- &nbsp; ₹ {{overviewpurchasetax | thousandSuffix : 5}}</span></div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{(overview_posTotal+overviewodc_payment.paid_totals)-(overview_expenseTotal + ((overviewtax_cgst+overvie_wodcTax_cgst)+(overviewtax_sgst+overviewodc_wodcTax_sgst))) - (overviewpurchasetotal_paid+overviewpurchasetotal_balance) - (overviewsaletotal_paid+overviewsaletotal_balance) | thousandSuffix : 5}}\n</span></div><div class=\"label md-truncate\">Profit Amount (<span translate>BILLINGS.INR</span>)</div></div></div>\n<ms-widget-front class=\"pie-chart\"><nvd3 config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"20\"><ms-widget-front class=\"white-bg layout-column\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">POS Orders</span></div><div layout=\"row\" layout-align=\"start center\">\n</div></div><div class=\"layout-column layout-align-start-start flex mt-24 ph-16 pv-8\"><div \nclass=\"layout-column layout-align-start-start flex w-100p\"><div class=\"title layout-row layout-align-center-center\">\n<span class=\"font-size-px-36\">{{overview_posPaid_count}}</span></div><div class=\"label md-truncate\">Total Ordered</div>\n</div><div class=\"layout-column layout-align-start-start flex w-100p mb-16\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"font-size-px-36\">{{overview_posOrder_count}}</span>\n</div><div class=\"label md-truncate\">Current Ordered</div><div \nclass=\"font-weight-500 secondary-text text-align-right w-100p\">{{overview_paidTotal_percent | number:2}}%</div>\n<md-progress-linear class=\"md-accent flex mt-16\" md-mode=\"determinate\" value=\"{{overview_paidTotal_percent}}\">\n</md-progress-linear></div><div class=\"layout-column layout-align-start-start flex w-100p mb-16\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"font-size-px-36\">\n{{overview_posPaid_count-overview_posOrder_count}}</span></div><div class=\"label md-truncate\">Paid Ordered</div><div \nclass=\"font-weight-500 secondary-text text-align-right w-100p\">{{overview_posTotal_percent | number:2}}%</div>\n<md-progress-linear class=\"md-accent flex mt-16\" md-mode=\"determinate\" value=\"{{overview_posTotal_percent}}\">\n</md-progress-linear></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/admindashboard/pos-billing/pos-billing.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><div layout=\"row\" flex><div \nclass=\"dropdown\"><span class=\"dropbtn\"><span hide=\"\" show-gt-sm=\"\">Print Today</span> Report <i \nclass=\"icon s16 icon-menu-down\"></i></span><div class=\"dropdown-content\"><a ng-click=\"printToCart(\'printSectionId\')\">\nAmount Report</a> <a ng-click=\"printToCart(\'OrderedDetails\')\">Sales Items Report</a></div></div></div>\n<md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><div class=\"ml-8\"><div class=\"medium ph-8 filter-dropdown-md\" layout=\"row\" \nstyle=\"align-items: center; justify-content: center\"><span flex=\"50\" hide=\"\" show-gt-sm=\"\"><a>Filter type :</a></span>\n<md-select ng-model=\"dropdownfilter\" ng-init=\"dropdownfilter=\'Default\'\" aria-label=\"today\" class=\"md-accent\" \nflex=\"100\" ng-disabled=\"todayDrop\"><md-option ng-repeat=\"dropdownfilter in vm.dropdownfilter\" \nvalue=\"{{dropdownfilter}}\">{{dropdownfilter}}</md-option></md-select></div></div><div \nclass=\"small no-error ph-16 small-date-icon filter-dropdown-lg\"><div class=\"layout-column\"><md-select ng-model=\"mode\" \nng-show=\"dropdownfilter == \'Default\'\" ng-init=\"mode = \'today\'\" \nng-change=\"changeDate(dropdownfilter, staff,mode,{{pos}},$event);\" class=\"md-accent\" flex=\"100\" aria-label=\"today\" \nng-disabled=\"todayDrop\"><md-option ng-repeat=\"mode in vm.paymentmodelist\" value=\"{{mode.value}}\">{{mode.name}}\n</md-option></md-select><div class=\"hide-date-picker-icon\" ng-show=\"dropdownfilter == \'Date\'\"><md-input-container \nclass=\"md-block md-accent\"><md-datepicker ng-model=\"myDates\" ng-init=\"myDates = myDate\" md-placeholder=\"Enter date\" \nmd-min-date=\"minDate\" md-max-date=\"maxDate\" \nng-change=\"changeDate(dropdownfilter, staff,myDates,$event);newdate(myDates);feedbackChange(staff,myDates,$event)\" \nng-disabled=\"todayDrop\"></md-datepicker></md-input-container></div><div class=\"hide-date-picker-icon\" \nng-show=\"dropdownfilter == \'Month\'\"><md-input-container class=\"md-block md-accent\"><md-datepicker ng-model=\"myMonth\" \nng-init=\"myMonth = myDate\" aria-label=\"today\" md-max-date=\"maxDate\" \nng-change=\"changeDate(dropdownfilter,staff,myMonth,\'month\',$event);\" md-date-locale=\"dateFields[2].locale\" \nmd-mode=\"{{dateFields[2].mode}}\" md-open-on-focus=\"true\" ng-disabled=\"todayDrop\"></md-datepicker></md-input-container>\n</div><div class=\"hide-date-picker-icon\" ng-show=\"dropdownfilter == \'Period\'\"><div layout=\"row\"><span flex=\"70\"><a>\nFrom :</a></span><md-input-container class=\"md-block md-accent\"><md-datepicker ng-model=\"myDates\" \nng-init=\"myDates = myDate\" md-placeholder=\"Enter date\" md-max-date=\"maxDate\" ng-disabled=\"todayDrop\"></md-datepicker>\n</md-input-container></div><div layout=\"row\"><span flex=\"70\"><a>To :</a></span><md-input-container \nclass=\"md-block md-accent\"><md-datepicker ng-model=\"toDates\" md-placeholder=\"Enter date\" md-min-date=\"myDates\" \nmd-max-date=\"maxDate\" \nng-change=\"changeDate(dropdownfilter,staff,myDates,toDates,$event);newdate(myDates);feedbackChange(staff,myDates,$event)\" \nng-disabled=\"todayDrop\"></md-datepicker></md-input-container></div></div></div></div><div \nclass=\"medium ph-8 filter-dropdown-md\" hide=\"\" show-gt-sm=\"\"><md-select ng-model=\"staff\" ng-init=\"staff=staffs\" \naria-label=\"today\" ng-change=\"changeDate(dropdownfilter,staff,OpenPermission ? newdate_data : mode,$event)\" \nclass=\"md-accent\" flex=\"100\" ng-disabled=\"todayDrop\"><md-option ng-repeat=\"staff in vm.staffRole\" \nvalue=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></div></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"70\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{ \'BILLINGS.AMOUNT\' | translate}}</span></div><div \nlayout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-xs-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{dinein_amount+takeaway_amount+doordelivery_amount | thousandSuffix : 5}}</span></div><div class=\"label md-truncate\">\n{{ \'BILLINGS.Total Amount\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\">\n{{total_cash+total_card+orderedtotal_cash+orderedtotal_card | thousandSuffix : 5}}</div><div class=\"label md-truncate\">\n{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}} (<span translate>BILLINGS.INR</span>)</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{(dinein_amount+takeaway_amount+doordelivery_amount)-(total_cash+total_card+orderedtotal_cash+orderedtotal_card) | thousandSuffix : 5}}\n</span></div><div class=\"label md-truncate\">Balance {{ \'BILLINGS.AMOUNT\' | translate}} (<span translate>BILLINGS.INR\n</span>)</div></div></div><div class=\"layout-row layout-xs-column layout-align-start-start tax-text-container\"><div \nflex class=\"layout-align-center-center layout-row mb-8 layout-align-xs-center-center\">Total Profit &nbsp; <span \ntranslate>BILLINGS.INR</span> {{total_profit_amount}} <span ng-show=\"(total_profit_amount * 1) != 0\" class=\"ml-5\">\n({{ (total_profit_amount / (dinein_amount + takeaway_amount + doordelivery_amount) * 100) .toFixed(2) }}%)</span></div>\n<div flex></div><div flex></div></div><div class=\"layout-row layout-align-start-start tax-text-container\"><div flex \nclass=\"layout-align-center-center layout-row\" \nng-if=\"vm.settings.dinein_permission && vm.settings.takeaway_permission && vm.settings.doordelivery_permission\"><span \nclass=\"ml-16 label\" ng-if=\"vm.settings.dinein_permission\"><span translate>BILLINGS.DIET-IN</span> &nbsp; <span \ntranslate>BILLINGS.INR</span> {{dinein_amount | thousandSuffix : 5}}</span> <span class=\"ml-16 label\" \nng-if=\"vm.settings.takeaway_permission\"><span translate>BILLINGS.TAKE-AWAY</span> &nbsp; <span translate>BILLINGS.INR\n</span> {{takeaway_amount | thousandSuffix : 5}}</span> <span class=\"ml-16 label\" \nng-if=\"vm.settings.doordelivery_permission\"><span translate>BILLINGS.DOOR-DELIVERY</span> &nbsp; <span translate>\nBILLINGS.INR</span> {{doordelivery_amount | thousandSuffix : 5}}</span></div><div flex \nclass=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">Total Tax- &nbsp; <span translate>BILLINGS.INR\n</span> {{tax_sgst+tax_cgst | thousandSuffix : 5}}</span> <span class=\"ml-16 label\">CGST- &nbsp; <span translate>\nBILLINGS.INR</span> {{tax_cgst | thousandSuffix : 5}}</span> <span class=\"ml-16 label\">SGST- &nbsp; <span translate>\nBILLINGS.INR</span> {{tax_sgst | thousandSuffix : 5}}</span></div></div><ms-widget-front class=\"pie-chart\"><nvd3 \nconfig=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3>\n<div class=\"layout-row layout-align-start-start tax-text-container mt-8 mb-24\"><div flex \nclass=\"layout-align-center-center layout-row layout-xs-column layout-align-xs-center-center layout-align-sm-center-center\">\n<span class=\"ml-16 label\" ng-repeat=\"onlinetype in onlinePaymentTypeAmount\">\n{{ getOnlineTypeNames(onlinetype) }} &nbsp; ₹ {{onlinetype.names | thousandSuffix : 5}}</span></div></div>\n</ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"30\">\n<ms-widget-front class=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{ \'BILLINGS.TODAY-HOT-SALES\' | translate}}</span><div ng-if=\"vm.download.soldItemsData\"><a export-to-sold-csv \nclass=\"download-csv ml-5\"><md-tooltip md-direction=\"top\">Export data to CSV</md-tooltip></a><table \nstyle=\"display: none\"><tr><th>Items</th><th>Sold Count</th></tr><tr \nng-repeat=\"posbill in posbill_data  | orderBy: posbill_query.order : true\"><td>{{posbill.sales_items}}</td><td>\n{{posbill.count}}</td></tr></table></div></div></div><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"posbill_query.order\"><tr md-row><th md-column width=\"50%\"><span>{{ \'BILLINGS.ITEMS\' | translate}}</span></th>\n<th md-column width=\"20%\" md-numeric md-order-by=\"count\"><span>{{ \'BILLINGS.SALES-COUNT\' | translate}}</span></th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" \nng-repeat=\"posbill in posbill_data  | orderBy: posbill_query.order : true | filter : vm.foodsearch | limitTo: posbill_query.limit: (posbill_query.page - 1) * posbill_query.limit\">\n<td md-cell ng-class=\"paidbill.status \" class=\"border-status\">{{posbill.sales_items}}</td><td md-cell>{{posbill.count}}\n</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"posbill_query.limit \" \nmd-limit-options=\"[10]\" md-page=\"posbill_query.page \" md-limit=\"posbill_query.order\" md-total=\"{{posbill_count}}\" \nmd-page-select></md-table-pagination></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"20\"><ms-widget-front \nclass=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{ \'BILLINGS.POS-BILL\' | translate}}</span></div><div \nlayout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"layout-column layout-align-start-start flex ph-24 pv-8\" ng-if=\"cashier_analytics_permission==true\"><div \nclass=\"layout-column mt-8 w-100p medium-analytics\"><div \nclass=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span><span>{{dinein_total+takeaway_total+doordelivery_total}}\n</span></span></div><div class=\"label md-truncate\">Total {{ \'BILLINGS.POS-BILL\' | translate}}</div></div></div><div \nclass=\"layout-column mt-8 w-100p\" ng-if=\"vm.settings.dinein_permission\"><div \nclass=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span><span>{{dinein_total}}</span></span></div><div \nclass=\"label md-truncate\" translate>BILLINGS.DIET-IN</div></div></div><div class=\"layout-column mt-8 w-100p\" \nng-if=\"vm.settings.takeaway_permission\"><div class=\"cash-count-widget layout-column layout-align-center-center flex\">\n<div class=\"title layout-row layout-align-center-center\"><span><span>{{takeaway_total}}</span></span></div><div \nclass=\"label md-truncate\" translate>BILLINGS.TAKE-AWAY</div></div></div><div class=\"layout-column mt-8 w-100p\" \nng-if=\"vm.settings.doordelivery_permission\"><div \nclass=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span><span>{{doordelivery_total}}</span></span></div><div \nclass=\"label md-truncate\" translate>BILLINGS.DOOR-DELIVERY</div></div></div></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"80\" hide=\"\" show-gt-sm=\"\"><ms-widget-front \nclass=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">Feedback</span></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div style=\"width: 100%\"><table class=\"feedback-table\"><tr><th width=\"8%\"></th>\n<th width=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/analytics-speed.svg\" \nalt=\"\" class=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.SPEED-OF-SERVICE</span></p>\n<div layout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_Service_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_Service_review ? (feedback_Service_review/5*100) : 0}}%\"></span></span></div></div></div></th>\n<th width=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/courtesy-staff.svg\" alt=\"\" \nclass=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.COURTEST-OF-STAFF</span></p><div \nlayout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_staff_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_staff_review ? (feedback_staff_review/5*100) : 0}}%\"></span></span></div></div></div></th><th \nwidth=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/quality-food.svg\" alt=\"\" \nclass=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.QUALITY-OF-FOOD</span></p><div \nlayout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_food_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_food_review ? (feedback_food_review/5*100) : 0}}%\"></span></span></div></div></div></th><th \nwidth=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/value-money.svg\" alt=\"\" \nclass=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.VALUE-FOR-MONEY</span></p><div \nlayout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_money_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_money_review ? (feedback_money_review/5*100) : 0}}%\"></span></span></div></div></div></th></tr>\n<tr class=\"fivestar\"><td class=\"fivestar-text\">{{feedbackjson.GREAT}}</td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_service_GREAT}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_service_GREAT | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_service_GREAT > 0\">{{feedback.Feedback_service[0].GREAT }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_GREAT}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_GREAT | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_GREAT > 0\">\n{{feedback.Feedback_staff[0].GREAT }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_GREAT}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_GREAT | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_GREAT > 0\">\n{{feedback.Feedback_food[0].GREAT }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_GREAT}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_money_GREAT | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_money_GREAT > 0\">\n{{feedback.Feedback_money[0].GREAT }}</span></div></td></tr><tr class=\"fourstar\"><td class=\"fourstar-text\">\n{{feedbackjson.GOOD}}</td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_service_GOOD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_service_GOOD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_service_GOOD > 0\">{{feedback.Feedback_service[0].GOOD }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_GOOD}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_GOOD | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_GOOD > 0\">\n{{feedback.Feedback_staff[0].GOOD }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_GOOD}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_GOOD | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_GOOD > 0\">{{feedback.Feedback_food[0].GOOD }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_GOOD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_money_GOOD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_money_GOOD > 0\">{{feedback.Feedback_money[0].GOOD }}</span></div></td></tr><tr class=\"thirdstar\"><td \nclass=\"thirdstar-text\">{{feedbackjson.OK}}</td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div \nclass=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_service_OK}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_service_OK | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_service_OK > 0\">\n{{feedback.Feedback_service[0].OK }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_staff_OK}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_staff_OK | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_OK > 0\">{{feedback.Feedback_staff[0].OK }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_OK}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_food_OK | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_food_OK > 0\">{{feedback.Feedback_food[0].OK }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_money_OK}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_money_OK | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_money_OK > 0\">\n{{feedback.Feedback_money[0].OK }}</span></div></td></tr><tr class=\"secondstar\"><td class=\"secondstar-text\">\n{{feedbackjson.BAD}}</td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_service_BAD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_service_BAD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_service_BAD > 0\">{{feedback.Feedback_service[0].BAD }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_BAD}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_BAD | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_BAD > 0\">\n{{feedback.Feedback_staff[0].BAD }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_BAD}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_BAD | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_BAD > 0\">{{feedback.Feedback_food[0].BAD }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_BAD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_money_BAD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_money_BAD > 0\">{{feedback.Feedback_money[0].BAD }}</span></div></td></tr><tr class=\"onestar\"><td \nclass=\"onestar-text\">{{feedbackjson.POORLY}}</td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div \nclass=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_service_POOR}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_service_POOR | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_service_POOR > 0\">\n{{feedback.Feedback_service[0].POOR }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_POOR}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_POOR | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_POOR > 0\">\n{{feedback.Feedback_staff[0].POOR }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_POOR}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_POOR | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_POOR > 0\">{{feedback.Feedback_food[0].POOR }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_POOR}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_money_POOR | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_money_POOR > 0\">{{feedback.Feedback_money[0].POOR }}</span></div></td></tr></table></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"35\" \nng-if=\"vm.settings.thirdparty_permission\"><ms-widget-front class=\"white-bg layout-column\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">{{ \'BILLINGS.THIRD-PARTY\' | translate}}</span></div></div>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"thirdparty_query.order\"><tr md-row><th md-column width=\"40%\"><span>\nName</span></th><th md-column width=\"30%\" md-numeric md-order-by=\"count\"><span>Total Order</span></th><th md-column \nwidth=\"30%\" md-numeric md-order-by=\"total\"><span>{{ \'BILLINGS.Total Amount\' | translate}}</span></th></tr></thead>\n<tbody md-body><tr md-row md-select=\"dessert\" \nng-repeat=\"thirdpartys in thirdparty  | orderBy: thirdparty_query.order : true | filter : vm.foodsearch | limitTo: thirdparty_query.limit: (thirdparty_query.page - 1) * thirdparty_query.limit\">\n<td md-cell ng-class=\"paidbill.status \" class=\"border-status\">{{thirdpartys.thirdparty_name}}</td><td md-cell>\n{{thirdpartys.count}}</td><td md-cell>{{thirdpartys.total}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"thirdparty_query.limit \" md-limit-options=\"[10]\" md-page=\"thirdparty_query.page \" \nmd-limit=\"thirdparty_query.order\" md-total=\"{{thirdparty_length}}\" md-page-select></md-table-pagination>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front \nclass=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"h3\"><span translate>BILLINGS.ORDER-TAKEN</span>\n Staff Performance</span></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head md-order=\"takenorder_query.order\"><tr\n md-row><th md-column width=\"30%\"><span>Staff Name</span></th><th md-column width=\"30%\" md-numeric \nmd-order-by=\"orderTakenCount\"><span>Total Order</span></th><th md-column width=\"40%\" md-numeric md-order-by=\"total\">\n<span>Total Amount</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nng-repeat=\"posbill in ordertaken_details  | orderBy: takenorder_query.order : true | filter : vm.foodsearch | limitTo: takenorder_query.limit: (takenorder_query.page - 1) * takenorder_query.limit\">\n<td md-cell>{{posbill.orderTakenBy}}</td><td md-cell>{{posbill.orderTakenCount}}</td><td md-cell>{{posbill.total}}</td>\n</tr></tbody></table><div class=\"layout-column layout-align-center-center no-data padding-32\" \nng-if=\"ordertaken_details.length==0\"><h3>There\'re no order taken data for you to see.</h3></div><md-table-pagination \nmd-limit=\"takenorder_query.limit \" md-limit-options=\"[10]\" md-page=\"takenorder_query.page \" \nmd-limit=\"takenorder_query.order\" md-total=\"{{ordertaken_length}}\" md-page-select></md-table-pagination>\n</md-table-container></ms-widget-front></ms-widget></div><div id=\"printSectionId\" style=\"display: none\"><div \nid=\"printID\"><h4>{{ReportTime | date:\'medium\'}}</h4><table class=\"item-table\"><tbody><tr><td>Cash</td><td \nclass=\"right\">₹ {{total_cashh}}</td></tr><tr><td>Online</td><td class=\"right\">₹ {{total_cardd}}</td></tr><tr \nng-if=\"purchasetotal_balancee\"><td>Balance</td><td class=\"right\">₹ {{purchasetotal_balancee}}</td></tr><tr \nclass=\"total-saving\"><td>Total Amount</td><td class=\"right\">₹ {{total_cashh + total_cardd}}</td></tr><tr \nng-if=\"vm.settings.dinein_permission\"><td>Dine in</td><td class=\"right\">{{dinein_totall}}</td></tr><tr \nng-if=\"takeaway_totall\"><td>Take Away</td><td class=\"right\">{{takeaway_totall}}</td></tr><tr \nng-if=\"doordelivery_totall\"><td>Door Delivery</td><td class=\"right\">{{doordelivery_totall}}</td></tr><tr \nclass=\"total-saving\"><td>Total Ordered</td><td class=\"right\">{{dinein_totall+takeaway_totall+ doordelivery_totall}}\n</td></tr><tr ng-if=\"onlinePaymentTypeAmount[0].count && domaincatergory === \'canteen\'\"><td>\n{{vm.onlineTypes[0].names}} Ordered</td><td class=\"right\">{{onlinePaymentTypeAmount[0].count}}</td></tr><tr \nng-if=\"onlinePaymentTypeAmount[1].count && domaincatergory === \'canteen\'\"><td>{{vm.onlineTypes[1].names}} Ordered</td>\n<td class=\"right\">{{onlinePaymentTypeAmount[1].count}}</td></tr><tr \nng-if=\"onlinePaymentTypeAmount[2].count && domaincatergory === \'canteen\'\"><td>{{vm.onlineTypes[2].names}} Ordered</td>\n<td class=\"right\">{{onlinePaymentTypeAmount[2].count}}</td></tr><tr \nng-if=\"onlinePaymentTypeAmount[3].count && domaincatergory === \'canteen\'\"><td>{{vm.onlineTypes[3].names}} Ordered</td>\n<td class=\"right\">{{onlinePaymentTypeAmount[3].count}}</td></tr><tr \nng-if=\"onlinePaymentTypeAmount[4].count && domaincatergory === \'canteen\'\"><td>{{vm.onlineTypes[4].names}} Ordered</td>\n<td class=\"right\">{{onlinePaymentTypeAmount[4].count}}</td></tr><tr class=\"total-saving\"><td>Total Expense</td><td \nclass=\"right\">{{total_paidd}}</td></tr></tbody></table><style type=\"text/css\">\n/*   @page {\r\n      size: auto;\r\n      margin: 0mm;\r\n    } */\r\n\r\n      #printID .item-table {\r\n        width: 100%;\r\n        color: #000;\r\n        border-spacing: 0;\r\n        margin: 0 auto;\r\n      }\r\n\r\n      #printID .text-right {\r\n        text-align: right;\r\n      }\r\n\r\n      #printID {\r\n        width: 94%;\r\n        color: #000;\r\n        letter-spacing: -0.8px;\r\n        font-family: \'Anonymous Pro\';\r\n        margin: 0 auto;\r\n        box-sizing: border-box;\r\n        word-spacing: -5px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID th {\r\n        border-top: 2px dashed #000;\r\n        border-bottom: 2px dashed #000;\r\n        padding: 4px 4px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      #printID td {\r\n        padding: 4px 5px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      h4 {\r\n        font-size: 15px !important;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID .total-saving td {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        font-size: 18px !important;\r\n        border-top: 1px dashed #000;\r\n        border-bottom: 1px dashed #000;\r\n      }\n</style></div></div><div id=\"OrderedDetails\" style=\"display: none\"><div id=\"printID\"><h4>{{ReportTime | date:\'medium\'}}\n</h4><table class=\"item-table\"><thead><th width=\"70%\">Item Name</th><th width=\"30%\">Sales Count</th></thead><tbody><tr \nng-repeat=\"puchaseData in items_Data\"><td width=\"70%\">{{puchaseData.sales_items}}</td><td class=\"right\" width=\"30%\">\n{{puchaseData.count}}</td></tr></tbody></table><style type=\"text/css\">\n/*  @page {\r\n      size: auto;\r\n      margin: 0mm;\r\n    }\r\n*/\r\n      #printID .item-table {\r\n        width: 100%;\r\n        color: #000;\r\n        border-spacing: 0;\r\n        margin: 0 auto;\r\n      }\r\n\r\n      #printID .text-right {\r\n        text-align: right;\r\n      }\r\n\r\n      #printID {\r\n        width: 94%;\r\n        color: #000;\r\n        letter-spacing: -0.8px;\r\n        font-family: \'Anonymous Pro\';\r\n        margin: 0 auto;\r\n        box-sizing: border-box;\r\n        word-spacing: -5px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID th {\r\n        border-top: 2px dashed #000;\r\n        border-bottom: 2px dashed #000;\r\n        padding: 4px 4px;\r\n        font-size: 14px;\r\n        text-align: left;\r\n      }\r\n\r\n      #printID td {\r\n        padding: 4px 5px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      h4 {\r\n        font-size: 15px !important;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID .total-saving td {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        font-size: 18px !important;\r\n        border-top: 1px dashed #000;\r\n        border-bottom: 1px dashed #000;\r\n      }\n</style></div></div>");
$templateCache.put("app/main/admin/admindashboard/sms-marketing/sms-marketing.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"inventory_foodSms_load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><div class=\"medium ph-16 filter-dropdown-lg\"><md-select class=\"md-accent\" ng-init=\"sms = \'LM\'\" \nng-model=\"sms\" ng-change=\"SmsChange(sms,staff,$event)\" aria-label=\"Change range\"><md-option \nng-repeat=\"sms in vm.sms_date\" value=\"{{sms.value}}\">{{sms.name}}</md-option></md-select></div><div \nclass=\"medium ph-8 filter-dropdown-md\"><md-select ng-model=\"staff\" aria-label=\"today\" ng-init=\"staff=staffs\" \nng-change=\"SmsChange(sms,staff,$event)\" class=\"md-accent\" flex=\"100\"><md-option \nng-repeat=\"staff in vm.sms_staffs | unique:\'staffID\'\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select>\n</div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"inventoryHide.length&&saleHide.length\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nCampaign {{\'BILLINGS.SMS-MARKETING\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{sms_data.totalcampaign}}</span></div><div \nclass=\"label md-truncate\">Total Campaign</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{sms_data.total}}</span></div><div \nclass=\"label md-truncate\">Sent</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{sms_data.DELIVERED}}</span></div><div \nclass=\"label md-truncate\">Delivered</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\">\n<div class=\"title layout-row layout-align-center-center\"><span>{{sms_data.PENDING}}</span></div><div \nclass=\"label md-truncate\">Pending</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\">\n<div class=\"title layout-row layout-align-center-center\"><span>{{sms_data.FAILED}}</span></div><div \nclass=\"label md-truncate\">Failed</div></div></div><div class=\"layout-row layout-align-start-start tax-text-container\">\n<div flex class=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">\nRemaining Total Sms- &nbsp; {{sms_count[0].promotionalCount+sms_count[0].transcationalCount}}</span> <span \nclass=\"ml-16 label\">Promotional Sms- &nbsp; {{sms_count[0].promotionalCount}}</span> <span class=\"ml-16 label\">\nTranscational Sms- &nbsp; {{sms_count[0].transcationalCount}}</span></div></div><ms-widget-front class=\"pie-chart\">\n<nvd3 config=\"vm.widget79.mainChart.config\" options=\"vm.widget79.mainChart.options\" data=\"vm.widget79.mainChart.data\">\n</nvd3></ms-widget-front></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/admindashboard/today-task/today-task.html","<div class=\"overview-header ph-16 layout-align-center-start\" layout=\"column\"><div layout=\"row\" class=\"w-100p\"><div \nclass=\"layout-align-start-start layout-column flex\"><h1>Today Task</h1><h3>{{todayDate | date}}</h3></div><div \nclass=\"layout-align-end-center mr-24 mt-24\" ng-if=\"vm.settings.download_daily_report\"><button \nng-click=\"pdf(document.getElementById(\'demo1\').innerHTML=Date());exportemail()\" \nclass=\"md-button md-default-theme md-ink-ripple\" type=\"button\">Download Today Report</button></div></div></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"50\" \nflex-gt-md=\"50\" ng-if=\"cashier_analytics_permission==true&&pos_today_delivery.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><h2><span translate>BILLINGS.POS-BILL</span></h2>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"doordelivery_query.order\"><tr md-row><th md-column>{{ \'BILLINGS.ORDERED-NO\' | translate}}</th>\n<th md-column>Type</th><th md-column>{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th></tr></thead><tbody md-body><tr \nmd-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"paidbill in pos_today_delivery | limitTo: doordelivery_query.limit: (doordelivery_query.page - 1) * doordelivery_query.limit | filter: doordelivery_query.filter | orderBy: doordelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.currentBills\"><td md-cell ng-class=\"paidbill.status\" class=\"border-status\">\n{{paidbill.salesorder_id}}</td><td md-cell>{{paidbill.sales_dietType}}</td><td md-cell><div class=\"layout-row\">\n{{ paidbill.sales_deliveryDate | date }}, {{ getdate(paidbill.sales_deliveryTime) | date : \'shortTime\'}}</div></td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"doordelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"doordelivery_query.page\" md-total=\"{{pos_today_delivery.length}}\" md-page-select>\n</md-table-pagination></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"50\" \nflex-gt-md=\"50\" ng-if=\"odc_analytics_permission==true&&odc_payment.today_events.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><h2><span translate>ODC.ODC-BANQUET</span></h2>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"odcdelivery_query.order\"><tr md-row><th md-column>{{ \'BILLINGS.ORDERED-NO\' | translate}}</th>\n<th md-column>{{ \'ODC.EVENTS\' | translate}}</th><th md-column>{{ \'ODC.EVENT-TIME\' | translate}}</th></tr></thead><tbody\n md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"paidbill in odc_payment.today_events | unique:\'salesorder_id\' | limitTo: odcdelivery_query.limit: (odcdelivery_query.page - 1) * odcdelivery_query.limit | filter: odcdelivery_query.filter | orderBy: odcdelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.currentOdc\"><td md-cell ng-class=\"paidbill.status\" class=\"border-status\">\n{{paidbill.salesorder_id}}</td><td md-cell>{{getOdcCategory(paidbill)}}</td><td md-cell><div class=\"layout-row\">\n{{ paidbill.odc_deliveryDate | date }}, {{ getdate(paidbill.sales_deliveryTime) | date : \'shortTime\'}}</div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"odcdelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"odcdelivery_query.page\" md-total=\"{{odc_payment.today_events.length}}\" \nmd-page-select></md-table-pagination></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" \nflex=\"50\" flex-gt-md=\"50\" ng-if=\"expense_analytics_permission==true&&expense_today_delivery.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><h2><span translate>EXPENSE.EXPENSE</span></h2>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"expensedelivery_query.order\"><tr md-row><th md-column>Today works</th><th md-column>Bill No\n</th><th md-column>{{ \'ODC.Category\' | translate}}</th><th md-column>{{ \'EXPENSE.DUE-DATE\' | translate}}</th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"paidbill in expense_today_delivery | limitTo: expensedelivery_query.limit: (expensedelivery_query.page - 1) * expensedelivery_query.limit | filter: expensedelivery_query.filter | orderBy: expensedelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.balanceExpense\"><td md-cell>{{\'EXPENSE.EXPENSE\' | translate}}</td><td md-cell \nng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.expense_bill_id}}</td><td md-cell>\n{{paidbill.category_name}}</td><td md-cell title=\"{{paidbill.created_on | date:\'medium\'}}\"><div class=\"layout-row\">\n{{ paidbill.created_on | date }}</div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"expensedelivery_query.limit\" md-limit-options=\"[5,10,15]\" md-page=\"expensedelivery_query.page\" \nmd-total=\"{{expense_today_delivery.length}}\" md-page-select></md-table-pagination></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"50\" flex-gt-md=\"50\" \nng-if=\"rawHide.length&&inventoryRaw_today_delivery.length\"><ms-widget-front class=\"white-bg\"><div \nclass=\"layout-align-start-start ph-16\"><h2><span translate>EXPENSE.vendor</span></h2><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"rawdelivery_query.order\"><tr md-row><th md-column>Today works</th><th md-column>Bill No</th><th md-column>\n{{ \'EXPENSE.vendor\' | translate}}</th><th md-column>{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"paidbill in inventoryRaw_today_delivery | limitTo: rawdelivery_query.limit: (rawdelivery_query.page - 1) * rawdelivery_query.limit | filter: rawdelivery_query.filter | orderBy: rawdelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.rmPurchasedOrder\"><td md-cell>{{\'Inventory.RAW-MATERIAL\' | translate}}</td><td \nmd-cell ng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.purchase_order_id}}</td><td md-cell>\n{{paidbill.vendor_name}}</td><td md-cell><div class=\"layout-row\">{{ paidbill.DeliveryDate | date }}</div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"rawdelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"rawdelivery_query.page\" md-total=\"{{inventoryRaw_today_delivery.length}}\" \nmd-page-select></md-table-pagination></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" \nflex=\"50\" flex-gt-md=\"50\" ng-if=\"saleHide.length&&inventorySale_today_delivery.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"saledelivery_query.order\"><tr md-row><th md-column>Today works</th><th md-column>Bill No</th><th md-column>\n{{ \'EXPENSE.vendor\' | translate}}</th><th md-column>{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"paidbill in inventorySale_today_delivery | limitTo: saledelivery_query.limit: (saledelivery_query.page - 1) * saledelivery_query.limit | filter: saledelivery_query.filter | orderBy: saledelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.smSalesOrder\"><td md-cell>{{\'Inventory.SALE-MATERIAL\' | translate}}</td><td \nmd-cell ng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.inventory_salesOrder_id}}</td><td md-cell>\n{{paidbill.vendor_name}}</td><td md-cell><div class=\"layout-row\">{{ paidbill.DeliveryDate | date }}</div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"saledelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"saledelivery_query.page\" md-total=\"{{inventorySale_today_delivery.length}}\" \nmd-page-select></md-table-pagination></div></ms-widget-front></ms-widget></div><div \nclass=\"layout-align-start-start ph-24\" \nng-if=\"inventorySale_today_delivery.length==0&&inventoryRaw_today_delivery.length==0&&expense_today_delivery.length==0&&odc_payment.today_events.length==0&&pos_today_delivery.length==0\">\n<h3 class=\"text-left mt-40\">There\'re no today task for you to see.</h3></div>");
$templateCache.put("app/main/admin/food-settings/dialog/food-settings.addfood.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-530 h-600 layout-column\"><md-dialog-content \nclass=\"flex layout-column medium\"><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">{{ vm.title}} \n<span translate>RESTRAUNTANT.MENU-ITEMS</span></h2></div><form name=\"addfoodForm\" novalidate><div layout=\"row\" \nclass=\"mb-24 mt-8\" flex=\"100\" ng-if=\"vm.settings.veg_nonveg_permission\"><md-input-container class=\"md-input-has-value\">\n<label class=\"md-required mb-8\" translate>Select a type</label><md-radio-group layout=\"row\" \nng-model=\"vm.fmInfo.fmItemType\" required><md-radio-button ng-repeat=\"foodtype in vm.foodtypes\" \nvalue=\"{{foodtype.value}}\" class=\"md-accent\">{{foodtype.name}}</md-radio-button></md-radio-group></md-input-container>\n</div><div layout=\"row\" class=\"mt-16 mb-8\" flex=\"100\"><md-input-container class=\"md-block md-accent\" ng-hide=\"show\" \nflex=\"50\"><label>Select {{\'ODC.Category\' | translate}}</label><md-select ng-model=\"vm.fmInfo.fmCatergoryID\" \nclass=\"md-accent\" ng-required=\"vm.fmInfo.fmItemName\"><md-option ng-repeat=\"foodcategory in vm.foodcategorys\" \nvalue=\"{{foodcategory.fmCatergoryID}}\">{{foodcategory.fmCatergoryName}}</md-option></md-select></md-input-container>\n<div ng-show=\"show\" layout=\"row\" flex=\"100\"><md-input-container class=\"md-accent md-block\" flex=\"50\"><label>\nAdd New {{\'BILLINGS.ACTIONS\' | translate}}</label><input type=\"text\" name=\"catergoryname\" \nng-model=\"vm.fmInfo.fmCatergoryName\" value=\"1\"></md-input-container><md-button \nclass=\"md-primary md-mini md-radio-buttonaised md-icon-button\" aria-label=\"save\" \nng-click=\"addNewCategory(foodcategory); show = !show\" title=\"Save\"><md-icon md-menu-origin md-font-icon=\"icon-check\">\n</md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" ng-click=\"show = !show\" \ntitle=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\"></md-icon></md-button></div></div><div \nclass=\"sub-head mt-24 mb-8\">{{\'FOOD.SALES\' | translate}} Information</div><div layout=\"row\" class=\"mt-24\"><div \nflex=\"100\" layout=\"row\"><md-input-container class=\"md-accent md-block\" flex=\"50\"><label><span translate>\nRESTRAUNTANT.ITEM</span> Name</label><input type=\"text\" ng-model=\"vm.fmInfo.fmItemName\" name=\"itemname\" required \nmaxlength=\"40\"><div class=\"hint\" translate ng-if=\"!addfoodForm.itemname.$invalid || addfoodForm.itemname.$untouched\">\nRESTRAUNTANT.HELP-TEXT.ADD-MENU-ITEM</div><div ng-messages=\"addfoodForm.itemname.$error\"><div ng-message=\"required\">\n<span><span translate>RESTRAUNTANT.ITEM</span> Name field is required</span></div></div></md-input-container></div>\n</div><div layout=\"row\" class=\"mt-24\"><div flex=\"100\" layout=\"row\"><md-input-container class=\"md-accent md-block\">\n<label><span translate>BILLINGS.RATE</span> per item (<span translate>BILLINGS.INR</span>)</label><input type=\"text\" \nname=\"price\" ng-model=\"vm.fmInfo.fmItemPrice\" ng-keypress=\"onlynumbers($event);\" maxlength=\"8\" pattern=\"^[1-9][0-9]*$\" \nrequired><div ng-messages=\"addfoodForm.price.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>BILLINGS.RATE</span></span></div><div ng-message=\"pattern\">\nPlease enter the valid price</div></div></md-input-container><div flex=\"50\" class=\"ml-16\"><md-input-container \nclass=\"md-accent md-block\"><label><span translate>Offer rate</span> per item (<span translate>BILLINGS.INR</span>)\n</label><input type=\"number\" name=\"offer\" ng-model=\"vm.fmInfo.offerprice\" max=\"{{vm.fmInfo.fmItemPrice}}\" \nng-keypress=\"onlynumbers($event);\"><div ng-messages=\"addfoodForm.offer.$error\" multiple=\"multiple\"><div \nng-message=\"max\"><span>Please enter below the Rate per item</span></div></div></md-input-container></div></div></div>\n<div layout=\"row\" class=\"mt-8\" ng-if=\"vm.settings.dealer\"><div flex=\"50\" layout=\"row\"><md-input-container \nclass=\"md-accent md-block ml-16\"><label><span translate=\"\">USERS.DEALER</span> Rate per item (<span translate>\nBILLINGS.INR</span>)</label><input type=\"number\" name=\"dprice\" ng-model=\"vm.fmInfo.dealer_price\" \nmax=\"{{vm.fmInfo.dealer_price}}\" ng-keypress=\"onlynumbers($event);\"><div ng-messages=\"addfoodForm.dprice.$error\" \nmultiple=\"multiple\"><div ng-message=\"max\"><span>Please enter below the <span translate=\"\">USERS.DEALER</span>\n price per item</span></div></div></md-input-container></div></div><div class=\"sub-head mt-8 mb-24\">Profit Information\n</div><div flex=\"50\"><md-input-container class=\"md-accent md-block ml-16\"><label><span translate=\"\">FOOD.ACTUAL-PRICE\n</span> Rate per item (<span translate>BILLINGS.INR</span>)</label><input type=\"number\" name=\"aprice\" \nng-model=\"vm.fmInfo.actual_price\" max=\"{{vm.fmInfo.actual_price}}\" ng-keypress=\"onlynumbers($event);\"><div \nng-messages=\"addfoodForm.aprice.$error\" multiple=\"multiple\"><div ng-message=\"max\"><span>Please enter below the <span \ntranslate=\"\">FOOD.ACTUAL-PRICE</span> price per item</span></div></div></md-input-container></div><md-radio-group \nclass=\"layout-row mb-24 flex\" ng-if=\"!vm.settings.global_tax&&vm.settings.indivudual_exclude\" id=\"radio-focus\" \nng-model=\"vm.fmInfo.tax_status\" id=\"myselector\"><md-radio-button ng-repeat=\"category in vm.dietType\" \nvalue=\"{{category.value}}\" class=\"md-accent\" ng-click=\"hello\">{{category.label}}</md-radio-button></md-radio-group><div\n layout=\"row\" class=\"mt-24\" ng-if=\"!vm.settings.global_tax&&vm.settings.indivudual_exclude\"><div flex=\"100\" \nlayout=\"row\"><md-input-container class=\"md-accent md-block\"><label><span>CGST Tax Rate</span></label><input \ntype=\"number\" name=\"cgst\" ng-model=\"vm.fmInfo.tax_cgst\" ng-keypress=\"onlynumberDot($event);\" maxlength=\"4\" \nng-required=\"vm.settings.indivudual_exclude\"><div ng-messages=\"addfoodForm.cgst.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the cgst rate</span></div><div ng-message=\"pattern\">\nPlease enter the valid rate</div></div></md-input-container><div flex=\"50\" class=\"ml-16\"><md-input-container \nclass=\"md-accent md-block\"><label><span>SGST Tax Rate</span></label><input type=\"number\" name=\"sgst\" \nng-model=\"vm.fmInfo.tax_sgst\" ng-keypress=\"onlynumberDot($event);\" maxlength=\"4\" \nng-required=\"vm.settings.indivudual_exclude\"><div ng-messages=\"addfoodForm.sgst.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the sgst rate</span></div><div ng-message=\"pattern\">\nPlease enter the valid rate</div></div></md-input-container></div></div></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-if=\"!vm.newFMItem\" ng-click=\"editFMItem(fmInfo)\" ng-disabled=\"addfoodForm.$invalid || addfoodForm.$pristine\">\nEdit Menu Items</md-button><md-button class=\"md-accent\" ng-if=\"vm.newFMItem\" ng-click=\"addFMItem()\" \nng-disabled=\"addfoodForm.$invalid\">Add Menu Items</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/raw-material/catergory/rm-category.addcategory.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex w-480 h-400 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-16\">\nAdd Category</h2><span class=\"secondary-text\">Category Name</span><div class=\"layout-row layout-align-start-start\">\n<md-input-container class=\"md-accent\" flex=\"100\"><input type=\"text\" ng-model=\"tableinfo.tableno\" ng-required=\"true\">\n</md-input-container></div><md-button class=\"md-accent\">Add Another</md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-click=\"closeDialog()\">Add Category</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/raw-material/catergory/rm-category.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"m-w-720\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-16\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add <span \ntranslate>RESTRAUNTANT.MENU-CATEGORY</span></md-button></div><div layout=\"row\" ng-show=\"show1\" \nclass=\"padding-16 ash-color mb-24 m-w-620\"><form name=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" \nlayout-wrap><md-input-container md-no-float class=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" \nng-model=\"rawcategory.rmCatergoryName\" name=\"catname\" placeholder=\"Category Name\" required maxlength=\"40\"><div \nng-messages=\"(addCategory.catname.$touched && addCategory.catname.$error) || addCategory.$invalid\"><div \nng-message=\"required\">Please enter the <span translate>RESTRAUNTANT.MENU-CATEGORY</span> name</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"end start\"><md-button \nng-click=\"cancelAddItem(rawcategory); show1 = !show1\">Cancel</md-button><md-button class=\"md-primary md-raised\" \nlayout-align-end ng-disabled=\"addCategory.$invalid\" ng-click=\"addNewCategory(rawcategory); show1 = \'\'\">\nAdd {{\'ODC.Category\' | translate}}</md-button></div></form></div><div class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple\"><thead><tr><th class=\"secondary-text\"><span class=\"column-title\">{{\'ODC.Category\' | translate}} Name\n</span></th><th class=\"secondary-text\"><span class=\"column-title\">{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr>\n</thead><tbody><tr class=\"cursor-pointer\" ng-repeat=\"rawcategory in vm.rawcategorys\"><td width=\"70%\" class=\"medium\">\n<span ng-hide=\"show\">{{ rawcategory.rmCatergoryName}}</span><div ng-show=\"show\"><form name=\"editCategory\" novalidate \nflex=\"100\"><md-input-container class=\"md-accent\"><input type=\"text\" aria-label=\"email\" \nng-model=\"rawcategory.rmCatergoryName\" name=\"name\" required maxlength=\"40\"><div ng-messages=\"editCategory.name.$error\">\n<div ng-message=\"required\">Please enter category name</div></div></md-input-container><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" ng-click=\"updateaData(rawcategory); show = \'\'\" \ntitle=\"Save\" ng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(rawcategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(rawcategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(rawcategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/raw-material/item/rm-item.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"mb-16\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add Item\n</md-button><div layout=\"row\" layout-align=\"end start\" flex><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.search\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"vm.search\" \nng-click=\"clearText()\"></md-icon></div></div></div><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'ODC.Category\' | translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.STOCK-QUANTITY\' | translate}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.ACTIONS\' | translate}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"rmInfo in vm.rawMenusInfo | filter: vm.search\"><td>{{ rmInfo.rmname }}</td><td>{{ getCategoryName(rmInfo) }}\n</td><td><span translate>BILLINGS.INR</span> {{ rmInfo.rmrate }}</td><td>{{ rmInfo.stock_quantity }}</td><td><md-button\n class=\"md-icon-button\" ng-click=\"vm.showAddTableDialog($event, rmInfo)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteContactConfirm(rmInfo, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/admin/sale-item/catergory/si-category.addcategory.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex w-480 h-400 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-16\">\nAdd {{\'ODC.Category\' | translate}}</h2><span class=\"secondary-text\">{{\'ODC.Category\' | translate}} Name</span><div \nclass=\"layout-row layout-align-start-start\"><md-input-container class=\"md-accent\" flex=\"100\"><input type=\"text\" \nng-model=\"tableinfo.tableno\" ng-required=\"true\"></md-input-container></div><md-button class=\"md-accent\">Add Another\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent\" ng-click=\"closeDialog()\">Add {{\'ODC.Category\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/sale-item/catergory/si-category.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div class=\"m-w-720\"><div \nlayout=\"row\" class=\"layout-align-start-center mb-16\" ng-hide=\"show1\"><md-button class=\"md-accent\" \naria-label=\"edit info\" ng-click=\"show1 = !show1\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\nAdd Category</md-button></div><div layout=\"row\" ng-show=\"show1\" class=\"padding-16 ash-color mb-24 m-w-620\"><form \nname=\"addCategory\" novalidate flex=\"100\"><div layout=\"row\" layout-wrap><md-input-container md-no-float \nclass=\"md-accent pr-16\" flex=\"100\"><input type=\"text\" ng-model=\"salecategory.siCatergoryName\" name=\"catname\" \nplaceholder=\"Category Name\" required maxlength=\"40\"><div \nng-messages=\"(addCategory.catname.$touched && addCategory.catname.$error) || addCategory.$invalid\"><div \nng-message=\"required\">Please enter the <span translate>ODC.Category</span> name</div></div></md-input-container></div>\n<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"cancelAddItem(rawcategory); show1 = !show1\">Cancel\n</md-button><md-button class=\"md-primary md-raised\" layout-align-end ng-disabled=\"addCategory.$invalid\" \nng-click=\"addNewCategory(salecategory); show1 = \'\'\">Add {{\'ODC.Category\' | translate}}</md-button></div></form></div>\n<div class=\"ms-responsive-table-wrapper\"><table class=\"simple\"><thead><tr><th class=\"secondary-text\"><span \nclass=\"column-title\">{{\'ODC.Category\' | translate}}</span></th><th class=\"secondary-text\"><span class=\"column-title\">\n{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody><tr class=\"cursor-pointer\" \nng-repeat=\"salecategory in vm.salecategorys\"><td width=\"70%\" class=\"medium\"><span ng-hide=\"show\">\n{{ salecategory.siCatergoryName}}</span><div ng-show=\"show\"><form name=\"editCategory\" novalidate flex=\"100\">\n<md-input-container class=\"md-accent\"><input type=\"text\" aria-label=\"email\" ng-model=\"salecategory.siCatergoryName\" \nname=\"name\" required maxlength=\"40\"><div ng-messages=\"editCategory.name.$error\"><div ng-message=\"required\">\nPlease enter category name</div></div></md-input-container><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" ng-click=\"updateaData(salecategory); show = \'\'\" \ntitle=\"Save\" ng-disabled=\"editCategory.$invalid || editCategory.$pristine \"><md-icon md-menu-origin \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" \nng-click=\"cancelItem(salecategory); show = !show\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></form><div></div></div></td><td><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"editItem(salecategory); show = !show\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"vm.deleteContactConfirm(salecategory, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/sale-item/item/si-item.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"mb-16 header-panel\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialogs($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>Add Item\n</md-button><div layout=\"row\" layout-align=\"end start\" flex><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"saleitems_query.filter\" ng-keypress=\"keyPressed($event)\" type=\"text\" placeholder=\"Search...\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"saleitems_query.filter\" \nng-click=\"clearTexts()\"></md-icon></div></div></div><div><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head md-order=\"saleitems_query.order\" \nmd-on-reorder=\"getDesserts\"><tr md-row><th md-column width=\"20%\">{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column \nwidth=\"10%\" class=\"hidebelow600\" ng-if=\"vm.settings.show_sales_item_image\">Image</th><th md-column \nng-if=\"vm.branchFilterData[0].barcode_enable == 1\" width=\"20%\" class=\"hidebelow600\">\n{{\'BILLINGS.BARCODE-NO\' | translate}}</th><th md-column width=\"15%\" class=\"hidebelow600\">{{\'ODC.Category\' | translate}}\n</th><th md-column width=\"10%\"><span ng-if=\"!vm.print.mrp\">{{\'FOOD.RATE-PER-QTY\' | translate}}</span> <span \nng-if=\"vm.print.mrp\">{{\'BILLINGS.MRP\' | translate}}</span></th><th md-column width=\"15%\" class=\"hidebelow600\">\n{{\'BILLINGS.STOCK-QUANTITY\' | translate}}</th><th md-column width=\"10%\" class=\"hidebelow600\"><span \nng-if=\"!vm.print.mrp\">Offer rate </span><span ng-if=\"vm.print.mrp\">{{\'BILLINGS.RATE\' | translate}}</span></th><th \nmd-column width=\"10%\">{{\'BILLINGS.ACTIONS\' | translate}}</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" ng-repeat=\"siInfo in vm.saleMenusInfo\"><td md-cell>\n{{ siInfo.siname }}</td><td md-cell class=\"hidebelow600\" ng-if=\"vm.settings.show_sales_item_image\"><img \nng-src=\"{{ siInfo.image_url || \'assets/images/empty_image.jpg\' }}\" alt=\"item\" \nstyle=\"max-width: 60px; max-height: 60px; object-fit: contain\"></td><td \nng-if=\"vm.branchFilterData[0].barcode_enable == 1\" md-cell class=\"hidebelow600\">{{ siInfo.barcode }}</td><td md-cell \nclass=\"hidebelow600\">{{ getCategoryName(siInfo) }}</td><td md-cell><span translate>BILLINGS.INR</span>\n {{ siInfo.sirate }}</td><td md-cell class=\"hidebelow600\">{{ siInfo.stock_quantity }}</td><td md-cell \nclass=\"hidebelow600\">{{ siInfo.offerprice }}</td><td md-cell><md-button class=\"md-icon-button\" \nng-click=\"vm.showAddTableDialogs($event, siInfo)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteContactConfirm(siInfo, $event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.saleMenusInfo.length==0\"><h3>\nThere\'re no items for you to see.</h3></div></md-table-container><md-table-pagination md-limit=\"saleitems_query.limit\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"saleitems_query.page\" md-total=\"{{paidexpense_count}}\" md-page-select \nmd-on-paginate=\"getDesserts\"></md-table-pagination></div></div>");
$templateCache.put("app/main/admin/tablesettings/dialog/tablesettings.addtable.dialog.html","<form name=\"addtable\"><md-dialog aria-label=\"Diet-in\" class=\"flex w-480 layout-column\"><md-dialog-content \nclass=\"flex layout-column\"><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-16\">Add <span translate>\nRESTRAUNTANT.TABLE-NO</span></h2><div class=\"layout-row layout-align-start-start\"><md-input-container \nclass=\"md-accent\" flex=\"100\"><input type=\"text\" name=\"tableno\" ng-keypress=\"onlynumber($event);\" maxlength=\"3\" \nng-model=\"tableinfo.table_no\" required placeholder=\"Enter table no\"><div ng-messages=\"addtable.tableno.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter table no</span></div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" ng-disabled=\"addtable.$invalid\" \nng-click=\"addNewTable(tableinfo)\">Add <span translate>RESTRAUNTANT.TABLE-NO</span></md-button></md-dialog-actions>\n</md-dialog></form>");
$templateCache.put("app/main/cashier/campaign/finishedcampaign/finishedcampaign.html","<div \nclass=\"layout-column layout-align-center-center min-height-100 md-whiteframe-2dp white-bg padding-24 text-center no-data\" \nng-if=\"vm.row_index.length==0\"><img src=\"assets/images/no-data.png\"><h1 class=\"text-center md-display-1\">\nHi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no campaign messages for you to see. If you want to create a new campaign just click below button and go ahead\n</h3><md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.newCampaign\">\nNew Campaign</md-button></div><div class=\"finishedCamp\" ng-if=\"vm.row_index.length!=0\"><ul><li \nng-repeat=\"cam in vm.row_index\" ng-click=\"campaignfilter(cam)\"><div layout=\"column\" ayout-align=\"start start\"><div \nlayout=\"row\"><div class=\"title h1\">{{cam.campaignName}}</div><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"removeRow(cam,$event,$index); $event.stopPropagation();\"><md-tooltip md-direction=\"bottom\">\nDelete the Campaign</md-tooltip><md-icon md-menu-origin md-font-icon=\"icon-delete \"></md-icon></md-button></div><div \nclass=\"subtitle h5 secondary-text\">{{cam.createdOn | date:\'medium\'}}</div></div><div layout=\"row\" class=\"mt-16 count\" \nlayout-align=\"start start\"><span class=\"flex-none\"><md-icon md-menu-origin \nmd-font-icon=\"text-black-40 icon-account flex-none mr-2 s16\"></md-icon>\n{{ getCustomerCount(cam)}}{{campaignStatus.length}} Sent </span><span class=\"flex\"></span> <span class=\"flex-none\">\n<md-icon md-menu-origin md-font-icon=\"text-black-40 icon-check-all flex-none mr-2 s16\"></md-icon>\n{{DeliveredCount.length}} Delivered</span></div></li></ul></div>");
$templateCache.put("app/main/cashier/campaign/newcampaign/campaign.html","<div \nclass=\"layout-column layout-align-center-center min-height-100 md-whiteframe-2dp white-bg padding-24 text-center no-data\" \nng-if=\"!authKey||!sender_id\"><img src=\"assets/images/no-data.png\"><h2 class=\"text-center m-w-620\">\nSetup your authkey/ sender id in settings page so you will the be able to create new SMS campaign</h2></div><div \nid=\"forms\" class=\"layout-column layout-align-start-start white-bg no-data\" style=\"position: relative\" \nng-if=\"authKey&&sender_id\"><div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-4dp min-height-100 layout-column padding-8 scrollable\"><div \nng-hide=\"online\" class=\"warm-msg\">You\'re in offline. This feature need internet connectivity to send sms</div><span>\nYour remaining message count available for Promotional:<span style=\"color: red\">{{promotional}}</span>\n And Transcational:<span style=\"color: red\">{{transcational}}</span></span><form name=\"horizontalStepper\" \nms-vertical-stepper ng-submit=\"vm.submitHorizontalStepper()\" ng-model=\"vm.horizontalStepper\" novalidate>\n<ms-vertical-stepper-step ng-form=\"horizontalStep1\" step=\"1\" step-title=\"\'CAMPAIGN\'\"><div layout=\"column\" flex \nclass=\"m-w-620 ml-8\"><div layout=\"row\"><div flex-none class=\"form-label mt-8 w-140\">Campaign Name</div>\n<md-input-container class=\"md-accent md-block\" md-no-float flex=\"100\"><input type=\"text\" name=\"firstname\" \nng-model=\"vm.horizontalStepper.step1.campaignName\" placeholder=\"Campaign Name\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Campaign Name is required.</span></div></div></md-input-container></div><div layout=\"row\" \nclass=\"hide-date-picker-icon spacer-8 mb-8\"><span flex-none class=\"form-label mt-8 w-140\">Sent time</span>\n<md-input-container class=\"margin-right-10\" md-no-float flex=\"52\"><md-select \nng-model=\"vm.horizontalStepper.step1.msgtype\" ng-init=\'vm.horizontalStepper.step1.msgtype=\"Immediate\"\' \nplaceholder=\"Delivery Time\" class=\"md-accent\" name=\"deliveryTime\"><md-option value=\"Immediate\">Immediate</md-option>\n<md-option value=\"Schedule\">Schedule</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n</div><div layout=\"row\" class=\"hide-date-picker-icon spacer-8 mb-8\"><span flex-none class=\"form-label mt-8 w-140\">\nmsg type</span><md-input-container class=\"margin-right-10\" md-no-float flex=\"52\"><md-select \nng-model=\"vm.horizontalStepper.step1.msgroute\" placeholder=\"Select\" class=\"md-accent\" name=\"deliveryTime\" required>\n<md-option value=\"1\">Promotional</md-option><md-option value=\"4\">Transcational</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"row\" class=\"hide-time-picker-icon spacer-8\" \nng-if=\"vm.horizontalStepper.step1.msgtype==\'Schedule\'\"><span flex-none class=\"form-label mt-8 w-140\">Date & Time</span>\n<div layout=\"row\" class=\"small hide-date-picker-icon spacer-8 margin-bottom-16\"><div class=\"layout-row\">\n<md-input-container class=\"md-block md-accent\" flex=\"50\"><md-datepicker name=\"eventDate\" \nng-init=\"vm.horizontalStepper.step1.campaignDate=myDate\" ng-model=\"vm.horizontalStepper.step1.campaignDate\" \nmd-min-date=\"minDate\" md-max-date=\"maxDate\" class=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" \nng-required=\"true\"></md-datepicker></md-input-container>&nbsp;&nbsp;&nbsp;<md-input-container \nclass=\"md-block md-accent\" flex=\"50\"><input type=\"time\" name=\"eventTime\" min=\"09:00:00\" max=\"18:00:00\" \nng-init=\"vm.horizontalStepper.step1.campaignTime=myDates\" ng-model=\"vm.horizontalStepper.step1.campaignTime\" required>\n<div ng-messages=\"horizontalStep1.eventTime.$error\" ng-show=\"horizontalStep1.eventTime.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>time is required.</span></div></div></md-input-container></div></div></div></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'SELECT CUSTOMERS\'\">\n<div class=\"white-bg layout-column\" layout-align=\"start start\" \nstyle=\"padding:16px; border:1px solid #dedede; max-height:350px; overflow-y: scroll\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"mb-16 no-error small\" style=\"height: 56px\"><div flex layout=\"row\" class=\"medium\"><div\n class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"visits\" aria-label=\"email\" \nng-init=\"visits=vm.lastvisits[0].visitid\" ng-change=\"customer_change(localityy,visits)\" class=\"md-accent\" flex=\"100\">\n<md-option ng-repeat=\"visits in vm.lastvisits\" value=\"{{visits.visitid}}\">{{visits.visits}}</md-option></md-select>\n</div><div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"localityy\" aria-label=\"email\" id=\"mu\" \nmultiple=\"multiple\" ng-change=\"customer_change(localityy,visits)\" class=\"md-accent\" flex=\"100\"><md-option \nng-repeat=\"localityy in vm.locality\" value=\"{{localityy.localityID}}\">{{localityy.localityName}}</md-option>\n</md-select></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><span ng-if=\"selected.length>0\">{{selected.length}} Selected</span><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"selected\" required><thead md-head \nmd-order=\"purchaseorder_query.order\" md-on-reorder=\"customPagination\"><tr md-row><th md-column \nmd-order-by=\"customer_name\" width=\"20%\">{{\'BILLINGS.CUSTOMER-LIST.NAME\' | translate}}</th><th md-column width=\"18%\">\n{{\'BILLINGS.CUSTOMER-LIST.MOBILE\' | translate}}</th><th md-column width=\"12%\">\n{{\'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}}</th><th md-column width=\"12%\">\n{{\'BILLINGS.CUSTOMER-LIST.CITY\' | translate}}</th><th md-column width=\"10%\" ng-if=\"vm.settings.veg_nonveg_permission\">\nFood Type</th><th md-column width=\"10%\">{{\'BILLINGS.CUSTOMER-LIST.TOTAL-ORDERED\' | translate}}</th><th md-column \nmd-numeric md-order-by=\"ordertime\" width=\"15%\">{{\'BILLINGS.CUSTOMER-LIST.LAST-ORDERED\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"customer\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"customer in vm.getpurchase | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order : true\" \nng-click=\"hidden($event,selected)\"><td md-cell><div layout=\"column\" class=\"layout-column\"><div><span class=\"username\">\n{{customer.customer_name }}</span></div><span class=\"time secondary-text\">{{customer.customer_email}}</span></div></td>\n<td md-cell>{{ customer.customer_mobile }}</td><td md-cell>{{ customer.customer_locality}}</td><td md-cell>\n{{ customer.customer_city }}</td><td md-cell ng-if=\"vm.settings.veg_nonveg_permission\">{{customer.customerFoodType}}\n</td><td md-cell>{{customer.total_visit}}</td><td md-cell>\n{{ customer.salesorder_id ? (customer.ordertime | date) : \'\'}} <span class=\"username\">\n{{ customer.salesorder_id ? customer.lastvisit : \'\'}}</span></td></tr></tbody></table><md-input-container \nstyle=\"display: none\" class=\"md-accent md-block\" md-no-float flex=\"100\"><input type=\"number\" min=\"1\" name=\"firstname\" \nng-model=\"selected.length\" placeholder=\"Campaign Name\" required></md-input-container></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'MESSAGE\'\"><div layout=\"column\" flex \nclass=\"m-w-620 ml-8 md-inline-form\"><div layout=\"row\"><div flex-none class=\"form-label mt-8 w-140\">Message</div>\n<md-input-container flex=\"100\"><textarea name=\"message\" aria-label=\"email\" maxlength=\"459\" \nng-model=\"vm.horizontalStepper.step1.message\" max-rows=\"8\" required></textarea><div class=\"md-errors-spacer\"><div \nclass=\"md-char-counter\"><span ng-if=\"vm.horizontalStepper.step1.message.length\">\n{{msgcount(vm.horizontalStepper.step1.message.length)}}</span>\n{{vm.horizontalStepper.step1.message.length ? \'\' : 0}} /{{vm.horizontalStepper.step1.message.length ? vm.horizontalStepper.step1.message.length : 0}}\n</div></div><div ng-messages=\"verticalStep3.message.$error\" ng-show=\"verticalStep3.message.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Message is required.</span></div></div></md-input-container><md-input-container \nstyle=\"display: none\" class=\"md-accent md-block\" md-no-float flex=\"100\"><input type=\"number\" min=\"1\" name=\"firstname\" \nng-model=\"selecte\" placeholder=\"Campaign Name\" ng-required=\"!online\"></md-input-container></div><div layout=\"row\" \nng-hide=\"online\"><div flex-none class=\"form-label mt-8 w-140\"></div><div class=\"warm-color\">\nNeed internet connectivity to send sms</div></div></div></ms-vertical-stepper-step></form></div></div>");
$templateCache.put("app/main/cashier/campaign/whatsappfinishedcampaign/whatsappfinishedcampaign.html","<div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-2dp min-height-100 layout-column padding-48 scrollable\" \nng-if=\"whatsapppermission!=true\"><h1>Upgrade your account</h1><h3 class=\"text-left\">\nPlease upgrade the account to access smart marketing with bulk message in whatsapp to promote your brand, product, services and offers to increase sales.\n</h3><br><span class=\"tag\">Contact us to upgrade :</span><br><div class=\"mt-12\">Mobile :- +91 9094858377</div><div \nclass=\"mt-4\">Email :- info@techfooddy.com</div><div class=\"mt-4\">Website :- www.techfooddy.com</div></div><div \nclass=\"white-bg md-whiteframe-4dp min-height-100 layout-column padding-24 scrollable customer-list\" \nng-if=\"whatsapppermission==true\"><div layout=\"row\" layout-align=\"start start\" class=\"mb-16 header-panel\"><div \nlayout=\"row\" layout-align=\"end start\" flex><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"pagination_query.searchText\" \ntype=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"pagination_query.searchText\" \nng-click=\"clearText_campaingns()\"></md-icon></div></div></div><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head><tr md-row><th md-column \nmd-order-by=\"customer_name\">{{\'WHATSAPP.CAMPAIGN-NAME\' | translate}}</th><th md-column>\n{{\'Inventory.CREATED ON\' | translate}}</th><th md-column>Total</th><th md-column>{{\'WHATSAPP.DELIVERED\' | translate}}\n</th><th md-column>{{\'BILLINGS.ACTIONS\' | translate}}</th></tr></thead><tbody md-body><tr class=\"cursor-pointer\" \nmd-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select ng-repeat=\"campaign in vm.campaign_datas\" href=\"#\" \nng-click=\"campaignfilter(campaign)\"><td md-cell>{{campaign.campaignName}}</td><td md-cell>\n{{campaign.createdOn | date:\'medium\'}}</td><td md-cell>{{getCustomerCount(campaign)}}{{campaignStatus.length}}</td><td \nmd-cell>{{DeliveredCount.length}}</td><td md-cell><md-button class=\"md-icon-button\" ng-hide=\"show\" \nng-click=\"removeRow(campaign,$event,$index); $event.stopPropagation();\"><md-tooltip md-direction=\"bottom\">\nDelete the Campaign</md-tooltip><md-icon md-menu-origin md-font-icon=\"icon-delete \"></md-icon></md-button></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"pagination_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"pagination_query.page\" md-total=\"{{totalItems}}\"></md-table-pagination></div>");
$templateCache.put("app/main/cashier/campaign/whatsappnewcampaign/whatsappnewcampaign.html","<div id=\"forms\" class=\"layout-column layout-align-start-start white-bg no-data\" style=\"position: relative\" \nng-if=\"whatsapppermission==true && expiryService==false\"><div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-4dp min-height-100 layout-column padding-8 scrollable\" \nng-if=\"!load&&!agreeContinueContidion\"><div ng-hide=\"online\" class=\"warm-msg\">\nYou\'re in offline. This feature need internet connectivity to send sms</div><form name=\"horizontalStepper\" \nms-vertical-stepper ng-submit=\"vm.submitHorizontalStepper()\" ng-model=\"vm.horizontalStepper\" novalidate>\n<ms-vertical-stepper-step ng-form=\"horizontalStep1\" step=\"1\" step-title=\"\'CAMPAIGN\'\"><div layout=\"column\" flex \nclass=\"m-w-620 ml-8\"><div layout=\"row\"><div flex-none class=\"form-label mt-8 w-140\">Campaign Name</div>\n<md-input-container class=\"md-accent md-block\" md-no-float flex=\"100\"><input type=\"text\" name=\"firstname\" \nng-model=\"vm.horizontalStepper.step1.campaignName\" placeholder=\"Campaign Name\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Campaign Name is required.</span></div></div></md-input-container></div></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'SELECT CUSTOMERS\'\">\n<div class=\"white-bg layout-column\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\" \nclass=\"no-error small\" style=\"height: 48px\"><div flex layout=\"row\" class=\"medium\"><div class=\"ph-8 filter-dropdown-sm\">\n<md-select ng-model=\"visits\" aria-label=\"email\" ng-init=\"visits=vm.lastvisits[0].visitid\" \nng-change=\"customer_change(localityy,visits)\" class=\"md-accent\" flex=\"100\"><md-option \nng-repeat=\"visits in vm.lastvisits\" value=\"{{visits.visitid}}\">{{visits.visits}}</md-option></md-select></div><div \nclass=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"localityy\" aria-label=\"email\" id=\"mu\" multiple=\"multiple\" \nng-change=\"customer_change(localityy,visits)\" class=\"md-accent\" flex=\"100\"><md-option \nng-repeat=\"localityy in vm.locality\" value=\"{{localityy.localityID}}\">{{localityy.localityName}}</md-option>\n</md-select></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" \nng-click=\"clearText()\"></md-icon></div><span ng-if=\"vm.selected.length>0\" class=\"selectedCount\">\n{{vm.selected.length}} Selected</span></div><div class=\"campaign_scroll_data\" layout=\"column\"><table md-table \nmd-progress=\"promise\"><thead md-head md-order=\"purchaseorder_query.order\" md-on-reorder=\"customPagination\"><tr md-row>\n<th md-column width=\"5%\"><md-checkbox aria-label=\"Select all visible\" ng-checked=\"vm.isAllVisibleSelected()\" \nng-click=\"vm.toggleAllVisible($event)\"></md-checkbox></th><th md-column md-order-by=\"customer_name\" width=\"20%\">\n{{\'BILLINGS.CUSTOMER-LIST.NAME\' | translate}}</th><th md-column width=\"18%\">\n{{\'BILLINGS.CUSTOMER-LIST.MOBILE\' | translate}}</th><th md-column md-order-by=\"customer_city\" width=\"12%\">\n{{\'BILLINGS.CUSTOMER-LIST.CITY\' | translate}}</th><th md-column width=\"10%\" ng-if=\"vm.settings.veg_nonveg_permission\">\nFood Type</th><th md-column width=\"10%\">{{\'BILLINGS.CUSTOMER-LIST.TOTAL-ORDERED\' | translate}}</th><th md-column \nmd-numeric md-order-by=\"ordertime\" width=\"15%\">{{\'BILLINGS.CUSTOMER-LIST.LAST-ORDERED\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row \nng-repeat=\"customer in vm.getpurchase\r\n                     | filter: purchaseorder_query.filter\r\n                     | orderBy: purchaseorder_query.order : true\r\n                     | limitTo: purchaseorder_query.limit:(purchaseorder_query.page - 1) * purchaseorder_query.limit\" \nng-click=\"vm.rowClicked(customer, $event)\"><td md-cell><md-checkbox aria-label=\"Select row\" \nng-checked=\"vm.isSelected(customer)\" ng-click=\"vm.toggleSelection(customer, $event)\"></md-checkbox></td><td md-cell>\n<div layout=\"column\" class=\"layout-column\"><div><span class=\"username\">{{customer.customer_name}}</span></div><span \nclass=\"time secondary-text\">{{customer.customer_email}}</span></div></td><td md-cell>{{ customer.customer_mobile }}\n</td><td md-cell>{{ customer.customer_locality }}</td><td md-cell ng-if=\"vm.settings.veg_nonveg_permission\">\n{{customer.customerFoodType}}</td><td md-cell>{{customer.total_visit}}</td><td md-cell>\n{{ customer.salesorder_id ? (customer.ordertime | date) : \'\'}} <span class=\"username\">\n{{ customer.salesorder_id ? customer.lastvisit : \'\'}}</span></td></tr></tbody></table><md-input-container \nstyle=\"display: none\" class=\"md-accent md-block\" md-no-float flex=\"100\"><input type=\"number\" min=\"1\" name=\"firstname\" \nng-model=\"vm.selected.length\" placeholder=\"Campaign Name\" required></md-input-container><md-table-pagination \nmd-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"purchaseorder_query.page\" \nmd-total=\"{{purchaseorder_count}}\" md-page-select></md-table-pagination></div></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'MESSAGE\'\"><div layout=\"column\" flex \nclass=\"m-w-620 ml-8 md-inline-form\"><div layout=\"row\"><div flex-none class=\"form-label mt-8 w-140\">Message</div>\n<md-input-container flex=\"100\"><textarea name=\"message\" aria-label=\"email\" maxlength=\"460\" \nng-model=\"vm.horizontalStepper.step1.message\" max-rows=\"8\" required></textarea><div class=\"md-errors-spacer\"><div \nclass=\"md-char-counter\"><span ng-if=\"vm.horizontalStepper.step1.message.length\"></span>\n{{vm.horizontalStepper.step1.message.length ? vm.horizontalStepper.step1.message.length : 0}}</div></div><div \nng-messages=\"verticalStep3.message.$error\" ng-show=\"verticalStep3.message.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Message is required.</span></div></div></md-input-container><md-input-container \nstyle=\"display: none\" class=\"md-accent md-block\" md-no-float flex=\"100\"><input type=\"number\" min=\"1\" name=\"firstname\" \nng-model=\"selecte\" placeholder=\"Campaign Name\" ng-required=\"!online\"></md-input-container></div><div layout=\"row\"><div \nflex-none class=\"form-label mt-8 w-140\">Image</div><div class=\"column flex\"><div layout=\"row\"><button \nngf-select=\"uploadFiles($files, $invalidFiles)\" multiple=\"multiple\" accept=\"image/*\" ngf-max-files=\"2\" \nngf-resize=\"{width: 1600, height: 1600}\" ngf-max-size=\"2MB\" class=\"receipt-upload\"><br><md-icon md-menu-origin \nmd-font-icon=\"icon-attachment\" class=\"mr-8 text-black-40\"></md-icon><br>Attach your Image<br>\n(Max 2 image files, Max size 2MB)</button></div><div layout=\"row\"><div class=\"property-thumb flex row\" \nstyle=\"background: transparent; border: 0\"><figure class=\"gallery-thumb\" ng-repeat=\"step in stepsModel\" \nstyle=\"width: 110px;\r\n      float: left\"><img ng-src=\"{{step}}\"> <a href=\"javascript:;\" \nng-click=\"removeupload($index) \" title=\"Delete \"><md-icon md-font-icon=\"icon icon-trash \"></md-icon></a></figure></div>\n</div></div></div><div layout=\"row\" ng-hide=\"online\"><div flex-none class=\"form-label mt-8 w-140\"></div><div \nclass=\"warm-color\">Need internet connectivity to send sms</div></div></div></ms-vertical-stepper-step></form></div>\n</div><div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-4dp min-height-100 layout-column padding-48 scrollable\" \nng-if=\"load&&!agreeContinueContidion\"><div layout=\"row\" class=\"layout-align-start-center\"><img \nsrc=\"assets/images/whatsapp.svg\" width=\"350px\"> <span class=\"ml-32 please_wait\" style=\"display: block; width:100%\">\nPlease wait, we are checking your authentication and sending messages.<br><br>\nPlease make your mobile and PC is always connected to the internet.<br><br><span><md-progress-linear \nmd-mode=\"indeterminate\" class=\"mt-16 md-accent\"></md-progress-linear></span></span></div></div><div \nclass=\"layout-column layout-align-start-start white-bg no-data\" style=\"position: relative\" \nng-if=\"whatsapppermission==true&&agreeContinueContidion\"><div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-4dp min-height-100 layout-column padding-48 scrollable\"><div layout=\"row\">\n<div layout=\"column\"><span class=\"md-display-1\">Important information<br>you must know before sending</span><div \nlayout=\"row\" class=\"mt-40\"><div layout=\"column\"><div layout=\"row\" class=\"mb-20\"><div class=\"countPoint\"><i \nclass=\"icon s24 icon-wifi mr-16 mt-2\"></i></div><div>\nEnsure that your mobile and your PC is always connected to the internet during sending.</div></div><div layout=\"row\" \nclass=\"mb-20\"><div class=\"countPoint\"><i class=\"icon s24 icon-history mr-16 mt-2\"></i></div><div>\nClear Whatsapp chat history after around 1000 messages to keep everything running smooth.</div></div><div layout=\"row\" \nclass=\"mb-20\"><div class=\"countPoint\"><i class=\"icon s24 icon-block-helper mr-16 mt-2\"></i></div><div>\nTo prevent account from banning, do not send more than 2000 messages per hour from single account. If it is a new Whatsapp account, start slowly with 50 messages per day and gradually increase or else your account can be banned.\n</div></div><div layout=\"row\" class=\"mb-40\"><div class=\"countPoint\"><i class=\"icon s24 icon-alert-circle mr-16 mt-2\">\n</i></div><div>Techfooddy is not responsible if whatsapp account is disabled or banned.</div></div><div layout=\"row\" \nclass=\"mb-20\"><md-checkbox ng-model=\"agreeCheked\" aria-label=\"Checkbox Label\" ng-true-value=\"\'yes\'\" \nng-false-value=\"\'no\'\">Don\'t show again</md-checkbox></div><div layout=\"row\" class=\"mb-20\"><md-button \nclass=\"md-raised md-accent layout-row layout-align-center-center\" ng-click=\"agreeContinue(agreeCheked)\">Okay & Continue\n</md-button></div></div></div></div><div flex=\"60\" layout-align=\"center center\" style=\"text-align: center\"><img \nsrc=\"assets/images/whatsapp_info.jpg\" class=\"mt-24\"></div></div></div></div><div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-2dp min-height-100 layout-column padding-48 scrollable\" \nng-if=\"whatsapppermission!=true\"><h1>Upgrade your account</h1><h3 class=\"text-left\">\nPlease upgrade the account to access smart marketing with bulk message in whatsapp to promote your brand, product, services and offers to increase sales.\n</h3><br><span class=\"tag\">Contact us to upgrade :</span><br><div class=\"mt-12\">\nMobile :- +91 8825818823, +91 9094858377</div><div class=\"mt-4\">Email :- info@techfooddy.com</div><div class=\"mt-4\">\nWebsite :- www.techfooddy.com</div></div><div layout=\"column\" \nclass=\"w-100p medium white-bg md-whiteframe-2dp min-height-100 layout-column padding-48 scrollable\" \nng-if=\"whatsapppermission==true && expiryService==true\"><h1>Renew your account</h1><div class=\"mt-12\">\nExpiry Date :- {{formattedExpiryDate}}</div><div class=\"mt-4\">Balance :- {{balanceCount}} messages</div><br><h3 \nclass=\"text-left\">Your WhatsApp balance is zero or the service has expired.<br>\nPlease renew the service to access smart marketing with bulk message in whatsapp to promote your brand, product, services and offers to increase sales.\n</h3><span class=\"tag\">Contact us to renew :</span><br><div class=\"mt-12\">Mobile :- +91 8825818823, +91 9094858377\n</div><div class=\"mt-4\">Email :- info@techfooddy.com</div><div class=\"mt-4\">Website :- www.techfooddy.com</div></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/bill-dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-860 h-700 layout-column viewsales-bill\"><md-toolbar \nclass=\"md-menu-toolbar md-toolbar-custom flex-none\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"layout-column\"><div \nclass=\"font-size-px-16 font-weight-500 text-italic padding-bottom-5\"><span><span translate>BILLINGS.ORDERED-NO</span>\n.{{salesorder_id}} </span><span class=\"ml-16 text-boxed badge food-badge\" \nng-class=\"{ \'ordered\': \'food-ordered\', \'Ready To Pickup\': \'food-pickup\', \'Ate\': \'food-ate\', \'finished\': \'food-bill-printed\', \'Pending Payment\': \'food-pending-payment\' }[response[0].status]\" \ntranslate>{{response[0].status}}</span></div><div class=\"layout-row layout-align-left\"><span \nclass=\"font-size-px-14 text-italic text-black-70\" title=\"{{fmitems[0].ordertime}}\">\n{{\'BILLINGS.ORDERED-TIME\' | translate}} : {{fmitems[0].shortOrdertime | date:\'shortTime\'}}</span>, <span \nclass=\"font-size-px-14 text-italic text-black-70\">{{\'BILLINGS.DELIVERY-TIME\' | translate}} : {{view_deliverytime}}\n</span></div></div><span flex></span><div class=\"layout-row layout-align-center-center text-black-70\"><md-button \nng-if=\"(saleseditt.length) || permission==\'admin\'\" class=\"layout-row layout-align-center-center\" \naria-label=\"Add & Print\" ng-click=\"Editdiet();closeDialog()\"><span \nclass=\"icon icon-pencil text-black-40 font-size-24 mr-8\"></span> <span translate>Edit</span></md-button><md-button \nclass=\"layout-row layout-align-center-center\" aria-label=\"Add & Print\" ng-click=\"printToCart();closeDialog()\"><span \nclass=\"icon icon-printer text-black-40 font-size-24 mr-8\"></span> <span translate>GENERAL.PRINT</span></md-button>\n</div></div><md-divider></md-divider></md-toolbar><md-dialog-content class=\"no-padding flex\"><div \nclass=\"layout-row layout-fill white-bg flex-100\"><div class=\"flex-none grey-100-bg w-200\"><ul class=\"pr-tabs\"><li \nclass=\"pr-tab\" ng-init=\"prTabName=\'tabFoodInfo\'\" ng-class=\"{\'active\': prTabName==\'tabFoodInfo\'}\" \nng-click=\"prTabName =\'tabFoodInfo\'\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><span translate>BILLINGS.BILL</span> Info</li><li \nclass=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'tabCustomerInfo\'}\" ng-click=\"prTabName =\'tabCustomerInfo\'\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span translate>GENERAL.CUSTOMER</span> Info</li><li class=\"pr-tab\" \nng-class=\"{\'active\': prTabName==\'tabFeedback\'}\" ng-click=\"prTabName =\'tabFeedback\'\" md-ink-ripple=\"rgba(0,0,0,0.5)\">\n<span translate>GENERAL.FEEDBACK</span></li></ul></div><div class=\"pr-tab-contents flex\" ng-switch=\"prTabName\"><div \nclass=\"pr-tab-content layout-fill\" ng-switch-when=\"tabFoodInfo\"><div \nng-include=\"\'app/main/cashier/billing/bill-dialog/templates/food.info.html\'\"></div></div><div class=\"pr-tab-content\" \nng-switch-when=\"tabCustomerInfo\"><div ng-include=\"\'app/main/cashier/billing/bill-dialog/templates/customer.info.html\'\">\n</div></div><div class=\"pr-tab-content\" ng-switch-when=\"tabFeedback\"><div \nng-include=\"\'app/main/cashier/billing/bill-dialog/templates/feedback.html\'\"></div></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/cashier/billing/addreturnbill/addreturnbill.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div \nclass=\"newbill returnbill w-100p layout-fill min-height-100 small no-error pl-24 pl-16\" layout=\"row\"><div \nclass=\"m-w-720\" style=\"width:720px\"><div id=\"bod\" class=\"m-w-720\"><div id=\"head\" class=\"m-w-640\"><div id=\"head\" \nclass=\"mb-24\"><div layout=\"row\" class=\"medium\"><div flex-none class=\"form-label w-100 mt-12 mr-16\">Return Reason</div>\n<md-input-container><md-select ng-model=\"vm.refund_method\"><md-option ng-repeat=\"returnType in vm.returnTypes\" \nng-value=\"returnType.values\">{{returnType.names}}</md-option></md-select></md-input-container><div></div></div><div \nlayout=\"row\" class=\"medium\"><div flex-none class=\"form-label w-100 mt-12 mr-16\">Sales Order No</div><md-input-container\n md-no-float class=\"md-accent md-block\" flex=\"90\"><input type=\"text\" class=\"qty\" ng-keypress=\"keyPressed($event)\" \nvalid-number name=\"saleorderno\" ng-model=\"saleorderno\" required><div ng-messages=\"addfoodForm.saleorderno.$error\" \nclass=\"hideerrormessage\"><div ng-message=\"required\"><span>Please enter the Sales Order No</span></div></div>\n</md-input-container><div><md-button class=\"md-accent md-raised ml-8 small_button\" aria-label=\"search bill\" \nng-click=\"vm.fetchSalesOrder(saleorderno)\"><md-icon md-menu-origin md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></div></div></div><div id=\"content1\" class=\"border-right border-left bill-info-food-list-wrapper\" \nng-if=\"vm.saleorderitems.length > 0\"><table class=\"dataTable\"><thead><tr><th class=\"secondary-text order-item\" \nwidth=\"4%\"><div class=\"table-header layout-row\"></div></th><th class=\"secondary-text order-item\" width=\"49%\"><div \nclass=\"table-header layout-row\"><span class=\"ml-8\" flex>{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}\n</span></div></th><th class=\"secondary-text\" width=\"17%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text hidebelow600\" width=\"15%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th></tr></thead>\n<tbody><tr><td colspan=\"5\" height=\"12\"></td></tr><tr \nng-repeat=\"fmitem in vm.saleorderitems track by fmitem.salesitem_id\"><td width=\"4%\" class=\"text-center\"><md-checkbox \nng-model=\"fmitem.selected\" aria-label=\"select item\" ng-change=\"vm.onSelectItem(fmitem, $index)\" class=\"mt-8\">\n</md-checkbox></td><td width=\"49%\">{{ fmitem.sales_items }}</td><td width=\"15%\"><div ng-if=\"fmitem.selected\"><input \ntype=\"number\" min=\"0\" step=\"1\" ng-model=\"fmitem.return_qty\" ng-change=\"vm.onQtyChange(fmitem)\" \nng-blur=\"vm.onQtyBlur(fmitem)\" id=\"qty-{{fmitem.salesitem_id}}\" style=\"width:80px\"><div \nstyle=\"font-size:11px;color:#888;margin-top:4px\"><small>max: {{fmitem.sales_quantity}}</small></div></div><div \nng-if=\"!fmitem.selected\">{{ fmitem.return_qty || 0 }}</div></td><td width=\"17%\">{{ fmitem.salesitem_rate | number:2 }}\n</td><td class=\"text-black-70 hidebelow600\" width=\"15%\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> {{ fmitem.item_subrate | number:2 }}</td></tr><tr><td colspan=\"5\" height=\"24\"></td></tr></tbody></table></div>\n<div id=\"foot\" ng-if=\"vm.saleorderitems.length > 0\"><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div flex class=\"font-size-px-13 ml-8\"></div><div class=\"tag flex-20\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div></div></div></div><div \nclass=\"fix-bottom pt-8 pl-16\"><div class=\"layout-row center-end small-fix-bottom-button\"><div \nclass=\"layout-row center-end flex\"><md-button class=\"md-raised layout-row layout-align-center-center\" \nng-click=\"cancel($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary big layout-row layout-align-center-center\" ng-disabled=\"vm.exitems.total_amount <= 0\" \nng-click=\"add_purchase()\">Save</md-button></div></div></div></section>");
$templateCache.put("app/main/cashier/billing/currentbills/currentbills.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg\"><md-nav-bar class=\"flex-none\" \nmd-selected-nav-item=\"currentNavItem\" nav-bar-aria-label=\"navigation links\" ng-show=\"vm.settings.ordered_posbills_tab\">\n<md-nav-item md-nav-click=\"goto(\'diet-in\')\" name=\"diet-in\" ng-if=\"vm.settings.dinein_permission\"><div \nclass=\"layout-row layout-align-center-center\"><span translate>RESTRAUNTANT.DIET-IN</span> <span \nclass=\"badge badge-circle margin-left-8\">{{ dinein_count}}</span></div></md-nav-item><md-nav-item \nmd-nav-click=\"goto(\'take-away\')\" name=\"take-away\" ng-if=\"vm.settings.takeaway_permission\"><div \nclass=\"layout-row layout-align-center-center\"><span translate>RESTRAUNTANT.TAKE-AWAY</span> <span \nclass=\"badge badge-circle margin-left-8\">{{takeaway_count}}</span></div></md-nav-item><md-nav-item \nmd-nav-click=\"goto(\'door-delivery\')\" name=\"door-delivery\" ng-if=\"vm.settings.doordelivery_permission\"><div \nclass=\"layout-row layout-align-center-center\"><span translate>RESTRAUNTANT.DOOR-DELIVERY</span> <span \nclass=\"badge badge-circle margin-left-8\">{{doordelivery_count}}</span></div></md-nav-item></md-nav-bar><div \nclass=\"md-nav-bar-content primary-transition flex\"><md-content class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/currentbills/dietin/diet.in.html\'\" ng-show=\"currentNavItem == \'diet-in\'\" \nms-scroll></md-content><md-content class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/currentbills/takeaway/take.away.html\'\" ng-show=\"currentNavItem == \'take-away\'\" \nms-scroll></md-content><md-content class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/currentbills/doordelivery/door.delivery.html\'\" \nng-show=\"currentNavItem == \'door-delivery\'\" ms-scroll></md-content><md-content style=\"display: none\" \nclass=\"md-padding layout-fill scrollable\" ng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" \nng-controller=\"printbillController as vm\" ms-scroll></md-content></div></div>");
$templateCache.put("app/main/cashier/billing/currentbills/sale-bill.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-640 h-600 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" ng-click=\"closeDialog()\"><md-icon \nmd-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32\">\nAdd Raw material item</h2></div><form name=\"addfoodForm\" novalidate><div layout=\"row\" flex=\"100\"><md-input-container \nclass=\"md-block md-accent\" ng-show=\"!x.showAdd\" flex=\"50\"><label>Select Category</label><md-select \nng-model=\"foodbeverageinfo.category\" class=\"md-accent\"><md-option value=\"Biriyani\">Vegetable</md-option><md-option \nvalue=\"Biriyani\">Water</md-option></md-select></md-input-container><md-button class=\"md-accent ml-8 mt-8\" \nng-show=\"!x.showAdd\" ng-click=\"x.showAdd = !x.showAdd\"><md-icon md-menu-origin md-font-icon=\"icon-plus-circle\">\n</md-icon></md-button><div ng-show=\"x.showAdd\" layout=\"row\" flex=\"100\"><md-input-container class=\"md-accent md-block\" \nflex=\"50\"><label>Create New Category</label><input type=\"text\" name=\"name\" ng-model=\"vm.foodbeverageinfo.category\" \nvalue=\"1\" required><div ng-messages=\"addfoodForm.quantity.$error\"><div ng-message=\"required\"><span>\nCatergory field is required</span></div></div></md-input-container><md-button \nclass=\"md-primary md-mini md-raised md-icon-button\" aria-label=\"save\" ng-click=\"x.showAdd = !x.showAdd\" title=\"Save\">\n<md-icon md-menu-origin md-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-hue md-icon-button\" \naria-label=\"close\" ng-click=\"x.showAdd = !x.showAdd\" title=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div><div layout=\"row\" class=\"mt-16\"><div flex=\"80\"><md-input-container \nclass=\"md-accent md-block\"><label><span translate>RESTRAUNTANT.ITEM</span> Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.foodbeverageinfo.name\" required><div class=\"hint\" translate>RESTRAUNTANT.HELP-TEXT.ADD-MENU-ITEM</div><div\n ng-messages=\"addfoodForm.name.$error\"><div ng-message=\"required\"><span><span translate>RESTRAUNTANT.ITEM</span>\n Name field is required</span></div></div></md-input-container><div layout=\"row\"><md-input-container \nclass=\"md-accent md-block ml-8\" flex=\"40\"><label><span>Unit Measurement</span></label><input type=\"text\" name=\"price\" \nng-model=\"vm.foodbeverageinfo.price\" value=\"1\" ng-pattern=\"/^[0-9]/\" required><div class=\"hint\">Ex. 1, 0.5</div><div \nng-messages=\"addfoodForm.price.$error\" multiple=\"multiple\"><div ng-message=\"required\">Please enter the unit measurement\n</div><div ng-message=\"pattern\">Enter the numbers only</div></div></md-input-container><md-input-container \nclass=\"md-block md-accent\" flex=\"30\"><label>Unit</label><md-select ng-model=\"foodbeverageinfo.measure\" \nclass=\"md-accent\"><md-option value=\"cup\">Litre</md-option><md-option value=\"cup\">Kilogram</md-option><md-option \nvalue=\"cup\">Gram</md-option></md-select></md-input-container><md-input-container class=\"md-accent md-block ml-8\" \nflex=\"30\"><label><span>Per Rate</span></label><input type=\"text\" name=\"price\" ng-model=\"vm.foodbeverageinfo.price\" \nvalue=\"1\" ng-pattern=\"/^[0-9]/\" required><div ng-messages=\"addfoodForm.price.$error\" multiple=\"multiple\"><div \nng-message=\"required\">Please enter the rate</div><div ng-message=\"pattern\">Enter the numbers only</div></div>\n</md-input-container></div><md-input-container class=\"md-accent md-block\" flex=\"50\"><label>Low Stock Alert</label>\n<input type=\"text\" name=\"name\" ng-model=\"vm.foodbeverageinfo.name\" required><div class=\"hint\">\nhow much quantity come to alert</div><div ng-messages=\"addfoodForm.name.$error\"><div ng-message=\"required\"><span>\nName field is required</span></div></div></md-input-container></div></div></form></md-dialog-content><md-dialog-actions\n layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" \nng-click=\"closeDialog()\">Add Item</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/billing/currentbills/take.away.merge.bill.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-530 h-520 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<div class=\"flex-none\"><h2 class=\"md-title margin-top-0\">Merge Bill</h2><div \nclass=\"layout-row layout-align-space-between-center\"><div \nclass=\"font-size-px-16 text-black-54 font-weight-500 text-italic padding-bottom-5\"><span>Ordered no. {{salesorder_id}}\n</span></div><div \nclass=\"font-size-px-16 text-black-54 font-weight-500 text-italic padding-bottom-5 layout-row layout-align-start-center\">\n<span class=\"flex\">Amount.</span><div class=\"layout-row layout-align-start-center flex padding-left-10\"><span \ntranslate>BILLINGS.INR</span> <span>{{payment_total[0]}}</span></div></div></div><span style=\"float: right\">\n{{sales_dietType}}</span><p class=\"text-black-54 font-size-px-14 margin-y-4\">Please select to merge bill</p></div><div \nclass=\"dataTable-primary padding-top-5 scrollable flex\" ms-scroll><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"TAMergeBillDtOptions\"><thead><tr><th class=\"secondary-text\" \nng-repeat=\"header in TAMergeBillHeaders\"><div class=\"table-header\"><span class=\"column-title\">{{ header.title }}</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"mergeBill in TAMergeBills\"><td><md-checkbox class=\"margin-0\" \nclass=\"layout-row mb-32\" ng-model=\"mergeBill.checked\" ng-checked=\"exists(mergeBill, selected)\" \nng-click=\"updateSelection($index, TAMergeBills, selected,mergeBill);\"></md-checkbox></td><td \nng-class=\"mergeBill.status\" class=\"text-black\">{{ mergeBill.salesorder_id }}</td><td><div \nclass=\"layout-row layout-align-start-center\"><span translate>BILLINGS.INR</span> <span>{{ mergeBill.payment_total }}\n</span></div></td><td><span class=\"text-boxed badge food-badge\" \nng-class=\"{ \'ordered\': \'food-ordered\', \'Ready To Pickup\': \'food-pickup\', \'Ate\': \'food-ate\', \'Bill Printed\': \'food-bill-printed\', \'Pending Payment\': \'food-pending-payment\' }[mergeBill.status]\">\n{{ mergeBill.status }}</span></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" ng-click=\"Merge_Bill()\">Merge Bill\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/billing/newbill/newbill.html","<div class=\"layout-column min-height-alter48px bill-color-bg pos-bill\"><form \nclass=\"newbill layout-row flex newbillform\" name=\"newBill\" novalidate layout-xs=\"column\"><div \nclass=\"flex-none pr-icons-tab-container\"><ul class=\"pr-icons-tabs\"><li class=\"pr-icons-tab\" \nng-class=\"{\'active\': prTabName==\'tabBillInfo\'}\" \nng-click=\"prTabName =\'tabBillInfo\';focus();validatecustomer();errormsgBillinfo()\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><div \nng-class=\"{\'error\': (newBill.quantity.$invalid || newBill.deliveryTime.$invalid || newBill.autocompleteFood.$invalid || newBill.tableno.$invalid || newBill.receive.$invalid || newBill.unpaidreason.$invalid) && (newBill.$submitted)}\">\n<md-icon class=\"layout-column mb-4\" md-font-icon=\"icon icon-receipt s20 \"></md-icon><span translate>BILLINGS.BILL\n</span> Info</div></li><li class=\"pr-icons-tab mt-8\" ng-class=\"{ \'active\': prTabName==\'tabCustomerInfo\' }\" \nng-click=\"prTabName=\'tabCustomerInfo\' ;focuscustomer();errormsgBillinfo();errormsgCustomer();customerinfo=true;billinfo=false; showfeedback=false \" \nmd-ink-ripple=\"rgba(0,0,0,0.5) \"><div \nng-class=\"{ \'error\': (newBill.autocompleteCustomer.$invalid) && (newBill.$submitted)} \"><md-icon \nclass=\"layout-column mb-4\" md-font-icon=\"icon icon-account \"></md-icon><span translate>BILLINGS.CUSTOMER</span><md-icon\n class=\"layout-column tick-icon\" \nng-if=\"customer.customer_mobile || customer.customer_name || customer.customer_email || customer.customer_address || customer.customer_city || customer_data\" \nmd-font-icon=\"icon icon-check-circle s16 \"></md-icon></div></li><li class=\"pr-icons-tab mt-8 hidebelow600\" \nng-class=\"{ \'active\': prTabName==\'tabFeedback\' }\" ng-click=\"prTabName=\'tabFeedback\' ;focusfeedback();feedbacks(); \" \nmd-ink-ripple=\"rgba(0,0,0,0.5) \"><md-icon class=\"layout-column mb-4\" md-font-icon=\"icon icon-comment-text-outline \">\n</md-icon><span translate>BILLINGS.FEEDBACK</span><md-icon class=\"layout-column tick-icon\" \nng-if=\"feedback.feedback_service || feedback.feedback_staff || feedback.feedback_food || feedback.feedback_money \" \nmd-font-icon=\"icon icon-check-circle s16 \"></md-icon></li><li class=\"pr-icons-tab mt-8 hideabove600\" \nng-class=\"{\'active\': prTabName==\'tabPayment\'}\" ng-click=\"prTabName =\'tabPayment\';paymenttab();\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newBill.deliveryTime.$invalid || newBill.receive.$invalid || newBill.unpaidreason.$invalid) && (newBill.$submitted)} \">\n<span translate>BILLINGS.PAYMENT</span></span></li></ul></div><div class=\"pr-icons-tab-contents bill-inner-color-bg\" \nng-class=\"{\'noteditable\': vm.no_edit_bill}\"><div ng-if=\"vm.no_edit_bill\" class=\"err_message mb-10\" \nstyle=\"margin:20px 20px 0\">This bill cannot be edit. Because applied customer points discount in amount.</div><div \nclass=\"pr-icons-tab-content layout-fill\" ng-show=\"billinfo\"><div class=\"layout-column layout-fill\" \nstyle=\"position: relative\" ng-include=\"\'app/main/cashier/billing/newbill/billinfo/billinfo.html\'\"></div></div><div \nclass=\"pr-icons-tab-content\" ng-show=\"customerinfo\"><div \nng-include=\"\'app/main/cashier/billing/newbill/customer/customer.info.html\'\"></div></div><div \nclass=\"pr-icons-tab-content\" ng-show=\"showfeedback\"><div \nng-include=\"\'app/main/cashier/billing/newbill/feedback/feedback.html\'\"></div></div><div \nclass=\"showabove600 pr-icons-tab-content newbill-payment-container\" ng-show=\"showpayment\"><div \nng-include=\"\'app/main/cashier/billing/newbill/payment/payment.html\'\"></div></div></div><section \nclass=\"flex-none right-box layout-column hidebelow959\"><div id=\"bod\"><div id=\"content1\" class=\"flex\"><div \nclass=\"layout-column flex min-height-100 bill-no\"><div class=\"text-align-right color-white ph-24\"><span \nclass=\"order layout-column\" ng-if=\"params.id\">{{ \'BILLINGS.ORDERED\' | translate}} No. {{params.id}}</span><div \nclass=\"tl-amount layout-column\"><div class=\"layout-row text-align-right\" style=\"margin: 0 0 0 auto\"><span translate \nclass=\"pt-8 pr-4\">BILLINGS.INR</span><span class=\"font-size-px-48\" style=\"line-height: 48px\">\n{{ vm.billing.roundtotal }}</span></div></div><span class=\"sub-text layout-column opa-40\">\n{{\'BILLINGS.Total Amount\' | translate}}</span></div><hr><div \nng-if=\"vm.billing.dietType==vm.dietType[2].value || vm.billing.dietType==vm.dietType[1].value\" \nclass=\"small delivery-time\"><div class=\"no-error ph-24\"><div \nclass=\"layout-column mt-16 mb-16 font-size-px-13 color-white opa-54\">DELIVERY TIME</div><div \nclass=\"layout-row layout-align-start-start mt-8\" md-theme=\"darkTheme\"><md-input-container class=\"margin-right-10\" \nmd-no-float flex=\"52\"><md-select ng-model=\"vm.billing.deliveryTime\" placeholder=\"Delivery Time\" class=\"md-accent\" \nname=\"deliveryTime\" \nng-required=\"vm.billing.dietType==vm.dietType[2].value || vm.billing.dietType==vm.dietType[1].value\"><md-option \nvalue=\"Immediate\">Immediate</md-option><md-option value=\"Schedule\">Schedule</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"layout-row layout-align-start-start mt-8\" \nmd-theme=\"darkTheme\" ng-if=\"vm.billing.deliveryTime==\'Schedule\'\"><div flex=\"40\" class=\"hide-date-picker-icon\">\n<md-input-container class=\"margin-right-16 md-block\"><md-datepicker name=\"eventDate\" \nng-model=\"vm.billing.sales_deliveryDate\" md-min-date=\"minDate\" md-max-date=\"maxDate\" class=\"md-accent\" \nmd-current-view=\"day\" md-placeholder=\"Enter date\" ng-required=\"true\"></md-datepicker><div class=\"md-errors-spacer\">\n</div></md-input-container></div><div flex=\"55\" class=\"ml-16\"><label class=\"time-picker font-size-px-12 color-white\">\nEnter Time</label><mdp-time-picker name=\"deliveryTime\" mdp-auto-switch=\"true\" ng-model=\"vm.billing.enterTime\" \nclass=\"flex no-time-icon\" required></mdp-time-picker></div></div></div><hr></div><div md-theme=\"darkTheme\" \nclass=\"small layout-column flex ms-scroll\"><div class=\"layout-row mt-8 font-size-px-13 color-white opa-70 ph-24\"><div \nclass=\"flex\" style=\"text-transform: uppercase\">{{\'BILLINGS.PAYMENT\' | translate}}</div><div \nclass=\"layout-column layout-align-end-center\" ng-if=\"vm.settings.show_fullyPaid_dropdown\"><md-input-container \nclass=\"md-block\" style=\"margin-top:-10px\"><md-select ng-model=\"vm.payment.payment_status\" aria-label=\"today\" \nng-change=\"disble_paymentmode()\" class=\"md-accent\" ng-required=\"vm.payment.payment_mode\"><md-option \nng-repeat=\"payment in vm.paymentTypes\" value=\"{{payment.value}}\">{{payment.name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"mb-8 mt-8 layout-column ph-24\"><div \nng-show=\"vm.payment.payment_status==\'unpaid\'\" class=\"layout-column mt-16\"><md-input-container \nclass=\"md-block md-accent\" flex=\"65\"><label>{{\'BILLINGS.REASON\' | translate}}</label><md-select \nng-model=\"vm.payment.unpaid_reason \" name=\"unpaidreason\" class=\"md-accent\" \nng-required=\"vm.payment.payment_status==\'unpaid\'\"><md-option value=\"complementary\">Complementary</md-option><md-option \nvalue=\"miscellaneous\">Miscellaneous</md-option><md-option value=\"guest\">InHouse Guest</md-option><md-option \nvalue=\"other\">Others</md-option></md-select></md-input-container></div><div style=\"display: none\"><md-radio-group \nclass=\"layout-row margin-bottom-16 margin-top-10\" id=\"radio-focuspay\" ng-init=\"vm.paymentstatus=\'paid\'\" \nng-model=\"vm.paymentstatus\"><md-radio-button ng-repeat=\"mode in vm.paymentstate\" value=\"{{mode.value}}\" \nclass=\"md-accent\">{{mode.name}}</md-radio-button></md-radio-group></div><div \nng-hide=\"vm.payment.payment_status==\'unpaid\'\"><md-radio-group class=\"layout-row margin-bottom-24 margin-top-10\" \nng-model=\"vm.payment.payment_mode\" ng-click=\"disble_unpaid_data()\" ng-hide=\"OpenPermission1\" \nng-required=\"vm.payment.payment_status==\'advance\'\" ng-change=\"changedata()\"><md-radio-button \nng-repeat=\"mode in vm.paymentmodelist\" value=\"{{mode.value}}\" class=\"md-accent\" ng-click=\"clear_card()\">{{mode.name}}\n</md-radio-button></md-radio-group></div><div class=\"layout-row layout-align-start-start mt-8\" \nng-if=\"vm.payment.payment_mode==\'cash & card\'\"><div flex=\"50\" class=\"mr-10\"><md-input-container \nclass=\"md-block mr-8 md-accent\"><label>Received <span translate>BILLINGS.CASH</span></label><input type=\"number\" \nname=\"receive\" ng-model=\"vm.payment.payment_received\" max=\"{{ vm.billing.roundtotal }}\" \nng-required=\"vm.payment.payment_mode==\'cash & card\'\"><div ng-messages=\"newBill.receive.$error\" role=\"alert\" \nng-if=\"newBill.receive.$dirty\"><div ng-message=\"max\">Enter lesser than total</div></div></md-input-container></div><div\n flex=\"50\" layout=\"column\" class=\"color-white opa-70 font-size-px-13 layout-align-start-start transfer-cash\" \nng-if=\"vm.payment.payment_transferred\"><div>Transfer <span translate>BILLINGS.CASH</span></div><div><span translate \nclass=\"pr-2\">BILLINGS.INR</span> {{ vm.payment.payment_transferred }}</div></div></div><div layout=\"row\" \nng-if=\"(vm.payment.payment_mode==\'cash\' || vm.payment.payment_mode==\'card\')&&vm.payment.payment_status!=\'paid\'\"><div \nflex=\"50\" class=\"mr-10\"><md-input-container class=\"md-block md-accent mt-8\"><label>Received <span translate>\nBILLINGS.CASH</span></label><input type=\"number\" name=\"receive\" ng-model=\"vm.payment.payment_received\" \nmax=\"{{ vm.billing.roundtotal }}\" ng-required=\"vm.payment.payment_status==\'advance\'\"></md-input-container></div><div \nflex=\"50\" layout=\"column\" class=\"color-white opa-70 font-size-px-13 layout-align-start-start transfer-cash\" \nng-if=\"vm.payment.payment_transferred\"><div>Balance <span translate>BILLINGS.CASH</span></div><div><span translate \nclass=\"pr-2\">BILLINGS.INR</span> {{ vm.payment.payment_transferred }}</div></div></div><div layout=\"row\"><div \nflex=\"75\"><md-input-container ng-if=\"vm.payment.payment_mode==\'card\' || vm.payment.payment_mode==\'cash & card\'\" \nclass=\"md-block md-accent\"><md-select placeholder=\" Select Type\" ng-model=\"vm.payment.online_type\" \nng-required=\"vm.payment.payment_mode==\'card\' || vm.payment.payment_mode==\'cash & card\'\"><md-option \nng-repeat=\"payment in vm.onlineTypes\" value=\"{{payment.values}}\">{{payment.names}}</md-option></md-select>\n</md-input-container></div></div></div><hr><div class=\"manage-by ph-24 no-error\"><div class=\"layout-column mt-24\" \nng-if=\"vm.staffs.length>0\"><md-input-container class=\"margin-right-10 md-block\"><md-select ng-model=\"vm.billing.staff\" \nplaceholder=\" Select {{ \'BILLINGS.ORDER-TAKEN\' | translate}}\" class=\"md-accent\"><md-option \nng-repeat=\"staff in vm.staffs\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></md-input-container>\n</div></div></div></div></div><div id=\"foot\" class=\"footer_control\"><div \nclass=\"text-align-left color-white receiveContainer\" md-theme=\"darkTheme\" \nng-show=\"vm.settings.balance_cash && vm.payment.payment_mode==\'cash\'\"><div layout=\"row\"><div flex=\"50\" class=\"col\">\n<span class=\"sub-text layout-column opa-80 mb-2\">Received Cash</span><div layout=\"column\"><md-input-container \nclass=\"md-darkTheme-theme\" md-no-float><input type=\"number\" name=\"receive\" ng-model=\"receivecash\" \nng-keyup=\"balanceCalculation()\" placeholder=\"0.00\"></md-input-container></div></div><div flex=\"50\" \nclass=\"col balancecash\"><span class=\"sub-text layout-column opa-80 mb-2\" style=\"text-align: left\">Balance Cash</span>\n<div class=\"balancetext\">{{ balancecash }}</div></div></div></div><div class=\"layout-row center-end stick-big-button\">\n<div class=\"layout-row center-end flex\" ng-if=\"!params.id \"><md-button \nclass=\"md-raised green1 big layout-row layout-align-center-center\" id=\"print\" aria-label=\"Add & Print\" \nng-click=\"savePrint.submit(\'print\')\"><span class=\"icon icon-printer font-size-24 mr-8\"></span> <span translate>\nGENERAL.PRINT</span></md-button><md-button ng-click=\"save.submit();\" id=\"save\" \nclass=\"md-raised cyan1 big layout-row layout-align-center-center\">Save</md-button><md-button \nclass=\"md-raised cancel big layout-row layout-align-center-center\" ng-click=\"cancel($event)\" id=\"cancel\"><span \ntranslate>Cancel</span></md-button></div><div ng-if=\"params.id\" class=\"layout-row center-end flex\"><md-button \nclass=\"md-raised green1 big layout-row layout-align-center-center\" aria-label=\"Add & Print \" \nng-click=\"updatePrint.update()\" id=\"print\"><span class=\"icon icon-printer font-size-24 mr-8\"></span> <span translate>\nGENERAL.PRINT</span></md-button><md-button ng-click=\"edit.update()\" id=\"save\" \nclass=\"md-raised cyan1 big layout-row layout-align-center-center\">Save</md-button><md-button \nclass=\"md-raised cancel big layout-row layout-align-center-center\" ng-click=\"canceledit($event)\" id=\"cancel\"><span \ntranslate>Cancel</span></md-button></div></div></div></div></section></form><div class=\"current-container\" flex-none \nng-if=\"row_index.length\"><div class=\"flex\" layout=\"row \" layout-align=\"start start \"><div \nclass=\"list-current layout-row\" style=\"width: 12.5%\" \nng-style=\"{background: doc_classes_colors[$index % doc_classes_colors.length]} \" ng-repeat=\"currentbill in row_index \" \nng-click=\"Editdiet(currentbill.salesorder_id,currentbill.customer_id) \"><div class=\"layout-column flex\"><div \nclass=\"layout-row flex\"><span flex class=\"id ml-4\">{{currentbill.salesorder_id}}</span> <span flex \nclass=\"layout-align-end-center text-align-right mr-4 timing text-align-right\" \nng-if=\"vm.billing.dietType==vm.dietType[0].value&&vm.settings.tableno_permission\"><label translate>BILLINGS.TABLE-NO\n</label>{{currentbill.tableitem}}</span></div><div class=\"layout-row flex\"><div flex class=\"price ml-4\"><span \ntranslate>BILLINGS.INR</span>{{currentbill.payment_total}}</div><div flex \nclass=\"timing text-align-right mr-4 layout-align-end-center\" title=\"{{currentbill.showorderdate}}\">\n{{currentbill.ordertime}}</div></div></div></div></div></div><div class=\"bottom_panel md-whiteframe-1dp\" show-xs=\"\" \nhide=\"\"><div class=\"layout-row flex\"><div flex class=\"layout-column\"><div><span translate class=\"pt-8 pr-4\">\nBILLINGS.INR</span><span class=\"totalamount\">{{vm.billing.roundtotal }}</span></div><span>\n{{\'BILLINGS.Total Amount\' | translate}}</span></div><div class=\"layout-align-center-end\"><div \nclass=\"layout-row center-end flex\" ng-if=\"!params.id \"><md-button \nclass=\"md-raised cancel big layout-row layout-align-center-center\" ng-click=\"cancel($event)\" id=\"cancel\"><span \ntranslate>Cancel</span></md-button><md-button \nclass=\"md-raised green1 big md-primary layout-row layout-align-center-center\" id=\"print\" aria-label=\"Add & Print\" \nng-click=\"savePrint.submit(\'print\')\"><span class=\"icon icon-printer font-size-24 mr-8\"></span> <span translate>\nGENERAL.PRINT</span></md-button></div><div ng-if=\"params.id\" class=\"layout-row center-end flex\"><md-button \nclass=\"md-raised cancel big layout-row layout-align-center-center\" ng-click=\"canceledit($event)\" id=\"cancel\"><span \ntranslate>Cancel</span></md-button><md-button \nclass=\"md-raised green1 big md-primary layout-row layout-align-center-center\" aria-label=\"Add & Print \" \nng-click=\"updatePrint.update()\" id=\"print\"><span class=\"icon icon-printer font-size-24 mr-8\"></span> <span translate>\nGENERAL.PRINT</span></md-button></div></div></div></div></div><div id=\"printBills\" style=\"display: none\"><div \nng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" \nng-class=\"{small: (vm.print.print_font_size == \'small\'), medium: (vm.print.print_font_size == \'medium\'), large: (vm.print.print_font_size == \'large\')}\">\n</div></div><div id=\"KOTPrint\" style=\"display: none\"><div \nng-include=\"\'app/main/cashier/billing/print-bill/kotprintbill.html\'\" \nng-class=\"{small: (vm.print.print_font_size == \'small\'), medium: (vm.print.print_font_size == \'medium\'), large: (vm.print.print_font_size == \'large\')}\">\n</div></div><div class=\"layout-column pos-bill mobileview_less_959 p-16\" style=\"display:none\"><form \nclass=\"newbill layout-row flex newbillform\" name=\"{{formname}}\" novalidate><div class=\"no-error small\"><div \nlayout=\"column\" flex><div layout=\"row\" ng-show=\"{{vm.settings.dinein_permission}}\"><md-radio-group \nclass=\"layout-row mb-16 flex radioGroupButton\" id=\"radio-focus\" ng-model=\"vm.billing.dietType\" id=\"myselector\" \nng-keypress=\"select($event)\" tabindex=\"1\"><md-radio-button ng-repeat=\"category in vm.dietType\" \nvalue=\"{{category.value}}\" class=\"md-accent selectored\" ng-click=\"clearThirdparty($event,category.value)\"><span \nclass=\"radioButton\">{{category.label}}</span></md-radio-button></md-radio-group></div><div \nclass=\"layout-column flex-none mr-16\" \nng-if=\"vm.billing.dietType==vm.dietType[0].value&&vm.settings.tableno_permission\"><span class=\"flex-40 pt-8 mb-10\">\n<label class=\"text-black-54 font-size-14\" translate>BILLINGS.TABLE-NO</label><span style=\"color:red\">*</span></span>\n<div class=\"horizontal_scroll horScrollBarMobile\"><md-radio-group class=\"layout-row flex radioGroupButton\" \nng-model=\"vm.billing.tableno\" ng-keypress=\"select($event)\" tabindex=\"2\" ng-required=\"vm.billing.dietType==\'dinein\'\" \nng-change=\"validatecustomer()\"><md-radio-button ng-repeat=\"tableno in vm.tablenos\" value=\"{{tableno.table_id}}\" \nclass=\"md-accent selectored\"><span class=\"radioButton\">{{tableno.table_no}}</span></md-radio-button><div \nng-messages=\"newBill.tableno.$invalid\"><div ng-message=\"required\"></div></div></md-radio-group></div></div><div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"layout-row md-accent layout-align-start-end\" \naria-label=\"Add & Items\" ng-click=\"showPopupMenu()\"><span class=\"layout-row layout-align-center-center\"><i \nclass=\"icon icon-plus font-size-24 mr-4 iconMdaccent\"></i>ADD ITEMS</span></md-button></div><table \nclass=\"dataTable flex track by $index\" navigatable><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" ng-if=\"!vm.print.mrp\">\n{{\'BILLINGS.RATE\' | translate}}</span> <span class=\"column-title\" ng-if=\"vm.print.mrp\">{{\'BILLINGS.MRP\' | translate}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th>\n</tr></thead><tbody><tr ng-if=\"vm.fmitems.length < 1\"><td colspan=\"5\"><div layout=\"column\" \nlayout-align=\"center center\">No items to display</div></td></tr><tr ng-repeat=\"fmitem in vm.fmitems track by $index\" \nclass=\"md-selected\"><td width=\"48%\">\n{{fmitem.sales_items.sales_items ? fmitem.sales_items.sales_items : fmitem.sales_items}}</td><td width=\"28%\"><div \nstyle=\"display: flex; align-items:center\"><button class=\"decreament\" \nng-click=\"fmitem.sales_quantity = fmitem.sales_quantity - 1\" ng-class=\"{\'enabledButton\': fmitem.sales_quantity > 1}\">\n<span class=\"icon icon-minus font-size-24 mr-8\"></span></button> <span \nstyle=\"width:20px; text-align:center; display: inline-block\">{{fmitem.sales_quantity}}</span> <button \nclass=\"increament\" ng-click=\"fmitem.sales_quantity = fmitem.sales_quantity + 1\"><span \nclass=\"icon icon-plus font-size-24 mr-8\"></span></button></div></td><td width=\"18%\"><span translate class=\"pr-2\">\nBILLINGS.INR</span> {{fmitem.salesitem_rate}}</td><td width=\"2%\"><a ng-if=\"formitem == \'\'\" \nng-click=\"removeRow(fmitem,$event,$index); $event.stopPropagation();\" class=\"removeRow\"><md-icon class=\"text-black-24\" \nmd-font-icon=\"icon icon-trash\"></md-icon></a></td></tr></tbody></table><div class=\"main-total-box\"><div \nclass=\"layout-row layout-align-start-center\"><div flex class=\"font-size-px-13 ml-8 grey-col-sec-text\" layout=\"row\">\n<span ng-if=\"hideRate.value==\'exclude\'&&!vm.settings.global_tax\">Total Rate <span translate class=\"pr-2\">BILLINGS.INR\n</span> <span ng-if=\"!vm.print.mrp\">{{fullexcluderate | number:1}}</span> <span ng-if=\"vm.print.mrp\">\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</span></span><span \nng-if=\"hideRate.value==\'include\'&&!vm.settings.global_tax\">Total Rate <span translate class=\"pr-2\">BILLINGS.INR</span> \n<span ng-if=\"!vm.print.mrp\">{{fullrate | number:1}}</span><span ng-if=\"vm.print.mrp\">\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</span></span><div class=\"ml-8\" \nng-if=\"!vm.settings.global_tax\">Total Tax <span translate class=\"pr-2\">BILLINGS.INR</span>\n {{ vm.billing.tax_cgstInclude + vm.billing.tax_sgstInclude | number:1}}<md-icon \ntitle=\"({{\'BILLINGS.CGST\' | translate}} {{ vm.billing.tax_cgstInclude | number:2}} + {{\'BILLINGS.SGST\' | translate}} {{ vm.billing.tax_sgstInclude | number:2}})\" \nmd-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></div></div><div class=\"tag flex-20\">\n{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-2\" \nng-if=\"(vm.settings.global_tax&&vm.taxs[0].taxRate)||(vm.settings.global_tax&&vm.taxs[1].taxRate)\"><div \nclass=\"tag flex\">{{\'BILLINGS.CGST\' | translate}}<span ng-if=\"vm.settings.global_tax\">({{vm.taxs[0].taxRate}}%)</span>\n + {{\'BILLINGS.SGST\' | translate}}<span ng-if=\"vm.settings.global_tax\">({{vm.taxs[1].taxRate}}%)</span></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ vm.billing.tax + vm.billing.tax_sgst | number:2}}</span>\n</div></div><div class=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" \nng-show=\"points[0].enablepoint==1\"><div class=\"flex\"></div><div flex=\"70\" layout=\"row\" \nng-show=\"points[0].enablepoint==1\" class=\"tag\" layout-align=\"end center\"><span ng-if=\"Openpoint==true\">\n<md-input-container md-no-float class=\"md-accent\" flex=\"30\" ng-show=\"OpenRemainPoints\"><input \nid=\"additional_charge-focus\" aria-label=\"today\" placeholder=\"\" maxlength=\"6\" type=\"number\" class=\"ml-8\" \nng-keypress=\"onlynumber($event);\" name=\"dis\" ng-model=\"vm.userPoints\"></md-input-container><a \nng-click=\"OpenRemainPoints= !OpenRemainPoints; initData(); openRemainpointdiscount();\" class=\"mr-16\">\nEdit Remaining points</a> </span><span \nng-show=\"vm.controlShow && !vm.pointOldCountNotIncrease && !vm.customerpoints.directlyapplypointamount && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0)) && (customer_data.pointsEarned>0 || customer.pointsEarned>0)\">\n<a ng-click=\"clearpointvalue(); initData();\" class=\"mr-16\">Clear old points</a></span> <span \nng-show=\"vm.controlShow && !vm.pointOldCountNotIncrease && !vm.customerpoints.directlyapplypointamount && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0)) && (customer_data.pointsEarned>0 || customer.pointsEarned>0)\">\n<a ng-click=\"applypointamount(); initData();\" class=\"mr-16\">Apply points to amount</a></span> <span class=\"mr-8\" \nng-show=\"points[0].enablepoint==1\" layout=\"row\"><md-icon ng-show=\"vm.clearPointback\" class=\"cursor-pointer mr-8\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" ng-click=\"clearPointback()\"></md-icon><md-icon \nng-show=\"vm.pointOldCountNotIncrease\" class=\"cursor-pointer mr-8\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" ng-click=\"vm.pointOldCountNotIncrease = 0\">\n</md-icon><md-icon \nng-show=\"vm.customerpoints.directlyapplypointamount && !vm.clearPointback && (points[0].enablepoint==1 && total_pointdiscount>0)\" \nclass=\"cursor-pointer mr-8\" md-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" \nng-click=\"Openpoint = !Openpoint;clearIconpointdiscount();dataopen(clearpointdiscount,$event);\"></md-icon>\n{{\'BILLINGS.POINTS-DISCOUNT\' | translate}} <span \nng-show=\"vm.customerpoints.directlyapplypointamount && (points[0].enablepoint==1  && total_pointdiscount>0) && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0) || (customer_data.pointsEarned))\">\n({{customer.pointsEarned ? customer.pointsEarned : customer_data.pointsEarned}})</span><span \nng-show=\"!vm.pointOldCountNotIncrease && !vm.customerpoints.directlyapplypointamount && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0)) && (customer_data.pointsEarned>0 || customer.pointsEarned>0)\">\n({{customer.pointsEarned ? customer.pointsEarned : customer_data.pointsEarned}})</span><span \nng-show=\"vm.pointOldCountNotIncrease\">({{0}})</span></span></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ total_pointdiscount | number:2}}</span></div></div></div>\n</div></div></div></form><div class=\"bottom_panel md-whiteframe-1dp\"><div class=\"layout-row flex\"><div flex \nclass=\"layout-column\"><div><span translate class=\"pt-8 pr-4\">BILLINGS.INR</span><span class=\"totalamount\">\n{{vm.billing.roundtotal }}</span></div><span>{{\'BILLINGS.Total Amount\' | translate}}</span></div><div \nclass=\"layout-align-center-end\"><div class=\"layout-row center-end flex\" ng-if=\"!params.id \"><md-button \nclass=\"md-raised cancel big layout-row layout-align-center-center\" ng-click=\"cancel($event)\" id=\"cancel\"><span \ntranslate>Cancel</span></md-button><md-button \nclass=\"md-raised green1 big md-primary layout-row layout-align-center-center\" id=\"print\" aria-label=\"Add & Print\" \nng-click=\"savePrint.submit(\'print\', \'stewardPrint\')\"><span class=\"icon icon-printer font-size-24 mr-8 hide\"></span> \n<span translate>KOT</span></md-button><md-button \nclass=\"md-raised green1 big md-primary layout-row layout-align-center-center\" id=\"print\" aria-label=\"Add & Print\" \nng-click=\"savePrint.submit(\'print\')\"><span class=\"icon icon-printer font-size-24 mr-8\"></span> <span translate>\nGENERAL.PRINT</span></md-button></div><div ng-if=\"params.id\" class=\"layout-row center-end flex\"><md-button \nclass=\"md-raised cancel big layout-row layout-align-center-center\" ng-click=\"canceledit($event)\" id=\"cancel\"><span \ntranslate>Cancel</span></md-button><md-button \nclass=\"md-raised green1 big md-primary layout-row layout-align-center-center\" aria-label=\"Add & Print \" \nng-click=\"updatePrint.update(\'updatePrint\')\" id=\"print\"><span class=\"icon icon-printer font-size-24 mr-8 hide\"></span> \n<span translate>SAVE & KOT PRINT</span></md-button></div></div></div></div></div><div class=\"dialogMenuItems\"><div \nclass=\"md-menu-toolbar md-whiteframe-1dp\"><div layout=\"row\" layout-align=\"start center\" class=\"ng-scope layout-row\">\n<div class=\"flex-none layout-row\" layout=\"row\" layout-align=\"start center\"><button class=\"md-icon-button md-button\" \nng-click=\"hidePopupMenu()\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></button></div><div \nclass=\"layout-row flex height48px\" layout-align=\"start center\" flex=\"\"><div class=\"padding-horizontal-16\" \nstyle=\"width:100%\"><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\">\n</md-icon><input class=\"search-input md-accent\" ng-model=\"item_query.filter\" type=\"text\" placeholder=\"Search items\" \nflex><md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" \nng-if=\"item_query.filter\" ng-click=\"clearText()\"></md-icon></div></div></div></div></div><div \nclass=\"menuItem_scroll_data\"><md-table-container><table md-table md-progress=\"promise\" ng-model=\"appitemSelected\">\n<tbody md-body><tr ng-repeat=\"item in vm.food | filter: item_query.filter\" \nng-class=\"{\'md-selected\': exists(item, appitemSelected)}\" md-select=\"item\" md-select-id=\"name\" md-select=\"dessert\"><td \nmd-cell><md-checkbox ng-checked=\"exists(item, appitemSelected)\" ng-click=\"toggle(item, appitemSelected)\" class=\"ml-8\" \naria-label=\"item select\"></md-checkbox></td><td md-cell width=\"14%\" class=\"item-image-cell\" \nng-if=\"vm.settings.show_sales_item_image\"><img ng-src=\"{{ item.image_url || \'assets/images/empty_image.jpg\' }}\" alt=\"\" \nclass=\"item-image-bill\"></td><td md-cell width=\"31%\">{{item.display}}<br><span class=\"category\">\n{{item.fmcatergoryName}}</span></td><td md-cell class=\"small\" width=\"30%\"><button class=\"decreament\" \nng-click=\"item.sales_quantity = item.sales_quantity - 1\" ng-class=\"{\'enabledButton\': item.sales_quantity > 1}\"><span \nclass=\"icon icon-minus font-size-24 mr-8\"></span></button> <span \nstyle=\"width:20px; text-align:center; display: inline-block\">{{item.sales_quantity}}</span> <button class=\"increament\" \nng-click=\"item.sales_quantity = item.sales_quantity + 1\"><span class=\"icon icon-plus font-size-24 mr-8\"></span>\n</button></td><td md-cell width=\"15%\"><span ng-if=\"!item.offerprice\"><span translate class=\"pr-2\">BILLINGS.INR</span>\n {{item.salesitem_rate}}</span> <span ng-if=\"item.offerprice\"><span translate class=\"pr-2\">BILLINGS.INR</span>\n {{item.offerprice}}</span></td></tr></tbody></table></md-table-container></div><div \nclass=\"bottom_panel md-whiteframe-1dp\"><div class=\"layout-row flex\"><div flex class=\"layout-column\"><div class=\"hide\">\n<span translate class=\"pt-8 pr-4\">BILLINGS.INR</span><span class=\"totalamount\">{{vm.billing.roundtotal}}</span></div>\n<span class=\"hide\">Total Price</span></div><div class=\"layout-align-center-end\"><md-button \nclass=\"md-raised md-primary layout-row layout-align-center-center\" \nng-click=\"selectedMenuItemChange(appitemSelected); hidePopupMenu()\" ng-disabled=\"appitemSelected.length < 1\"><span>\nADD ITEMS <span ng-if=\"appitemSelected.length > 0\">{{appitemSelected.length}}</span></span></md-button></div></div>\n</div></div>");
$templateCache.put("app/main/cashier/billing/paidbills/paidbills.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-md small hide-date-picker-icon\" layout=\"row\"><a class=\"calendar-switch\" \nng-click=\"OpenDayWises();changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nng-show=\"OpenMonthWise\"><md-tooltip md-direction=\"top\">Change to date wise filter</md-tooltip></a><a \nclass=\"calendar-switch\" \nng-click=\"OpenMonthWises();changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nng-show=\"OpenDayWise\"><md-tooltip md-direction=\"top\">Change to month wise filter</md-tooltip></a><md-input-container \nclass=\"md-block md-accent\"><md-datepicker ng-model=\"myDate\" aria-label=\"today\" ng-show=\"OpenDayWise\" \nmd-placeholder=\"Enter date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block md-accent\"><md-datepicker \nng-model=\"monthyear\" aria-label=\"today\" ng-show=\"OpenMonthWise\" md-max-date=\"maxDate\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nng-required=\"dateFields[2].required\" md-date-locale=\"dateFields[2].locale\" md-mode=\"{{dateFields[2].mode}}\" \nmd-open-on-focus=\"true\"></md-datepicker></md-input-container></div><div class=\"ph-8 filter-dropdown-sm hidebelow959\" \nng-show=\"vm.settings.diettype_filter\"><md-select ng-model=\"diet\" aria-label=\"today\" \nng-init=\"diet=vm.dietType[0].value\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"diet in vm.dietType\" value=\"{{diet.value}}\">{{diet.label}}\n</md-option></md-select></div><div class=\"ph-8 filter-dropdown-sm hidebelow959\" \nng-show=\"vm.settings.dealertype_filter && vm.settings.dealer\"><md-select ng-model=\"dealer\" aria-label=\"today\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option value=\"all\" ng-init=\"dealer=\'all\'\">All Customer Type</md-option><md-option \nng-repeat=\"dealerList in vm.dealerLists\" value=\"{{dealerList.value}}\">{{dealerList.label}}</md-option></md-select>\n</div><div class=\"ph-8 filter-dropdown-sm hidebelow959\"><md-select ng-model=\"payment\" aria-label=\"today\" \nng-init=\"payment=vm.paymentmodelist[0].value\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"payment in  vm.paymentmodelist\" value=\"{{payment.value}}\">\n{{payment.name}}</md-option></md-select></div><div ng-show=\"permission\" ng-hide=\"!permission\" \nclass=\"ph-8 filter-dropdown-sm hidebelow959\"><md-select ng-model=\"staffss\" aria-label=\"today\" \nng-init=\"staffss=vm.staffRole[0].staffID\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}\n</md-option></md-select></div><div ng-if=\"vm.paidbill.length>0\" class=\"layout-align-start-start ph-12\"><a \nexport-to-csv class=\"download-csv hidebelow959\" ng-show=\"OpenDayWise\"><md-tooltip md-direction=\"top\">Export data to CSV\n</md-tooltip></a><table style=\"display: none\" ng-show=\"OpenDayWise\"><tr><th>Ordered No</th><th>Total Amount</th><th>\nCash received</th><th>Online transferred</th><th>CGST</th><th>SGST</th><th>Additonal Charge</th><th>Discount</th><th>\nPayment Type</th><th ng-if=\"vm.settings.dealer\">Membership</th><th>Ordered Time</th><th>Sales Man</th><th>Created By\n</th><th>Delivered Time</th></tr><tr ng-repeat=\"paidbill in vm.paidbill\"><td>{{paidbill.salesorder_id}}</td><td>\n{{paidbill.payment_total}}</td><td>{{paidbill.cashpay}}</td><td>{{paidbill.onlinepay}}</td><td>{{paidbill.tax_rate}}\n</td><td>{{paidbill.tax_sgst}}</td><td>{{paidbill.additional_charge}}</td><td>{{paidbill.discount}}</td><td>\n{{paidbill.payment_mode}}</td><td ng-if=\"vm.settings.dealer\">{{paidbill.dealer_status}}</td><td>{{paidbill.ordertime}}\n</td><td>{{paidbill.manageBy}}</td><td>{{paidbill_staffnames(paidbill)}}</td><td>\n{{paidbill.sales_deliveryTime | date }}</td></tr></table><a export-to-csv class=\"download-csv\" ng-show=\"OpenMonthWise\" \nng-if=\"!payment\"><md-tooltip md-direction=\"top\">Export data to CSV</md-tooltip></a><table ng-show=\"OpenMonthWise\" \nng-if=\"!payment\" style=\"display: none\"><tr><th>Date</th><th>Total Amount</th></tr><tr \nng-repeat=\"perdaytotalData in vm.perdaytotalDatas | orderBy:\'$index\':true\"><td>{{perdaytotalData.date}}</td><td>\n{{perdaytotalData.total_amount}}</td></tr><tr><td>Total Amount</td><td>\n{{takeaway_amount+doordelivery_amount+dinein_amount}}</td></tr><tr><td></td><td></td></tr><tr><td>Total Tax</td><td>\n{{tax_sgst+tax_cgst}}</td></tr><tr><td>Total CGST</td><td>{{tax_cgst}}</td></tr><tr><td>Total SGST</td><td>{{tax_sgst}}\n</td></tr></table></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"doordelivery_query.filter\" \ntype=\"text\" placeholder=\"Search ordered no or amount\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"doordelivery_query.filter\" ng-click=\"clearText()\"></md-icon>\n</div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"doordelivery_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column>\n{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th md-column \nng-if=\"vm.settings.diettype_filter&&vm.settings.tableno_permission\">{{ \'BILLINGS.TYPE\' | translate}}</th><th md-column>\n{{ \'BILLINGS.AMOUNT\' | translate}}</th><th md-column class=\"hidebelow959\">{{ \'BILLINGS.ORDERED-TIME\' | translate}}</th>\n<th md-column class=\"hidebelow959\">{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th><th md-column class=\"hidebelow959\">\n{{ \'BILLINGS.ORDER-TAKEN\' | translate}}</th><th md-column ng-if=\"permission!=admin\" class=\"hidebelow959\">\n{{ \'BILLINGS.CREATED-BY\' | translate}}</th><th md-column><span>{{ \'BILLINGS.ACTIONS\' | translate}}</span></th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in vm.paidbill | limitTo: doordelivery_query.limit: (doordelivery_query.page - 1) * doordelivery_query.limit | filter: doordelivery_query.filter | orderBy: doordelivery_query.order\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.salesorder_id}}</td><td md-cell \nng-if=\"vm.settings.diettype_filter&&vm.settings.tableno_permission\">{{ paidbill.sales_dietType }} <span \nstyle=\"font-size:11px\" ng-if=\"paidbill.thirdparty_id\">({{ paidbill.thirdparty_name }})</span></td><td md-cell><span \ntranslate>BILLINGS.INR</span> <span>{{ paidbill.payment_total }}</span> <span class=\"flex-none adv-amount\" \nng-if=\"paidbill.payment_mode!=\'cash & card\'\">{{paidbill.payment_mode==\'card\' ? \'online\' : paidbill.payment_mode}}\n</span> <span class=\"flex-none adv-amount\" ng-if=\"paidbill.payment_mode==\'cash & card\'\">cash <span translate>\nBILLINGS.INR</span> {{paidbill.payment_received}} & online <span translate>BILLINGS.INR</span>\n {{paidbill.payment_transferred}}</span></td><td md-cell title=\"{{ paidbill.showorderdate }}\" class=\"hidebelow959\">\n{{ paidbill.ordertime }}<md-icon \ntitle=\"Last updated by  {{ update_staff(paidbill)}} ,on {{ paidbill.last_modified | date:\'medium\'}}\" class=\"rate-edit\" \nmd-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \ntitle=\"{{paidbill.showdeliverdate | date:\'medium\'}}\" class=\"hidebelow959\"><div class=\"layout-row\">\n{{ paidbill.sales_deliveryTime | date }}<div id=\"demo\" class=\"ml-8 remaining-timer\" \nng-if=\"paidbill.sales_deliveryTime != \'Immediate\'\"><span class=\"flex-none\">- {{paidbill.remainingtime}}</span></div>\n</div></td><td md-cell class=\"hidebelow959\">{{ paidbill.manageBy }}</td><td md-cell ng-if=\"permission!=admin\" \nclass=\"hidebelow959\">{{ paidbill_staffnames(paidbill) }}</td><td md-cell><md-button aria-label=\"Printcard\" \nng-click=\"printToCart(paidbill);$event.stopPropagation();\" class=\"md-icon-button\" \nng-if=\"stewardPermission != \'steward\'\"><md-icon md-menu-origin md-font-icon=\"text-black-40 icon-printer\"></md-icon>\n</md-button><md-menu ng-if=\"admin.length || saleseditt.length\"><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"Editpos(paidbill.salesorder_id,paidbill.customer_id)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\">\n</md-icon>View & Edit</md-button></md-menu-item><md-menu-item ng-if=\"admin.length\"><md-button \nng-click=\"removeRow(paidbill,$event,$index)\"><md-icon md-menu-origin md-font-icon=\"icon-trash\"></md-icon>Delete\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.paidbill.length==0\"><h3>\nThere\'re no paid bills for you to see.</h3></div></md-table-container><md-table-pagination \nmd-limit=\"doordelivery_query.limit\" md-limit-options=\"[5,10,15]\" md-page=\"doordelivery_query.page\" \nmd-total=\"{{paidbill_count}}\" md-page-select></md-table-pagination></div></div><div \nclass=\"paid-fix md-accent-bg hidebelow959\" ng-if=\"vm.paidbill.length>0\"><div layout=\"row\" layout-align=\"start start\">\n<div flex-none class=\"paid-each-container\"><span class=\"title\">{{\'BILLINGS.Total Amount\' | translate}} <span \nng-if=\"payment\">of {{payment==\'card\' ? \'online\' : payment}}</span></span> <span class=\"inr\" translate>BILLINGS.INR\n</span> <span class=\"amount\" ng-if=\"!payment\">{{takeaway_amount+doordelivery_amount+dinein_amount}}</span> <span \nclass=\"amount\" ng-if=\"payment==\'cash\'\">{{takeaway_amount+doordelivery_amount+dinein_amount- payment_transferred}}\n</span> <span class=\"amount\" ng-if=\"payment==\'card\'\">\n{{takeaway_amount+doordelivery_amount+dinein_amount- payment_received}}</span> <span title=\"ordered\" class=\"ordered\">\n<img src=\"assets/icons/order-icon.svg\"> {{takeaway_total+doordelivery_total+dinein_total}}</span></div></div></div>\n</section><md-content style=\"display: none\" class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" ng-controller=\"printbillController as vm\" ms-scroll>\n</md-content>");
$templateCache.put("app/main/cashier/billing/print-bill/kotprintbill.html","<div id=\"KOTPrint\"><div \nng-class=\"{small: (vm.print.print_font_size == \'small\'), medium: (vm.print.print_font_size == \'medium\'), large: (vm.print.print_font_size == \'large\')}\">\n<div id=\"printSection\"><div class=\"bill-info\"><div class=\"left-side\"><span class=\"font-weight-600\">\n{{\'BILLINGS.ORDERED-NO\' | translate}}:</span> {{salesId}}<br><span class=\"font-weight-600\" \nng-if=\"vm.print.print_font_size!=\'large\'\">{{\'ODC.Date\' | translate}}:</span>\n {{fmitems[0].ordertime | date:\'mediumDate\'}} &nbsp; &nbsp;{{fmitems[0].ordertime | date:\'shortTime\'}}<br><span \nclass=\"font-weight-600\">Ordered By:</span> {{vm.staffName}}</div><div class=\"right-side\"><span \nng-if=\"vm.settings.tableno_permission\" style=\"text-transform:capitalize\">{{vm.billing.dietType}}</span><br><span \nng-if=\"vm.settings.tableno_permission&&vm.billing.dietType==\'dinein\'\">Table No: {{vm.billing.tableno}}</span></div>\n</div><table class=\"item-table\"><thead><tr><th class=\"secondary-text\" width=\"80%\" valign=\"middle\"><div \nclass=\"table-header\"><span class=\"column-title ml-8\">{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"20%\" valign=\"middle\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.QTY\' | translate}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"fmitem in vm.fmitems\"><td \nwidth=\"80%\" valign=\"middle\"><span ng-class=\"{\'strike\': fmitem.type==\'deleted\'}\">\n{{fmitem.sales_items.sales_items ? fmitem.sales_items.sales_items : fmitem.sales_items}}</span></td><td width=\"20%\" \nvalign=\"middle\"><span ng-class=\"{\'strike\': fmitem.type==\'deleted\'}\">{{fmitem.sales_quantity}}</span> &nbsp; <strike>\n{{fmitem.old_sales_quantity}}</strike></td></tr></tbody></table></div><style type=\"text/css\">\n@media print {\r\n        body {\r\n          margin: 0;\r\n          padding: 0;\r\n        }\r\n\r\n        #KOTPrint, #KOTPrint * {\r\n          visibility: visible !important;\r\n        }\r\n\r\n        #printBills, #KOTPrint {\r\n          position: absolute;\r\n          left: 0;\r\n          top: 0;\r\n          width: 100%;\r\n        }\r\n      }\r\n            @page {\r\n        size: auto;\r\n        margin: 0mm;\r\n      }\r\n\r\n      body {\r\n        padding: 0;\r\n        margin: 0\r\n      }\r\n      /*\r\n      @font-face {\r\n  font-family: \'Roboto\';\r\n  src: url(\'../assets/font/Roboto/Roboto-Medium.eot\');\r\n  src: url(\'../assets/font/Roboto/Roboto-Medium.eot?#iefix\') format(\'embedded-opentype\'),\r\n      url(\'../assets/font/Roboto/Roboto-Medium.woff2\') format(\'woff2\'),\r\n      url(\'../assets/font/Roboto/Roboto-Medium.woff\') format(\'woff\'),\r\n      url(\'../assets/font/Roboto/Roboto-Medium.ttf\') format(\'truetype\'),\r\n      url(\'../assets/font/Roboto/Roboto-Medium.svg#Roboto-Medium\') format(\'svg\');\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \'Roboto\';\r\n  src: url(\'../../../../../assets/font/Roboto/Roboto-Bold.eot\');\r\n  src: url(\'../../../../../assets/font/Roboto/Roboto-Bold.eot?#iefix\') format(\'embedded-opentype\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Bold.woff2\') format(\'woff2\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Bold.woff\') format(\'woff\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Bold.ttf\') format(\'truetype\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Bold.svg#Roboto-Bold\') format(\'svg\');\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \'Roboto\';\r\n  src: url(\'../../../../../assets/font/Roboto/Roboto-Regular.eot\');\r\n  src: url(\'../../../../../assets/font/Roboto/Roboto-Regular.eot?#iefix\') format(\'embedded-opentype\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Regular.woff2\') format(\'woff2\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Regular.woff\') format(\'woff\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Regular.ttf\') format(\'truetype\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Regular.svg#Roboto-Regular\') format(\'svg\');\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \'Roboto\';\r\n  src: url(\'../../../../../assets/font/Roboto/Roboto-Light.eot\');\r\n  src: url(\'../../../../../assets/font/Roboto/Roboto-Light.eot?#iefix\') format(\'embedded-opentype\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Light.woff2\') format(\'woff2\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Light.woff\') format(\'woff\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Light.ttf\') format(\'truetype\'),\r\n      url(\'../../../../../assets/font/Roboto/Roboto-Light.svg#Roboto-Light\') format(\'svg\');\r\n  font-weight: 300;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: \'Anonymous Pro\';\r\n  src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.eot\');\r\n  src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.eot?#iefix\') format(\'embedded-opentype\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.woff2\') format(\'woff2\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.woff\') format(\'woff\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.ttf\') format(\'truetype\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.svg#AnonymousPro\') format(\'svg\');\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \'Anonymous Pro\';\r\n  src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.eot\');\r\n  src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.eot?#iefix\') format(\'embedded-opentype\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.woff2\') format(\'woff2\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.woff\') format(\'woff\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.ttf\') format(\'truetype\'),\r\n      url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.svg#AnonymousPro-Bold\') format(\'svg\');\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n*/\r\n      #KOTPrint {\r\n        width: 100%;\r\n        display: inline-block;\r\n        margin: 0;\r\n        padding: 0\r\n      }\r\n\r\n      #printSection {\r\n        width: 96%;\r\n        color: #000;\r\n        letter-spacing: -0.8px;\r\n        font-family: \'Anonymous Pro\';\r\n        margin: 0 auto;\r\n        box-sizing: border-box;\r\n        word-spacing: -5px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .small #printSection {\r\n        font-size: 12px;\r\n      }\r\n\r\n      .medium #printSection {\r\n        font-size: 14px;\r\n      }\r\n\r\n      .large #printSection {\r\n        font-size: 16px;\r\n      }\r\n\r\n      #printSection .uppercase {\r\n        text-transform: uppercase;\r\n      }\r\n\r\n      #printSection .mt-4 {\r\n        margin-top: 4px;\r\n      }\r\n\r\n      #printSection .mb-4 {\r\n        margin-bottom: 4px;\r\n      }\r\n\r\n      #printSection .mb-8 {\r\n        margin-bottom: 8px;\r\n      }\r\n\r\n      #printSection .mb-12 {\r\n        margin-bottom: 12px;\r\n      }\r\n\r\n      #printSection .ml-12 {\r\n        margin-left: 12px;\r\n      }\r\n\r\n      #printSection .text-center {\r\n        text-align: center;\r\n      }\r\n\r\n      #printSection .text-right {\r\n        text-align: right;\r\n      }\r\n\r\n      #printSection .bill-info {\r\n        margin: 12px 0 10px;\r\n        font-weight: bold;\r\n        width: 100%;\r\n        display: inline-block;\r\n      }\r\n\r\n      #printSection .left-side {\r\n        width: 65%;\r\n        float: left;\r\n      }\r\n\r\n      .large #printSection .left-side {\r\n        width: 60% !important;\r\n        ;\r\n      }\r\n\r\n      #printSection .bill-info .right-side {\r\n        width: 35%;\r\n        display: inline-block;\r\n        text-align: right\r\n      }\r\n\r\n      .large #printSection .bill-info .right-side {\r\n        width: 40% !important;\r\n      }\r\n\r\n      #printSection .item-table {\r\n        width: 100%;\r\n        color: #000;\r\n      }\r\n\r\n      #printSection th {\r\n        text-align: left;\r\n        text-transform: uppercase;\r\n      }\r\n\r\n      .small #printSection th {\r\n        border-top: 1px solid #000;\r\n        border-bottom: 1px solid #000;\r\n        padding: 2px 3px;\r\n        font-size: 12px;\r\n      }\r\n\r\n      .medium #printSection th {\r\n        border-top: 1px solid #000;\r\n        border-bottom: 1px solid #000;\r\n        padding: 4px 4px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      .large #printSection th {\r\n        border-top: 1px solid #000;\r\n        border-bottom: 1px solid #000;\r\n        padding: 5px 4px;\r\n        font-size: 16px;\r\n      }\r\n\r\n      #printSection .total-saving {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .small #printSection .total-saving {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .medium #printSection .total-saving {\r\n        font-size: 22px;\r\n      }\r\n\r\n      .large #printSection .total-saving {\r\n        font-size: 24px;\r\n      }\r\n\r\n      #printSection .next-earned {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        margin: 8px 0 0;\r\n        letter-spacing: 0.5px;\r\n      }\r\n\r\n      .small #printSection .next-earned {\r\n        font-size: 12px;\r\n      }\r\n\r\n      .medium #printSection .next-earned {\r\n        font-size: 14px;\r\n      }\r\n\r\n      .large #printSection .next-earned {\r\n        font-size: 16px;\r\n      }\r\n\r\n\r\n      #printSection .footer-text {\r\n        margin-top: 12px;\r\n        margin-bottom: 6px;\r\n      }\r\n\r\n      #printSection td {\r\n        font-weight: 700;\r\n      }\r\n\r\n      .small #printSection td {\r\n        padding: 2px 3px;\r\n        font-size: 12px;\r\n      }\r\n\r\n      .medium #printSection td {\r\n        padding: 3px 4px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      .large #printSection td {\r\n        padding: 4px 4px;\r\n        font-size: 16px;\r\n      }\r\n\r\n      #printSection .item-table tr.no-padd td {\r\n        padding: 1px 0;\r\n      }\r\n\r\n      #printSection .right {\r\n        text-align: right;\r\n      }\r\n\r\n      #printSection .border-top {\r\n        border-top: 1px solid #000;\r\n        margin-top: 2px;\r\n      }\r\n\r\n      .small #printSection .border-top {\r\n        border-top: 1px solid #000;\r\n      }\r\n\r\n      .large #printSection .border-top {\r\n        border-top: 1px solid #000;\r\n      }\r\n\r\n      #printSection .border-bottom {\r\n        border-bottom: 1px solid #000;\r\n        margin-bottom: 2px;\r\n      }\r\n\r\n      .small #printSection .border-bottom {\r\n        border-bottom: 1px solid #000;\r\n      }\r\n\r\n      .large #printSection .border-bottom {\r\n        border-bottom: 1px solid #000;\r\n      }\r\n\r\n      #printSection .print-logo {\r\n        margin: 0 auto;\r\n        width: 186px;\r\n        height: 56px;\r\n      }\r\n\r\n      .small #printSection strike {\r\n        font-size: 12px\r\n      }\r\n\r\n      .medium #printSection strike,\r\n      .large #printSection strike {\r\n        font-size: 13px\r\n      }\r\n      .strike {\r\n        text-decoration: line-through;\r\n      }\r\n      #printSection .main-total-box {\r\n        padding: 10px 2px 12px;\r\n      }\r\n\r\n      .main-total-box .layout-row {\r\n        margin-bottom: 2px\r\n      }\r\n\r\n      #printSection .main-total-box .tag {\r\n        padding-right: 5%;\r\n        text-align: right;\r\n        width: 75%;\r\n        float: left;\r\n        text-transform: uppercase;\r\n      }\r\n\r\n      .small #printSection .main-total-box .tag {\r\n        font-size: 12px;\r\n      }\r\n\r\n      .medium #printSection .main-total-box .tag {\r\n        font-size: 14px;\r\n      }\r\n\r\n      .large #printSection .main-total-box .tag {\r\n        font-size: 16px;\r\n      }\r\n\r\n      #printSection .main-total-box .value {\r\n        text-align: right;\r\n        width: 20%;\r\n        display: inline-block;\r\n      }\r\n\r\n      .small #printSection .main-total-box .footer .tag {\r\n        font-size: 18px;\r\n      }\r\n\r\n      .medium #printSection .main-total-box .footer .tag {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .large #printSection .main-total-box .footer .tag {\r\n        font-size: 20px;\r\n      }\r\n\r\n      #printSection .total {\r\n        font-weight: 700;\r\n        line-height: 24px;\r\n      }\r\n\r\n      .small #printSection .total {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .medium #printSection .total {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .large #printSection .total {\r\n        font-size: 20px;\r\n      }\r\n\r\n      #printSection .total-rate-container {\r\n        text-transform: uppercase;\r\n        border-bottom: 1px solid #000;\r\n        padding-bottom: 4px !important;\r\n      }\r\n\r\n      #printSection .customer-details {\r\n        padding: 6px 0;\r\n        border-top: 1px solid #000;\r\n        border-bottom: 1px solid #000;\r\n      }\r\n\r\n      #printSection .main-total-box .total-rate-container .tag {\r\n        text-align: left !important;\r\n      }\n</style></div></div>");
$templateCache.put("app/main/cashier/billing/print-bill/printbill.html","<div id=\"printBill\"><div \nng-class=\"{small: (vm.print.print_font_size == \'small\'), medium: (vm.print.print_font_size == \'medium\'), large: (vm.print.print_font_size == \'large\')}\">\n<div id=\"printSection\" ng-if=\"vm.settings.global_tax\"><div class=\"text-center\"><img alt=\"Logo\" \nclass=\"print-logo text-center\" ng-src=\"{{logoUrl}}\" \nng-class=\"{rect: (vm.print.logoShape == \'rect\'), round: (vm.print.logoShape == \'round\')}\"></div><div \nclass=\"text-center print-address\"><div>{{branchaddress}}.</div><div>PH: &nbsp;{{contact_number}}</div><div \nng-if=\"branchGstNo\">GST NO: &nbsp;{{branchGstNo}}</div></div><div class=\"bill-info\"><div class=\"left-side\"><span \nclass=\"font-weight-600\">{{\'BILLINGS.ORDERED-NO\' | translate}}:</span> {{salesId}}<br><span class=\"font-weight-600\" \nng-if=\"vm.print.print_font_size!=\'large\'\">{{\'ODC.Date\' | translate}}:</span>\n {{fmitems[0].ordertime | date:\'mediumDate\'}} &nbsp; &nbsp;{{fmitems[0].ordertime | date:\'shortTime\'}}<br><span \nclass=\"font-weight-600\">{{\'BILLINGS.PAYMENT\' | translate}}:</span> <span class=\"camelcase\">{{vm.payment.payment_mode}}\n</span></div><div class=\"right-side\" ng-if=\"vm.billing.dietType==\'dinein\'\"><br><span \nng-if=\"vm.settings.tableno_permission\">{{\'BILLINGS.TABLE-NO\' | translate}}: {{vm.billing.tableno}}</span></div></div>\n<table class=\"item-table\"><thead><tr><th class=\"secondary-text\" width=\"47%\" valign=\"middle\"><div class=\"table-header\">\n<span class=\"column-title ml-8 camelcase\">{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" \nwidth=\"8%\" valign=\"middle\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span>\n</div></th><th class=\"secondary-text\" width=\"23%\" valign=\"middle\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"23%\" valign=\"middle\"><div \nclass=\"table-header right\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"fmitem in vm.fmitems\"><td valign=\"middle\" class=\"items_name\">\n{{fmitem.sales_items.sales_items ? fmitem.sales_items.sales_items : fmitem.sales_items}}</td><td valign=\"middle\">\n{{fmitem.sales_quantity}}</td><td valign=\"middle\">{{fmitem.salesitem_rate}}.00 <strike ng-if=\"fmitem.offerprice\">\n&nbsp; {{fmitem.actualprice}}</strike></td><td class=\"right\" valign=\"middle\">\n{{fmitem.sales_quantity * fmitem.salesitem_rate}}.00</td></tr></tbody></table><div \nclass=\"main-total-box border-top mb-0 mt-0\"><div class=\"layout-row layout-align-start-start mt-4 total-rate-container\" \nstyle=\"width: 100%\"><div class=\"flex\"><span>TOTAL ITEMS : &nbsp; {{vm.fmitems.length}}</span> &nbsp; &nbsp; &nbsp; \n<span>TOTAL QTY : &nbsp; {{vm.totalqty}}</span><span class=\"ml-12\"></span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag\">{{\'BILLINGS.Sub Total\' | translate}} :</div><div \nclass=\"value layout-row layout-align-end-center\"><span>\n{{vm.billing.subTotal ? vm.billing.subTotal : fmitems.subTotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\" ng-if=\"vm.taxs[0].taxRate\"><div class=\"tag flex\">\n{{\'BILLINGS.CGST\' | translate}}({{vm.taxs[0].taxRate}}%) :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>{{vm.billing.tax | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\" ng-if=\"vm.taxs[1].taxRate\"><div class=\"tag flex\">\n{{\'BILLINGS.SGST\' | translate}}({{vm.taxs[1].taxRate}}%) :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>{{vm.billing.tax_sgst | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"vm.billing.additional_charge\"><div class=\"tag flex\">\nAdditional Charge :</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span>\n{{vm.billing.additional_charge | number:2}}</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" \nng-if=\"vm.billing.discount\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}} <span \nng-if=\"vm.billing.discount_type==\'percent\'\">({{vm.billing.discount}} %)</span> :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>\n{{(vm.billing.discount_type==\'amount\' ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2))}}\n</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"total_pointdiscount\"><div \nclass=\"tag flex\">{{\'BILLINGS.POINTS-DISCOUNT\' | translate}} :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>{{ total_pointdiscount | number:2}}</span></div></div>\n<div class=\"layout-row footer mt-4 text-right\"><span class=\"total uppercase\">{{\'BILLINGS.Total Amount\' | translate}} \n</span><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.billing.roundtotal}}\n</span></div></div><div class=\"total-saving text-center\" ng-if=\"savedamount||vm.billing.discount||total_pointdiscount\">\nTOTAL SAVING : {{savedamount+total_pointdiscount+(vm.billing.discount_type==\'amount\' ? (vm.billing.discount) : (vm.billing.discount_percent)) | number:2}}\n</div><div class=\"next-earned text-center\" \nng-if=\"pointsEarned && points[0].enablepoint==1 && vm.print.show_custom_points\">\nPoints earned to next visit : {{ pointsEarned}}</div><div class=\"text-center\" \nng-if=\"qrcode_status==1 && vm.branchFilterData[0].upiId && vm.branchFilterData[0].upiName\"><img ng-src=\"{{qrcode}}\" \nwidth=\"{{qrcode_width}}\" height=\"{{qrcode_height}}\"></div><div class=\"text-center footer-text\">{{branchfooter}}</div>\n<div class=\"text-center techfooddyAddress\" ng-if=\"vm.print.tf_details\">Powered by TechFooddy Software<br>\nwww.techfooddy.com</div><div \nng-if=\"vm.print.print_customer_details && customer.customer_mobile && (vm.billing.dietType==\'doordelivery\')\" \nclass=\"footer-text customer-details\"><span class=\"mb-4\">CUSTOMER DETAILS</span><br>Name : {{customer.customer_name}}\n<br>Address : {{customer.customer_address}}<br><span ng-if=\"customer.customer_city\">City : {{customer.customer_city}}\n<br></span>Mobile : {{customer.customer_mobile.customer_mobile}}</div><div \nng-if=\"vm.print.print_customer_details && customer_data.customer_mobile && (vm.billing.dietType==\'doordelivery\')\" \nclass=\"footer-text customer-details\"><span class=\"mb-4\">CUSTOMER DETAILS</span><br>\nName : {{customer_data.customer_name}}<br>Address : {{customer_data.customer_address}}<br><span \nng-if=\"customer.customer_city\">City : {{customer_data.customer_city}}<br></span>\nMobile : {{customer_data.customer_mobile.customer_mobile}}</div></div><div id=\"printSection\" \nng-if=\"!vm.settings.global_tax\"><div class=\"text-center\"><img alt=\"Logo\" class=\"print-logo text-center\" \nsrc=\"{{logoUrl}}\" ng-class=\"{rect: (vm.print.logoShape == \'rect\'), round: (vm.print.logoShape == \'round\')}\"></div><div \nclass=\"text-center print-address\">{{branchaddress}} <span>PH: &nbsp;{{contact_number}}</span> <span \nng-if=\"branchGstNo\">GST NO: &nbsp;{{branchGstNo}}</span></div><div class=\"bill-info\"><div class=\"left-side\"><span \nclass=\"font-weight-600\">{{\'BILLINGS.ORDERED-NO\' | translate}}:</span> {{salesId}}<br><span class=\"font-weight-600\" \nng-if=\"vm.print.print_font_size!=\'large\'\">{{\'ODC.Date\' | translate}}:</span>\n {{fmitems[0].ordertime | date:\'mediumDate\'}} &nbsp; &nbsp;{{fmitems[0].ordertime | date:\'shortTime\'}}</div><div \nclass=\"right-side\"><span ng-if=\"settings.tableno_permission\">{{vm.billing.dietType}}<br></span><span \nng-if=\"settings.tableno_permission&&vm.billing.dietType==\'dinein\'\">\n{{\'BILLINGS.TABLE-NO\' | translate}}: {{vm.billing.tableno}}<br></span><div \nng-if=\"vm.payment.payment_status == \'paid\' && vm.print.cashmode\"><span class=\"font-weight-600\">\n{{\'BILLINGS.PAYMENT\' | translate}}:</span> <span class=\"camelcase\">{{vm.payment.payment_mode}}</span></div><div \nng-if=\"vm.activedealer == 1\"><span class=\"camelcase\">{{\'USERS.DEALER\' | translate}}</span></div></div></div><table \nclass=\"item-table\"><thead><tr><th class=\"secondary-text\" width=\"35%\" valign=\"middle\"><div class=\"table-header\"><span \nclass=\"column-title ml-8 camelcase\">{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" \nwidth=\"8%\" valign=\"middle\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span>\n</div></th><th class=\"secondary-text\" width=\"23%\" valign=\"middle\" ng-if=\"!vm.print.mrp\"><div class=\"table-header\"><span\n class=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"12%\" \nvalign=\"middle\" ng-if=\"!vm.print.mrp\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.TAX\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"17%\" valign=\"middle\" \nng-if=\"vm.print.mrp\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.MRP\' | translate}}</span></div>\n</th><th class=\"secondary-text\" width=\"18%\" valign=\"middle\" ng-if=\"vm.print.mrp\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text right\" width=\"23%\" \nvalign=\"middle\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"fmitem in vm.fmitems\"><td width=\"35%\" valign=\"middle\" class=\"items_name\">\n{{fmitem.sales_items.sales_items ? fmitem.sales_items.sales_items : fmitem.sales_items}}</td><td width=\"8%\" \nvalign=\"middle\">{{fmitem.sales_quantity}}</td><td ng-if=\"(hideRate.value==\'include\')  && !vm.print.mrp\" width=\"23%\" \nvalign=\"middle\" class=\"items\">\n{{(fmitem.sales_quantity * fmitem.salesitem_rate)-(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}} &nbsp; &nbsp; \n<strike ng-if=\"fmitem.offerprice\">\n{{(fmitem.sales_quantity * fmitem.actualprice)-(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</strike>\n</td><td ng-if=\"(hideRate.value==\'exclude\') && !vm.print.mrp\" width=\"23%\" valign=\"middle\">\n{{fmitem.salesitem_rate*fmitem.sales_quantity | number:1}} &nbsp; &nbsp; <strike ng-if=\"fmitem.offerprice\">\n{{fmitem.actualprice*fmitem.sales_quantity | number:1}}</strike></td><td \nng-if=\"(hideRate.value==\'include\') && vm.print.mrp\" width=\"17%\" valign=\"middle\">{{fmitem.actualprice | number:1}}</td>\n<td ng-if=\"(hideRate.value==\'exclude\') && vm.print.mrp\" width=\"17%\" valign=\"middle\">\n{{fmitem.salesitem_rate*fmitem.sales_quantity | number:1}}</td><td ng-if=\"(hideRate.value==\'include\') && vm.print.mrp\" \nwidth=\"18%\" valign=\"middle\">{{fmitem.salesitem_rate | number:1}}</td><td width=\"12%\" valign=\"middle\" \nng-if=\"(hideRate.value==\'include\') && !vm.print.mrp && vm.print.total_tax\">\n{{fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem | number:1}}</td><td class=\"right\" ng-if=\"hideRate.value==\'include\'\" \nwidth=\"23%\" valign=\"middle\">{{fmitem.sales_quantity * fmitem.salesitem_rate | number:2}}</td><td class=\"right\" \nng-if=\"hideRate.value==\'exclude\'\" width=\"23%\" valign=\"middle\">\n{{(fmitem.sales_quantity * fmitem.salesitem_rate)+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:2}}</td>\n</tr></tbody></table><div class=\"main-total-box border-top mb-0 mt-0\"><div \nclass=\"layout-row layout-align-start-start mt-4 total-rate-container\" style=\"width: 100%\"><div class=\"flex\"><span \nng-if=\"hideRate.value==\'include\' && !vm.print.mrp && vm.print.total_rate\">\nTOTAL {{\'BILLINGS.RATE\' | translate}} : &nbsp; {{fullrate | number:2}}</span> <span \nng-if=\"hideRate.value==\'include\' && vm.print.mrp && vm.print.total_rate\">\nTOTAL {{\'BILLINGS.RATE\' | translate}} : &nbsp; {{vm.billing.subTotal ? vm.billing.subTotal : fmitems.subTotal | number:2}}\n</span> <span ng-if=\"hideRate.value==\'exclude\' && vm.print.total_rate\">\nTOTAL {{\'BILLINGS.RATE\' | translate}} : &nbsp; {{fullexcluderate | number:2}}</span><span class=\"ml-12\" \nng-if=\"vm.print.total_tax\">TOTAL {{\'BILLINGS.TAX\' | translate}} : &nbsp; {{totalTax | number:2}}</span> <span \nclass=\"ml-12\" ng-if=\"vm.print.total_qty\">TOTAL {{\'BILLINGS.QTY\' | translate}} : &nbsp; {{vm.totalqty}}</span></div>\n</div><div class=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">Subtotal :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span ng-if=\"hideRate.value==\'include\'\">\n{{vm.billing.subTotal ? vm.billing.subTotal : fmitems.subTotal | number:2}}</span> <span \nng-if=\"hideRate.value==\'exclude\'\">{{excludesubTotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\" ng-if=\"vm.billing.additional_charge\"><div class=\"tag flex\">\nAdditional Charge :</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span>\n{{vm.billing.additional_charge | number:2}}</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" \nng-if=\"vm.billing.discount\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}} <span \nng-if=\"vm.billing.discount_type==\'percent\'\">({{vm.billing.discount}} %)</span> :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>\n{{(vm.billing.discount_type==\'amount\' ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2))}}\n</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"total_pointdiscount\"><div \nclass=\"tag flex\">{{\'BILLINGS.POINTS-DISCOUNT\' | translate}} :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>{{ total_pointdiscount | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">Rounded Off:</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span ng-if=\"hideRate.value==\'include\'\">\n{{(vm.billing.roundtotal) - ((vm.billing.subTotal ? vm.billing.subTotal : fmitems.subTotal) + (vm.billing.additional_charge) - (vm.billing.discount_type==\'amount\' ? vm.billing.discount : vm.billing.discount_percent) - total_pointdiscount) | number:2}}\n</span></div></div><div class=\"layout-row footer mt-4 text-right\"><span class=\"total uppercase\">\n{{\'BILLINGS.Total Amount\' | translate}} </span><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span\n class=\"total uppercase\">{{vm.billing.roundtotal}}</span></div></div><div class=\"total-saving text-center\" \nng-if=\"savedamount||vm.billing.discount||total_pointdiscount\">\nTOTAL SAVING : {{savedamount+total_pointdiscount+(vm.billing.discount_type==\'amount\' ? (vm.billing.discount) : (vm.billing.discount_percent)) | number:2}}\n</div><div class=\"next-earned text-center\" \nng-if=\"pointsEarned && points[0].enablepoint==1 && vm.print.show_custom_points\">\nPoints earned to next visit : {{ pointsEarned}}</div><div class=\"text-center\" ng-if=\"qrcode_status==1\"><img \nng-src=\"{{qrcode}}\" width=\"{{qrcode_width}}\" height=\"{{qrcode_height}}\"></div><div class=\"text-center footer-text\">\n{{branchfooter}}</div><div class=\"text-center techfooddyAddress\" ng-if=\"vm.print.tf_details\">\nPowered by TechFooddy Software<br>www.techfooddy.com</div></div></div><style type=\"text/css\">\n/* @page {\r\n    size: auto;\r\n    margin: 0mm;\r\n  }\r\n\r\n  body {\r\n    padding: 0;\r\n    margin: 0\r\n  } */\r\n    @media print {\r\n      body {\r\n        margin: 0;\r\n        padding: 0;\r\n      }\r\n\r\n      #printBills,\r\n      #KOTPrint {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n      }\r\n\r\n      #printBills,\r\n      #printBills * {\r\n        visibility: visible !important;\r\n      }\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Roboto\';\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Medium.eot\');\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Medium.eot?#iefix\') format(\'embedded-opentype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Medium.woff2\') format(\'woff2\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Medium.woff\') format(\'woff\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Medium.ttf\') format(\'truetype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Medium.svg#Roboto-Medium\') format(\'svg\');\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-display: swap;\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Roboto\';\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Bold.eot\');\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Bold.eot?#iefix\') format(\'embedded-opentype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Bold.woff2\') format(\'woff2\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Bold.woff\') format(\'woff\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Bold.ttf\') format(\'truetype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Bold.svg#Roboto-Bold\') format(\'svg\');\r\n      font-weight: 700;\r\n      font-style: normal;\r\n      font-display: swap;\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Roboto\';\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Regular.eot\');\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Regular.eot?#iefix\') format(\'embedded-opentype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Regular.woff2\') format(\'woff2\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Regular.woff\') format(\'woff\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Regular.ttf\') format(\'truetype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Regular.svg#Roboto-Regular\') format(\'svg\');\r\n      font-weight: 400;\r\n      font-style: normal;\r\n      font-display: swap;\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Roboto\';\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Light.eot\');\r\n      src: url(\'../../../../../assets/font/Roboto/Roboto-Light.eot?#iefix\') format(\'embedded-opentype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Light.woff2\') format(\'woff2\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Light.woff\') format(\'woff\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Light.ttf\') format(\'truetype\'),\r\n        url(\'../../../../../assets/font/Roboto/Roboto-Light.svg#Roboto-Light\') format(\'svg\');\r\n      font-weight: 300;\r\n      font-style: normal;\r\n      font-display: swap;\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Anonymous Pro\';\r\n      src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.eot\');\r\n      src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.eot?#iefix\') format(\'embedded-opentype\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.woff2\') format(\'woff2\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.woff\') format(\'woff\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.ttf\') format(\'truetype\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro.svg#AnonymousPro\') format(\'svg\');\r\n      font-weight: 400;\r\n      font-style: normal;\r\n      font-display: swap;\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Anonymous Pro\';\r\n      src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.eot\');\r\n      src: url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.eot?#iefix\') format(\'embedded-opentype\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.woff2\') format(\'woff2\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.woff\') format(\'woff\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.ttf\') format(\'truetype\'),\r\n        url(\'../../../../../assets/font/AnonymousPro/AnonymousPro-Bold.svg#AnonymousPro-Bold\') format(\'svg\');\r\n      font-weight: 700;\r\n      font-style: normal;\r\n      font-display: swap;\r\n    }\r\n\r\n\r\n    #printSection {\r\n      width: 96%;\r\n      color: #000;\r\n      letter-spacing: -0.8px;\r\n      font-family: \'Anonymous Pro\';\r\n      margin: 0 auto;\r\n      box-sizing: border-box;\r\n      word-spacing: -5px;\r\n      font-weight: 700;\r\n    }\r\n\r\n    .small #printSection {\r\n      font-size: 12px;\r\n    }\r\n\r\n    .medium #printSection {\r\n      font-size: 14px;\r\n    }\r\n\r\n    .large #printSection {\r\n      font-size: 16px;\r\n    }\r\n\r\n    #printSection .uppercase {\r\n      text-transform: uppercase;\r\n    }\r\n\r\n    #printSection .print-address {\r\n      width: 95%;\r\n      margin: 0 auto;\r\n      font-family: \'Roboto\';\r\n      word-spacing: 0px;\r\n      letter-spacing: -0.2px;\r\n      font-weight: 400;\r\n    }\r\n\r\n    #printSection .techfooddyAddress {\r\n      width: 100%;\r\n      margin: 0 auto;\r\n      font-family: \'Roboto\';\r\n      word-spacing: 0px;\r\n      letter-spacing: -0.2px;\r\n      font-weight: 400;\r\n      border-top: 1px solid #000;\r\n      font-size: 11px;\r\n      margin-top: 10px;\r\n      padding-top: 5px\r\n    }\r\n\r\n    .small #printSection .print-address {\r\n      font-size: 11px;\r\n    }\r\n\r\n    .medium #printSection .print-address {\r\n      font-size: 13px;\r\n    }\r\n\r\n    .large #printSection .print-address {\r\n      font-size: 14px;\r\n    }\r\n\r\n    #printSection .print-address span {\r\n      display: inline-block;\r\n    }\r\n\r\n    #printSection .mt-4 {\r\n      margin-top: 4px;\r\n    }\r\n\r\n    #printSection .mb-4 {\r\n      margin-bottom: 4px;\r\n    }\r\n\r\n    #printSection .mb-8 {\r\n      margin-bottom: 8px;\r\n    }\r\n\r\n    #printSection .mb-12 {\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    #printSection .ml-12 {\r\n      margin-left: 12px;\r\n    }\r\n\r\n    #printSection .text-center {\r\n      text-align: center;\r\n    }\r\n\r\n    #printSection .text-right {\r\n      text-align: right;\r\n    }\r\n\r\n    #printSection .camelcase {\r\n      text-transform: capitalize;\r\n    }\r\n\r\n    #printSection .bill-info {\r\n      margin: 12px 0 10px;\r\n      font-weight: bold;\r\n      width: 100%;\r\n      display: inline-block;\r\n    }\r\n\r\n    #printSection .left-side {\r\n      width: 65%;\r\n      float: left;\r\n    }\r\n\r\n    .large #printSection .left-side {\r\n      width: 60% !important;\r\n      ;\r\n    }\r\n\r\n    #printSection .bill-info .right-side {\r\n      width: 35%;\r\n      display: inline-block;\r\n      text-align: right\r\n    }\r\n\r\n    .large #printSection .bill-info .right-side {\r\n      width: 40% !important;\r\n    }\r\n\r\n    #printSection .item-table {\r\n      width: 100%;\r\n      color: #000;\r\n    }\r\n\r\n    #printSection .items_name {\r\n      text-transform: capitalize;\r\n    }\r\n\r\n    #printSection th {\r\n      text-align: left;\r\n      text-transform: uppercase;\r\n    }\r\n\r\n    .small #printSection th {\r\n      border-top: 1px solid #000;\r\n      border-bottom: 1px solid #000;\r\n      padding: 2px 3px;\r\n      font-size: 12px;\r\n    }\r\n\r\n    .medium #printSection th {\r\n      border-top: 1px solid #000;\r\n      border-bottom: 1px solid #000;\r\n      padding: 4px 4px;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .large #printSection th {\r\n      border-top: 1px solid #000;\r\n      border-bottom: 1px solid #000;\r\n      padding: 5px 4px;\r\n      font-size: 16px;\r\n    }\r\n\r\n    #printSection .total-saving {\r\n      text-transform: uppercase;\r\n      font-weight: 700;\r\n    }\r\n\r\n    .small #printSection .total-saving {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .medium #printSection .total-saving {\r\n      font-size: 22px;\r\n    }\r\n\r\n    .large #printSection .total-saving {\r\n      font-size: 24px;\r\n    }\r\n\r\n    #printSection .next-earned {\r\n      text-transform: uppercase;\r\n      font-weight: 700;\r\n      margin: 8px 0 0;\r\n      letter-spacing: 0.5px;\r\n    }\r\n\r\n    .small #printSection .next-earned {\r\n      font-size: 12px;\r\n    }\r\n\r\n    .medium #printSection .next-earned {\r\n      font-size: 14px;\r\n    }\r\n\r\n    .large #printSection .next-earned {\r\n      font-size: 16px;\r\n    }\r\n\r\n\r\n    #printSection .footer-text {\r\n      margin-top: 12px;\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n    #printSection td {\r\n      font-weight: 700;\r\n    }\r\n\r\n    .small #printSection td {\r\n      padding: 2px 3px;\r\n      font-size: 12px;\r\n    }\r\n\r\n    .medium #printSection td {\r\n      padding: 3px 4px;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .large #printSection td {\r\n      padding: 4px 4px;\r\n      font-size: 16px;\r\n    }\r\n\r\n    #printSection .item-table tr.no-padd td {\r\n      padding: 1px 0;\r\n    }\r\n\r\n    #printSection .right {\r\n      text-align: right;\r\n    }\r\n\r\n    #printSection .border-top {\r\n      border-top: 1px solid #000;\r\n      margin-top: 2px;\r\n    }\r\n\r\n    .small #printSection .border-top {\r\n      border-top: 1px solid #000;\r\n    }\r\n\r\n    .large #printSection .border-top {\r\n      border-top: 1px solid #000;\r\n    }\r\n\r\n    #printSection .border-bottom {\r\n      border-bottom: 1px solid #000;\r\n      margin-bottom: 2px;\r\n    }\r\n\r\n    .small #printSection .border-bottom {\r\n      border-bottom: 1px solid #000;\r\n    }\r\n\r\n    .large #printSection .border-bottom {\r\n      border-bottom: 1px solid #000;\r\n    }\r\n\r\n    #printSection .print-logo {\r\n      margin: 0 auto 2px;\r\n      width: 186px;\r\n      height: 56px;\r\n    }\r\n\r\n    #printSection .print-logo.rect {\r\n      margin: 0 auto;\r\n      width: 186px;\r\n      height: 56px;\r\n    }\r\n\r\n    #printSection .print-logo.round {\r\n      margin: 0 auto;\r\n      width: 100px;\r\n      height: 70px;\r\n    }\r\n\r\n    .small #printSection strike {\r\n      font-size: 12px\r\n    }\r\n\r\n    .medium #printSection strike,\r\n    .large #printSection strike {\r\n      font-size: 13px\r\n    }\r\n\r\n    #printSection .main-total-box {\r\n      padding: 10px 2px 12px;\r\n    }\r\n\r\n    .main-total-box .layout-row {\r\n      margin-bottom: 2px\r\n    }\r\n\r\n    #printSection .main-total-box .tag {\r\n      padding-right: 5%;\r\n      text-align: right;\r\n      width: 75%;\r\n      float: left;\r\n      text-transform: uppercase;\r\n    }\r\n\r\n    .small #printSection .main-total-box .tag {\r\n      font-size: 12px;\r\n    }\r\n\r\n    .medium #printSection .main-total-box .tag {\r\n      font-size: 14px;\r\n    }\r\n\r\n    .large #printSection .main-total-box .tag {\r\n      font-size: 16px;\r\n    }\r\n\r\n    #printSection .main-total-box .value {\r\n      text-align: right;\r\n      width: 20%;\r\n      display: inline-block;\r\n    }\r\n\r\n    .small #printSection .main-total-box .footer .tag {\r\n      font-size: 18px;\r\n    }\r\n\r\n    .medium #printSection .main-total-box .footer .tag {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .large #printSection .main-total-box .footer .tag {\r\n      font-size: 20px;\r\n    }\r\n\r\n    #printSection .total {\r\n      font-weight: 700;\r\n      line-height: 24px;\r\n    }\r\n\r\n    .small #printSection .total {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .medium #printSection .total {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .large #printSection .total {\r\n      font-size: 20px;\r\n    }\r\n\r\n    #printSection .total-rate-container {\r\n      text-transform: uppercase;\r\n      border-bottom: 1px solid #000;\r\n      padding-bottom: 4px !important;\r\n    }\r\n\r\n    #printSection .customer-details {\r\n      padding: 6px 0;\r\n      border-top: 1px solid #000;\r\n      border-bottom: 1px solid #000;\r\n    }\r\n\r\n    #printSection .main-total-box .total-rate-container .tag {\r\n      text-align: left !important;\r\n    }\n</style></div>");
$templateCache.put("app/main/cashier/billing/returnbills/returnbills.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 header-panel\"><md-button class=\"md-accent ml-16\" \naria-label=\"edit info\" ng-click=\"addreturn($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\nAdd Return Bill</md-button></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table md-table \nmd-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"return_query.order\" md-on-reorder=\"\"><tr md-row><th md-column>{{ \'RETURNS.RETURNED-NO\' | translate}}</th><th \nmd-column>{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th md-column>{{ \'RETURNS.REFUND_METHOD\' | translate }}</th><th \nmd-column>{{ \'RETURNS.REMARKS\' | translate }}</th><th md-column>{{ \'BILLINGS.CREATED-BY\' | translate}}</th><th \nmd-column>{{ \'RETURNS.TOTAL_REFUND\' | translate }}</th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select \nng-repeat=\"returnBill in (returnBills || [])\r\n                        | limitTo: return_query.limit : (return_query.page - 1) * return_query.limit\r\n                        | filter: return_query.filter\r\n                        | orderBy: return_query.order\">\n<td md-cell class=\"border-status\">{{ returnBill.returnorder_id }}</td><td md-cell class=\"border-status\">\n{{ returnBill.original_salesorder_id }}</td><td md-cell class=\"border-status\">{{ returnBill.refund_method }}</td><td \nmd-cell class=\"border-status\">{{ returnBill.remarks }}</td><td md-cell class=\"border-status\">\n{{ returnBill.created_at }}</td><td md-cell class=\"border-status\">{{ returnBill.total_refund }}</td></tr></tbody>\n</table><div class=\"layout-column layout-align-center-center no-data padding-32\" \nng-if=\"!(returnBills && returnBills.length)\"><h3>There\'re no return bills for you to see.</h3></div>\n</md-table-container><md-table-pagination md-limit=\"return_query.limit\" md-limit-options=\"[5,10,15]\" \nmd-page=\"return_query.page\" md-total=\"{{returnBillCount}}\" md-page-select></md-table-pagination></div></div></section>");
$templateCache.put("app/main/cashier/billing/trashbills/trashbills.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-sm hidebelow959\" ng-show=\"vm.settings.diettype_filter\"><md-select ng-model=\"diet\" \naria-label=\"today\" ng-init=\"diet=vm.dietType[0].value\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"diet in vm.dietType\" value=\"{{diet.value}}\">{{diet.label}}\n</md-option></md-select></div><div class=\"ph-8 filter-dropdown-sm hidebelow959\" \nng-show=\"vm.settings.dealertype_filter && vm.settings.dealer\"><md-select ng-model=\"dealer\" aria-label=\"today\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option value=\"all\" ng-init=\"dealer=\'all\'\">All Customer Type</md-option><md-option \nng-repeat=\"dealerList in vm.dealerLists\" value=\"{{dealerList.value}}\">{{dealerList.label}}</md-option></md-select>\n</div><div class=\"ph-8 filter-dropdown-sm hidebelow959\"><md-select ng-model=\"payment\" aria-label=\"today\" \nng-init=\"payment=vm.paymentmodelist[0].value\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"payment in  vm.paymentmodelist\" value=\"{{payment.value}}\">\n{{payment.name}}</md-option></md-select></div><div ng-show=\"permission\" ng-hide=\"!permission\" \nclass=\"ph-8 filter-dropdown-sm hidebelow959\"><md-select ng-model=\"staffss\" aria-label=\"today\" \nng-init=\"staffss=vm.staffRole[0].staffID\" \nng-change=\"changeDate(OpenDayWise ? myDate : \'\',diet,dealer,payment,staffss,OpenMonthWise ? monthyear : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}\n</md-option></md-select></div><div ng-if=\"vm.paidbill.length>0\" class=\"layout-align-start-start ph-12\"><a \nexport-to-csv class=\"download-csv hidebelow959\" ng-show=\"OpenDayWise\"><md-tooltip md-direction=\"top\">Export data to CSV\n</md-tooltip></a><table style=\"display: none\" ng-show=\"OpenDayWise\"><tr><th>Ordered No</th><th>Total Amount</th><th>\nCash received</th><th>Online transferred</th><th>CGST</th><th>SGST</th><th>Additonal Charge</th><th>Discount</th><th>\nPayment Type</th><th ng-if=\"vm.settings.dealer\">Membership</th><th>Ordered Time</th><th>Sales Man</th><th>Created By\n</th><th>Delivered Time</th></tr><tr ng-repeat=\"paidbill in vm.paidbill\"><td>{{paidbill.salesorder_id}}</td><td>\n{{paidbill.payment_total}}</td><td>{{paidbill.cashpay}}</td><td>{{paidbill.onlinepay}}</td><td>{{paidbill.tax_rate}}\n</td><td>{{paidbill.tax_sgst}}</td><td>{{paidbill.additional_charge}}</td><td>{{paidbill.discount}}</td><td>\n{{paidbill.payment_mode}}</td><td ng-if=\"vm.settings.dealer\">{{paidbill.dealer_status}}</td><td>{{paidbill.ordertime}}\n</td><td>{{paidbill.manageBy}}</td><td>{{paidbill_staffnames(paidbill)}}</td><td>\n{{paidbill.sales_deliveryTime | date }}</td></tr></table><a export-to-csv class=\"download-csv\" ng-show=\"OpenMonthWise\" \nng-if=\"!payment\"><md-tooltip md-direction=\"top\">Export data to CSV</md-tooltip></a><table ng-show=\"OpenMonthWise\" \nng-if=\"!payment\" style=\"display: none\"><tr><th>Date</th><th>Total Amount</th></tr><tr \nng-repeat=\"perdaytotalData in vm.perdaytotalDatas | orderBy:\'$index\':true\"><td>{{perdaytotalData.date}}</td><td>\n{{perdaytotalData.total_amount}}</td></tr><tr><td>Total Amount</td><td>\n{{takeaway_amount+doordelivery_amount+dinein_amount}}</td></tr><tr><td></td><td></td></tr><tr><td>Total Tax</td><td>\n{{tax_sgst+tax_cgst}}</td></tr><tr><td>Total CGST</td><td>{{tax_cgst}}</td></tr><tr><td>Total SGST</td><td>{{tax_sgst}}\n</td></tr></table></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"doordelivery_query.filter\" \ntype=\"text\" placeholder=\"Search ordered no or amount\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"doordelivery_query.filter\" ng-click=\"clearText()\"></md-icon>\n</div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"doordelivery_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column>\n{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th md-column \nng-if=\"vm.settings.diettype_filter&&vm.settings.tableno_permission\">{{ \'BILLINGS.TYPE\' | translate}}</th><th md-column>\n{{ \'BILLINGS.AMOUNT\' | translate}}</th><th md-column class=\"hidebelow959\">{{ \'BILLINGS.ORDERED-TIME\' | translate}}</th>\n<th md-column class=\"hidebelow959\">{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th><th md-column class=\"hidebelow959\">\n{{ \'BILLINGS.ORDER-TAKEN\' | translate}}</th><th md-column ng-if=\"permission!=admin\" class=\"hidebelow959\">\n{{ \'BILLINGS.CREATED-BY\' | translate}}</th><th md-column><span>{{ \'BILLINGS.ACTIONS\' | translate}}</span></th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in vm.paidbill | limitTo: doordelivery_query.limit: (doordelivery_query.page - 1) * doordelivery_query.limit | filter: doordelivery_query.filter | orderBy: doordelivery_query.order\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.salesorder_id}}</td><td md-cell \nng-if=\"vm.settings.diettype_filter&&vm.settings.tableno_permission\">{{ paidbill.sales_dietType }} <span \nstyle=\"font-size:11px\" ng-if=\"paidbill.thirdparty_id\">({{ paidbill.thirdparty_name }})</span></td><td md-cell><span \ntranslate>BILLINGS.INR</span> <span>{{ paidbill.payment_total }}</span> <span class=\"flex-none adv-amount\" \nng-if=\"paidbill.payment_mode!=\'cash & card\'\">{{paidbill.payment_mode==\'card\' ? \'online\' : paidbill.payment_mode}}\n</span> <span class=\"flex-none adv-amount\" ng-if=\"paidbill.payment_mode==\'cash & card\'\">cash <span translate>\nBILLINGS.INR</span> {{paidbill.payment_received}} & online <span translate>BILLINGS.INR</span>\n {{paidbill.payment_transferred}}</span></td><td md-cell title=\"{{ paidbill.showorderdate }}\" class=\"hidebelow959\">\n{{ paidbill.last_modified | date:\'medium\'}}<md-icon \ntitle=\"Last updated by  {{ update_staff(paidbill)}} ,on {{ paidbill.last_modified | date:\'medium\'}}\" class=\"rate-edit\" \nmd-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \ntitle=\"{{paidbill.showdeliverdate | date:\'medium\'}}\" class=\"hidebelow959\"><div class=\"layout-row\">\n{{ paidbill.sales_deliveryTime | date }}<div id=\"demo\" class=\"ml-8 remaining-timer\" \nng-if=\"paidbill.sales_deliveryTime != \'Immediate\'\"><span class=\"flex-none\">- {{paidbill.remainingtime}}</span></div>\n</div></td><td md-cell class=\"hidebelow959\">{{ paidbill.manageBy }}</td><td md-cell ng-if=\"permission!=admin\" \nclass=\"hidebelow959\">{{ paidbill_staffnames(paidbill) }}</td><td md-cell><md-button aria-label=\"Printcard\" \nng-click=\"printToCart(paidbill);$event.stopPropagation();\" class=\"md-icon-button\" \nng-if=\"stewardPermission != \'steward\'\"><md-icon md-menu-origin md-font-icon=\"text-black-40 icon-printer\"></md-icon>\n</md-button><md-menu ng-if=\"admin.length || saleseditt.length\"><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"admin.length\">\n<md-button ng-click=\"removeRow(paidbill,$event,$index)\"><md-icon md-menu-origin md-font-icon=\"icon-trash\"></md-icon>\nDelete</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.paidbill.length==0\"><h3>\nThere\'re no paid bills for you to see.</h3></div></md-table-container><md-table-pagination \nmd-limit=\"doordelivery_query.limit\" md-limit-options=\"[5,10,15]\" md-page=\"doordelivery_query.page\" \nmd-total=\"{{paidbill_count}}\" md-page-select></md-table-pagination></div></div><div \nclass=\"paid-fix md-accent-bg hidebelow959\" ng-if=\"vm.paidbill.length>0\"><div layout=\"row\" layout-align=\"start start\">\n<div flex-none class=\"paid-each-container\"><span class=\"title\">{{\'BILLINGS.Total Amount\' | translate}} <span \nng-if=\"payment\">of {{payment==\'card\' ? \'online\' : payment}}</span></span> <span class=\"inr\" translate>BILLINGS.INR\n</span> <span class=\"amount\" ng-if=\"!payment\">{{takeaway_amount+doordelivery_amount+dinein_amount}}</span> <span \nclass=\"amount\" ng-if=\"payment==\'cash\'\">{{takeaway_amount+doordelivery_amount+dinein_amount- payment_transferred}}\n</span> <span class=\"amount\" ng-if=\"payment==\'card\'\">\n{{takeaway_amount+doordelivery_amount+dinein_amount- payment_received}}</span> <span title=\"ordered\" class=\"ordered\">\n<img src=\"assets/icons/order-icon.svg\"> {{takeaway_total+doordelivery_total+dinein_total}}</span></div><div flex-none \nclass=\"paid-each-container\" ng-if=\"vm.settings.dinein_permission\"><span class=\"title\">\n{{\'BILLINGS.DIET-IN\' | translate}}</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">\n{{dinein_amount}}</span> <span title=\"ordered\" class=\"ordered\"><img src=\"assets/icons/order-icon.svg\"> {{dinein_total}}\n</span></div><div flex-none class=\"paid-each-container\" ng-if=\"vm.settings.takeaway_permission\"><span class=\"title\">\n{{\'BILLINGS.TAKE-AWAY\' | translate}}</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">\n{{takeaway_amount}}</span> <span title=\"ordered\" class=\"ordered\"><img src=\"assets/icons/order-icon.svg\">\n {{takeaway_total}}</span></div><div flex-none class=\"paid-each-container\" ng-if=\"vm.settings.doordelivery_permission\">\n<span class=\"title\">{{\'BILLINGS.DOOR-DELIVERY\' | translate}}</span> <span class=\"inr\" translate>BILLINGS.INR</span> \n<span class=\"amount\">{{doordelivery_amount}}</span> <span title=\"ordered\" class=\"ordered\"><img \nsrc=\"assets/icons/order-icon.svg\"> {{doordelivery_total}}</span></div></div></div></section><md-content \nstyle=\"display: none\" class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" ng-controller=\"printbillController as vm\" ms-scroll>\n</md-content>");
$templateCache.put("app/main/cashier/customer-list/customer-analytics/customer-analytics.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp layout-align-center\" \nng-if=\"vm.loader\"><div layout-align=\"center center\" layout=\"column\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"48\" md-mode=\"indeterminate\"></md-progress-circular><br>Please wait, Loading data</div></section><div \nng-if=\"!vm.loader\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" class=\"customer-header\"><md-toolbar class=\"md-accent md-tall ms-widget_md layout-row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle layout-align-start-start layout-column flex\"><div \nclass=\"layout-align-start-start layout-row\"><img ng-src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"Photo\" src=\"assets/images/avatars/profile.jpg\"><div layout=\"column\" \nclass=\"text-container\"><div class=\"contact-name\">{{customer_name}}</div><div layout=\"row\" class=\"mt-8\"><i \nclass=\"icon s16 icon-cellphone-android mr-8 mt-2\"></i><div class=\"mobile-no\">{{customer_mobile}}</div></div><div \nlayout=\"row\" class=\"mt-4\" ng-if=\"hidelastvisit\"><i class=\"icon s16 icon-clock mr-8 mt-2\"></i><div class=\"mobile-no\">\n<span>Last Ordered:</span> {{ordertime | date}} ({{lastvisit}})</div></div></div></div></div><div \nclass=\"layout-align-end-center mr-24 mt-24\"><md-button class=\"md-primary md-raised\" layout-align-end \nng-click=\"vm.showAddTableDialog($event,customer);\">Edit Profile</md-button></div></md-toolbar></ms-widget></div><div \nng-if=\"hidelastvisit\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"50\" class=\"customer-anal\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">Overview</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{total_visit}}</span></div><div class=\"label md-truncate\">\nTotal Ordered</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{total}}</span></div>\n<div class=\"label md-truncate\">Total Amount</div></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container mb-16\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{avgtotal | number:2}}\n</span></div><div class=\"label md-truncate\">Avg.Amount of per Order</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\" ng-if=\"points[0].enablepoint==1\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{pointsEarned}}</span></div><div class=\"label md-truncate\">\nEarned point</div></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">Ordered type</span>\n</div></div><ms-widget-front class=\"pie-chart\"><nvd3 config=\"vm.widget6.mainChart.config\" \noptions=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg expense-category\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Ordered</div></div><md-table-container \nclass=\"p-10\"><table md-table multiple=\"multiple\"><thead md-head><tr md-row><th md-column>\n{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th md-column>{{ \'BILLINGS.AMOUNT\' | translate}}</th><th md-column>\n{{ \'BILLINGS.ORDERED-TIME\' | translate}}</th></tr></thead><tbody md-body><tr class=\"cursor-pointer\" md-auto-select \nng-repeat=\"customer in vm.customer_lastVisits\" ng-click=\"Editpos(customer.x,customer.customer_id)\"><td md-cell><a \nhref=\"#\" ng-click=\"Editpos(customer.x,customer.customer_id)\">{{customer.x }}</a></td><td md-cell><span translate>\nBILLINGS.INR</span> {{customer.y}}</td><td md-cell>{{ customer.date }}</td></tr></tbody></table></md-table-container>\n</ms-widget-front></ms-widget><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg expense-category\">\n<div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\">Top 10 ordered items</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-24\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" \noptions=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3></div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"80\"><ms-widget-front class=\"white-bg layout-column\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">Feedback</span></div><div layout=\"row\" layout-align=\"start center\"></div>\n</div><table class=\"feedback-table\"><tr><th width=\"8%\"></th><th width=\"23%\"><div class=\"header\"><img \nsrc=\"assets/corporate/{{domaincatergory}}/feedback/analytics-speed.svg\" alt=\"\" class=\"pricing-img\"><p \nclass=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.SPEED-OF-SERVICE</span></p><div layout=\"row\" \nlayout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">{{feedback_Service_review | number:1}}\n</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_Service_review ? feedback_Service_review/5*100 : 0;}}%\"></span></span></div></div></div></th>\n<th width=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/courtesy-staff.svg\" alt=\"\" \nclass=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.COURTEST-OF-STAFF</span></p><div \nlayout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_staff_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_staff_review ? feedback_staff_review/5*100 : 0;}}%\"></span></span></div></div></div></th><th \nwidth=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/quality-food.svg\" alt=\"\" \nclass=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.QUALITY-OF-FOOD</span></p><div \nlayout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_food_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_food_review ? feedback_food_review/5*100 : 0;}}%\"></span></span></div></div></div></th><th \nwidth=\"23%\"><div class=\"header\"><img src=\"assets/corporate/{{domaincatergory}}/feedback/value-money.svg\" alt=\"\" \nclass=\"pricing-img\"><p class=\"pricing-header\"><span translate>GENERAL.FEEDBACK-LIST.VALUE-FOR-MONEY</span></p><div \nlayout=\"row\" layout-align=\"center center\" class=\"mt-16 mb-16\"><span class=\"mr-10 rating-text\">\n{{feedback_money_review | number:1}}</span><div class=\"layout-column\"><span class=\"stars\"><span \nstyle=\"width:{{feedback_money_review ? feedback_money_review/5*100 : 0;}}%\"></span></span></div></div></div></th></tr>\n<tr class=\"fivestar\"><td class=\"fivestar-text\">Great</td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_service_GREAT}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_service_GREAT | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_service_GREAT > 0\">{{feedback.Feedback_service[0].GREAT }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_GREAT}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_GREAT | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_GREAT > 0\">\n{{feedback.Feedback_staff[0].GREAT }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_GREAT}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_GREAT | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_GREAT > 0\">\n{{feedback.Feedback_food[0].GREAT }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_GREAT}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_money_GREAT | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_money_GREAT > 0\">\n{{feedback.Feedback_money[0].GREAT }}</span></div></td></tr><tr class=\"fourstar\"><td class=\"fourstar-text\">Good</td>\n<td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_service_GOOD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_service_GOOD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_service_GOOD > 0\">{{feedback.Feedback_service[0].GOOD }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_GOOD}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_GOOD | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_GOOD > 0\">\n{{feedback.Feedback_staff[0].GOOD }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_GOOD}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_GOOD | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_GOOD > 0\">{{feedback.Feedback_food[0].GOOD }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_GOOD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_money_GOOD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_money_GOOD > 0\">{{feedback.Feedback_money[0].GOOD }}</span></div></td></tr><tr class=\"thirdstar\"><td \nclass=\"thirdstar-text\">Ok</td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div \nclass=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_service_OK}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_service_OK | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_service_OK > 0\">\n{{feedback.Feedback_service[0].OK }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_staff_OK}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_staff_OK | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_OK > 0\">{{feedback.Feedback_staff[0].OK }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_OK}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_food_OK | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_food_OK > 0\">{{feedback.Feedback_food[0].OK }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_money_OK}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_money_OK | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_money_OK > 0\">\n{{feedback.Feedback_money[0].OK }}</span></div></td></tr><tr class=\"secondstar\"><td class=\"secondstar-text\">Bad</td>\n<td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_service_BAD}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_service_BAD | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_service_BAD > 0\">\n{{feedback.Feedback_service[0].BAD }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_staff_BAD}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_staff_BAD | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_BAD > 0\">{{feedback.Feedback_staff[0].BAD }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_BAD}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_food_BAD | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_food_BAD > 0\">{{feedback.Feedback_food[0].BAD }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_money_BAD}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_money_BAD | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_money_BAD > 0\">\n{{feedback.Feedback_money[0].BAD }}</span></div></td></tr><tr class=\"onestar\"><td class=\"onestar-text\">Poorly</td><td>\n<div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_service_POOR}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_service_POOR | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_service_POOR > 0\">{{feedback.Feedback_service[0].POOR }}</span></div></td><td><div \nclass=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" \nstyle=\"width: {{feedback_staff_POOR}}% !important\"><md-tooltip md-direction=\"top\">{{feedback_staff_POOR | number:2}}%\n</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_staff_POOR > 0\">\n{{feedback.Feedback_staff[0].POOR }}</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\">\n<div class=\"progress-bar\" class=\"mt-16 mb-16 flex\" style=\"width: {{feedback_food_POOR}}% !important\"><md-tooltip \nmd-direction=\"top\">{{feedback_food_POOR | number:2}}%</md-tooltip></div><span \nclass=\"font-size-px-12 text-black-70 ml-10 reviews\" ng-if=\"feedback_food_POOR > 0\">{{feedback.Feedback_food[0].POOR }}\n</span></div></td><td><div class=\"flex layout-row mt-6 layout-align-start-center\"><div class=\"progress-bar\" \nclass=\"mt-16 mb-16 flex\" style=\"width: {{feedback_money_POOR}}% !important\"><md-tooltip md-direction=\"top\">\n{{feedback_money_POOR | number:2}}%</md-tooltip></div><span class=\"font-size-px-12 text-black-70 ml-10 reviews\" \nng-if=\"feedback_money_POOR > 0\">{{feedback.Feedback_money[0].POOR }}</span></div></td></tr></table></ms-widget-front>\n</ms-widget></div></div><div class=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"100\"><div \nclass=\"layout-column layout-align-center-center md-whiteframe-2dp white-bg padding-48 text-center no-data\" \nng-if=\"!hidelastvisit\"><h3 class=\"text-center\">There\'re no data for you to see.</h3></div></ms-widget></div></div>");
$templateCache.put("app/main/cashier/customer-list/dialog/add_customer_dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-640 h-600 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">{{vm.title}} Customer</h2></div><div \nclass=\"layout-column medium\"><form name=\"CustomerInfo\"><div layout=\"row\"><md-input-container \nclass=\"md-block md-accent mr-16\" flex=\"50\"><label translate=\"\">BILLINGS.CUSTOMER-LIST.MOBILE</label><input type=\"text\" \nvalid-number name=\"number\" max=\"10\" ng-keypress=\"phonenumber($event)\" ng-model=\"customer.customer_mobile\" \nng-minlength=\"{{number.name.minlength}}\" ng-maxlength=\"{{number.name.maxlength}}\" required><div \nng-messages=\"CustomerInfo.number.$dirty || CustomerInfo.number.$error\" role=\"alert\" multiple=\"multiple\"><span \nng-show=\"CustomerInfo.number.$error.minlength\">Please enter minimum 10 numbers!</span> <span \nng-show=\"CustomerInfo.number.$error.maxlength\">Please enter maximum 12 numnbers!</span></div></md-input-container>\n</div><div layout=\"row\" class=\"mt-8\"><div flex=\"50\" class=\"mr-16 flex-50\"><md-input-container \nclass=\"md-block md-accent mr-16\" flex><label translate=\"\">BILLINGS.CUSTOMER-LIST.NAME</label><input type=\"text\" \nname=\"name\" ng-model=\"customer.customer_name\" ng-minlength=\"{{user.name.minlength}}\" \nng-maxlength=\"{{user.name.maxlength}}\" ng-required=\"customer.customer_mobile\"><div \nng-messages=\"CustomerInfo.name.$dirty || CustomerInfo.name.$error\" role=\"alert\" multiple=\"multiple\"><span \nng-show=\"CustomerInfo.name.$error.minlength\">Please enter minimum 3 characters!</span> <span \nng-show=\"CustomerInfo.name.$error.maxlength\">Please enter maximum 30 characters!</span></div></md-input-container>\n</div><div flex=\"50\" class=\"flex-50\"><md-input-container class=\"md-block md-accent\" flex><label for=\"email\" \ntranslate=\"\">BILLINGS.CUSTOMER-LIST.EMAIL</label><input type=\"email\" name=\"email\" ng-model=\"customer.customer_email\" \nng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"addUser.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>Please enter the valid e-mail address</span></div></div></md-input-container></div></div>\n<div layout=\"row\" class=\"mt-8\"><div flex=\"100\" class=\"mr-16\"><md-input-container class=\"md-block md-accent mr-16\" flex>\n<label translate=\"\">BILLINGS.CUSTOMER-LIST.ADDRESS</label><textarea ng-model=\"customer.customer_address\" max-rows=\"5\">\n</textarea></md-input-container></div></div><div layout=\"row\" class=\"mt-8\"><div flex=\"50\" class=\"mr-16 foodItem-auto\">\n<md-autocomplete class=\"md-accent\" md-input-id=\"fooditem\" flex=\"100\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"customer.localityName\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"{{ \'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}}\" md-min-length=\"0\" required md-require-match \nmd-autoselect=\"true\"><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.localityName}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You <b>must</b> enter a <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">Please select an existing <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete></div><div flex=\"50\"><md-input-container \nclass=\"md-block md-accent\"><label translate=\"\">BILLINGS.CUSTOMER-LIST.CITY</label><input type=\"text\" \nng-model=\"customer.customer_city\"></md-input-container></div></div><div layout=\"row\" class=\"mt-8\"><div flex=\"100\" \nclass=\"mr-16\" layout=\"column\"><md-checkbox ng-model=\"customer.whatsapp\" ng-true-value=\"1\" ng-false-value=\"0\">\nWhatsapp No.</md-checkbox><span class=\"secondary-text md-block ml-32 mb-24 mtm-16\">\nIt is useful to send message in whatsapp</span></div></div></form></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button ng-if=\"!customer.customer_id\" \nclass=\"md-accent\" ng-disabled=\"CustomerInfo.$invalid\" ng-click=\"submit_customer(customer)\">Submit</md-button><md-button\n ng-if=\"customer.customer_id\" class=\"md-accent\" ng-disabled=\"CustomerInfo.$invalid\" \nng-click=\"update_customer(customer)\">Update</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/customer-list/dialog/customer_view.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-640 h-600 layout-column\"><md-dialog-content class=\"flex layout-column\">\n<div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">CustomerID:{{customer.customer_id}}</h2></div><div \nclass=\"layout-column\"><form name=\"CustomerInfo\"><div layout=\"row\"><md-input-container class=\"md-block md-accent mr-16\" \nflex=\"50\"><label translate=\"\">BILLINGS.CUSTOMER-LIST.MOBILE</label><input type=\"text\" name=\"number\" \nng-model=\"customer.customer_mobile\" ng-minlength=\"{{number.name.minlength}}\" ng-maxlength=\"{{number.name.maxlength}}\" \nrequired><div ng-messages=\"CustomerInfo.number.$dirty || CustomerInfo.number.$error\" role=\"alert\" multiple=\"multiple\">\n<span ng-show=\"CustomerInfo.number.$error.minlength\">Please enter minimum 10 numbers!</span> <span \nng-show=\"CustomerInfo.number.$error.maxlength\">Please enter maximum 12 numnbers!</span></div></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block md-accent mr-16\" flex=\"50\"><label translate=\"\">\nBILLINGS.CUSTOMER-LIST.NAME</label><input type=\"text\" name=\"name\" ng-model=\"customer.customer_name\" \nng-minlength=\"{{user.name.minlength}}\" ng-maxlength=\"{{user.name.maxlength}}\" ng-required=\"customer.customer_mobile\">\n<div ng-messages=\"CustomerInfo.name.$dirty || CustomerInfo.name.$error\" role=\"alert\" multiple=\"multiple\"><span \nng-show=\"CustomerInfo.name.$error.minlength\">Please enter minimum 3 characters!</span> <span \nng-show=\"CustomerInfo.name.$error.maxlength\">Please enter maximum 30 characters!</span></div></md-input-container>\n<md-input-container class=\"md-block md-accent\" flex=\"50\"><label for=\"email\" translate=\"\">BILLINGS.CUSTOMER-LIST.EMAIL\n</label><input type=\"email\" name=\"email\" ng-model=\"customer.customer_email\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"addUser.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nPlease enter the valid e-mail address</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block md-accent mr-16\" flex=\"50\"><label translate=\"\">BILLINGS.CUSTOMER-LIST.ADDRESS\n</label><textarea ng-model=\"customer.customer_address\" max-rows=\"5\"></textarea></md-input-container><md-input-container\n class=\"md-block md-accent\" flex=\"50\"><label translate=\"\">BILLINGS.CUSTOMER-LIST.CITY/LOCALITY</label><input \ntype=\"text\" ng-model=\"customer.customer_city\"></md-input-container></div></form></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/dashboard/expense/expense.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><div \nclass=\"medium ph-16 filter-dropdown-lg\"><div layout=\"row\" layout-align=\"start center\"><md-select class=\"md-accent\" \nng-init=\"expense = \'LM\'\" ng-model=\"expense\" ng-change=\"expenseChange(expense,$event)\" aria-label=\"Change range\" \nflex=\"100\"><md-option ng-repeat=\"expense in expense_scheduless\" value=\"{{expense.value}}\">{{expense.name}}</md-option>\n</md-select></div></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">{{\'EXPENSE.EXPENSE\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{total_paid+total_balance}}</span></div><div class=\"label md-truncate\">{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}</div>\n</div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{total_paid}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.PAID-EXPENSE\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{total_balance}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}</div></div></div><div \nclass=\"layout-row layout-align-start-start tax-text-container\"><div flex class=\"layout-align-center-center layout-row\">\n<span class=\"ml-16 label\">Tax Cgst- &nbsp; ₹ {{expensetax | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Tax Sgst- &nbsp; ₹ {{expensetaxCgst | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Tax- &nbsp; ₹ {{expensetaxSgst | thousandSuffix : fractionSize}}</span></div></div>\n<ms-widget-front class=\"pie-chart\"><nvd3 config=\"vm.widget7.mainChart.config\" options=\"vm.widget7.mainChart.options\" \ndata=\"vm.widget7.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\">\n<span class=\"h3\">{{\'EXPENSE.VENDORS\' | translate}}</span></div></div><div layout=\"row\" layout-align=\"end center\" \nflex=\"100\" class=\"mt-8 mb-16\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"vm.expensesearch\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div><md-table-container><table md-table \nmd-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"expense_query.order\"><tr md-row><th md-column width=\"12%\">{{\'EXPENSE.vendor\' | translate}} name</th><th \nmd-column width=\"12%\" md-column md-order-by=\"total\">{{\'BILLINGS.PRICE\' | translate}}</th><th md-column width=\"12%\">\n{{\'EXPENSE.PERCENTAGE\' | translate}}</th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"vendor in expense_data | orderBy : expense_query.order : true | filter : vm.expensesearch | limitTo: expense_query.limit: (expense_query.page - 1) * expense_query.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{vendor.vendor_name}}</td><td md-cell>{{vendor.total}}\n</td><td md-cell>{{vendor.total_percent | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination\n md-limit=\"expense_query.limit \" md-limit-options=\"[10] \" md-page=\"expense_query.page \" \nmd-total=\"{{expense_query_count}}\" md-page-select></md-table-pagination></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg expense-category\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">Expense Category</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-24\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" \nconfig=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3>\n</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/cashier/dashboard/inventory/inventory.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"inventory_foodRaw_load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><div class=\"medium ph-16 filter-dropdown-lg\"><md-select class=\"md-accent\" aria-label=\"email\" \nng-init=\"inventory = \'LM\'\" ng-model=\"inventory\" \nng-change=\"inventoryChange(dayset,inventory,$event);rawmaterialChange(inventory,$event);purchaseexpenseChange(inventory,$event);SalesexpenseChange(inventory,$event)\" \naria-label=\"Change range\"><md-option ng-repeat=\"inventory in inventory_schedules\" value=\"{{inventory.value}}\">\n{{inventory.name}}</md-option></md-select></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pt-8 light-blue\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" flex=\"100\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h3\" translate>BILLINGS.SALES-ITEMS</span></div><div layout=\"row\" \nlayout-align=\"end center\" flex class=\"mb-16\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"vm.foodsearch\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div></div><div layout=\"row\" \nclass=\"week-container light-blue\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><ul\n class=\"weekdays\"><li ng-repeat=\"weekday in vm.weekdays\" ng-class=\"{active : activeMenu === weekday}\" \nclass=\"md-accent\"><a ng-click=\"setActive(weekday);inventoryChange(weekday.name,inventory,$event)\">{{weekday.name}}</a>\n</li></ul><div layout=\"row\" layout-align=\"end center\"><md-progress-circular class=\"md-accent ml-10 mt-10\" \nng-if=\"weekday_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div></div><div \nclass=\"medium select-small mb-8\" layout=\"row\" layout-align=\"end center\" flex-none><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"food_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\n<md-select ng-model=\"stu\" aria-label=\"email\" class=\"md-accent\" ng-init=\"stu = \'All\'\" ng-change=\"getFood_items(stu)\">\n<md-option ng-repeat=\"food in vm.fmCategory | unique:\'staffID\'\" value=\"{{food.fmCatergoryID}}\">{{food.fmCatergoryName}}\n</md-option></md-select></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head md-order=\"inventory_food.order\"><tr \nmd-row><th md-column width=\"60%\"><span>{{\'BILLINGS.ITEMS\' | translate}}</span></th><th md-column width=\"20%\" \nmd-order-by=\"count\"><span>COUNT</span></th><th md-column width=\"20%\" md-numeric md-order-by=\"total\"><span>\nAvg.{{\'FOOD.SALES\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nng-repeat=\"food in food_beverage  | orderBy: inventory_food.order : true | filter : vm.foodsearch | limitTo: inventory_food.limit: (inventory_food.page - 1) * inventory_food.limit\">\n<td md-cell ng-class=\"paidbill.status \" class=\"border-status\">{{food.sales_items}}</td><td md-cell>{{food.count}}</td>\n<td md-cell>{{food.total | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"inventory_food.limit \" md-limit-options=\"[10]\" md-page=\"inventory_food.page \" \nmd-limit=\"inventory_food.order\" md-total=\"{{inventory_food_count}} \" md-page-select></md-table-pagination>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row \" flex=\"100 \" flex-gt-md=\"50 \"><ms-widget-front \nclass=\"white-bg\"><div class=\"light-blue\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" flex=\"100\" \nclass=\"analy-inner-tab\"><md-nav-bar class=\"flex\" md-selected-nav-item=\"currentNavItem\" \nnav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"goto(\'diet-in\')\" name=\"rawmaterial\" \nng-if=\"inventoryHide.length&&rawHide.length\"><div class=\"layout-row layout-align-center-center\">\nPurchase {{\'Inventory.RAW-MATERIAL\' | translate}}</div></md-nav-item><md-nav-item md-nav-click=\"goto(\'take-away\')\" \nname=\"salematerial\" ng-if=\"inventoryHide.length&&saleHide.length\"><div class=\"layout-row layout-align-center-center\">\nPurchase {{\'Inventory.SALE-MATERIAL\' | translate}}</div></md-nav-item></md-nav-bar></div></div><div layout=\"row\" \nclass=\"week-container light-blue\" layout-align=\"start center\" ng-show=\"currentNavItem == \'rawmaterial\'\"><div \nlayout=\"row\" layout-align=\"start center\" flex class=\"mb-16 mt-8\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.rawsearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div><div \nclass=\"medium select-small mb-8\" layout=\"row\" layout-align=\"end center\" flex-none><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"raw_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular>\n<md-select ng-model=\"stu\" aria-label=\"email\" class=\"md-accent\" ng-init=\"stu = \'All\'\" ng-change=\"getRaw_items(stu)\">\n<md-option ng-repeat=\"food in vm.rmCategory\" value=\"{{food.rmCatergoryID}}\">{{food.rmCatergoryName}}</md-option>\n</md-select></div></div><div layout=\"row\" class=\"week-container light-blue\" layout-align=\"start center\" \nng-show=\"currentNavItem == \'salematerial\'\"><div layout=\"row\" layout-align=\"start center\" flex class=\"mb-16 mt-8\"><div \nclass=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input md-accent\" ng-model=\"vm.salesearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" \nflex></div></div><div class=\"medium select-small mb-8\" layout=\"row\" layout-align=\"end center\" flex-none>\n<md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"sale_load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><md-select ng-model=\"stu\" aria-label=\"email\" class=\"md-accent\" ng-init=\"stu = \'All\'\" \nng-change=\"getSale_items(stu)\"><md-option ng-repeat=\"food in vm.smCategory\" value=\"{{food.smCatergoryID}}\">\n{{food.smCatergoryName}}</md-option></md-select></div></div><div ng-show=\"currentNavItem == \'rawmaterial\'\">\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"rawmaterial_query.order\"><tr md-row><th md-column width=\"60%\">\n{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"20%\">Ordered Qty</th><th width=\"20%\" md-column \nmd-order-by=\"total\">{{\'BILLINGS.PRICE\' | translate}}</th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select \nng-repeat=\"rawmaterial in raw_data | orderBy : rawmaterial_query.order : true | filter : vm.rawsearch | limitTo: rawmaterial_query.limit: (rawmaterial_query.page - 1) * rawmaterial_query.limit\">\n<td md-cell>{{rawmaterial.rmname}}</td><td md-cell>{{rawmaterial.Qty}}</td><td md-cell>{{rawmaterial.total}}</td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"rawmaterial_query.limit \" md-limit-options=\"[10] \" \nmd-page=\"rawmaterial_query.page\" md-total=\"{{rawmaterial_count}} \" md-page-select></md-table-pagination></div><div \nng-show=\"currentNavItem == \'salematerial\'\"><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head md-order=\"salematerial_query.order\">\n<tr md-row><th md-column width=\"60%\">{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"20%\">Ordered Qty</th><th\n width=\"20%\" md-column md-order-by=\"total\">{{\'BILLINGS.PRICE\' | translate}}</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"salematerial in sale_data | orderBy : salematerial_query.order : true | filter : vm.salesearch | limitTo: salematerial_query.limit: (salematerial_query.page - 1) * salematerial_query.limit\">\n<td md-cell>{{salematerial.smname}}</td><td md-cell>{{salematerial.Qty}}</td><td md-cell>{{salematerial.total}}</td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"salematerial_query.limit \" \nmd-limit-options=\"[10]\" md-page=\"salematerial_query.page\" md-total=\"{{salematerial_count}}\" md-page-select>\n</md-table-pagination></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap ng-if=\"inventoryHide.length&&rawHide.length\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nPurchase {{\'Inventory.RAW-MATERIAL\' | translate}} {{\'BILLINGS.PAYMENT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{purchasetotal_paid+purchasetotal_balance}}</span></div><div class=\"label md-truncate\">\n{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{purchasetotal_paid}}\n</span></div><div class=\"label md-truncate\">{{\'EXPENSE.PAID-EXPENSE\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{purchasetotal_balance}}\n</span></div><div class=\"label md-truncate\">{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}</div></div></div><div \nclass=\"layout-row layout-align-start-start tax-text-container\"><div flex class=\"layout-align-center-center layout-row\">\n<span class=\"ml-16 label\">Tax Cgst- &nbsp; ₹ {{purchasetaxCgst | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Sgst- &nbsp; ₹ {{purchasetaxSgst | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Tax- &nbsp; ₹ {{purchasetax | thousandSuffix : fractionSize}}</span></div></div>\n<ms-widget-front class=\"pie-chart\"><nvd3 config=\"vm.widget34.mainChart.config\" options=\"vm.widget34.mainChart.options\" \ndata=\"vm.widget34.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\">\n<span class=\"h3\">{{\'Inventory.RAW-MATERIAL\' | translate}} {{\'EXPENSE.VENDORS\' | translate}}</span></div></div><div \nlayout=\"row\" layout-align=\"end center\" flex=\"100\" class=\"mt-8 mb-16\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.expensesearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"purchaseexpense_query.order\"><tr md-row><th md-column width=\"12%\">\n{{\'EXPENSE.vendor\' | translate}} name</th><th md-column width=\"12%\" md-column md-order-by=\"total\">\n{{\'BILLINGS.PRICE\' | translate}}</th><th md-column width=\"12%\">{{\'EXPENSE.PERCENTAGE\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select md-select=\"dessert\" \nng-repeat=\"vendor in purchaseexpense_data | orderBy : purchaseexpense_query.order : true | filter : vm.expensesearch | limitTo: purchaseexpense_query.limit: (purchaseexpense_query.page - 1) * purchaseexpense_query.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{vendor.vendor_name}}</td><td md-cell>{{vendor.total}}\n</td><td md-cell>{{vendor.total_percent | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination\n md-limit=\"purchaseexpense_query.limit \" md-limit-options=\"[10] \" md-page=\"purchaseexpense_query.page \" \nmd-total=\"{{purchaseexpense_query_count}}\" md-page-select></md-table-pagination></ms-widget-front></ms-widget></div>\n<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"inventoryHide.length&&saleHide.length\"><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">\nPurchase {{\'Inventory.SALE-MATERIAL\' | translate}} {{\'BILLINGS.PAYMENT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{saletotal_paid+saletotal_balance}}</span></div><div class=\"label md-truncate\">{{\'EXPENSE.TOTAL-EXPENSE\' | translate}}\n</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{saletotal_paid}}</span>\n</div><div class=\"label md-truncate\">{{\'EXPENSE.PAID-EXPENSE\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>{{saletotal_balance}}\n</span></div><div class=\"label md-truncate\">{{\'EXPENSE.BALANCE-EXPENSE\' | translate}}</div></div></div><div \nclass=\"layout-row layout-align-start-start tax-text-container\"><div flex class=\"layout-align-center-center layout-row\">\n<span class=\"ml-16 label\">Tax Cgst- &nbsp; ₹ {{salestaxCgst | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Sgst- &nbsp; ₹ {{salestaxSgst | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">Total Tax- &nbsp; ₹ {{salestax | thousandSuffix : fractionSize}}</span></div></div><ms-widget-front\n class=\"pie-chart\"><nvd3 config=\"vm.widget78.mainChart.config\" options=\"vm.widget78.mainChart.options\" \ndata=\"vm.widget78.mainChart.data\"></nvd3></ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-8 light-blue\" \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\">\n<span class=\"h3\">{{\'Inventory.SALE-MATERIAL\' | translate}} {{\'EXPENSE.VENDORS\' | translate}}</span></div></div><div \nlayout=\"row\" layout-align=\"end center\" flex=\"100\" class=\"mt-8 mb-16\"><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"vm.expensesearch\" type=\"text\" placeholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex></div></div></div>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" \nng-model=\"mdtableselected\"><thead md-head md-order=\"saleexpense_query.order\"><tr md-row><th md-column width=\"12%\">\n{{\'EXPENSE.vendor\' | translate}} name</th><th md-column width=\"12%\" md-column md-order-by=\"total\">\n{{\'BILLINGS.PRICE\' | translate}}</th><th md-column width=\"12%\">{{\'EXPENSE.PERCENTAGE\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"vendor in saleexpense_data | orderBy : saleexpense_query.order : true | filter : vm.expensesearch | limitTo: expense_query.limit: (saleexpense_query.page - 1) * saleexpense_query.limit\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{vendor.vendor_name}}</td><td md-cell>{{vendor.total}}\n</td><td md-cell>{{vendor.total_percent | number:2}}</td></tr></tbody></table></md-table-container><md-table-pagination\n md-limit=\"saleexpense_query.limit \" md-limit-options=\"[10] \" md-page=\"saleexpense_query.page \" \nmd-total=\"{{saleexpense_query_count}}\" md-page-select></md-table-pagination></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/cashier/dashboard/odc/odc.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><div \nclass=\"medium ph-16 filter-dropdown-lg\"><div layout=\"row\" layout-align=\"start center\"><md-select class=\"md-accent\" \nng-init=\"expense = \'LM\'\" ng-model=\"expense\" ng-change=\"changeOdc(expense,$event)\" aria-label=\"Change range\" flex=\"100\">\n<md-option ng-repeat=\"expense in expense_scheduless\" value=\"{{expense.value}}\">{{expense.name}}</md-option></md-select>\n</div></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{ \'ODC.ODC-BANQUET\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\">\n{{odc_payment.upcoming_events+odc_payment.finished_Events | thousandSuffix : fractionSize}}</div><div \nclass=\"label md-truncate\">{{ \'ODC.EVENTS\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{odc_payment.upcoming_events | thousandSuffix : fractionSize}}</span></div><div class=\"label md-truncate\">\n{{\'ODC.UPCOMING-EVENTS\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{odc_payment.finished_Events | thousandSuffix : fractionSize}}</span></div><div class=\"label md-truncate\">\n{{ \'ODC.FINISHED-EVENTS\' | translate}}</div></div></div><ms-widget-front class=\"pie-chart\"><nvd3 class=\"h-400\" \nconfig=\"vm.widget66.mainChart.config\" options=\"vm.widget66.mainChart.options\" data=\"vm.widget66.mainChart.data\"></nvd3>\n</ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"30\">\n<ms-widget-front class=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{ \'BILLINGS.PAYMENT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start flex ph-24 pv-8\"><div class=\"layout-column mt-32 w-100p\"><div \nclass=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><i class=\"icon s24 icon-currency-inr\"></i> <span><span>\n{{odc_payment.paid_totals | thousandSuffix : fractionSize}}</span></span></div><div class=\"label md-truncate\">\nTotal {{ \'BILLINGS.AMOUNT\' | translate}}</div></div><div \nclass=\"layout-row layout-align-start-start tax-text-container\"><div flex class=\"layout-align-center-center layout-row\">\n<span class=\"ml-16 label\">Total Tax- &nbsp; ₹ {{Odctax_sgst+Odctax_cgst | thousandSuffix : fractionSize}}</span> <span \nclass=\"ml-16 label\">CGST- &nbsp; ₹ {{Odctax_cgst | thousandSuffix : fractionSize}}</span> <span class=\"ml-16 label\">\nSGST- &nbsp; ₹ {{Odctax_sgst | thousandSuffix : fractionSize}}</span></div></div></div><div \nclass=\"layout-column mt-32 w-100p\"><div class=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><i class=\"icon s24 icon-currency-inr\"></i> <span><span>\n{{odc_payment.received_totals}}</span></span></div><div class=\"label md-truncate\">\n{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}}</div></div></div><div class=\"layout-column mt-32 w-100p\"><div \nclass=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><i class=\"icon s24 icon-currency-inr\"></i> <span><span>\n{{odc_payment.paid_totals-odc_payment.received_totals | thousandSuffix : fractionSize}}</span></span></div><div \nclass=\"label md-truncate\">Balance {{ \'BILLINGS.AMOUNT\' | translate}}</div></div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/cashier/dashboard/overview/overview.html","<div class=\"overview-header ph-16 layout-align-center-start\" layout=\"column\"><div layout=\"row\" class=\"w-100p\"><div \nclass=\"layout-align-start-start layout-column flex\"><h1>Today Task</h1><h3>{{todayDate | date}}</h3></div><div \nclass=\"layout-align-end-center mr-24 mt-24\" ng-if=\"vm.settings.download_daily_report\"><button \nng-click=\"pdf(document.getElementById(\'demo1\').innerHTML=Date());exportemail()\" \nclass=\"md-button md-default-theme md-ink-ripple\" type=\"button\">Download Today Report</button></div></div></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"50\" \nflex-gt-md=\"50\" ng-if=\"cashier_analytics_permission==true&&pos_today_delivery.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><h2><span translate>BILLINGS.POS-BILL</span></h2>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"doordelivery_query.order\"><tr md-row><th md-column>{{ \'BILLINGS.ORDERED-NO\' | translate}}</th>\n<th md-column>Type</th><th md-column>{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th></tr></thead><tbody md-body><tr \nmd-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in pos_today_delivery | limitTo: doordelivery_query.limit: (doordelivery_query.page - 1) * doordelivery_query.limit | filter: doordelivery_query.filter | orderBy: doordelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.currentBills\"><td md-cell ng-class=\"paidbill.status\" class=\"border-status\">\n{{paidbill.salesorder_id}}</td><td md-cell>{{paidbill.sales_dietType}}</td><td md-cell><div class=\"layout-row\">\n{{ paidbill.sales_deliveryDate | date }}, {{ getdate(paidbill.sales_deliveryTime) | date : \'shortTime\'}}</div></td>\n</tr></tbody></table></md-table-container><md-table-pagination md-limit=\"doordelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"doordelivery_query.page\" md-total=\"{{pos_today_delivery.length}}\" md-page-select>\n</md-table-pagination></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"50\" \nflex-gt-md=\"50\" ng-if=\"odc_analytics_permission==true&&odc_payment.today_events.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><h2><span translate>ODC.ODC-BANQUET</span></h2>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"odcdelivery_query.order\"><tr md-row><th md-column>{{ \'BILLINGS.ORDERED-NO\' | translate}}</th>\n<th md-column>{{ \'ODC.EVENTS\' | translate}}</th><th md-column>{{ \'ODC.EVENT-TIME\' | translate}}</th></tr></thead><tbody\n md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in odc_payment.today_events | unique:\'salesorder_id\' | limitTo: odcdelivery_query.limit: (odcdelivery_query.page - 1) * odcdelivery_query.limit | filter: odcdelivery_query.filter | orderBy: odcdelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.currentOdc\"><td md-cell ng-class=\"paidbill.status\" class=\"border-status\">\n{{paidbill.salesorder_id}}</td><td md-cell>{{getOdcCategory(paidbill)}}</td><td md-cell><div class=\"layout-row\">\n{{ paidbill.odc_deliveryDate | date }}, {{ getdate(paidbill.sales_deliveryTime) | date : \'shortTime\'}}</div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"odcdelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"odcdelivery_query.page\" md-total=\"{{odc_payment.today_events.length}}\" \nmd-page-select></md-table-pagination></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" \nflex=\"50\" flex-gt-md=\"50\" ng-if=\"expense_analytics_permission==true&&expense_today_delivery.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><h2><span translate>EXPENSE.EXPENSE</span></h2>\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"expensedelivery_query.order\"><tr md-row><th md-column>Today works</th><th md-column>Bill No\n</th><th md-column>{{ \'ODC.Category\' | translate}}</th><th md-column>{{ \'EXPENSE.DUE-DATE\' | translate}}</th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in expense_today_delivery | limitTo: expensedelivery_query.limit: (expensedelivery_query.page - 1) * expensedelivery_query.limit | filter: expensedelivery_query.filter | orderBy: expensedelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.balanceExpense\"><td md-cell>{{\'EXPENSE.EXPENSE\' | translate}}</td><td md-cell \nng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.expense_bill_id}}</td><td md-cell>\n{{paidbill.category_name}}</td><td md-cell title=\"{{paidbill.created_on | date:\'medium\'}}\"><div class=\"layout-row\">\n{{ paidbill.created_on | date }}</div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"expensedelivery_query.limit\" md-limit-options=\"[5,10,15]\" md-page=\"expensedelivery_query.page\" \nmd-total=\"{{expense_today_delivery.length}}\" md-page-select></md-table-pagination></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"50\" flex-gt-md=\"50\" \nng-if=\"rawHide.length&&inventoryRaw_today_delivery.length\"><ms-widget-front class=\"white-bg\"><div \nclass=\"layout-align-start-start ph-16\"><h2><span translate>EXPENSE.vendor</span></h2><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"rawdelivery_query.order\"><tr md-row><th md-column>Today works</th><th md-column>Bill No</th><th md-column>\n{{ \'EXPENSE.vendor\' | translate}}</th><th md-column>{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in inventoryRaw_today_delivery | limitTo: rawdelivery_query.limit: (rawdelivery_query.page - 1) * rawdelivery_query.limit | filter: rawdelivery_query.filter | orderBy: rawdelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.rmPurchasedOrder\"><td md-cell>{{\'Inventory.RAW-MATERIAL\' | translate}}</td><td \nmd-cell ng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.purchase_order_id}}</td><td md-cell>\n{{paidbill.vendor_name}}</td><td md-cell><div class=\"layout-row\">{{ paidbill.DeliveryDate | date }}</div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"rawdelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"rawdelivery_query.page\" md-total=\"{{inventoryRaw_today_delivery.length}}\" \nmd-page-select></md-table-pagination></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" \nflex=\"50\" flex-gt-md=\"50\" ng-if=\"saleHide.length&&inventorySale_today_delivery.length\"><ms-widget-front \nclass=\"white-bg\"><div class=\"layout-align-start-start ph-16\"><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"saledelivery_query.order\"><tr md-row><th md-column>Today works</th><th md-column>Bill No</th><th md-column>\n{{ \'EXPENSE.vendor\' | translate}}</th><th md-column>{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"paidbill in inventorySale_today_delivery | limitTo: saledelivery_query.limit: (saledelivery_query.page - 1) * saledelivery_query.limit | filter: saledelivery_query.filter | orderBy: saledelivery_query.order\" \nclass=\"cursor-pointer\" ui-sref=\"app.smSalesOrder\"><td md-cell>{{\'Inventory.SALE-MATERIAL\' | translate}}</td><td \nmd-cell ng-class=\"paidbill.status\" class=\"border-status\">{{paidbill.inventory_salesOrder_id}}</td><td md-cell>\n{{paidbill.vendor_name}}</td><td md-cell><div class=\"layout-row\">{{ paidbill.DeliveryDate | date }}</div></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-limit=\"saledelivery_query.limit\" \nmd-limit-options=\"[5,10,15]\" md-page=\"saledelivery_query.page\" md-total=\"{{inventorySale_today_delivery.length}}\" \nmd-page-select></md-table-pagination></div></ms-widget-front></ms-widget></div><div \nclass=\"layout-align-start-start ph-24\" \nng-if=\"inventorySale_today_delivery.length==0&&inventoryRaw_today_delivery.length==0&&expense_today_delivery.length==0&&odc_payment.today_events.length==0&&pos_today_delivery.length==0\">\n<h3 class=\"text-left mt-40\">There\'re no today task for you to see.</h3></div>");
$templateCache.put("app/main/cashier/dashboard/pos-billing/pos-billing.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><div layout=\"row\" flex \nng-if=\"stewardappHide\"><div class=\"dropdown\"><span class=\"dropbtn\">Print Today Report <i \nclass=\"icon s16 icon-menu-down\"></i></span><div class=\"dropdown-content\"><a ng-click=\"printToCart(\'printSectionId\')\">\nAmount Report</a> <a ng-click=\"printToCart(\'OrderedDetails\')\">Sales Items Report</a></div></div></div><div \nclass=\"medium ph-16 filter-dropdown-lg\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"small-date-icon small no-error\"><div class=\"hide-date-picker-icon\"><md-input-container \nclass=\"md-block md-accent\"><md-datepicker ng-model=\"myDate\" md-placeholder=\"Enter date\" md-min-date=\"minDate\" \nmd-max-date=\"maxDate\" ng-change=\"changeDate(myDate)\"></md-datepicker></md-input-container></div><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div></div>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"stewardappHide\"><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"70\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">{{ \'BILLINGS.AMOUNT\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{dinein_amount+takeaway_amount+doordelivery_amount | thousandSuffix : 5}}</span></div><div class=\"label md-truncate\">\n{{ \'BILLINGS.Total Amount\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{total_cash+total_card+orderedtotal_cash+orderedtotal_card | thousandSuffix : 5}}</span></div><div \nclass=\"label md-truncate\">{{ \'BILLINGS.RECEIVED-AMOUNT\' | translate}}</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span>\n{{(dinein_amount+takeaway_amount+doordelivery_amount)-(total_cash+total_card+orderedtotal_cash+orderedtotal_card) | thousandSuffix : 5}}\n</span></div><div class=\"label md-truncate\">Balance {{ \'BILLINGS.AMOUNT\' | translate}}</div></div></div><div \nclass=\"layout-row layout-align-start-start tax-text-container\"><div flex \nclass=\"layout-align-center-center layout-row layout-xs-column layout-align-xs-center-center layout-sm-column layout-align-sm-center-center\">\n<span class=\"ml-16 label\" ng-if=\"vm.settings.dinein_permission\"><span translate>BILLINGS.DIET-IN</span>\n &nbsp; ₹ {{dinein_amount | thousandSuffix : 5}}</span> <span class=\"ml-16 label\" \nng-if=\"vm.settings.takeaway_permission\"><span translate>BILLINGS.TAKE-AWAY</span>\n &nbsp; ₹ {{takeaway_amount | thousandSuffix : 5}}</span> <span class=\"ml-16 label\" \nng-if=\"vm.settings.doordelivery_permission\"><span translate>BILLINGS.DOOR-DELIVERY</span>\n &nbsp; ₹ {{doordelivery_amount | thousandSuffix : 5}}</span></div><div flex \nclass=\"layout-align-center-center layout-row layout-xs-column layout-align-xs-center-center layout-sm-column layout-align-sm-center-center\">\n<span class=\"ml-16 label\">Total Tax- &nbsp; ₹ {{tax_sgst+tax_cgst | thousandSuffix : 5}}</span> <span \nclass=\"ml-16 label\">CGST- &nbsp; ₹ {{tax_cgst | thousandSuffix : 5}}</span> <span class=\"ml-16 label\">\nSGST- &nbsp; ₹ {{tax_sgst | thousandSuffix : 5}}</span></div></div><ms-widget-front class=\"pie-chart\"><nvd3 \nconfig=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3>\n<div class=\"layout-row layout-align-start-start tax-text-container mt-8 mb-24\"><div flex \nclass=\"layout-align-center-center layout-row layout-xs-column layout-align-xs-center-center layout-sm-column layout-align-sm-center-center\">\n<span class=\"ml-16 label\" ng-repeat=\"onlinetype in onlinePaymentTypeAmount\">\n{{ getOnlineTypeNames(onlinetype) }} &nbsp; ₹ {{onlinetype.names | thousandSuffix : 5}}</span></div></div>\n</ms-widget-front></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"30\">\n<ms-widget-front class=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{ \'BILLINGS.TODAY-HOT-SALES\' | translate}}</span></div></div><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" class=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"posbill_query.order\"><tr md-row><th md-column width=\"70%\"><span>{{ \'BILLINGS.ITEMS\' | translate}}</span></th>\n<th md-column width=\"30%\" md-numeric md-order-by=\"count\"><span>{{ \'BILLINGS.SALES-COUNT\' | translate}}</span></th></tr>\n</thead><tbody md-body><tr md-row md-auto-select md-select=\"dessert\" \nng-repeat=\"posbill in posbill_data  | orderBy: posbill_query.order : true | filter : vm.foodsearch | limitTo: posbill_query.limit: (posbill_query.page - 1) * posbill_query.limit\">\n<td md-cell ng-class=\"paidbill.status \" class=\"border-status\">{{posbill.sales_items}}</td><td md-cell>{{posbill.count}}\n</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"posbill_query.limit \" \nmd-limit-options=\"[10]\" md-page=\"posbill_query.page \" md-limit=\"posbill_query.order\" md-total=\"{{posbill_count}}\" \nmd-page-select></md-table-pagination></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"stewardappHide\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"40\"><ms-widget-front \nclass=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{ \'BILLINGS.POS-BILL\' | translate}}</span></div></div>\n<div class=\"layout-column mt-32\"><div class=\"cash-count-widget layout-column layout-align-center-center flex\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{dinein_total+takeaway_total+doordelivery_total}}</span>\n</div><div class=\"label md-truncate\">Total {{ \'BILLINGS.POS-BILL\' | translate}}</div></div></div><div \nclass=\"layout-column layout-align-start-start flex mt-32 ph-24 pv-8\" ng-if=\"cashier_analytics_permission==true\"><div \nclass=\"layout-column layout-align-start-start flex w-100p\" ng-if=\"vm.settings.dinein_permission\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"font-size-px-36\">{{dinein_total}}</span></div><div \nclass=\"label md-truncate\">{{ \'BILLINGS.DIET-IN\' | translate}}</div><div \nclass=\"font-weight-500 secondary-text text-align-right w-100p\">{{dinein_percent | number:2}}%</div><md-progress-linear \nclass=\"md-accent flex mt-16\" md-mode=\"determinate\" value=\"{{dinein_percent}}\"></md-progress-linear></div><div \nclass=\"layout-column layout-align-start-start flex w-100p\" ng-if=\"vm.settings.takeaway_permission\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"font-size-px-36\">{{takeaway_total}}</span></div><div \nclass=\"label md-truncate\">{{ \'BILLINGS.TAKE-AWAY\' | translate}}</div><div \nclass=\"font-weight-500 secondary-text text-align-right w-100p\">{{takeaway_percent | number:2}}%</div>\n<md-progress-linear class=\"md-accent flex mt-16\" md-mode=\"determinate\" value=\"{{takeaway_percent}}\">\n</md-progress-linear></div><div class=\"layout-column layout-align-start-start flex w-100p mb-24\" \nng-if=\"vm.settings.doordelivery_permission\"><div class=\"title layout-row layout-align-center-center\"><span \nclass=\"font-size-px-36\">{{doordelivery_total}}</span></div><div class=\"label md-truncate\">\n{{ \'BILLINGS.DOOR-DELIVERY\' | translate}}</div><div class=\"font-weight-500 secondary-text text-align-right w-100p\">\n{{doordelivery_percent | number:2}}%</div><md-progress-linear class=\"md-accent flex mt-16\" md-mode=\"determinate\" \nvalue=\"{{doordelivery_percent}}\"></md-progress-linear></div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"60\" ng-if=\"thirdparty_length&&vm.settings.thirdparty_permission\"><ms-widget-front \nclass=\"white-bg layout-column\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{ \'BILLINGS.THIRD-PARTY-INTEGRATION\' | translate}}\n</span></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" \nclass=\"p-16 mt-8\" ng-model=\"mdtableselected\"><thead md-head md-order=\"thirdparty_query.order\"><tr md-row><th md-column \nwidth=\"60%\"><span>{{ \'BILLINGS.THIRD-PARTY\' | translate}}</span></th><th md-column width=\"20%\" md-numeric \nmd-order-by=\"count\"><span>{{ \'BILLINGS.SALES-COUNT\' | translate}}</span></th><th md-column width=\"20%\" md-numeric \nmd-order-by=\"total\"><span>{{ \'BILLINGS.Total Amount\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select md-select=\"dessert\" \nng-repeat=\"thirdpartys in thirdparty  | orderBy: thirdparty_query.order : true | filter : vm.foodsearch | limitTo: thirdparty_query.limit: (thirdparty_query.page - 1) * thirdparty_query.limit\">\n<td md-cell ng-class=\"paidbill.status \" class=\"border-status\">{{thirdpartys.thirdparty_name}}</td><td md-cell>\n{{thirdpartys.count}}</td><td md-cell>{{thirdpartys.total}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"thirdparty_query.limit \" md-limit-options=\"[10]\" md-page=\"thirdparty_query.page \" \nmd-limit=\"thirdparty_query.order\" md-total=\"{{thirdparty_length}}\" md-page-select></md-table-pagination>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"stewardappShow\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h3\">Orders</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-space-around-center count-container\" \nlayout=\"row\"><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{dinein_total+takeaway_total+doordelivery_total}}</span>\n</div><div class=\"label md-truncate\">Total Orders</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{overview_posOrder_countt}}</span></div><div \nclass=\"label md-truncate\">Pending Orders</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>\n{{(dinein_total+takeaway_total+doordelivery_total) - overview_posOrder_countt }}</span></div><div \nclass=\"label md-truncate\">Finished Orders</div></div></div><ms-widget-front class=\"pie-chart\"><nvd3 \nconfig=\"vm.widget67.mainChart.config\" options=\"vm.widget67.mainChart.options\" data=\"vm.widget67.mainChart.data\"></nvd3>\n</ms-widget-front></ms-widget-front></ms-widget><div id=\"printSectionId\" style=\"display: none\"><div id=\"printID\"><h4>\n{{ReportTime | date:\'medium\'}}</h4><table class=\"item-table\"><tbody><tr><td>Cash</td><td class=\"right\">\n₹ {{total_cashh}}</td></tr><tr><td>Online</td><td class=\"right\">₹ {{total_cardd}}</td></tr><tr \nng-if=\"purchasetotal_balancee\"><td>Balance</td><td class=\"right\">₹ {{purchasetotal_balancee}}</td></tr><tr \nclass=\"total-saving\"><td>Total Amount</td><td class=\"right\">₹ {{total_cashh + total_cardd}}</td></tr><tr \nng-if=\"vm.settings.dinein_permission\"><td>Dine in</td><td class=\"right\">{{dinein_totall}}</td></tr><tr \nng-if=\"takeaway_totall\"><td>Take Away</td><td class=\"right\">{{takeaway_totall}}</td></tr><tr \nng-if=\"doordelivery_totall\"><td>Door Delivery</td><td class=\"right\">{{doordelivery_totall}}</td></tr><tr \nclass=\"total-saving\"><td>Total Ordered</td><td class=\"right\">{{dinein_totall+takeaway_totall+ doordelivery_totall}}\n</td></tr><tr class=\"total-saving\"><td>Total Expense</td><td class=\"right\">{{total_paidd}}</td></tr></tbody></table>\n<style type=\"text/css\">\n/* @page {\r\n      size: auto;\r\n      margin: 0mm;\r\n    } */\r\n\r\n      #printID .item-table {\r\n        width: 100%;\r\n        color: #000;\r\n        border-spacing: 0;\r\n        margin: 0 auto;\r\n      }\r\n\r\n      #printID .text-right {\r\n        text-align: right;\r\n      }\r\n\r\n      #printID {\r\n        width: 94%;\r\n        color: #000;\r\n        letter-spacing: -0.8px;\r\n        font-family: \'Anonymous Pro\';\r\n        margin: 0 auto;\r\n        box-sizing: border-box;\r\n        word-spacing: -5px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID th {\r\n        border-top: 2px dashed #000;\r\n        border-bottom: 2px dashed #000;\r\n        padding: 4px 4px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      #printID td {\r\n        padding: 4px 5px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      h4 {\r\n        font-size: 15px !important;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID .total-saving td {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        font-size: 18px !important;\r\n        border-top: 1px dashed #000;\r\n        border-bottom: 1px dashed #000;\r\n      }\n</style></div></div><div id=\"OrderedDetails\" style=\"display: none\"><div id=\"printID\"><h4>{{ReportTime | date:\'medium\'}}\n</h4><table class=\"item-table\"><thead><th width=\"70%\">Item Name</th><th width=\"30%\">Sales Count</th></thead><tbody><tr \nng-repeat=\"puchaseData in items_Data\"><td width=\"70%\">{{puchaseData.sales_items}}</td><td class=\"right\" width=\"30%\">\n{{puchaseData.count}}</td></tr></tbody></table><style type=\"text/css\">\n/*  @page {\r\n      size: auto;\r\n      margin: 0mm ;\r\n    } */\r\n\r\n      #printID .item-table {\r\n        width: 100%;\r\n        color: #000;\r\n        border-spacing: 0;\r\n        margin: 0 auto;\r\n      }\r\n\r\n      #printID .text-right {\r\n        text-align: right;\r\n      }\r\n\r\n      #printID {\r\n        width: 94%;\r\n        color: #000;\r\n        letter-spacing: -0.8px;\r\n        font-family: \'Anonymous Pro\';\r\n        margin: 0 auto;\r\n        box-sizing: border-box;\r\n        word-spacing: -5px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID th {\r\n        border-top: 2px dashed #000;\r\n        border-bottom: 2px dashed #000;\r\n        padding: 4px 4px;\r\n        font-size: 14px;\r\n        text-align: left;\r\n      }\r\n\r\n      #printID td {\r\n        padding: 4px 5px;\r\n        font-size: 14px;\r\n      }\r\n\r\n      h4 {\r\n        font-size: 15px !important;\r\n        font-weight: 700;\r\n      }\r\n\r\n      #printID .total-saving td {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        font-size: 18px !important;\r\n        border-top: 1px dashed #000;\r\n        border-bottom: 1px dashed #000;\r\n      }\n</style></div></div></div>");
$templateCache.put("app/main/cashier/dashboard/sms-marketing/sms-marketing.html","<div layout=\"row\" flex=\"100\" layout-align=\"end center\" class=\"dashboard-filter-container\"><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"inventory_foodSms_load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular><div class=\"medium ph-16 filter-dropdown-lg\"><md-select class=\"md-accent\" ng-init=\"sms = \'LM\'\" \nng-model=\"sms\" ng-change=\"SmsChange(sms,$event)\" aria-label=\"Change range\"><md-option ng-repeat=\"sms in vm.sms_date\" \nvalue=\"{{sms.value}}\">{{sms.name}}</md-option></md-select></div></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"inventoryHide.length&&saleHide.length\"><ms-widget flippable=\"false\" layout=\"row\" \nflex=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nCampaign {{\'BILLINGS.SMS-MARKETING\' | translate}}</span></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{sms_data.totalcampaign}}</span></div><div \nclass=\"label md-truncate\">Total Campaign</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{sms_data.total}}</span></div><div \nclass=\"label md-truncate\">Sent</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{sms_data.DELIVERED}}</span></div><div \nclass=\"label md-truncate\">Delivered</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\">\n<div class=\"title layout-row layout-align-center-center\"><span>{{sms_data.PENDING}}</span></div><div \nclass=\"label md-truncate\">Pending</div></div><div class=\"cash-count-widget layout-column layout-align-center-center\">\n<div class=\"title layout-row layout-align-center-center\"><span>{{sms_data.FAILED}}</span></div><div \nclass=\"label md-truncate\">Failed</div></div></div><div class=\"layout-row layout-align-start-start tax-text-container\">\n<div flex class=\"layout-align-center-center layout-row\"><span class=\"ml-16 label\">\nRemaining Total Sms- &nbsp; {{sms_count[0].promotionalCount+sms_count[0].transcationalCount}}</span> <span \nclass=\"ml-16 label\">Promotional Sms- &nbsp; {{sms_count[0].promotionalCount}}</span> <span class=\"ml-16 label\">\nTranscational Sms- &nbsp; {{sms_count[0].transcationalCount}}</span></div></div><ms-widget-front class=\"pie-chart\">\n<nvd3 config=\"vm.widget79.mainChart.config\" options=\"vm.widget79.mainChart.options\" data=\"vm.widget79.mainChart.data\">\n</nvd3></ms-widget-front></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/cashier/dealer/add-dealer_order/addDealer.html","<form class=\"newbill w-100p layout-fill small no-error\" name=\"newsales\" novalidate style=\"position: relative\"><div \nclass=\"layout-row min-height-100 md-whiteframe-2dp white-bg\"><div class=\"flex-none left-side-ver-tab\"><ul \nclass=\"pr-tabs\"><li class=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'tabBillInfo\'}\" \nng-click=\"prTabName =\'tabBillInfo\';expensebills()\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newsales.rate.$invalid || odcBill.autocompleteFood.$invalid || newsales.autocompleteVendor.$invalid || newsales.DueDate.$invalid ||  newsales.eventDate.$invalid || newsales.status.$invalid || newsales.quantity.$invalid) && (newsales.$submitted)} \">\nDealer Order Info</span></li><li class=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'tabPayment\'}\" \nng-click=\"prTabName =\'tabPayment\';payment()\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newsales.payment_details.$invalid || newsales.cheque_no.$invalid ||  newsales.paid_date.$invalid || newsales.received_amount.$invalid || newsales.amountType.$invalid ||  newsales.transcation_no.$invalid) && (newsales.$submitted)} \">\n<span translate>BILLINGS.PAYMENT</span></span></li></ul></div><div class=\"pr-tab-contents flex\" ng-switch=\"prTabName\">\n<div class=\"pr-tab-content layout-fill\" ng-show=\"expensebill\"><div \nng-include=\"\'app/main/cashier/dealer/add-dealer_order/dealer-order-info/add_dealer.html\'\" class=\"layout-fill\"></div>\n</div><div class=\"pr-tab-content\" ng-show=\"payments\"><div \nng-include=\"\'app/main/cashier/dealer/add-dealer_order/sale-material-payment/payment.html\'\"></div></div><div \nclass=\"fix-bottom pt-8 pl-16\"><div class=\"layout-row center-end small-fix-bottom-button\"><div \nclass=\"layout-row center-end flex\" ng-if=\"!params.id\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"cancel($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary big layout-row layout-align-center-center\" ng-click=\"add_purchase()\">Save</md-button></div>\n<div ng-if=\"params.id\" class=\"layout-row layout-align-space-between-center m-w-860\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"canceledit($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary layout-row layout-align-center-center\" ng-click=\"update_purchase()\">Save</md-button></div>\n</div></div></div></div></form>");
$templateCache.put("app/main/cashier/dealer/dealer-order/sm-dealer-order.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-md\"><md-datepicker ng-model=\"monthyear\" aria-label=\"email\" md-max-date=\"maxDate\" \nng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" ng-required=\"dateFields[2].required\" \nmd-date-locale=\"dateFields[2].locale\" md-mode=\"{{dateFields[2].mode}}\" md-open-on-focus=\"true\"></md-datepicker></div>\n<div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"vendor\" aria-label=\"email\" \nng-init=\"vendor=vm.vendor[0].vendorID\" ng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"vendor in vm.vendor\" value=\"{{vendor.vendorID}}\">\n{{vendor.vendor_name}}</md-option></md-select></div><div ng-show=\"permission\" ng-hide=\"!permission\" \nclass=\"medium ph-8 filter-dropdown-sm\"><md-select ng-model=\"staffss\" aria-label=\"email\" \nng-init=\"staffss=vm.staffRole[0].staffID\" \nng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" class=\"md-accent\" flex=\"100\"><md-option\n ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></div><div \nng-if=\"vm.getpurchase.length>0\" class=\"layout-align-start-start ph-12\"><table style=\"display: none\"><tr><th>Ordered No\n</th><th>{{\'BILLINGS.ITEMS\' | translate}}</th><th>Total {{\'BILLINGS.AMOUNT\' | translate}}</th><th>Advance paid</th><th>\n{{\'EXPENSE.Balance\' | translate}} Amount</th><th>{{ \'BILLINGS.CGST\' | translate}}</th><th>\n{{ \'BILLINGS.SGST\' | translate}}</th><th>{{ \'BILLINGS.DISCOUNT\' | translate}}</th><th>{{\'EXPENSE.vendor\' | translate}}\n</th><th>Payment Status</th><th>Due/ {{\'EXPENSE.PAID-DATE\' | translate}}</th><th></th><th>\nOrderd {{\'BILLINGS.STATUS\' | translate}}</th><th>{{\'Inventory.DeliveryDate\' | translate}}</th><th></th><th \nng-if=\"permission!=admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th>{{\'Inventory.CREATED ON\' | translate}}</th>\n</tr><tr ng-repeat=\"rmPurchasedOrder in vm.getpurchase\"><td>{{rmPurchasedOrder.purchase_order_id}}</td><td>\n{{ rmPurchasedOrder.rmname }}</td><td>{{rmPurchasedOrder.total_amount}}</td><td>{{rmPurchasedOrder.received_amount}}\n</td><td>\n{{ rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount==rmPurchasedOrder.total_amount ? 0 : rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount }}\n</td><td>{{rmPurchasedOrder.tax_cgst }}</td><td>{{rmPurchasedOrder.tax_sgst}}</td><td>{{rmPurchasedOrder.discount}}\n</td><td>{{ rmPurchasedOrder.vendor_name }}</td><td>{{ rmPurchasedOrder.payment_status }}</td><td>\n{{ rmPurchasedOrder.due_date | date }}</td><td>{{ rmPurchasedOrder.purchaseStatus}}</td><td>\n{{rmPurchasedOrder.DeliveryDate | date}}</td><td ng-if=\"permission!=admin\">\n{{purchaseorder_staffnames(rmPurchasedOrder) }}</td><td>{{ rmPurchasedOrder.created_on | date}}</td></tr></table></div>\n<md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" \ntype=\"text\" placeholder=\"search {{\'Inventory.PURCHASED-NO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex>\n<md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" \nng-if=\"purchaseorder_query.filter\" ng-click=\"clearText()\"></md-icon></div></div><div \nclass=\"layout-align-start-start ph-16\"><md-table-container><table id=\"tableid\" md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"purchaseorder_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"10%\">Ordered No</th>\n<th md-column width=\"5%\">{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"9%\">\n{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column width=\"15%\">{{\'EXPENSE.Balance\' | translate}}</th><th md-column \nwidth=\"9%\">Dealer Name</th><th md-column width=\"10%\">DUE/{{\'EXPENSE.PAID-DATE\' | translate}}</th><th md-column \nwidth=\"19%\">{{\'BILLINGS.STATUS\' | translate}}</th><th md-column ng-if=\"permission!=admin\" width=\"10%\">\n{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">{{\'BILLINGS.ACTIONS\' | translate}}</th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"rmPurchasedOrder in vm.getpurchase | limitTo: purchaseorder_query.limit: (purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order\">\n<td md-cell ng-class=\"currentbill.status\" class=\"border-status\">{{rmPurchasedOrder.purchase_order_id}}</td><td md-cell>\n{{ rmPurchasedOrder.rmname }}</td><td md-cell><div class=\"layout-row layout-align-start-center\"><span \nclass=\"grey-col-sec-text pr-2\" translate>BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ rmPurchasedOrder.total_amount }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\"><span \ntranslate class=\"warm-color\" \nng-if=\"rmPurchasedOrder.received_amount > \'0\'  || rmPurchasedOrder.payment_status==\'unpaid\'\">BILLINGS.INR</span> <span \nng-show=\"rmPurchasedOrder.received_amount > \'0\' || rmPurchasedOrder.payment_status==\'unpaid\'\" \nclass=\"font-size-px-18 warm-color\">{{ rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount }}</span> <span \nclass=\"font-size-px-18\" ng-if=\"rmPurchasedOrder.received_amount == \'0\'  && rmPurchasedOrder.payment_status!=\'unpaid\'\">\n{{\'0\'}}</span> <span class=\"flex-none adv-amount\" ng-if=\"rmPurchasedOrder.received_amount > \'0\'\">\nadv {{ rmPurchasedOrder.received_amount }}</span></td><td md-cell>{{ rmPurchasedOrder.vendor_name }}</td><td md-cell>\n{{rmPurchasedOrder.due_date==\'undefined\' || rmPurchasedOrder.due_date==\'null\' ? \'-\' : rmPurchasedOrder.due_date | date}}\n</td><td md-cell title=\"{{ rmPurchasedOrder.deli_time }}\"><div class=\"layout-row\"><span \nclass=\"text-boxed badge food-badge ng-binding food-ordered\" \nng-class=\"{ \'ordered\': \'food-ordered\', \'delivered\': \'food-bill-printed\'}[rmPurchasedOrder.purchaseStatus]\">\n{{ rmPurchasedOrder.purchaseStatus}}</span> <span class=\"flex-none ml-8 sub-text\" \ntitle=\"{{ rmPurchasedOrder.deli_time }}\" ng-if=\"rmPurchasedOrder.purchaseStatus==\'delivered\'\">\n{{ rmPurchasedOrder.purchaseStatus==\'ordered\' ? \'Expected\' : \'Delivered\'}} date<br>\n{{rmPurchasedOrder.DeliveryDate | date }}</span><md-icon \ntitle=\"Last updated by  {{update_staff(rmPurchasedOrder)}} ,on {{rmPurchasedOrder.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></div></td><td md-cell \nng-if=\"permission!=admin\">{{purchaseorder_staffnames(rmPurchasedOrder) }}</td><td><md-icon md-menu-origin \nmd-font-icon=\"icon-attachment\" ng-if=\"rmPurchasedOrder.attached == \'yes\'\"></md-icon><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"purchaseid(rmPurchasedOrder.purchase_order_id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"removeRow(rmPurchasedOrder,$event,$index); $event.stopPropagation();\"><md-icon class=\"text-black-24\" \nmd-font-icon=\"icon icon-trash\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><div class=\"layout-column layout-align-center-center no-data padding-32\" \nng-if=\"vm.getpurchase.length==0\"><h3>There\'re no purchase ordered for you to see.</h3></div></md-table-container>\n<md-table-pagination md-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"purchaseorder_query.page\" md-total=\"{{purchaseorder_count}}\" md-page-select></md-table-pagination></div></div>\n<div class=\"paid-fix md-accent-bg\" ng-if=\"vm.getpurchase.length>0\"><div layout=\"row\" layout-align=\"start start\"><div \nflex-none class=\"paid-each-container\"><span class=\"title\">Paid Amount</span> <span class=\"inr\" translate>BILLINGS.INR\n</span> <span class=\"amount\">{{total_paid}}</span><span title=\"purchase ordered\" class=\"paid_count\"><img \nsrc=\"assets/icons/order-icon.svg\"> {{paid_count}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">Balance Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{balance}}\n</span><span title=\"purchase ordered\" class=\"paid_count\"><img src=\"assets/icons/order-icon.svg\"> {{balance_count}}\n</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In cash</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_cash}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In card</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_card}}</span>\n</div><div flex-none class=\"paid-each-container\"><span class=\"title\">In cheque</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_cheque}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In online</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_online}}\n</span></div></div></div></section>");
$templateCache.put("app/main/cashier/expense/balance-expense/balance-expense.html","<div \nclass=\"layout-column layout-align-center-center min-height-100 text-center no-data md-whiteframe-2dp white-bg padding-16\" \nng-if=\"vm.balancebill.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 \nclass=\"text-center md-display-1\">Hi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no current Expensebills for you to see. If you want to create a new Expensebill just click below button and go ahead\n</h3><md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.newExpense\">\nNew Expense</md-button></div><section \nclass=\"paid-container inner-content layout-column min-height-100 white-bg md-whiteframe-4dp\" \nng-if=\"vm.balancebill.length>0 || retrieve\"><div layout=\"column\" flex><div layout=\"row\" layout-align=\"center start\" \nclass=\"mb-16 no-error small\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"balexpense_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"balexpense_query.filter\" \nng-click=\"clearTextss()\"></md-icon></div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"balexpense_query.order\" md-on-reorder=\"getDesserts\"><tr md-row><th md-column>{{\'EXPENSE.BILLNO\' | translate}}\n</th><th md-column class=\"hidebelow600\">{{\'ODC.Category\' | translate}}</th><th md-column>\n{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column>{{\'EXPENSE.Balance\' | translate}}</th><th md-column \nng-if=\"permission==admin\" class=\"hidebelow600\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column \nng-if=\"vm.settings.exp_vendor\" class=\"hidebelow600\">{{\'EXPENSE.VENDOR/PERSON\' | translate}}</th><th md-column \nng-if=\"vm.settings.exp_duedate\" class=\"hidebelow600\">{{\'EXPENSE.DUE-DATE\' | translate}}</th><th md-column><span>\n{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.balancebill | limitTo: balexpense_query.limit: (balexpense_query.page - 1) * balexpense_query.limit | filter: balexpense_query.filter | orderBy: balexpense_query.order\">\n<td md-cell>{{ balExpBill.expense_bill_id }}</td><td md-cell class=\"hidebelow600\">{{ balExpBill.category_name }}</td>\n<td md-cell><div class=\"layout-row layout-align-start-center\"><span translate class=\"grey-col-sec-text pr-2\">\nBILLINGS.INR</span> <span class=\"font-size-px-18\">{{ balExpBill.total_amount }}</span></div></td><td md-cell \ntitle=\"{{currentbill.showdeliverdate}}\"><span translate class=\"warm-color\">BILLINGS.INR</span> <span \nclass=\"font-size-px-18 warm-color\">{{ balExpBill.total_amount - balExpBill.received_amount }}</span> <span \nclass=\"flex-none adv-amount\" ng-if=\"balExpBill.received_amount > \'0\'\">adv {{ balExpBill.received_amount }}</span></td>\n<td md-cell ng-if=\"permission==admin\" class=\"hidebelow600\">{{ balexpense_staffnames(balExpBill) }}<md-icon \ntitle=\"Last updated by  {{ update_staff(balExpBill)}} ,on {{ balExpBill.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \ntitle=\"{{paidbill.deliveredFullTime}}\" ng-if=\"vm.settings.exp_vendor\" class=\"hidebelow600\">{{ balExpBill.vendor_name }}\n</td><td md-cell ng-if=\"vm.settings.exp_duedate\" class=\"hidebelow600\">{{ balExpBill.due_date | date }} <span \nclass=\"text-boxed badge food-badge\" \nng-class=\"{ \'low\': \'remaining-low\', \'med\': \'remaining-med\', \'high\': \'remaining-high\', \'null\': \'display-none\' }[balExpBill.status]\">\n{{ balExpBill.remaining }}</span></td><td ng-if=\"permission==admin || expenseeditt.length || expensedeletee.length\">\n<md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" \nng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"permission==admin || expenseeditt.length\"><md-button \nng-click=\"balexpense(balExpBill.expense_bill_id)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\nView & Edit</md-button></md-menu-item><md-menu-item ng-if=\"permission==admin || expensedeletee.length\"><md-button \nng-click=\"removeRow(balExpBill,$event,$index)\"><md-icon class=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon>\n<span>Delete</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"balexpense_query.limit\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"balexpense_query.page\" md-total=\"{{paidexpense_count}}\" md-on-paginate=\"getDessertsss\" md-page-select>\n</md-table-pagination></div></div><div class=\"paid-fix md-accent-bg\" ng-if=\"vm.balancebill.length>0\"><div layout=\"row\" \nlayout-align=\"start start\"><div flex-none class=\"paid-each-container\"><span class=\"title\">\nTotal {{\'EXPENSE.EXPENSE\' | translate}}</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">\n{{total_expense}}</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">Total Advance paid</span> \n<span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_advance}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">Total Balance</span> <span class=\"inr\" translate>BILLINGS.INR</span> \n<span class=\"amount\">{{total_expense - total_advance}}</span></div></div></div></section><md-content \nstyle=\"display: none\" class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" ng-controller=\"printbillController as vm\" ms-scroll>\n</md-content>");
$templateCache.put("app/main/cashier/expense/balance-expense/balanceExpense.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg\"><md-nav-bar class=\"flex-none\" \nmd-selected-nav-item=\"currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"goto(\'diet-in\')\" name=\"diet-in\"><div class=\"layout-row layout-align-center-center\"><span translate>\ngeneral</span> <span class=\"badge badge-circle margin-left-8\">{{paidexpense_count}}</span></div></md-nav-item>\n</md-nav-bar><div class=\"md-nav-bar-content primary-transition flex\"><md-content \nclass=\"md-padding layout-fill scrollable\" ng-include=\"\'app/main/cashier/expense/balance-expense/balance-expense.html\'\" \nng-show=\"currentNavItem == \'diet-in\'\" ms-scroll></md-content></div></div>");
$templateCache.put("app/main/cashier/expense/new-expense/new-expense.html","<form class=\"newbill w-100p layout-fill small no-error\" name=\"newexpense\" novalidate style=\"position: relative\"><div \nclass=\"layout-row min-height-100 md-whiteframe-2dp white-bg mobile-height\" layout-xs=\"column\"><div \nclass=\"flex-none left-side-ver-tab\"><ul class=\"pr-tabs\"><li class=\"pr-tab\" \nng-class=\"{\'active\': prTabName==\'tabBillInfo\'}\" ng-click=\"prTabName =\'tabBillInfo\';expensebills()\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newexpense.item_amount.$invalid || odcBill.autocompleteFood.$invalid || newexpense.category.$invalid || newexpense.item_name.$invalid ||  newexpense.eventDate.$invalid || newexpense.receive.$invalid) && (newexpense.$submitted)} \">\n<span translate>EXPENSE.EXPENSE</span> Info</span></li><li class=\"pr-tab\" \nng-class=\"{\'active\': prTabName==\'tabPayment\'}\" ng-click=\"prTabName =\'tabPayment\';payment()\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newexpense.payment_details.$invalid || newexpense.cheque_no.$invalid || newexpense.paid_date.$invalid || newexpense.amountType.$invalid || newexpense.received_amount.$invalid || newexpense.transcation_no.$invalid) && (newexpense.$submitted)} \">\n<span translate>BILLINGS.PAYMENT</span></span></li></ul></div><div class=\"pr-tab-contents flex\" ng-switch=\"prTabName\">\n<div class=\"pr-tab-content\" ng-show=\"expensebill\"><div \nng-include=\"\'app/main/cashier/expense/new-expense/expense-info/expense-info.html\'\" class=\"layout-fill\"></div></div><div\n class=\"pr-tab-content\" ng-show=\"payments\"><div \nng-include=\"\'app/main/cashier/expense/new-expense/payment/payment.html\'\"></div></div><div class=\"pr-tab-content\" \nng-switch-when=\"recurring\"><div ng-include=\"\'app/main/cashier/expense/new-expense/recurring/recurring.html\'\"></div>\n</div><div class=\"fix-bottom pt-8 pl-16\"><div class=\"layout-row center-end small-fix-bottom-button\"><div \nclass=\"layout-row center-end flex\" ng-if=\"!params.id\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"cancel($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary big layout-row layout-align-center-center\" ng-click=\"saveBill()\">Save</md-button></div><div\n ng-if=\"params.id\" class=\"layout-row layout-align-space-between-center m-w-860\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"canceledit($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary layout-row layout-align-center-center\" ng-click=\"updateBill()\">Save</md-button></div></div>\n</div></div></div></form>");
$templateCache.put("app/main/cashier/expense/paid-expense/paid-expense.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-md small hide-date-picker-icon\" layout=\"row\"><a class=\"calendar-switch\" \nng-click=\"OpenDayWises();changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nng-show=\"OpenMonthWise\"><md-tooltip md-direction=\"top\">Change to date wise filter</md-tooltip></a><a \nclass=\"calendar-switch\" \nng-click=\"OpenMonthWises();changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nng-show=\"OpenDayWise\"><md-tooltip md-direction=\"top\">Change to month wise filter</md-tooltip></a><md-input-container \nclass=\"md-block md-accent\"><md-datepicker ng-model=\"myDates\" aria-label=\"email\" ng-show=\"OpenDayWise\" \nmd-placeholder=\"Enter date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nng-change=\"changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block md-accent\"><md-datepicker \nng-model=\"monthyear\" aria-label=\"email\" ng-show=\"OpenMonthWise\" md-max-date=\"maxDate\" \nng-change=\"changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nng-required=\"dateFields[2].required\" md-date-locale=\"dateFields[2].locale\" md-mode=\"{{dateFields[2].mode}}\" \nmd-open-on-focus=\"true\"></md-datepicker></md-input-container></div><div class=\"ph-8 filter-dropdown-sm hidebelow600\">\n<md-select ng-model=\"categoryid\" aria-label=\"email\" ng-init=\"categoryid=vm.category[0].exCatergoryID\" \nng-change=\"changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"categoryid in vm.category\" value=\"{{categoryid.exCatergoryID}}\">\n{{categoryid.exCatergoryName}}</md-option></md-select></div><div class=\"ph-8 filter-dropdown-sm\" style=\"display: none\">\n<md-select ng-model=\"payment\" aria-label=\"email\" ng-init=\"payment=vm.paymentmodelist[0].value\" \nng-change=\"changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"payment in  vm.paymentmodelist\" value=\"{{payment.value}}\">\n{{payment.label}}</md-option></md-select></div><div class=\"ph-8 filter-dropdown-sm hidebelow600\" \nng-if=\"vm.settings.exp_vendor\"><md-select ng-model=\"vendor\" aria-label=\"email\" ng-init=\"vendor=vm.vendor[0].vendorID\" \nng-change=\"changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"vendor in vm.vendor\" value=\"{{vendor.vendorID}}\">\n{{vendor.vendor_name}}</md-option></md-select></div><div ng-show=\"permission\" ng-hide=\"!permission\" \nclass=\"ph-8 filter-dropdown-sm hidebelow600\"><md-select ng-model=\"staffss\" aria-label=\"email\" \nng-init=\"staffss=vm.staffRole[0].staffID\" \nng-change=\"changeDate(OpenMonthWise ? monthyear : \'\',categoryid,payment,vendor,staffss,OpenDayWise ? myDates : \'\',$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}\n</md-option></md-select></div><div ng-if=\"vm.paidbill.length>0\" class=\"layout-align-start-start ph-12 hidebelow600\"><a \nexport-to-csv3 class=\"download-csv\"><md-tooltip md-direction=\"top\">Export data to CSV</md-tooltip></a><table \nstyle=\"display: none\"><tr><th>{{\'EXPENSE.BILLNO\' | translate}}</th><th>{{\'ODC.Category\' | translate}}</th><th>\n{{\'BILLINGS.AMOUNT\' | translate}}</th><th>{{\'BILLINGS.CGST\' | translate}}</th><th>{{\'BILLINGS.SGST\' | translate}}</th>\n<th>{{\'BILLINGS.DISCOUNT\' | translate}}</th><th ng-if=\"vm.settings.exp_vendor\">{{\'EXPENSE.VENDOR/PERSON\' | translate}}\n</th><th ng-if=\"permission==admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th>{{\'EXPENSE.PAID-DATE\' | translate}}\n</th></tr><tr ng-repeat=\"paidbill in vm.paidbill\"><td>{{paidbill.expense_bill_id}}</td><td>{{ paidbill.category_name }}\n</td><td>{{paidbill.total_amount}}</td><td>{{paidbill.tax_cgst}}</td><td>{{paidbill.tax_sgst}}</td><td>\n{{paidbill.discount}}</td><td ng-if=\"vm.settings.exp_vendor\">{{paidbill.vendor_name}}</td><td \nng-if=\"permission==admin\">{{paidexpense_staffnames(paidbill)}}</td><td>{{ formatDate(paidbill.paid_date) | date }}</td>\n</tr></table></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"balexpense_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"balexpense_query.filter\" \nng-click=\"clearTexts()\"></md-icon></div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"balexpense_query.order\" md-on-reorder=\"getDesserts\"><tr md-row><th md-column width=\"10%\">\n{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column width=\"12%\" class=\"hidebelow600\">{{\'ODC.Category\' | translate}}</th>\n<th md-column width=\"16%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column width=\"14%\" \nng-if=\"vm.settings.exp_vendor\">{{\'EXPENSE.VENDOR/PERSON\' | translate}}</th><th md-column ng-if=\"permission==admin\" \nwidth=\"12%\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"14%\" class=\"hidebelow600\">\n{{\'EXPENSE.PAID-DATE\' | translate}}</th><th md-column width=\"10%\" ng-if=\"permission==admin || expenseeditt.length\">\n<span>{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select \nng-repeat=\"paidExpBill in vm.paidbill | limitTo: balexpense_query.limit: (balexpense_query.page - 1) * balexpense_query.limit | filter: balexpense_query.filter | orderBy: balexpense_query.order\">\n<td md-cell ng-class=\"paidbill.status\" class=\"border-status\">{{ paidExpBill.expense_bill_id}}</td><td md-cell \nclass=\"hidebelow600\">{{paidExpBill.category_name }}</td><td md-cell><span translate>BILLINGS.INR</span> <span>\n{{ paidExpBill.total_amount }}</span> <span class=\"flex-none adv-amount\">\n{{ paidExpBill.payment_type==\'onlineTranscation\' ? \'online\' : paidExpBill.payment_type}}</span></td><td md-cell \nng-if=\"vm.settings.exp_vendor\">{{ paidExpBill.vendor_name }}</td><td md-cell ng-if=\"permission==admin\">\n{{ paidexpense_staffnames(paidExpBill) }}<md-icon \ntitle=\"Last updated by  {{ update_staff(paidExpBill)}} ,on {{ formatDate(paidExpBill.last_modified) | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \ntitle=\"{{paidExpBill.paidDateFullTime}}\" class=\"hidebelow600\">{{ formatDate(paidExpBill.paid_date) | date }}</td><td \nng-if=\"permission==admin || expenseeditt.length || expensedeletee.length\"><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"permission==admin || expenseeditt.length\"><md-button ng-click=\"paidexpense(paidExpBill.expense_bill_id)\">\n<md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item \nng-if=\"permission==admin || expensedeletee.length\"><md-button ng-click=\"removeRow(paidExpBill,$event,$index)\"><md-icon \nclass=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon><span>Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.paidbill.length==0\"><h3>\nThere\'re no paid bills for you to see.</h3></div></md-table-container><md-table-pagination \nmd-limit=\"balexpense_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"balexpense_query.page\" \nmd-total=\"{{paidexpense_count}}\" md-page-select></md-table-pagination></div></div><div \nclass=\"paid-fix md-accent-bg hidebelow959\" ng-if=\"vm.paidbill.length>0\"><div layout=\"row\" layout-align=\"start start\">\n<div flex-none class=\"paid-each-container\"><span class=\"title\">Total {{\'EXPENSE.EXPENSE\' | translate}}</span> <span \nclass=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_expense}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">In cash</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span \nclass=\"amount\">{{total_cash}}</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In card</span>\n <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_card}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">In cheque</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span \nclass=\"amount\">{{total_cheque}}</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In online\n</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_online}}</span></div></div></div>\n</section><md-content style=\"display: none\" class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" ng-controller=\"printbillController as vm\" ms-scroll>\n</md-content>");
$templateCache.put("app/main/cashier/expense/paid-expense/paidExpense.html","<div class=\"layout-column min-height-100 md-whiteframe-2dp white-bg\"><md-nav-bar class=\"flex-none\" \nmd-selected-nav-item=\"currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"goto(\'diet-in\')\" name=\"diet-in\"><div class=\"layout-row layout-align-center-center\"><span translate>\ngeneral</span> <span class=\"badge badge-circle margin-left-8\">{{ paidexpense_count}}</span></div></md-nav-item>\n<md-nav-item md-nav-click=\"goto(\'take-away\')\" name=\"take-away\"><div class=\"layout-row layout-align-center-center\"><span\n translate>Inventory.RAW-MATERIAL</span> <span class=\"badge badge-circle margin-left-8\">{{purchaseexpense_count}}\n</span></div></md-nav-item><md-nav-item md-nav-click=\"goto(\'door-delivery\')\" name=\"door-delivery\"><div \nclass=\"layout-row layout-align-center-center\"><span translate>Inventory.SALE-MATERIAL</span> <span \nclass=\"badge badge-circle margin-left-8\">{{salesexpense_count}}</span></div></md-nav-item></md-nav-bar><div \nclass=\"md-nav-bar-content primary-transition flex\"><md-content class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/expense/paid-expense/paid-expense.html\'\" ng-show=\"currentNavItem == \'diet-in\'\" ms-scroll>\n</md-content><md-content class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/expense/paid-expense/purchase_expense/purchase_expense.html\'\" \nng-show=\"currentNavItem == \'take-away\'\" ms-scroll></md-content><md-content class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/expense/paid-expense/sales_expense/sales_expense.html\'\" \nng-show=\"currentNavItem == \'door-delivery\'\" ms-scroll></md-content><md-content style=\"display: none\" \nclass=\"md-padding layout-fill scrollable\" ng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" \nng-controller=\"printbillController as vm\" ms-scroll></md-content></div></div>");
$templateCache.put("app/main/cashier/odc-bill/current-odc-bill/current-odc.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-md\"><md-datepicker ng-model=\"monthyear\" aria-label=\"email\" md-max-date=\"maxDate\" \nng-change=\"changeDate(amount_type,monthyear,staffss,$event)\" ng-required=\"dateFields[2].required\" \nmd-date-locale=\"dateFields[2].locale\" md-mode=\"{{dateFields[2].mode}}\" md-open-on-focus=\"true\"></md-datepicker></div>\n<div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"amount_type\" aria-label=\"email\" \nng-init=\"amount_type=vm.amount_type[0].value\" ng-change=\"changeDate(amount_type,monthyear,staffss,$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"amount_type in vm.amount_type\" value=\"{{amount_type.value}}\">\n{{amount_type.name}}</md-option></md-select></div><div ng-show=\"permission\" ng-hide=\"!permission\" \nclass=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"staffss\" aria-label=\"email\" \nng-init=\"staffss=vm.staffRole[0].staffID\" ng-change=\"changeDate(amount_type,monthyear,staffss,$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}\n</md-option></md-select></div><div ng-if=\"vm.balancebill.length>0\" class=\"layout-align-start-start ph-12\"><a \nexport-to-csv4 class=\"download-csv\"><md-tooltip md-direction=\"top\">Export all the data to CSV</md-tooltip></a><table \nstyle=\"display: none\"><tr><th style=\"color: red\">{{\'Inventory.PURCHASED-NO\' | translate}}</th><th>\n{{\'ODC.Category\' | translate}}</th><th>Total {{\'BILLINGS.AMOUNT\' | translate}}</th><th>Advance paid</th><th>\n{{\'EXPENSE.Balance\' | translate}} Amount</th><th>{{ \'BILLINGS.CGST\' | translate}}</th><th>\n{{ \'BILLINGS.SGST\' | translate}}</th><th>Additonal Charge</th><th>{{ \'BILLINGS.DISCOUNT\' | translate}}</th><th>\n{{\'BILLINGS.CUSTOMER\' | translate}}</th><th>Payment Status</th><th>Event Date</th><th></th><th>\n{{\'ODC.EVENT-TIME\' | translate}}</th><th ng-if=\"permission==admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th>\n{{\'EXPENSE.PAID-DATE\' | translate}}</th></tr><tr ng-repeat=\"rmPurchasedOrder in vm.balancebill\"><td>\n{{rmPurchasedOrder.salesorder_id}}</td><td>{{ balexpense_getcategory(rmPurchasedOrder) }}</td><td>\n{{rmPurchasedOrder.payment_total}}</td><td>{{rmPurchasedOrder.payment_received}}</td><td>\n{{ rmPurchasedOrder.payment_total - rmPurchasedOrder.payment_received==rmPurchasedOrder.payment_total ? 0 : rmPurchasedOrder.payment_total - rmPurchasedOrder.payment_received }}\n</td><td>{{rmPurchasedOrder.tax_rate }}</td><td>{{rmPurchasedOrder.tax_sgst }}</td><td>\n{{rmPurchasedOrder.additional_charge }}</td><td>{{rmPurchasedOrder.discount}}</td><td>\n{{balexpense_customernames(rmPurchasedOrder)}}</td><td>{{ rmPurchasedOrder.payment_status }}</td><td>\n{{ rmPurchasedOrder.odc_deliveryDate | date }}</td><td>{{ rmPurchasedOrder.sales_deliveryTime}}</td><td \nng-if=\"permission==admin\">{{balexpense_staffnames(rmPurchasedOrder)}}</td><td>{{ rmPurchasedOrder.paid_date | date}}\n</td></tr></table></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"paidexpense_query.filter\" \ntype=\"text\" placeholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"paidexpense_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"paidexpense_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"12%\">\n{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column width=\"12%\">{{\'ODC.Category\' | translate}}</th><th md-column \nwidth=\"12%\">{{\'BILLINGS.CUSTOMER\' | translate}}</th><th md-column width=\"10%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th\n md-column width=\"16%\">{{\'EXPENSE.Balance\' | translate}}</th><th md-column width=\"16%\">{{\'ODC.EVENT-TIME\' | translate}}\n</th><th md-column ng-if=\"permission==admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">\n{{\'BILLINGS.STATUS\' | translate}}</th><th md-column width=\"14%\"><span>{{\'BILLINGS.ACTIONS\' | translate}}</span></th>\n</tr></thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.balancebill | limitTo: paidexpense_query.limit: (paidexpense_query.page - 1) * paidexpense_query.limit | filter: paidexpense_query.filter | orderBy: paidexpense_query.order\">\n<td md-cell>{{ balExpBill.salesorder_id }}</td><td md-cell>{{ balexpense_getcategory(balExpBill) }}</td><td md-cell>\n{{ balexpense_customernames(balExpBill) }}</td><td md-cell><span translate>BILLINGS.INR</span> <span>\n{{ balExpBill.payment_total }}</span> <span class=\"flex-none adv-amount\" ng-if=\"balExpBill.payment_status!=\'unpaid\'\">\n{{ balExpBill.payment_mode==\'onlineTranscation\' ? \'online\' : balExpBill.payment_mode}}</span></td><td md-cell \ntitle=\"{{currentbill.showdeliverdate}}\"><span translate class=\"warm-color\" ng-if=\"balExpBill.payment_received > \'0\'\">\nBILLINGS.INR</span> <span ng-show=\"balExpBill.payment_received > \'0\'\" class=\"font-size-px-18 warm-color\">\n{{ balExpBill.payment_total - balExpBill.payment_received}}</span> <span class=\"font-size-px-18\" \nng-if=\"balExpBill.payment_received == \'0\'\">{{\'-\'}}</span> <span class=\"flex-none adv-amount\" \nng-if=\"balExpBill.payment_received > \'0\'\">adv {{ balExpBill.payment_received }}</span></td><td md-cell>\n{{ balExpBill.odc_deliveryDate | date }},{{ balExpBill.sales_deliveryTime | date : format : timezone}}<md-icon \ntitle=\"Last updated by {{ update_staff(balExpBill)}},on {{ balExpBill.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \nng-if=\"permission==admin\">{{ balexpense_staffnames(balExpBill) }}</td><td md-cell>{{balExpBill.status}}</td><td \nng-if=\"permission==admin || odceditt.length || odcdeletee.length\"><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"permission==admin || odceditt.length\"><md-button \nng-click=\"balexpense(balExpBill.salesorder_id,balExpBill.customer_id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item \nng-if=\"permission==admin || odcdeletee.length\"><md-button ng-click=\"removeRow(balExpBill,$event,$index)\"><md-icon \nclass=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon><span>Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.balancebill.length==0\"><h3>\nThere\'re no purchase ordered for you to see.</h3></div></md-table-container><md-table-pagination \nmd-limit=\"paidexpense_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"paidexpense_query.page\" \nmd-total=\"{{paidexpense_count}}\" md-page-select></md-table-pagination></div></div><div class=\"paid-fix md-accent-bg\" \nng-if=\"vm.balancebill.length>0\"><div layout=\"row\" layout-align=\"start start\"><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">Total Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> \n<span class=\"amount\">{{full_data}}</span><span title=\"purchase ordered\" class=\"paid_count\"><img \nsrc=\"assets/icons/order-icon.svg\"> {{paid_count+balance_count}}</span></div><div flex-none class=\"paid-each-container\">\n<span class=\"title\">Paid Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">\n{{total_paid}}</span><span title=\"purchase ordered\" class=\"paid_count\"><img src=\"assets/icons/order-icon.svg\">\n {{paid_count}}</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">Balance Amount</span> <span \nclass=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{balance}}</span><span title=\"purchase ordered\" \nclass=\"paid_count\"><img src=\"assets/icons/order-icon.svg\"> {{balance_count}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">In cash</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span \nclass=\"amount\">{{total_cash}}</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In card</span>\n <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_card}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">In cheque</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span \nclass=\"amount\">{{total_cheque}}</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In online\n</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_online}}</span></div></div></div>\n</section>");
$templateCache.put("app/main/cashier/odc-bill/new-odc-bill/new-odc-bill.html","<form class=\"newbill w-100p layout-fill small no-error\" name=\"odcBill\" novalidate style=\"position: relative\"><div \nclass=\"layout-row min-height-100 md-whiteframe-2dp white-bg\"><div class=\"flex-none left-side-ver-tab\"><ul \nclass=\"pr-tabs\"><li class=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'tabBillInfo\'}\" \nng-click=\"prTabName =\'tabBillInfo\';focus();odcbills();\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (odcBill.quantity.$invalid || odcBill.autocompleteFood.$invalid || odcBill.category.$invalid || odcBill.eventTime.$invalid ||  odcBill.eventDate.$invalid || odcBill.receive.$invalid || odcBill.Banquet.$invalid) && (odcBill.$submitted)} \">\nEvent Info</span></li><li class=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'customer\'}\" \nng-click=\"prTabName =\'customer\';focuscustomer();odcbills();customerinfos();\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (odcBill.autocompleteCustomer.$invalid) && (odcBill.$submitted)} \">Customer</span></li><li \nclass=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'tabPayment\'}\" ng-click=\"prTabName =\'tabPayment\';payment();\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (odcBill.payment_details.$invalid || odcBill.cheque_no.$invalid || odcBill.amountType.$invalid || odcBill.paid_date.$invalid || odcBill.received_amount.$invalid || odcBill.transcation_no.$invalid) && (odcBill.$submitted)} \">\nPayment</span></li></ul></div><div class=\"pr-tab-contents flex\"><div class=\"pr-tab-content layout-fill\" \nng-show=\"odcbill\"><div ng-include=\"\'app/main/cashier/odc-bill/new-odc-bill/odc-info/odc-info.html\'\" \nclass=\"layout-fill\"></div></div><div class=\"pr-tab-content\" ng-show=\"payments\"><div \nng-include=\"\'app/main/cashier/odc-bill/new-odc-bill/payment/payment.html\'\"></div></div><div class=\"pr-tab-content\" \nng-show=\"customerinfo\" id=\"customer-info\"><div \nng-include=\"\'app/main/cashier/odc-bill/new-odc-bill/customer/customer.info.html\'\"></div></div><div \nclass=\"fix-bottom pt-8 pl-16\"><div class=\"layout-row center-end small-fix-bottom-button\"><div \nclass=\"layout-row center-end flex\" ng-if=\"!params.id\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"cancel($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary big layout-row layout-align-center-center\" ng-click=\"saveBill()\">Save</md-button></div><div\n ng-if=\"params.id\" class=\"layout-row layout-align-space-between-center m-w-860\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"canceledit($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary layout-row layout-align-center-center\" \nng-disabled=\"newexpense.$invalid || newexpense.$pristine\" ng-click=\"updateBill()\">Save</md-button></div></div></div>\n</div></div></form>");
$templateCache.put("app/main/cashier/odc-bill/paid-odc-bill/paid-odc.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-md\"><md-datepicker ng-model=\"monthyear\" aria-label=\"email\" md-max-date=\"maxDate \" \nng-change=\"changeDate(amount_type,monthyear,staffss,$event) \" ng-required=\"dateFields[2].required \" \nmd-date-locale=\"dateFields[2].locale \" md-mode=\"{{dateFields[2].mode}} \" md-open-on-focus=\"true \"></md-datepicker>\n</div><div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"amount_type\" aria-label=\"email\" \nng-init=\"amount_type=vm.amount_type[0].value \" ng-change=\"changeDate(amount_type,monthyear,staffss,$event) \" \nclass=\"md-accent\" flex=\"100 \"><md-option ng-repeat=\"amount_type in vm.amount_type \" value=\"{{amount_type.value}} \">\n{{amount_type.name}}</md-option></md-select></div><div ng-show=\"permission \" ng-hide=\"!permission \" \nclass=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"staffss\" aria-label=\"email\" \nng-init=\"staffss=vm.staffRole[0].staffID \" ng-change=\"changeDate(amount_type,monthyear,staffss,$event) \" \nclass=\"md-accent\" flex=\"100 \"><md-option ng-repeat=\"staff in vm.staffRole \" value=\"{{staff.staffID}} \">{{staff.name}}\n</md-option></md-select></div><div ng-if=\"vm.balancebill.length>0\" class=\"layout-align-start-start ph-12\"><a \nexport-to-csv5 class=\"download-csv\"><md-tooltip md-direction=\"top\">Export all the data to CSV</md-tooltip></a><table \nstyle=\"display: none\"><tr><th style=\"color: red\">{{\'Inventory.PURCHASED-NO\' | translate}}</th><th>\n{{\'ODC.Category\' | translate}}</th><th>Total {{\'BILLINGS.AMOUNT\' | translate}}</th><th>Advance paid</th><th>\n{{\'EXPENSE.Balance\' | translate}} Amount</th><th>{{ \'BILLINGS.CGST\' | translate}}</th><th>\n{{ \'BILLINGS.SGST\' | translate}}</th><th>Additonal Charge</th><th>{{ \'BILLINGS.DISCOUNT\' | translate}}</th><th>\n{{\'BILLINGS.CUSTOMER\' | translate}}</th><th>Payment Status</th><th>Event Date</th><th></th><th>\n{{\'ODC.EVENT-TIME\' | translate}}</th><th ng-if=\"permission==\'admin\'\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th>\n{{\'EXPENSE.PAID-DATE\' | translate}}</th></tr><tr ng-repeat=\"rmPurchasedOrder in vm.balancebill\"><td>\n{{rmPurchasedOrder.salesorder_id}}</td><td>{{ balexpense_getcategory(rmPurchasedOrder) }}</td><td>\n{{rmPurchasedOrder.payment_total}}</td><td>{{rmPurchasedOrder.payment_received}}</td><td>\n{{ rmPurchasedOrder.payment_total - rmPurchasedOrder.payment_received==rmPurchasedOrder.payment_total ? 0 : rmPurchasedOrder.payment_total - rmPurchasedOrder.payment_received }}\n</td><td>{{rmPurchasedOrder.tax_rate }}</td><td>{{rmPurchasedOrder.tax_sgst }}</td><td>\n{{rmPurchasedOrder.additional_charge }}</td><td>{{rmPurchasedOrder.discount}}</td><td>\n{{balexpense_customernames(rmPurchasedOrder)}}</td><td>{{ rmPurchasedOrder.payment_status }}</td><td>\n{{ rmPurchasedOrder.odc_deliveryDate | date }}</td><td>{{ rmPurchasedOrder.sales_deliveryTime}}</td><td \nng-if=\"permission==\'admin\'\">{{balexpense_staffnames(rmPurchasedOrder)}}</td><td>{{ rmPurchasedOrder.paid_date | date}}\n</td></tr></table></div><md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"paidexpense_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"paidexpense_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"paidexpense_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"12%\">\n{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column width=\"12%\">{{\'ODC.Category\' | translate}}</th><th md-column \nwidth=\"12%\">{{\'BILLINGS.CUSTOMER\' | translate}}</th><th md-column width=\"10%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th\n md-column width=\"16%\">{{\'EXPENSE.Balance\' | translate}}</th><th md-column width=\"16%\">{{\'ODC.EVENT-TIME\' | translate}}\n</th><th md-column ng-if=\"permission==admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"14%\" \nng-if=\"permission==admin || odceditt.length\"><span>{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody \nmd-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.balancebill | limitTo: paidexpense_query.limit: (paidexpense_query.page - 1) * paidexpense_query.limit | filter: paidexpense_query.filter | orderBy: paidexpense_query.order\">\n<td md-cell>{{ balExpBill.salesorder_id }}</td><td md-cell>{{ balexpense_getcategory(balExpBill) }}</td><td md-cell>\n{{ balexpense_customernames(balExpBill) }}</td><td md-cell><span translate>BILLINGS.INR</span> <span>\n{{ balExpBill.payment_total }}</span> <span class=\"flex-none adv-amount\" ng-if=\"balExpBill.payment_status!=\'unpaid\'\">\n{{ balExpBill.payment_mode==\'onlineTranscation\' ? \'online\' : balExpBill.payment_mode}}</span></td><td md-cell \ntitle=\"{{currentbill.showdeliverdate}}\"><span translate class=\"warm-color\" ng-if=\"balExpBill.payment_received > \'0\'\">\nBILLINGS.INR</span> <span ng-show=\"balExpBill.payment_received > \'0\'\" class=\"font-size-px-18 warm-color\">\n{{ balExpBill.payment_total - balExpBill.payment_received}}</span> <span class=\"font-size-px-18\" \nng-if=\"balExpBill.payment_received == \'0\'\">{{\'-\'}}</span> <span class=\"flex-none adv-amount\" \nng-if=\"balExpBill.payment_received > \'0\'\">adv {{ balExpBill.payment_received }}</span></td><td md-cell>\n{{ balExpBill.odc_deliveryDate | date }},{{ balExpBill.sales_deliveryTime}}<md-icon \ntitle=\"Last updated by {{ update_staff(balExpBill)}} ,on {{ balExpBill.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \nng-if=\"permission==admin\">{{ balexpense_staffnames(balExpBill) }}</td><td \nng-if=\"permission==admin || odceditt.length || odcdeletee.length\"><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"permission==admin || odceditt.length\"><md-button \nng-click=\"balexpense(balExpBill.salesorder_id,balExpBill.customer_id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item \nng-if=\"permission==admin || odcdeletee.length\"><md-button ng-click=\"removeRow(balExpBill,$event,$index)\"><md-icon \nclass=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon><span>Delete</span></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table></md-table-container><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.balancebill.length==0\"><h3>\nThere\'re no purchase ordered for you to see.</h3></div><md-table-pagination md-limit=\"paidexpense_query.limit\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"paidexpense_query.page\" md-total=\"{{paidexpense_count}}\" md-page-select>\n</md-table-pagination></div></div><div class=\"paid-fix md-accent-bg\" ng-if=\"vm.balancebill.length>0\"><div layout=\"row\" \nlayout-align=\"start start\"><div flex-none class=\"paid-each-container\"><span class=\"title\">Total Amount</span> <span \nclass=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{full_data}}</span><span title=\"purchase ordered\" \nclass=\"paid_count\"><img src=\"assets/icons/order-icon.svg\"> {{paid_count+balance_count}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">Paid Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> \n<span class=\"amount\">{{total_paid}}</span><span title=\"purchase ordered\" class=\"paid_count\"><img \nsrc=\"assets/icons/order-icon.svg\"> {{paid_count}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">Balance Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{balance}}\n</span><span title=\"purchase ordered\" class=\"paid_count\"><img src=\"assets/icons/order-icon.svg\"> {{balance_count}}\n</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In cash</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_cash}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In card</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_card}}</span>\n</div><div flex-none class=\"paid-each-container\"><span class=\"title\">In cheque</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_cheque}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In online</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_online}}\n</span></div></div></div></section>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/admin/raw-material/item/dialog/rm-additem.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-530 layout-column\"><md-dialog-content \nclass=\"flex layout-column medium\"><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">\n{{ vm.title}} Raw Material <span translate>RESTRAUNTANT.ITEM</span></h2></div><form name=\"addrawForm\" novalidate><div \nlayout=\"row\" class=\"mt-4\" flex=\"100\"><md-input-container class=\"md-block md-accent\" ng-hide=\"show\" flex=\"50\"><label>\nSelect {{\'ODC.Category\' | translate}}</label><md-select ng-model=\"vm.rmInfo.rmCatergoryID\" class=\"md-accent\" \nng-required=\"vm.rmInfo.rmname\"><md-option ng-repeat=\"rawcategory in vm.rawcategorys\" \nvalue=\"{{rawcategory.rmCatergoryID}}\">{{rawcategory.rmCatergoryName}}</md-option></md-select></md-input-container><div \nng-show=\"show\" layout=\"row\" flex=\"100\"><md-input-container class=\"md-accent md-block\" flex=\"50\"><label>\nAdd New {{\'ODC.Category\' | translate}}</label><input type=\"text\" name=\"catergoryname\" \nng-model=\"vm.rmInfo.rmCatergoryName\" value=\"1\"></md-input-container><md-button \nclass=\"md-primary md-mini md-radio-buttonaised md-icon-button\" aria-label=\"save\" \nng-click=\"addNewCategory(rawcategory); show = !show\" title=\"Save\"><md-icon md-menu-origin md-font-icon=\"icon-check\">\n</md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" ng-click=\"show = !show\" \ntitle=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\"></md-icon></md-button></div></div><div layout=\"row\" \nclass=\"mt-16\"><div flex=\"100\" class=\"mt-8\"><md-input-container class=\"md-accent md-block mt-16 mb-4\"><label><span \ntranslate>RESTRAUNTANT.ITEM</span> Name</label><input type=\"text\" name=\"itemname\" ng-model=\"vm.rmInfo.rmname\" required \nmaxlength=\"40\"><div class=\"hint\" translate ng-if=\"!addrawForm.itemname.$invalid || addrawForm.itemname.$untouched\">\nRESTRAUNTANT.HELP-TEXT.ADD-RAW-ITEM</div><div ng-messages=\"addrawForm.itemname.$error\"><div ng-message=\"required\">\n<span><span translate>RESTRAUNTANT.ITEM</span> Name field is required</span></div></div></md-input-container><div \nlayout=\"row\" class=\"mt-24\"><md-input-container md-no-float class=\"md-accent md-block mr-16\" flex=\"30\"><label>\nContain Quantity</label><input type=\"text\" ng-keypress=\"onlynumber($event);\" maxlength=\"8\" pattern=\"^[1-9][0-9]*$\" \nname=\"packquantity\" ng-model=\"vm.rmInfo.containQty\" required><div class=\"hint\" translate \nng-if=\"!addrawForm.packquantity.$invalid || addrawForm.packquantity.$untouched\">RESTRAUNTANT.HELP-TEXT.ADD-MENU-QTY\n</div><div ng-messages=\"addrawForm.packquantity.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>RESTRAUNTANT.QUANTITY</span></span></div><div ng-message=\"pattern\">\nPlease enter valid amount</div></div></md-input-container><div flex=\"25\" class=\"ml-16\" ng-hide=\"show\">\n<md-input-container class=\"md-block md-accent\"><label>Unit</label><md-select ng-model=\"vm.rmInfo.unit\" \nclass=\"md-accent\" required><md-option ng-repeat=\"unit in  vm.unit\" value=\"{{unit.value}}\">{{unit.name}}</md-option>\n</md-select></md-input-container></div><div flex=\"45\" class=\"ml-16\"><md-input-container class=\"md-accent md-block\">\n<label><span translate>BILLINGS.RATE</span> per contain qty (<span translate>BILLINGS.INR</span>)</label><input \ntype=\"text\" name=\"price\" ng-keypress=\"onlynumber($event);\" maxlength=\"8\" ng-model=\"vm.rmInfo.rmrate\" value=\"1\" \npattern=\"^[1-9][0-9]*$\" required><div ng-messages=\"addrawForm.price.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the <span translate>BILLINGS.RATE</span></span></div><div \nng-message=\"pattern\">Please enter the valid price</div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"mt-24\"><md-input-container class=\"md-accent md-block\" flex=\"50\"><label>Opening Stock qty</label><input \ntype=\"text\" ng-keypress=\"onlynumber($event);\" pattern=\"^[0-9][0-9]*$\" maxlength=\"8\" name=\"quantity1\" \nng-model=\"vm.rmInfo.stock_quantity\" required><div class=\"hint\" translate \nng-if=\"!addrawForm.quantity1.$invalid || addrawForm.quantity1.$untouched\">RESTRAUNTANT.HELP-TEXT.ADD-MENU-QTY</div><div\n ng-messages=\"addrawForm.quantity1.$error\"><div ng-message=\"required\"><span>Please enter the opening stock qty</span>\n</div><div ng-message=\"pattern\">Please enter the valid qty</div></div></md-input-container></div></div></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button \nclass=\"md-accent\" ng-if=\"!vm.newRMItem\" ng-disabled=\"addrawForm.$invalid || addrawForm.$pristine\" \nng-click=\"editRMItem(rmInfo)\">Edit Item</md-button><md-button class=\"md-accent\" ng-if=\"vm.newRMItem\" \nng-click=\"addRMItem()\" ng-disabled=\"addrawForm.$invalid\">Add Item</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/sale-item/item/dialog/si-additem.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-620 layout-column\"><md-dialog-content \nclass=\"flex layout-column medium\"><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">\n{{ vm.title}} Sale Material <span translate>RESTRAUNTANT.ITEM</span></h2></div><form name=\"addrawForm\" novalidate><div \nlayout=\"row\" class=\"mt-8\" flex=\"100\"><md-input-container class=\"md-block md-accent\" ng-hide=\"show\" flex=\"50\"><label>\nSelect Category</label><md-select ng-model=\"vm.siInfo.siCatergoryID\" class=\"md-accent\" ng-required=\"vm.siInfo.siname\">\n<md-option ng-repeat=\"salecategory in vm.salecategorys | orderBy:\'siCatergoryName\'\" \nvalue=\"{{salecategory.siCatergoryID}}\">{{salecategory.siCatergoryName}}</md-option></md-select></md-input-container>\n<div ng-show=\"show\" layout=\"row\" flex=\"100\"><md-input-container class=\"md-accent md-block\" flex=\"50\"><label>\nAdd New Category</label><input type=\"text\" name=\"catergoryname\" ng-model=\"vm.siInfo.siCatergoryName\" value=\"1\">\n</md-input-container><md-button class=\"md-primary md-mini md-radio-buttonaised md-icon-button\" aria-label=\"save\" \nng-click=\"addNewCategory(salecategory); show = !show\" title=\"Save\"><md-icon md-menu-origin md-font-icon=\"icon-check\">\n</md-icon></md-button><md-button class=\"md-hue md-icon-button\" aria-label=\"close\" ng-click=\"show = !show\" \ntitle=\"Cancel\"><md-icon md-menu-origin md-font-icon=\"icon-close\"></md-icon></md-button></div></div><div \nlayout=\"column\" class=\"mt-24\"><div flex=\"100\" layout=\"row\" class=\"mt-4\"><md-input-container class=\"md-accent md-block\" \nflex=\"50\"><label><span translate>RESTRAUNTANT.ITEM</span> Name</label><input type=\"text\" name=\"itemname\" \nng-model=\"vm.siInfo.siname\" required maxlength=\"40\"><div class=\"hint\" translate \nng-if=\"!addrawForm.itemname.$invalid || addrawForm.itemname.$untouched\">RESTRAUNTANT.HELP-TEXT.ADD-MENU-ITEM</div><div \nng-messages=\"addrawForm.itemname.$error\"><div ng-message=\"required\"><span><span translate>RESTRAUNTANT.ITEM</span>\n Name field is required</span></div></div></md-input-container><div flex=\"50\" class=\"ml-16\"><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"100\"><label>Opening {{\'BILLINGS.STOCK-QUANTITY\' | translate}}</label>\n<input type=\"text\" ng-keypress=\"onlynumber($event);\" maxlength=\"8\" name=\"quantitys\" \nng-model=\"vm.siInfo.stock_quantity\" required><div class=\"hint\" translate \nng-if=\"!addrawForm.quantitys.$invalid || addrawForm.quantitys.$untouched\">RESTRAUNTANT.HELP-TEXT.ADD-MENU-QTY</div><div\n ng-messages=\"addrawForm.quantitys.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the opening stock qty</span></div></div></md-input-container></div></div><div flex=\"100\" layout=\"row\" \nclass=\"mt-16\" ng-if=\"vm.branchFilterData[0].barcode_enable == 1\"><md-input-container class=\"md-accent md-block\" \nflex=\"50\"><label><span translate>BILLINGS.BARCODE-NO</span></label><input type=\"text\" name=\"barcode\" \nng-model=\"vm.siInfo.barcode\" required maxlength=\"25\"><div ng-messages=\"addrawForm.barcode.$error\"><div \nng-message=\"required\"><span><span translate>BILLINGS.BARCODE-NO</span> field is required</span></div></div>\n</md-input-container></div><div class=\"sub-head mt-24 mb-8\">{{\'FOOD.PURCHASE\' | translate}} Information</div><div \nlayout=\"row\" class=\"mt-24\"><md-input-container md-no-float class=\"md-accent md-block\" flex=\"50\"><label>\nQuantity per case</label><input type=\"text\" ng-keypress=\"onlynumber($event);\" maxlength=\"8\" pattern=\"^[1-9][0-9]*$\" \nname=\"packquantity\" ng-model=\"vm.siInfo.containQty\" required><div class=\"hint\" translate \nng-if=\"!addrawForm.packquantity.$invalid || addrawForm.packquantity.$untouched\">Contain quantity per case</div><div \nng-messages=\"addrawForm.packquantity.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>Please enter the \n<span translate>RESTRAUNTANT.QUANTITY</span></span></div><div ng-message=\"pattern\">Please enter valid amount</div>\n</div></md-input-container><div flex=\"50\" class=\"ml-16\"><md-input-container class=\"md-accent md-block\"><label>\n{{\'FOOD.PURCHASE\' | translate}} amount per case (<span translate>BILLINGS.INR</span>)</label><input type=\"number\" \nname=\"purchaseprice\" ng-keypress=\"onlynumbers($event);\" ng-model=\"vm.siInfo.PurchasePrice\" required><div \nng-messages=\"addrawForm.purchaseprice.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPlease enter the amount</span></div><div ng-message=\"pattern\">Please enter valid purchase amount</div></div>\n</md-input-container></div></div><div class=\"sub-head mt-24 mb-8\">{{\'FOOD.SALES\' | translate}} Information</div><div \nlayout=\"row\" class=\"mt-24\"><md-input-container class=\"md-accent md-block\" flex=\"30\"><label><span ng-if=\"!vm.print.mrp\">\n{{\'FOOD.RATE-PER-QTY\' | translate}}</span> <span ng-if=\"vm.print.mrp\">{{\'BILLINGS.MRP\' | translate}}</span>(<span \ntranslate>BILLINGS.INR</span>)</label><input type=\"number\" name=\"price\" ng-keypress=\"onlynumbers($event);\" \nng-model=\"vm.siInfo.sirate\" value=\"1\" required><div class=\"hint\" translate \nng-if=\"(!addrawForm.price.$invalid || addrawForm.price.$untouched) && !vm.print.mrp\">Sales rate for per qty</div><div \nclass=\"hint\" translate ng-if=\"(!addrawForm.price.$invalid || addrawForm.price.$untouched) && vm.print.mrp\">\nSales mrp for per qty</div><div ng-messages=\"addrawForm.price.$error\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Please enter the <span translate>BILLINGS.RATE</span></span></div><div ng-message=\"pattern\">\nPlease enter valid rate</div></div></md-input-container><div class=\"ml-16\"><md-input-container \nclass=\"md-accent md-block\"><label><span>Offer Rate</span> per item (<span translate>BILLINGS.INR</span>)</label><input \ntype=\"number\" name=\"offer\" ng-model=\"vm.siInfo.offerprice\" max=\"{{vm.siInfo.sirate}}\" \nng-keypress=\"onlynumbers($event);\"><div ng-messages=\"addrawForm.offer.$error\" multiple=\"multiple\"><div \nng-message=\"max\"><span>Please enter below the Rate per item</span></div></div></md-input-container></div><div \nclass=\"ml-16\" ng-if=\"vm.settings.dealer\"><md-input-container class=\"md-accent md-block ml-16\"><label><span \ntranslate=\"\">USERS.DEALER</span> Rate per item (<span translate>BILLINGS.INR</span>)</label><input type=\"number\" \nname=\"dealer_price\" ng-model=\"vm.siInfo.dealer_price\" max=\"{{vm.siInfo.sirate}}\" ng-keypress=\"onlynumbers($event);\">\n<div ng-messages=\"addrawForm.dealer_price.$error\" multiple=\"multiple\"><div ng-message=\"max\"><span>\nPlease enter below the <span translate=\"\">USERS.DEALER</span> price per item</span></div></div></md-input-container>\n</div></div></div><br><md-radio-group class=\"layout-row mb-24 flex\" \nng-if=\"!vm.settings.global_tax&&vm.settings.indivudual_exclude\" id=\"radio-focus\" ng-model=\"vm.siInfo.tax_status\" \nid=\"myselector\"><md-radio-button ng-repeat=\"category in vm.dietType\" value=\"{{category.value}}\" class=\"md-accent\" \nng-click=\"hello\">{{category.label}}</md-radio-button></md-radio-group><div layout=\"row\" class=\"mt-24\" \nng-if=\"!vm.settings.global_tax&&vm.settings.indivudual_exclude\"><div flex=\"100\" layout=\"row\"><md-input-container \nclass=\"md-accent md-block\"><label><span>CGST Tax Rate</span></label><input type=\"number\" name=\"cgst\" \nng-model=\"vm.siInfo.tax_cgst\" ng-keypress=\"onlynumberDot($event);\" maxlength=\"4\" \nng-required=\"vm.settings.indivudual_exclude\"><div ng-messages=\"addrawForm.cgst.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the cgst rate</span></div><div ng-message=\"pattern\">\nPlease enter the valid rate</div></div></md-input-container><div flex=\"50\" class=\"ml-16\"><md-input-container \nclass=\"md-accent md-block\"><label><span>SGST Tax Rate</span></label><input type=\"number\" name=\"sgst\" \nng-model=\"vm.siInfo.tax_sgst\" ng-keypress=\"onlynumberDot($event);\" maxlength=\"4\" \nng-required=\"vm.settings.indivudual_exclude\"><div ng-messages=\"addrawForm.sgst.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Please enter the sgst rate</span></div><div ng-message=\"pattern\">\nPlease enter the valid rate</div></div></md-input-container></div></div></div><div ng-if=\"vm.barcode_warning\" \nclass=\"err_message\">\nThis barcode already added to \"{{vm.siInfo.siname}}\" Item. Please use another barcode. If you need add a duplicate barcode item, please click add button.\n</div><div layout=\"column\" layout-align=\"start start\" flex=\"50\" class=\"mt-16\" \nng-if=\"vm.settings.show_sales_item_image\"><div ng-if=\"vm.file || vm.siInfo.image_url\" class=\"mb-12\"><img \nng-if=\"vm.file\" ngf-src=\"vm.file\" alt=\"item image\" \nstyle=\"max-width: 120px; max-height: 120px; border: 1px solid #ccc; border-radius: 4px\"> <img \nng-if=\"!vm.file && vm.siInfo.image_url\" ng-src=\"{{vm.siInfo.image_url}}\" alt=\"item image\" \nstyle=\"max-width: 120px; max-height: 120px; border: 1px solid #ccc; border-radius: 4px\"></div><input \nstyle=\"display: none\" id=\"siItemImage\" type=\"file\" ngf-select ng-model=\"vm.file\" ngf-accept=\"\'image/*\'\"><label \nfor=\"siItemImage\" class=\"md-button md-accent\">Upload Image</label><md-button ng-if=\"vm.file || vm.siInfo.image_url\" \nclass=\"md-warn md-icon-button\" ng-click=\"vm.file=null; vm.siInfo.image_url=null;\" title=\"Remove image\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></form></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"closeDialog()\">Cancel</md-button><md-button class=\"md-accent\" ng-if=\"!vm.newRMItem\" \nng-disabled=\"addrawForm.$invalid || addrawForm.$pristine\" ng-click=\"editRMItem(siInfo)\">Edit Menu Items</md-button>\n<md-button class=\"md-accent\" ng-if=\"vm.newRMItem\" ng-click=\"addRMItem()\" ng-disabled=\"addrawForm.$invalid\">\nAdd Menu Items</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/campaign/finishedcampaign/campaign-analytics/campaign-analytics.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nclass=\"customer-header\" style=\"padding: 0\"><md-toolbar class=\"md-accent md-tall ms-widget_md layout-row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle layout-align-start-start layout-column flex\"><div \nclass=\"layout-align-start-start layout-row\"><div layout=\"column\" class=\"text-container\"><div class=\"contact-name\">\n{{campaigndata[0].campaignName}}</div><div layout=\"row\" class=\"mt-8\"><i \nclass=\"icon s16 icon-message-text-outline mr-8 mt-2\"></i><div class=\"mobile-no\"><span>MESSAGE :</span>\n {{campaigndata[0].message}}</div></div><div layout=\"row\" class=\"mt-4\"><i class=\"icon s16 icon-clock mr-8 mt-2\"></i>\n<div class=\"mobile-no mr-16\"><span>CREATED ON :</span> {{CampaignCreated | date:\'medium\'}}</div><span \nclass=\"mobile-no ml-36\" ng-if=\"!online\"><span>LAST SYNC: </span>{{ dblastSync | date:\'medium\'}}</span></div></div>\n</div></div></md-toolbar></ms-widget></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container white-bg md-whiteframe-1dp mb-16 padding-24\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{total}}</span></div><div \nclass=\"label md-truncate ng-binding\">Sent</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{DELIVERED.length}}</span></div><div \nclass=\"label md-truncate ng-binding\">Delivered</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{Submitted.length}}</span></div><div \nclass=\"label md-truncate ng-binding\">Submitted</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{FAILED.length}}</span></div><div \nclass=\"label md-truncate ng-binding\">Failed</div></div></div><div \nclass=\"white-bg md-whiteframe-1dp layout-column padding-24 scrollable\"><div layout=\"row\" layout-align=\"start start\" \nclass=\"mb-16\"><div layout=\"row\" layout-align=\"end start\" flex><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"purchaseorder_query.filter\" ng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" ng-click=\"clearText()\"></md-icon>\n</div></div></div><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\"><thead md-head \nmd-order=\"purchaseorder_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column md-order-by=\"customername\">\n{{\'BILLINGS.CUSTOMER-LIST.NAME\' | translate}}</th><th md-column>{{\'BILLINGS.CUSTOMER-LIST.MOBILE\' | translate}}</th><th\n md-column>{{\'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}}</th><th md-column>\n{{\'BILLINGS.CUSTOMER-LIST.CITY\' | translate}}</th><th md-column>Status</th><th md-column>Delivered Date</th></tr>\n</thead><tbody md-body><tr class=\"cursor-pointer\" md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"customer in vm.getpurchase | limitTo: purchaseorder_query.limit:(purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order : true\" \nhref=\"#\" ng-click=\"goLogin(customer.customer_id);\"><td md-cell><div layout=\"column\" class=\"layout-column\"><div><span \nclass=\"username\">{{customer.customername }}</span></div></div></td><td md-cell>{{ customer.customerMobile }}</td><td \nmd-cell>{{ customer.customerlocality }}</td><td md-cell>{{ customer.customercity }}</td><td md-cell>{{customer.status}}\n</td><td md-cell>{{customer.deliverydate | date:\'medium\'}}</td></tr></tbody></table><md-table-pagination \nmd-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"purchaseorder_query.page\" \nmd-total=\"{{purchaseorder_count}}\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/cashier/campaign/whatsappfinishedcampaign/whatsapp-campaign-analytics/whatsapp-campaign-analytics.html","<div class=\"layout-column layout-align-start-start layout-gt-sm-row white-bg md-whiteframe-1dp mb-16 padding-24\"><div \nclass=\"layout-align-start-start layout-row\"><div layout=\"column\" class=\"text-container\"><div layout=\"row\"><i \nclass=\"icon s16 icon-information-outline mr-8 mt-2\"></i><div class=\"mobile-no\" layout=\"row\"><span \nclass=\"leftContentdata\">CAMPAIGN NAME :</span><span>{{campaigndata[0].campaignName}}</span></div></div><div \nlayout=\"row\" class=\"mt-8\"><i class=\"icon s16 icon-message-text-outline mr-8 mt-2\"></i><div class=\"mobile-no\" \nlayout=\"row\"><span class=\"leftContentdata\">MESSAGE :</span><span>{{campaigndata[0].message}}</span></div></div><div \nlayout=\"row\" class=\"mt-12\"><i class=\"icon s16 icon-clock mr-8 mt-2\"></i><div class=\"mobile-no mr-16\" layout=\"row\"><span\n style=\"width:150px\">CREATED ON :</span><span> {{CampaignCreated | date:\'medium\'}}</span></div><div \nclass=\"mobile-no ml-36\" ng-if=\"!online\" layout=\"row\"><span style=\"width:150px\">LAST SYNC: </span><span>\n{{ dblastSync | date:\'medium\'}}</span></div></div><div layout=\"row\" class=\"mt-12\" \nng-if=\"campaigndata[0].Images.length > 0\"><i class=\"icon s16 icon-image-filter mr-8 mt-2\"></i> <span \nclass=\"mobile-no mr-16\" layout=\"row\"><span class=\"leftContentdata\">IMAGE :</span> <span \nng-repeat=\"imgUrl in campaigndata[0].Images\" class=\"whatsappImage\"><img ng-src=\"{{imgUrl}}\" alt=\"Campaign Image\" \nstyle=\"max-width: 100px; margin-right: 10px\"></span></span></div></div></div></div><div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container white-bg md-whiteframe-1dp mb-16 padding-24\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{total}}</span></div><div \nclass=\"label md-truncate ng-binding\">Total</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{DELIVERED.length}}</span></div><div \nclass=\"label md-truncate ng-binding\">Delivered</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span>{{FAILED.length}}</span></div><div \nclass=\"label md-truncate ng-binding\">Failed</div></div></div><div \nclass=\"white-bg md-whiteframe-1dp layout-column padding-24 scrollable\"><div layout=\"row\" layout-align=\"start start\" \nclass=\"mb-16\"><div layout=\"row\" layout-align=\"end start\" flex><div class=\"search md-block ml-36\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" \nng-model=\"purchaseorder_query.filter\" ng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" ng-click=\"clearText()\"></md-icon>\n</div></div></div><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\"><thead md-head \nmd-order=\"purchaseorder_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column md-order-by=\"customername\">\n{{\'BILLINGS.CUSTOMER-LIST.NAME\' | translate}}</th><th md-column>{{\'BILLINGS.CUSTOMER-LIST.MOBILE\' | translate}}</th><th\n md-column>{{\'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}}</th><th md-column>\n{{\'BILLINGS.CUSTOMER-LIST.CITY\' | translate}}</th><th md-column>Status</th></tr></thead><tbody md-body><tr \nclass=\"cursor-pointer\" md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"customer in vm.getpurchase | limitTo: purchaseorder_query.limit:(purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order : true\" \nhref=\"#\" ng-click=\"goLogin(customer.customer_id);\"><td md-cell><div layout=\"column\" class=\"layout-column\"><div><span \nclass=\"username\">{{customer.customername }}</span></div></div></td><td md-cell>{{ customer.customerMobile }}</td><td \nmd-cell>{{ customer.customerlocality }}</td><td md-cell>{{ customer.customercity }}</td><td md-cell>{{customer.status}}\n</td></tr></tbody></table><md-table-pagination md-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"purchaseorder_query.page\" md-total=\"{{purchaseorder_count}}\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/templates/customer.info.html","<div layout=\"column\"><div flex><ul class=\"user-profile\"><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.NAME\n</div><div class=\"title\">{{customer.customer_name}}</div></li><li><div class=\"label\" translate>\nBILLINGS.CUSTOMER-LIST.MOBILE</div><div class=\"title\">{{customer.customer_mobile}}</div></li><li><div class=\"label\" \ntranslate>BILLINGS.CUSTOMER-LIST.EMAIL</div><div class=\"title\">{{customer.customer_email}}</div></li><li><div \nclass=\"label\" translate>BILLINGS.CUSTOMER-LIST.ADDRESS</div><div class=\"title\">{{customer.customer_address}}</div></li>\n<li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.LOCALITY</div><div class=\"title\" translate><span translate>\n{{customer.customer_locality}}</span></div></li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.CITY</div><div \nclass=\"title\" translate><span translate>{{customer.customer_city}}</span></div></li></ul></div></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/templates/feedback.html","<div class=\"feedback mt-24\"><table width=\"85%\"><tr><th width=\"40%\"></th><th width=\"12%\" class=\"text-align-center\">\n{{feedbackjson.POORLY}}</th><th width=\"12%\" class=\"text-align-center\">{{feedbackjson.BAD}}</th><th width=\"12%\" \nclass=\"text-align-center\">{{feedbackjson.OK}}</th><th width=\"12%\" class=\"text-align-center\">{{feedbackjson.GOOD}}</th>\n<th width=\"12%\" class=\"text-align-center\">{{feedbackjson.GREAT}}</th></tr><tr><td class=\"text-align-right\"><span \nclass=\"mr-32\">{{feedbackjson.Service}}:{{feedback.feedback_service}}</span></td><td><div class=\"first\" \nng-class=\"{ \'1\': \'active\',\'!1\':\'\'}[feedback.feedback_service]\"></div></td><td><div class=\"second\" \nng-class=\"{ \'2\': \'active\',\'!2\':\'\'}[feedback.feedback_service]\"></div></td><td><div class=\"third\" \nng-class=\"{ \'3\': \'active\',\'!3\':\'\'}[feedback.feedback_service]\"></div></td><td><div class=\"four\" \nng-class=\"{ \'4\': \'active\',\'!4\':\'\'}[feedback.feedback_service]\"></div></td><td><div class=\"five\" \nng-class=\"{ \'5\': \'active\',\'!5\':\'\'}[feedback.feedback_service]\"></div></td></tr><tr><td class=\"text-align-right\"><span \nclass=\"mr-32\">{{feedbackjson.Staff}}: {{feedback.feedback_staff}}</span></td><td><div class=\"first\" \nng-class=\"{ \'1\': \'active\',\'!1\':\'\'}[feedback.feedback_staff]\"></div></td><td><div class=\"second\" \nng-class=\"{ \'2\': \'active\',\'!2\':\'\'}[feedback.feedback_staff]\"></div></td><td><div class=\"third\" \nng-class=\"{ \'3\': \'active\',\'!3\':\'\'}[feedback.feedback_staff]\"></div></td><td><div class=\"four\" \nng-class=\"{ \'4\': \'active\',\'!4\':\'\'}[feedback.feedback_staff]\"></div></td><td><div class=\"five\" \nng-class=\"{ \'5\': \'active\',\'!5\':\'\'}[feedback.feedback_staff]\"></div></td></tr><tr><td class=\"text-align-right\"><span \nclass=\"mr-32\">{{feedbackjson.Food}}: {{feedback.feedback_food}}</span></td><td><div class=\"first\" \nng-class=\"{ \'1\': \'active\',\'!1\':\'\'}[feedback.feedback_food]\"></div></td><td><div class=\"second\" \nng-class=\"{ \'2\': \'active\',\'!2\':\'\'}[feedback.feedback_food]\"></div></td><td><div class=\"third\" \nng-class=\"{ \'3\': \'active\',\'!3\':\'\'}[feedback.feedback_food]\"></div></td><td><div class=\"four\" \nng-class=\"{ \'4\': \'active\',\'!4\':\'\'}[feedback.feedback_food]\"></div></td><td><div class=\"five\" \nng-class=\"{ \'5\': \'active\',\'!5\':\'\'}[feedback.feedback_food]\"></div></td></tr><tr><td class=\"text-align-right\"><span \nclass=\"mr-32\">{{feedbackjson.Money}}: {{feedback.feedback_money}}</span></td><td><div class=\"first\" \nng-class=\"{ \'1\': \'active\',\'!1\':\'\'}[feedback.feedback_money]\"></div></td><td><div class=\"second\" \nng-class=\"{ \'2\': \'active\',\'!2\':\'\'}[feedback.feedback_money]\"></div></td><td><div class=\"third\" \nng-class=\"{ \'3\': \'active\',\'!3\':\'\'}[feedback.feedback_money]\"></div></td><td><div class=\"four\" \nng-class=\"{ \'4\': \'active\',\'!4\':\'\'}[feedback.feedback_money]\"></div></td><td><div class=\"five\" \nng-class=\"{ \'5\': \'active\',\'!5\':\'\'}[feedback.feedback_money]\"></div></td></tr></table></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/templates/food.info.html","<div class=\"font-size-16 mb-24 m-w-780 sales-bill\"><div class=\"receipt-border-top border-right border-left\"></div><div \nclass=\"padding-8p border-right border-left\" ng-if=\"settings.global_tax\"><div class=\"bill-info\"><div class=\"left-side\">\n{{response[0].sales_dietType}}</div><div class=\"right-side text-align-right\"><span \nng-if=\"response[0].sales_dietType==\'dinein\'\">{{\'BILLINGS.TABLE-NO\' | translate}} :{{response[0].tableitem}}</span>\n</div></div><table><thead><tr><th class=\"secondary-text\" width=\"50%\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"12%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span></div></th><th \nclass=\"secondary-text right\" width=\"14%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text right mr-8\" width=\"24%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"fmitem in fmitems\"><td>{{fmitem.sales_items}}</td><td>{{fmitem.sales_quantity}}</td><td \nclass=\"right\">{{fmitem.salesitem_rate}}.00</td><td class=\"right\">{{fmitem.sales_quantity * fmitem.salesitem_rate}}.00\n</td></tr></tbody></table><div class=\"main-total-box border-top mb-0 mt-0\"><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}} :</div>\n<div class=\"value flex-20 layout-row layout-align-end-center\"><span translate class=\"grey-col-sec-text pr-2\">\nBILLINGS.INR</span> <span>{{ fmitems.subTotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\" ng-if=\"taxs[0].taxRate\"><div class=\"tag flex\">\n{{\'BILLINGS.CGST\' | translate}}({{taxs[0].taxRate}}%) :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> <span>{{payment.tax_rate | number:2}}</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" \nng-if=\"taxs[1].taxRate\"><div class=\"tag flex\">{{\'BILLINGS.SGST\' | translate}}({{taxs[1].taxRate}}%) :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> <span>{{payment.tax_sgst | number:2}}</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" \nng-if=\"payment.additional_charge\"><div class=\"tag flex\">Additional Charge:</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> <span>{{payment.additional_charge | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\" ng-if=\"payment.discount\"><div class=\"tag flex\">\n{{\'BILLINGS.DISCOUNT\' | translate}}:</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{payment.discount | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"total_pointdiscount\"><div class=\"tag flex\">\n{{\'BILLINGS.POINTS-DISCOUNT\' | translate}} :</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span>\n₹{{ total_pointdiscount | number:2}}</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" \nng-if=\"savedamount\"><div class=\"tag flex\">You are saved the amount :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>\n₹{{savedamount+payment.discount+total_pointdiscount | number:2}}</span></div></div><div class=\"layout-row footer mt-4\">\n<div class=\"tag flex layout-row layout-align-end-center\">{{\'BILLINGS.Total Amount\' | translate}} :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> <span class=\"total\">{{payment.payment_total}}</span></div></div><div \nclass=\"layout-row layout-align-start-center\" ng-if=\"pointsEarned && points[0].enablepoint==1\"><div class=\"tag flex\" \nstyle=\"text-align: left\">Points earned to next visit : <span>{{ pointsEarned}}</span></div></div></div><div \nclass=\"main-total-box mb-0 mt-0\">Managed By: {{manageBy}}</div></div><div class=\"padding-8p border-right border-left\" \nng-if=\"!settings.global_tax\"><div class=\"bill-info\"><div class=\"left-side\"><span ng-if=\"settings.tableno_permission\">\n{{response[0].sales_dietType}}</span></div><div class=\"right-side text-align-right\"><span \nng-if=\"settings.tableno_permission&&response[0].sales_dietType==\'dinein\'\">\n{{\'BILLINGS.TABLE-NO\' | translate}} :{{response[0].tableitem}}</span></div></div><table><thead><tr><th \nclass=\"secondary-text\" width=\"50%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"6%\"><div class=\"table-header\"><span\n class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text right\" width=\"12%\"><div\n class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th \nclass=\"secondary-text right\" width=\"10%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.TAX\' | translate}}</span></div></th><th class=\"secondary-text right mr-8\" width=\"22%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"fmitem in fmitems\"><td>{{fmitem.sales_items}}</td><td>{{fmitem.sales_quantity}}</td><td \nclass=\"right\" ng-if=\"hideRate.value==\'exclude\'\">{{fmitem.sales_quantity * fmitem.salesitem_rate}}</td><td \nclass=\"right\" ng-if=\"hideRate.value==\'include\'\">\n{{(fmitem.sales_quantity * fmitem.salesitem_rate)-(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem)}}</td><td \nclass=\"right\">{{fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem | number:2}}</td><td class=\"right\" \nng-if=\"hideRate.value==\'include\'\">{{fmitem.sales_quantity * fmitem.salesitem_rate}}.00</td><td class=\"right\" \nng-if=\"hideRate.value==\'exclude\'\">\n{{(fmitem.sales_quantity * fmitem.salesitem_rate)+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem)}}</td></tr></tbody>\n</table><div class=\"main-total-box border-top mb-0 mt-0\"><div class=\"layout-row layout-align-start-center mt-4\"><div \nclass=\"tag flex\" ng-if=\"hideRate.value==\'include\'\">TOTAL {{\'BILLINGS.RATE\' | translate}} : {{fullrate | number:2}}\n</div><div class=\"tag flex\" ng-if=\"hideRate.value==\'exclude\'\">\nTOTAL {{\'BILLINGS.RATE\' | translate}} :{{fullexcluderate | number:2}}</div><div class=\"tag flex\">\nTOTAL {{\'BILLINGS.TAX\' | translate}} :{{totalTax | number:2}}</div><div class=\"tag flex\">\n{{\'BILLINGS.Sub Total\' | translate}} :</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span ng-if=\"hideRate.value==\'include\'\">\n{{ fmitems.subTotal | number:2}}</span> <span ng-if=\"hideRate.value==\'exclude\'\">{{excludesubTotal | number:2}}</span>\n</div></div><div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"payment.additional_charge\"><div \nclass=\"tag flex\">Additional Charge:</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{payment.additional_charge | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"payment.discount\"><div class=\"tag flex\">\n{{\'BILLINGS.DISCOUNT\' | translate}}:</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{payment.discount | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-4\" ng-if=\"total_pointdiscount\"><div class=\"tag flex\">\n{{\'BILLINGS.POINTS-DISCOUNT\' | translate}} :</div><div class=\"value flex-20 layout-row layout-align-end-center\"><span>\n₹{{ total_pointdiscount | number:2}}</span></div></div><div class=\"layout-row layout-align-start-center mt-4\" \nng-if=\"savedamount\"><div class=\"tag flex\">You are saved the amount :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span>\n₹{{savedamount+payment.discount+total_pointdiscount | number:2}}</span></div></div><div class=\"layout-row footer mt-4\">\n<div class=\"tag flex layout-row layout-align-end-center\">{{\'BILLINGS.Total Amount\' | translate}} :</div><div \nclass=\"value flex-20 layout-row layout-align-end-center\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> <span class=\"total\">{{ payment.payment_total | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center\" ng-if=\"pointsEarned && points[0].enablepoint==1\"><div class=\"tag flex\" \nstyle=\"text-align: left\">Points earned to next visit : <span>{{ pointsEarned}}</span></div></div></div><div \nclass=\"main-total-box mb-0 mt-0\">Managed By: {{manageBy}}</div></div><div \nclass=\"receipt-border border-right border-left\"></div></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/templates/manage.html","<div class=\"w-400\"><div class=\"font-size-16 font-weight-500 text-italic mb-40\"><span translate>BILLINGS.ORDERED-NO\n</span>. 56564</div><div layout-wrap layout-gt-sm=\"row\"><md-input-container class=\"md-block md-accent\" ng-hide=\"show\" \nflex=\"50\"><label>Select Role</label><md-select ng-model=\"vm.currentbills.manageBy\" class=\"md-accent\"><md-option \nng-repeat=\"staff in vm.staffss\" value=\"{{staff.name}}\">{{staff.name}}</md-option></md-select></md-input-container>\n</div></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/templates/payment.html","<div class=\"w-400\"><div class=\"font-size-16 font-weight-500 text-italic mb-8\"><span translate>BILLINGS.ORDERED-NO\n</span>. 56564</div><md-button ng-click=\"OpenPermission = !OpenPermission\" class=\"md-accent ml-0 mb-8\">\nADD DISCOUNT/ COUPON<md-icon md-font-icon=\"icon-menu-down\" class=\"icon s24\" aria-hidden=\"true\"></md-icon></md-button>\n<div class=\"layout-row w-400 ash-color pr-16 pl-16 pt-8 mb-16\" ng-show=\"OpenPermission\"><md-input-container \nclass=\"md-block md-accent\"><label><span translate>BILLINGS.DISCOUNT</span></label><input type=\"text\">\n</md-input-container><md-input-container class=\"md-accent mr-24\"><md-select ng-model=\"vm.discount\"><md-option \nng-repeat=\"discountType in vm.discountTypes\" value=\"{{ discountType.currency }}\">{{ discountType.currency }}\n</md-option></md-select></md-input-container></div><ul class=\"main-total-box full-bordered mb-25\"><li \nclass=\"layout-row layout-align-start-center\"><div class=\"tag flex\">Sub Total</div><div \nclass=\"value flex-30 layout-row layout-align-start-center\"><span translate>BILLINGS.INR</span> <span>860</span></div>\n</li><li class=\"layout-row layout-align-start-center\"><div class=\"tag flex\">Vat(2%)</div><div \nclass=\"value flex-30 layout-row layout-align-start-center\"><span translate>BILLINGS.INR</span> <span>40</span></div>\n</li><li class=\"layout-row footer\"><div class=\"tag flex\">Total Amount</div><div \nclass=\"value flex-30 layout-row layout-align-start-center\"><span translate>BILLINGS.INR</span> <span>900</span></div>\n</li></ul></div><div class=\"w-400\"><span class=\"secondary-text\"><span translate>BILLINGS.PAYMENT</span> Mode</span><div\n class=\"ash-color p-8 mb-16 mt-8\"><md-radio-group class=\"layout-row margin-bottom-16 margin-top-10\" \nng-model=\"currentbill.paymentmode\"><md-radio-button ng-repeat=\"mode in vm.paymentmodelist\" value=\"{{mode.value}}\" \nclass=\"md-accent\">{{mode.name}}</md-radio-button></md-radio-group></div><div \nclass=\"layout-row layout-align-start-center\" ng-if=\"currentbill.paymentmode == \'cash & card\'\"><md-input-container \nclass=\"md-block md-accent\"><label>Received Cash</label><input type=\"text\" ng-model=\"currentbill.receivedCash\" \nng-required=\"true\"></md-input-container><md-input-container class=\"md-block md-accent\"><label>Transfer Cash</label>\n<input type=\"text\" ng-model=\"currentbill.transferCash\"></md-input-container></div><div \nclass=\"layout-col layout-align-start-center\" \nng-if=\"currentbill.paymentmode == \'card\' || currentbill.paymentmode == \'cash & card\'\"><md-input-container \nclass=\"md-block md-accent\"><label>Transaction No</label><input type=\"text\" ng-model=\"currentbill.transactionNo\" \nng-required=\"true\"></md-input-container></div><div class=\"layout-col layout-align-start-center\" \nng-if=\"currentbill.paymentmode == \'unpaid\'\"><md-input-container class=\"md-block md-accent mt-16\"><label>Reason</label>\n<md-select ng-model=\"currentbill.unpaidReason\" class=\"md-accent\" ng-required=\"true\"><md-option value=\"police\">Police\n</md-option><md-option value=\"disability\">Disabled Person</md-option></md-select></md-input-container><div \nclass=\"pt-16\"><md-input-container class=\"md-block md-accent\"><label>Description</label><textarea \nng-model=\"currentbill.unpaidReasonDesc\" rows=\"2\"></textarea></md-input-container></div></div></div><div \nclass=\"layout-row layout-align-start-center\"><md-button class=\"md-raised md-primary margin-left-0\" aria-label=\"Submit\" \nng-if=\"vm.paymentmode != \'unpaid\'\">Paid</md-button><md-button class=\"md-raised md-primary margin-left-0\" \naria-label=\"Submit\" ng-if=\"vm.paymentmode == \'unpaid\'\">Submit</md-button></div>");
$templateCache.put("app/main/cashier/billing/bill-dialog/templates/timeline.html","Manage By : {{response[0].manageBy}}<br><br><timeline class=\"default\"><timeline-event \nng-repeat=\"timeline in foodTimeline\" side=\"right\"><timeline-badge class=\"{{timeline.badgeClass}}\"></timeline-badge><div\n class=\"timeline-label black-text font-size-14\">{{timeline.time}}</div><timeline-panel class=\"{{timeline.badgeClass}}\">\n<timeline-heading><div class=\"black-text font-weight-500 font-size-14\">{{timeline.title}}</div></timeline-heading><div \nclass=\"text-black-54 font-size-14 margin-top-16\">{{timeline.content}}</div><div \nclass=\"text-black-54 font-size-12 margin-top-15\">{{timeline.manage}}</div></timeline-panel></timeline-event></timeline>");
$templateCache.put("app/main/cashier/billing/currentbills/dietin/diet.in.html","<div class=\"layout-column layout-align-center-center min-height-100 white-bg padding-24 text-center no-data\" \nng-if=\"dinein.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 class=\"text-center md-display-1\">\nHi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no {{\'BILLINGS.ORDERED-BILLS\' | translate }} for you to see. If you want to create a new bill just click below button and go ahead\n</h3><md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.newBill\">\n{{\'BILLINGS.NEW-BILL\' | translate}}</md-button></div><div layout=\"row\" layout-align=\"center start\" flex class=\"mb-16\" \nng-if=\"dinein.length || retrieve\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"dinein_query.filter\" \nng-keypress=\"keyPressed($event)\" ng-model-options=\"filter.options\" type=\"text\" \nplaceholder=\"Search {{\'BILLINGS.ORDERED-NO\' | translate}} or {{ \'BILLINGS.TABLE-NO\' | translate}}...\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"dinein_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><div ng-if=\"dinein.length || retrieve\"><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"dinein_query.order\" md-on-reorder=\"getDesserts\"><tr md-row><th md-column width=\"7%\">\n{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th md-column width=\"5%\" class=\"hidebelow959\">\n{{ \'BILLINGS.ITEMS\' | translate}}</th><th md-column ng-if=\"vm.settings.tableno_permission\" width=\"5%\">\n{{ \'BILLINGS.TABLE-NO\' | translate}}</th><th md-column width=\"7%\">{{ \'BILLINGS.AMOUNT\' | translate}}</th><th md-column \nwidth=\"10%\" class=\"hidebelow959\">{{ \'BILLINGS.ORDERED-TIME\' | translate}}</th><th md-column width=\"10%\" \nclass=\"hidebelow959\">{{ \'BILLINGS.ORDER-TAKEN\' | translate}}</th><th md-column ng-if=\"permission==admin\" width=\"10%\" \nclass=\"hidebelow959\">{{ \'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"15%\"><span>\n{{ \'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"currentbill in dinein | limitTo: dinein_query.limit | filter: dinein_query.filter | orderBy: dinein_query.order\">\n<td md-cell ng-class=\"currentbill.status\" class=\"border-status\">{{currentbill.salesorder_id}}</td><td md-cell \nclass=\"hidebelow959\">{{ currentbill.sales_items }}</td><td md-cell ng-if=\"vm.settings.tableno_permission\">\n{{ currentbill.tableitem }}</td><td md-cell><div class=\"layout-row layout-align-start-center\"><span \nclass=\"grey-col-sec-text pr-2\" translate>BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ currentbill.payment_total }}</span></div></td><td md-cell class=\"hidebelow959\"><span \ntitle=\"{{ currentbill.showorderdate }}\">{{ currentbill.ordertime }}</span><md-icon \ntitle=\"Last updated by  {{ update_staff(currentbill)}} ,on {{ currentbill.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \nclass=\"hidebelow959\">{{ currentbill.manageBy }}</td><td md-cell ng-if=\"permission==admin\" class=\"hidebelow959\">\n{{ dinein_staffnames(currentbill) }}</td><td><md-button class=\"md-icon-button small-button hidebelow959\" \naria-label=\"PrintBill\" title=\"Print Bill\" ng-click=\"printToCart(currentbill);$event.stopPropagation();\"><md-icon \nmd-menu-origin md-font-icon=\"text-black-40 icon-printer\"></md-icon></md-button><md-button \nng-if=\"admin.length || saleseditt.length\" class=\"md-icon-button small-button\" aria-label=\"Edit\" title=\"Edit Item\" \nng-click=\"Editdiet(currentbill.salesorder_id,currentbill.customer_id);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"text-black-40 icon-pencil\"></md-icon></md-button><md-button ng-if=\"admin.length\" \nng-click=\"removeRow(currentbill,$event,$index)\" class=\"md-icon-button small-button hidebelow959\" aria-label=\"Delete\">\n<md-icon md-font-icon=\"icon-trash text-black-40\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"dinein_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"dinein_query.page\" \nmd-total=\"{{dinein_count}}\" md-on-paginate=\"getDesserts\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/cashier/billing/currentbills/doordelivery/door.delivery.html","<div class=\"layout-column layout-align-center-center min-height-100 white-bg padding-24 text-center no-data\" \nng-if=\"vm.doordelivery.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 \nclass=\"text-center md-display-1\">Hi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no current bills for you to see. If you want to create a new bill just click below button and go ahead</h3>\n<md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.newBill\">\n{{\'BILLINGS.NEW-BILL\' | translate}}</md-button></div><div layout=\"row\" layout-align=\"center start\" flex class=\"mb-16\" \nng-if=\"vm.doordelivery.length>0 || retrieve\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"doordelivery_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{ \'BILLINGS.ORDERED-NO\' | translate}},{{ \'BILLINGS.AMOUNT\' | translate}} or {{ \'BILLINGS.ORDER-TAKEN\' | translate}}\" \nflex><md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" \nng-if=\"doordelivery_query.filter\" ng-click=\"clearText()\"></md-icon></div></div><div \nng-if=\"vm.doordelivery.length  || retrieve\"><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head md-order=\"doordelivery_query.order\" \nmd-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"10%\">{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th \nmd-column width=\"5%\" class=\"hidebelow959\">{{ \'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"7%\">\n{{ \'BILLINGS.AMOUNT\' | translate}}</th><th md-column width=\"7%\" class=\"hidebelow959\">{{\'EXPENSE.Balance\' | translate}}\n</th><th md-column width=\"7%\" class=\"hidebelow959\">{{ \'BILLINGS.ORDERED-TIME\' | translate}}</th><th md-column \nwidth=\"10%\" class=\"hidebelow959\">{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th><th md-column width=\"10%\" \nclass=\"hidebelow959\">{{ \'BILLINGS.ORDER-TAKEN\' | translate}}</th><th md-column ng-if=\"permission==admin\" width=\"10%\" \nclass=\"hidebelow959\">{{ \'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"15%\"><span>\n{{ \'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"currentbill in vm.doordelivery | limitTo: doordelivery_query.limit | filter: doordelivery_query.filter | orderBy: doordelivery_query.order\">\n<td md-cell ng-class=\"currentbill.status\" class=\"border-status\">{{currentbill.salesorder_id}}</td><td md-cell \nclass=\"hidebelow959\">{{ currentbill.sales_items }}</td><td md-cell><div class=\"layout-row layout-align-start-center\">\n<span class=\"grey-col-sec-text pr-2\" translate>BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ currentbill.payment_total }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\" \nclass=\"hidebelow959\"><span translate class=\"warm-color\" \nng-if=\"(currentbill.payment_received > \'0\')||(!currentbill.payment_mode&&currentbill.payment_total!=0)\">BILLINGS.INR\n</span> <span ng-show=\"currentbill.payment_status!=\'paid\'\" class=\"font-size-px-18 warm-color\">\n{{ currentbill.payment_total - currentbill.payment_received}}</span> <span class=\"font-size-px-18\" \nng-if=\"currentbill.payment_received == \'0\'&&currentbill.payment_mode\">{{\'-\'}}</span> <span \nclass=\"flex-none adv-amount\" ng-if=\"currentbill.payment_received > \'0\'\">adv {{ currentbill.payment_received }}</span>\n</td><td md-cell title=\"{{ currentbill.showorderdate }}\" class=\"hidebelow959\">{{ currentbill.ordertime }}<md-icon \ntitle=\"Last updated by  {{ update_staff(currentbill)}} ,on {{ currentbill.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \ntitle=\"{{currentbill.showdeliverdate}}\" class=\"hidebelow959\"><div class=\"layout-row\">\n{{ currentbill.sales_deliveryTime }}<div id=\"demo\" class=\"ml-8 remaining-timer\" \nng-if=\"currentbill.sales_deliveryTime != \'Immediate\'\"><span class=\"flex-none\">{{currentbill.remainingtime}}</span>\n</div></div></td><td md-cell class=\"hidebelow959\">{{ currentbill.manageBy }}</td><td md-cell ng-if=\"permission==admin\" \nclass=\"hidebelow959\">{{doordelivery_staffnames(currentbill) }}</td><td><md-button \nclass=\"md-icon-button small-button hidebelow959\" aria-label=\"PrintBill\" title=\"Print Bill\" \nng-click=\"printToCart(currentbill);$event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"text-black-40 icon-printer\"></md-icon></md-button><md-button class=\"md-icon-button small-button\" \nng-if=\"admin.length || saleseditt.length\" aria-label=\"Edit\" title=\"Edit Item\" \nng-click=\"Editdiet(currentbill.salesorder_id,currentbill.customer_id);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"text-black-40 icon-pencil\"></md-icon></md-button><md-button ng-if=\"admin.length\" \nng-click=\"removeRow(currentbill,$event,$index)\" class=\"md-icon-button small-button hidebelow959\" aria-label=\"Delete\">\n<md-icon md-font-icon=\"icon-trash text-black-40\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"doordelivery_query.limit\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"doordelivery_query.page\" md-total=\"{{doordelivery_count}}\" md-on-paginate=\"getDessertsss\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/cashier/billing/currentbills/takeaway/take.away.html","<div class=\"layout-column layout-align-center-center min-height-100 white-bg padding-24 text-center no-data\" \nng-if=\"vm.takeaway.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 class=\"text-center md-display-1\">\nHi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no current bills for you to see. If you want to create a new bill just click below button and go ahead</h3>\n<md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.newBill\">\n{{\'BILLINGS.NEW-BILL\' | translate}}</md-button></div><div layout=\"row\" layout-align=\"center start\" flex class=\"mb-16\" \nng-if=\"vm.takeaway.length>0 || retrieve\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"takeaway_query.filter\" type=\"text\" \nplaceholder=\"Search {{ \'BILLINGS.ORDERED-NO\' | translate}},{{ \'BILLINGS.AMOUNT\' | translate}} or {{ \'BILLINGS.ORDER-TAKEN\' | translate}}\" \nflex><md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" \nng-if=\"takeaway_query.filter\" ng-click=\"clearText()\"></md-icon></div></div><div ng-if=\"vm.takeaway.length || retrieve\">\n<md-table-container><table md-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\">\n<thead md-head md-order=\"takeaway_query.order\" md-on-reorder=\"getDessertss\"><tr md-row><th md-column width=\"10%\">\n{{ \'BILLINGS.ORDERED-NO\' | translate}}</th><th md-column width=\"5%\" class=\"hidebelow959\">\n{{ \'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"7%\">{{ \'BILLINGS.AMOUNT\' | translate}}</th><th md-column \nwidth=\"7%\" class=\"hidebelow959\">{{\'EXPENSE.Balance\' | translate}}</th><th md-column width=\"7%\" class=\"hidebelow959\">\n{{ \'BILLINGS.ORDERED-TIME\' | translate}}</th><th md-column width=\"10%\" class=\"hidebelow959\">\n{{ \'BILLINGS.DELIVERED-TIME\' | translate}}</th><th md-column width=\"10%\" class=\"hidebelow959\">\n{{ \'BILLINGS.ORDER-TAKEN\' | translate}}</th><th md-column ng-if=\"permission==admin\" width=\"10%\" class=\"hidebelow959\">\n{{ \'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"15%\"><span>{{ \'BILLINGS.ACTIONS\' | translate}}</span>\n</th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-select=\"dessert\" \nng-repeat=\"currentbill in vm.takeaway | limitTo: takeaway_query.limit | filter: takeaway_query.filter | orderBy: takeaway_query.order\">\n<td md-cell ng-class=\"currentbill.status\" class=\"border-status\">{{currentbill.salesorder_id}}</td><td md-cell \nclass=\"hidebelow959\">{{ currentbill.sales_items }}</td><td md-cell><div class=\"layout-row layout-align-start-center\">\n<span class=\"grey-col-sec-text pr-2\" translate>BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ currentbill.payment_total }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\" \nclass=\"hidebelow959\"><span translate class=\"warm-color\" \nng-if=\"(currentbill.payment_received > \'0\')||(!currentbill.payment_mode&&currentbill.payment_total!=0)\">BILLINGS.INR\n</span> <span ng-show=\"(currentbill.payment_status!=\'paid\')\" class=\"font-size-px-18 warm-color\">\n{{ currentbill.payment_total - currentbill.payment_received}}</span> <span class=\"font-size-px-18\" \nng-if=\"currentbill.payment_received == \'0\'&&currentbill.payment_mode\">{{\'-\'}}</span> <span \nclass=\"flex-none adv-amount\" ng-if=\"currentbill.payment_received > \'0\'\">adv {{ currentbill.payment_received }}</span>\n</td><td md-cell class=\"hidebelow959\"><span title=\"{{ currentbill.showorderdate }}\">{{ currentbill.ordertime }}</span>\n<md-icon title=\"Last updated by  {{ update_staff(currentbill)}} ,on {{ currentbill.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td md-cell \ntitle=\"{{currentbill.showdeliverdate}}\" class=\"hidebelow959\"><div class=\"layout-row\">\n{{ currentbill.sales_deliveryTime }}<div id=\"demo\" class=\"ml-8 remaining-timer\" \nng-if=\"currentbill.sales_deliveryTime != \'Immediate\'\"><span class=\"flex-none\">{{currentbill.remainingtime}}</span>\n</div></div></td><td md-cell class=\"hidebelow959\">{{ currentbill.manageBy }}</td><td md-cell ng-if=\"permission==admin\" \nclass=\"hidebelow959\">{{ takeaway_staffnames(currentbill) }}</td><td><md-button \nclass=\"md-icon-button small-button hidebelow959\" aria-label=\"PrintBill\" title=\"Print Bill\" \nng-click=\"printToCart(currentbill);$event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"text-black-40 icon-printer\"></md-icon></md-button><md-button ng-if=\"admin.length || saleseditt.length\" \nclass=\"md-icon-button small-button\" aria-label=\"Edit\" title=\"Edit Item\" \nng-click=\"Editdiet(currentbill.salesorder_id,currentbill.customer_id);$event.stopPropagation();\"><md-icon \nmd-font-icon=\"text-black-40 icon-pencil\"></md-icon></md-button><md-button ng-if=\"admin.length\" \nng-click=\"removeRow(currentbill,$event,$index)\" class=\"md-icon-button small-button hidebelow959\" aria-label=\"Delete\">\n<md-icon md-font-icon=\"icon-trash text-black-40\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"takeaway_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"takeaway_query.page\" \nmd-total=\"{{takeaway_count}}\" md-on-paginate=\"getDessertss\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/cashier/billing/newbill/billinfo/billinfo.html","<div id=\"bod\" class=\"no-error small\"><div id=\"head\"><div layout=\"row\" ng-show=\"{{vm.settings.dealer}}\"><md-radio-group \nclass=\"layout-row mb-20 flex\" id=\"radio-focus\" ng-model=\"vm.activedealer\" id=\"myselector\" ng-keypress=\"select($event)\" \ntabindex=\"1\"><md-radio-button ng-repeat=\"category in vm.dealerLists\" value=\"{{category.value}}\" \nclass=\"md-accent selectored\" ng-click=\"cancelDealer($event, vm.activedealer, category.value)\">{{category.label}}\n</md-radio-button></md-radio-group></div><div layout=\"row\" ng-show=\"{{vm.settings.dinein_permission}}\"><md-radio-group \nclass=\"layout-row mb-20 flex\" id=\"radio-focus\" ng-model=\"vm.billing.dietType\" id=\"myselector\" \nng-keypress=\"select($event)\" tabindex=\"1\"><md-radio-button ng-repeat=\"category in vm.dietType\" \nvalue=\"{{category.value}}\" class=\"md-accent selectored\" ng-click=\"clearThirdparty($event,category.value)\">\n{{category.label}}</md-radio-button></md-radio-group><span class=\"flex-none font-size-px-13\"><a \nng-click=\"vm.validation.bill_description = true\" class=\"ml-16\" ng-show=\"vm.validation.bill_description == false\">\nAdd Description</a></span></div><div class=\"layout-row\"><div class=\"layout-row flex-none mr-16 mb-20\" \nstyle=\"width: 220px\" ng-if=\"vm.billing.dietType==vm.dietType[0].value&&vm.settings.tableno_permission\"><span \nclass=\"flex-40 pt-8\"><label class=\"text-black-54 font-size-14 mr-16\" translate>BILLINGS.TABLE-NO</label></span>\n<md-input-container class=\"md-accent\" flex=\"60\" md-no-float><md-select ng-model=\"vm.billing.tableno\" \nplaceholder=\"Select\" name=\"tableno\" class=\"md-accent\" ng-required=\"vm.billing.dietType==\'dinein\'\" \nng-change=\"validatecustomer()\" required md-no-asterisk=\"false\"><md-option ng-repeat=\"tableno in vm.tablenos\" \nvalue=\"{{tableno.table_id}}\">{{tableno.table_no}}</md-option></md-select><div ng-messages=\"newBill.tableno.$invalid\">\n<div ng-message=\"required\"></div></div></md-input-container></div><div class=\"layout-row flex-none mr-16 mb-20\" \nstyle=\"width: 220px\" \nng-if=\"(vm.billing.dietType==vm.dietType[1].value || vm.billing.dietType==vm.dietType[2].value )&&vm.settings.thirdparty_permission\">\n<span class=\"flex-40 pt-8\"><label class=\"text-black-54 font-size-14 mr-16\" translate>BILLINGS.THIRD-PARTY</label>\n</span><md-input-container class=\"md-accent\" flex=\"60\" md-no-float><md-select ng-model=\"vm.billing.thirdparty_id\" \nplaceholder=\"Select\" name=\"thirdparty\" class=\"md-accent\"><md-option ng-repeat=\"ThirdParty in vm.ThirdPartys\" \nvalue=\"{{ThirdParty.thirdparty_id}}\">{{ThirdParty.thirdparty_name}}</md-option></md-select></md-input-container></div>\n<div layout=\"column\" flex class=\"mb-16 mr-16\" \nng-if=\"(vm.billing.dietType==vm.dietType[1].value || vm.billing.dietType==vm.dietType[2].value )&&vm.settings.thirdparty_permission&&vm.billing.thirdparty_id\">\n<md-input-container class=\"md-block md-accent\" md-no-float><input type=\"text\" \nplaceholder=\"{{getThirdPartyName(vm.billing.thirdparty_id)}} {{ \'BILLINGS.ORDER-NO\' | translate}}\" \nng-model=\"vm.billing.thirdparty_orderno\"></md-input-container></div><div layout=\"column\" flex=\"50\" \nng-if=\"OpenDescription = vm.validation.bill_description\" class=\"mb-16\"><md-input-container class=\"md-block md-accent\" \nmd-no-float><input type=\"text\" placeholder=\"{{\'BILLINGS.Description\' | translate}}\" \nng-model=\"vm.payment.unpaid_description\" ng-required=\"vm.activedealer == 1\"></md-input-container></div></div></div><div\n id=\"content1\" class=\"flex\"><div layout=\"row\" layout-align=\"end center\" show-xs=\"\" hide=\"\"><md-button \nclass=\"layout-row md-accent layout-align-start-end\" aria-label=\"Add & Items\" ng-click=\"showPopupMenu()\"><span \nclass=\"layout-row layout-align-center-center\"><i class=\"icon icon-plus font-size-24 mr-4 iconMdaccent\"></i>ADD ITEMS\n</span></md-button></div><div class=\"layout-column flex bill-info-food-list-wrapper small no-error\"><table \nclass=\"desktopbill hidebelow600 dataTable border-right border-right border-left border-bottom flex track by $index\" \nnavigatable hide-xs=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title ml-8\">\n{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"16%\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-if=\"!vm.print.mrp\">{{\'BILLINGS.RATE\' | translate}}</span> <span \nclass=\"column-title\" ng-if=\"vm.print.mrp\">{{\'BILLINGS.MRP\' | translate}}</span></div></th><th \nclass=\"secondary-text hidebelow600\" width=\"12%\" ng-if=\"!vm.settings.global_tax\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-if=\"!vm.print.mrp\">Tax</span> <span class=\"column-title\" ng-if=\"vm.print.mrp\">\n{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text hidebelow600\" width=\"14%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"8%\"></th></tr></thead><tbody style=\"padding: 12px 0\" hide-xs=\"\"><tr \nng-repeat=\"fmitem in vm.fmitems\"><td class=\"foodItem-auto\" ng-if=\"vm.branchFilterData[0].barcode_enable == 1\">\n<md-autocomplete md-mode=\"standard\" ng-class=\"{\'autodd\': $index == indx}\" md-input-id=\"fooditem\" \nclass=\"md-accent no-label ml-8\" flex=\"100\" md-input-name=\"autocompleteFood\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.sales_items\" \nmd-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" ng-keypress=\"barcodekeyPressed($event)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{\'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-require-match required md-autofocus=\"true\" \nmd-placeholder=\"hello\" md-autoselect=\"true\" ng-focus=\"setfoucus($index)\"><md-item-template><span \nmd-highlight-text=\"fmitem.searchText\">{{item.sales_items}}</span><span class=\"autocomplete-catergory\">{{item.display}}\n</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" class=\"hideerrormessage\"><div \nng-message=\"required\">You <b>must</b> enter a</div><div ng-message=\"md-require-match\">Please select an existing</div>\n</div></md-autocomplete></td><td class=\"foodItem-auto\" ng-if=\"vm.branchFilterData[0].barcode_enable != 1\">\n<md-autocomplete md-delay=\"50\" ng-class=\"{\'autodd\': $index == indx}\" md-input-id=\"fooditem2\" \nclass=\"md-accent no-label ml-8\" flex=\"100\" md-input-name=\"autocompleteFood\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.sales_items\" \nmd-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" ng-keypress=\"keyPressedNextMove($event)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{\'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-min-length=\"0\" md-require-match required \nmd-autofocus=\"true\" md-placeholder=\"hello\" md-autoselect=\"true\" ng-focus=\"setfoucus($index)\"><md-item-template><span \nmd-highlight-text=\"fmitem.searchText\">{{item.sales_items}}</span><span class=\"autocomplete-catergory\">\n{{item.fmcatergoryName}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nclass=\"hideerrormessage\"><div ng-message=\"required\">You <b>must</b> enter a</div><div ng-message=\"md-require-match\">\nPlease select an existing</div></div></md-autocomplete></td><td width=\"10%\"><md-input-container md-no-float \nclass=\"md-accent\" flex=\"90\"><input id=\"quantity\" class=\"qty\" maxlength=\"4\" ng-keypress=\"keyPressed($event);\" \nplaceholder=\"{{ \'RESTRAUNTANT.QTY\' | translate }}\" valid-number type=\"text\" name=\"quantity\" \nng-model=\"fmitem.sales_quantity\" required autocomplete=\"off\" ng-focus=\"setfoucus($index)\"><div \nng-messages=\"newBill.quantity.$error\" class=\"hideerrormessage\"><div ng-message=\"required\">You <b>must</b> enter a</div>\n</div></md-input-container></td><td class=\"text-black-70 hidebelow600\" width=\"16%\" ng-if=\"vm.settings.global_tax\"><span\n ng-hide=\"OpenPermissions\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span>\n {{fmitem.salesitem_rate | number:1}} <strike ng-if=\"fmitem.offerprice\"><span translate class=\"pr-2\">BILLINGS.INR\n</span> {{fmitem.actualprice | number:1}}</strike></span></td><td class=\"text-black-70\" width=\"16%\" \nng-if=\"hideRate.value==\'include\'&&!vm.settings.global_tax\"><div ng-if=\"!vm.print.mrp\"><span translate \nclass=\"grey-col-sec-text\">BILLINGS.INR</span>\n {{(fmitem.subitemtotal )-(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}} &nbsp;<strike \nng-if=\"fmitem.offerprice && vm.activedealer != \'dealer\'\" class=\"hidebelow600\"> <span translate \nclass=\"grey-col-sec-text\">BILLINGS.INR</span>\n {{(fmitem.sales_quantity * fmitem.actualprice)-(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</strike>\n</div><div ng-if=\"vm.print.mrp\"><span ng-hide=\"OpenPermissions\"><span translate class=\"grey-col-sec-text\">BILLINGS.INR\n</span> {{fmitem.actualprice | number:1}}</span> <a ng-click=\"OpenPermissions = !OpenPermissions\" \nng-hide=\"OpenPermissions\" title=\"Edit Rate\" class=\"rate-edit\" ng-if=\"vm.settings.edit_rate\"><md-icon \nclass=\"cursor-pointer mr-2\" md-font-icon=\"icon icon-pencil s16 text-black-16\"></md-icon></a><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"90\" ng-show=\"OpenPermissions\" ng-if=\"vm.settings.edit_rate\"><input \ntype=\"number\" name=\"actualprice\" ng-keypress=\"keyPressed($event);\" ng-focus=\"setfoucus($index)\" \nng-model=\"fmitem.actualprice\" required aria-label=\"quantity\"><div ng-messages=\"addfoodForm.actualprice.$error\"><div \nng-message=\"required\"><span>Please enter the <span translate>RESTRAUNTANT.RATE</span></span></div></div>\n</md-input-container></div></td><td class=\"text-black-70\" width=\"16%\" \nng-if=\"hideRate.value==\'exclude\'&&!vm.settings.global_tax\"><span ng-hide=\"OpenPermissions\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> {{(fmitem.subitemtotal) | number:1}} <strike \nng-if=\"fmitem.offerprice\" class=\"hidebelow600\"><span translate class=\"pr-2\">BILLINGS.INR</span>\n {{fmitem.actualprice | number:1}}</strike></span></td><td class=\"text-black-70 hidebelow600\" width=\"12%\" \nng-if=\"!vm.settings.global_tax\"><div ng-if=\"!vm.print.mrp\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR\n</span> {{ fmitem.tax_cgstPerItem + fmitem.tax_sgstPerItem | number:1}}<md-icon \ntitle=\"{{\'BILLINGS.CGST\' | translate}}  {{ fmitem.tax_cgstPerItem | number:2}} + {{\'BILLINGS.SGST\' | translate}} {{ fmitem.tax_sgstPerItem | number:2}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></div><div ng-if=\"vm.print.mrp\">\n<span ng-hide=\"OpenPermissions\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span>\n {{(fmitem.offerprice ) | number:1}}</span> <a ng-click=\"OpenPermissions = !OpenPermissions\" ng-hide=\"OpenPermissions\" \ntitle=\"Edit Rate\" class=\"rate-edit\" ng-if=\"vm.settings.edit_rate\"><md-icon class=\"cursor-pointer mr-2\" \nmd-font-icon=\"icon icon-pencil s16 text-black-16\"></md-icon></a><md-input-container md-no-float \nclass=\"md-accent md-block\" flex=\"90\" ng-show=\"OpenPermissions\" ng-if=\"vm.settings.edit_rate\"><input type=\"number\" \nname=\"salesitem_rate\" ng-keypress=\"keyPressed($event);\" ng-focus=\"setfoucus($index)\" ng-model=\"fmitem.salesitem_rate\" \nrequired aria-label=\"quantity\"><div ng-messages=\"addfoodForm.salesitem_rate.$error\"><div ng-message=\"required\"><span>\nPlease enter the <span translate>RESTRAUNTANT.RATE</span></span></div></div></md-input-container></div></td><td \nclass=\"text-black-70 hidebelow600\" width=\"14%\" ng-if=\"vm.settings.global_tax\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> {{fmitem.subitemtotal | number:2}}</td><td \nclass=\"text-black-70 hidebelow600\" width=\"14%\" ng-if=\"hideRate.value==\'include\'&&!vm.settings.global_tax\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> {{fmitem.subitemtotal | number:2}}</td><td \nclass=\"text-black-70 hidebelow600\" width=\"14%\" ng-if=\"hideRate.value==\'exclude\'&&!vm.settings.global_tax\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span>\n {{(fmitem.subitemtotal)+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:2}}</td><td width=\"8%\"><a \nng-if=\"formitem == \'\'\" ng-click=\"removeRow(fmitem,$event,$index); $event.stopPropagation();\" class=\"removeRow\"><md-icon\n class=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon></a></td></tr></tbody></table><table \nclass=\"hideabove600 dataTable mobileBill border-right border-right border-left border-bottom flex track by $index\" \nnavigatable ng-if=\"winsize601\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"28%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"18%\"><div class=\"table-header\"><span class=\"column-title\" ng-if=\"!vm.print.mrp\">\n{{\'BILLINGS.RATE\' | translate}}</span> <span class=\"column-title\" ng-if=\"vm.print.mrp\">{{\'BILLINGS.MRP\' | translate}}\n</span></div></th><th class=\"secondary-text\" width=\"6%\"></th></tr></thead><tbody><tr ng-if=\"vm.fmitems.length < 1\"><td \ncolspan=\"5\"><div layout=\"column\" layout-align=\"center center\">No items to display</div></td></tr><tr \nng-repeat=\"fmitem in vm.fmitems track by $index\" class=\"md-selected\"><td width=\"48%\">\n{{fmitem.sales_items.sales_items ? fmitem.sales_items.sales_items : fmitem.sales_items}}</td><td width=\"28%\"><div \nstyle=\"display: flex; align-items:center\"><button class=\"decreament\" \nng-click=\"fmitem.sales_quantity = fmitem.sales_quantity - 1\" ng-class=\"{\'enabledButton\': fmitem.sales_quantity > 1}\">\n<span class=\"icon icon-minus font-size-24 mr-8\"></span></button> <span \nstyle=\"width:20px; text-align:center; display: inline-block\">{{fmitem.sales_quantity}}</span> <button \nclass=\"increament\" ng-click=\"fmitem.sales_quantity = fmitem.sales_quantity + 1\"><span \nclass=\"icon icon-plus font-size-24 mr-8\"></span></button></div></td><td width=\"18%\"><span translate class=\"pr-2\">\nBILLINGS.INR</span> {{fmitem.salesitem_rate}}</td><td width=\"6%\"><a ng-if=\"formitem == \'\'\" \nng-click=\"removeRow(fmitem,$event,$index); $event.stopPropagation();\" class=\"removeRow\"><md-icon class=\"text-black-24\" \nmd-font-icon=\"icon icon-trash\"></md-icon></a></td></tr></tbody></table></div></div><div id=\"foot\"><div \nclass=\"fix-bottom\"><div class=\"main-total-box\"><div class=\"layout-row layout-align-start-center\"><div flex \nclass=\"font-size-px-13 ml-8 grey-col-sec-text\" layout=\"row\"><span class=\"hidebelow600\" \nng-if=\"hideRate.value==\'exclude\'&&!vm.settings.global_tax\">Total Rate <span translate class=\"pr-2\">BILLINGS.INR</span> \n<span ng-if=\"!vm.print.mrp\">{{fullexcluderate | number:1}}</span> <span ng-if=\"vm.print.mrp\">\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</span></span><span \nclass=\"hidebelow600\" ng-if=\"hideRate.value==\'include\'&&!vm.settings.global_tax\">Total Rate <span translate \nclass=\"pr-2\">BILLINGS.INR</span> <span ng-if=\"!vm.print.mrp\">{{fullrate | number:1}}</span><span ng-if=\"vm.print.mrp\">\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</span></span><div \nclass=\"ml-8 hidebelow600\" ng-if=\"!vm.settings.global_tax\">Total Tax <span translate class=\"pr-2\">BILLINGS.INR</span>\n {{ vm.billing.tax_cgstInclude + vm.billing.tax_sgstInclude | number:1}}<md-icon \ntitle=\"({{\'BILLINGS.CGST\' | translate}} {{ vm.billing.tax_cgstInclude | number:2}} + {{\'BILLINGS.SGST\' | translate}} {{ vm.billing.tax_sgstInclude | number:2}})\" \nmd-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></div></div><div class=\"tag flex-20\">\n{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-2\" \nng-if=\"(vm.settings.global_tax&&vm.taxs[0].taxRate)||(vm.settings.global_tax&&vm.taxs[1].taxRate)\"><div \nclass=\"tag flex\">{{\'BILLINGS.CGST\' | translate}}<span ng-if=\"vm.settings.global_tax\">({{vm.taxs[0].taxRate}}%)</span>\n {{ vm.billing.tax | number:2}} + {{\'BILLINGS.SGST\' | translate}}<span ng-if=\"vm.settings.global_tax\">\n({{vm.taxs[1].taxRate}}%)</span> {{ vm.billing.tax_sgst | number:2}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ vm.billing.tax + vm.billing.tax_sgst | number:2}}</span>\n</div></div><div class=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" \nng-show=\"points[0].enablepoint==1\"><div class=\"flex\"></div><div flex=\"70\" layout=\"row\" \nng-show=\"points[0].enablepoint==1\" class=\"tag\" layout-align=\"end center\"><span ng-if=\"Openpoint==true\">\n<md-input-container md-no-float class=\"md-accent\" flex=\"30\" ng-show=\"OpenRemainPoints\"><input \nid=\"additional_charge-focus\" aria-label=\"today\" placeholder=\"\" maxlength=\"6\" type=\"number\" class=\"ml-8\" \nng-keypress=\"onlynumber($event);\" name=\"dis\" ng-model=\"vm.userPoints\"></md-input-container><a \nng-click=\"OpenRemainPoints= !OpenRemainPoints; initData(); openRemainpointdiscount();\" class=\"mr-16\">\nEdit Remaining points</a> </span><span \nng-show=\"vm.controlShow && !vm.pointOldCountNotIncrease && !vm.customerpoints.directlyapplypointamount && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0)) && (customer_data.pointsEarned>0 || customer.pointsEarned>0)\">\n<a ng-click=\"clearpointvalue(); initData();\" class=\"mr-16\">Clear old points</a></span> <span \nng-show=\"vm.controlShow && !vm.pointOldCountNotIncrease && !vm.customerpoints.directlyapplypointamount && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0)) && (customer_data.pointsEarned>0 || customer.pointsEarned>0)\">\n<a ng-click=\"applypointamount(); initData();\" class=\"mr-16\">Apply points to amount</a></span> <span class=\"mr-8\" \nng-show=\"points[0].enablepoint==1\" layout=\"row\"><md-icon ng-show=\"vm.clearPointback\" class=\"cursor-pointer mr-8\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" ng-click=\"clearPointback()\"></md-icon><md-icon \nng-show=\"vm.pointOldCountNotIncrease\" class=\"cursor-pointer mr-8\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" ng-click=\"vm.pointOldCountNotIncrease = 0\">\n</md-icon><md-icon \nng-show=\"vm.customerpoints.directlyapplypointamount && !vm.clearPointback && (points[0].enablepoint==1 && total_pointdiscount>0)\" \nclass=\"cursor-pointer mr-8\" md-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" \nng-click=\"Openpoint = !Openpoint;clearIconpointdiscount();dataopen(clearpointdiscount,$event);\"></md-icon>\n{{\'BILLINGS.POINTS-DISCOUNT\' | translate}} <span \nng-show=\"vm.customerpoints.directlyapplypointamount && (points[0].enablepoint==1  && total_pointdiscount>0) && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0) || (customer_data.pointsEarned))\">\n({{customer.pointsEarned ? customer.pointsEarned : customer_data.pointsEarned}})</span><span \nng-show=\"!vm.pointOldCountNotIncrease && !vm.customerpoints.directlyapplypointamount && ((newBill.autocompleteCustomer.$valid==true &&  vm.billing.roundtotal>=points[0].amount && customer.searchText!=0)) && (customer_data.pointsEarned>0 || customer.pointsEarned>0)\">\n({{customer.pointsEarned ? customer.pointsEarned : customer_data.pointsEarned}})</span><span \nng-show=\"vm.pointOldCountNotIncrease\">({{0}})</span></span></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ total_pointdiscount | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" ng-show=\"OpenCharge\"><div \nclass=\"flex\"></div><div class=\"tag flex md-accent spacer-8 flex-45\" layout=\"row\"><div flex layout=\"row\"><md-icon \nclass=\"cursor-pointer mr-8\" md-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" \nng-click=\"OpenCharge = !OpenCharge; clearCharge()\"></md-icon><span class=\"mt-10 mr-8\">Additional Charge</span></div>\n<div flex><md-input-container md-no-float class=\"md-accent\" flex=\"60\"><input id=\"additional_charge-focus\" \naria-label=\"today\" placeholder=\"\" maxlength=\"6\" type=\"number\" class=\"ml-8\" ng-keypress=\"onlynumber($event);\" \nname=\"dis\" ng-change=\"dataChange()\" ng-model=\"vm.billing.additional_charge\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.billing.additional_charge | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" \nng-show=\"OpenPermissionreturn\"><div class=\"flex hidebelow600\"></div><div class=\"tag flex md-accent spacer-8 flex-45\" \nlayout=\"row\"><div flex layout=\"row\"><md-icon class=\"cursor-pointer mr-8\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" \nng-click=\"OpenPermissionreturn = !OpenPermissionreturn; clearDis()\" ng-hide=\"params.id\"></md-icon><span \nclass=\"mt-10 mr-8\">Return Bill No</span></div><div flex><md-input-container class=\"md-accent hide\" md-no-float \nflex=\"40\"><md-select ng-model=\"vm.billing.discount_type\" ng-change=\"dataChange()\" \nng-init=\"vm.billing.discount_type=\'amount\'\" aria-label=\"today\" class=\"md-accent\" ng-required=\"show\"><md-option \nvalue=\"amount\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></md-option><md-option \nvalue=\"percent\">%</md-option></md-select></md-input-container><md-input-container md-no-float class=\"md-accent\" \nflex=\"40\"><input placeholder=\"Return Bill no\" ng-keypress=\"onlynumber($event)\" type=\"number\" class=\"ml-8\" name=\"dis\" \nng-model=\"vm.billing.return_bill_no\" ng-disabled=\"params.id\"></md-input-container><md-button \nclass=\"md-accent md-raised ml-8 small_button\" aria-label=\"search bill\" \nng-click=\"vm.fetchreturnOrder($event, vm.billing.return_bill_no)\" ng-disabled=\"params.id\"><md-icon md-menu-origin \nmd-font-icon=\"icon-magnify\"></md-icon></md-button><md-input-container md-no-float class=\"md-accent\" flex=\"30\" \nng-if=\"vm.billing.discount_type==\'amount\'\"><input id=\"discount-focus\" placeholder=\"amount\" \nng-keypress=\"onlynumber($event)\" type=\"number\" class=\"ml-8\" max=\"{{vm.billing.roundtotal + vm.billing.discount}}\" \nname=\"dis\" ng-change=\"dataChange()\" ng-model=\"vm.billing.discount\" disabled=\"disabled\"></md-input-container></div>\n</div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.billing.discount_type==\'amount\') ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2)}}\n</span></div></div><div class=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" \nng-show=\"OpenPermission\"><div class=\"flex hidebelow600\"></div><div class=\"tag flex md-accent spacer-8 flex-45\" \nlayout=\"row\"><div flex layout=\"row\"><md-icon class=\"cursor-pointer mr-8\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" \nng-click=\"OpenPermission = !OpenPermission; clearDis()\"></md-icon><span class=\"mt-10 mr-8\">\n{{\'BILLINGS.DISCOUNT\' | translate}}</span></div><div flex><md-input-container class=\"md-accent\" md-no-float flex=\"40\">\n<md-select ng-model=\"vm.billing.discount_type\" ng-change=\"dataChange()\" ng-init=\"vm.billing.discount_type=\'amount\'\" \naria-label=\"today\" class=\"md-accent\" ng-required=\"show\"><md-option value=\"amount\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></md-option><md-option value=\"percent\">%</md-option></md-select>\n</md-input-container><md-input-container md-no-float class=\"md-accent\" flex=\"60\" \nng-if=\"vm.billing.discount_type==\'amount\'\"><input id=\"discount-focus\" placeholder=\"amount\" \nng-keypress=\"onlynumber($event)\" type=\"number\" class=\"ml-8\" max=\"{{vm.billing.roundtotal + vm.billing.discount}}\" \nname=\"dis\" ng-change=\"dataChange()\" ng-model=\"vm.billing.discount\"></md-input-container><md-input-container \nmd-no-float class=\"md-accent\" flex=\"60\" ng-if=\"vm.billing.discount_type==\'percent\'\"><input id=\"discount-focus\" \nplaceholder=\"percentage\" ng-keypress=\"onlynumber($event)\" type=\"number\" class=\"ml-8\" max=\"100\" name=\"dis\" \nng-change=\"dataChange()\" ng-model=\"vm.billing.discount\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.billing.discount_type==\'amount\') ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2)}}\n</span></div></div><div class=\"layout-row footer total-amount-row\"><div flex class=\"font-size-px-13 ml-8\" layout=\"row\" \nlayout-align=\"center center\"><a ng-click=\"OpenPermissionreturn = !OpenPermissionreturn;focusdicount()\" \nng-show=\"!OpenPermissionreturn\">+ Return Order</a> <a ng-click=\"OpenPermission = !OpenPermission;focusdicount()\" \nclass=\"ml-16\" ng-show=\"!OpenPermission && !OpenPermissionreturn\">+ {{\'BILLINGS.DISCOUNT-NEWBILL\' | translate}}</a> <a \nng-click=\"OpenCharge = !OpenCharge;focusaddCharge()\" class=\"ml-16\" ng-show=\"!OpenCharge\">+ Additional Charge</a></div>\n<div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{ vm.billing.roundtotal }}</span></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/cashier/billing/newbill/customer/customer.info.html","<div id=\"customer-info\"><div ng-if=\"!customer_data\"><div class=\"m-w-530\"><div class=\"layout-column medium\"><a \nng-hide=\"true\" id=\"clearcustomer\" ng-click=\"clearcustomer($event)\">reset</a><div class=\"label font-size-px-13\">\nEnter customer mobile nos</div><md-autocomplete md-input-id=\"radio-focuscustomer\" class=\"md-accent no-label\" \nflex=\"100\" md-input-name=\"autocompleteCustomer\" md-search-text-change=\"searchTextChangge(customer.searchText);\" \nmd-items=\"item in vm.querySearchh(customer.searchText);\" ng-keyup=\"dataopen()\" \nng-keypress=\"onlynumber($event); phonenumber($event); openCustomerDialog($event,customer.searchText ?  customer.searchText : customer);\" \nmd-selected-item=\"customer.customer_mobile\" \nmd-selected-item-change=\"vm.selectedItemChangge(customer);customer_info($event);clearcustomerChangepointdiscount();dataopen()\" \nmd-search-text=\"customer.searchText\" md-min-length=\"0\" md-item-text=\"item.customer_mobile\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" placeholder=\"mobile no\" md-require-match \nmd-autofocus=\"true\" md-autoselect=\"true\" md-placeholder=\"hello\" \nng-required=\"(vm.billing.dietType==\'doordelivery\'&&!vm.billing.thirdparty_id) || (vm.billing.dietType==\'takeaway\' && vm.billing.deliveryTime==\'Schedule\')\">\n<md-item-template><span md-highlight-text=\"customer.searchText\">{{item.customer_mobile}}</span> <span \nclass=\"autocomplete-catergory\">{{item.customer_name}}</span></md-item-template><md-not-found>\nNo found \"{{customer.searchText}}\". <a class=\"customerClick\" \nng-click=\"vm.showAddTableDialog($event,customer.searchText ?  customer.searchText : customer)\">Create a new customer\n</a></md-not-found></md-autocomplete><div class=\"help-text\">(ex: 9840123210)</div></div></div><div layout=\"row\" \nlayout-xs=\"column\" ng-if=\"customer.customer_mobile\" class=\"user-profile\"><ul class=\"user-profile mt-24\" flex=\"60\" \nstyle=\"padding: 0\"><md-button class=\"md-accent\" style=\"float: right\" ng-click=\"vm.showAddTableDialog($event,customer)\">\nEdit</md-button><a ui-sref=\"app.customeranalytics({id:customer.customer_id})\" target=\"_blank\" \nstyle=\"float: right;line-height: 46px; font-size: 14px;font-weight: 500\">VIEW MORE</a><li><div class=\"label\" translate>\nBILLINGS.CUSTOMER-LIST.NAME</div><div class=\"title\">{{customer.customer_name}}</div></li><li \nng-if=\"vm.settings.show_customer_email\"><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.EMAIL</div><div \nclass=\"title\">{{customer.customer_email}}</div></li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.ADDRESS\n</div><div class=\"title\">{{customer.customer_address}}</div></li><li><div class=\"label\" translate>\nBILLINGS.CUSTOMER-LIST.LOCALITY</div><div class=\"title\"><span>{{customer.customer_locality}}</span></div></li><li><div \nclass=\"label\" translate>BILLINGS.CUSTOMER-LIST.CITY</div><div class=\"title\">{{customer.customer_city}}</div></li></ul>\n<div flex=\"40\" class=\"customer-analytics medium-analytics\" \nng-if=\"((customer_data.customer_mobile || customer.customer_mobile))\"><span class=\"help-text\">Last Ordered </span>\n- {{ordertime | date}} ( {{lastvisit}})<div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container ng-scope\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"ng-binding\">{{total_visit}}</span></div><div \nclass=\"label md-truncate ng-binding\">Total Ordered</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span class=\"ng-binding\">\n{{avgtotal | number:2}}</span></div><div class=\"label md-truncate ng-binding\">Avg. Amount per order</div></div></div>\n<div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container ng-scope\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span class=\"ng-binding\">\n{{totaleat}}</span></div><div class=\"label md-truncate ng-binding\">Total Amount</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\" ng-show=\"points[0].enablepoint==1\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"ng-binding\">\n{{customer_data.pointsEarned ? customer_data.pointsEarned : customer.pointsEarned}}</span></div><div \nclass=\"label md-truncate ng-binding\">Points Earned</div></div></div></div></div></div><div ng-if=\"customer_data\"><div \nclass=\"m-w-530\"><div class=\"err_message mb-10\" ng-if=\"!vm.no_edit_bill\">You cannot change the customer in edit bill\n</div><div class=\"layout-column medium\"><md-autocomplete md-input-id=\"radio-focuscustomer\" disabled=\"true\" \nng-class=\"{\'autodd\': $index == indx}\" class=\"md-accent\" flex=\"100\" md-input-name=\"autocompleteCustomer\" \nmd-no-cache=\"vm.noCache\" md-search-text-change=\"searchTextChangge(customer.searchText);dataopen(Openpoint)\" \nng-keypress=\"onlynumber($event); phonenumber($event); openCustomerDialog($event,customer.searchText);\" \nng-keyup=\"dataopen(Openpoint)\" ng-keydown=\"dataopen(Openpoint)\" md-selected-item=\"customer_data.customer_mobile\" \nmd-selected-item-change=\"vm.selectedItemChangge(customer_data);customer_info($event);dataopen(Openpoint)\" \nmd-search-text=\"customer.searchText\" md-items=\"item in vm.querySearchh(customer.searchText)\" \nmd-item-text=\"item.display\" md-floating-label=\"Enter customer mobile no\" md-autoselect=\"true\" md-require-match \nmd-autofocus=\"true\"><md-item-template><span md-highlight-text=\"customer.searchText\">{{item.customer_mobile}}</span> \n<span class=\"autocomplete-catergory\">{{item.customer_name}}</span></md-item-template><md-not-found>\nNo found \"{{customer.searchText}}\". <a class=\"customerClick\" \nng-click=\"vm.showAddTableDialog($event,customer.searchText ?  customer.searchText : customer_data)\">\nCreate a new customer</a></md-not-found></md-autocomplete><div class=\"help-text\">(ex: 9840123210)</div></div></div><div\n layout=\"row\" layout-xs=\"column\" ng-if=\"customer_data.customer_mobile\" class=\"user-profile flex\"><ul \nclass=\"user-profile mt-24\" flex=\"55\"><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.NAME</div><div \nclass=\"title\">{{customer_data.customer_name}}</div></li><li ng-if=\"vm.settings.show_customer_email\"><div class=\"label\" \ntranslate>BILLINGS.CUSTOMER-LIST.EMAIL</div><div class=\"title\">{{customer_data.customer_email}}</div></li><li><div \nclass=\"label\" translate>BILLINGS.CUSTOMER-LIST.ADDRESS</div><div class=\"title\">{{customer_data.customer_address}}</div>\n</li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.LOCALITY</div><div class=\"title\"><span>\n{{customer_data.customer_locality}}</span></div></li><li ng-if=\"vm.settings.show_customer_city\"><div class=\"label\" \ntranslate>BILLINGS.CUSTOMER-LIST.CITY</div><div class=\"title\"><span>{{customer_data.customer_city}}</span></div></li>\n</ul><div flex=\"45\" class=\"customer-analytics medium-analytics\" \nng-if=\"((customer_data.customer_mobile || customer.customer_mobile))\"><span class=\"help-text\">Last Ordered </span>\n- {{ordertime | date}} ( {{lastvisit}})<div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container ng-scope\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span class=\"ng-binding\">{{total_visit}}</span></div><div \nclass=\"label md-truncate ng-binding\">Total Order</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span class=\"ng-binding\">\n{{avgtotal | number:2}}</span></div><div class=\"label md-truncate ng-binding\">Avg. Amount per order</div></div></div>\n<div \nclass=\"layout-column layout-align-start-start layout-gt-sm-row layout-align-gt-sm-space-around-center count-container ng-scope\">\n<div class=\"cash-count-widget layout-column layout-align-center-center\"><div \nclass=\"title layout-row layout-align-center-center\"><span translate>BILLINGS.INR</span> <span class=\"ng-binding\">\n{{totaleat}}</span></div><div class=\"label md-truncate ng-binding\">Total Amount</div></div><div \nclass=\"cash-count-widget layout-column layout-align-center-center\" \nng-show=\"(points[0].enablepoint==1) && existing_customer_id\"><div class=\"title layout-row layout-align-center-center\">\n<span class=\"ng-binding\">{{customer.pointsEarned ? customer.pointsEarned : customer_data.pointsEarned}}</span></div>\n<div class=\"label md-truncate ng-binding\">Points Earned</div></div></div></div></div></div></div>");
$templateCache.put("app/main/cashier/billing/newbill/feedback/feedback.html","<div class=\"viewsales-bill\"><div class=\"feedback mt-24\"><table width=\"85%\"><tr><th width=\"40%\"></th><th width=\"12%\" \nclass=\"text-align-center\">{{feedbackjson.POORLY}}</th><th width=\"12%\" class=\"text-align-center\">{{feedbackjson.BAD}}\n</th><th width=\"12%\" class=\"text-align-center\">{{feedbackjson.OK}}</th><th width=\"12%\" class=\"text-align-center\">\n{{feedbackjson.GOOD}}</th><th width=\"12%\" class=\"text-align-center\">{{feedbackjson.GREAT}}</th></tr><tr><td \nclass=\"text-align-right\"><span class=\"mr-32\" translate=\"\">{{feedbackjson.Service}}</span></td><td colspan=\"5\"><div \nlayout-row><label flex ng-repeat=\"service in feedback_service\" for=\"{{service.name}}\"><input type=\"radio\" \nng-model=\"feedback.feedback_service\" ng-value=\"service\" id=\"{{service.name}}\" name=\"service\" \nng-click=\"serviceActive(feedback.feedback_service);\"><div class=\"{{service.class}}\" \nng-class=\"{active : activeMenu === service || feedback.feedback_service == {{service.no}}}\"></div></label></div></td>\n</tr><tr><td class=\"text-align-right\"><span class=\"mr-32\" translate=\"\">{{feedbackjson.Staff}}</span></td><td \ncolspan=\"5\"><div layout-row><label flex ng-repeat=\"staff in feedback_staff\" for=\"{{staff.name}}\"><input type=\"radio\" \nng-model=\"feedback.feedback_staff\" ng-value=\"staff\" id=\"{{staff.name}}\" name=\"feedback_staff\" \nng-click=\"staffActive(feedback.feedback_staff);\"><div class=\"{{staff.class}}\" \nng-class=\"{active : staffactiveMenu === staff || feedback.feedback_staff == {{staff.no}}}\"></div></label></div></td>\n</tr><tr><td class=\"text-align-right\"><span class=\"mr-32\" translate=\"\">{{feedbackjson.Food}}</span></td><td \ncolspan=\"5\"><div layout-row><label flex ng-repeat=\"food in feedback_food\" for=\"{{food.name}}\"><input type=\"radio\" \nng-model=\"feedback.feedback_food\" ng-value=\"food\" id=\"{{food.name}}\" name=\"food\" \nng-click=\"qualityActive(feedback.feedback_food);\"><div class=\"{{food.class}}\" \nng-class=\"{active : qualityactiveMenu === food || feedback.feedback_food == {{food.no}}}\"></div></label></div></td>\n</tr><tr><td class=\"text-align-right\"><span class=\"mr-32\" translate=\"\">{{feedbackjson.Money}}</span></td><td \ncolspan=\"5\"><div layout-row><label flex ng-repeat=\"quality in feedback_quality\" for=\"{{quality.name}}\"><input \ntype=\"radio\" ng-model=\"feedback.feedback_money\" ng-value=\"quality\" id=\"{{quality.name}}\" name=\"quality\" \nng-click=\"moneyActive(feedback.feedback_money);\"><div class=\"{{quality.class}}\" \nng-class=\"{active : moneyactiveMenu === quality || feedback.feedback_money == {{quality.no}}}\"></div></label></div>\n</td></tr></table></div></div>");
$templateCache.put("app/main/cashier/billing/newbill/payment/payment.html","<div class=\"m-w-584\" style=\"padding-bottom: 36px; !important\"><div \nclass=\"font-size-16 font-weight-500 text-italic mb-16\"><span ng-if=\"params.id\">\n{{\'BILLINGS.ORDERED-NO\' | translate}}. {{params.id}}</span></div><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\" \nng-if=\"hideRate.value==\'exclude\'&&!vm.settings.global_tax\"><div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}}\n</div><div class=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"pr-2\">+ </span><span ng-if=\"!vm.print.mrp\">\n{{fullexcluderate | number:1}}</span> <span ng-if=\"vm.print.mrp\">\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</span></div></div><div \nclass=\"layout-row layout-align-start-center\" ng-if=\"hideRate.value==\'include\'&&!vm.settings.global_tax\"><div \nclass=\"tag flex\">Total Rate</div><div class=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\">\n<span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"pr-2\">+ </span><span \nng-if=\"!vm.print.mrp\">{{fullrate | number:1}}</span> <span ng-if=\"vm.print.mrp\">\n{{vm.billing.subTotal+(fmitem.tax_cgstPerItem+fmitem.tax_sgstPerItem) | number:1}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\" ng-if=\"!vm.settings.global_tax\"><div class=\"tag flex\">Total Tax</div>\n<div class=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"pr-2\">+ </span><span>\n{{ vm.billing.tax_cgstInclude + vm.billing.tax_sgstInclude | number:1}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"pr-2\">- </span><span>\n{{(vm.billing.discount_type==\'amount\') ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2)}}\n</span></div></div><div class=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">Additional Charge</div>\n<div class=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span><span class=\"pr-2\"> + </span><span>\n{{vm.billing.additional_charge | number:2}}</span></div></div><div class=\"layout-row footer mt-4\"><div \nclass=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.billing.roundtotal }}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div><div class=\"mt-24 new-paid-container\"><div \nclass=\"layout-row mt-8 font-size-px-13\"><div class=\"flex\" style=\"text-transform: uppercase\">\n{{\'BILLINGS.PAYMENT\' | translate}} Details</div><div class=\"layout-column layout-align-end-center\" \nng-if=\"vm.settings.show_fullyPaid_dropdown\"><md-input-container class=\"md-block\" style=\"margin-top:-10px\"><md-select \nng-model=\"vm.payment.payment_status\" aria-label=\"today\" ng-change=\"disble_paymentmode()\" class=\"md-accent\" \nng-required=\"vm.payment.payment_mode\"><md-option ng-repeat=\"payment in vm.paymentTypes\" value=\"{{payment.value}}\">\n{{payment.name}}</md-option></md-select></md-input-container></div></div><div class=\"mb-8 mt-8 layout-column\"><div \nng-show=\"vm.payment.payment_status==\'unpaid\'\" class=\"layout-column mt-16\"><md-input-container \nclass=\"md-block md-accent\" flex=\"65\"><label>{{\'BILLINGS.REASON\' | translate}}</label><md-select \nng-model=\"vm.payment.unpaid_reason \" name=\"unpaidreason\" class=\"md-accent\" \nng-required=\"vm.payment.payment_status==\'unpaid\'\"><md-option value=\"complementary\">Complementary</md-option><md-option \nvalue=\"miscellaneous\">Miscellaneous</md-option><md-option value=\"guest\">InHouse Guest</md-option><md-option \nvalue=\"other\">Others</md-option></md-select></md-input-container></div><div style=\"display: none\"><md-radio-group \nclass=\"layout-row margin-bottom-16 margin-top-10\" id=\"radio-focuspay\" ng-init=\"vm.paymentstatus=\'paid\'\" \nng-model=\"vm.paymentstatus\"><md-radio-button ng-repeat=\"mode in vm.paymentstate\" value=\"{{mode.value}}\" \nclass=\"md-accent\">{{mode.name}}</md-radio-button></md-radio-group></div><div \nng-hide=\"vm.payment.payment_status==\'unpaid\'\" class=\"border-top border-bottom p-8 pt-16 pb-16 mb-8\"><md-radio-group \nclass=\"layout-row\" ng-model=\"vm.payment.payment_mode\" ng-click=\"disble_unpaid_data()\" ng-hide=\"OpenPermission1\" \nng-required=\"vm.payment.payment_status==\'advance\'\" ng-change=\"changedata()\"><md-radio-button \nng-repeat=\"mode in vm.paymentmodelist\" value=\"{{mode.value}}\" class=\"md-accent\" ng-click=\"clear_card()\">{{mode.name}}\n</md-radio-button></md-radio-group></div><div class=\"layout-row layout-align-start-start mt-8\" \nng-if=\"vm.payment.payment_mode==\'cash & card\'\"><div flex=\"50\" class=\"mr-10\"><md-input-container \nclass=\"md-block mr-8 md-accent\"><label>Received <span translate>BILLINGS.CASH</span></label><input type=\"number\" \nname=\"receive\" ng-model=\"vm.payment.payment_received\" max=\"{{ vm.billing.roundtotal }}\" \nng-required=\"vm.payment.payment_mode==\'cash & card\'\"><div ng-messages=\"newBill.receive.$error\" role=\"alert\" \nng-if=\"newBill.receive.$dirty\"><div ng-message=\"max\">Enter lesser than total</div></div></md-input-container></div><div\n flex=\"50\" layout=\"column\" class=\"font-size-px-13 layout-align-start-start transfer-cash\" \nng-if=\"vm.payment.payment_transferred\"><div>Transfer <span translate>BILLINGS.CASH</span></div><div><span translate \nclass=\"pr-2\">BILLINGS.INR</span> {{ vm.payment.payment_transferred }}</div></div></div><div layout=\"row\" \nng-if=\"(vm.payment.payment_mode==\'cash\' || vm.payment.payment_mode==\'card\')&&vm.payment.payment_status!=\'paid\'\"><div \nflex=\"50\" class=\"mr-10\"><md-input-container class=\"md-block md-accent mt-8\"><label>Received <span translate>\nBILLINGS.CASH</span></label><input type=\"number\" name=\"receive\" ng-model=\"vm.payment.payment_received\" \nmax=\"{{ vm.billing.roundtotal }}\" ng-required=\"vm.payment.payment_status==\'advance\'\"></md-input-container></div><div \nflex=\"50\" layout=\"column\" class=\"font-size-px-13 layout-align-start-start transfer-cash\" \nng-if=\"vm.payment.payment_transferred\"><div>Balance <span translate>BILLINGS.CASH</span></div><div><span translate \nclass=\"pr-2\">BILLINGS.INR</span> {{ vm.payment.payment_transferred }}</div></div></div><div layout=\"row\">\n<md-input-container ng-if=\"vm.payment.payment_mode==\'card\' || vm.payment.payment_mode==\'cash & card\'\" \nclass=\"md-block md-accent\"><md-select placeholder=\" Select Type\" ng-model=\"vm.payment.online_type\" \nng-required=\"vm.payment.payment_mode==\'card\' || vm.payment.payment_mode==\'cash & card\'\"><md-option \nng-repeat=\"payment in vm.onlineTypes\" value=\"{{payment.values}}\">{{payment.names}}</md-option></md-select>\n</md-input-container></div></div></div></div>");
$templateCache.put("app/main/cashier/billing/returnbills/view-returnbill/view-returnbill.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>hello {{returnBill}}</div>");
$templateCache.put("app/main/cashier/dealer/add-dealer_order/dealer-order-info/add_dealer.html","<div class=\"newbill w-100p layout-fill min-height-100 small no-error\" layout=\"row\" style=\"position: relative\"><div \nclass=\"m-w-720\" style=\"width:720px\"><div id=\"bod\" class=\"m-w-720\"><div id=\"head\" class=\"m-w-640\"><div id=\"head\" \nclass=\"mb-24\"><div layout=\"row\" class=\"medium\"><div flex-none class=\"form-label w-100 mt-12\">Dealer Name</div>\n<md-autocomplete class=\"md-accent no-label ml-8\" md-input-name=\"autocompleteVendor\" flex=\"60\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"vm.purchase.vendor_name\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-min-length=\"0\" md-autoselect=\"true\" \nmd-require-match required><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.vendor_name}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You <b>must</b> enter a <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">Please select an existing <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><md-button class=\"md-accent md-icon-button ml-4\" \nng-click=\"vm.showAddTableDialog($event)\" flex-none title=\"Add New Vendor\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16\" class=\"mr-8\"></md-icon></md-button></div><div layout=\"row\" class=\"mt-8\"><div \nflex-none class=\"form-label mt-8 w-100\">{{\'BILLINGS.STATUS\' | translate}}</div><div flex=\"60\" layout=\"row\">\n<md-input-container class=\"md-accent\" flex><md-select ng-model=\"vm.purchase.status\" ng-disabled=\"disable_state\" \nng-change=\"changestatus()\" name=\"status\" placeholder=\"Select\" class=\"md-accent\" ng-required=\"true\"><md-option \nng-repeat=\"mode in  vm.orderstatus\" value=\"{{mode.status}}\" selected=\"vm.purchase.selectOrdered\">{{mode.value}}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nclass=\"hide-date-picker-icon spacer-8 mt-16\" ng-if=\"vm.purchase.status==\'delivered\'\"><span flex-none \nclass=\"form-label mt-8 w-100\">Delivery {{\'ODC.Date\' | translate}}</span><div flex layout=\"row\"><md-input-container \nclass=\"md-block md-accent\" ng-if=\"vm.purchase.status\" flex-none><md-datepicker name=\"eventDate\" \nng-model=\"vm.purchase.DeliveryDate\" class=\"md-accent\" md-placeholder=\"{{placeholderstatus}}\"></md-datepicker>\n</md-input-container></div></div></div></div><div id=\"purchasesalematerial\" style=\"display: none\">\n{{\'Inventory.PURCHASED-NO\' | translate}}-{{purchase_order_id}}<br>Export Time-{{ReportTime | date:\'medium\'}}<br>\n{{\'Inventory.DeliveryDate\' | translate}}-{{vm.purchase.DeliveryDate | date}}<br>\n{{\'BILLINGS.Sub Total\' | translate}}-{{vm.exitems.subtotal | number:2}}<br>\nApproximate Total-{{vm.exitems.total_amount | number:2}}<br><table><tr><th>{{\'BILLINGS.ITEMS\' | translate}}</th><th>\n{{\'BILLINGS.QTY\' | translate}}</th><th>containQty</th><th>{{\'BILLINGS.RATE\' | translate}}</th><th>\n{{\'BILLINGS.Sub Total\' | translate}}</th></tr><tr ng-repeat=\"rmPurchasedOrder in vm.exitems\"><td>\n{{ rmPurchasedOrder.smname.smname ? rmPurchasedOrder.smname.smname : rmPurchasedOrder.smname }}</td><td>\n{{rmPurchasedOrder.quantity}}</td><td>{{ rmPurchasedOrder.containQty }}</td><td>\n{{rmPurchasedOrder.smrate.smrate ? rmPurchasedOrder.smrate.smrate : rmPurchasedOrder.smrate }}</td><td>\n{{rmPurchasedOrder.item_subtotal}}</td></tr></table></div><div id=\"editor\"></div><div id=\"content1\" \nclass=\"border-right border-left bill-info-food-list-wrapper\"><table class=\"dataTable\"><thead><tr><th \nclass=\"secondary-text\" width=\"45%\"><div class=\"table-header layout-row\"><span class=\"ml-8\" flex>\n{{\'BILLINGS.ITEMS\' | translate}}</span> <a href=\"#\" ng-click=\"vm.showAddTableDialogs($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16 md-accent\" class=\"mr-16\" title=\"Add New {{\'BILLINGS.ITEM\' | translate}}\"></md-icon>\n</a></div></th><th class=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"17%\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"15%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"8%\"></th></tr></thead><tbody><tr><td colspan=\"5\" height=\"12\"></td></tr><tr \nng-repeat=\"fmitem in vm.exitems\"><td width=\"45%\" class=\"foodItem-auto\" \nng-if=\"vm.branchFilterData[0].barcode_enable == 1\"><div layout=\"row\"><md-autocomplete \nng-class=\"{\'autodd\': $index == indx}\" md-input-name=\"autocompleteFood\" md-input-name=\"autocompleteFood\" \nclass=\"md-accent no-label ml-8\" flex=\"100\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.smname\" \nmd-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" ng-keypress=\"barcodekeyPressed($event)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearchrm(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-autofocus=\"true\" md-autoselect=\"true\" \nmd-require-match required><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.smname}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You <b>must</b> enter a <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">Please select an existing <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><span ng-if=\"fmitem.containQty\" flex-none \nclass=\"piece-contain\">{{fmitem.containQty}} item contain</span></div></td><td width=\"45%\" class=\"foodItem-auto\" \nng-if=\"vm.branchFilterData[0].barcode_enable != 1\"><div layout=\"row\"><md-autocomplete \nng-class=\"{\'autodd\': $index == indx}\" md-input-name=\"autocompleteFood\" md-input-name=\"autocompleteFood\" \nclass=\"md-accent no-label ml-8\" flex=\"100\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.smname\" \nmd-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" ng-keypress=\"keyPressed($event)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearchrm(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-autofocus=\"true\" md-autoselect=\"true\" \nmd-min-length=\"0\" md-require-match required><md-item-template class=\"md-accent\"><span \nmd-highlight-text=\"fmitem.searchText\">{{item.smname}}</span></md-item-template><div \nng-messages=\"newBill.autocompleteFood.$error\" ng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You \n<b>must</b> enter a <span translate>RESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">\nPlease select an existing <span translate>RESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><span \nng-if=\"fmitem.containQty\" flex-none class=\"piece-contain\">{{fmitem.containQty}} item contain</span></div></td><td \nwidth=\"15%\"><md-input-container md-no-float class=\"md-accent md-block\" flex=\"90\"><input \nplaceholder=\"{{ \'RESTRAUNTANT.QUANTITY\' | translate }}\" type=\"text\" maxlength=\"4\" class=\"qty\" \nng-keypress=\"keyPressed($event)\" valid-number name=\"quantity\" ng-model=\"fmitem.quantity\" required><div \nng-messages=\"addfoodForm.quantity.$error\"><div ng-message=\"required\"><span>Please enter the <span translate>\nRESTRAUNTANT.QUANTITY</span></span></div></div></md-input-container></td><td width=\"17%\"><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"90\"><input type=\"text\" name=\"rate\" maxlength=\"8\" valid-number \nng-keypress=\"keyPressed($event)\" aria-label=\"email\" ng-model=\"fmitem.smrate\" required><div \nng-messages=\"addfoodForm.quantity.$error\"><div ng-message=\"required\"><span>Please enter the <span translate>\nRESTRAUNTANT.RATE</span></span></div></div></md-input-container></td><td class=\"text-black-70\" width=\"15%\"><span \ntranslate class=\"grey-col-sec-text pr-2\" ng-if=\"subtotalss\" ng-model=\"$parent.subtotals\">BILLINGS.INR</span>\n {{fmitem.quantity * fmitem.smrate}}</td><td width=\"8%\"><md-button ng-if=\"formitem == \'\'\" \nclass=\"md-icon-button margin-0-force small-button\" aria-label=\"Delete\" ng-click=\"removeRow(fmitem,$event,$index)\">\n<md-icon class=\"text-black-40\" md-font-icon=\"icon icon-trash\"></md-icon></md-button></td></tr><tr><td colspan=\"5\" \nheight=\"24\"></td></tr></tbody></table></div><div id=\"foot\"><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div flex class=\"font-size-px-13 ml-8\"><a ng-click=\"OpenTax = !OpenTax;focustax()\" ng-show=\"!OpenTax\" \nng-model=\"defaultopen\">Add {{\'BILLINGS.TAX\' | translate}}</a>&nbsp;&nbsp; <a \nng-click=\"OpenPermission = !OpenPermission;focusdiscount()\" ng-show=\"!OpenPermission\" class=\"ml-16\">\nAdd {{\'BILLINGS.DISCOUNT\' | translate}}</a></div><div class=\"tag flex-20\">{{\'BILLINGS.Sub Total\' | translate}}</div>\n<div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center spacer-8\" ng-show=\"OpenTax\" ng-show=\"OpenPermission\"><div class=\"flex\">\n</div><div class=\"tag flex md-accent spacer-8 flex-80\" layout=\"row\"><div flex=\"50\" layout=\"row\" class=\"mr-8\"><div flex>\n<md-icon class=\"cursor-pointer\" md-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4 mt-8\" title=\"Remove Tax\" \nng-hide=\"hideclose\" ng-click=\"OpenTax = !OpenTax; clrTax()\"></md-icon></div><div flex=\"35\"><md-input-container \nclass=\"md-accent\"><md-select ng-model=\"vm.exitems.tax_status\" \nng-init=\"!params.id ? vm.exitems.tax_status=\'exclude\' : \'\'\" ng-change=\"dataChange()\" name=\"status\" \nplaceholder=\"Select\" class=\"md-accent\" ng-required=\"true\"><md-option ng-repeat=\"mode in  vm.purchaseTax_status\" \nvalue=\"{{mode.value}}\">{{mode.label}}</md-option></md-select></md-input-container></div><div flex=\"35\">\n<md-input-container class=\"md-accent\" md-no-float><md-select ng-model=\"vm.exitems.tax_type\" aria-label=\"email\" \nng-init=\"!params.id ? vm.exitems.tax_type=\'percent\' : \'\'\" ng-change=\"dataChange()\" class=\"md-accent\" \nng-required=\"show\"><md-option value=\"amount\"><span translate>BILLINGS.INR</span></md-option><md-option value=\"percent\">\n%</md-option></md-select></md-input-container></div></div><div flex=\"25\" layout=\"row\"><span class=\"mt-12 mr-8\">\n{{\'BILLINGS.CGST\' | translate}}(%)</span><md-input-container md-no-float class=\"md-accent\"><input placeholder=\"\" \nid=\"tax-focus\" aria-label=\"email\" maxlength=\"{{vm.exitems.tax_type==\'percent\' ? \'2\' : \'\'}}\" valid-number type=\"text\" \nname=\"quantitys\" ng-change=\"dataChange()\" ng-model=\"vm.exitems.tax_cgst\"></md-input-container></div><div flex=\"25\" \nlayout=\"row\"><span class=\"mt-12 mr-8\">{{\'BILLINGS.SGST\' | translate}}(%)</span><md-input-container md-no-float \nclass=\"md-accent\"><input placeholder=\"\" aria-label=\"email\" id=\"taxSgst-focus\" \nmaxlength=\"{{vm.exitems.tax_type==\'percent\' ? \'2\' : \'\'}}\" valid-number type=\"text\" name=\"quantitys\" \nng-change=\"dataChange()\" ng-model=\"vm.exitems.tax_sgst\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.taxamount | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center spacer-8\" ng-show=\"OpenPermission\"><div class=\"flex\"></div><div \nclass=\"tag flex md-accent spacer-8 flex-40\" layout=\"row\"><div flex layout=\"row\"><md-icon class=\"cursor-pointer\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4\" title=\"Remove\" ng-hide=\"hideclose\" \nng-click=\"OpenPermission = !OpenPermission; clearDis()\"></md-icon><span class=\"mt-12 mr-8\">\n{{\'BILLINGS.DISCOUNT\' | translate}}</span></div><div class=\"mr-8\" flex><md-input-container md-no-float \nclass=\"md-accent\"><input id=\"discount-focus\" max=\"{{vm.exitems.total_amount + vm.exitems.discount}}\" \nng-keypress=\"onlynumber($event);\" aria-label=\"email\" placeholder=\"\" type=\"number\" name=\"quantitys\" \nng-change=\"dataChange()\" ng-model=\"vm.exitems.discount\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div></div></div></div>");
$templateCache.put("app/main/cashier/dealer/add-dealer_order/sale-material-payment/payment.html","<div class=\"m-w-584\"><div class=\"font-size-16 font-weight-500 text-italic mb-16\"><span ng-if=\"params.id\">\n{{\'BILLINGS.ORDERED-NO\' | translate}}. {{params.id}}</span></div><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.CGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_cgstValue ? vm.exitems.tax_cgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.SGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_sgstValue ? vm.exitems.tax_sgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div><div class=\"m-w-584 mt-32\"><span \nclass=\"secondary-text\">Select the <span translate>BILLINGS.PAYMENT</span> Details *</span><div \nclass=\"border-top border-bottom p-8 mb-16 mt-8\"><md-radio-group class=\"layout-row margin-bottom-8 margin-top-4\" \nng-click=\"clear_advancePaid()\" ng-model=\"vm.expayment.payment_status\" name=\"payment_details\" required><md-radio-button \nng-repeat=\"mode in vm.payment\" value=\"{{mode.value}}\" class=\"md-accent\">{{mode.name}}</md-radio-button>\n</md-radio-group></div><div flex-none layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nclass=\"mt-8 hide-date-picker-icon\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Date</div><md-input-container class=\"md-block md-accent\" flex=\"50\">\n<md-datepicker ng-model=\"vm.expayment.paid_date\" name=\"paid_date\" md-min-date=\"minDates\" md-max-date=\"maxDates\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" required></md-datepicker></md-input-container>\n</div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex><md-select \nng-model=\"vm.expayment.payment_type\" name=\"amountType\" placeholder=\"Select\" class=\"md-accent\" required><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'advance paid\'\" \nng-click=\"clear_fullyPaid()\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Amount <span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></div><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"50\"><input placeholder=\"Received {{\'BILLINGS.AMOUNT\' | translate}} (₹)\" type=\"text\" name=\"received_amount\" \nng-model=\"vm.expayment.received_amount\" required></md-input-container><span class=\"balance-color mt-8\" \nng-if=\"vm.expayment.received_amount\">Bal (₹) {{ vm.exitems.total_amount - vm.expayment.received_amount}}</span></div>\n<div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'advance paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex \nng-click=\"clear_payment()\"><md-select ng-model=\"vm.expayment.payment_type\" placeholder=\"Select\" name=\"amountType\" \nclass=\"md-accent\" required><md-option ng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">\n{{expayment.label}}</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'fully paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'advance paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.TRANSCATION\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.TRANSCATION\' | translate}}\" \ntype=\"text\" name=\"transcation_no\" ng-model=\"vm.expayment.transcation_no\"></md-input-container></div><div layout=\"row\" \nclass=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.CHEQUE-NO\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.CHEQUE-NO\' | translate}}\" type=\"text\" \nname=\"cheque_no\" ng-model=\"vm.expayment.cheque_no\"></md-input-container></div><div layout=\"row\" class=\"mt-16 flex\" \nng-if=\"vm.expayment.payment_status == \'unpaid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Notes</div>\n<md-input-container class=\"md-block md-accent\" md-no-float><label>Enter the notes</label><textarea \nng-model=\"vm.expayment.note\" rows=\"1\"></textarea></md-input-container></div></div></div>");
$templateCache.put("app/main/cashier/expense/balance-expense/purchase_expense/purchase_expense.html","<div class=\"layout-column layout-align-center-center min-height-100 text-center no-data\" \nng-if=\"vm.purchaseexpense.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 \nclass=\"text-center md-display-1\">Hi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no {{\'Inventory.PURCHASE-ORDER\' | translate}} bills for you to see.</h3></div><div \nclass=\"min-height-100 layout-column scrollable\" ng-if=\"vm.purchaseexpense.length>0 || retrieve\"><div layout=\"row\" \nlayout-align=\"center start\" flex class=\"mb-16\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseexpense_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseexpense_query.filter\" \nng-click=\"clearTexts()\"></md-icon></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head md-order=\"purchaseexpense_query.order\" \nmd-on-reorder=\"getDessertss\"><tr md-row><th md-column width=\"12%\">{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column \nwidth=\"10%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column width=\"16%\">{{\'EXPENSE.Balance\' | translate}}</th><th \nmd-column ng-if=\"permission!=admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">\n{{\'EXPENSE.VENDOR/PERSON\' | translate}}</th><th md-column width=\"16%\">{{\'EXPENSE.DUE-DATE\' | translate}}</th><th \nmd-column width=\"14%\"><span>{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.purchaseexpense | limitTo: purchaseexpense_query.limit | filter: purchaseexpense_query.filter | orderBy: purchaseexpense_query.order\">\n<td md-cell>{{ balExpBill.purchase_expense_id }}</td><td md-cell><div class=\"layout-row layout-align-start-center\">\n<span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ balExpBill.total_amount }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\"><span translate \nclass=\"warm-color\">BILLINGS.INR</span> <span class=\"font-size-px-18 warm-color\">\n{{ balExpBill.total_amount - balExpBill.received_amount }}</span> <span class=\"flex-none adv-amount\" \nng-if=\"balExpBill.received_amount > \'0\'\">adv {{ balExpBill.received_amount }}</span></td><td md-cell \nng-if=\"permission!=admin\">{{ balexpense_staffnames(balExpBill) }}</td><td md-cell \ntitle=\"{{paidbill.deliveredFullTime}}\">{{ balExpBill.vendor_name }}</td><td md-cell>{{ balExpBill.due_date | date }} \n<span class=\"text-boxed badge food-badge\" \nng-class=\"{ \'low\': \'remaining-low\', \'med\': \'remaining-med\', \'high\': \'remaining-high\', \'null\': \'display-none\' }[balExpBill.status]\">\n{{ balExpBill.remaining }}</span></td><td><md-menu><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"purchaseexpense(balExpBill.purchase_expense_id)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\">\n</md-icon>View & Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=\"null\"><md-icon md-menu-origin \nmd-font-icon=\"icon-printer\"></md-icon><span translate>GENERAL.PRINT</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"purchaseexpense_query.limit\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"purchaseexpense_query.page\" md-total=\"{{purchaseexpense_count}}\" \nmd-on-paginate=\"getDessertsss\" md-page-select></md-table-pagination></div><md-content style=\"display: none\" \nclass=\"md-padding layout-fill scrollable\" ng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" \nng-controller=\"printbillController as vm\" ms-scroll></md-content>");
$templateCache.put("app/main/cashier/expense/balance-expense/sales_expense/sales_expense.html","<div class=\"layout-column layout-align-center-center min-height-100 text-center no-data\" \nng-if=\"vm.salesexpense.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 \nclass=\"text-center md-display-1\">Hi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no {{\'Inventory.SALES-ORDER\' | translate}} bills for you to see.</h3></div><div \nclass=\"min-height-100 layout-column scrollable\" ng-if=\"vm.salesexpense.length>0 || retrieve\"><div layout=\"row\" \nlayout-align=\"center start\" flex class=\"mb-16\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"paidexpense_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"paidexpense_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head md-order=\"paidexpense_query.order\" \nmd-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"12%\">{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column \nwidth=\"10%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column width=\"16%\">{{\'EXPENSE.Balance\' | translate}}</th><th \nmd-column ng-if=\"permission!=admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">\n{{\'EXPENSE.VENDOR/PERSON\' | translate}}</th><th md-column width=\"16%\">{{\'EXPENSE.DUE-DATE\' | translate}}</th><th \nmd-column width=\"14%\"><span>{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.salesexpense | limitTo: paidexpense_query.limit | filter: paidexpense_query.filter | orderBy: paidexpense_query.order\">\n<td md-cell>{{ balExpBill.sales_expense_id }}</td><td md-cell><div class=\"layout-row layout-align-start-center\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ balExpBill.total_amount }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\"><span translate \nclass=\"warm-color\">BILLINGS.INR</span> <span class=\"font-size-px-18 warm-color\">\n{{ balExpBill.total_amount - balExpBill.received_amount }}</span> <span class=\"flex-none adv-amount\" \nng-if=\"balExpBill.received_amount > \'0\'\">adv {{ balExpBill.received_amount }}</span></td><td md-cell \nng-if=\"permission!=admin\">{{ balexpense_staffnames(balExpBill) }}</td><td md-cell \ntitle=\"{{paidbill.deliveredFullTime}}\">{{ balExpBill.vendor_name }}</td><td md-cell>{{ balExpBill.due_date | date }} \n<span class=\"text-boxed badge food-badge\" \nng-class=\"{ \'low\': \'remaining-low\', \'med\': \'remaining-med\', \'high\': \'remaining-high\', \'null\': \'display-none\' }[balExpBill.status]\">\n{{ balExpBill.remaining }}</span></td><td><md-menu><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"saleexpense(balExpBill.sales_expense_id)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\"></md-icon>\nView & Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=\"null\"><md-icon md-menu-origin \nmd-font-icon=\"icon-printer\"></md-icon><span translate>GENERAL.PRINT</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"paidexpense_query.limit\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"paidexpense_query.page\" md-total=\"{{salesexpense_count}}\" \nmd-on-paginate=\"getDessertsss\" md-page-select></md-table-pagination></div><md-content style=\"display: none\" \nclass=\"md-padding layout-fill scrollable\" ng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" \nng-controller=\"printbillController as vm\" ms-scroll></md-content>");
$templateCache.put("app/main/cashier/expense/new-expense/expense-info/expense-info.html","<div class=\"newbill w-100p layout-fill min-height-100 small no-error\" layout=\"row\" style=\"position: relative\"><div \nclass=\"m-w-640\" style=\"width: 640px\"><div id=\"bod\" class=\"m-w-640\"><div id=\"head\" class=\"pb-24\"><div layout=\"row\" \nclass=\"margin-bottom-16\"><div flex-none class=\"form-label mt-8 w-100\">{{\'ODC.Category\' | translate}}</div>\n<md-input-container class=\"md-accent md-block\" flex=\"50\"><md-select ng-model=\"vm.expense.exCatergoryID\" \nname=\"category\" placeholder=\"Select\" class=\"md-accent\" required><md-option ng-repeat=\"mode in vm.expensecategory\" \nvalue=\"{{mode.exCatergoryID}}\">{{mode.exCatergoryName}}</md-option></md-select></md-input-container><md-button \nclass=\"md-accent md-icon-button ml-4\" flex-none title=\"Add New Catergory\" style=\"display: none\"><md-icon \nmd-menu-origin md-font-icon=\"icon-plus-circle s16\" class=\"mr-8\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"small hide-date-picker-icon spacer-8\" ng-if=\"vm.settings.exp_duedate\"><span flex-none \nclass=\"form-label mt-8 w-100\">Due {{\'ODC.Date\' | translate}} (₹)</span><md-input-container class=\"md-block md-accent\" \nflex=\"50\"><md-datepicker ng-model=\"vm.expense.created_on\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\"></md-datepicker></md-input-container></div><div \nlayout=\"row\" class=\"margin-bottom-16 mt-4\" ng-if=\"vm.settings.exp_vendor\"><div flex-none class=\"form-label mt-8 w-100\">\n{{\'EXPENSE.vendor\' | translate}}</div><md-autocomplete class=\"md-accent no-label\" flex=\"50\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"vm.expense.vendor_name\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-min-length=\"0\" md-require-match \nmd-autoselect=\"true\"><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.vendor_name}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You <b>must</b> enter a <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">Please select an existing <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><md-button class=\"md-accent md-icon-button ml-4\" \nng-click=\"vm.showAddTableDialogs($event)\" flex-none title=\"Add New Vendor\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16\" class=\"mr-8\"></md-icon></md-button></div></div><div id=\"content1\" \nclass=\"border-right border-left bill-info-food-list-wrapper\"><table class=\"dataTable\"><thead><tr><th \nclass=\"secondary-text\" width=\"68%\"><div class=\"table-header\"><span class=\"column-title ml-8\">\n{{\'BILLINGS.Description\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"27%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.AMOUNT\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"5%\"></th></tr></thead><tbody><tr><td colspan=\"3\" height=\"12\"></td></tr><tr \nng-repeat=\"expenseitem in vm.exitems\"><td width=\"68%\"><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"100\"><input type=\"text\" ng-class=\"{\'autodd\': $index==indx}\" name=\"item_name\" ng-keypress=\"keyPressed($event)\" \naria-label=\"email\" ng-model=\"expenseitem.item_name\" required><div ng-messages=\"newexpense.quantity.$error\"><div \nng-message=\"required\"><span>Please enter the <span translate>RESTRAUNTANT.QUANTITY</span></span></div></div>\n</md-input-container></td><td width=\"27%\"><div layout=\"row\"><span flex-none class=\"mt-8 secondary-text\">₹</span>\n<md-input-container md-no-float class=\"md-accent md-block\" flex=\"80\"><input type=\"text\" id=\"ds\" aria-label=\"email\" \nname=\"item_amount\" ng-keypress=\"keyPressed($event)\" valid-number maxlength=\"8\" ng-model=\"expenseitem.item_amount\" \nrequired><div ng-messages=\"addfoodForm.quantity.$error\"><div ng-message=\"required\"><span>Please enter the <span \ntranslate>RESTRAUNTANT.QUANTITY</span></span></div></div></md-input-container></div></td><td width=\"5%\"><md-button \nng-if=\"formitem == \'\'\" class=\"md-icon-button margin-0-force small-button\" aria-label=\"Delete\" \nng-click=\"removeRow(expenseitem,$event,$index)\"><md-icon class=\"text-black-40\" md-font-icon=\"icon icon-trash\">\n</md-icon></md-button></td></tr><tr><td colspan=\"3\" height=\"24\"></td></tr></tbody></table></div><div id=\"foot\"><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div flex class=\"font-size-px-13 ml-8\"><a ng-click=\"OpenTax = !OpenTax;focustax()\" ng-show=\"!OpenTax\" \nng-model=\"defaultopen\">Add {{\'EXPENSE.TAX\' | translate}}</a> <a \nng-click=\"OpenPermission = !OpenPermission;focusdiscount()\" ng-show=\"!OpenPermission\" class=\"ml-16\">\nAdd {{\'BILLINGS.DISCOUNT\' | translate}}</a></div><div class=\"tag flex-20\">{{\'BILLINGS.Sub Total\' | translate}}</div>\n<div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center spacer-8\" ng-show=\"OpenTax\" ng-show=\"OpenPermission\"><div class=\"flex\">\n</div><div class=\"tag flex md-accent spacer-8 flex-80 taxcontainer\" layout=\"row\"><div flex=\"50\" layout=\"row\" \nclass=\"mr-8\"><div flex><md-icon class=\"cursor-pointer\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4 mt-8\" title=\"Remove\" ng-hide=\"hideclose\" \nng-click=\"OpenTax = !OpenTax; clrTax()\"></md-icon></div><div flex=\"35\" class=\"hidebelow600\"><md-input-container \nclass=\"md-accent\"><md-select ng-model=\"vm.exitems.tax_status\" \nng-init=\"!params.id ? vm.exitems.tax_status=\'exclude\' : \'\'\" ng-change=\"dataChange()\" name=\"status\" \nplaceholder=\"Select\" class=\"md-accent\" ng-required=\"true\"><md-option ng-repeat=\"mode in  vm.purchaseTax_status\" \nvalue=\"{{mode.value}}\">{{mode.label}}</md-option></md-select></md-input-container></div><div flex=\"35\" \nclass=\"hidebelow600\"><md-input-container class=\"md-accent\" md-no-float><md-select ng-model=\"vm.exitems.tax_type\" \naria-label=\"email\" ng-init=\"!params.id ? vm.exitems.tax_type=\'amount\' : \'\'\" ng-change=\"dataChange()\" class=\"md-accent\" \nng-required=\"show\"><md-option value=\"amount\"><span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span>\n</md-option><md-option value=\"percent\">%</md-option></md-select></md-input-container></div></div><div flex=\"25\" \nlayout=\"row\"><span class=\"mt-12 mr-8 hidebelow600\">{{\'BILLINGS.CGST\' | translate}}(%)</span><md-input-container \nmd-no-float class=\"md-accent\"><input placeholder=\"{{\'BILLINGS.CGST\' | translate}}(%)\" id=\"tax-focus\" \naria-label=\"email\" maxlength=\"2\" valid-number type=\"text\" name=\"quantitys\" ng-change=\"dataChange()\" \nng-model=\"vm.exitems.tax_cgst\"></md-input-container></div><div flex=\"25\" layout=\"row\"><span \nclass=\"mt-12 mr-8 hidebelow600\">{{\'BILLINGS.SGST\' | translate}}(%)</span><md-input-container md-no-float \nclass=\"md-accent\"><input placeholder=\"{{\'BILLINGS.SGST\' | translate}}(%)\" id=\"taxSgst-focus\" aria-label=\"email\" \nmaxlength=\"2\" valid-number type=\"text\" name=\"quantitys\" ng-change=\"dataChange()\" ng-model=\"vm.exitems.tax_sgst\">\n</md-input-container></div></div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\">\n<span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.taxamount | number:2}}</span>\n</div></div><div class=\"layout-row layout-align-start-center spacer-8 discount-container\" ng-show=\"OpenPermission\"><div\n class=\"flex\"></div><div class=\"tag flex md-accent spacer-8 flex-40\" layout=\"row\"><div flex layout=\"row\"><md-icon \nclass=\"cursor-pointer\" md-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4\" title=\"Remove\" ng-hide=\"hideclose\" \nng-click=\"OpenPermission = !OpenPermission; clearDis()\"></md-icon><span class=\"mt-10 mr-8\">\n{{\'BILLINGS.DISCOUNT\' | translate}}</span></div><div class=\"mr-8\" flex><md-input-container md-no-float \nclass=\"md-accent\"><input id=\"discount-focus\" placeholder=\"\" max=\"{{vm.exitems.total_amount + vm.exitems.discount}}\" \ntype=\"number\" aria-label=\"email\" name=\"quantity\" ng-change=\"dataChange()\" ng-model=\"vm.exitems.discount\">\n</md-input-container></div></div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\">\n<span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount ==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div></div></div></div>");
$templateCache.put("app/main/cashier/expense/new-expense/payment/payment.html","<div class=\"m-w-584\"><div class=\"font-size-16 font-weight-500 text-italic mb-16\"><span ng-if=\"params.id\">\n{{\'BILLINGS.ORDERED-NO\' | translate}}. {{params.id}}</span></div><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.CGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_cgstValue ? vm.exitems.tax_cgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.SGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_sgstValue ? vm.exitems.tax_sgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div><div class=\"m-w-584 mt-32\"><span \nclass=\"secondary-text\">Select the <span translate>BILLINGS.PAYMENT</span> Details *</span><div \nclass=\"border-top border-bottom p-8 mb-16 mt-8\"><md-radio-group class=\"layout-row margin-bottom-10 margin-top-8\" \nng-click=\"clear_advancePaid()\" ng-model=\"vm.expayment.payment_status\" name=\"payment_details\" required><md-radio-button \nng-repeat=\"mode in vm.payment\" value=\"{{mode.value}}\" class=\"md-accent\">{{mode.name}}</md-radio-button>\n</md-radio-group></div><div flex-none layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nclass=\"mt-8 hide-date-picker-icon\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Date</div><md-input-container class=\"md-block md-accent\" flex=\"50\">\n<md-datepicker ng-model=\"vm.expayment.paid_date\" name=\"paid_date\" md-min-date=\"minDates\" md-max-date=\"maxDates\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" required></md-datepicker></md-input-container>\n</div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex md-no-float><md-select \nng-model=\"vm.expayment.payment_type\" name=\"amountType\" class=\"md-accent\" placeholder=\"Select\" required><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'advance paid\'\" \nng-click=\"clear_fullyPaid()\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Amount <span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></div><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"40\"><input placeholder=\"Amount (₹)\" type=\"text\" name=\"received_amount\" ng-model=\"vm.expayment.received_amount\" \nrequired></md-input-container><span class=\"balance-color mt-8\" ng-if=\"vm.expayment.received_amount\">\nBal (₹) {{ vm.exitems.total_amount - vm.expayment.received_amount}}</span></div><div layout=\"row\" class=\"mt-8\" \nng-if=\"vm.expayment.payment_status == \'advance paid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Mode</div>\n<md-input-container class=\"md-accent\" flex ng-click=\"clear_payment()\" md-no-float><md-select \nng-model=\"vm.expayment.payment_type\" name=\"amountType\" class=\"md-accent\" placeholder=\"Select\" required><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'fully paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'advance paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.TRANSCATION\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.TRANSCATION\' | translate}}\" \ntype=\"text\" name=\"transcation_no\" ng-model=\"vm.expayment.transcation_no\"></md-input-container></div><div layout=\"row\" \nclass=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.CHEQUE-NO\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.CHEQUE-NO\' | translate}}\" type=\"text\" \nname=\"cheque_no\" ng-model=\"vm.expayment.cheque_no\"></md-input-container></div><div layout=\"row\" class=\"mt-16 flex\" \nng-if=\"vm.expayment.payment_status == \'unpaid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Notes</div>\n<md-input-container class=\"md-block md-accent\" md-no-float><label>Enter the notes</label><textarea \nng-model=\"vm.expayment.note\" rows=\"1\"></textarea></md-input-container></div></div></div>");
$templateCache.put("app/main/cashier/expense/new-expense/recurring/recurring.html","<div class=\"m-w-584\"><md-checkbox ng-model=\"levels\" ng-checked=\"\" class=\"mt-8\">Make Recurring</md-checkbox><div \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16 font-size-px-14\">Repeat this expense automatically</div><div \nng-show=\"levels\" class=\"border-top m-w-480\" layout=\"column\"><div layout=\"row\" \nclass=\"medium hide-date-picker-icon spacer-8 mt-24\"><span flex-none class=\"form-label w-140 mt-8\">Start On</span>\n<md-input-container class=\"md-block md-accent\" flex=\"100\"><md-datepicker ng-model=\"vm.recurring.status\" \nclass=\"md-accent\" md-current-view=\"year\" md-placeholder=\"Enter date\"></md-datepicker></md-input-container></div><div \nlayout=\"row\" class=\"medium spacer-8 mb-8\"><span flex-none class=\"form-label w-140 mt-8\">Repeat every</span>\n<md-input-container class=\"md-accent pt-0 ml-16 md-block\" flex=\"40\" md-no-float><md-select \nng-model=\"vm.recurring.repeat_every\"><md-option ng-repeat=\"mode in vm.oftenlist\" value=\"{{mode.value}}\">{{mode.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"medium hide-date-picker-icon spacer-8 mt-16\"><span flex-none class=\"form-label w-140\">Ends</span><md-radio-group\n class=\"layout-row\" ng-model=\"vm.recurring.end_mode\"><md-radio-button ng-repeat=\"pay in vm.howmanylist\" \nvalue=\"{{pay.value}}\" class=\"md-accent\">{{pay.name}}</md-radio-button></md-radio-group></div><div layout=\"row\" \nng-show=\"vm.recurring.end_mode==\'remaining\'\" class=\"medium mt-16 mb-16\"><span flex-none class=\"w-140\"></span>\n<md-input-container md-no-float class=\"md-accent md-block\" flex=\"40\"><input placeholder=\"Count\" type=\"text\" \nname=\"quantity\" ng-model=\"vm.recurring.end_count\" required><div class=\"hint\">Count of remaining to finish</div>\n</md-input-container></div></div></div>");
$templateCache.put("app/main/cashier/expense/paid-expense/purchase_expense/purchase_expense.html","<div class=\"layout-column layout-align-center-center min-height-100 text-center no-data\" \nng-if=\"vm.purchaseexpense.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 \nclass=\"text-center md-display-1\">Hi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no {{\'Inventory.PURCHASE-ORDER\' | translate}} bills for you to see. If you want to add a new purchase just click below button and go ahead\n</h3><md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.addPurchase\">\n{{\'Inventory.ADD-PURCHASE-ORDER\' | translate}}</md-button></div><div class=\"min-height-100 layout-column scrollable\" \nng-if=\"vm.purchaseexpense.length>0 || retrieve\"><div layout=\"row\" layout-align=\"center start\" flex class=\"mb-16\"><div \nclass=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input md-accent\" ng-model=\"purchaseexpense_query.filter\" ng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseexpense_query.filter\" \nng-click=\"clearTextss()\"></md-icon></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head md-order=\"purchaseexpense_query.order\" \nmd-on-reorder=\"getDessertss\"><tr md-row><th md-column width=\"12%\">{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column \nwidth=\"10%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column ng-if=\"permission!=admin\">\n{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">{{\'EXPENSE.VENDOR/PERSON\' | translate}}</th><th \nmd-column width=\"16%\">{{\'EXPENSE.PAID-DATE\' | translate}}</th><th md-column width=\"14%\"><span>\n{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.purchaseexpense | limitTo: purchaseexpense_query.limit | filter: purchaseexpense_query.filter | orderBy: purchaseexpense_query.order\">\n<td md-cell>{{ balExpBill.purchase_expense_id }}</td><td md-cell><div class=\"layout-row layout-align-start-center\">\n<span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ balExpBill.total_amount }}</span></div></td><td md-cell ng-if=\"permission!=admin\">\n{{ balexpense_staffnames(balExpBill) }}</td><td md-cell title=\"{{paidbill.deliveredFullTime}}\">\n{{ balExpBill.vendor_name }}</td><td md-cell>{{ balExpBill.paid_date | date}}</td><td><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"purchaseexpense(balExpBill.purchase_expense_id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=\"null\">\n<md-icon md-menu-origin md-font-icon=\"icon-printer\"></md-icon><span translate>GENERAL.PRINT</span></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"purchaseexpense_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"purchaseexpense_query.page\" \nmd-total=\"{{purchaseexpense_count}}\" md-on-paginate=\"getDessertsss\" md-page-select></md-table-pagination></div>\n<md-content style=\"display: none\" class=\"md-padding layout-fill scrollable\" \nng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" ng-controller=\"printbillController as vm\" ms-scroll>\n</md-content>");
$templateCache.put("app/main/cashier/expense/paid-expense/sales_expense/sales_expense.html","<div class=\"layout-column layout-align-center-center min-height-100 text-center no-data\" \nng-if=\"vm.salesexpense.length==0 && !retrieve\"><img src=\"assets/images/no-data.png\"><h1 \nclass=\"text-center md-display-1\">Hi {{staff_name}}!</h1><h3 class=\"text-center\">\nThere\'re no {{\'Inventory.SALES-ORDER\' | translate}} bills for you to see. If you want to add a new Sales just click below button and go ahead\n</h3><md-button class=\"md-raised md-primary layout-row layout-align-center-center mt-16\" ui-sref=\"app.addSales\">\n{{\'Inventory.ADD-SALES-ORDER\' | translate}}</md-button></div><div class=\"min-height-100 layout-column scrollable\" \nng-if=\"vm.salesexpense.length>0 || retrieve\"><div layout=\"row\" layout-align=\"center start\" flex class=\"mb-16\"><div \nclass=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input md-accent\" ng-model=\"paidexpense_query.filter\" ng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search {{\'EXPENSE.BILLNO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"paidexpense_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><md-table-container><table md-table md-row-select multiple=\"multiple\" \nmd-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head md-order=\"paidexpense_query.order\" \nmd-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"12%\">{{\'EXPENSE.BILLNO\' | translate}}</th><th md-column \nwidth=\"10%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column ng-if=\"permission!=admin\">\n{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">{{\'EXPENSE.VENDOR/PERSON\' | translate}}</th><th \nmd-column width=\"16%\">{{\'EXPENSE.PAID-DATE\' | translate}}</th><th md-column width=\"14%\"><span>\n{{\'BILLINGS.ACTIONS\' | translate}}</span></th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select \nng-repeat=\"balExpBill in vm.salesexpense | limitTo: paidexpense_query.limit | filter: paidexpense_query.filter | orderBy: paidexpense_query.order\">\n<td md-cell>{{ balExpBill.sales_expense_id }}</td><td md-cell><div class=\"layout-row layout-align-start-center\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ balExpBill.total_amount }}</span></div></td><td md-cell ng-if=\"permission!=admin\">\n{{ balexpense_staffnames(balExpBill) }}</td><td md-cell title=\"{{paidbill.deliveredFullTime}}\">\n{{ balExpBill.vendor_name }}</td><td md-cell>{{ balExpBill.paid_date | date}}</td><td><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"saleexpense(balExpBill.sales_expense_id)\"><md-icon md-menu-origin md-font-icon=\"icon-pencil\">\n</md-icon>View & Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=\"null\"><md-icon md-menu-origin \nmd-font-icon=\"icon-printer\"></md-icon><span translate>GENERAL.PRINT</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"paidexpense_query.limit\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"paidexpense_query.page\" md-total=\"{{salesexpense_count}}\" \nmd-on-paginate=\"getDessertsss\" md-page-select></md-table-pagination></div><md-content style=\"display: none\" \nclass=\"md-padding layout-fill scrollable\" ng-include=\"\'app/main/cashier/billing/print-bill/printbill.html\'\" \nng-controller=\"printbillController as vm\" ms-scroll></md-content>");
$templateCache.put("app/main/cashier/inventory/raw-material/add-purchase_order/addPurchase.html","<form class=\"newbill w-100p layout-fill small no-error\" name=\"newpurchase\" novalidate style=\"position: relative\"><div \nclass=\"layout-row min-height-100 md-whiteframe-2dp white-bg\"><div class=\"flex-none left-side-ver-tab\"><ul \nclass=\"pr-tabs\"><li class=\"pr-tab\" ng-class=\"{\'active\': prTabName==\'tabBillInfo\'}\" \nng-click=\"prTabName =\'tabBillInfo\';expensebills()\" md-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newpurchase.rate.$invalid || odcBill.autocompleteFood.$invalid || newpurchase.autocompleteVendor.$invalid || newpurchase.status.$invalid || newpurchase.quantity.$invalid) && (newpurchase.$submitted)} \">\n<span translate>Inventory.PURCHASE-ORDER</span> Info</span></li><li class=\"pr-tab\" \nng-class=\"{\'active\': prTabName==\'tabPayment\'}\" ng-click=\"prTabName =\'tabPayment\';payment()\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newpurchase.payment_details.$invalid || newpurchase.cheque_no.$invalid || newpurchase.paid_date.$invalid || newpurchase.received_amount.$invalid || newpurchase.amountType.$invalid || newpurchase.transcation_no.$invalid) && (newpurchase.$submitted)} \">\n<span translate>BILLINGS.PAYMENT</span></span></li></ul></div><div class=\"pr-tab-contents flex\" ng-switch=\"prTabName\">\n<div class=\"pr-tab-content layout-fill\" ng-show=\"expensebill\"><div \nng-include=\"\'app/main/cashier/inventory/raw-material/add-purchase_order/purchaseorder-info/add_purchase.html\'\" \nclass=\"layout-fill\"></div></div><div class=\"pr-tab-content\" ng-show=\"payments\"><div \nng-include=\"\'app/main/cashier/inventory/raw-material/add-purchase_order/raw-material-payment/payment.html\'\"></div>\n</div><div class=\"fix-bottom pt-8 pl-16\"><div class=\"layout-row center-end small-fix-bottom-button\"><div \nclass=\"layout-row center-end flex\" ng-if=\"!params.id\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"cancel($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary big layout-row layout-align-center-center\" ng-click=\"add_purchase()\">Save</md-button></div>\n<div ng-if=\"params.id\" class=\"layout-row layout-align-space-between-center m-w-860\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"canceledit($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary layout-row layout-align-center-center\" ng-click=\"update_purchase()\">Save</md-button></div>\n</div></div></div></div></form>");
$templateCache.put("app/main/cashier/inventory/raw-material/deliver-to-kitchen/deliver-to-kitchen-additem.dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-780 h-600 layout-column deliver-to-kitchen\"><md-dialog-content \nclass=\"flex layout-column\"><md-button class=\"md-icon-button dialog-top-close-icon\" aria-label=\"Close\" \nng-click=\"closeDialog()\"><md-icon md-font-icon=\"icon icon-close\"></md-icon></md-button><div class=\"flex-none\"><h2 \nclass=\"md-title margin-top-0 mb-32\">{{title}} Deliver to Kitchen</h2></div><form name=\"addfoodForm\" novalidate><div \nlayout=\"row\" flex=\"100\"><table class=\"dataTable border-right border-left border-bottom\"><thead><tr><th \nclass=\"secondary-text\" width=\"40%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"10%\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"10%\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\" width=\"40%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'Inventory.PURPOSE\' | translate}}</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"fmitem in exitems\" class=\"small no-error\"><td><md-autocomplete class=\"md-accent no-label ml-8\" \nng-class=\"{\'autodd\': $index == indx}\" md-input-id=\"fooditem\" flex=\"100\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.rmname\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in querySearch(fmitem.searchText)\" \nng-keypress=\"exitems[0].deliveryto_kitchen_id ? \'\' : keyPressed($event)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-min-length=\"0\" md-autoselect=\"true\" \nng-disabled=\"exitems[0].deliveryto_kitchen_id\" md-autofocus=\"true\" md-require-match required><md-item-template \nclass=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">{{item.rmname}}</span></md-item-template><div \nng-messages=\"addfoodForm.autocompleteFood.$error\" ng-if=\"addfoodForm.autocompleteFood.$touched\"><div \nng-message=\"required\">You <b>must</b> enter a <span translate>RESTRAUNTANT.MENU-ITEM</span></div><div \nng-message=\"md-require-match\">Please select an existing <span translate>RESTRAUNTANT.MENU-ITEM</span></div></div>\n</md-autocomplete></td><td><md-input-container md-no-float class=\"md-accent md-block\" flex=\"100\"><input \nplaceholder=\"Qty\" type=\"number\" name=\"quantity\" \nng-keypress=\"exitems[0].deliveryto_kitchen_id ? \'\' : keyPressed($event)\" ng-model=\"fmitem.quantity\" required><div \nng-messages=\"addfoodForm.quantity.$error\"><div ng-message=\"required\"><span>Please enter the <span translate>\nRESTRAUNTANT.QUANTITY</span></span></div></div></md-input-container></td><td>\n{{fmitem.rmname.unit ? fmitem.rmname.unit : fmitem.unit}}</td><td><md-input-container md-no-float \nclass=\"md-accent md-block\" flex=\"100\"><input ng-keypress=\"exitems[0].deliveryto_kitchen_id ? \'\' : keyPressed($event)\" \nplaceholder=\"Description\" type=\"text\" name=\"quantity\" ng-model=\"fmitem.reason\"></md-input-container></td><td \nng-value=\"{{$index}}\" ng-if=\"!exitems[0].deliveryto_kitchen_id&&$index != 0\"><a \nng-click=\"removeRow(fmitem,$event,$index); $event.stopPropagation();\"><md-icon class=\"text-black-24\" \nmd-font-icon=\"icon icon-trash\"></md-icon></a></td></tr><tr ng-if=\"!exitems[0].deliveryto_kitchen_id\"><td colspan=\"5\">\n<md-button class=\"md-accent mb-16\" ng-click=\"addRow()\" aria-label=\"Add Parcel\">Add Item</md-button></td></tr></tbody>\n</table></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"closeDialog()\">Cancel\n</md-button><md-button class=\"md-accent\" ng-if=\"!newRMItem\" ng-click=\"editItem(delToKitchen)\">Edit Item</md-button>\n<md-button class=\"md-accent\" ng-if=\"newRMItem\" ng-click=\"submit()\">Submit</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/inventory/raw-material/deliver-to-kitchen/deliver-to-kitchen.html","<div class=\"white-bg md-whiteframe-4dp min-height-100 layout-column inner-content scrollable\"><div layout=\"row\" \nlayout-align=\"start start\" class=\"mb-16\"><md-button class=\"md-accent\" aria-label=\"edit info\" \nng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin md-font-icon=\"icon-plus\"></md-icon>\n{{\'Inventory.ADD-DELIVER\' | translate}}</md-button><div layout=\"row\" layout-align=\"end start\" \nclass=\"hide-date-picker-icon\" flex><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" \ntype=\"text\" placeholder=\"search {{\'BILLINGS.ITEMS\' | translate}} or {{ \'Inventory.PURPOSE\' | translate}}\" flex><md-icon\n md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div></div><md-table-container><table md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"purchaseorder_query.order\"><tr md-row><th md-column>{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column>\n{{\'BILLINGS.QTY\' | translate}}</th><th md-column>{{\'Inventory.PURPOSE\' | translate}}</th><th md-column \nng-if=\"permission!=admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column>\n{{\'BILLINGS.DELIVERED-TIME\' | translate}}</th><th md-column>{{\'BILLINGS.ACTIONS\' | translate}}</th></tr></thead><tbody \nmd-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"delToKitchen in vm.getpurchase |  limitTo: purchaseorder_query.limit: (purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order\">\n<td md-cell>{{ delToKitchen.rmname.rmname ? delToKitchen.rmname.rmname : delToKitchen.rmname }}</td><td md-cell>\n{{ delToKitchen.quantity}} {{delToKitchen.unit}}</td><td md-cell>{{ delToKitchen.reason ? delToKitchen.reason : \'-\' }}\n</td><td md-cell ng-if=\"permission!=admin\">{{ deliverykitchen_staffnames(delToKitchen) }}</td><td md-cell>\n{{ formatDate(delToKitchen.delivered_date) | date}}<md-icon \ntitle=\"Last updated by  {{update_staff(delToKitchen)}} ,on {{formatDate(delToKitchen.last_modified) | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></td><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showAddTableDialog($event,delToKitchen)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteContactConfirm(delToKitchen,$event); $event.stopPropagation();\"><md-icon md-menu-origin \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.getpurchase.length==0\"><h3>\nThere\'re no delivery taken data for you to see.</h3></div></md-table-container><md-table-pagination \nmd-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"purchaseorder_query.page\" \nmd-total=\"{{vm.getpurchase.length}}\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/cashier/inventory/raw-material/purchased-order/rm-purchased-order.html","<section class=\"paid-container layout-column min-height-100 white-bg md-whiteframe-4dp\"><div layout=\"column\" flex><div \nlayout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" class=\"medium\"><div \nclass=\"ph-8 filter-dropdown-md\"><md-datepicker ng-model=\"monthyear\" aria-label=\"email\" md-max-date=\"maxDate\" \nng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" ng-required=\"dateFields[2].required\" \nmd-date-locale=\"dateFields[2].locale\" md-mode=\"{{dateFields[2].mode}}\" md-open-on-focus=\"true\"></md-datepicker></div>\n<div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"vendor\" aria-label=\"email\" \nng-init=\"vendor=vm.vendor[0].vendorID\" ng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" \nclass=\"md-accent\" flex=\"100\"><md-option ng-repeat=\"vendor in vm.vendor\" value=\"{{vendor.vendorID}}\">\n{{vendor.vendor_name}}</md-option></md-select></div><div ng-show=\"permission\" ng-hide=\"!permission\" \nclass=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"staffss\" aria-label=\"email\" \nng-init=\"staffss=vm.staffRole[0].staffID\" \nng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" class=\"md-accent\" flex=\"100\"><md-option\n ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></div><div \nng-if=\"vm.getpurchase.length>0\" class=\"layout-align-start-start ph-12\"><a export-to-csv1 class=\"download-csv\" \nstyle=\"display: none\"><md-tooltip md-direction=\"top\">Export all the data to CSV</md-tooltip></a><table \nstyle=\"display: none\"><tr><th style=\"color: red\">{{\'Inventory.PURCHASED-NO\' | translate}}</th><th>\n{{\'BILLINGS.ITEMS\' | translate}}</th><th>Total {{\'BILLINGS.AMOUNT\' | translate}}</th><th>Advance paid</th><th>\n{{\'EXPENSE.Balance\' | translate}} Amount</th><th>{{ \'BILLINGS.CGST\' | translate}}</th><th>\n{{ \'BILLINGS.SGST\' | translate}}</th><th>{{ \'BILLINGS.DISCOUNT\' | translate}}</th><th>{{\'EXPENSE.vendor\' | translate}}\n</th><th>Payment Status</th><th>Due/ {{\'EXPENSE.PAID-DATE\' | translate}}</th><th></th><th>\nOrderd {{\'BILLINGS.STATUS\' | translate}}</th><th>{{\'Inventory.DeliveryDate\' | translate}}</th><th></th><th \nng-if=\"permission!=admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th>{{\'Inventory.CREATED ON\' | translate}}</th>\n</tr><tr ng-repeat=\"rmPurchasedOrder in vm.getpurchase\"><td>{{rmPurchasedOrder.purchase_order_id}}</td><td>\n{{ rmPurchasedOrder.rmname }}</td><td>{{rmPurchasedOrder.total_amount}}</td><td>{{rmPurchasedOrder.received_amount}}\n</td><td>\n{{ rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount==rmPurchasedOrder.total_amount ? 0 : rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount }}\n</td><td>{{rmPurchasedOrder.tax_cgst }}</td><td>{{rmPurchasedOrder.tax_sgst}}</td><td>{{rmPurchasedOrder.discount}}\n</td><td>{{ rmPurchasedOrder.vendor_name }}</td><td>{{ rmPurchasedOrder.payment_status }}</td><td>\n{{ rmPurchasedOrder.due_date | date }}</td><td>{{ rmPurchasedOrder.purchaseStatus}}</td><td>\n{{rmPurchasedOrder.DeliveryDate | date}}</td><td ng-if=\"permission!=admin\">\n{{purchaseorder_staffnames(rmPurchasedOrder) }}</td><td>{{ rmPurchasedOrder.created_on | date}}</td></tr></table></div>\n<md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" \nng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"search {{\'Inventory.PURCHASED-NO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex><md-icon \nmd-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"purchaseorder_query.filter\" \nng-click=\"clearText()\"></md-icon></div></div><div class=\"layout-align-start-start ph-16\"><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"purchaseorder_query.order\" md-on-reorder=\"getPurchaseOrder\"><tr md-row><th md-column width=\"10%\">\n{{\'Inventory.PURCHASED-NO\' | translate}}</th><th md-column width=\"5%\">{{\'BILLINGS.ITEMS\' | translate}}</th><th \nmd-column width=\"9%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column width=\"15%\">{{\'EXPENSE.Balance\' | translate}}\n</th><th md-column width=\"10%\">{{\'EXPENSE.PAID-DATE\' | translate}}</th><th md-column width=\"9%\">\n{{\'EXPENSE.vendor\' | translate}}</th><th md-column width=\"19%\">{{\'BILLINGS.STATUS\' | translate}}</th><th md-column \nng-if=\"permission!=admin\" width=\"10%\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">\n{{\'BILLINGS.ACTIONS\' | translate}}</th></tr></thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" \nmd-auto-select \nng-repeat=\"rmPurchasedOrder in vm.getpurchase | limitTo: purchaseorder_query.limit: (purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order\">\n<td md-cell ng-class=\"currentbill.status\" class=\"border-status\">{{rmPurchasedOrder.purchase_order_id}}</td><td md-cell>\n{{ rmPurchasedOrder.rmname }}</td><td md-cell><div class=\"layout-row layout-align-start-center\"><span \nclass=\"grey-col-sec-text pr-2\" translate>BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ rmPurchasedOrder.total_amount }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\"><span \ntranslate class=\"warm-color\" \nng-if=\"rmPurchasedOrder.received_amount > \'0\' || rmPurchasedOrder.payment_status==\'unpaid\'\">BILLINGS.INR</span> <span \nng-show=\"rmPurchasedOrder.received_amount > \'0\'  || rmPurchasedOrder.payment_status==\'unpaid\'\" \nclass=\"font-size-px-18 warm-color\">{{ rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount }}</span> <span \nclass=\"font-size-px-18\" ng-if=\"rmPurchasedOrder.received_amount == \'0\'  && rmPurchasedOrder.payment_status!=\'unpaid\'\">\n{{\'0\'}}</span> <span class=\"flex-none adv-amount\" ng-if=\"rmPurchasedOrder.received_amount > \'0\'\">\nadv {{ rmPurchasedOrder.received_amount }}</span></td><td md-cell>\n{{rmPurchasedOrder.due_date==\'undefined\' || rmPurchasedOrder.due_date==\'null\' ? \'-\' : rmPurchasedOrder.due_date | date}}\n</td><td md-cell>{{ rmPurchasedOrder.vendor_name }}</td><td md-cell><div class=\"layout-row ng-binding\"><span \nclass=\"text-boxed badge food-badge ng-binding food-ordered\" \nng-class=\"{ \'ordered\': \'food-ordered\', \'delivered\': \'food-bill-printed\'}[rmPurchasedOrder.purchaseStatus]\">\n{{ rmPurchasedOrder.purchaseStatus}}</span> <span class=\"flex-none ml-8 sub-text\" \ntitle=\"{{ rmPurchasedOrder.deli_time }}\" ng-if=\"rmPurchasedOrder.purchaseStatus==\'delivered\'\">\n{{ rmPurchasedOrder.purchaseStatus==\'ordered\' ? \'Expected\' : \'Delivered\'}} date<br>\n{{rmPurchasedOrder.DeliveryDate | date }}</span><md-icon \ntitle=\"Last updated by  {{update_staff(rmPurchasedOrder)}} ,on {{rmPurchasedOrder.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></div></td><td md-cell \nng-if=\"permission!=admin\">{{purchaseorder_staffnames(rmPurchasedOrder) }}</td><td><md-icon md-menu-origin \nmd-font-icon=\"icon-attachment\" ng-if=\"rmPurchasedOrder.attached == \'yes\'\"></md-icon><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"purchaseid(rmPurchasedOrder.purchase_order_id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"deletePurchaseOrder(rmPurchasedOrder,$event,$index); $event.stopPropagation();\"><md-icon \nclass=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon>Delete</md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table><div class=\"layout-column layout-align-center-center no-data padding-32\" \nng-if=\"vm.getpurchase.length==0\"><h3>There\'re no purchase ordered for you to see.</h3></div></md-table-container>\n<md-table-pagination md-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"purchaseorder_query.page\" md-total=\"{{purchaseorder_count}}\" md-page-select></md-table-pagination></div></div>\n<div class=\"paid-fix md-accent-bg\" ng-if=\"vm.getpurchase.length>0\"><div layout=\"row\" layout-align=\"start start\"><div \nflex-none class=\"paid-each-container\"><span class=\"title\">Paid Amount</span> <span class=\"inr\" translate>BILLINGS.INR\n</span> <span class=\"amount\">{{total_paid}}</span><span title=\"purchase ordered\" class=\"paid_count\"><img \nsrc=\"assets/icons/order-icon.svg\"> {{paid_count}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">Balance Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{balance}}\n</span><span title=\"purchase ordered\" class=\"paid_count\"><img src=\"assets/icons/order-icon.svg\"> {{balance_count}}\n</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In cash</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_cash}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In card</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_card}}</span>\n</div><div flex-none class=\"paid-each-container\"><span class=\"title\">In cheque</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_cheque}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In online</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_online}}\n</span></div></div></div></section>");
$templateCache.put("app/main/cashier/inventory/raw-material/stock-raw-material/stock-raw-material.html","<div class=\"white-bg md-whiteframe-4dp inner-content min-height-100 layout-column\"><div \nclass=\"result-info mb-16 small\" layout=\"row\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\" \nflex><div class=\"flex\" layout=\"row\"><div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"stu\" aria-label=\"today\" \nclass=\"md-accent\" ng-init=\"stu = \'All\'\" ng-change=\"getRaw_items(stu)\"><md-option ng-repeat=\"food in vm.rmCategory\" \nvalue=\"{{food.rmCatergoryID}}\">{{food.rmCatergoryName}}</md-option></md-select></div><div ng-if=\"vm.rmstock.length>0\" \nclass=\"layout-align-start-start ph-12\"><a export-to-csv8 class=\"download-csv\"><md-tooltip md-direction=\"top\">\nExport data to CSV</md-tooltip></a><table style=\"display: none\"><tr><th>{{\'BILLINGS.ITEMS\' | translate}}</th><th>\n{{\'ODC.Category\' | translate}}</th><th>Available {{\'BILLINGS.QTY\' | translate}}</th></tr><tr \nng-repeat=\"stockRawMaterial in vm.rmstock | filter:vm.search\"><td>{{ stockRawMaterial.rmname }}</td><td>\n{{ getCategoryName(stockRawMaterial) }}</td><td class=\"table-second\">\n{{ stockRawMaterial.stock_quantity }}- {{stockRawMaterial.unit}}</td></tr></table></div><md-progress-circular \nclass=\"md-accent ml-10 mt-10\" ng-if=\"raw_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div>\n<div layout=\"row\" layout-align=\"end start\"><div class=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"{{\'BILLINGS.SEARCH\' | translate}}..\" flex><md-icon md-font-icon=\"icon-close s16\" \nclass=\"icon search-icon clr-button\" title=\"clear\" ng-if=\"vm.search\" ng-click=\"clearText()\"></md-icon></div></div></div>\n</div><div class=\"dataTable-primary scrollable\" ms-scroll><table class=\"dataTable row-border\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.ITEMS\' | translate}}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'ODC.Category\' | translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Available {{\'BILLINGS.QTY\' | translate}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"stockRawMaterial in vm.rmstock | filter:vm.search\"><td>{{ stockRawMaterial.rmname }}</td><td>\n{{ getCategoryName(stockRawMaterial) }}</td><td><span class=\"table-second mr-4\">{{ stockRawMaterial.stock_quantity }}\n</span> {{stockRawMaterial.unit}}</td></tr></tbody></table><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.rmstock.length==0\"><h3>\nThere\'re no {{\'Inventory.STOCK-OF-RAW-MATERIAL\' | translate}} for you to see.</h3><br><br><hr></div></div></div>");
$templateCache.put("app/main/cashier/inventory/sale-material/add-sales_order/addSales.html","<form class=\"newbill w-100p layout-fill small no-error purchase-order\" name=\"newsales\" novalidate \nstyle=\"position: relative\"><div class=\"layout-row min-height-100 md-whiteframe-2dp white-bg mobile-height\" \nlayout-xs=\"column\"><div class=\"flex-none left-side-ver-tab\"><ul class=\"pr-tabs\"><li class=\"pr-tab\" \nng-class=\"{\'active\': prTabName==\'tabBillInfo\'}\" ng-click=\"prTabName =\'tabBillInfo\';expensebills()\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newsales.rate.$invalid || odcBill.autocompleteFood.$invalid || newsales.autocompleteVendor.$invalid || newsales.DueDate.$invalid ||  newsales.eventDate.$invalid || newsales.status.$invalid || newsales.quantity.$invalid) && (newsales.$submitted)} \">\n<span translate>Inventory.PURCHASE-ORDER</span> Info</span></li><li class=\"pr-tab\" \nng-class=\"{\'active\': prTabName==\'tabPayment\'}\" ng-click=\"prTabName =\'tabPayment\';payment()\" \nmd-ink-ripple=\"rgba(0,0,0,0.5)\"><span \nng-class=\"{ \'error\': (newsales.payment_details.$invalid || newsales.cheque_no.$invalid ||  newsales.paid_date.$invalid || newsales.received_amount.$invalid || newsales.amountType.$invalid ||  newsales.transcation_no.$invalid) && (newsales.$submitted)} \">\n<span translate>BILLINGS.PAYMENT</span></span></li></ul></div><div class=\"pr-tab-contents flex\" ng-switch=\"prTabName\">\n<div class=\"pr-tab-content layout-fill\" ng-show=\"expensebill\"><div \nng-include=\"\'app/main/cashier/inventory/sale-material/add-sales_order/salesorder-info/add_sales.html\'\" \nclass=\"layout-fill\"></div></div><div class=\"pr-tab-content\" ng-show=\"payments\"><div \nng-include=\"\'app/main/cashier/inventory/sale-material/add-sales_order/sale-material-payment/payment.html\'\"></div></div>\n<div class=\"fix-bottom pt-8 pl-16\"><div class=\"layout-row center-end small-fix-bottom-button\"><div \nclass=\"layout-row center-end flex\" ng-if=\"!params.id\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"cancel($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary big layout-row layout-align-center-center\" ng-click=\"add_purchase()\">Save</md-button></div>\n<div ng-if=\"params.id\" class=\"layout-row layout-align-space-between-center m-w-860\"><md-button \nclass=\"md-raised layout-row layout-align-center-center\" ng-click=\"canceledit($event)\">Cancel</md-button><md-button \nclass=\"md-raised md-primary layout-row layout-align-center-center\" ng-click=\"update_purchase()\">Save</md-button></div>\n</div></div></div></div></form>");
$templateCache.put("app/main/cashier/inventory/sale-material/sales-order/sm-sales-order.html","<section class=\"paid-container sales-material-list layout-column min-height-100 white-bg md-whiteframe-4dp\"><div \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"start start\" class=\"mb-16 no-error small\"><div flex layout=\"row\" \nclass=\"medium\"><div class=\"ph-8 filter-dropdown-md\"><md-datepicker ng-model=\"monthyear\" aria-label=\"email\" \nmd-max-date=\"maxDate\" ng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" \nng-required=\"dateFields[2].required\" md-date-locale=\"dateFields[2].locale\" md-mode=\"{{dateFields[2].mode}}\" \nmd-open-on-focus=\"true\"></md-datepicker></div><div class=\"ph-8 filter-dropdown-sm hidebelow600\"><md-select \nng-model=\"vendor\" aria-label=\"email\" ng-init=\"vendor=vm.vendor[0].vendorID\" \nng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" class=\"md-accent\" flex=\"100\"><md-option\n ng-repeat=\"vendor in vm.vendor\" value=\"{{vendor.vendorID}}\">{{vendor.vendor_name}}</md-option></md-select></div><div \nng-show=\"permission\" ng-hide=\"!permission\" class=\"medium ph-8 filter-dropdown-sm hidebelow600\"><md-select \nng-model=\"staffss\" aria-label=\"email\" ng-init=\"staffss=vm.staffRole[0].staffID\" \nng-change=\"changeDate(status_type,amount_type,monthyear,vendor,staffss,$event)\" class=\"md-accent\" flex=\"100\"><md-option\n ng-repeat=\"staff in vm.staffRole\" value=\"{{staff.staffID}}\">{{staff.name}}</md-option></md-select></div><div \nng-if=\"vm.getpurchase.length>0\" class=\"layout-align-start-start ph-12\"><table style=\"display: none\"><tr><th>\n{{\'Inventory.PURCHASED-NO\' | translate}}</th><th>{{\'BILLINGS.ITEMS\' | translate}}</th><th>\nTotal {{\'BILLINGS.AMOUNT\' | translate}}</th><th>Advance paid</th><th>{{\'EXPENSE.Balance\' | translate}} Amount</th><th>\n{{ \'BILLINGS.CGST\' | translate}}</th><th>{{ \'BILLINGS.SGST\' | translate}}</th><th>{{ \'BILLINGS.DISCOUNT\' | translate}}\n</th><th>{{\'EXPENSE.vendor\' | translate}}</th><th>Payment Status</th><th>Due/ {{\'EXPENSE.PAID-DATE\' | translate}}</th>\n<th></th><th>Orderd {{\'BILLINGS.STATUS\' | translate}}</th><th>{{\'Inventory.DeliveryDate\' | translate}}</th><th></th><th\n ng-if=\"permission!=admin\">{{\'BILLINGS.CREATED-BY\' | translate}}</th><th>{{\'Inventory.CREATED ON\' | translate}}</th>\n</tr><tr ng-repeat=\"rmPurchasedOrder in vm.getpurchase\"><td>{{rmPurchasedOrder.purchase_order_id}}</td><td>\n{{ rmPurchasedOrder.rmname }}</td><td>{{rmPurchasedOrder.total_amount}}</td><td>{{rmPurchasedOrder.received_amount}}\n</td><td>\n{{ rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount==rmPurchasedOrder.total_amount ? 0 : rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount }}\n</td><td>{{rmPurchasedOrder.tax_cgst }}</td><td>{{rmPurchasedOrder.tax_sgst}}</td><td>{{rmPurchasedOrder.discount}}\n</td><td>{{ rmPurchasedOrder.vendor_name }}</td><td>{{ rmPurchasedOrder.payment_status }}</td><td>\n{{ rmPurchasedOrder.due_date | date }}</td><td>{{ rmPurchasedOrder.purchaseStatus}}</td><td>\n{{rmPurchasedOrder.DeliveryDate | date}}</td><td ng-if=\"permission!=admin\">\n{{purchaseorder_staffnames(rmPurchasedOrder) }}</td><td>{{ rmPurchasedOrder.created_on | date}}</td></tr></table></div>\n<md-progress-circular class=\"md-accent ml-10 mt-10\" ng-if=\"load\" md-mode=\"indeterminate\" md-diameter=\"20\">\n</md-progress-circular></div><div class=\"search md-block mr-16\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input md-accent\" ng-model=\"purchaseorder_query.filter\" \ntype=\"text\" placeholder=\"search {{\'Inventory.PURCHASED-NO\' | translate}} or {{ \'BILLINGS.AMOUNT\' | translate}}\" flex>\n<md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" \nng-if=\"purchaseorder_query.filter\" ng-click=\"clearText()\"></md-icon></div></div><div \nclass=\"layout-align-start-start ph-16\"><md-table-container><table id=\"tableid\" md-table md-row-select \nmultiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"purchaseorder_query.order\" md-on-reorder=\"getDessertsss\"><tr md-row><th md-column width=\"10%\">\n{{\'Inventory.PURCHASED-NO\' | translate}}</th><th md-column width=\"5%\" class=\"hidebelow600\">\n{{\'BILLINGS.ITEMS\' | translate}}</th><th md-column width=\"9%\">{{\'BILLINGS.AMOUNT\' | translate}}</th><th md-column \nwidth=\"15%\">{{\'EXPENSE.Balance\' | translate}}</th><th md-column width=\"9%\" class=\"hidebelow600\">\n{{\'EXPENSE.vendor\' | translate}}</th><th md-column width=\"10%\" class=\"hidebelow600\">\nDUE/{{\'EXPENSE.PAID-DATE\' | translate}}</th><th md-column width=\"19%\" class=\"hidebelow600\">\n{{\'BILLINGS.STATUS\' | translate}}</th><th md-column ng-if=\"permission!=admin\" width=\"10%\" class=\"hidebelow600\">\n{{\'BILLINGS.CREATED-BY\' | translate}}</th><th md-column width=\"12%\">{{\'BILLINGS.ACTIONS\' | translate}}</th></tr>\n</thead><tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"rmPurchasedOrder in vm.getpurchase | limitTo: purchaseorder_query.limit: (purchaseorder_query.page - 1) * purchaseorder_query.limit | filter: purchaseorder_query.filter | orderBy: purchaseorder_query.order\">\n<td md-cell ng-class=\"currentbill.status\" class=\"border-status\">{{rmPurchasedOrder.purchase_order_id}}</td><td md-cell \nclass=\"hidebelow600\">{{ rmPurchasedOrder.rmname }}</td><td md-cell><div class=\"layout-row layout-align-start-center\">\n<span class=\"grey-col-sec-text pr-2\" translate>BILLINGS.INR</span> <span class=\"font-size-px-18\">\n{{ rmPurchasedOrder.total_amount }}</span></div></td><td md-cell title=\"{{currentbill.showdeliverdate}}\"><span \ntranslate class=\"warm-color\" \nng-if=\"rmPurchasedOrder.received_amount > \'0\'  || rmPurchasedOrder.payment_status==\'unpaid\'\">BILLINGS.INR</span> <span \nng-show=\"rmPurchasedOrder.received_amount > \'0\' || rmPurchasedOrder.payment_status==\'unpaid\'\" \nclass=\"font-size-px-18 warm-color\">{{ rmPurchasedOrder.total_amount - rmPurchasedOrder.received_amount }}</span> <span \nclass=\"font-size-px-18\" ng-if=\"rmPurchasedOrder.received_amount == \'0\'  && rmPurchasedOrder.payment_status!=\'unpaid\'\">\n{{\'0\'}}</span> <span class=\"flex-none adv-amount\" ng-if=\"rmPurchasedOrder.received_amount > \'0\'\">\nadv {{ rmPurchasedOrder.received_amount }}</span></td><td md-cell class=\"hidebelow600\">\n{{ rmPurchasedOrder.vendor_name }}</td><td md-cell class=\"hidebelow600\">\n{{rmPurchasedOrder.due_date==\'undefined\' || rmPurchasedOrder.due_date==\'null\' ? \'-\' : rmPurchasedOrder.due_date | date}}\n</td><td md-cell title=\"{{ rmPurchasedOrder.deli_time }}\" class=\"hidebelow600\"><div class=\"layout-row\"><span \nclass=\"text-boxed badge food-badge ng-binding food-ordered\" \nng-class=\"{ \'ordered\': \'food-ordered\', \'delivered\': \'food-bill-printed\'}[rmPurchasedOrder.purchaseStatus]\">\n{{ rmPurchasedOrder.purchaseStatus}}</span> <span class=\"flex-none ml-8 sub-text hidebelow600\" \ntitle=\"{{ rmPurchasedOrder.deli_time }}\" ng-if=\"rmPurchasedOrder.purchaseStatus==\'delivered\'\">\n{{ rmPurchasedOrder.purchaseStatus==\'ordered\' ? \'Expected\' : \'Delivered\'}} date<br>\n{{rmPurchasedOrder.DeliveryDate | date }}</span><md-icon \ntitle=\"Last updated by  {{update_staff(rmPurchasedOrder)}} ,on {{rmPurchasedOrder.last_modified | date:\'medium\'}}\" \nclass=\"rate-edit hidebelow600\" md-font-icon=\"icon icon-information s16 text-black-16\"></md-icon></div></td><td md-cell \nng-if=\"permission!=admin\" class=\"hidebelow600\">{{purchaseorder_staffnames(rmPurchasedOrder) }}</td><td><md-icon \nmd-menu-origin md-font-icon=\"icon-attachment\" ng-if=\"rmPurchasedOrder.attached == \'yes\'\"></md-icon><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"purchaseid(rmPurchasedOrder.purchase_order_id)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-pencil\"></md-icon>View & Edit</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"removeRow(rmPurchasedOrder,$event,$index); $event.stopPropagation();\"><md-icon class=\"text-black-24\" \nmd-font-icon=\"icon icon-trash\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><div class=\"layout-column layout-align-center-center no-data padding-32\" \nng-if=\"vm.getpurchase.length==0\"><h3>There\'re no purchase ordered for you to see.</h3></div></md-table-container>\n<md-table-pagination md-limit=\"purchaseorder_query.limit\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"purchaseorder_query.page\" md-total=\"{{purchaseorder_count}}\" md-page-select></md-table-pagination></div></div>\n<div class=\"paid-fix md-accent-bg hidebelow600\" ng-if=\"vm.getpurchase.length>0\"><div layout=\"row\" \nlayout-align=\"start start\"><div flex-none class=\"paid-each-container\"><span class=\"title\">Paid Amount</span> <span \nclass=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_paid}}</span><span title=\"purchase ordered\" \nclass=\"paid_count\"><img src=\"assets/icons/order-icon.svg\"> {{paid_count}}</span></div><div flex-none \nclass=\"paid-each-container\"><span class=\"title\">Balance Amount</span> <span class=\"inr\" translate>BILLINGS.INR</span> \n<span class=\"amount\">{{balance}}</span><span title=\"purchase ordered\" class=\"paid_count\"><img \nsrc=\"assets/icons/order-icon.svg\"> {{balance_count}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In cash</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_cash}}</span>\n</div><div flex-none class=\"paid-each-container\"><span class=\"title\">In card</span> <span class=\"inr\" translate>\nBILLINGS.INR</span> <span class=\"amount\">{{total_card}}</span></div><div flex-none class=\"paid-each-container\"><span \nclass=\"title\">In cheque</span> <span class=\"inr\" translate>BILLINGS.INR</span> <span class=\"amount\">{{total_cheque}}\n</span></div><div flex-none class=\"paid-each-container\"><span class=\"title\">In online</span> <span class=\"inr\" \ntranslate>BILLINGS.INR</span> <span class=\"amount\">{{total_online}}</span></div></div></div></section>");
$templateCache.put("app/main/cashier/inventory/sale-material/stock-sale-material/stock-sale-material.html","<div class=\"white-bg md-whiteframe-4dp inner-content min-height-100 layout-column\"><div \nclass=\"result-info mb-16 small\" layout=\"row\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\" \nflex><div class=\"flex\" layout=\"row\"><div class=\"ph-8 filter-dropdown-sm\"><md-select ng-model=\"stu\" aria-label=\"today\" \nclass=\"md-accent\" ng-init=\"stu = \'All\'\" ng-change=\"getSale_items(stu)\"><md-option ng-repeat=\"food in vm.smCategory\" \nvalue=\"{{food.siCatergoryID}}\">{{food.smCatergoryName}}</md-option></md-select></div><div ng-if=\"vm.sistock.length>0\" \nclass=\"layout-align-start-start ph-12 hidebelow600\"><a export-to-csv7 class=\"download-csv\"><md-tooltip \nmd-direction=\"top\">Export data to CSV</md-tooltip></a><table style=\"display: none\"><tr><th>\n{{\'BILLINGS.ITEMS\' | translate}}</th><th ng-if=\"vm.branchFilterData[0].barcode_enable == 1\">\n{{\'BILLINGS.BARCODE-NO\' | translate}}</th><th>{{\'ODC.Category\' | translate}}</th><th>\nAvailable {{\'BILLINGS.QTY\' | translate}}</th></tr><tr ng-repeat=\"stockSaleMaterial in vm.sistock  | filter:vm.search\">\n<td>{{ stockSaleMaterial.siname }}</td><td ng-if=\"vm.branchFilterData[0].barcode_enable == 1\">\n{{ stockSaleMaterial.barcode }}</td><td>{{ getCategoryName(stockSaleMaterial) }}</td><td class=\"table-second\">\n{{ stockSaleMaterial.stock_quantity }}</td></tr></table></div><md-progress-circular class=\"md-accent ml-10 mt-10\" \nng-if=\"sale_load\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></div><div \nclass=\"search md-block ml-36\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input md-accent\" ng-model=\"saleitems_query.filter\" ng-keypress=\"keyPressed($event)\" type=\"text\" \nplaceholder=\"Search...\" flex><md-icon md-font-icon=\"icon-close s16\" class=\"icon search-icon clr-button\" title=\"clear\" \nng-if=\"saleitems_query.filter\" ng-click=\"clearTexts()\"></md-icon></div></div></div><div><md-table-container><table \nmd-table md-row-select multiple=\"multiple\" md-progress=\"promise\" ng-model=\"mdtableselected\"><thead md-head \nmd-order=\"saleitems_query.order\" md-on-reorder=\"getDesserts\"><tr md-row><th md-column>{{\'BILLINGS.ITEMS\' | translate}}\n</th><th md-column ng-if=\"vm.branchFilterData[0].barcode_enable == 1\">{{\'BILLINGS.BARCODE-NO\' | translate}}</th><th \nmd-column>{{\'ODC.Category\' | translate}}</th><th md-column>Available {{\'BILLINGS.QTY\' | translate}}</th></tr></thead>\n<tbody md-body><tr md-row md-select=\"dessert\" md-select-id=\"name\" md-auto-select \nng-repeat=\"stockSaleMaterial in vm.sistock\"><td md-cell>{{ stockSaleMaterial.siname }}</td><td md-cell \nng-if=\"vm.branchFilterData[0].barcode_enable == 1\">{{ stockSaleMaterial.barcode }}</td><td md-cell>\n{{ getCategoryName(stockSaleMaterial) }}</td><td class=\"table-second\" md-cell>{{ stockSaleMaterial.stock_quantity }}\n</td></tr></tbody></table></md-table-container><div \nclass=\"layout-column layout-align-center-center no-data padding-32\" ng-if=\"vm.sistock.length==0\"><h3>\nThere\'re no {{\'Inventory.STOCK-OF-SALE-MATERIAL\' | translate}} for you to see.</h3></div><md-table-pagination \nmd-limit=\"saleitems_query.limit\" md-limit-options=\"[5, 10, 15]\" md-page=\"saleitems_query.page\" \nmd-total=\"{{paidexpense_count}}\" md-page-select md-on-paginate=\"getDesserts\"></md-table-pagination></div></div>");
$templateCache.put("app/main/cashier/odc-bill/new-odc-bill/customer/customer.info.html","<div class=\"w-480\" ng-if=\"!customer_data\"><div class=\"layout-column\"><form name=\"odcbill\"><div \nclass=\"label font-size-px-13\">Enter customer mobile no</div><md-autocomplete md-input-id=\"radio-focuscustomer\" \nng-keypress=\"onlynumber($event); phonenumber($event)\" ng-class=\"{\'autodd\': $index == indx}\" \nclass=\"md-accent no-label radio-focuscustomer\" flex=\"100\" md-input-name=\"autocompleteCustomer\" \nmd-no-cache=\"vm.noCache\" md-search-text-change=\"searchTextChangge(customer.searchText)\" \nmd-selected-item=\"customer.customer_mobile\" md-selected-item-change=\"vm.selectedItemChangge(customer)\" \nmd-min-length=\"0\" maxlength=\"4\" md-search-text=\"customer.searchText\" \nmd-items=\"item in vm.querySearchh(customer.searchText)\" md-item-text=\"item.customer_mobile\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-autoselect=\"true\" md-require-match \nplaceholder=\"mobile no\" md-autofocus=\"true\" required><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.customer_mobile}}</span> <span md-highlight-text=\"vm.searchText\">{{item.customer_name}}</span>\n</md-item-template><md-not-found>No number matching \"{{customer.searchText}}\" were found. <a \nng-click=\"vm.showAddTableDialog($event,customer.searchText ?  customer.searchText : customer)\">Create a new customer\n</a></md-not-found></md-autocomplete><div class=\"help-text\">(ex: 9840123210)</div></form><ul \nclass=\"user-profile flex mt-24 w-100p\" ng-if=\"customer.customer_mobile\"><md-button class=\"md-accent\" \nstyle=\"float: right\" ng-click=\"vm.showAddTableDialog($event,customer)\">Edit</md-button><li><div class=\"label\" \ntranslate>BILLINGS.CUSTOMER-LIST.NAME</div><div class=\"title\">{{customer.customer_name}}</div></li><li><div \nclass=\"label\" translate>BILLINGS.CUSTOMER-LIST.EMAIL</div><div class=\"title\">{{customer.customer_email}}</div></li><li>\n<div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.ADDRESS</div><div class=\"title\">{{customer.customer_address}}</div>\n</li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.LOCALITY</div><div class=\"title\"><span>\n{{customer.customer_locality}}</span></div></li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.CITY</div><div \nclass=\"title\"><span>{{customer.customer_city}}</span></div></li></ul></div></div><div class=\"w-480\" \nng-if=\"customer_data\"><div class=\"layout-column\"><form><md-autocomplete ng-class=\"{\'autodd\': $index == indx}\" \nclass=\"md-accent no-label\" flex=\"100\" md-input-name=\"autocompleteFood\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChangge(customer.searchText)\" md-selected-item=\"customer_data.customer_mobile\" \nmd-selected-item-change=\"vm.selectedItemChangge(customer)\" md-search-text=\"customer.searchText\" \nmd-items=\"item in vm.querySearchh(customer.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter customer mobile no\" md-autoselect=\"true\" placeholder=\"mobile no\" md-require-match \nmd-autofocus=\"true\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.customer_mobile}}</span> <span \nmd-highlight-text=\"vm.searchText\">{{item.customer_name}}</span></md-item-template><md-not-found>\nNo number matching \"{{customer.searchText}}\" were found. <a \nng-click=\"vm.showAddTableDialog($event,customer.searchText ?  customer.searchText : customer_data)\">Create a new one!\n</a></md-not-found></md-autocomplete></form><ul class=\"user-profile flex mt-24 w-100p\" \nng-if=\"customer_data.customer_mobile\"><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.NAME</div><div \nclass=\"title\">{{customer_data.customer_name}}</div></li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.EMAIL\n</div><div class=\"title\">{{customer_data.customer_email}}</div></li><li><div class=\"label\" translate>\nBILLINGS.CUSTOMER-LIST.ADDRESS</div><div class=\"title\">{{customer_data.customer_address}}</div></li><li><div \nclass=\"label\" translate>BILLINGS.CUSTOMER-LIST.LOCALITY</div><div class=\"title\"><span>\n{{customer_data.customer_locality}}</span></div></li><li><div class=\"label\" translate>BILLINGS.CUSTOMER-LIST.CITY</div>\n<div class=\"title\"><span>{{customer_data.customer_city}}</span></div></li></ul></div></div>");
$templateCache.put("app/main/cashier/odc-bill/new-odc-bill/odc-info/odc-info.html","<div class=\"newbill m-w-720 w-100p layout-fill small no-error\" style=\"position: relative\"><div id=\"bod\"><div id=\"head\">\n<div flex-none layout=\"column\" layout-align=\"start start\"><div layout=\"row\" class=\"mb-8 mt-8\"><div flex-none \nclass=\"form-label w-100\" translate>ODC.TYPE</div><md-radio-group class=\"layout-row\" id=\"radio-focus\" \nng-model=\"vm.expense.sales_dietType\" id=\"myselector\"><md-radio-button ng-repeat=\"category in vm.odcType\" \nvalue=\"{{category.label}}\" class=\"md-accent\" ng-click=\"hello\" required>{{category.label}}</md-radio-button>\n</md-radio-group></div><div layout=\"row\" class=\"margin-bottom-16 mt-8\" flex><div flex-none \nclass=\"form-label mt-8 w-100\" translate>ODC.Category</div><div flex=\"50\" class=\"mr-8\"><md-input-container \nclass=\"md-accent md-block\" flex=\"100\"><md-select placeholder=\"Select\" name=\"category\" \nng-model=\"vm.expense.category_id\" class=\"md-accent\" required md-no-asterisk=\"false\" \nng-required=\"vm.expense.sales_dietType\"><md-option ng-repeat=\"mode in vm.expensecategory\" value=\"{{mode.value}}\">\n{{mode.label}}</md-option></md-select></md-input-container></div><div flex=\"50\" class=\"mr-8\"><md-input-container \nclass=\"md-accent md-block ml-8\" flex=\"100\" ng-if=\"vm.expense.sales_dietType==\'Banquet\'\"><md-select \nng-model=\"vm.expense.hall_no\" placeholder=\"Select Hall\" name=\"Banquet\" class=\"md-accent\" \nng-required=\"vm.expense.sales_dietType==\'Banquet\'\" required md-no-asterisk=\"false\"><md-option \nng-repeat=\"mode in vm.hall_no\" value=\"{{mode.BanquetHallID}}\">{{mode.BanquetHallName}}</md-option></md-select>\n</md-input-container></div><div flex=\"50\"><md-input-container class=\"md-accent\" md-no-float flex=\"100\"><md-select \nng-model=\"vm.billing.odc_type\" ng-change=\"odctypeChange()\" ng-init=\"vm.billing.odc_type=\'combo\'\" aria-label=\"today\" \nclass=\"md-accent\" ng-required=\"show\"><md-option value=\"combo\">Combo menu</md-option><md-option value=\"individual\">\nIndividual menu</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nclass=\"small hide-date-picker-icon spacer-8 margin-bottom-16\"><span flex-none class=\"form-label mt-8 w-100\">Event <span\n translate=\"\">ODC.Date</span></span><div class=\"layout-row\"><md-input-container class=\"md-block md-accent\" flex=\"50\">\n<md-datepicker name=\"eventDate\" ng-model=\"vm.expense.created_on\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" ng-required=\"true\"></md-datepicker>\n</md-input-container><mdp-time-picker name=\"eventTime\" mdp-auto-switch=\"true\" class=\"ml-16\" \nng-model=\"vm.billing.enterTime\" ng-required=\"vm.expense.created_on\"></mdp-time-picker></div></div></div><table \nclass=\"dataTable\" flex><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title ml-8\">\n{{\'BILLINGS.ITEMS\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"10%\" \nng-if=\"vm.billing.odc_type==\'individual\'\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"20%\" \nng-if=\"vm.billing.odc_type==\'individual\'\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"15%\" \nng-if=\"vm.billing.odc_type==\'individual\'\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.Sub Total\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"5%\"></th></tr></thead></table>\n</div><div id=\"content1\" class=\"border-right border-left\"><table class=\"dataTable\"><tbody><tr><td colspan=\"2\" \nheight=\"8\"></td></tr><tr ng-repeat=\"fmitem in vm.fmitems\"><td class=\"foodItem-auto\"><md-autocomplete \nng-class=\"{\'autodd\': $index == indx}\" class=\"md-accent no-label ml-8\" flex=\"100\" md-input-name=\"autocompleteFood\" \nmd-no-cache=\"vm.noCache\" md-search-text-change=\"searchTextChange(fmitem.searchText)\" \nmd-selected-item=\"fmitem.sales_items\" md-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" ng-keypress=\"keyPressed($event)\" \nmd-min-length=\"0\" md-require-match required md-autofocus=\"true\" md-autoselect=\"true\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.sales_items}}</span></md-item-template><div \nng-messages=\"odcBill.autocompleteFood.$error\" ng-if=\"odcBill.autocompleteFood.$touched\"><div ng-message=\"required\">\n</div></div></md-autocomplete></td><td width=\"10%\" ng-if=\"vm.billing.odc_type==\'individual\'\"><md-input-container \nmd-no-float class=\"md-accent\" flex=\"90\"><input id=\"quantity\" maxlength=\"4\" ng-keypress=\"keyPressed($event);\" \nplaceholder=\"{{ \'RESTRAUNTANT.QTY\' | translate }}\" valid-number type=\"text\" name=\"quantity\" \nng-model=\"fmitem.sales_quantity\" ng-required=\"vm.billing.odc_type==\'individual\'\"><div \nng-messages=\"newBill.quantity.$error\"><div ng-message=\"required\"></div></div></md-input-container></td><td \nng-if=\"vm.billing.odc_type==\'individual\'\" width=\"20%\"><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"90\"><input type=\"number\" name=\"quantity\" ng-keypress=\"keyPressed($event);\" ng-model=\"fmitem.salesitem_rate\" \nng-required=\"vm.billing.odc_type==\'individual\'\"><div ng-messages=\"addfoodForm.quantity.$error\"><div \nng-message=\"required\"><span>Please enter the <span translate>RESTRAUNTANT.RATE</span></span></div></div>\n</md-input-container></td><td class=\"text-black-70\" width=\"15%\" ng-if=\"vm.billing.odc_type==\'individual\'\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> {{fmitem.subitemtotal | number:2}}</td><td width=\"5%\"><a \nng-if=\"formitem == \'\'\" ng-click=\"removeRow(fmitem,$event,$index); $event.stopPropagation();\"><md-icon \nclass=\"text-black-24\" md-font-icon=\"icon icon-trash\"></md-icon></a></td></tr><tr><td colspan=\"2\" height=\"8\"></td></tr>\n</tbody></table></div><div id=\"foot\"><div class=\"m-w-780 border-right border-left qty-container\" \nng-if=\"vm.billing.odc_type==\'combo\'\"><div class=\"layout-row layout-align-start-center\"><div class=\"flex\" \nng-repeat=\"fmitem in vm.fmitemss\"><div class=\"layout-row\"><div flex=\"45\"></div><div flex=\"30\" class=\"layout-row mr-16\">\n<span class=\"form-label flex-none\">{{\'ODC.PER-ITEM-PRICE\' | translate}}</span><md-input-container \nclass=\"md-block md-accent\"><input type=\"text\" name=\"email\" aria-label=\"email\" maxlength=\"4\" valid-number \nng-model=\"fmitem.salesitem_rate\" ng-required=\"vm.billing.odc_type==\'combo\'\"></md-input-container></div><div flex=\"25\" \nclass=\"layout-row mr-16\"><span class=\"form-label flex-none\">{{\'ODC.TOTAL-QUANTITY\' | translate}}</span>\n<md-input-container class=\"md-block md-accent mr-8\"><input type=\"text\" name=\"quantity\" aria-label=\"email\" valid-number \nmaxlength=\"6\" ng-model=\"fmitem.sales_quantity\" ng-required=\"vm.billing.odc_type==\'combo\'\"></md-input-container></div>\n</div></div></div></div><table class=\"border-right border-left dataTable\" style=\"display: none\"><tr><td colspan=\"2\" \nheight=\"16\"></td></tr><tr ng-repeat=\"fmitem in vm.fmitemss\"><td><div class=\"layout-row layout-align-start-center\"><div \nclass=\"flex\"><div class=\"layout-row\"><div flex=\"40\"></div><md-input-container class=\"md-block md-accent mr-8\" \nflex=\"35\" style=\"margin-right: 8px\"><label for=\"email\" aria-label=\"today\">{{\'ODC.PER-ITEM-PRICE\' | translate}} ₹\n</label><input type=\"text\" name=\"email\" aria-label=\"todays\" maxlength=\"8\" valid-number \nng-model=\"fmitem.salesitem_rate\"></md-input-container><md-input-container class=\"md-accent\" flex=\"25\"><label \nfor=\"email\">{{\'ODC.TOTAL-QUANTITY\' | translate}}</label><input type=\"text\" aria-label=\"email\" name=\"quantity\" \nvalid-number maxlength=\"4\" ng-model=\"fmitem.sales_quantity\"><div ng-messages=\"odcBill.quantity.$error\"><div \nng-message=\"required\"></div></div></md-input-container></div></div></div></td><td></td></tr><tr><td colspan=\"2\" \nheight=\"8\"></td></tr></table><div class=\"fix-bottom\"><div class=\"main-total-box m-w-780 border-right border-left\"><div \nclass=\"layout-row layout-align-start-center\"><div flex class=\"font-size-px-13 ml-8\"><a \nng-click=\"OpenPermission = !OpenPermission; focusdiscount();\" ng-show=\"!OpenPermission\">\nAdd {{\'BILLINGS.DISCOUNT\' | translate}}</a> <a ng-click=\"OpenCharge = !OpenCharge;focusaddCharge()\" class=\"ml-16\" \nng-show=\"!OpenCharge\">Add Additional Charge</a></div><div class=\"tag flex-20\">{{\'BILLINGS.Sub Total\' | translate}}\n</div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.billing.subTotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-2\" \nng-if=\"(vm.settings.global_tax&&vm.taxs[0].taxRate)||(vm.settings.global_tax&&vm.taxs[1].taxRate)\"><div \nclass=\"tag flex\">\n{{\'BILLINGS.CGST\' | translate}}({{vm.taxs[0].taxRate}}%) {{ vm.billing.tax | number:2}} + {{\'BILLINGS.SGST\' | translate}}({{vm.taxs[1].taxRate}}%) {{ vm.billing.tax_sgst | number:2}}\n</div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ vm.billing.tax + vm.billing.tax_sgst | number:2}}</span>\n</div></div><div class=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" \nng-show=\"OpenCharge\"><div class=\"flex\"></div><div class=\"tag flex md-accent spacer-8 flex-45\" layout=\"row\"><div flex \nlayout=\"row\"><md-icon class=\"cursor-pointer mr-8\" md-font-icon=\"icon icon-close-circle s16 text-black-30\" \ntitle=\"Remove\" ng-click=\"OpenCharge = !OpenCharge; clearCharge()\"></md-icon><span class=\"mt-10 mr-8\">Additional Charge\n</span></div><div flex><md-input-container md-no-float class=\"md-accent\" flex=\"60\"><input id=\"additional_charge-focus\" \naria-label=\"today\" placeholder=\"\" maxlength=\"6\" type=\"number\" class=\"ml-8\" ng-keypress=\"onlynumber($event);\" \nname=\"dis\" ng-change=\"dataChange()\" ng-model=\"vm.billing.additional_charge\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.billing.additional_charge | number:2}}</span></div></div>\n<div class=\"layout-row layout-align-start-center mt-2 extra-small spacer-8 pos-discount\" ng-show=\"OpenPermission\"><div \nclass=\"flex\"></div><div class=\"tag flex md-accent spacer-8 flex-45\" layout=\"row\"><div flex layout=\"row\"><md-icon \nclass=\"cursor-pointer mr-8\" md-font-icon=\"icon icon-close-circle s16 text-black-30\" title=\"Remove\" \nng-click=\"OpenPermission = !OpenPermission; clearDis()\"></md-icon><span class=\"mt-10 mr-8\">\n{{\'BILLINGS.DISCOUNT\' | translate}}</span></div><div class=\"mr-8\" flex><md-input-container class=\"md-accent mr-8\" \nmd-no-float flex=\"40\"><md-select ng-model=\"vm.billing.discount_type\" aria-label=\"today\" ng-change=\"dataChange()\" \nng-init=\"vm.billing.discount_type=\'amount\'\" class=\"md-accent\" ng-required=\"show\"><md-option value=\"amount\"><span \ntranslate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></md-option><md-option value=\"percent\">%</md-option>\n</md-select></md-input-container><md-input-container md-no-float class=\"md-accent\" flex=\"60\" \nng-if=\"vm.billing.discount_type==\'amount\'\"><input id=\"discount-focus\" ng-keypress=\"onlynumber($event)\" \nplaceholder=\"amount\" type=\"number\" class=\"ml-8\" max=\"{{vm.billing.roundtotal + vm.billing.discount}}\" name=\"dis\" \nng-change=\"dataChange()\" ng-model=\"vm.billing.discount\"></md-input-container><md-input-container md-no-float \nclass=\"md-accent\" flex=\"60\" ng-if=\"vm.billing.discount_type==\'percent\'\"><input id=\"discount-focus\" \nng-keypress=\"onlynumber($event)\" placeholder=\"percentage\" type=\"number\" class=\"ml-8\" max=\"100\" name=\"dis\" \nng-change=\"dataChange()\" ng-model=\"vm.billing.discount\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.billing.discount_type==\'amount\') ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2)}}\n</span></div></div><div class=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}\n</div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{ vm.billing.roundtotal }}</span></div></div>\n</div></div><div class=\"receipt-border border-right border-left\"></div></div></div></div>");
$templateCache.put("app/main/cashier/odc-bill/new-odc-bill/payment/payment.html","<div class=\"m-w-584\"><div class=\"font-size-16 font-weight-500 text-italic mb-16\"><span ng-if=\"params.id\">\nOrder No. {{params.id}}</span></div><div class=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div \nclass=\"layout-row layout-align-start-center\"><div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.billing.subTotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.CGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ vm.billing.tax | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.SGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{ vm.billing.tax_sgst | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.billing.discount_type==\'amount\') ? (vm.billing.discount | number:2) : (vm.billing.discount_percent | number:2)}}\n</span></div></div><div class=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}\n</div><div class=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{ vm.billing.roundtotal}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div><div class=\"m-w-584 mt-32\"><span \nclass=\"secondary-text\">Select the <span translate>BILLINGS.PAYMENT</span> Details *</span><div \nclass=\"border-top border-bottom p-8 mb-16 mt-8\"><md-radio-group class=\"layout-row margin-bottom-10 margin-top-8\" \nng-click=\"clear_advancePaid()\" name=\"payment_details\" ng-model=\"vm.expayment.payment_status\" required><md-radio-button \nng-repeat=\"mode in vm.payment\" value=\"{{mode.value}}\" class=\"md-accent\">{{mode.name}}</md-radio-button>\n</md-radio-group></div><div flex-none layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nclass=\"mt-8 hide-date-picker-icon\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Date</div><md-input-container class=\"md-block md-accent\" flex=\"100\">\n<md-datepicker name=\"paid_date\" ng-model=\"vm.expayment.paid_date\" md-min-date=\"minDate\" md-max-date=\"maxDate\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" ng-required=\"true\"></md-datepicker>\n</md-input-container></div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div \nflex-none class=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex md-no-float>\n<md-select ng-model=\"vm.expayment.payment_type\" name=\"amountType\" placeholder=\"Select\" class=\"md-accent\" required=\"\">\n<md-option ng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" class=\"mt-8\" \nng-if=\"vm.expayment.payment_status == \'advance paid\'\" ng-click=\"clear_fullyPaid()\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Amount <span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></div>\n<md-input-container md-no-float class=\"md-accent md-block\" flex=\"40\"><input placeholder=\"Amount (₹)\" type=\"text\" \nname=\"received_amount\" ng-model=\"vm.expayment.received_amount\" required></md-input-container><span \nclass=\"balance-color mt-8\" ng-if=\"vm.expayment.received_amount\">\nBal (₹) {{ vm.billing.roundtotal - vm.expayment.received_amount}}</span></div><div layout=\"row\" class=\"mt-8\" \nng-if=\"vm.expayment.payment_status == \'advance paid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Mode</div>\n<md-input-container class=\"md-accent\" flex md-no-float><md-select ng-model=\"vm.expayment.payment_type\" \nname=\"amountType\" class=\"md-accent\" placeholder=\"Select\" required=\"\"><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'fully paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'advance paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.TRANSCATION\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"100\"><input placeholder=\"{{\'BILLINGS.TRANSCATION\' | translate}}\" \ntype=\"text\" name=\"transcation_no\" ng-model=\"vm.expayment.transcation_no\"></md-input-container></div><div layout=\"row\" \nclass=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.CHEQUE-NO\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.CHEQUE-NO\' | translate}}\" type=\"text\" \nng-model=\"vm.expayment.cheque_no\"></md-input-container></div><div layout=\"row\" class=\"mt-16 flex\" \nng-if=\"vm.expayment.payment_status == \'unpaid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Notes</div>\n<md-input-container class=\"md-block md-accent\" md-no-float><label>Enter the notes</label><textarea \nng-model=\"vm.expayment.note\" rows=\"1\"></textarea></md-input-container></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/cashier/billing/newbill/customer/dialog/add_customer_dialog.html","<md-dialog aria-label=\"Diet-in\" class=\"flex m-w-530 h-600 layout-column\" id=\"hello\"><md-dialog-content \nclass=\"flex layout-column\"><div class=\"flex-none\"><h2 class=\"md-title margin-top-0 mb-32 ml-8\">{{vm.title}} Customer\n</h2></div><div class=\"layout-column medium\"><form name=\"CustomerInfo\" eopd-enter=\"{{ngSubmits}}_customer(customer)\">\n<div layout=\"row\" class=\"mr-16\"><md-input-container class=\"md-block md-accent mr-16\" flex=\"50\"><label translate=\"\">\nBILLINGS.CUSTOMER-LIST.MOBILE</label><input type=\"text\" name=\"mobile\" ng-model=\"customer.customer_mobile\" valid-number \nmaxlength=\"10\" ng-minlength=\"{{number.name.minlength}}\" ng-maxlength=\"{{number.name.maxlength}}\" required \nautofocus=\"true\" id=\"customerMobileNo\" next-on-enter><div \nng-messages=\"CustomerInfo.number.$dirty || CustomerInfo.number.$error\" role=\"alert\" multiple=\"multiple\"><span \nng-show=\"CustomerInfo.number.$error.minlength\">Please enter minimum 10 numbers!</span> <span \nng-show=\"CustomerInfo.number.$error.maxlength\">Please enter maximum 12 numnbers!</span></div></md-input-container>\n</div><div layout=\"row\" class=\"mt-8\"><div flex class=\"mr-16\"><md-input-container class=\"md-accent md-block\"><label \ntranslate=\"\">BILLINGS.CUSTOMER-LIST.NAME</label><input type=\"text\" name=\"name\" ng-model=\"customer.customer_name\" \nmaxlength=\"60\" ng-minlength=\"{{user.name.minlength}}\" ng-maxlength=\"{{user.name.maxlength}}\" \nng-required=\"customer.customer_mobile\" class=\"keydown\" next-on-enter><div \nng-messages=\"CustomerInfo.name.$dirty || CustomerInfo.name.$error\" role=\"alert\" multiple=\"multiple\"><span \nng-show=\"CustomerInfo.name.$error.minlength\">Please enter minimum 3 characters!</span> <span \nng-show=\"CustomerInfo.name.$error.maxlength\">Please enter maximum 60 characters!</span></div></md-input-container>\n</div><div flex=\"50\" ng-if=\"vm.settings.show_customer_email\"><md-input-container class=\"md-block md-accent\"><label \nfor=\"email\" translate=\"\">BILLINGS.CUSTOMER-LIST.EMAIL</label><input type=\"email\" name=\"email\" \nng-model=\"customer.customer_email\" ng-pattern=\"/^.+@.+\\..+$/\" next-on-enter><div ng-messages=\"addUser.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>Please enter the valid e-mail address</span></div>\n</div></md-input-container></div></div><div layout=\"row\" class=\"mt-8\"><div flex=\"100\" class=\"mr-16\"><md-input-container\n class=\"md-block md-accent\"><label translate=\"\">BILLINGS.CUSTOMER-LIST.ADDRESS</label><textarea \nng-model=\"customer.customer_address\" max-rows=\"5\" class=\"mr-16\" autocomplete=\"off\" next-on-enter></textarea>\n</md-input-container></div></div><div layout=\"row\" class=\"mt-8\"><div flex class=\"foodItem-auto\"><md-autocomplete \nclass=\"md-accent\" flex=\"100\" md-no-cache=\"vm.noCache\" md-search-text-change=\"searchTextChange(fmitem.searchText)\" \nmd-selected-item=\"customer.localityName\" md-search-text=\"fmitem.searchText\" \nmd-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"{{ \'BILLINGS.CUSTOMER-LIST.LOCALITY\' | translate}}\" md-min-length=\"0\" \nng-required=\"{{vm.settings.req_locality}}\" md-require-match md-autoselect=\"true\" next-on-enter><md-item-template \nclass=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">{{item.localityName}}</span></md-item-template><div \nng-messages=\"newBill.autocompleteFood.$error\" ng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You \n<b>must</b> enter a <span translate>RESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">\nPlease select an existing <span translate>RESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete></div><div \nflex=\"50\" class=\"pl-16\" ng-if=\"vm.settings.show_customer_city\"><md-input-container class=\"md-block md-accent\"><label \ntranslate=\"\">BILLINGS.CUSTOMER-LIST.CITY</label><input type=\"text\" ng-model=\"customer.customer_city\">\n</md-input-container></div></div><div layout=\"row\" class=\"mt-8\"><div flex=\"100\" class=\"mr-16\" layout=\"column\">\n<md-checkbox ng-model=\"customer.whatsapp\" ng-true-value=\"1\" ng-false-value=\"0\">Whatsapp No.</md-checkbox><span \nclass=\"secondary-text md-block ml-32 mb-24 mtm-16\">It is useful to send message in whatsapp</span></div></div></form>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><a ng-click=\"closeDialog()\" \nclass=\"md-accent md-button md-default-theme md-ink-ripple disable-button\">Cancel</a><md-button \nng-if=\"!customer.customer_id\" class=\"md-accent\" ng-disabled=\"CustomerInfo.$invalid\" \nng-click=\"submit_customer(customer)\">Submit</md-button><md-button ng-if=\"customer.customer_id\" class=\"md-accent\" \nng-disabled=\"CustomerInfo.$invalid\" next-on-enter ng-click=\"update_customer(customer)\">Update</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/cashier/inventory/raw-material/add-purchase_order/purchaseorder-info/add_purchase.html","<div class=\"newbill w-100p layout-fill min-height-100 small no-error\" layout=\"row\" style=\"position: relative\"><div \nclass=\"m-w-720\"><div id=\"bod\" class=\"m-w-720\"><div id=\"head\" class=\"mb-24 m-w-640\"><div layout=\"row\" class=\"medium\">\n<div flex-none class=\"form-label w-100 mt-10\">{{\'EXPENSE.vendor\' | translate}}</div><md-autocomplete \nmd-input-name=\"autocompleteVendor\" class=\"md-accent no-label ml-8\" flex=\"60\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"vm.purchase.vendor_name\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-autoselect=\"true\" md-min-length=\"0\" \nmd-require-match required><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.vendor_name}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You <b>must</b> enter a <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">Please select an existing <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><md-button class=\"md-accent md-icon-button ml-4\" \nng-click=\"vm.showAddTableDialogs($event)\" flex-none title=\"Add New Vendor\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16\" class=\"mr-8\"></md-icon></md-button></div><div layout=\"row\" class=\"mt-8\"><div \nflex-none class=\"form-label mt-8 w-100\">{{\'BILLINGS.STATUS\' | translate}}</div><div flex=\"60\" layout=\"row\">\n<md-input-container class=\"md-accent\" flex><md-select ng-model=\"vm.purchase.status\" ng-disabled=\"disable_state\" \nng-change=\"changestatus()\" name=\"status\" md-no-float placeholder=\"Select\" class=\"md-accent\" ng-required=\"true\">\n<md-option ng-repeat=\"mode in  vm.orderstatus\" value=\"{{mode.status}}\" selected=\"vm.purchase.selectOrdered\">\n{{mode.value}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nclass=\"hide-date-picker-icon spacer-8 mt-16\" ng-if=\"vm.purchase.status==\'delivered\'\"><span flex-none \nclass=\"form-label mt-8 w-100\">Delivery {{\'ODC.Date\' | translate}}</span><div flex layout=\"row\"><md-input-container \nclass=\"md-block md-accent\"><md-datepicker name=\"eventDate\" ng-model=\"vm.purchase.DeliveryDate\" class=\"md-accent\" \nmd-placeholder=\"{{placeholderstatus}}\"></md-datepicker></md-input-container></div></div></div><div \nid=\"purchaserawmaterial\" style=\"display: none\"><span style=\"color: blue\">\n{{\'Inventory.PURCHASED-NO\' | translate}}-{{purchase_order_id}}</span><br><span style=\"color: blue\">\nExport Time-{{ReportTime | date:\'medium\'}}</span><br><span style=\"color: blue\">\n{{\'Inventory.DeliveryDate\' | translate}}-{{vm.purchase.DeliveryDate | date}}</span><br><span style=\"color: blue\">\n{{\'BILLINGS.Sub Total\' | translate}}-{{vm.exitems.subtotal | number:2}}</span><br><span style=\"color: blue\">\nApproximate Total-{{vm.exitems.total_amount | number:2}}</span><br><table class=\"dataTable\"><thead><tr><th \nclass=\"secondary-text\" width=\"45%\">{{\'BILLINGS.ITEMS\' | translate}}</th><th class=\"secondary-text\" width=\"15%\">\n{{\'BILLINGS.QTY\' | translate}}</th><th class=\"secondary-text\" width=\"10%\">containQty</th><th class=\"secondary-text\" \nwidth=\"10%\">{{\'BILLINGS.RATE\' | translate}}</th><th class=\"secondary-text\" width=\"20%\">\n{{\'BILLINGS.Sub Total\' | translate}}</th></tr></thead><tr ng-repeat=\"rmPurchasedOrder in vm.exitems\"><td>\n{{ rmPurchasedOrder.rmname.rmname ? rmPurchasedOrder.rmname.rmname : rmPurchasedOrder.rmname }}</td><td>\n{{rmPurchasedOrder.quantity}}</td><td>{{ rmPurchasedOrder.containQty }}</td><td>{{rmPurchasedOrder.rmrate}}</td><td>\n{{rmPurchasedOrder.item_subtotal}}</td></tr></table></div><div id=\"editor\"></div><div id=\"content1\" \nclass=\"border-right border-left bill-info-food-list-wrapper\"><table class=\"dataTable\"><thead><tr><th \nclass=\"secondary-text\" width=\"45%\"><div class=\"table-header layout-row\"><span class=\"flex ml-8\">\n{{\'BILLINGS.ITEMS\' | translate}}</span> <a href=\"#\" ng-click=\"vm.showAddTableDialog($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16 md-accent\" class=\"mr-16\" title=\"Add New {{\'BILLINGS.ITEM\' | translate}}\"></md-icon>\n</a></div></th><th class=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"17%\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"15%\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th><th \nclass=\"secondary-text\" width=\"8%\"></th></tr></thead><tbody><tr><td colspan=\"5\" height=\"12\"></td></tr><tr \nng-repeat=\"fmitem in vm.exitems\"><td width=\"45%\" class=\"foodItem-auto\"><div layout=\"row\"><md-autocomplete \nng-class=\"{\'autodd\': $index == indx}\" md-input-id=\"auto\" class=\"md-accent no-label ml-8\" flex=\"100\" \nmd-input-name=\"autocompleteFood\" md-no-cache=\"vm.noCache\" md-search-text-change=\"searchTextChange(fmitem.searchText)\" \nmd-selected-item=\"fmitem.rmname\" md-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" \nng-keypress=\"keyPressed($event)\" md-search-text=\"fmitem.searchText\" \nmd-items=\"item in vm.querySearchrm(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-min-length=\"0\" md-autoselect=\"true\" \nmd-autofocus=\"true\" md-require-match required><md-item-template class=\"md-accent\"><span \nmd-highlight-text=\"fmitem.searchText\">{{item.rmname}}</span></md-item-template><div \nng-messages=\"newBill.autocompleteFood.$error\" ng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You \n<b>must</b> enter a <span translate>RESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">\nPlease select an existing <span translate>RESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><span \nng-if=\"fmitem.containQty\" flex-none class=\"piece-contain\">{{fmitem.containQty}} {{fmitem.unit}} contain</span></div>\n</td><td width=\"15%\"><md-input-container md-no-float class=\"md-accent md-block\" flex=\"90\"><input \nplaceholder=\"{{ \'RESTRAUNTANT.QUANTITY\' | translate }}\" ng-keypress=\"keyPressed($event)\" type=\"text\" valid-number \nname=\"quantity\" maxlength=\"4\" ng-model=\"fmitem.quantity\" required><div ng-messages=\"addfoodForm.quantity.$error\"><div \nng-message=\"required\"><span>Please enter the <span translate>RESTRAUNTANT.QUANTITY</span></span></div></div>\n</md-input-container></td><td width=\"17%\"><md-input-container md-no-float class=\"md-accent md-block\" flex=\"90\"><input \ntype=\"text\" name=\"rate\" maxlength=\"8\" aria-label=\"email\" valid-number ng-model=\"fmitem.rmrate\" \nng-keypress=\"keyPressed($event)\" required><div ng-messages=\"addfoodForm.quantity.$error\"><div ng-message=\"required\">\n<span>Please enter the <span translate>RESTRAUNTANT.RATE</span></span></div></div></md-input-container></td><td \nclass=\"text-black-70\" width=\"15%\"><span translate class=\"grey-col-sec-text pr-2\" ng-if=\"subtotalss\" \nng-model=\"$parent.subtotals\">BILLINGS.INR</span> {{fmitem.quantity * fmitem.rmrate}}</td><td width=\"8%\"><md-button \nng-if=\"formitem == \'\'\" class=\"md-icon-button margin-0-force small-button\" aria-label=\"Delete\" \nng-click=\"removeRow(fmitem,$event,$index)\"><md-icon class=\"text-black-40\" md-font-icon=\"icon icon-trash\"></md-icon>\n</md-button></td></tr><tr><td colspan=\"5\" height=\"24\"></td></tr></tbody></table></div><div id=\"foot\"><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div flex class=\"font-size-px-13 ml-8\"><a ng-click=\"OpenTax = !OpenTax;focustax()\" ng-show=\"!OpenTax\" \nng-model=\"defaultopen\">Add {{\'BILLINGS.TAX\' | translate}}</a>&nbsp;&nbsp; <a \nng-click=\"OpenPermission = !OpenPermission;focusdiscount()\" ng-show=\"!OpenPermission\" class=\"ml-16\">Add discount</a>\n</div><div class=\"tag flex-20\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center spacer-8\" ng-show=\"OpenTax\" ng-show=\"OpenPermission\"><div class=\"flex\">\n</div><div class=\"tag flex md-accent spacer-8 flex-80\" layout=\"row\"><div flex=\"50\" layout=\"row\" class=\"mr-8\"><div flex>\n<md-icon class=\"cursor-pointer\" md-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4 mt-8\" title=\"Remove\" \nng-hide=\"hideclose\" ng-click=\"OpenTax = !OpenTax; clrTax()\"></md-icon></div><div flex=\"35\"><md-input-container \nclass=\"md-accent\"><md-select ng-model=\"vm.exitems.tax_status\" \nng-init=\"!params.id ? vm.exitems.tax_status=\'exclude\' : \'\'\" ng-change=\"dataChange()\" name=\"status\" \nplaceholder=\"Select\" class=\"md-accent\" ng-required=\"true\"><md-option ng-repeat=\"mode in  vm.purchaseTax_status\" \nvalue=\"{{mode.value}}\">{{mode.label}}</md-option></md-select></md-input-container></div><div flex=\"35\">\n<md-input-container class=\"md-accent\" md-no-float><md-select ng-model=\"vm.exitems.tax_type\" aria-label=\"email\" \nng-init=\"!params.id ? vm.exitems.tax_type=\'percent\' : \'\'\" ng-change=\"dataChange()\" class=\"md-accent\" \nng-required=\"show\"><md-option value=\"amount\"><span translate>BILLINGS.INR</span></md-option><md-option value=\"percent\">\n%</md-option></md-select></md-input-container></div></div><div flex=\"25\" layout=\"row\"><span class=\"mt-12 mr-8\">\n{{\'BILLINGS.CGST\' | translate}}(%)</span><md-input-container md-no-float class=\"md-accent\"><input placeholder=\"\" \nid=\"tax-focus\" maxlength=\"{{vm.exitems.tax_type==\'percent\' ? \'2\' : \'\'}}\" valid-number type=\"text\" aria-label=\"email\" \nname=\"quantitys\" ng-change=\"dataChange()\" ng-model=\"vm.exitems.tax_cgst\"></md-input-container></div><div flex=\"25\" \nlayout=\"row\"><span class=\"mt-12 mr-8\">{{\'BILLINGS.SGST\' | translate}}(%)</span><md-input-container md-no-float \nclass=\"md-accent\"><input placeholder=\"\" id=\"taxSgst-focus\" maxlength=\"{{vm.exitems.tax_type==\'percent\' ? \'2\' : \'\'}}\" \nvalid-number type=\"text\" name=\"quantitys\" ng-change=\"dataChange()\" aria-label=\"email\" ng-model=\"vm.exitems.tax_sgst\">\n</md-input-container></div></div><div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\">\n<span translate class=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.taxamount | number:2}}</span>\n</div></div><div class=\"layout-row layout-align-start-center small spacer-8\" ng-show=\"OpenPermission\"><div \nclass=\"flex\"></div><div class=\"tag flex md-accent spacer-8 flex-40\" layout=\"row\"><div flex layout=\"row\"><md-icon \nclass=\"cursor-pointer\" md-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4\" title=\"Remove\" ng-hide=\"hideclose\" \nng-click=\"OpenPermission = !OpenPermission; clearDis()\"></md-icon><span class=\"mt-10 mr-8\">\n{{\'BILLINGS.DISCOUNT\' | translate}}</span></div><div class=\"mr-8\" flex><md-input-container md-no-float \nclass=\"md-accent\"><input id=\"discount-focus\" max=\"{{vm.exitems.total_amount + vm.exitems.discount}}\" placeholder=\"\" \nng-keypress=\"onlynumber($event);\" aria-label=\"email\" type=\"number\" name=\"quantitys\" ng-change=\"dataChange()\" \nng-model=\"vm.exitems.discount\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div></div></div></div>");
$templateCache.put("app/main/cashier/inventory/raw-material/add-purchase_order/raw-material-payment/payment.html","<div class=\"m-w-584\"><div class=\"font-size-16 font-weight-500 text-italic mb-16\"><span ng-if=\"params.id\">\n{{\'BILLINGS.ORDERED-NO\' | translate}}. {{params.id}}</span></div><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.CGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_cgstValue ? vm.exitems.tax_cgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.SGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_sgstValue ? vm.exitems.tax_sgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div><div class=\"m-w-584 mt-32\"><span \nclass=\"secondary-text\">Select the <span translate>BILLINGS.PAYMENT</span> Details *</span><div \nclass=\"border-top border-bottom p-8 mb-16 mt-8\"><md-radio-group class=\"layout-row margin-bottom-8 margin-top-8\" \nng-click=\"clear_advancePaid()\" ng-model=\"vm.expayment.payment_status\" name=\"payment_details\" required><md-radio-button \nng-repeat=\"mode in vm.payment\" value=\"{{mode.value}}\" class=\"md-accent\">{{mode.name}}</md-radio-button>\n</md-radio-group></div><div flex-none layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nclass=\"mt-8 hide-date-picker-icon\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Date</div><md-input-container class=\"md-block md-accent\" flex=\"50\">\n<md-datepicker ng-model=\"vm.expayment.paid_date\" name=\"paid_date\" md-min-date=\"minDates\" md-max-date=\"maxDates\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" required></md-datepicker></md-input-container>\n</div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex md-no-float><md-select \nng-model=\"vm.expayment.payment_type\" name=\"amountType\" class=\"md-accent\" placeholder=\"Select\" required><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'advance paid\'\" \nng-click=\"clear_fullyPaid()\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Amount <span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></div><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"40\"><input placeholder=\"Amount (₹)\" type=\"text\" name=\"received_amount\" ng-model=\"vm.expayment.received_amount\" \nrequired></md-input-container><span class=\"balance-color mt-8\" ng-if=\"vm.expayment.received_amount\">\nBal (₹) {{ vm.exitems.total_amount - vm.expayment.received_amount}}</span></div><div layout=\"row\" class=\"mt-8\" \nng-if=\"vm.expayment.payment_status == \'advance paid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Mode</div>\n<md-input-container class=\"md-accent\" flex ng-click=\"clear_payment()\" md-no-float><md-select \nng-model=\"vm.expayment.payment_type\" name=\"amountType\" class=\"md-accent\" placeholder=\"Select\" required><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'fully paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'advance paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.TRANSCATION\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.TRANSCATION\' | translate}}\" \ntype=\"text\" name=\"transcation_no\" ng-model=\"vm.expayment.transcation_no\"></md-input-container></div><div layout=\"row\" \nclass=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.CHEQUE-NO\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.CHEQUE-NO\' | translate}}\" type=\"text\" \nname=\"cheque_no\" ng-model=\"vm.expayment.cheque_no\"></md-input-container></div><div layout=\"row\" class=\"mt-16 flex\" \nng-if=\"vm.expayment.payment_status == \'unpaid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Notes</div>\n<md-input-container class=\"md-block md-accent\" md-no-float><label>Enter the notes</label><textarea \nng-model=\"vm.expayment.note\" rows=\"1\"></textarea></md-input-container></div></div></div>");
$templateCache.put("app/main/cashier/inventory/sale-material/add-sales_order/sale-material-payment/payment.html","<div class=\"m-w-584\"><div class=\"font-size-16 font-weight-500 text-italic mb-16\"><span ng-if=\"params.id\">\n{{\'BILLINGS.ORDERED-NO\' | translate}}. {{params.id}}</span></div><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div class=\"tag flex\">{{\'BILLINGS.Sub Total\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.CGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_cgstValue ? vm.exitems.tax_cgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">\n{{\'EXPENSE.TAX\' | translate}} {{\'BILLINGS.SGST\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{(vm.exitems.tax_sgstValue ? vm.exitems.tax_sgstValue : 0) | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center mt-4\"><div class=\"tag flex\">{{\'BILLINGS.DISCOUNT\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-30 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div><div class=\"m-w-584 mt-32\"><span \nclass=\"secondary-text\">Select the <span translate>BILLINGS.PAYMENT</span> Details *</span><div \nclass=\"border-top border-bottom p-8 mb-16 mt-8\"><md-radio-group class=\"layout-row margin-bottom-8 margin-top-4\" \nng-click=\"clear_advancePaid()\" ng-model=\"vm.expayment.payment_status\" name=\"payment_details\" required><md-radio-button \nng-repeat=\"mode in vm.payment\" value=\"{{mode.value}}\" class=\"md-accent\">{{mode.name}}</md-radio-button>\n</md-radio-group></div><div flex-none layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nclass=\"mt-8 hide-date-picker-icon\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Date</div><md-input-container class=\"md-block md-accent\" flex=\"50\">\n<md-datepicker ng-model=\"vm.expayment.paid_date\" name=\"paid_date\" md-min-date=\"minDates\" md-max-date=\"maxDates\" \nclass=\"md-accent\" md-current-view=\"day\" md-placeholder=\"Enter date\" required></md-datepicker></md-input-container>\n</div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'fully paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex><md-select \nng-model=\"vm.expayment.payment_type\" name=\"amountType\" placeholder=\"Select\" class=\"md-accent\" required><md-option \nng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">{{expayment.label}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'advance paid\'\" \nng-click=\"clear_fullyPaid()\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Paid Amount <span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span></div><md-input-container md-no-float class=\"md-accent md-block\" \nflex=\"50\"><input placeholder=\"Received {{\'BILLINGS.AMOUNT\' | translate}} (₹)\" type=\"text\" name=\"received_amount\" \nng-model=\"vm.expayment.received_amount\" required></md-input-container><span class=\"balance-color mt-8\" \nng-if=\"vm.expayment.received_amount\">Bal (₹) {{ vm.exitems.total_amount - vm.expayment.received_amount}}</span></div>\n<div layout=\"row\" class=\"mt-8\" ng-if=\"vm.expayment.payment_status == \'advance paid\'\"><div flex-none \nclass=\"form-label w-120 mr-8 mt-8\">Paid Mode</div><md-input-container class=\"md-accent\" flex \nng-click=\"clear_payment()\"><md-select ng-model=\"vm.expayment.payment_type\" placeholder=\"Select\" name=\"amountType\" \nclass=\"md-accent\" required><md-option ng-repeat=\"expayment in vm.expense_amountType\" value=\"{{expayment.value}}\">\n{{expayment.label}}</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'fully paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'card\' && vm.expayment.payment_status == \'advance paid\') || ( vm.expayment.payment_type == \'onlineTranscation\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.TRANSCATION\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.TRANSCATION\' | translate}}\" \ntype=\"text\" name=\"transcation_no\" ng-model=\"vm.expayment.transcation_no\"></md-input-container></div><div layout=\"row\" \nclass=\"mt-16\" \nng-if=\"(vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'fully paid\') || (vm.expayment.payment_type == \'cheque\' && vm.expayment.payment_status == \'advance paid\')\">\n<div flex-none class=\"form-label w-120 mr-8 mt-8\">{{\'BILLINGS.CHEQUE-NO\' | translate}}</div><md-input-container \nmd-no-float class=\"md-accent md-block\" flex=\"50\"><input placeholder=\"{{\'BILLINGS.CHEQUE-NO\' | translate}}\" type=\"text\" \nname=\"cheque_no\" ng-model=\"vm.expayment.cheque_no\"></md-input-container></div><div layout=\"row\" class=\"mt-16 flex\" \nng-if=\"vm.expayment.payment_status == \'unpaid\'\"><div flex-none class=\"form-label w-120 mr-8 mt-8\">Notes</div>\n<md-input-container class=\"md-block md-accent\" md-no-float><label>Enter the notes</label><textarea \nng-model=\"vm.expayment.note\" rows=\"1\"></textarea></md-input-container></div></div></div>");
$templateCache.put("app/main/cashier/inventory/sale-material/add-sales_order/salesorder-info/add_sales.html","<div class=\"newbill w-100p layout-fill min-height-100 small no-error\" layout=\"row\" style=\"position: relative\"><div \nclass=\"m-w-720\" style=\"width:720px\"><div id=\"bod\" class=\"m-w-720\"><div id=\"head\" class=\"m-w-640\"><div id=\"head\" \nclass=\"mb-24\"><div layout=\"row\" class=\"medium\"><div flex-none class=\"form-label w-100 mt-12\">\n{{\'EXPENSE.vendor\' | translate}}</div><md-autocomplete class=\"md-accent no-label ml-8\" \nmd-input-name=\"autocompleteVendor\" flex=\"60\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"vm.purchase.vendor_name\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearch(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-min-length=\"0\" md-autoselect=\"true\" \nmd-require-match required><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.vendor_name}}</span></md-item-template><div ng-messages=\"newBill.autocompleteFood.$error\" \nng-if=\"newBill.autocompleteFood.$touched\"><div ng-message=\"required\">You <b>must</b> enter a <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div><div ng-message=\"md-require-match\">Please select an existing <span translate>\nRESTRAUNTANT.MENU-ITEM</span></div></div></md-autocomplete><md-button class=\"md-accent md-icon-button ml-4\" \nng-click=\"vm.showAddTableDialog($event)\" flex-none title=\"Add New Vendor\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16\" class=\"mr-8\"></md-icon></md-button></div><div layout=\"row\" class=\"mt-8\"><div \nflex-none class=\"form-label mt-8 w-100\">{{\'BILLINGS.STATUS\' | translate}}</div><div flex=\"60\" layout=\"row\">\n<md-input-container class=\"md-accent\" flex><md-select ng-model=\"vm.purchase.status\" ng-disabled=\"disable_state\" \nng-change=\"changestatus()\" name=\"status\" placeholder=\"Select\" class=\"md-accent\" ng-required=\"true\"><md-option \nng-repeat=\"mode in  vm.orderstatus\" value=\"{{mode.status}}\" selected=\"vm.purchase.selectOrdered\">{{mode.value}}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nclass=\"hide-date-picker-icon spacer-8 mt-16\" ng-if=\"vm.purchase.status==\'delivered\'\"><span flex-none \nclass=\"form-label mt-8 w-100\">Delivery {{\'ODC.Date\' | translate}}</span><div flex layout=\"row\"><md-input-container \nclass=\"md-block md-accent\" ng-if=\"vm.purchase.status\" flex-none><md-datepicker name=\"eventDate\" \nng-model=\"vm.purchase.DeliveryDate\" class=\"md-accent\" md-placeholder=\"{{placeholderstatus}}\"></md-datepicker>\n</md-input-container></div></div></div></div><div id=\"purchasesalematerial\" style=\"display: none\">\n{{\'Inventory.PURCHASED-NO\' | translate}}-{{purchase_order_id}}<br>Export Time-{{ReportTime | date:\'medium\'}}<br>\n{{\'Inventory.DeliveryDate\' | translate}}-{{vm.purchase.DeliveryDate | date}}<br>\n{{\'BILLINGS.Sub Total\' | translate}}-{{vm.exitems.subtotal | number:2}}<br>\nApproximate Total-{{vm.exitems.total_amount | number:2}}<br><table><tr><th>{{\'BILLINGS.ITEMS\' | translate}}</th><th>\n{{\'BILLINGS.QTY\' | translate}}</th><th>containQty</th><th>{{\'BILLINGS.RATE\' | translate}}</th><th>\n{{\'BILLINGS.Sub Total\' | translate}}</th></tr><tr ng-repeat=\"rmPurchasedOrder in vm.exitems\"><td>\n{{ rmPurchasedOrder.smname.smname ? rmPurchasedOrder.smname.smname : rmPurchasedOrder.smname }}</td><td>\n{{rmPurchasedOrder.quantity}}</td><td>{{ rmPurchasedOrder.containQty }}</td><td>\n{{rmPurchasedOrder.smrate.smrate ? rmPurchasedOrder.smrate.smrate : rmPurchasedOrder.smrate }}</td><td>\n{{rmPurchasedOrder.item_subtotal}}</td></tr></table></div><div id=\"editor\"></div><div id=\"content1\" \nclass=\"border-right border-left bill-info-food-list-wrapper\"><table class=\"dataTable\"><thead><tr><th \nclass=\"secondary-text order-item\" width=\"45%\"><div class=\"table-header layout-row\"><span class=\"ml-8\" flex>\n{{\'BILLINGS.ITEMS\' | translate}}</span> <a href=\"#\" ng-click=\"vm.showAddTableDialogs($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-plus-circle s16 md-accent\" class=\"mr-16\" title=\"Add New {{\'BILLINGS.ITEM\' | translate}}\"></md-icon>\n</a></div></th><th class=\"secondary-text\" width=\"15%\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'BILLINGS.QTY\' | translate}}</span></div></th><th class=\"secondary-text\" width=\"17%\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'BILLINGS.RATE\' | translate}}</span></div></th><th class=\"secondary-text hidebelow600\" \nwidth=\"15%\"><div class=\"table-header\"><span class=\"column-title\">{{\'BILLINGS.Sub Total\' | translate}}</span></div></th>\n<th class=\"secondary-text\" width=\"8%\"></th></tr></thead><tbody><tr><td colspan=\"5\" height=\"12\"></td></tr><tr \nng-repeat=\"fmitem in vm.exitems\"><td width=\"45%\" class=\"foodItem-auto order-item\" \nng-if=\"vm.branchFilterData[0].barcode_enable == 1\"><div layout=\"row\"><md-autocomplete \nng-class=\"{\'autodd\': $index == indx}\" md-input-name=\"autocompleteFood\" md-input-name=\"autocompleteFood\" \nclass=\"md-accent no-label ml-8\" flex=\"100\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.smname\" \nmd-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" ng-keypress=\"barcodekeyPressed($event)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearchrm(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-autofocus=\"true\" md-autoselect=\"true\" \nmd-require-match required><md-item-template class=\"md-accent\"><span md-highlight-text=\"fmitem.searchText\">\n{{item.smname}}</span></md-item-template><div ng-messages=\"addfoodForm.autocompleteFood.$error\" \nclass=\"hideerrormessage\"><div ng-message=\"required\">You <b>must</b> enter a</div><div ng-message=\"md-require-match\">\nPlease select an existing</div></div></md-autocomplete><span ng-if=\"fmitem.containQty\" flex-none \nclass=\"piece-contain hidebelow600\">{{fmitem.containQty}} item contain</span></div></td><td width=\"45%\" \nclass=\"foodItem-auto\" ng-if=\"vm.branchFilterData[0].barcode_enable != 1\"><div layout=\"row\"><md-autocomplete \nng-class=\"{\'autodd\': $index == indx}\" md-input-name=\"autocompleteFood\" md-input-name=\"autocompleteFood\" \nclass=\"md-accent no-label ml-8\" flex=\"100\" md-no-cache=\"vm.noCache\" \nmd-search-text-change=\"searchTextChange(fmitem.searchText)\" md-selected-item=\"fmitem.smname\" \nmd-selected-item-change=\"vm.selectedItemChange($index,fmitem)\" ng-keypress=\"keyPressed($event)\" \nmd-search-text=\"fmitem.searchText\" md-items=\"item in vm.querySearchrm(fmitem.searchText)\" md-item-text=\"item.display\" \nmd-floating-label=\"Enter the {{ \'RESTRAUNTANT.MENU-ITEM\' | translate}}\" md-autofocus=\"true\" md-autoselect=\"true\" \nmd-min-length=\"0\" md-require-match required><md-item-template class=\"md-accent\"><span \nmd-highlight-text=\"fmitem.searchText\">{{item.smname}}</span></md-item-template><div \nng-messages=\"addfoodForm.autocompleteFood.$error\" class=\"hideerrormessage\"><div ng-message=\"required\">You <b>must</b>\n enter a</div><div ng-message=\"md-require-match\">Please select an existing</div></div></md-autocomplete><span \nng-if=\"fmitem.containQty\" flex-none class=\"piece-contain hidebelow600\">{{fmitem.containQty}} item contain</span></div>\n</td><td width=\"15%\"><md-input-container md-no-float class=\"md-accent md-block\" flex=\"90\"><input \nplaceholder=\"{{ \'RESTRAUNTANT.QUANTITY\' | translate }}\" type=\"text\" maxlength=\"4\" class=\"qty\" \nng-keypress=\"keyPressed($event)\" valid-number name=\"quantity\" ng-model=\"fmitem.quantity\" required><div \nng-messages=\"addfoodForm.quantity.$error\" class=\"hideerrormessage\"><div ng-message=\"required\"><span>Please enter the \n<span translate>RESTRAUNTANT.QUANTITY</span></span></div></div></md-input-container></td><td width=\"17%\">\n<md-input-container md-no-float class=\"md-accent md-block\" flex=\"90\"><input type=\"text\" name=\"rate\" maxlength=\"8\" \nvalid-number ng-keypress=\"keyPressed($event)\" aria-label=\"email\" ng-model=\"fmitem.smrate\" required><div \nng-messages=\"addfoodForm.rate.$error\" class=\"hideerrormessage\"><div ng-message=\"required\"><span>Please enter the <span \ntranslate>RESTRAUNTANT.RATE</span></span></div></div></md-input-container></td><td class=\"text-black-70 hidebelow600\" \nwidth=\"15%\"><span translate class=\"grey-col-sec-text pr-2\" ng-if=\"subtotalss\" ng-model=\"$parent.subtotals\">BILLINGS.INR\n</span> {{fmitem.quantity * fmitem.smrate}}</td><td width=\"8%\"><md-button ng-if=\"formitem == \'\'\" \nclass=\"md-icon-button margin-0-force small-button\" aria-label=\"Delete\" ng-click=\"removeRow(fmitem,$event,$index)\">\n<md-icon class=\"text-black-40\" md-font-icon=\"icon icon-trash\"></md-icon></md-button></td></tr><tr><td colspan=\"5\" \nheight=\"24\"></td></tr></tbody></table></div><div id=\"foot\"><div \nclass=\"main-total-box border-top mb-0 mt-0 border-right border-left\"><div class=\"layout-row layout-align-start-center\">\n<div flex class=\"font-size-px-13 ml-8\"><a ng-click=\"OpenTax = !OpenTax;focustax()\" ng-show=\"!OpenTax\" \nng-model=\"defaultopen\">Add {{\'BILLINGS.TAX\' | translate}}</a>&nbsp;&nbsp; <a \nng-click=\"OpenPermission = !OpenPermission;focusdiscount()\" ng-show=\"!OpenPermission\" class=\"ml-16\">\nAdd {{\'BILLINGS.DISCOUNT\' | translate}}</a></div><div class=\"tag flex-20\">{{\'BILLINGS.Sub Total\' | translate}}</div>\n<div class=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.subtotal | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center spacer-8\" ng-show=\"OpenTax\" ng-show=\"OpenPermission\"><div class=\"flex\">\n</div><div class=\"tag flex md-accent spacer-8 flex-80 taxcontainer\" layout=\"row\"><div flex=\"50\" layout=\"row\" \nclass=\"mr-8\"><div flex><md-icon class=\"cursor-pointer\" \nmd-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4 mt-8\" title=\"Remove Tax\" ng-hide=\"hideclose\" \nng-click=\"OpenTax = !OpenTax; clrTax()\"></md-icon></div><div flex=\"35\" class=\"hidebelow600\"><md-input-container \nclass=\"md-accent\"><md-select ng-model=\"vm.exitems.tax_status\" \nng-init=\"!params.id ? vm.exitems.tax_status=\'exclude\' : \'\'\" ng-change=\"dataChange()\" name=\"status\" \nplaceholder=\"Select\" class=\"md-accent\" ng-required=\"true\"><md-option ng-repeat=\"mode in  vm.purchaseTax_status\" \nvalue=\"{{mode.value}}\">{{mode.label}}</md-option></md-select></md-input-container></div><div flex=\"35\" \nclass=\"hidebelow600\"><md-input-container class=\"md-accent\" md-no-float><md-select ng-model=\"vm.exitems.tax_type\" \naria-label=\"email\" ng-init=\"!params.id ? vm.exitems.tax_type=\'percent\' : \'\'\" ng-change=\"dataChange()\" \nclass=\"md-accent\" ng-required=\"show\"><md-option value=\"amount\"><span translate>BILLINGS.INR</span></md-option>\n<md-option value=\"percent\">%</md-option></md-select></md-input-container></div></div><div flex=\"25\" layout=\"row\"><span \nclass=\"mt-12 mr-8 hidebelow600\">{{\'BILLINGS.CGST\' | translate}}(%)</span><md-input-container md-no-float \nclass=\"md-accent\"><input placeholder=\"{{\'BILLINGS.CGST\' | translate}}(%)\" id=\"tax-focus\" aria-label=\"email\" \nmaxlength=\"{{vm.exitems.tax_type==\'percent\' ? \'2\' : \'\'}}\" valid-number type=\"text\" name=\"quantitys\" \nng-change=\"dataChange()\" ng-model=\"vm.exitems.tax_cgst\"></md-input-container></div><div flex=\"25\" layout=\"row\"><span \nclass=\"mt-12 mr-8 hidebelow600\">{{\'BILLINGS.SGST\' | translate}}(%)</span><md-input-container md-no-float \nclass=\"md-accent\"><input placeholder=\"{{\'BILLINGS.SGST\' | translate}}(%)\" aria-label=\"email\" id=\"taxSgst-focus\" \nmaxlength=\"{{vm.exitems.tax_type==\'percent\' ? \'2\' : \'\'}}\" valid-number type=\"text\" name=\"quantitys\" \nng-change=\"dataChange()\" ng-model=\"vm.exitems.tax_sgst\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>{{vm.exitems.taxamount | number:2}}</span></div></div><div \nclass=\"layout-row layout-align-start-center spacer-8 discount-container\" ng-show=\"OpenPermission\"><div class=\"flex\">\n</div><div class=\"tag flex md-accent spacer-8 flex-40\" layout=\"row\"><div flex layout=\"row\"><md-icon \nclass=\"cursor-pointer\" md-font-icon=\"icon icon-close-circle s16 text-black-30 mr-4\" title=\"Remove\" ng-hide=\"hideclose\" \nng-click=\"OpenPermission = !OpenPermission; clearDis()\"></md-icon><span class=\"mt-12 mr-8\">\n{{\'BILLINGS.DISCOUNT\' | translate}}</span></div><div class=\"mr-8\" flex><md-input-container md-no-float \nclass=\"md-accent\"><input id=\"discount-focus\" max=\"{{vm.exitems.total_amount + vm.exitems.discount}}\" \nng-keypress=\"onlynumber($event);\" aria-label=\"email\" placeholder=\"\" type=\"number\" name=\"quantitys\" \nng-change=\"dataChange()\" ng-model=\"vm.exitems.discount\"></md-input-container></div></div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span>\n{{vm.exitems.discount==\'\' ? 0.00 : vm.exitems.discount | number:2}}</span></div></div><div \nclass=\"layout-row footer mt-4\"><div class=\"tag flex\">{{\'BILLINGS.Total Amount\' | translate}}</div><div \nclass=\"value flex-20 layout-row layout-align-start-center padding-horizontal-10\"><span translate \nclass=\"grey-col-sec-text pr-2\">BILLINGS.INR</span> <span class=\"total\">{{vm.exitems.total_amount}}</span></div></div>\n</div><div class=\"receipt-border border-right border-left\"></div></div></div></div></div>");}]);